// http://stackoverflow.com/a/22564291/292787
if (!window.location.origin) {
    window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}

//the work around from https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith#Polyfill
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (searchString, length) {
        length = length || this.length;
        return this.substr(length - searchString.length, searchString.length) === searchString;
    };
}

//the work around from https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex#Polyfill
if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function (predicate) {
        if (this == null) {
            throw new TypeError('Array.prototype.findIndex called on null or undefined');
        }
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        var list = Object(this);
        var length = list.length >>> 0;
        var thisArg = arguments[1];
        var value;

        for (var i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
                return i;
            }
        }
        return -1;
    };
}

Date.prototype.addHours = function (h) {
    this.setTime(this.getTime() + (h * 60 * 60 * 1000));
    return this;
}

/**
 * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
 *
 * @type boolean
 */
var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

// work around for the android virtual keyboard
function isAndroid() {
    return navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;
}

function iOS() {
    return /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
}

function isMobileOrRipple() {
    return window.cordova || (window.parent && window.parent.ripple);
}

function getIosVersion(){
    /**
     * returns iOS version as array. for example, for iOS 6.1.6 returns ["6", "1", "6"]
     */
    return ((
        //"Mozilla/5.0 (iPod; CPU iPhone OS 6_1_6 like Mac OS X) AppleWebKit/536.26 (KHTML, like Gecko) Version/6.0 Mobile/10B500 Safari/8536.25"
        navigator.userAgent
        .match(/OS ((\d+_?){2,3})\s/)||[''])[0]
        .match(/((\d+_?){2,3})\s/)||[''])[0]
        .split('_');
}

function getIosVersionFloat() {
    /**
     * returns iOS version as float. for example, for iOS 6.1.6 returns 6.1
     */
    var iOsVersion = getIosVersion();
    return iOsVersion.length > 1 ? parseFloat(iOsVersion[0] + '.' + iOsVersion[1]) : -1;
}

function isLandscape() {
    if (window.orientation == undefined)
        return false;
    return window.orientation == 90 || window.orientation == -90;
}

function isPortrait() {
    if (window.orientation == undefined)
        return true;
    return window.orientation == 0 || window.orientation == 180;
}

// work around, details: http://getbootstrap.com/getting-started/#support-ie10-width
// Copyright 2014-2015 Twitter, Inc.
// Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
function getAndroidVersion(ua) {
    ua = (ua || navigator.userAgent).toLowerCase();
    var match = ua.match(/android\s([0-9\.]*)/);
    return match ? match[1] : false;
};

function loadCss(url) {
    var link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', url);
    document.getElementsByTagName('head')[0].appendChild(link);
}

// http://stackoverflow.com/a/17907562/292787
function getInternetExplorerVersion() {
    var rv = -1;
    if (navigator.appName == 'Microsoft Internet Explorer') {
        var ua = navigator.userAgent;
        var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
        if (re.exec(ua) != null)
            rv = parseFloat(RegExp.$1);
    }
    else if (navigator.appName == 'Netscape') {
        var ua = navigator.userAgent;
        var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
        if (re.exec(ua) != null)
            rv = parseFloat(RegExp.$1);
    }
    return rv;
}

var isIE = getInternetExplorerVersion() > 0;

// this function is necessary to avoid /../ in url
// the problem with /../ in url is that it can accumulate during navigation in cordova
// and produce urls like 'x-wmapp0:www/Pages/SignUp/../SignUp/../SignUp/../SignUp/../SignUp/../Welcome.html'
// after 10 transitions between SignUp and Welcome it stops to work completely and page can't be displayed
function getAbsoluteUrl(base, relative) {
    // remove everything after #
    var hashPosition = base.indexOf('#');
    if (hashPosition > 0) {
        base = base.slice(0, hashPosition);
    }

    // the rest of the function is taken from http://stackoverflow.com/a/14780463
    // http://stackoverflow.com/a/25833886 - this doesn't work in cordova
    // http://stackoverflow.com/a/14781678 - this doesn't work in cordova
    var stack = base.split("/"),
        parts = relative.split("/");
    stack.pop(); // remove current file name (or empty string)
    // (omit if "base" is the current folder without trailing slash)
    for (var i = 0; i < parts.length; i++) {
        if (parts[i] == ".")
            continue;
        if (parts[i] == "..")
            stack.pop();
        else
            stack.push(parts[i]);
    }
    return stack.join("/");
}

function isNumberFormatCorrect(numberStr) {
    // '^\.$' - '.'
    // '^(?=.+)(?:\d*)?(?:\.)?$' - '12.';
    // '^(?=.+)(?:\d*)?(?:\.\d+)?$' - '1' or '1.1' or '.3'
    var reg = /^\.$|^(?=.+)(?:\d*)?(?:\.)?$|^(?=.+)(?:\d*)?(?:\.\d+)?$/;
    return reg.test(numberStr);
}

function getMaskedPhoneNumberValue(rawValue) {
    var input = $('<input>').val(rawValue);
    input.mask(Config.phoneNumberMask);
    return input.val();
}

function getPositiveAmountString(value){
    var amount = parseFloat(value);
    if(amount < 0) {
        amount = Math.abs(amount);
    }
    return amount.toFixed(2);
}

function documentWrite(data) {
    if (deviceIsWindowsPhone) {
        MSApp.execUnsafeLocalFunction(function () {
            document.writeln(data);
        });
    } else {
        document.write(data);
    }
}

var utilli = utilli || {};

utilli.roles = {
    Administrator: 'Administrator',
    Agent: 'Agent',
    Assistant: 'Assistant',
    PropertyManager: 'PropertyManager',
    CSR: 'CSR',
    CSRAdmin: 'CSR-Admin',
    FieldServiceEngineer: 'FieldServiceEngineer',
    SystemUser: 'SystemUser',
    DataExporter: 'DataExporter'
}

utilli.scrollTop = function() {
    $('.mainPageScroll').scrollTop(0);
};

/* scrolls current page to the bottom
 * @param delay - sometimes it's required to postpone scroll till content gets updated (rendered)
 */
utilli.scrollBottom = function (delay) {
    setTimeout(function() {
        $('.mainPageScroll').each(function (index, item) {
            //http://stackoverflow.com/a/270628
            $(item).scrollTop(item.scrollHeight);
        });
    }, delay);
};

utilli.clearLocalStorage = function () {
    //localStorage.removeItem('ApiUrl'); - do not remove! I need this for touch id
    //localStorage.removeItem('ServiceProviderName'); - do not remove! I need this for touch id
    //localStorage.removeItem('CurrentAccountNumber'); - do not remove! I need this for touch id
    localStorage.removeItem('BusinessPartner');
    //localStorage.removeItem('current_user'); - do not remove! I need this for touch id
    localStorage.removeItem('SecurityToken');
    localStorage.removeItem('email');
    localStorage.removeItem('CurrentUtilityType');
    localStorage.removeItem('currentAggregation');
    localStorage.removeItem('PropertyManager');
    localStorage.removeItem('PropertyManagerTour');
    localStorage.removeItem('PropertyManagerFirstTour');
};

utilli.aggregationTypes = {
    property: 'property',
    group: 'group'
}

utilli.addUserName = function (state, params) {
    params = params || {};
    params.userName = utilli.isAdmin ? state.params.userId :
        (params.userName ? params.userName : '');
    return params;
};

//return property or group object (depend on "Group View" or "Property View" was clicked)
utilli.getCurrentAggregation = function() { 
    var json = localStorage.getItem('currentAggregation');
    if (!json) 
        return null;
    return JSON.parse(json);
}

utilli.clearCurrentAggregation = function () { 
    localStorage.removeItem('currentAggregation')
}

utilli.getCurrentGroupId = function () {
    var aggregation = utilli.getCurrentAggregation();
    if (aggregation && aggregation.Type === 'group')
        return aggregation.Id;
    return null;
}

utilli.getCurrentPropertyId = function () {
    var aggregation = utilli.getCurrentAggregation();
    if (aggregation && aggregation.Type === 'property')
        return aggregation.Id;
    return null;
}

utilli.handleAjaxResponse = function (response, ModalServiceExt, successCallbackFn) {
    if (response == undefined || response.HasErrors == undefined) {
        ModalServiceExt.showServerError();
        return;
    }
    if (response.HasErrors) {
        ModalServiceExt.showError(response.Errors[0]);
    }
    else {
        if (successCallbackFn)
            successCallbackFn();
    }
};

utilli.downloadFile = function (apiUrl, fileName) {
    var link = document.createElement("a");
    link.href = apiUrl;
    link.style.visibility = false;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

//todo: remove, use utilli.validatePassword instead of this
utilli.isPasswordValid = function (userName, passwd, passwdConf, passwdMinLength) {
    if (!passwdMinLength)
        passwdMinLength = Config.passwdMinLength;
    var result = passwd
        && passwd.length >= passwdMinLength
        && utilli.hasDigits(passwd)
        && utilli.hasLetters(passwd)
        && passwd != userName;
    return result;
};

utilli.validatePassword = function (password, userName, passRequirements, paswdMinLength, oldPassword, minUserIdLength) {
    if(!minUserIdLength)
        minUserIdLength = 1;
    var requirement = findRequirementByName(passRequirements, 'PasswordLength');
    var passwordErrors = [];
    if (requirement && (!password || password.length < paswdMinLength))
        passwordErrors.push(requirement.ErrorText);
    if ((requirement = findRequirementByName(passRequirements, 'DigitsNumber')) && !utilli.hasDigits(password))
        passwordErrors.push(requirement.ErrorText);
    if ((requirement = findRequirementByName(passRequirements, 'NotCurrentPassword')) && oldPassword == password)
        passwordErrors.push(requirement.ErrorText);
    if ((requirement = findRequirementByName(passRequirements, 'Letters'))
        && (!utilli.hasLowerCaseLetters(password) || !utilli.hasUpperCaseLetters(password)))
        passwordErrors.push(requirement.ErrorText);
    if ((requirement = findRequirementByName(passRequirements, 'SpecialSymbols')) && !utilli.hasSpecialSymbols(password))
        passwordErrors.push(requirement.ErrorText);
    if ((requirement = findRequirementByName(passRequirements, 'NotUserID')) && userName === password)
        passwordErrors.push(requirement.ErrorText);
    if (password !== userName && (requirement = findRequirementByName(passRequirements, 'NotContainUserID')) 
        && password && userName && minUserIdLength <= userName.length && password.indexOf(userName) !== -1) {
            passwordErrors.push(requirement.ErrorText);
        }
    return passwordErrors;
}

function findRequirementByName(list, key) {
    return _.find(list, function (item) { return item.Key === key; });
}

utilli.hasDigits = function(password) {
    return /\d/.test(password);
};

utilli.hasLowerCaseLetters = function (password) {
    return /[a-z]/.test(password);
};

utilli.hasUpperCaseLetters = function (password) {
    return /[A-Z]/.test(password);
};

utilli.hasLetters = function(password) {
    return /[a-zA-Z]/.test(password);
};

utilli.hasSpecialSymbols = function (password) {
    var regex = /[-!$%^&#*()_+|~=`{}\[\]:";'<>?,.\/@]/;
    var result = regex.test(password);
    return result;
};

utilli.getFileUrlWithToken = function(token) {
    var url = localStorage.getItem('ApiUrl') + 'api/GeneratedFiles/GetFile?token=' + token;
    return url;
};

utilli.hasAdminOrCsrRole = function (token) {
    if (!token) {
        token = localStorage.getItem('SecurityToken');
    }
    var payload = utilli.getPayload(token);
    if (!payload)
        return false;

    var result = _.some(payload.roles, function (role) {
        return role === utilli.roles.Administrator || role === utilli.roles.CSRAdmin || role === utilli.roles.CSR;
    });

    return result;
};

utilli.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
utilli.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

utilli.setWindowLocation = function (url) {
    console.log('redirect to new url: ' + url);
    if (utilli.isSafari){
        // https://stackoverflow.com/a/31223302/292787
        setTimeout(function(){ document.location.href = url; }, 1);
    }
    else {
        document.location.href = url;
    }
}

/**
 * If user is already logged-in then redirect to the default page based on user role.
 * @param {} $state 
 * @returns {} true if redirect should happen
 */
utilli.goesToDefaultPage = function($state, setApiUrl) {
    var goToAdmin = function() {
        var adminUrl = utilli.getAdminUrl();
        utilli.setWindowLocation(adminUrl);
    }
    var token = localStorage.getItem('SecurityToken');
    if (token) {
        if (utilli.hasAdminOrCsrRole(token)) {
            // check if this is the customer view
            if (utilli.hasPropertyManagerRole()) {
                $state.goMainLayout('PropertyList');
                return;
            }
            if (setApiUrl){
                setApiUrl(goToAdmin);
            }
            else{
                goToAdmin();
            }
        }
        else if (utilli.hasAgentRole())
            $state.goMainLayout('Search');
        else if (utilli.hasPropertyManagerRole())
            $state.goMainLayout('PropertyList');
        else if (utilli.hasFieldServiceEngineerRole())
            $state.goMainLayout('WorkCenters');
        else
            $state.goMainLayout('Dashboard');
        return true;
    }
    return false;
}

utilli.getAdminUrl = function () {
    var adminUrl = window.location.origin + window.location.pathname;
    if(isMobileOrRipple()) {
        var indexOfIndex = adminUrl.indexOf('index.html');
        if (indexOfIndex > 0) {
            adminUrl = adminUrl.substr(0, indexOfIndex);
        }
        adminUrl = adminUrl + 'Admin/index.html/#/';
    }
    else {
        adminUrl = adminUrl.endsWith("index.html") ? adminUrl + '/' : adminUrl;
        adminUrl = adminUrl + 'Admin/#/';
    }
    return adminUrl;
}

utilli.hasAgentRole = function (token) {
    return utilli.hasRole(utilli.roles.Agent, token);
}

utilli.hasAssistantRole = function (token) {
    return utilli.hasRole(utilli.roles.Assistant, token);
}

utilli.notAgentOrAssistant = function (token) {
    return !utilli.hasAgentRole(token) && !utilli.hasAssistantRole(token);
}

utilli.hasPropertyManagerRole = function (token) {
    if (!token)
        token = localStorage.getItem('SecurityToken');
    var payload = utilli.getPayload(token);
    if (!payload)
        return false;

    var result = _.some(payload.roles, function (role) {
        return role === utilli.roles.PropertyManager;
    });

    if (!result && utilli.isAdmin) {
        var value = localStorage.getItem('PropertyManager');
        if (value)
            result = true;
    }

    return result;
}

utilli.hasDataExporterRole = function (token) {
    return utilli.hasRole(utilli.roles.DataExporter, token);
};

utilli.hasAdminRole = function (token) {
    if (!token) {
        token = localStorage.getItem('SecurityToken');
    }
    var payload = utilli.getPayload(token);
    if (!payload)
        return false;

    var result = _.some(payload.roles, function (role) {
        return role === utilli.roles.Administrator || role === utilli.roles.CSRAdmin;
    });

    return result;
};

utilli.hasCsrAdminRole = function (token) {
    return utilli.hasRole(utilli.roles.CSRAdmin, token);
};

utilli.hasSuperAdminRole = function (token) {
    return utilli.hasRole(utilli.roles.Administrator, token);
};

utilli.hasFieldServiceEngineerRole = function (token) {
    if (!token)
        token = localStorage.getItem('SecurityToken');

    return utilli.hasRole(utilli.roles.FieldServiceEngineer, token);
};

utilli.hasRole = function(role, token){
    if (!token)
        token = localStorage.getItem("SecurityToken");
    var payload = utilli.getPayload(token);
    if (!payload)
        return false;
    var result = _.some(payload.roles, function (r) {
        return r === role;
    });
    return result;
}

utilli.isDemo = function() {
    return DeploymentSettings.deploymentEnvironment === "Demo"
    || DeploymentSettings.deploymentEnvironment === "Demo2"
    || DeploymentSettings.deploymentEnvironment === "Debug"
    || DeploymentSettings.deploymentEnvironment === "Dev";
}

utilli.getCurrentUserName = function () {
    var token = localStorage.getItem("SecurityToken");
    var payload = utilli.getPayload(token);
    if (!payload)
        return null;

    return payload.userName;
}

utilli.getPayload = function(token) {
    if (!token)
        return null;

    var parts = token.split('.');
    var encoded = parts[1];
    var json = atob(encoded);
    var payload = JSON.parse(json);
    return payload;
}

/* returns phone number that starts with 1 and has 11 digits.
* @param maskPhoneNumber - 10 digit phone number extracted from ui-mask
*/
utilli.getFullPhoneNumber = function(maskPhoneNumber) {
    return Config.phoneNumberMask[1] + maskPhoneNumber;
}

utilli.registerGoogleAnalytics = function(win, rootScope, location) {
    if (!win || !win.ga || !rootScope || !location) return;
    win.ga('create', 'UA-91827657-1',{'cookieFlags': 'SameSite=None; Secure'});
    var isMobile = isMobileOrRipple();
    if (isMobile) {
        // http://stackoverflow.com/a/35057298/292787
        win.ga('set', 'checkProtocolTask', function () { });
    }
    win.ga('set', 'dimension1', DeploymentSettings.currentServiceProvider);// ServiceProvider
    win.ga('set', 'dimension2', DeploymentSettings.deploymentEnvironment);// DeploymentEnvironment
    win.ga('set', 'dimension3', isMobile ? 'mobile' : 'web');// ClientType
    rootScope.$on('$stateChangeSuccess', function (event) {
        var relativeUrl = utilli.isAdmin ? '/Admin/#' + location.path() : '/#' + location.path();
        win.ga('send', 'pageview', relativeUrl);
    });
}

// initialize so that utilli.localizationDictionary[key] will not fail with undefined error
utilli.localizationDictionary = {};

utilli.isLanguagePackEnabled = function() {
    if(window.location.href.indexOf("WelcomeAgent") !== -1)
    {
        // no languages for Agents Welcome
        return false;
    }

    if(window.location.href.indexOf("/Admin") !== -1)
    {
        // no languages for Admins
        return false;
    }

    if (isMobileOrRipple())
        return Config.enableLanguagePack;

    if (DeploymentSettings.currentServiceProvider.length > 0) {
        var enableLanguagePack = Config.providers[DeploymentSettings.currentServiceProvider].EnableLanguagePack;
        return enableLanguagePack;
    }

    return false;
}

function getCurrentLanguage() {

    if (utilli.isLanguagePackEnabled()) {
        var language = localStorage.getItem('language');
        console.log('language: ' + language);
        if (utilli.checkDefinedValue(language))
            return language;
    }

    return 'en';
}

utilli.registerLocalization = function (rootScope, resource) {

    var language = getCurrentLanguage();
    localStorage.setItem('language', language);
    utilli.changeLanguage(resource, language);
    rootScope._t = utilli._t;
}

utilli._t = function (key) {
    var localized = utilli.localizationDictionary[key];
    return localized ? localized : key;
};

utilli.checkDefinedValue = function (value) {
    if (value === null || value === 'null' || value === 'undefined' || value === undefined || value === '')
        return false;
    return true;
}

utilli.changeLanguage = function (resource, language, callback) {
    console.log('changeLanguage() language: ' + language);
    if (!utilli.isLanguagePackEnabled())
        return;
    if (!utilli.checkDefinedValue(language))
        language = 'en';
    var filePath = 'languages/' + language + '.json' + DeploymentSettings.currentVersion;
    if (utilli.isAdmin)
        filePath = '../' + filePath;
    resource(filePath).get(function (data) {
        utilli.localizationDictionary = data;

        var _t = utilli._t;

        utilli.errors.serverErrorMessage = _t('Server error. Try again later.');
        utilli.errors.validationErorrsMessage = _t('Please correct your information.');

        localStorage.setItem('language', language);

        var urlPrefixKendoLib = '';
        if(utilli.isAdmin)
        {
            urlPrefixKendoLib = '../';
        }   
        if(language == 'en') {
            $.getScript(urlPrefixKendoLib + "libs/kendo/Languages/kendo.messages.en-US.min.js", function () {});
            kendo.culture('en-US'); }
        else if (language == 'es') {      
            $.getScript(urlPrefixKendoLib + "libs/kendo/Languages/kendo.messages.es-US.min.js", function () {}); 
            kendo.culture('es-US'); }
        else  if(language == 'ko') {   
            $.getScript(urlPrefixKendoLib + "libs/kendo/Languages/kendo.messages.ko-KR.min.js", function () {});
            kendo.culture('ko-KR');  }
       else  if(language == 'zh') {   
            $.getScript(urlPrefixKendoLib + "libs/kendo/Languages/kendo.messages.zh-CN.min.js", function () {});
            kendo.culture('zh-CN');
       }

        if (callback)
            callback(language);
    });
}

//English - English
//Espanol - Spanish
//Deutsch - German
//Русский - Russian
//සිංහල - Sinhalese
//中文 - Chinese
//नहीं - Hindi

//utilli.languages = [
//    { name: 'English', abbreviation: 'en' },
//    { name: 'Espanol (Spanish)', abbreviation: 'es' },
//    { name: 'Français (French)', abbreviation: 'fr' },
//    { name: 'Deutsch (German)', abbreviation: 'de' },
//    { name: 'සිංහල (Sinhalese)', abbreviation: 'si' },
//    { name: '中文 (Chinese)', abbreviation: 'zh' },
//    { name: 'Nederlands (Dutch)', abbreviation: 'nl' },
//    { name: 'Afrikaans', abbreviation: 'af' },
//    { name: 'हिन्दी (Hindi)', abbreviation: 'hi' },
//    { name: 'ગુજરાતી (Gujarati)', abbreviation: 'gu' },
//    { name: 'ಕನ್ನಡ (Kannada)', abbreviation: 'kn' },
//    { name: 'मराठी (Marathi)', abbreviation: 'mr' },
//    { name: 'ਪੰਜਾਬੀ (Punjabi)', abbreviation: 'pa' },
//    { name: 'தமிழ் (Tamil)', abbreviation: 'ta' },
//    { name: 'తెలుగు (Telugu)', abbreviation: 'te' },
//    { name: 'العَرَبِيَّة‎‎ (Arabic)', abbreviation: 'ar' },
//    { name: 'Русский (Russian)', abbreviation: 'ru' } ];

utilli.languages = {
    "wgl": [
        { name: 'English', abbreviation: 'en' },
        { name: 'Espanol (Spanish)', abbreviation: 'es' }
    ],
    "px": [
        { name: 'English', abbreviation: 'en' },
    ],
    "gni": [
        { name: 'English', abbreviation: 'en' },
        { name: 'Espanol (Spanish)', abbreviation: 'es' },
        { name: 'Français (French)', abbreviation: 'fr' },
        { name: 'Deutsch (German)', abbreviation: 'de' },
        { name: 'සිංහල (Sinhalese)', abbreviation: 'si' },
        { name: '中文 (Chinese)', abbreviation: 'zh' },
        { name: 'Nederlands (Dutch)', abbreviation: 'nl' },
        { name: 'Afrikaans', abbreviation: 'af' },
        { name: 'हिन्दी (Hindi)', abbreviation: 'hi' },
        { name: 'ગુજરાતી (Gujarati)', abbreviation: 'gu' },
        { name: 'ಕನ್ನಡ (Kannada)', abbreviation: 'kn' },
        { name: 'मराठी (Marathi)', abbreviation: 'mr' },
        { name: 'ਪੰਜਾਬੀ (Punjabi)', abbreviation: 'pa' },
        { name: 'தமிழ் (Tamil)', abbreviation: 'ta' },
        { name: 'తెలుగు (Telugu)', abbreviation: 'te' },
        { name: 'العَرَبِيَّة‎‎ (Arabic)', abbreviation: 'ar' },
        { name: '한국어 (Korean)', abbreviation: 'ko' },
        { name: 'Беларуская мова (Belarusian)', abbreviation: 'be' },
        { name: 'Русский (Russian)', abbreviation: 'ru' }
    ],

    "demo": [
        { name: 'English', abbreviation: 'en' },
        { name: 'Espanol (Spanish)', abbreviation: 'es' },
        { name: 'Français (French)', abbreviation: 'fr' },
        { name: 'Deutsch (German)', abbreviation: 'de' },
        { name: 'සිංහල (Sinhalese)', abbreviation: 'si' },
        { name: '中文 (Chinese)', abbreviation: 'zh' },
        { name: 'Nederlands (Dutch)', abbreviation: 'nl' },
        { name: 'Afrikaans', abbreviation: 'af' },
        { name: 'हिन्दी (Hindi)', abbreviation: 'hi' },
        { name: 'ગુજરાતી (Gujarati)', abbreviation: 'gu' },
        { name: 'ಕನ್ನಡ (Kannada)', abbreviation: 'kn' },
        { name: 'मराठी (Marathi)', abbreviation: 'mr' },
        { name: 'ਪੰਜਾਬੀ (Punjabi)', abbreviation: 'pa' },
        { name: 'தமிழ் (Tamil)', abbreviation: 'ta' },
        { name: 'తెలుగు (Telugu)', abbreviation: 'te' },
        { name: 'العَرَبِيَّة‎‎ (Arabic)', abbreviation: 'ar' },
        { name: '한국어‎‎ (Korean)', abbreviation: 'ko' },
        { name: 'Беларуская мова (Belarusian)', abbreviation: 'be' },
        { name: 'Русский (Russian)', abbreviation: 'ru' }
    ],

    "hc": [
        { name: 'English', abbreviation: 'en' },
        { name: 'Espanol (Spanish)', abbreviation: 'es' },
        { name: '한국어‎‎ (Korean)', abbreviation: 'ko' },
        { name: '中文 (Chinese)', abbreviation: 'zh' }
    ]
};

utilli.getCountryPhoneNumberCode = function () {
    return Config.phoneNumberMask[1]; // +1 999... -> 1 or +7 999 ... -> 7
};

utilli.datePickerOptions = {
    formatYear: 'yyyy',
    startingDay: 1,
    showWeeks: false
};

utilli.isAuthorized = function () {
    if (localStorage.getItem('SecurityToken'))
        return true;
    return false;
}

utilli.errors = {
    serverErrorMessage: utilli._t('Server error. Try again later.'),
    validationErorrsMessage: utilli._t('Please correct your information.')
};

utilli.getApplicationService  = function (serviceName) {
    var elem = angular.element(document.querySelector('[ng-app]'));
    var injector = elem.injector();
    var result = injector.get(serviceName);
    return result;
}

utilli.mobilePlatforms = {
    unknown: 'Unknown',
    android: 'Android',
    iOs: 'IOs',
    windowsPhone: 'WindowsPhone',
}

utilli.getPlatformName = function () {
    var result = utilli.mobilePlatforms.unknown;
    if(deviceIsWindowsPhone)
        result = utilli.mobilePlatforms.windowsPhone;
    else if(isAndroid())
        result = utilli.mobilePlatforms.android;
    else if(iOS())
        result = utilli.mobilePlatforms.iOs;
    return result;
}

/**
 * Formats number to be displayed on UI.
 * For example, in US we need separate thousands with comma and have 2 fraction digits
 * @param {} num a number that needs to be presented as a string
 * @returns {} formatted string
 */
utilli.formatNumber = function(num) {
    return num.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

/**
 * Same as formatNumber but for currency - with leading $ and minimum 2 decimal places
 * @param {float} num a number that needs to be presented as currency
 */
utilli.formatCurrency = function(num){
    return '$' + num.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
}

/**
 * Removes float numbers after the second number.
 * For example, 0.123 -> 0.12
 * @param {} num a number that needs to be changed
 * @returns {} trimmed value
 */
utilli.trimFloat2 = function (num) {
    return parseFloat((num).toFixed(2));;
}

utilli.localStorageItemNotNull =  function (name) {
    var item = localStorage.getItem(name);
    var result = item != null && item != "null";
    return result;
}

/**
 * Returns positive number or zero.
 * Returns zero for NaNs, undefined, etc.
 * @param {string} num number
 */
utilli.parsePositiveFloat = function (num){
    var parsed = parseFloat(num);
    return parsed > 0 ? parsed : 0;
}

/**
 * timeout value in ms for refreshing Energy Star status
 */
utilli.propertyRefreshTimeout = 5 * 1000; // 5 sec

utilli.getCurrentProviderConfigValue = function (key, defaultValue) {
    if (!DeploymentSettings.currentServiceProvider || DeploymentSettings.currentServiceProvider.length === 0
        || !Config.providers[DeploymentSettings.currentServiceProvider][key])
        return defaultValue;
    return Config.providers[DeploymentSettings.currentServiceProvider][key];
}

utilli.getHelpEmail = function () {
    return utilli.getCurrentProviderConfigValue("HelpEmail", "help@utilli.com");
}

utilli.getSupportPhoneNumber = function () {
    return utilli.getCurrentProviderConfigValue("SupportPhoneNumber", "330-701-8398");
}

utilli.isPropertyManagerApp = function () {
    return DeploymentSettings.providersGroupShortName && 
        (DeploymentSettings.providersGroupShortName.toUpperCase() === 'WGL' || DeploymentSettings.providersGroupShortName.toUpperCase() === 'PX');
}

utilli.isPx = function () {
    return DeploymentSettings.providersGroupShortName && DeploymentSettings.providersGroupShortName.toUpperCase() === 'PX';
}

utilli.isHc = function () {
    return DeploymentSettings.providersGroupShortName && DeploymentSettings.providersGroupShortName.toUpperCase() === 'HC';
}

utilli.adjustPhoneNumber = function (phoneNumber) {
    if (!phoneNumber)
        return null;

    if (phoneNumber.length > Config.phoneNumberLengthWithoutCountryCode)
        return phoneNumber.substr(Config.countryCodeLength);

    return phoneNumber;
}

utilli.fixSelectElementForMobile = function  () {
    // this hack fixes a select element behavior in mobile (changing selected options).
    var allSelectElements = document.getElementsByTagName('select');
    for (var i = 0; i < allSelectElements.length; i++) {
        allSelectElements[i].addEventListener('touchstart', function (e) {
            //This is the important line
            e.stopPropagation();
        }, false);
    }
}

utilli.clientEnum = {
    mobileApp: 1,
    portal: 2
};

utilli.pm = {
    meterErrorCodes: {
        serviceAddressMismatch: 3
    }
};

utilli.getStateNameWithoutLayout = function (fullStateName) {
    var index = fullStateName.indexOf('.');
    var state = '';
    if (index >= 0)
        state = fullStateName.substr(index + 1);
    else
        state = fullStateName;
    return state;
}

utilli.togglePasswordVisibility = function (pswId, iconId) {
    var elemPassword = $('#' + pswId);
    if (elemPassword.attr('type') === 'password')
        elemPassword.attr('type', 'text');
    else
        elemPassword.attr('type', 'password');

    $('#' + iconId).toggleClass('glyphicon-eye-close').toggleClass('glyphicon-eye-open');
}

utilli.getStringForComparison = function (source) {
    //https://stackoverflow.com/questions/3286874/remove-all-multiple-spaces-in-javascript-and-replace-with-single-space?answertab=votes#tab-top
    var result = source.toUpperCase().replace(/ +(?= )/g,'');
    return result;
}

utilli.notificationTypes = {
    sms: 1,
    email: 2,
    smsAndEmail: 3
}

utilli.paymentTypes = {
    card: 1,
    check: 2
}

utilli.hideColumnByTitle = function (grid, fieldName) {
    for (var i = 0; i < grid.columns.length; i++){
        if (grid.columns[i].title == fieldName){
            grid.hideColumn(i);
            return;
        }
    }
}

utilli.arePhoneNumbersEqual = function (phone1, phone2){
    return utilli.adjustPhoneNumber(phone1) == utilli.adjustPhoneNumber(phone2);
}

utilli.emptyAccountStatus = '--'

utilli.fillAccountStatuses = function(accountInfo) {
    var result = [];
    if(accountInfo.Tax && accountInfo.Tax != utilli.emptyAccountStatus)
        result.push(accountInfo.Tax);
    if(accountInfo.CheckStatus && accountInfo.CheckStatus != utilli.emptyAccountStatus)
        result.push(accountInfo.CheckStatus);
    if(accountInfo.HardshipIndicator && accountInfo.HardshipIndicator != utilli.emptyAccountStatus)
        result.push(accountInfo.HardshipIndicator);
    if(accountInfo.MeterStatus && accountInfo.MeterStatus != utilli.emptyAccountStatus 
        && accountInfo.MeterStatus != '06')// 06 - Active. i think that there is no need to show Active status
        result.push(accountInfo.MeterStatusDescription);
    if(accountInfo.CashOnlyCustomer && accountInfo.CashOnlyCustomer != utilli.emptyAccountStatus)
        result.push(accountInfo.CashOnlyCustomer);
    return result;
}

utilli.getDateWithoutTime = function (dateTime){
    dateTime = dateTime || new Date();
    return new Date(dateTime.setHours(0,0,0,0));
}

utilli.hcMeterStatuses = {
    notInstalled: "01",
    installedRelevantToTech: "02",
    allocatedToInstallation: "03",
    meterDisconnected: "04",
    inActive: "05",
    active: "06"
}


utilli.getSafariPushNotificationPermissionData = function () {
    var permissionData = utilli.isSafari 
        ? window.safari.pushNotification.permission('web.com.utilli.mobile')
        : null;
    return permissionData;
}

utilli.checkSafariRemotePermission = function ($scope, apiUrl, accountNumber) {
    var pd = utilli.getSafariPushNotificationPermissionData();
    var checkFn = function (permissionData) {
        if (permissionData.permission === 'default') {
            // This is a new web service URL and its validity is unknown.
            window.safari.pushNotification.requestPermission(
                apiUrl.slice(0, -1), // The web service URL.
                'web.com.utilli.mobile',     // The Website Push ID.
                {
                    "accountNumber": accountNumber
                }, // Data that you choose to send to your server to help you identify the user.
                checkFn         // The callback function.
            );
        }
        else if (permissionData.permission === 'denied') {
            // The user said no.
        }
        else if (permissionData.permission === 'granted') {
            $scope.$apply();
            console.log('we have a device token')
        }
    }
    checkFn(pd);
}

utilli._currentServiceProviderDeffered = jQuery.Deferred();

utilli.resolveServiceProviderApiDeffered = function (apiUrl) { 
    utilli._currentServiceProviderDeffered.resolve(apiUrl);
}

utilli.rejectServiceProviderApiDeffered = function (e) { 
    utilli._currentServiceProviderDeffered.reject(e);
}

utilli.getServiceProviderApiDeffered = function () { 
    return utilli._currentServiceProviderDeffered.promise();
}

utilli.getUrlParameter = function getUrlParameter(p) {

    var pageUrl = window.location.hash.substring(1);
    pageUrl = pageUrl.substring(pageUrl.indexOf("?") + 1);
    var urlVariables = pageUrl.split('&'),
        parameterName,
        i;

    for (i = 0; i < urlVariables.length; i++) {
        parameterName = urlVariables[i].split('=');

        if (parameterName[0] === p) {
            return parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1]);
        }
    }
};
$(function() {
    var allInputCssSelectors = 'input[type="text"],input[type="number"],input[type="password"],input[type="email"],input[type="tel"], textarea';
    var allInputAndSelectCssSelectors = allInputCssSelectors + ', select';
    var handleOrientationChange = function(){
        window.onorientationchange = function () {
            if ($(allInputCssSelectors).is(':focus'))
                setTimeout(fixHeight, 900); //Need at least 800 milliseconds
        }
    }
    if (isAndroid()) {
        $(document).on('focus', allInputCssSelectors, fixHeight);
        $(document).on('focusout', allInputCssSelectors, resetHeightFix);
        handleOrientationChange();
    }

    if (iOS()) {
        // for new iOS we apply the fix only when the keyboard is opened
        // but for old iOS we apply the fix permanently
        if (getIosVersionFloat() > 6) {
            handleOrientationChange();
            $(document).on('focus', allInputAndSelectCssSelectors, function () {
                //applyTopMenuFix(); // i think that after the last iOS update this fix doesn't change anything
                fixHeight.call(this);
            });
            $(document).on('focusout', allInputCssSelectors, resetHeightFix);
            $(document).on('blur', allInputAndSelectCssSelectors, function () {
                var topMenuElement = getTopMenu();
                topMenuElement.css({
                    'position': '',
                    'top': ''
                });
                var bottomMenuElement = getBottomMenu();
                bottomMenuElement.css({
                    'position': '',
                    'top': ''
                });
            });
        }
        else {
            applyTopMenuFix();
        }
    }

    function getTopMenu() {
        return $('.navbar.navbar-fixed-top');
    }

    function getBottomMenu() {
        return $('.navbar.navbar-fixed-bottom');
    }

    /**
     * changes position CSS of the top menu to absolute to avoid issues on iPhone when keyboard is opened
     */
    function applyTopMenuFix(){
        var topMenuElements = getTopMenu();
        topMenuElements.css({
            'position': 'absolute',
            'top': '0'
        });
        var bottomMenuElement = getBottomMenu();
        bottomMenuElement.css({
            'position': 'absolute',
            'top': document.height - getBottomMenu().height() + 'px'
        });
    }

    function fixHeight() {
        var me = this;
        if (me.id){
            // if there is a label for the input then scroll to the label
            var labels = $('label[for^="' + me.id + '"]');
            var scrollToElement = labels.length > 0 ? labels[0] : me;
        }
        // wrap it in a timeout so that if a user goes from one input into another
        // then first focus-out is fired with it's own timeout
        // later focus is fired with a timeout that is bigger than the one that is set in focus-out.
        // this is why here the timeout value is 10, while in resetHeightFix the timeout value is 1,
        // it is to ensure that the code in fixHeight will be executed after the code in resetHeightFix
        setTimeout(function(){
            var element = $('.main-ui-view');
            if ($('#virtualKeyboardPlace').length == 0)
                element.append('<div id="virtualKeyboardPlace"><div>');
            $('#virtualKeyboardPlace').height(getHeigthKeyboardPlace());
            // scroll current element to the top of the page
            if (scrollToElement)
                scrollToElement.scrollIntoView(true);
            // move scroll so that current element will be below the top menu
            var topMenuHeight = getTopMenu().height();
            $('body').scrollTop($('body').scrollTop() - topMenuHeight);
        }, 10);
    }

    function resetHeightFix() {
        // wrap it in a timeout so that if a user presses a button then button click will fire first
        setTimeout(function(){
            $('#virtualKeyboardPlace').height(0);
        }, 1);
    }

    function getHeigthKeyboardPlace() {
        if (isLandscape())
            return $('html').height() * 0.6;
        if (isPortrait())
            return $('html').height() * 0.5;
        return 1;
    }
});
function hideSplashScreen(){
    if (navigator.splashscreen) {
        if (parseFloat(getAndroidVersion()) > 4.3)
        {
            // for android 4.4+ splashscreen plugin switches app to just full-screen mode while we want immersiveMode.
            // immersiveMode avoids the top system bar to appear when keyboard is active
            AndroidFullScreen.immersiveMode(function () {
                console.log("switched to immersiveMode");
            }, function () {
                console.log("failed to switch to immersiveMode");
            });
        }
        navigator.splashscreen.hide();
    }
}

'use strict';
/* Global configuration settings */
if (!window.Config) {
    window.Config =
    {
        version: "0.4.0",
        Debug: false,
        serverErrorMsg: "Service unavailable, please try again later.",
        consumptionUnits: {
            // numbers mean multipliers on which consumption must be multiplied
            // to get consumption in that units.
            // CCF: 1 means that we get consumption from the backend in CCFs
            // and do not need to multiply anything to show consumption in CCFs
            // Gallons: 748.05 means that we get consumption from the backend in CCFs
            // and need to multiply it by 748.05 to show consumption in Gallons
            Water: { CCF: 1, Gallons: 748.05 },
            Electricity: { kWh: 1 },
            Gas: { MCF: 1, CCF: 10, Therms: 10.28 }
        },
        /**
         * Gets consumption units that are currently configured
         */
        getCurrentConsumptionUnits: function() {
            var utilliType = localStorage.getItem('CurrentUtilityType');
            utilliType = !utilliType || utilliType === 'null' || utilliType === 'undefined' ? "Gas" : utilliType;
            return Config.consumptionUnits[utilliType];
        },
        /**
         * Gets multiplier for the specified consumption unit
         */
        getConsumptionUnitFraction: function(unitsType) {
            return Config.getCurrentConsumptionUnits()[unitsType];
        },
        /**
         * If false, hide the View button and the Understand Your Bill button.
         */
        enableBillDownload: true,
        smallConvenienceFee: 2.95,
        largeConvenienceFee: 12.95,
        largeConvenienceFeeBorder: 600,

        phoneNumberMask: "+1 (999) 999-9999",
        phoneNumberLengthWithoutCountryCode: 10,
        countryCodeLength: 1,
        ccNumberMask: "9999 9999 9999? 9999 999",
        contractAccountMaxLength: 12,
        passwdMinLength: 8,

        zipCodeRegexp: /^(\d{5})?$|^$|^(\d{5}-\d{4})?$/,
        emailPattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

        // value for mobile app
        enableLanguagePack: "calculated below",

        maxMetersOnStackedDashboard: 15,
        wglProviderName: 'Wgl',
        hcProviderName: 'Hc',
        pxProviderName: 'Px',

        // the below info exists on server and it's not good to duplicate it here,
        // but i want welcome page to load fast, so i don't want to pull these data from server
        providers: {
            "Neo": {
                "Name": "NEO Natural Gas",
                "SiteName": "Northeast Ohio Natural Gas",
                "HelpEmail": "billpay@neogas.com",
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableOutageMap": true,
                "EnableLanguagePack": true,
                "providersGroupShortName": "gni"
            },
            "Orwell": {
                "Name": "Orwell Natural Gas",
                "SiteName": "Orwell Natural Gas",
                "HelpEmail": "billpay@orwellgas.com",
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableLanguagePack": true,
                "providersGroupShortName": "gni"
            },
            "Ewst": {
                "Name": "Ewst Natural Gas",
                "SiteName": "Energy West Montana",
                "HelpEmail": "billpay@ewst.com",
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableLanguagePack": true,
                "providersGroupShortName": "gni"
            },
            "Wgl": {
                "Name": "Washington Gas",
                "SiteName": "Washington Gas",
                "HelpEmail": "aggregateddata@washgas.com",
                "EnablePhoneNumbersOnLoginPage": false,
                "EnableLanguagePack": true,
                "EnablePropertyManagerLink": DeploymentSettings.deploymentEnvironment !== "Prod",
                "SupportPhoneNumber": "123-123-1234",
                "providersGroupShortName": "wgl"
            },
            "Px": {
                "Name": "Property Experience",
                "SiteName": "Utilli PX",
                "HelpEmail": "px@utilli.com",
                "EnablePhoneNumbersOnLoginPage": false,
                "EnableLanguagePack": true,
                "EnablePropertyManagerLink": DeploymentSettings.deploymentEnvironment !== "Prod",
                "SupportPhoneNumber": "123-123-1234",
                "providersGroupShortName": "px"
            },
            "Bangor": {
                "Name": "Bangor Natural Gas",
                "SiteName": "Bangor Natural Gas",
                "HelpEmail": "billpay@bangorgas.com",
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableLanguagePack": false,
                "providersGroupShortName": "gni"
            },
            "Frontier": {
                "Name": "Frontier Natural Gas",
                "SiteName": "Frontier Natural Gas",
                "HelpEmail": "billpay@frontiernaturalgas.com",
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableLanguagePack": true,
                "providersGroupShortName": "gni"
            },
            "Hc": {
                "Name": "Howard County",
                "SiteName": "Howard County",
                "HelpEmail": "billing@howardcountymd.gov",
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableLanguagePack": true,
                "providersGroupShortName": "hc"
            },
            "DemoProvider": {
                "Name": "Utilli Demo",
                "SiteName": "Utilli Demo",
                "HelpEmail": "info@utilli.com",
                "EnableOutageMap": true,
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableLanguagePack": true,
            },
            "SapDemoProvider": {
                "Name": "Utilli SAP Demo",
                "SiteName": "Utilli SAP Demo",
                "HelpEmail": "info@utilli.com",
                "EnableOutageMap": true,
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableLanguagePack": true,
            }
        },
        appUrls: {
            android: "https://play.google.com/store/apps/details?id=com.utilli.UtilliMobile",
            iOs: "https://itunes.apple.com/us/app/howard-county-utilli/id905053011",
            winPhone: "https://www.microsoft.com/en-us/store/apps/utilli-mobile/9nblggh5k7fw"
        }
        
    };

    Config.wglProvidersGroupShortName = Config.providers[Config.wglProviderName].providersGroupShortName;
    Config.hcProvidersGroupShortName = Config.providers[Config.hcProviderName].providersGroupShortName;
    Config.pxProvidersGroupShortName = Config.providers[Config.pxProviderName].providersGroupShortName;
}

window.Config.states = [
{ name: 'ALABAMA', abbreviation: 'AL' },
{ name: 'ALASKA', abbreviation: 'AK' },
{ name: 'AMERICAN SAMOA', abbreviation: 'AS' },
{ name: 'ARIZONA', abbreviation: 'AZ' },
{ name: 'ARKANSAS', abbreviation: 'AR' },
{ name: 'CALIFORNIA', abbreviation: 'CA' },
{ name: 'COLORADO', abbreviation: 'CO' },
{ name: 'CONNECTICUT', abbreviation: 'CT' },
{ name: 'DELAWARE', abbreviation: 'DE' },
{ name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC' },
{ name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM' },
{ name: 'FLORIDA', abbreviation: 'FL' },
{ name: 'GEORGIA', abbreviation: 'GA' },
{ name: 'GUAM', abbreviation: 'GU' },
{ name: 'HAWAII', abbreviation: 'HI' },
{ name: 'IDAHO', abbreviation: 'ID' },
{ name: 'ILLINOIS', abbreviation: 'IL' },
{ name: 'INDIANA', abbreviation: 'IN' },
{ name: 'IOWA', abbreviation: 'IA' },
{ name: 'KANSAS', abbreviation: 'KS' },
{ name: 'KENTUCKY', abbreviation: 'KY' },
{ name: 'LOUISIANA', abbreviation: 'LA' },
{ name: 'MAINE', abbreviation: 'ME' },
{ name: 'MARSHALL ISLANDS', abbreviation: 'MH' },
{ name: 'MARYLAND', abbreviation: 'MD' },
{ name: 'MASSACHUSETTS', abbreviation: 'MA' },
{ name: 'MICHIGAN', abbreviation: 'MI' },
{ name: 'MINNESOTA', abbreviation: 'MN' },
{ name: 'MISSISSIPPI', abbreviation: 'MS' },
{ name: 'MISSOURI', abbreviation: 'MO' },
{ name: 'MONTANA', abbreviation: 'MT' },
{ name: 'NEBRASKA', abbreviation: 'NE' },
{ name: 'NEVADA', abbreviation: 'NV' },
{ name: 'NEW HAMPSHIRE', abbreviation: 'NH' },
{ name: 'NEW JERSEY', abbreviation: 'NJ' },
{ name: 'NEW MEXICO', abbreviation: 'NM' },
{ name: 'NEW YORK', abbreviation: 'NY' },
{ name: 'NORTH CAROLINA', abbreviation: 'NC' },
{ name: 'NORTH DAKOTA', abbreviation: 'ND' },
{ name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP' },
{ name: 'OHIO', abbreviation: 'OH' },
{ name: 'OKLAHOMA', abbreviation: 'OK' },
{ name: 'OREGON', abbreviation: 'OR' },
{ name: 'PALAU', abbreviation: 'PW' },
{ name: 'PENNSYLVANIA', abbreviation: 'PA' },
{ name: 'PUERTO RICO', abbreviation: 'PR' },
{ name: 'RHODE ISLAND', abbreviation: 'RI' },
{ name: 'SOUTH CAROLINA', abbreviation: 'SC' },
{ name: 'SOUTH DAKOTA', abbreviation: 'SD' },
{ name: 'TENNESSEE', abbreviation: 'TN' },
{ name: 'TEXAS', abbreviation: 'TX' },
{ name: 'UTAH', abbreviation: 'UT' },
{ name: 'VERMONT', abbreviation: 'VT' },
{ name: 'VIRGIN ISLANDS', abbreviation: 'VI' },
{ name: 'VIRGINIA', abbreviation: 'VA' },
{ name: 'WASHINGTON', abbreviation: 'WA' },
{ name: 'WEST VIRGINIA', abbreviation: 'WV' },
{ name: 'WISCONSIN', abbreviation: 'WI' },
{ name: 'WYOMING', abbreviation: 'WY' }
];
String.prototype.getTime = function () {
    var dateString = this;
    var date = dateString.split("/");
    // month in JS is index in array of 12 months. Transform the month number to the index.
    var month = parseInt(date[0]) - 1;
    return (new Date(date[2], month, date[1])).getTime();
};

String.prototype.getPositiveAmount = function () {
    var amountString = this;
    var amount = parseFloat(amountString);
    if(amount < 0) {
        amount = Math.abs(amount);
    }
    return amount.toString();
};
'use strict';
var provide;
angular.module('utilliApp', ['credit-cards', 'infinite-scroll',
        'angularSpinner', 'angularModalService', 'ngSanitize', 'ngIOS9UIWebViewPatch',
        'commonServices', 'ui.router', 'kendo.directives', 'ct.ui.router.extras', 'ui.mask',
        'ui.bootstrap', 'ngResource'
])
    .factory('authorizeInterceptor', function () {
        return {
            request: function (config) {

                // IMPORTANT: for static resources such as maintenance.html don't add params because the template can 
                // be embedded into index.html and angular will not resolve it when parameters are added and will try
                // to download from the server while the server can be down
                if (!config.url.startsWith('http://') && !config.url.startsWith('https://'))
                    return config;

                config.params = config.params || {};
                config.params['clientVersion'] = DeploymentSettings.clientVersion;
    
                var language = localStorage.getItem('language');
                if (utilli.checkDefinedValue(language)) {
                    config.params['lang'] = language;
                } else {
                    config.params['lang'] = 'en';
                }

                var token = localStorage.getItem('SecurityToken');
                var apiUrl = localStorage.getItem('ApiUrl');
                if (token && !config.withoutAuthentication 
                    // we need to add token only if the user is already logged in (ApiUrl exists in localStorage then)
                    // and the request is to api (not providers web api)
                    && apiUrl && config.url.startsWith(apiUrl)) {
                    config.headers['Authorization'] = token;
                }
                return config;
            }
        }
    })
    .factory('httpInterceptor', ['$q', '$injector', 'RequestService', function ($q, $injector, RequestService) {
        function saveEmptyParametersOf(request) {
            if (request.params && angular.isObject(request.params)) {
                var keys = Object.keys(request.params);
                angular.forEach(keys, function (item) {
                    var value = request.params[item];
                    if (value === null || angular.isUndefined(value)) {
                        // assign null or undefined properties with empty string - 
                        // in that case empty params are included into the url.
                        request.params[item] = '';
                    }
                });
            }
        }

        function notAuthenticatedRequest(url) {
            //if url starts with null it means localStorage.getItem('ApiUrl') is null 
            //that means it is not authenticated user
            var result = url.startsWith('null');
            return result;
        }

        function isZeroStatusResponse(response) {
            var result = response.status == 0
                && (!response.config.timeout || response.config.timeout.status != 499) //499 - client cancelled request, it is initialized in RequestService.abort().
                && !notAuthenticatedRequest(response.config.url);
            return result;
        }

        function pingProvidersApi(fnCallback) {
            $.ajax({
                url: DeploymentSettings.providersServiceUrl.replace('api/', '') + 'Sms/Ping',
                method: 'GET'
            })
            .fail(function (e) {
                console.log(e);
                if(fnCallback)
                    fnCallback();
            });
        }

        var reload = function(state, newUrl) {
            newUrl = newUrl ? newUrl : '';
            // i use window.location here instead of state.go because i want to force BROWSER 
            // to reload the whole page and get source code updates from our web server.
            // note: state.current.url returns not full relative url, for example, for 
            // the view "TopMenuLayout.SignUpPropertyManager.Step2" it returns "/SignUpPropertyManagerStep2"
            // instead of "#/SignUpPropertyManager/SignUpPropertyManagerStep2"
            var indexOfIndex = window.location.href.indexOf('index.html');
            var newLocation = window.location.href;
            if (indexOfIndex > 0) {
                newLocation = newLocation.substr(0, indexOfIndex);
            }
            else {
                var relativeUrl = state.href(state.current.name);
                var indexOfRelativeUrl = newLocation.indexOf(relativeUrl);
                if (indexOfRelativeUrl > 0) {
                    newLocation = newLocation.substr(0, indexOfRelativeUrl);
                }
            }
            if (utilli.isAdmin) {
                var indexOfAdmin = newLocation.indexOf('Admin/');
                if (indexOfAdmin > 0) {
                    newLocation = newLocation.substr(0, indexOfAdmin);
                }
            }
            utilli.setWindowLocation(newLocation + newUrl);
        }

        //find web api url that match with current request url
        //for example the current request url is https://apidev.utilli.com/hc/api/System/Check
        //we get the https://apidev.utilli.com/hc/api/ as result
        var getServiceProviderUrl = function (requestUrl) {
            var deferred = $q.defer();

            $.ajax({
                url: DeploymentSettings.providersServiceUrl + 'Providers/GetAllProviders',
                method: 'GET'
            })
            .done(function (providers) {
                if (!providers || providers.length == 0) {
                    deferred.reject("We cannot get providers list from web api providers.");
                    return;
                }
                var providerInfo = _.find(providers, function(provider){ 
                    return requestUrl.indexOf(provider.ApiUrl) !== -1; 
                });

                deferred.resolve(providerInfo);
            })
            .fail(function (e) {
                deferred.reject(e);
            });

            return deferred.promise;
        }

        var responseInterceptor = {
            request: function (request) {
                if (notAuthenticatedRequest(request.url)) {
                    RequestService.forcedAbort(request);
                    utilli.clearLocalStorage();
                    var stateService = $injector.get('$state');
                    stateService.goToSignIn(true);
                    return request;
                }
                if (request.url.indexOf(".html") != -1 && !$injector.get('$templateCache').get(request.url))
                    request.url += DeploymentSettings.currentVersion;
                RequestService.add(request);
                saveEmptyParametersOf(request);
                return request;
            },
            response: function (response) {

                // if generation was not changed on the server the value of 'ValidGeneration' header is 'Valid'.
                // Otherwise header is 'NotValid'. If header is null then generation was not checked on the server.
                var header = response.headers('ValidGeneration');
                if (header != null && header !== 'Valid') {
                    var modalService = $injector.get('ModalServiceExt');
                    modalService.showMessage(
                        utilli._t('Notification'), 
                        utilli._t('Your session has expired. You must login again to continue.'), 
                        function () {
                            var state = $injector.get('$state');
                            if (isMobileOrRipple()) {
                                state.goToSignIn();
                                return response;
                            }
                            console.log('Redirect to login page because security token generation is obsolete.');
                            RequestService.abort();
                            utilli.clearLocalStorage();
                            reload(state);
                            return response;
                        }
                    );
                }

                return response;
            },
            responseError: function (response) {

                var stateService = $injector.get('$state');

                // 401 error code is thrown when user is not authorized (token is wrong or expired).
                if (response.status == 401) {
                    var modalService = $injector.get('ModalServiceExt');
                    modalService.showMessage(utilli._t('Notification'), utilli._t('You are not logged in or your session has expired. Please login to continue.'), function () {
                        console.log('Redirect to login page because security token is not valid.');
                        RequestService.abort();

                        //Yuriy Sokha: I want this redirect to always work. It is required for Bot Authorization.
                        var currentState = stateService.current.name;
                        stateService.goToSignIn(true);

                        utilli.clearLocalStorage();
                        return response;
                    });
                }

                if (response.status == 403) {
                    var header = response.headers('Client-Version');
                    if (header != null && header === 'not-valid') {
                        //setTimeout(function(){
                        var modalService = $injector.get('ModalServiceExt');
                        modalService.showMessage(
                            utilli._t('Notification'), 
                            utilli._t("Current page is outdated. Please refresh to continue."), 
                            function () {
                                var state = $injector.get('$state');
                                if (isMobileOrRipple()) {
                                    localStorage.setItem('forcedUpdateMobile', true);
                                    reload(state, 'UpdateMobile.html');
                                    return response;
                                }
                                console.log('Refreshing because page is outdated.');
                                RequestService.abort();
                                reload(state);
                                return response;
                            }
                        );
                    //}, 100);
                    }
                }

                // 503 error code is thrown when maintenance is required.
                if (response.status == 503) {
                    console.log('Redirect to maintenance page.');
                    RequestService.abort();
                    stateService.go('Maintenance');
                    return response;
                }

                if(isZeroStatusResponse(response))
                {
                    var usSpinnerService = $injector.get('usSpinnerService');
                    getServiceProviderUrl(response.config.url)
                        .then(function(providerInfo) {
                            if (!providerInfo.IsAvailable) {
                                console.log('Redirect to maintenance page.');
                                usSpinnerService.stop('spinner-1');
                                usSpinnerService.stop('spinner-admin');
                                RequestService.abort();
                                stateService.go('Maintenance');
                            }
                        }, function (e) {
                            console.log(e);
                            pingProvidersApi(function () {
                                usSpinnerService.stop('spinner-1');
                                usSpinnerService.stop('spinner-admin');
                                stateService.go('NoConnection');
                            });
                        });

                }

                return $q.reject(response);
            }
        }

        return responseInterceptor;
    }
    ])
    .config(['$compileProvider', '$stateProvider', '$urlRouterProvider', '$stickyStateProvider', '$httpProvider',
        function ($compileProvider, $stateProvider, $urlRouterProvider, $stickyStateProvider, $httpProvider) {
        $stickyStateProvider.enableDebug(true);
        // http://stackoverflow.com/a/23110108/292787
        // http://stackoverflow.com/questions/24246464/display-images-through-html-img-tag-with-angularjs-and-ionic
        // for windows phone also x-wmapp: http://stackoverflow.com/a/29625730/292787
        $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|file|ms-appx|x-wmapp.?):/);

        $httpProvider.interceptors.push('httpInterceptor');
        $httpProvider.interceptors.push('authorizeInterceptor');

        // routing configuration below uses angular-ui-router, and ui-router-extras
        // see examples at :
        // http://plnkr.co/edit/bEdJczNwYEfTI7joyh9h?p=preview
        // http://plnkr.co/edit/bFMLqLENmPFfCD0XCz8V?p=preview
        // http://plnkr.co/edit/rIxTa9DyOB2jsk8lpE1h?p=preview
        if (!utilli.isAdmin) {
            $urlRouterProvider.otherwise('/');
        }

        function isParamsArray(params) {
            var result = Object.prototype.toString.call(params) === '[object Array]';
            return result;
        }

        function getCommonHeaderViewsConfiguration(stateName, parentFolder) {
            var pagesPath = utilli.isAdmin ? '../' : '';
            parentFolder = parentFolder ? parentFolder += '/' : ''
            return {
                "top-menu": {
                    templateUrl: pagesPath + 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: pagesPath + 'Pages/' + parentFolder + stateName + '/' + stateName + '.html',
                    controller: stateName + 'Controller'
                }
            };
        }

            var registerForLayoutStateWithCommonHeader = function (stateName, params, layout, parentFolder) {
                var url = utilli.isAdmin ? '/Customer/:userId/:contractAccountNumber/:propertyManager/' + stateName
                    : '/' + stateName;
                if (isParamsArray(params)) {
                    //we use it for keeping parameters into url
                    if (params && params.length > 0) {
                        params.forEach(function (item) {
                            url += '/:' + item;
                        });
                    }
                }
                $stateProvider.state(layout + '.' + stateName, {
                    url: url,
                    views: getCommonHeaderViewsConfiguration(stateName, parentFolder),
                    params: isParamsArray(params) ? null : params
                });
            };

            var registerPropertyManagerRoute = function (stateName, params, parentFolder) {
                var layout = utilli.isAdmin ? 'AdminMainLayout.Customer.CustomerLayout' : 'MainLayout';
                var url = utilli.isAdmin ? '/PropertyManager/:userId/:propertyManager/' + stateName
                    : '/' + stateName;
                if (isParamsArray(params)) {
                    //we use it for keeping parameters into url
                    if (params && params.length > 0) {
                        params.forEach(function (item) {
                            url += '/:' + item;
                        });
                    }
                }
                $stateProvider.state(layout + '.' + stateName, {
                    url: url,
                    views: getCommonHeaderViewsConfiguration(stateName, parentFolder),
                    params: isParamsArray(params) ? null : params
                });
            };

        function registerRelative(mainFolder, stateName, params) {
            var pagesPath = utilli.isAdmin ? '../' : '';
            var layout = utilli.isAdmin ? 'AdminMainLayout.Customer.CustomerLayout' : 'MainLayout';
            var url = utilli.isAdmin ? '/Customer/:userId/:contractAccountNumber/:propertyManager/' + stateName
                : '/' + stateName;
            $stateProvider.state(layout + '.' + stateName, {
                url: url,
                views: {
                    "top-menu": {
                        templateUrl: pagesPath + 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: pagesPath + 'Pages/' + mainFolder + '/' + stateName + '.html',
                        controller: stateName + 'Controller'
                    }
                },
                params: params
            });
        }

        var registerStateWithCommonHeader = function (stateName, params, parentFolder) {
            var layout = utilli.isAdmin ? 'AdminMainLayout.Customer.CustomerLayout' : 'MainLayout';
            registerForLayoutStateWithCommonHeader(stateName, params, layout, parentFolder);
        };

        var registerForTopMenuLayout = function (stateName, params) {
            registerForLayoutStateWithCommonHeader(stateName, params, 'TopMenuLayout');
        };

        var registerForgotPasswordRoutes = function () {
            $stateProvider.state('TopMenuLayout.ForgotPassword', {
                url: '/ForgotPassword',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/ForgotPassword/ForgotPasswordHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/ForgotPassword/ForgotPassword.html',
                        controller: 'ForgotPasswordController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotPassword.Step1', {
                url: '/ForgotPasswordStep1',
                views: {
                    "ForgotPasswordSteps": {
                        templateUrl: 'Pages/ForgotPassword/Step1.html',
                        controller: 'ForgotPasswordStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotPassword.Step2', {
                url: '/ForgotPasswordStep2',
                views: {
                    "ForgotPasswordSteps": {
                        templateUrl: 'Pages/ForgotPassword/Step2.html',
                        controller: 'ForgotPasswordStep2Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotPassword.Success', {
                url: '/ForgotPasswordSuccess',
                views: {
                    "ForgotPasswordSteps": {
                        templateUrl: 'Pages/ForgotPassword/Success.html'
                    }
                }
            });
        }

        var registerForgotPasswordByEmailRoutes = function () {
            $stateProvider.state('TopMenuLayout.ForgotPasswordByEmail', {
                url: '/ForgotPasswordByEmail',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/ForgotPasswordByEmail/ForgotPasswordByEmailHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/ForgotPasswordByEmail/ForgotPasswordByEmail.html',
                        controller: 'ForgotPasswordByEmailController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotPasswordByEmail.Step1', {
                url: '/ForgotPasswordByEmailStep1/?from',
                views: {
                    "ForgotPasswordSteps": {
                        templateUrl: 'Pages/ForgotPasswordByEmail/Step1.html',
                        controller: 'ForgotPasswordByEmailStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotPasswordByEmail.Success', {
                url: '/ForgotPasswordByEmailSuccess',
                views: {
                    "ForgotPasswordSteps": {
                        templateUrl: 'Pages/ForgotPasswordByEmail/Success.html',
                        controller: 'ForgotPasswordByEmailSuccessController'
                    }
                }
            });
        }

        var registerForgotUserIdRoutes = function () {
            $stateProvider.state('TopMenuLayout.ForgotUserId', {
                url: '/ForgotUserId',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/ForgotUserId/ForgotUserIdHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/ForgotUserId/ForgotUserId.html',
                        controller: 'ForgotUserIdController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotUserId.Step1', {
                url: '/ForgotUserIdStep1',
                views: {
                    "ForgotUserIdSteps": {
                        templateUrl: 'Pages/ForgotUserId/Step1.html',
                        controller: 'ForgotUserIdStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotUserId.Step2', {
                url: '/ForgotUserIdStep2',
                views: {
                    "ForgotUserIdSteps": {
                        templateUrl: 'Pages/ForgotUserId/Step2.html',
                        controller: 'ForgotUserIdStep2Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotUserId.Success', {
                url: '/ForgotUserIdSuccess',
                views: {
                    "ForgotUserIdSteps": {
                        templateUrl: 'Pages/ForgotUserId/Success.html',
                        controller: 'ForgotUserIdSuccessController'
                    }
                }
            });
        }

        var registerForgotUserIdByEmailRoutes = function () {
            $stateProvider.state('TopMenuLayout.ForgotUserIdByEmail', {
                url: '/ForgotUserIdByEmail',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/ForgotUserIdByEmail/ForgotUserIdByEmailHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/ForgotUserIdByEmail/ForgotUserIdByEmail.html',
                        controller: 'ForgotUserIdByEmailController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotUserIdByEmail.Step1', {
                url: '/Step1/?from',
                views: {
                    "ForgotUserIdByEmailSteps": {
                        templateUrl: 'Pages/ForgotUserIdByEmail/Step1.html',
                        controller: 'ForgotUserIdByEmailStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotUserIdByEmail.Success', {
                url: '/Success',
                views: {
                    "ForgotUserIdByEmailSteps": {
                        templateUrl: 'Pages/ForgotUserIdByEmail/Success.html',
                        controller: 'ForgotUserIdByEmailSuccessController'
                    }
                }
            });
        }

        if (!utilli.isAdmin) {
            $stateProvider.state('TopMenuLayout', {
                views: {
                    "body-view": {
                        templateUrl: 'Pages/TopMenuLayout.html'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.Languages', {
                url: '/WelcomeLanguages',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/Languages/Languages.html',
                        controller: 'LanguagesController'
                    }
                }
            });
            $stateProvider.state('MainLayout', {
                views: {
                    "body-view": {
                        templateUrl: 'Pages/MainLayout.html',
                        controller: 'MainLayoutController'
                    }
                }
            });
        }
        registerStateWithCommonHeader('Dashboard');
        registerStateWithCommonHeader('PayNow', ['AccountNumber']);//we use this url in TaksRunner
        registerStateWithCommonHeader('InstallmentPlan');
        registerStateWithCommonHeader('Usage');
        registerStateWithCommonHeader('BillsAndPayments');
        registerStateWithCommonHeader('BillDetails', ['billNumber']);
        registerStateWithCommonHeader('PaymentOptions');
        registerStateWithCommonHeader('AddCard');
        registerStateWithCommonHeader('AddBankAccount');
        registerStateWithCommonHeader('BankAccount', ['Id']);
        registerStateWithCommonHeader('Card', ['Id']);
        registerStateWithCommonHeader('PayByCard');
        registerStateWithCommonHeader('PayByCheck');
        registerStateWithCommonHeader('PayByCheckConfirmation');
        registerStateWithCommonHeader('NotificationDetails', ['Id']);
        registerStateWithCommonHeader('UserNotifications');
        registerStateWithCommonHeader('AccountList', ['redirectIfSingle']);
        registerStateWithCommonHeader('MoveService');
        registerStateWithCommonHeader('CancelService');
        registerStateWithCommonHeader('CancelSuccess');
        registerStateWithCommonHeader('ChangePassword');
        registerStateWithCommonHeader('DonationHistory');
        registerStateWithCommonHeader('BudgetBillingLearnMore');
        registerStateWithCommonHeader('BudgetBilling');
        registerStateWithCommonHeader('AddAccount');
        registerStateWithCommonHeader('EditAccounts');
        registerStateWithCommonHeader('Faqs', ['directDebitParam', 'donationParam']);
        registerStateWithCommonHeader('EnrollCardMessage', ['Id']);
        registerStateWithCommonHeader('EnrollBankAccountMessage', ['Id']);
        registerStateWithCommonHeader('UnenrollCardMessage', ['Id']);
        registerStateWithCommonHeader('UnenrollBankAccountMessage', ['Id']);
        registerStateWithCommonHeader('Profile');
        registerStateWithCommonHeader('MobilePhoneConfirmation', ['forProgramEnrollments', 'forProgramEnrollmentsLearnMore', 'phoneNumber']);
        registerStateWithCommonHeader('Avatars', ['forAgent', 'forAssistant', 'forPropertyManager']);
        registerStateWithCommonHeader('OutageCenter');
        registerStateWithCommonHeader('OutageMap');
        registerStateWithCommonHeader('TurnOffMap');
        registerStateWithCommonHeader('OutageList');
        registerStateWithCommonHeader('OutageSafety');
        registerStateWithCommonHeader('OutageHistory');
        registerStateWithCommonHeader('ReportOutage');
        registerStateWithCommonHeader('OpenOutageReport', ['Id', 'mode']);
        registerStateWithCommonHeader('MeterData');
        registerForTopMenuLayout('TermsAndConditions');//we use this url in TaksRunner
        registerForTopMenuLayout('SystemInfo');
        registerStateWithCommonHeader('AboutUs');
        registerStateWithCommonHeader('EnergyEfficiency');
        registerStateWithCommonHeader('Languages');

        registerStateWithCommonHeader('WorkCenters', ['redirectIfSingle']);
        registerStateWithCommonHeader('LookUp');
        registerStateWithCommonHeader('LookUpLog');
        registerStateWithCommonHeader('PaymentHistory');
        registerStateWithCommonHeader('WorkOrders');
        //registerStateWithCommonHeader('WorkOrder', ['contractAccountNumber', 'orderNumber']);

        $stateProvider.state('MainLayout.TurnOffQuickPay', {
            // parent: 'MainLayout',
            url: '/QuickPay',
            views:
            {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/QuickPay/Step2.html',
                    controller: 'QuickPayStep2Controller'
                }
            }
        });

        //function registerOutageReportChildView(state) {
        //    $stateProvider.state('MainLayout.ReportOutage.' + state, {
        //        url: '/' + state,
        //        views: {
        //            "outage-location": {
        //                templateUrl: 'Pages/ReportOutage/' + state + '/' + state + '.html',
        //                controller: state + 'Controller'
        //            },
        //            "top-menu": {
        //                templateUrl: 'Pages/CommonHeader/CommonHeader.html',
        //                controller: 'CommonHeaderController'
        //            }
        //        }
        //    });
        //}

        //registerOutageReportChildView('ServiceAddress');
        //registerOutageReportChildView('NearbyAddress');
        //registerOutageReportChildView('NearbyCrossStreet');
        //registerOutageReportChildView('MyLocation');

        //function registerOpenOutageReportChildView(state) {
        //    $stateProvider.state('MainLayout.OpenOutageReport.' + state, {
        //        url: '/' + state,
        //        views: {
        //            "outage-location": {
        //                templateUrl: 'Pages/ReportOutage/' + state + '/' + state + '.html',
        //                controller: state + 'Controller'
        //            },
        //            "top-menu": {
        //                templateUrl: 'Pages/CommonHeader/CommonHeader.html',
        //                controller: 'CommonHeaderController'
        //            }
        //        }
        //    });
        //}

        //registerOpenOutageReportChildView('ServiceAddress');
        //registerOpenOutageReportChildView('NearbyAddress');
        //registerOpenOutageReportChildView('NearbyCrossStreet');
        //registerOpenOutageReportChildView('MyLocation');

        registerProgramEnrollmentsRoutes();

        function registerProgramEnrollmentsRoutes() {

            registerStateWithCommonHeader('ProgramEnrolments');

            registerRelative('ProgramEnrolments', 'DonationLearnMore');
            registerRelative('ProgramEnrolments', 'SmsNotificationsLearnMore');
            registerRelative('ProgramEnrolments', 'EmailNotificationsLearnMore');
            registerRelative('ProgramEnrolments', 'EBillingLearnMore');

            createWizard()
                .registerWizardRoot('DonationEnrollment','DonationEnrollmentSteps', 'ProgramEnrolments', { program: null })
                .registerWizardStep('DonationEnrollment', 'Step1')
                .registerWizardStep('RoundUpEnrollment', 'Success')
                .registerWizardStep('FixedAmountEnrollment', 'Step2')
                .registerWizardStep('FixedAmountEnrollment', 'Success')
                .registerWizardStep('PercentageEnrollment', 'Step2')
                .registerWizardStep('PercentageEnrollment', 'Success');
        }

        function createWizard() {
            var Wizard = function() {
                this.parentView = '';
                this.wizardRootStateName = '';
                this.parentDirectory = '';
            };

            Wizard.prototype.registerWizardRoot = function(wizardRoot, parentView, parentDirectory, params) {
                this.parentView = parentView;
                this.wizardRootStateName = wizardRoot;
                this.parentDirectory = parentDirectory;

                var pagesPath = utilli.isAdmin ? '../' : '';
                $stateProvider.state('MainLayout.' + this.wizardRootStateName, {
                    url: '/' + this.wizardRootStateName,
                    views: {
                        "top-menu": {
                            templateUrl: pagesPath + 'Pages/CommonHeader/CommonHeader.html',
                            controller: 'CommonHeaderController'
                        },
                        "main-content": {
                            templateUrl: 'Pages/' + parentDirectory + '/' +  this.wizardRootStateName + '/' + this.wizardRootStateName + '.html',
                            controller:  this.wizardRootStateName + 'StepsController'
                        }
                    },
                    params: params || {}
                });
                return this;
            };

            Wizard.prototype.registerWizardStep = function(stateName, stepNumber, params) {
                var templateUrl = this.parentDirectory
                    ? 'Pages/' + this.parentDirectory + '/'
                    : 'Pages/';
                var views = {};
                views[this.parentView] = {
                    templateUrl: templateUrl + this.wizardRootStateName + '/' + stateName + stepNumber + '.html',
                    controller: stateName + stepNumber + 'Controller'
                }
                //MainLayout.DonationEnrollment.FixedAmountEnrollmentStep2
                $stateProvider.state('MainLayout.' + this.wizardRootStateName + '.' + stateName + stepNumber, {
                    url: '/' + stateName + stepNumber,
                    views: views,
                    params: params || {}
                });
                return this;
            };

            var result = new Wizard();
            return result;
        }

        $stateProvider.state('TopMenuLayout.BotAuthorize', {
            url: '/BotAuthorize/:channelId/:clientId/:conversationId/:logoutRequired/:serviceUrl',
            views: {
                "main-content": {
                    templateUrl: 'Pages/BotAuthorize/BotAuthorize.html',
                    controller: 'BotAuthorizeController'
                },
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                 },
            }
        });

        $stateProvider.state('ResetPassword', {
            url: '/ResetPassword/:token',
            views: {
                "body-view": {
                    templateUrl: 'Pages/ResetPassword/ResetPassword.html',
                    controller: 'ResetPasswordController'
                }
            }
        });

        $stateProvider.state('ChallengeEmailSucceed', {
            url: '/ChallengeEmailSucceed/:token',
            views: {
                "body-view": {
                    templateUrl: 'Pages/ChallengeEmailSucceed/ChallengeEmailSucceed.html',
                    controller: 'ChallengeEmailSucceedController'
                }
            }
        });
        $stateProvider.state('NonSupported', {
            url: '/NonSupported',
            views: {
                "body-view": {
                    templateUrl: 'Pages/NonSupported/NonSupported.html',
                    controller: 'NonSupportedController'
                }
            }
        });
        $stateProvider.state('UpdateApp', {
            url: '/UpdateApp',
            views: {
                "body-view": {
                    templateUrl: 'Pages/UpdateApp/Update.html',
                    controller: 'UpdateAppController'
                }
            }
        });

            registerPropertyManagersRoutes();

            function registerPropertyManagersRoutes() {
                registerWelcomePropertyManagersRoutes();
                registerSignUpPropertyManagersRoutes();
                registerPropertyManagerRoute('GroupStackedDashboard', null, 'PropertyManagers');
                registerPropertyManagerRoute('PropertyStackedDashboard', null, 'PropertyManagers');
                registerPropertyManagerRoute('PropertyBarDashboard', null, 'PropertyManagers');
                registerPropertyManagerRoute('PropertyDetailedDashboard', ['selectedPeriodString'], 'PropertyManagers');
                registerPropertyManagerRoute('PropertyManagerUsage', null, 'PropertyManagers');
                registerPropertyManagerRoute('PropertyGroupList', null, 'PropertyManagers');
                registerPropertyManagerRoute('AddPropertyGroup', null, 'PropertyManagers');
                registerPropertyManagerRoute('EditPropertyGroup', ['propertyGroupId'], 'PropertyManagers');
                registerPropertyManagerRoute('Property', ['propertyId'], 'PropertyManagers');
                registerPropertyManagerRoute('EditProperty', ['id', 'showAuthorizationMetersWarning'], 'PropertyManagers');
                registerPropertyManagerRoute('PropertyList', null, 'PropertyManagers');
                registerPropertyManagerRoute('ReasonsForNoScore', ['propertyId'], 'PropertyManagers');
                registerPropertyManagerRoute('PropertyManagerProfile', null, 'PropertyManagers');
                registerPropertyManagerRoute('Billing', null, 'PropertyManagers');
                registerPropertyManagerRoute('PropertyManagerEnergyEfficiency', null, 'PropertyManagers');
                registerPropertyManagerRoute('SendInvitation', ['propertyId'], 'PropertyManagers');
                registerPropertyManagerRoute('Authorizations', null, 'PropertyManagers');
                registerPropertyManagerRoute('Invitations', ['propertyId'], 'PropertyManagers');
                registerPropertyManagerRoute('RecipientInvitationView', ['id', 'meterNumber'], 'PropertyManagers');
                registerPropertyManagerRoute('AddProperty', null, 'PropertyManagers');
                registerPropertyManagerRoute('SharedAccounts', null, 'PropertyManagers');
                registerPropertyManagerRoute('SendSharingAccountRequest', null, 'PropertyManagers');
                registerPropertyManagerRoute('SendSharingAccountRequestEmail', ['email'], 'PropertyManagers');
                registerPropertyManagerRoute(
                    'MeterNeedsApproval',
                    ['propertyId', 'meterId', 'meterNumber', 'mode', 'stepsCount', 'step', 'from'],
                    'PropertyManagers');

                registerAddPropertyRoute('PropertyOverview');
                registerAddPropertyRoute('PropertyType');
                registerAddPropertyRoute('PropertyDetails', ['type']);
                registerAddPropertyRoute('AddMeters', ['topMeter']);
                registerAddPropertyRoute('BulkMetersInput');
                registerAddPropertyRoute('FailedMeters', ['topMeter']);
                registerAddPropertyRoute('Authorization');

                function registerAddPropertyRoute(stateName, params) {
                    var layout = utilli.isAdmin ? 'AdminMainLayout.Customer.CustomerLayout' : 'MainLayout';
                    var url = '/' + stateName + '/:id/:mode/:stepsCount/:step';

                    if (isParamsArray(params)) {
                        //we use it for keeping parameters into url
                        if (params && params.length > 0) {
                            params.forEach(function (item) {
                                url += '/:' + item;
                            });
                        }
                    }

                    var pagesPath = utilli.isAdmin ? '../' : '';

                    $stateProvider.state(layout + '.AddProperty.' + stateName, {
                        url: url,
                        views: {
                            "AddPropertySteps": {
                                templateUrl: pagesPath + 'Pages/PropertyManagers/AddProperty/' + stateName + '.html',
                                controller: stateName + 'Controller'
                            }
                        },
                        params: isParamsArray(params) ? null : params
                    });
                }

                function registerAddPropertyErrorsRoute(stateName, params) {
                    var layout = utilli.isAdmin ? 'AdminMainLayout.Customer.CustomerLayout' : 'MainLayout';

                    var url = utilli.isAdmin ? '/PropertyManager/:userId/:propertyManager/' + stateName + '/:propertyId/:meterId/:mode/:stepsCount/:step'
                        : '/' + stateName + '/:propertyId/:meterId/:mode/:stepsCount/:step/:from';

                    if (isParamsArray(params)) {
                        //we use it for keeping parameters into url
                        if (params && params.length > 0) {
                            params.forEach(function (item) {
                                url += '/:' + item;
                            });
                        }
                    }

                    var pagesPath = utilli.isAdmin ? '../' : '';

                    $stateProvider.state(layout + '.' + stateName, {
                        url: url,
                        views: {
                            "top-menu": {
                                templateUrl: pagesPath + 'Pages/CommonHeader/CommonHeader.html',
                                controller: 'CommonHeaderController'
                            },
                            "main-content": {
                                templateUrl: pagesPath + 'Pages/PropertyManagers/AddProperty/Errors/' + stateName + '.html',
                                controller: stateName + 'Controller'
                            }
                        },
                        params: isParamsArray(params) ? null : params
                    });
                }

                registerAddPropertyErrorsRoute('MeterDoesNotExist');
                registerAddPropertyErrorsRoute('MeterDuplicated');
                registerAddPropertyErrorsRoute('MeterIsUsed');
                registerAddPropertyErrorsRoute('MultipleTiedMeters');
                registerAddPropertyErrorsRoute('ClaimMeter');
                registerAddPropertyErrorsRoute('ServiceAddressMismatches');

                function registerImportPropertyRoute(stateName, params, templateName) {
                    var layout = utilli.isAdmin ? 'AdminMainLayout.Customer.CustomerLayout' : 'MainLayout';
                    var url = '/' + stateName + '/:id/:stepsCount/:step';

                    if (isParamsArray(params)) {
                        //we use it for keeping parameters into url
                        if (params && params.length > 0) {
                            params.forEach(function (item) {
                                url += '/:' + item;
                            });
                        }
                    }

                    var pagesPath = utilli.isAdmin ? '../' : '';
                    var template = templateName ? templateName : stateName;

                    $stateProvider.state(layout + '.AddProperty.' + stateName, {
                        url: url,
                        views: {
                            "AddPropertySteps": {
                                templateUrl: pagesPath + 'Pages/PropertyManagers/AddProperty/' + template + '.html',
                                controller: stateName + 'Controller'
                            }
                        },
                        params: isParamsArray(params) ? null : params
                    });
                }

                registerImportPropertyRoute('LinkEnergyStarAccount');
                registerImportPropertyRoute('LinkEnergyStarAccountInstructions');
                registerImportPropertyRoute('LinkEnergyStarAccountForPropertyImport');
                registerImportPropertyRoute('LinkEnergyStarAccountForPropertyImportInstructions', null, 'LinkEnergyStarAccountInstructions');
                registerImportPropertyRoute('ShareExistingEnergyStarPropertyInstructions');
                registerImportPropertyRoute('PropertySharingResults');

                $stateProvider.state('TopMenuLayout.MeterDoesNotExist', {
                    url: '/MeterDoesNotExist/:meterId/:token',
                    views: {
                        "top-menu": {
                            templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                            controller: 'CommonHeaderController'
                        },
                        "main-content": {
                            templateUrl: 'Pages/PropertyManagers/AddProperty/Errors/MeterDoesNotExist.html',
                            controller: 'MeterDoesNotExistController'
                        }
                    }
                });

                $stateProvider.state('TopMenuLayout.MeterDuplicated', {
                    url: '/MeterDuplicated/:meterId/:token',
                    views: {
                        "top-menu": {
                            templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                            controller: 'CommonHeaderController'
                        },
                        "main-content": {
                            templateUrl: 'Pages/PropertyManagers/AddProperty/Errors/MeterDuplicated.html',
                            controller: 'MeterDuplicatedController'
                        }
                    }
                });

                $stateProvider.state('TopMenuLayout.ServiceAddressMismatches', {
                    url: '/ServiceAddressMismatches/:propertyId/:meterId/:token',
                    views: {
                        "top-menu": {
                            templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                            controller: 'CommonHeaderController'
                        },
                        "main-content": {
                            templateUrl: 'Pages/PropertyManagers/AddProperty/Errors/ServiceAddressMismatches.html',
                            controller: 'ServiceAddressMismatchesController'
                        }
                    }
                });

                $stateProvider.state('TopMenuLayout.MultipleTiedMeters', {
                    url: '/MultipleTiedMeters/:meterId/:token',
                    views: {
                        "top-menu": {
                            templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                            controller: 'CommonHeaderController'
                        },
                        "main-content": {
                            templateUrl: 'Pages/PropertyManagers/AddProperty/Errors/MultipleTiedMeters.html',
                            controller: 'MultipleTiedMetersController'
                        }
                    }
                });

                $stateProvider.state('TopMenuLayout.ClaimMeter', {
                    url: '/ClaimMeter/:meterId/:token',
                    views: {
                        "top-menu": {
                            templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                            controller: 'CommonHeaderController'
                        },
                        "main-content": {
                            templateUrl: 'Pages/PropertyManagers/AddProperty/Errors/ClaimMeter.html',
                            controller: 'ClaimMeterController'
                        }
                    }
                });

                $stateProvider.state('TopMenuLayout.SendDataSharingInvitation', {
                    url: '/SendDataSharingInvitation/:token/:useCachedMeters',
                    views: {
                        "top-menu": {
                            templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                            controller: 'CommonHeaderController'
                        },
                        "main-content": {
                            templateUrl: 'Pages/PropertyManagers/SendDataSharingInvitation/SendDataSharingInvitation.html',
                            controller: 'SendDataSharingInvitationController'
                        },
                        "footer": {
                            templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                            controller: 'WelcomeFooterController'
                        }
                    }
                });
                $stateProvider.state('TopMenuLayout.RevokeMeterSharing', {
                    url: '/RevokeMeterSharing/:token',
                    views: {
                        "top-menu": {
                            templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                            controller: 'CommonHeaderController'
                        },
                        "main-content": {
                            templateUrl: 'Pages/PropertyManagers/RevokeMeterSharing/RevokeMeterSharing.html',
                            controller: 'RevokeMeterSharingController'
                        }
                    }
                });
                $stateProvider.state('TopMenuLayout.RequestMeterSharingRevoke', {
                    url: '/RequestMeterSharingRevoke',
                    views: {
                        "top-menu": {
                            templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                            controller: 'CommonHeaderController'
                        },
                        "main-content": {
                            templateUrl: 'Pages/PropertyManagers/RequestMeterSharingRevoke/RequestMeterSharingRevoke.html',
                            controller: 'RequestMeterSharingRevokeController'
                        }
                    }
                });
            }


        // below are routes for not logged in users
        // in admin on Customer View we show only the part of the app 
        // that is visible only for logged in users, hence we don't need
        // these routes for admin
        if (utilli.isAdmin)
            return;
        // if running in mobile app then use a custom welcome page for mobile
        if (isMobileOrRipple()) 
            registerWelcomeMobileRoutes();
        else 
            registerWelcomeRoutes();

        function getMainRootRoute() {
            return utilli.isPropertyManagerApp()
                ? '/WelcomeMain/?from' 
                : '/?from';
        }

        function registerWelcomeRoutes() {
            $stateProvider.state('TopMenuLayout.WelcomeAlexa', {
                url: '/WelcomeAlexa',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/WelcomeAlexa/WelcomeAlexa.html',
                        controller: 'WelcomeAlexaController'
                    }
                }
            });

            $stateProvider.state('TopMenuLayout.Welcome', {
                url: getMainRootRoute(),
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/Welcome/Welcome.html',
                        controller: 'WelcomeController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.Welcome.SignIn', {
                sticky: true,
                dsr: true,
                views: {
                    "SignIn": {
                        templateUrl: 'Pages/SignIn/SignInPart.html',
                        controller: 'SignInPartController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.Welcome.SignIn.Credentials', {
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Credentials.html',
                        controller: 'CredentialsController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.Welcome.SignIn.Providers', {
                url: '/Providers',
				// for not mobile sign in we also need login,passwd to use it on common portals (like portalqa.utilli.com)
                params: { signInParams: { from: null, login: null, passwd: null } },
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Providers.html',
                        controller: 'ProvidersController'
                    }
                }
            });
        }

        function registerSignUpPropertyManagersRoutes() {
            $stateProvider.state('TopMenuLayout.SignUpPropertyManager', {
                url: '/SignUpPropertyManager',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/PropertyManagers/SignUp/SignUpHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/PropertyManagers/SignUp/SignUp.html',
                        controller: 'SignUpPropertyManagerController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpPropertyManager.Step1', {
                url: '/SignUpPropertyManagerStep1/:email',
                views: {
                    "SignUpPropertyManagerSteps": {
                        templateUrl: 'Pages/PropertyManagers/SignUp/Step1.html',
                        controller: 'SignUpPropertyManagerStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpPropertyManager.Step2', {
                url: '/SignUpPropertyManagerStep2',
                params: { email: null },
                views: {
                    "SignUpPropertyManagerSteps": {
                        templateUrl: 'Pages/PropertyManagers/SignUp/Step2.html',
                        controller: 'SignUpPropertyManagerStep2Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpPropertyManager.Step3', {
                url: '/SignUpPropertyManagerStep3',
                views: {
                    "SignUpPropertyManagerSteps": {
                        templateUrl: 'Pages/PropertyManagers/SignUp/Step3.html',
                        controller: 'SignUpPropertyManagerStep3Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpPropertyManager.Success', {
                url: '/SignUpPropertyManagerSuccess',
                views: {
                    "SignUpPropertyManagerSteps": {
                        templateUrl: 'Pages/PropertyManagers/SignUp/Success.html',
                        controller: 'SignUpPropertyManagerSuccessController'
                    }
                }
            });
        }

        function getPropertyManagerRootRoute () {
            return utilli.isPropertyManagerApp()  
                ? '/?from' 
                : '/WelcomePropertyManager/?from';
        }

        function registerWelcomePropertyManagersRoutes() {
            $stateProvider.state('TopMenuLayout.WelcomePropertyManager', {
                url: getPropertyManagerRootRoute(),// we use this url in email sending service
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/PropertyManagers/Welcome/Welcome.html',
                        controller: 'WelcomePropertyManagerController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            }
            );
            $stateProvider.state('TopMenuLayout.WelcomePropertyManager.SignIn', {
                sticky: true,
                dsr: true,
                views: {
                    "SignIn": {
                        templateUrl: 'Pages/SignIn/SignInPart.html',
                        controller: 'SignInPartController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomePropertyManager.SignIn.Credentials', {
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Credentials.html',
                        controller: 'CredentialsController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomePropertyManager.SignIn.Providers', {
                url: '/Providers?from',
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Providers.html',
                        controller: 'ProvidersController'
                    }
                }
            });
        }

        function registerAgentsRoutes() {
            registerWelcomeAgentsRoutes();
            registerSignUpAgentsRoutes();
            registerStateWithCommonHeader('Search', null, 'Agents');
            registerStateWithCommonHeader('AgentProfile', null, 'Agents');
            registerStateWithCommonHeader('SearchHistory', null, 'Agents');
            registerStateWithCommonHeader('SettlementProperty', ['AccountNumber', 'Address'], 'Agents');
        }

        function registerSignUpAgentsRoutes() {
            $stateProvider.state('TopMenuLayout.SignUpAgent', {
                url: '/SignUpAgent',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/Agents/SignUp/SignUpHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/Agents/SignUp/SignUp.html',
                        controller: 'SignUpAgentController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAgent.Step1', {
                url: '/SignUpAgentStep1',
                views: {
                    "SignUpAgentSteps": {
                        templateUrl: 'Pages/Agents/SignUp/Step1.html',
                        controller: 'SignUpAgentStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAgent.Step2', {
                url: '/SignUpAgentStep2',
                views: {
                    "SignUpAgentSteps": {
                        templateUrl: 'Pages/Agents/SignUp/Step2.html',
                        controller: 'SignUpAgentStep2Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAgent.Step3', {
                url: '/SignUpAgentStep3',
                views: {
                    "SignUpAgentSteps": {
                        templateUrl: 'Pages/Agents/SignUp/Step3.html',
                        controller: 'SignUpAgentStep3Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAgent.Success', {
                url: '/SignUpAgentSuccess',
                views: {
                    "SignUpAgentSteps": {
                        templateUrl: 'Pages/Agents/SignUp/Success.html',
                        controller: 'SignUpAgentSuccessController'
                    }
                }
            });
        }

        function registerWelcomeAgentsRoutes() {
            $stateProvider.state('TopMenuLayout.WelcomeAgent', {
                url: '/WelcomeAgent',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/Agents/Welcome/Welcome.html',
                        controller: 'WelcomeAgentController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomeAgent.SignIn', {
                sticky: true,
                dsr: true,
                views: {
                    "SignIn": {
                        templateUrl: 'Pages/SignIn/SignInPart.html',
                        controller: 'SignInPartController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomeAgent.SignIn.Credentials', {
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Credentials.html',
                        controller: 'CredentialsController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomeAgent.SignIn.Providers', {
                url: '/Providers?from',
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Providers.html',
                        controller: 'ProvidersController'
                    }
                }
            });
        }

        registerAgentsRoutes();


        function registerAssistantsRoutes() {
            registerWelcomeAssistantsRoutes();
            registerSignUpAssistantsRoutes();
            registerStateWithCommonHeader('AssistantSearch', null, 'Assistants');
            registerStateWithCommonHeader('AssistantProfile', null, 'Assistants');
            registerStateWithCommonHeader('Delinquents', null, 'Assistants');
            registerStateWithCommonHeader('AssistantSearchHistory', null, 'Assistants');
        }

        function registerSignUpAssistantsRoutes() {
            $stateProvider.state('TopMenuLayout.SignUpAssistant', {
                url: '/SignUpAssistant',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/Assistants/SignUp/SignUpHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/Assistants/SignUp/SignUp.html',
                        controller: 'SignUpAssistantController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAssistant.Step1', {
                url: '/SignUpAssistantStep1',
                views: {
                    "SignUpAssistantSteps": {
                        templateUrl: 'Pages/Assistants/SignUp/Step1.html',
                        controller: 'SignUpAssistantStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAssistant.Step2', {
                url: '/SignUpAssistantStep2',
                views: {
                    "SignUpAssistantSteps": {
                        templateUrl: 'Pages/Assistants/SignUp/Step2.html',
                        controller: 'SignUpAssistantStep2Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAssistant.Step3', {
                url: '/SignUpAssistantStep3',
                views: {
                    "SignUpAssistantSteps": {
                        templateUrl: 'Pages/Assistants/SignUp/Step3.html',
                        controller: 'SignUpAssistantStep3Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAssistant.Success', {
                url: '/SignUpAssistantSuccess',
                views: {
                    "SignUpAssistantSteps": {
                        templateUrl: 'Pages/Assistants/SignUp/Success.html',
                        controller: 'SignUpAssistantSuccessController'
                    }
                }
            });
        }

        function registerWelcomeAssistantsRoutes() {
            $stateProvider.state('TopMenuLayout.WelcomeAssistant', {
                url: '/WelcomeAssistant',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/Assistants/Welcome/Welcome.html',
                        controller: 'WelcomeAssistantController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomeAssistant.SignIn', {
                sticky: true,
                dsr: true,
                views: {
                    "SignIn": {
                        templateUrl: 'Pages/SignIn/SignInPart.html',
                        controller: 'SignInPartController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomeAssistant.SignIn.Credentials', {
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Credentials.html',
                        controller: 'CredentialsController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomeAssistant.SignIn.Providers', {
                url: '/Providers?from',
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Providers.html',
                        controller: 'ProvidersController'
                    }
                }
            });
        }

        registerAssistantsRoutes();

        function registerWelcomeMobileRoutes() {
            $stateProvider.state('WelcomeMobile', {
                url: '/',
                views: {
                    "body-view": {
                        templateUrl: 'Pages/WelcomeMobile/WelcomeMobile.html',
                        controller: 'WelcomeMobileController'
                    }
                }
            });
        }

        $stateProvider.state('TopMenuLayout.SignIn', {
            url: '/SignIn?from',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/SignIn/SignIn.html',
                    controller: 'SignInPartController'
                }
            }
        });
        $stateProvider.state('TopMenuLayout.SignIn.Credentials', {
            views: {
                "SignInSteps": {
                    templateUrl: 'Pages/SignIn/Credentials.html',
                    controller: 'CredentialsController'
                }
            }
        });
        $stateProvider.state('TopMenuLayout.SignIn.Providers', {
            url: '/Providers',
            params: { signInParams: { from: null, login: null, passwd: null } },
            views: {
                "SignInSteps": {
                    templateUrl: 'Pages/SignIn/Providers.html',
                    controller: 'ProvidersController'
                }
            }
        });

        registerForgotPasswordRoutes();
        registerForgotPasswordByEmailRoutes();
        registerForgotUserIdRoutes();
        registerForgotUserIdByEmailRoutes();
        registerSignUpRoutes();
        
        function registerSignUpRoutes() {
            $stateProvider.state('TopMenuLayout.SignUp', {
                url: '/SignUp?accountnumber&customerfullname&zip&email&token&user&psw&question&answer',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/SignUp/SignUpHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/SignUp/SignUp.html',
                        controller: 'SignUpController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUp.Step1', {
                url: '/SignUpStep1', //we use this url in EmailService templates
                views: {
                    "SignUpSteps": {
                        templateUrl: 'Pages/SignUp/Step1.html',
                        controller: 'SignUpStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUp.Step2', {
                url: '/SignUpStep2',
                views: {
                    "SignUpSteps": {
                        templateUrl: 'Pages/SignUp/Step2.html',
                        controller: 'SignUpStep2Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUp.Step3', {
                url: '/SignUpStep3',
                views: {
                    "SignUpSteps": {
                        templateUrl: 'Pages/SignUp/Step3.html',
                        controller: 'SignUpStep3Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUp.Success', {
                url: '/SignUpSuccess',
                views: {
                    "SignUpSteps": {
                        templateUrl: 'Pages/SignUp/Success.html',
                        controller: 'SignUpSuccessController'
                    }
                }
            });
        }

        //registerForTopMenuLayout('Maintenance');

        $stateProvider.state('Maintenance', {
            url: '/Maintenance',
            views: {
                'body-view': {
                    templateUrl: 'maintenance.html',
                    controller: 'MaintenanceController'
                }
            }
        });

        $stateProvider.state('NoConnection', {
            url: '/NoConnection',
            views: {
                'body-view': {
                    templateUrl: 'noconnection.html',
                    controller: 'NoConnectionController'
                }
            }
        });

        // Quick Pay
        // Quick Pay on Welcome
        $stateProvider.state('TopMenuLayout.Welcome.QuickPay', {
            sticky: true,
            dsr: true,
            views: {
                "QuickPay": {
                    templateUrl: 'Pages/QuickPay/QuickPayPart.html',
                    controller: 'QuickPayController'
                }
            }
        });
        $stateProvider.state('TopMenuLayout.Welcome.QuickPay.Step1', {
            views: {
                "QuickPaySteps": {
                    templateUrl: 'Pages/QuickPay/Step1.html',
                    controller: 'QuickPayStep1Controller'
                }
            }
        });
        $stateProvider.state('TopMenuLayout.Welcome.QuickPay.Step2', {
            views: {
                "QuickPaySteps": {
                    templateUrl: 'Pages/QuickPay/Step2.html',
                    controller: 'QuickPayStep2Controller'
                }
            }
        });
        // Quick Pay standalone
        $stateProvider.state('TopMenuLayout.QuickPay', {
            url: '/QuickPay',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/QuickPay/QuickPayHeader.html',
                    controller: 'QuickPayHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/QuickPay/QuickPay.html',
                    controller: 'QuickPayController'
                }
            }
        });
        $stateProvider.state('TopMenuLayout.QuickPay.Step1', {
            url: '/QuickPayStep1',
            views: {
                "QuickPaySteps": {
                    templateUrl: 'Pages/QuickPay/Step1.html',
                    controller: 'QuickPayStep1Controller'
                }
            }
        });
        $stateProvider.state('TopMenuLayout.QuickPay.Step2', {
            url: '/QuickPayStep2?accountNumber',
            views: {
                "QuickPaySteps": {
                    templateUrl: 'Pages/QuickPay/Step2.html',
                    controller: 'QuickPayStep2Controller'
                }
            }
        });
        
        $stateProvider.state('TopMenuLayout.OutageCenter', {
            url: '/Outages?anonymous',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/OutageCenter/OutageCenter.html',
                    controller: 'OutageCenterController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.PublicFaqs', {
			//we use this url in TaksRunner
            url: '/PublicFaqs', 
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/Faqs/Faqs.html',
                    controller: 'FaqsController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.OutageMap', {
            url: '/OutageMapSignedOut?anonymous',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/OutageMap/OutageMap.html',
                    controller: 'OutageMapController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.TurnOffMap', {
            url: '/TurnOffMap',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/FieldServiceEngineer/TurnOffMap/TurnOffMap.html',
                    controller: 'TurnOffMapController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.OutageList', {
            url: '/OutageListSignedOut?anonymous',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/OutageList/OutageList.html',
                    controller: 'OutageListController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.OpenOutageReport', {
            url: '/OpenOutageSignedOut?Id&mode&anonymous',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/OpenOutageReport/OpenOutageReport.html',
                    controller: 'OpenOutageReportController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.OutageSafety', {
            url: '/OutageSafetySignedOut?anonymous',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/OutageSafety/OutageSafety.html',
                    controller: 'OutageSafetyController'
                }
            }
        });
    }])
    .config(['$provide', function ($provide) {
        // add fixedFinally to all $q promises https://stackoverflow.com/a/17889426/292787
        $provide.decorator('$q', ["$delegate", function ($delegate) {
            var promisePatcher = function (promise){
                promise.fixedFinally = function (fn) {
                    return promise['finally'](fn);
                };
                // then also should return fixed object
                var originalThen = promise.then;
                promise.then = function () {
                    var self = this;
                    var originalThenResult = originalThen.apply(self, arguments);
                    originalThenResult.fixedFinally = function (fn) {
                        return originalThenResult['finally'](fn);
                    };
                    return originalThenResult;
                };
            }

            var originalDefer = $delegate.defer;
            $delegate.defer = function () {
                var deferred = originalDefer();
                promisePatcher(deferred.promise);
                return deferred;
            };
            // apply the patch also to $q.resolve()
            var originalResolve = $delegate.resolve;
            $delegate.resolve = function(){
                var self = this;
                var resolvedPromise = originalResolve.apply(self, arguments);
                promisePatcher(resolvedPromise);
                return resolvedPromise;
            }
            return $delegate;
          }]);
        
        $provide.decorator('$http', ["$delegate", function ($delegate) {
            var $http = $delegate;

            // status === 0 - means that request was cancelled.
            // requests cancelling happens when we move from one page to another.
            // if a request was cancelled then we skip error handling to avoid modal 
            // pop-ups with messages after user already moved to another page.
            var skippingErrorStatusCodeHandling = 0;

            // "finally" may not work in old android browsers, because "finally" was a reserved keyword in javascript.
            // here i add wrapper method 'fixedFinally' to be used instead of 'finally'
            function fixFinally(promise){
                if (!promise || !promise['then']) // if it's not a promise then just return whatever it is
                    return promise;
                promise.fixedFinally = function (fn) {
                    return promise['finally'](fn);
                };
                return promise;
            }

            /** adds method apiThen in addition to regular then */
            function addApiThen(ajaxPromise){
                /** same as regular 'then' but with built-in error handling */
                ajaxPromise['apiThen'] = function(regularArguments, errorHandler){
                    if (typeof regularArguments !== 'Array'){
                        regularArguments = [regularArguments];
                    }
                    // errorHandler can be either ModalServiceExt or $scope.errors
                    var scopeErrors = errorHandler.showAjaxError ? null : errorHandler;
                    var ModalServiceExt = errorHandler.showAjaxError ? errorHandler : null;
                    return ajaxPromise.then(function(response){
                        // if $scope.errors is passed then check ApiResponse for errors and return Data
                        if (scopeErrors)
                            scopeErrors.length = 0;
                        if (!response.data.Errors || !response.data.Errors.length)
                            return regularArguments[0](response.data.Data);
                        if (scopeErrors){
                            _.forEach(response.data.Errors, function(item){
                                scopeErrors.push(item);
                            });
                        }
                        else{
                            ModalServiceExt.showError(response.data.Errors[0]);
                        }
                    }, function(error) {
                        if (ModalServiceExt){
                            ModalServiceExt.showAjaxError(error);
                        }
                        else{
                            console.error(error);
                            scopeErrors.push(utilli.errors.serverErrorMessage);
                        }
                        if (regularArguments.length > 1)
                            regularArguments[1](error);
                    });
                };
            }
            
            // ajaxPromise - a promise returned by $http or a shortcut like $http.get, $http.post etc
            var fixHttpPromise = function (ajaxPromise) {
                // fix the deprecated method 'error'
                var originalErrorMethod = ajaxPromise['error'];
                ajaxPromise['error'] = function utilliErrorWrapper() {
                    if (arguments.length === 0)
                        return originalErrorMethod.apply(ajaxPromise, arguments);
                    var originalErrorHandler = arguments[0];
                    var errorHandlerWrapper = function () {
                        if (arguments.length > 1 && arguments[1] === skippingErrorStatusCodeHandling)
                            return null;
                        return originalErrorHandler.apply(originalErrorHandler, arguments);
                    };
                    return originalErrorMethod.apply(ajaxPromise, [errorHandlerWrapper]);
                }
                // fix the method 'then' of the ajax promise
                var originalThenMethod = ajaxPromise['then'];
                ajaxPromise['then'] = function utilliThenWrapper() {
                    // if error handler method is not specified in 'then'.
                    if (arguments.length === 1){
                        return fixFinally(originalThenMethod.apply(ajaxPromise, arguments));
                    }
                    // if both success and error handlers are specified
                    var thenSuccessHandler = arguments[0];
                    var originalThenErrorHandler = arguments[1];
                    var thenErrorHandlerWrapper = function () {
                        if (arguments.length == 1 && arguments[0].status === skippingErrorStatusCodeHandling)
                            return null;
                        return fixFinally(originalThenErrorHandler.apply(originalThenErrorHandler, arguments));
                    };
                    return fixFinally(originalThenMethod.apply(ajaxPromise, [thenSuccessHandler, thenErrorHandlerWrapper]));
                };
                addApiThen(ajaxPromise);
                return ajaxPromise;
            }

            // apply the fix to the function $http itself to handle such calls like $http({url: url, method: "GET"})...
            var wrapper = function () {
                var promise = $http.apply($http, arguments);
                return fixHttpPromise(promise);
            };

            // apply the fix to all shortcuts: $http.get, $http.head, $http.post, $http.put, $http.delete, $http.jsonp, $http.patch
            Object.keys($http).filter(function (key) {
                return (typeof $http[key] === 'function');
            }).forEach(function (key) {
                wrapper[key] = function () {
                    var promise = $http[key].apply($http, arguments);
                    return fixHttpPromise(promise);
                };
            });
            return wrapper;
        }]);
    }])
    .config([
        '$httpProvider', function ($httpProvider) {
            // see http://stackoverflow.com/a/20276775
            // and also http://www.bennadel.com/blog/2615-posting-form-data-with-http-in-angularjs.htm
            // Use x-www-form-urlencoded Content-Type
            $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

            /**
         * The workhorse; converts an object to x-www-form-urlencoded serialization.
         * @param {Object} obj
         * @return {String}
         */
            var param = function (obj) {
                var query = '', name, value, fullSubName, subName, subValue, innerObj, i;

                for (name in obj) {
                    value = obj[name];

                    if (value instanceof Array) {
                        for (i = 0; i < value.length; ++i) {
                            subValue = value[i];
                            fullSubName = name + '[' + i + ']';
                            innerObj = {};
                            innerObj[fullSubName] = subValue;
                            query += param(innerObj) + '&';
                        }
                    } else if (value instanceof Object) {
                        for (subName in value) {
                            subValue = value[subName];
                            fullSubName = name + '[' + subName + ']';
                            innerObj = {};
                            innerObj[fullSubName] = subValue;
                            query += param(innerObj) + '&';
                        }
                    } else if (value !== undefined && value !== null)
                        query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
                }

                return query.length ? query.substr(0, query.length - 1) : query;
            };

            // Override $http service's default transformRequest
            $httpProvider.defaults.transformRequest = [
                function (data) {
                    return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
                }
            ];
        }
    ])
    .run(['$rootScope', '$state', '$http', '$q', '$window', '$location', '$document', 'RequestService', 'CheckVersionService',
        'ServiceProvidersService', 'ServerCacheService', 'ModalServiceExt', '$resource', 'productTourService',
        function ($rootScope, $state, $http, $q, $window, $location, $document, RequestService, CheckVersionService,
            ServiceProvidersService, ServerCacheService, ModalServiceExt, $resource, productTourService) {

            var offline = localStorage.getItem('offline')
            if (offline === "1" && window.location.href.indexOf("Maintenance") == -1)
            {
                $state.go('Maintenance');  
            }
            utilli.registerGoogleAnalytics($window, $rootScope, $location);

            $document.bind('keyup', function(e) {
                $rootScope.$broadcast('keyup', e);
              });

            //because it couldn't be loaded when we don't have an internet connection.
            function preLoadNoConnectionPageLogo() {
                if (utilli.isAdmin) {

                    if (DeploymentSettings.providersGroupShortName === 'wgl')
                        $http.get('../Images/Wgl-logo.png');
                    else 
                        $http.get('../Images/Utilli-logo.png');
                }
                else {

                    if (DeploymentSettings.providersGroupShortName === 'wgl')
                        $http.get('Images/Wgl-logo.png');
                    else 
                        $http.get('Images/Utilli-logo.png');
                }
            }
			
			preLoadNoConnectionPageLogo();

            utilli.registerLocalization($rootScope, $resource);

            // if it was refresh (F5 pressed) then send request to refresh server cache.
            ServerCacheService.clearServerCache();

            //it is work around of https://issues.apache.org/jira/browse/CB-11751
            //we must delete this code after it will be fixed
            if (!$window.extendedSplashScreen)
                $window.extendedSplashScreen = {};

            FastClick.attach(document.body);

            var lastLocationChangeTimestamp;
            // this is the mechanism how to detect browser's back/forward button pressed. The feature is: when back button is pressed the 
            // $locationChangeSuccess event is fired the first, then $watch for $location.path() is called. 
            // When a user uses links or buttons except 'back button' then $watch is called the first and after that $locationChangeStart is fired.
            // see http://stackoverflow.com/questions/15813850/detect-history-back-using-angular
            $rootScope.$on('$locationChangeSuccess', function () {
                $rootScope.actualLocation = $location.path();
                lastLocationChangeTimestamp = new Date();
                ModalServiceExt.clear();
            });

            $rootScope.$watch(function () { return $location.path(); }, function (newLocation) {
                if ($rootScope.actualLocation === newLocation) {
                    // back button was pressed.
                    RequestService.abort(lastLocationChangeTimestamp);
                }
            });


            $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState) {
                if (!utilli.isAdmin && productTourService.isTourActive())
                    productTourService.pauseTour();

                var isAccountDataValid = itemNotNull('CurrentAccountNumber') && itemNotNull('CurrentUtilityType');
                if (utilli.hasAgentRole() && isProtectedPage(toState) && !isAccountDataValid) {
                    if(fromState.name)
                        e.preventDefault();
                    else {
                        e.preventDefault();
                        $state.goMainLayout('Search');
                    }
                }
            });

            function hasAgentsAccess() {
                var isAccountDataValid = itemNotNull('CurrentAccountNumber') && itemNotNull('CurrentUtilityType'); 
                utilli.hasAgentRole() && isProtectedPage(toState) && !isAccountDataValid
            }

            function itemNotNull(name) {
                var result = localStorage.getItem(name) != null && localStorage.getItem(name) != "null";
                return result;
            }
            
            function isProtectedPage (toState) {
                var result = toState.name == 'MainLayout.Dashboard' || toState.name  == 'MainLayout.BillsAndPayments' || toState.name  == 'MainLayout.MeterData';
                return result;
            }

            // state extensions
            $state.goMainLayout = function (stateName, params, options) {
                if (utilli.isAdmin) {
                    params = params || {};

                    if (options && options.reload === stateName)
                        options.reload = 'AdminMainLayout.Customer.CustomerLayout.' + stateName;

                    params.userId = $state.params.userId;
                    params.propertyManager = $state.params.propertyManager;
                    params.contractAccountNumber = $state.params.contractAccountNumber;
                    $state.go('AdminMainLayout.Customer.CustomerLayout.' + stateName, params, options);
                } else {
                    if (options && options.reload === stateName)
                        options.reload = 'MainLayout.' + stateName;
                    $state.go('MainLayout.' + stateName, params, options);
                }
                //utilli.scrollTop(); // on some pages (Profile for example) scroll top doesn't happen automatically. why?
            };

            $state.goTopMenuLayout = function (stateName) {
                $state.go('TopMenuLayout.' + stateName);
            };

            $state.goToWelcome = function (params) {
                if (isMobileOrRipple()) {
                    $state.go('WelcomeMobile', params);
                } else {
                    // if add a reload then it loads child states
                    // but looses current child states
                    if (utilli.hasAgentRole())
                        $state.goToAgentsWelcome(params);
                    else if (utilli.hasAssistantRole())
                        $state.goToAssistantsWelcome(params);
                    else if (utilli.hasPropertyManagerRole() || utilli.isPropertyManagerApp())
                        $state.goToPropertyManagersWelcome(params);
                    else
                        $state.go('TopMenuLayout.Welcome', params, { reload: true });
                }
            };

            $state.goToAgentsWelcome = function (params) {
                $state.go('TopMenuLayout.WelcomeAgent', params, { reload: true });
            }

            $state.goToAssistantsWelcome = function (params) {
                $state.go('TopMenuLayout.WelcomeAssistant', params, { reload: true });
            }

            $state.goToPropertyManagersWelcome = function (params) {
                $state.go('TopMenuLayout.WelcomePropertyManager', params, { reload: true });
            }

            /**
             * Changes current state to 'SignIn'.
             * @param {bool} withRedirect When true then it remembers the current state and 
             * will redirect to it after login
             */
            $state.goToSignIn = function (withRedirect) {
                if (withRedirect){
                    console.log('redirect from ' + this.current.name);
                }
                // note: this.params.from may already exist if we redirected the user explicitly to sign in.
                // it may happen for example if the user comes to the PayNow page by a direct link from email.
                // in this case if he is not logged in then we redirect him explicitly from PayNow to SignIn
                // so that he will land on SignIn.
                var redirectedFrom = withRedirect && !this.params.from // if from already exists then don't replace it
                    ? { from: JSON.stringify({ stateName: this.current.name, stateParams: this.params }) }
                    : null;
                if (isMobileOrRipple()) {
                    if (utilli.isPropertyManagerApp())
                        $state.goToPropertyManagersWelcome(redirectedFrom);
                    else
                        $state.go('TopMenuLayout.SignIn.Credentials', redirectedFrom);
                } else {
                    // if add a reload then it loads child states
                    // but looses current child states
                    if (utilli.isPropertyManagerApp())
                        $state.goToPropertyManagersWelcome(redirectedFrom);
                    else
                        $state.go('TopMenuLayout.Welcome', redirectedFrom, { reload: true });
                }
            };

            $state.goToSignUp = function () {
                if (isMobileOrRipple() && utilli.isPropertyManagerApp()) {
                    $state.go('TopMenuLayout.SignUpPropertyManager.Step1');
                } else {
                    // if add a reload then it loads child states
                    // but looses current child states
                    $state.go('TopMenuLayout.SignUp.Step1');
                }
            }

            $state.goToForgotPassword = function () {
                if (isMobileOrRipple() && utilli.isPropertyManagerApp()) {
                    $state.go('TopMenuLayout.ForgotPasswordByEmail.Step1');
                } else {
                    $state.go('TopMenuLayout.ForgotPassword.Step1');
                }
            }

            $state.goToForgotUserID = function () {
                if (isMobileOrRipple() && utilli.isPropertyManagerApp()) {
                    $state.go('TopMenuLayout.ForgotUserIdByEmail.Step1');
                } else {
                    $state.go('TopMenuLayout.ForgotUserId.Step1');
                }
            }

            $state.goToSignInWithRedirectTo = function (to) {

                var redirectTo = to ? { from: JSON.stringify({ stateName: to }) } : null;

                if (isMobileOrRipple()) {
                    $state.go('TopMenuLayout.SignIn.Credentials', redirectTo);
                } else {
                    // if add a reload then it loads child states
                    // but looses current child states
                    $state.go('TopMenuLayout.Welcome', redirectTo, { reload: true });
                }
            };

            $state.includesChild = function (childStateName) {
                return $state.current.name.indexOf(childStateName) >= 0;
            }

            $state.goFromWelcomeTo = function (stateName, params) {
                if (isMobileOrRipple()) {
                    return $state.go('TopMenuLayout.' + stateName, params);
                } else {
                    return $state.go('TopMenuLayout.Welcome.' + stateName, params);
                }
            };
            $state.goRelativeTo = function (parentName, childName, params) {
                var parentPos = $state.current.name.indexOf(parentName);
                if (parentPos < 0)
                    return $state;

                var topRoute = $state.current.name.slice(0, parentPos);
                return $state.go(topRoute + parentName + '.' + childName, params);
            };

            function pingPortal() {
                //do the empty request to detect the maintenance mode
                ServiceProvidersService.getProviderApiUrl().then(function (apiUrl) {
                    var url = apiUrl + 'api/System/Check';
                    $http({
                        url: url,
                        method: "GET",
                        withoutAuthentication: true
                    })
                    .success(function () { })
                    .error(function () { });
                });
            }

            // check app version compatibility with deployed back-end system
            if (isMobileOrRipple()) {
                CheckVersionService
                    .checkVersion()
                    .then(function (result) {
                        if (CheckVersionService.isVersionWrong(result))
                            $state.go('UpdateApp');
                            // result should be either correct or wrong,
                            // otherwise it's unexpected result and most probably
                            // the internet connection is just missing or
                            // our server (ProvidersWebApi project) is completely down
                        else if (!CheckVersionService.isVersionCorrect(result))
                            $state.go('NoConnection');
                    });
            }
            else {
                pingPortal();
            }
        }])
    .directive('ngBindHtmlDynamic', ["$compile", function($compile) {
        return {
            restrict: 'A',
            replace: true,
            link: function (scope, element, attrs) {
                scope.$watch(attrs.ngBindHtmlDynamic, function(html) {
                    element[0].innerHTML = html;
                    $compile(element.contents())(scope);
                });
            }
        };
    }])
    // restrict user to enter into an input only digits
    .directive('restrictCurrency', function () {
        return {
            restrict: 'A',
            link: function (scope, element) {
                var fixNumberFormat = function (element) {
                    if (element.value == '') {
                        return;
                    }
                    if (!isNumberFormatCorrect(element.value)) {
                        element.value = 0;
                        return;
                    }
                    // format as 0.00
                    element.value = Number(element.value).toFixed(2);
                };

                $(element).keyup(function () {
                    // NOTE: when input type is 'number' there is an issue:
                    // https://docs.angularjs.org/api/ng/input/input%5Bnumber%5D
                    // see 'Issues with HTML5 constraint validation'
                    // !this.value - this is necessary to allow a user to enter dot first
                    // because when a user enters dot this.value is empty here
                    if (!this.value || !this.value.trim() || isNumberFormatCorrect(this.value))
                        return;
                    this.value = this.oldValue;// we can't do just slice, because user can be entering in the middle
                });
                $(element).keydown(function (e) {
                    if (e.keyCode === 13) {
                        fixNumberFormat(this);
                        e.preventDefault();
                        return;
                    }
                    this.oldValue = this.value;// save for future use in key-up
                });
                $(element).focusout(function () {
                    fixNumberFormat(this);
                });
            }
        };
    })
    // restrict user to enter the phone number in the +1 (999) 999-9999 format
    .directive('phoneTemplate', ['$timeout', '$window', function ($timeout, $window) {
        return {
            link: function ($scope, element) {
                $window.$(element).mask(Config.phoneNumberMask);
            }
        };
    }])
    .directive('ccNumberTemplate', ['$timeout', '$window', function ($timeout, $window) {
        return {
            link: function ($scope, element) {
                $window.$(element).mask(Config.ccNumberMask, { placeholder: "" });
            }
        };
    }]);

'use strict';

angular.module('utilliApp')
    .controller('CommonHeaderController', [
        '$scope', '$state', 'CommonHeaderService',
        function ($scope, $state, CommonHeaderService) {
            $scope.CommonHeaderService = CommonHeaderService;
        }
    ]);
'use strict';
angular.module('utilliApp').factory('CommonHeaderService', [
// ReSharper disable InconsistentNaming
    '$window', '$state', 'HeaderServiceFactory', function ($window, $state, HeaderServiceFactory) {
// ReSharper restore InconsistentNaming
        var baseService = HeaderServiceFactory.getHeaderSerivce();
        return baseService;
    }
]);
'use strict';
angular.module('utilliApp')
.controller('ChallengeEmailSucceedController', ['$scope', '$http', '$stateParams', '$sce', '$state', '$location',
        'ServiceProvidersService', 'usSpinnerService',
    // ReSharper disable InconsistentNaming
    function ($scope, $http, $stateParams, $sce, $state, $location, ServiceProvidersService, usSpinnerService) {
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming
        $scope.validateToken = function ()
        {
            $scope.status = _t('Email verification...');
            if (!$stateParams.token)
            {
                $scope.errors = [utilli.errors.serverErrorMessage];
                usSpinnerService.stop('spinner-1');
                return;
            }
            setWelcomePageLink($stateParams.token);
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider)
                .then(
                function(providerData){
                    var url = providerData.ApiUrl + 'api/Registration/ChallengeEmail';
                    $http({
                        url: url,
                        method: 'GET',
                        params: { verificationToken: $stateParams.token },
                        withoutAuthentication: true
                    }).success(function(data) {
                        usSpinnerService.stop('spinner-1');
                        if (data.Errors && data.Errors.length > 0) {
                            $scope.errors = data.Errors;
                            return;
                        }
                        $scope.status = _t('Your Email Has Been Verified');
                        $scope.html = $sce.trustAsHtml(data.Data.Html);
                    }).error(function() {
                        usSpinnerService.stop('spinner-1');
                        $scope.errors =  [utilli.errors.serverErrorMessage];
                    });
                },
                function () {
                    usSpinnerService.stop('spinner-1');
                    $scope.errors = [utilli.errors.serverErrorMessage];
                });
        };

        function setWelcomePageLink(token) {

            var roles = utilli.getPayload(token).roles;
            if (roles) {
                var isAgent = _.some(roles, function (role) {
                    return role === utilli.roles.Agent;
                });
                var isPropertyManager = _.some(roles, function (role) {
                    return role === utilli.roles.PropertyManager;
                });
                if (isAgent)
                    $scope.welcomePath = 'TopMenuLayout.WelcomeAgent';
                else if (isPropertyManager)
                    $scope.welcomePath = 'TopMenuLayout.WelcomePropertyManager';
                else
                    $scope.welcomePath = 'TopMenuLayout.Welcome';
            }

        }
    }]);
'use strict';
angular.module('utilliApp')
.controller('MobilePhoneConfirmationController', ['$scope', '$http', '$state', '$stateParams', '$sce', '$timeout',
    '$location', 'ServiceProvidersService', 'ModalServiceExt', 'usSpinnerService', 'NotificationBoxService',
    'CommonHeaderService', 'LeftMenuService',
    function ($scope, $http, $state, $stateParams, $sce, $timeout, $location, ServiceProvidersService,
        ModalServiceExt, usSpinnerService, NotificationBoxService, CommonHeaderService, LeftMenuService) {
        NotificationBoxService.setTemporarilyHide(true);
        LeftMenuService.show();
        CommonHeaderService.setUpBackButton($scope._t('Confirmation'));

        $scope.forProgramEnrollments = $stateParams.forProgramEnrollments;
        $scope.forProgramEnrollmentsLearnMore = $stateParams.forProgramEnrollmentsLearnMore;

        $scope.phoneNumberMask = Config.phoneNumberMask;
        var countryCode = utilli.getCountryPhoneNumberCode();
        $scope.confirmationCodeMask = "9999";
        $scope.phoneNumber = $stateParams.phoneNumber;

        $scope.verificationCodeRequested = false;
        $scope.canRequestVerificationCode = true;

        (function () {
            usSpinnerService.spin("spinner-1");
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/StaticData/GetPhoneNumberConfirmationDisclamer',
                method: 'GET'
            }).success(function (data) {
                usSpinnerService.stop("spinner-1");
                $scope.html = $sce.trustAsHtml(data);
            }).error(function () {
                usSpinnerService.stop("spinner-1");
                $scope.errors = [ $scope._t('Server error. Try again later.') ];
            });
        })();

        $scope.timeout = 15;
        $scope.timeoutStr = '' + $scope.timeout;

        var tickTimer = function () {
            if ($scope.timeout != 0) {
                $scope.timeout--;
                $timeout(tickTimer, 1000);
            } else {
                $scope.canRequestVerificationCode = true;
            }

            $scope.timeoutStr = '' + $scope.timeout;
            if ($scope.timeoutStr.length < 2) {
                $scope.timeoutStr = '0' + $scope.timeoutStr;
            }
        }

        $scope.sendVerificationCode = function () {
            $scope.errors = [];
            if (validatePhoneNumber()) {
                $scope.canRequestVerificationCode = false;

                $scope.timeout = 15;
                $scope.timeoutStr = '' + $scope.timeout;

                $timeout(tickTimer, 1000);

                usSpinnerService.spin('spinner-1');
                var url = localStorage.getItem('ApiUrl') + 'api/Profile/GenerateNewPhoneConfirmationCode';
                var requestData = {
                    phoneNumber: countryCode + $scope.phoneNumber
                };
                utilli.addUserName($state, requestData);
                usSpinnerService.spin('spinner-1');
                $http({
                    url: url,
                    method: 'GET',
                    params:requestData
                }).success(function (data) {
                    if (data.Errors && data.Errors.length > 0) {
                        $scope.errors = data.Errors;
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    usSpinnerService.stop('spinner-1');
                    $scope.verificationCodeRequested = true;
                }).error(function () {
                    $scope.errors = [$scope._t('Server error. Try again later.')];
                    usSpinnerService.stop('spinner-1');
                });
            }
        }

        $scope.confirmPhone = function () {
            $scope.errors = [];
            if (validateConfirmationCode()) {
                var url = localStorage.getItem('ApiUrl') + 'api/Profile/ConfirmPhoneNumber';
                usSpinnerService.spin('spinner-1');
                var requestData = {
                    phoneNumber: countryCode + $scope.phoneNumber,
                    code: $scope.confirmationCode
                }
                utilli.addUserName($state, requestData);
                $http({
                    url: url,
                    method: 'GET',
                    params: requestData
                }).success(function (data) {
                    if (data.Errors && data.Errors.length > 0) {
                        $scope.errors = data.Errors;
                        usSpinnerService.stop('spinner-1');
                        return;
                    } else {
                        NotificationBoxService.setSubscribeSmsVisibilityServerFlag(false);
                        var maskedPhone = getMaskedPhoneNumberValue(countryCode + $scope.phoneNumber);
                        var popupMessage = $scope._t('Your phone number') + ' ' + maskedPhone + ' ' + $scope._t('has been successfully verified for Utilli SMS notifications.');
                        ModalServiceExt.showMessage($scope._t('SMS Notifications'), popupMessage, function() {
                            if ($scope.forProgramEnrollments)
                                $state.goMainLayout('ProgramEnrolments');
                            else if ($scope.forProgramEnrollmentsLearnMore)
                                $state.goMainLayout('SmsNotificationsLearnMore');
                            else
                                $state.goMainLayout('Profile');
                        });
                        usSpinnerService.stop('spinner-1');
                    }
                }).error(function () {
                    $scope.errors = [ $scope._t('Server error. Try again later.') ];
                    usSpinnerService.spin('spinner-1');
                });
            }
        }

        function validatePhoneNumber() {
            var valid = true;
            $scope.phoneNumberError = false;

            if (!$scope.phoneNumber) {
                $scope.phoneNumberError = true;
                valid = false;
            }

            return valid;
        }

        function validateConfirmationCode() {
            var valid = true;
            $scope.confirmationCodeError = false;

            if (!$scope.confirmationCode) {
                $scope.confirmationCodeError = true;
                valid = false;
            }

            return valid;
        }

        $scope.back = function () {
            if ($scope.forProgramEnrollments)
                $state.goMainLayout('ProgramEnrolments');
            else if ($scope.forProgramEnrollmentsLearnMore)
                $state.goMainLayout('SmsNotificationsLearnMore');
        }

        $scope.$on('$destroy', function () {
            NotificationBoxService.setTemporarilyHide(false);
        });
    }]);
'use strict';
angular.module('utilliApp')
.controller('TermsAndConditionsController', ['$scope', '$http', '$sce', 'usSpinnerService',
    'ServiceProvidersService', 'CommonHeaderService',
    // ReSharper disable InconsistentNaming
    function ($scope, $http, $sce, usSpinnerService, ServiceProvidersService, CommonHeaderService) {
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming

        CommonHeaderService.setUpBackButton(_t('Terms and Conditions'), true);
        $scope.loadContent = function () {
            usSpinnerService.spin("spinner-1");
            ServiceProvidersService.getCurrentProvider().then(
                function(providerData) {
                    var provider = providerData;
                    var url = provider.ApiUrl + 'api/StaticData/GetTermsAndConditions';
                    $http({
                        url: url,
                        method: 'GET'
                    }).success(function(data) {
                        $scope.html = $sce.trustAsHtml(data);

                        usSpinnerService.stop("spinner-1");
                    }).error(function() {
                        usSpinnerService.stop("spinner-1");
                        $scope.errors = [{ key: 'Error', Message: utilli.errors.serverErrorMessage }];
                    });
                },
                function() {
                    usSpinnerService.stop("spinner-1");
                    $scope.errors = [{ key: 'Error', Message: utilli.errors.serverErrorMessage }];
                }
            );
        }
}]);
'use strict';
angular.module('utilliApp')
    .controller('SystemInfoController', [
        '$scope', '$http', 'usSpinnerService', 'ServiceProvidersService', 'CommonHeaderService', 'ModalServiceExt',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, ServiceProvidersService, CommonHeaderService, ModalServiceExt) {
            // ReSharper restore InconsistentNaming
            CommonHeaderService.setUp();

            usSpinnerService.spin("spinner-1");
            ServiceProvidersService.getCurrentProvider().then(
                function(providerData) {
                    var provider = providerData;

                    $http({
                        method: 'GET',
                        url: provider.ApiUrl + 'api/System/GetDbInfo'
                    }).success(function(resp) {
                        usSpinnerService.stop('spinner-1');
                        if (!resp || !resp.Data) {
                            ModalServiceExt.showInfo("No response.");
                            return;
                        }

                        $scope.dbInfo = resp.Data;
                    }).error(function() {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showInfo("Unexpected error.");
                    });

                    $scope.applyMigrations = function() {
                        usSpinnerService.spin('spinner-1');
                        $http({
                            method: 'POST',
                            url: provider.ApiUrl + 'api/System/UpdateDb'
                        }).success(function() {
                            usSpinnerService.stop('spinner-1');
                            ModalServiceExt.showInfo("Success.");
                        }).error(function() {
                            usSpinnerService.stop('spinner-1');
                            ModalServiceExt.showInfo("Unexpected error.");
                        });
                    };
                });
        }
    ]);
/// <reference path="../SignIn/Credentials.js" />
'use strict';
angular.module('utilliApp')
    .controller('BotLoginController', [
        '$scope', '$http', '$sce', 'usSpinnerService',
        'ServiceProvidersService', 'CommonHeaderService', 'CheckVersionService', '$state', '$stateParams', '$location',
        function($scope, $http, $sce, usSpinnerService, ServiceProvidersService, CommonHeaderService, CheckVersionService, $state, $stateParams, $location) {
        CommonHeaderService.setUp();
        $scope.loadContent = function () {
            usSpinnerService.spin("spinner-1");
            ServiceProvidersService.getCurrentProvider().then(
                function(providerData) {
                    var provider = providerData;
                    var url = provider.ApiUrl + 'api/StaticData/GetTermsAndConditions';
                    $http({
                        url: url,
                        method: 'GET'
                    }).success(function(data) {
                        $scope.html = $sce.trustAsHtml(data);

                        usSpinnerService.stop("spinner-1");
                    }).error(function() {
                        usSpinnerService.stop("spinner-1");
                        $scope.errors = [{ key: 'Error', Message: utilli.errors.serverErrorMessage }];
                    });
                },
                function() {
                    usSpinnerService.stop("spinner-1");
                    $scope.errors = [{ key: 'Error', Message: utilli.errors.serverErrorMessage }];
                }
            );

            var checkVersionPromise = CheckVersionService.checkVersion();

            $scope.goToWithVersionChecking = function (state) {
                usSpinnerService.spin('spinner-1');
                checkVersionPromise.then(function () {
                    $state.go(state);
                    usSpinnerService.stop('spinner-1');
                });
            }

            $scope.botLogin = function () {
                usSpinnerService.spin('spinner-1');

                var login = $.trim($scope.credentials.login);
                var password = $.trim($scope.credentials.password);


                var dataobj = {
                    userNameOrEmail: login,
                    password: password,
                    channelId: $location.search().channelId,
                    fromId: $location.search().fromId
                };

                $http({
                    url: 'https://bot.utilli.com/api/messages/LogOn',
                    method: "GET",
                    params: dataobj
                }).success(function () {
                    usSpinnerService.stop('spinner-1');
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                });
            };


        }
}]);
'use strict';
angular.module('utilliApp')
    .factory('GridService', ['$http',
        function ($http) {
            var svc = {};
            /**
            * Creates a function that will be resizing a grid.
            * @param gridElement - element of the grid whose size needs to be adjusted
            * @param bottomSpace - how much pixels should be left at the bottom of the grid
            */
            svc.getGridResizeFunc = function (gridElement, bottomSpace) {
                var resizeFunc = function (kendoGrid) {
                    if (!kendoGrid || kendoGrid.table == null)
                        return;

                    var grid = gridElement.find(".k-grid-content");
                    var contentContainerHeight = $('.y-scrollable').innerHeight();
                    var containerOtherElemententsHeight = gridElement[0].getBoundingClientRect().top - $('.y-scrollable')[0].getBoundingClientRect().top;
                        //$('.main-ui-view').innerHeight() - gridElement.innerHeight();

                    var otherElements = gridElement.children().not(".k-grid-content");
                    var otherElementsHeight = 0;
                    otherElements.each(function () {
                        otherElementsHeight += $(this).outerHeight();
                    });
                    otherElementsHeight += parseInt(gridElement.css('border-top-width'));
                    otherElementsHeight += parseInt(gridElement.css('border-bottom-width'));
                    otherElementsHeight += parseInt(gridElement.css('margin-bottom'));
                    if (bottomSpace)
                        otherElementsHeight += bottomSpace;

                    var contentContainerHeightWithoutTopElements = contentContainerHeight - containerOtherElemententsHeight;

                    var minimumVisibleRows = 5;
                    var heightOf10Rows = !kendoGrid._data || kendoGrid._data.length === 0 ? 0 : minimumVisibleRows * kendoGrid.table[0].clientHeight / kendoGrid._data.length;
                    if (contentContainerHeightWithoutTopElements < heightOf10Rows) {
                        var height = kendoGrid._data.length < minimumVisibleRows ? kendoGrid.table[0].clientHeight : heightOf10Rows;
                        grid.height(Math.floor(height) - 1);
                        gridElement[0].style.height = '';
                        return;
                    }
                    // if there is a horizontal scroll then its height should be added to the grid size
                    var horizontalScrollHeight = 20;
                    var minHeight = contentContainerHeightWithoutTopElements < kendoGrid.table[0].clientHeight + horizontalScrollHeight + otherElementsHeight
                        ? contentContainerHeightWithoutTopElements - otherElementsHeight
                        : kendoGrid.table[0].clientHeight + horizontalScrollHeight;
                    grid.height(Math.floor(minHeight) - 1);
                    gridElement[0].style.height = '';
                };
                return resizeFunc;
            }
            return svc;
        }]);


'use strict';
angular.module('utilliApp')
    .factory('PaymentHistoryService', ['$http', '$q', 'ModalServiceExt', '$rootScope', 'usSpinnerService',
        function ($http, $q, ModalServiceExt, $rootScope, usSpinnerService) {
            var _t = utilli._t;
            var extendPaymentItem = function(paymentItem, isPaymentCancelationEnabled) {
                var getCanCancelPayment = function() {
                    if (!isPaymentCancelationEnabled)
                        return false;
                    var now = new Date();
                    now.setDate(now.getDate() - 1);
                    var controlTime = now.getTime();
                    var paymentTime = paymentItem.PaymentDate.getTime();
                    if (paymentTime < controlTime)
                        return false;
                    return paymentItem.PaymentAmount < 0;
                }
                paymentItem.PaymentDescription = paymentItem.PaymentDescription === 'Other' && paymentItem.PaymentAmount > 0
                    ? _t('Cancelled payment')
                    : paymentItem.PaymentDescription;

                paymentItem.paymentDateUnix = paymentItem.PaymentDate.getTime();
                paymentItem.checkOrConfirmationNumber = paymentItem.PaymentConfirmationNumber;
                paymentItem.amount = getPositiveAmountString(paymentItem.PaymentAmount);
                paymentItem.canCancelPayment = getCanCancelPayment();
                paymentItem.cancelPayment = function() {
                    var requestData = { AccountNumber: paymentItem.AccountNumber, PaymentId: paymentItem.PaymentId };
                    usSpinnerService.spin('spinner-1');
                    $http({
                        url: localStorage.getItem('ApiUrl') + 'api/PaymentHistory/CancelPayment',
                        method: "POST",
                        data: requestData
                    }).success(function(data) {
                        usSpinnerService.stop('spinner-1');
                        if (data == 'Success') {
                            if (paymentItem.PaymentDate.getTime() > new Date().getTime())
                                ModalServiceExt.showInfo(_t('Payment cancellation was successful.'));
                            else
                                ModalServiceExt.showInfo(_t('Your request for payment cancellation was successful. Credit will post to your bank account/credit card in approximately 24 hours. Please contact customer service with any questions.'));
                            // broadcast event so that grid and infinite scrolling will get it and update themselves
                            $rootScope.$broadcast('paymentCanceledEvent', paymentItem.PaymentId);
                        } else
                            ModalServiceExt.showInfo(_t('The payment has been already canceled.'));
                    }).error(function () {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showInfo(_t('Your request for payment cancellation failed. Please contact customer services for further assistance.'));
                    });
                }
            };

            return {
                extendPaymentItem: extendPaymentItem
            };
        }
    ]);
'use strict';

angular.module('utilliApp')
    .controller('BillsAndPaymentsController', ['$scope', '$http', '$state', 'BillsService', '$rootScope', '$timeout',
        'LeftMenuService', 'ModalServiceExt', 'CommonHeaderService', 'CommonDataService', 'PaymentHistoryService',
    function ($scope, $http, $state, billsService, $rootScope, $timeout, LeftMenuService, ModalServiceExt,
        CommonHeaderService, CommonDataService, PaymentHistoryService) {
        LeftMenuService.setCurrentTab('BillsAndPayments');
        CommonHeaderService.setUp($scope._t('BILL & PAYMENT HISTORY'));
        $scope.currentTab = 'BillsList';
        $scope.isPayNowButtonVisible = !utilli.hasAgentRole();

        var pageSize = 20;

        $scope.viewDetails = function (bill) {
            billsService.setCurrentBill(bill);
            $rootScope.showSlideAnimation = true;
            $state.goMainLayout('BillDetails', { billNumber: bill.BillNumber });
            $timeout(function () { $rootScope.showSlideAnimation = false; }, 1000);
        };

        $scope.billAmountClass = function (billItem) {
            if (billItem.PaidStatus.toUpperCase() == 'UNPAID')
                return "data-amount-unpaid";
            else if (billItem.PaidStatus.toUpperCase().indexOf('PENDING') > -1)
                return "data-amount-pending";
            else
                return "data-amount";
        };

        $scope.billsHistoryInfoForScrolling = [];
        $scope.billsInfoForScrolling = [];

        $scope.billsInfoBusy = false;
        var billsLoadedCount = 0;
        $scope.billsInfoEndReached = false;

        $scope.billsHistoryInfoBusy = false;
        var paymentsLoaded = 0;
        $scope.billsHistoryInfoEndReached = false;

        $scope.getBillsInfoScrolling = function () {

            if ($scope.billsInfoBusy)
                return;
            $scope.billsInfoBusy = true;

            var accountNumber = localStorage.getItem('CurrentAccountNumber');

            var dataRequest = {
                accountNumber: accountNumber,
                skip: billsLoadedCount,
                pageSize: pageSize,
                withTotalCount: false
            };
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Bills/GetBillInfoPage/',
                method: "GET",
                params: dataRequest
            }).success(function (data) {
                $scope.IsGettingDashboardInfo = false;
                if (!data) {
                    ModalServiceExt.showServerError();
                    return;
                }
                if (data.ErrorList && data.ErrorList.length > 0) {
                    ModalServiceExt.showError(data.ErrorList[0].Message);
                    return;
                }
                $scope.acceptBillsInfoScrolling(data);
            }).error(function () {
                $scope.IsGettingDashboardInfo = false;
                ModalServiceExt.showServerError();
            });
        };

        $scope.acceptBillsInfoScrolling = function (data) {
            if (!data.Bills) {
                $scope.billsInfoBusy = false;
                $scope.billsInfoEndReached = true;
                return;
            }

            for (var i = 0; i < data.Bills.length; i++) {
                $scope.billsInfoForScrolling.push(data.Bills[i]);
                billsLoadedCount++;
            }
            $scope.billsInfoBusy = false;

            if (data.Bills.length < pageSize) {
                $scope.billsInfoEndReached = true;
            }
        };

        $scope.getBillsHistoryInfoScrolling = function () {

            if ($scope.billsHistoryInfoBusy)
                return;
            $scope.billsHistoryInfoBusy = true;

            var accountNumber = localStorage.getItem('CurrentAccountNumber');

            var dataRequest = {
                accountNumber: accountNumber,
                skip: paymentsLoaded,
                pageSize: pageSize,
                withTotalCount: false
            };

            CommonDataService.getCommonData().then(
                function(commonData) {
                    $scope.EnablePaymentCancelation = commonData.EnablePaymentCancelation;
                },
                function() {
                    ModalServiceExt.showServerError();
                }).then(
                function() {
                    $http({
                        url: localStorage.getItem('ApiUrl') + 'api/PaymentHistory/GetPaymentsPage/',
                        method: "GET",
                        params: dataRequest
                    }).success(function(data) {
                        $scope.IsGettingDashboardInfo = false;
                        var jsondata = data;
                        if (jsondata) {
                            if (jsondata.ErrorList && jsondata.ErrorList.length > 0) {
                                $scope.billsHistoryInfoEndReached = true;
                                ModalServiceExt.showError(jsondata.ErrorList[0].Message);
                            } else {
                                $scope.acceptBillsHistoryInfoScrolling(data);
                            }
                        } else {
                    ModalServiceExt.showServerError();
                        }
                    }).error(function() {
                        $scope.billsHistoryInfoEndReached = true;
                        ModalServiceExt.showServerError();
                    });
                });
        };

        $scope.acceptBillsHistoryInfoScrolling = function (data) {
            if (!data.GetPaymentHistoricBills || data.GetPaymentHistoricBills.length == 0) {
                $scope.billsHistoryInfoBusy = false;
                $scope.billsHistoryInfoEndReached = true;
                return;
            }

            for (var i = 0; i < data.GetPaymentHistoricBills.length; i++) {
                PaymentHistoryService.extendPaymentItem(data.GetPaymentHistoricBills[i], $scope.EnablePaymentCancelation);
                $scope.billsHistoryInfoForScrolling.push(data.GetPaymentHistoricBills[i]);
                paymentsLoaded++;
            }
            $scope.billsHistoryInfoBusy = false;

            if (data.GetPaymentHistoricBills.length < pageSize) {
                $scope.billsHistoryInfoEndReached = true;
            }
        };

        $scope.$on('paymentCanceledEvent', function(event, data)
        {
            for (var i = 0; i < $scope.billsHistoryInfoForScrolling.length; i++)
            {
                var item = $scope.billsHistoryInfoForScrolling[i];
                if (item.PaymentId != data)
                    continue;

                $scope.billsHistoryInfoForScrolling.splice(i, 1);
            }
        });
    }])
;
'use strict';

angular.module('utilliApp')
    .controller('BillsGridCtrl', [
        '$scope', '$rootScope', '$http', 'BillsService', '$state', 'OpenFileService',
        'GridService', 'ModalServiceExt',
        function ($scope, $rootScope, $http, BillsService, $state, OpenFileService, GridService, ModalServiceExt) {
            var gridResizeFunc = GridService.getGridResizeFunc($("#billsGrid"));

            $(window).resize(function() {
                gridResizeFunc($scope.billsKendoGrid);
            });
            $rootScope.$on('subscribe-notification-hide', function (event, args) {
                // gridResizeFunc($scope.billsKendoGrid);
                $scope.billsKendoGrid.dataSource.read();
                $scope.billsKendoGrid.refresh();
            })

            $scope.understandMyBill = function() {
                OpenFileService.openUnderstandBillFile();
            }

            $scope.makePayment = function() {
                $state.goMainLayout("PayNow");
            }

            $scope.managePaymentOptions = function () {
                $state.goMainLayout("PaymentOptions");
            }

            $scope.viewBill = function(bill) {
                OpenFileService.openBill(bill.BillNumber, bill.AccountNumber);
            }

            var accountNumber = localStorage.getItem('CurrentAccountNumber');

            $scope.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function (options) {
                            var webapi = new kendo.data.transports.webapi({ prefix: "" });
                            var params = webapi.parameterMap(options.data);
                            params = $.extend(params, { 
                                accountNumber: accountNumber,
                                skip: (params.page - 1) * params.pageSize,
                                pageSize: params.pageSize,
                                withTotalCount: true,
                            });
                            var url = localStorage.getItem('ApiUrl') + 'api/Bills/GetBillInfoPage';
                            $http.get(url, { params: params })
                                .success(function (data) {
                                    options.success(data);
                                    gridResizeFunc($scope.usersKendoGrid);
                                })
                                .error(function () {
                                    options.error();
                                });
                        }
                    },
                    schema: {
                        data: function(response) {
                            // resize is useful here for the case when number of items per page is changed.
                            // i call resize to handle that the grid can expand or shrink.
                            // timeout is necessary to process resize after data is loaded
                            setTimeout(function () { gridResizeFunc($scope.billsKendoGrid); }, 0);
                            if (!response) {
                                ModalServiceExt.showServerError();
                                return [];
                            }
                            if (response.ErrorList.length > 0) {
                                ModalServiceExt.showError(response.ErrorList[0].Message);
                                return [];
                            }
                            return response.Bills;
                        },
                        total: "TotalBillsCount"
                    },
                    pageSize: 20,
                    serverPaging: true
                },
                sortable: true,
                pageable: {
                    pageSize: 10,
                    pageSizes: [10, 25, 50],
                    buttonCount: 3,
                    refresh: true
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                dataBound: function() { gridResizeFunc($scope.billsKendoGrid); },
                columns: [
                    {
                        field: "BillNumber",
                        title: $scope._t('Invoice Number'),
                        template: "<span # if (PaidStatus == 'Unpaid') {# style='color:red;' #}# >#: BillNumber #</span>",
                        width: 140
                    }, {
                        field: "BillDate",
                        title: $scope._t('Date'),
                        template: "<span # if (PaidStatus == 'Unpaid') {# style='color:red;' #}# >#: BillDate #</span>",
                        width: 100
                    }, {
                        field: "BillAmount",
                        title: $scope._t('Amount'),
                        template: "<span # if (PaidStatus == 'Unpaid') {# style='color:red;' #}# >#: kendo.format('{0:c2}', BillAmount)#</span>",
                        width: 90
                    }, {
                        field: "LatePayAmount",
                        title: $scope._t('Charges'),
                        template: "<span # if (PaidStatus == 'Unpaid') {# style='color:red;' #}# >#: kendo.format('{0:c2}', LatePayAmount)#</span>",
                        width: 90
                    }, {
                        field: "DueDate",
                        title: $scope._t('Due Date'),
                        template: "<span # if (PaidStatus == 'Unpaid') {# style='color:red;' #}# >#: DueDate #</span>",
                        width: 100
                    }, {
                        field: "PaidStatus",
                        title: $scope._t('Status'),
                        template: "<span # if (PaidStatus == 'Unpaid') {# style='color:red;' #}# >#: PaidStatusTranslated #</span>",
                        width: 70
                    }, {
                        width: 70,
                        template: kendo.template($("#view-btn-template").html())
                    }
                ]
            }
        }
    ]);
'use strict';

angular.module('utilliApp')
.controller('PaymentsGridCtrl', ['$scope', '$rootScope', '$http', 'BillsService', 'GridService',
        'CommonDataService', 'ModalServiceExt', 'PaymentHistoryService', '$state',
        function ($scope, $rootScope, $http, BillsService, GridService, CommonDataService,
            ModalServiceExt, PaymentHistoryService, $state) {
            var gridResizeFunc = GridService.getGridResizeFunc($("#paymentsGrid"));
            $(window).resize(function () {
                gridResizeFunc($scope.paymentsKendoGrid);
            });

            var accountNumber = localStorage.getItem('CurrentAccountNumber');

            $scope.$on('paymentCanceledEvent', function () {
                $scope.paymentsKendoGrid.dataSource.read();
                $scope.paymentsKendoGrid.refresh();
            });

            $rootScope.$on('subscribe-notification-hide', function (event, args) {
                // gridResizeFunc($scope.paymentsKendoGrid);
                $scope.paymentsKendoGrid.dataSource.read();
                $scope.paymentsKendoGrid.refresh();
            })

            $scope.makePayment = function () {
                $state.goMainLayout("PayNow");
            }   

            $scope.managePaymentOptions = function () {
                $state.goMainLayout("PaymentOptions");
            }

            CommonDataService.getCommonData().then(
                function(commonData) {
                    $scope.EnablePaymentCancelation = commonData.EnablePaymentCancelation;
                },
                function() {
                    ModalServiceExt.showServerError();
                }).then(
                function () {
                    var columns = [
                        {
                            field: "PaymentDate",
                            title: $scope._t('Date'),
                            width: 100
                        }, {
                            field: "PaymentAmount",
                            title: $scope._t('Amount'),
                            template: "#: kendo.format('{0:c2}', PaymentAmount)#",
                            width: 80
                        }, {
                            field: "PaymentDescription",
                            title: $scope._t('Description'),
                            width: 130
                        }, {
                            field: "PaymentBy",
                            title: $scope._t('Payment By'),
                            width: 100, 
                            hidden: utilli.isHc()
                        }, {
                            title: $scope._t('Check/Conf. #'),
                            template: "#: PaymentConfirmationNumber #",
                            width: 120
                        }
                    ];
                    if ($scope.EnablePaymentCancelation) {
                        columns.push({
                            width: 100,
                            template: "<input type='button' class='btn btn-primary grid-button' ng-show='#: canCancelPayment #' value='Cancel' ng-click='dataItem.cancelPayment()' />"
                        });
                    }
                    $scope.mainGridOptions = {
                        dataSource: {
                            transport: {
                                read: function (options) {
                                    var webapi = new kendo.data.transports.webapi({ prefix: "" });
                                    var params = webapi.parameterMap(options.data);
                                    params = $.extend(params, { 
                                        accountNumber: accountNumber,
                                        skip: (params.page - 1) * params.pageSize,
                                        pageSize: params.pageSize,
                                        withTotalCount: true
                                    });
                                    var url = localStorage.getItem('ApiUrl') + 'api/PaymentHistory/GetPaymentsPage';
                                    $http.get(url, { params: params })
                                        .success(function (data) {
                                            options.success(data);
                                            gridResizeFunc($scope.usersKendoGrid);
                                        })
                                        .error(function () {
                                            options.error();
                                        });
                                }
                            },
                            schema: {
                                data: function (response) {
                                    // resize is useful here for the case when number of items per page is changed.
                                    // i call resize to handle that the grid can expand or shrink.
                                    // timeout is necessary to process resize after data is loaded
                                    setTimeout(function () { gridResizeFunc($scope.paymentsKendoGrid); }, 0);

                                    if (!response) {
                                        ModalServiceExt.showServerError();
                                        return [];
                                    }
                                    if (response.ErrorList.length > 0) {
                                        ModalServiceExt.showError(response.ErrorList[0].Message);
                                        return [];
                                    }

                                    response.GetPaymentHistoricBills.forEach(function (item) {
                                        PaymentHistoryService.extendPaymentItem(item, $scope.EnablePaymentCancelation);
                                    });

                                    return response.GetPaymentHistoricBills;
                                },
                                total: "TotalPaymentsCount"
                            },
                            pageSize: 10,
                            serverPaging: true
                        },
                        sortable: true,
                        pageable: {
                            pageSize: 10,
                            pageSizes: [10, 25, 50],
                            buttonCount: 5,
                            refresh: true
                        },
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        dataBound: gridResizeFunc,
                        columns: columns
                    }
                });
        }])
'use strict';

angular.module('utilliApp')
    .controller('DashboardController', ['$scope', 'usSpinnerService', '$timeout', 'CommonDataService', 
        '$q', 'ModalService', 'ModalServiceExt', 'LeftMenuService', '$state', 'CommonHeaderService', 
        'CustomerInfoDataService', 'DueReminderService', 'UnitsService', 'productTourService', 'TimeService',
        function ($scope, usSpinnerService, $timeout,
// ReSharper disable InconsistentNaming
            CommonDataService, $q, ModalService, ModalServiceExt, LeftMenuService, $state,
            CommonHeaderService, CustomerInfoDataService, DueReminderService, UnitsService, productTourService,
            TimeService) {
            // ReSharper restore InconsistentNaming
            $scope.units = UnitsService;
            $scope.isPayNowButtonVisible = !utilli.hasAgentRole();
            LeftMenuService.setCurrentTab('Dashboard');
            CommonHeaderService.setUpNotificationButton();
            $scope.customerInfo = {};
            $scope.customerInfo.account = {};
            var loading = $scope._t('loading...');
            $scope.customerInfo.account.AccountNumber = loading;
            $scope.customerInfo.account.ServiceAddress = loading;
            $scope.customerInfo.account.CustomerFullName = loading;

            $scope.customerInfo.userinfo = {};
            
            $scope.LastPaymentDate = loading;
            $scope.LastPaymentAmount = loading;

            $scope.IsGettingDashboardInfo = false;

            $scope.dashboardInfo = {};

            $scope.payNow = function ()
            {
                usSpinnerService.spin('spinner-1');
                CommonDataService.getCommonData().then(
                    function() {
                        usSpinnerService.stop('spinner-1');
                        $state.goMainLayout('PayNow');
                    },
                    function() {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showError($scope._t('Service is unavailable now. Try again later.'));
                    });
            }

            $scope.emiOption = function ()
            {
                $state.goMainLayout('InstallmentPlan');
            }

            $scope.getUtilityImage = function () {
                var utilliType = localStorage.getItem('CurrentUtilityType');
                if (utilliType == 'Gas')
                    return 'gas-bgr';
                if (utilliType == 'Water')
                    return 'water-bgr';
                if (utilliType == 'Electricity')
                    return 'elctr-bgr';

                return '';
            }

            CommonDataService.getCommonData().then(
                function (commonData) {
                    $scope.showRefundButton = commonData.EnablePaymentRefund;
                    $scope.EnableInstallmentPlan = utilli.notAgentOrAssistant() && commonData.EnableInstallmentPlan;
                },
                function () {
                    ModalServiceExt.showError($scope._t('Service is unavailable now. Try again later.'));
                });

            $scope.isEmiOptionVisible = function(){
                // EMI Option button should not be visible if balance is negative. negative balance means that user
                // has paid in ahead (for resources  than he hasn't yet consumed). Installment Plan program makes
                // sense only if the user owe a lot of money to the company and has troubles to pay them all in one time
                return $scope.EnableInstallmentPlan && $scope.customerInfo.userinfo.TotalOpenBalance > 0;
            }

            $scope.requestRefund = function() {
                usSpinnerService.spin('spinner-1');
                $timeout(function() {
                    ModalServiceExt.showInfo($scope._t('Your request for a refund is being processed. '+
                        'Please check back in 24 hours or call customer service for further clarifications.'));
                    $scope.showRefundButton = false;
                    usSpinnerService.stop('spinner-1');
                }, 1500);
            }

            $scope.GetDashboardInfo = function () {
                usSpinnerService.spin('spinner-1');

                $scope.IsGettingDashboardInfo = true;
                CustomerInfoDataService.getCustomerInfoData()
                    .then(
                        function(customerInfoData) {
                            if (!customerInfoData) {
                                ModalServiceExt.showServerError();
                                return;
                            }
                            if (utilli.hasAssistantRole()){
                                LeftMenuService.setContractAccountInfo(customerInfoData);
                            }
                            if (customerInfoData.ERROR_LIST && customerInfoData.ERROR_LIST.length > 0) {
                                ModalServiceExt.showError(customerInfoData.ERROR_LIST[0].Message);
                            } else {
                                acceptDashboardData(customerInfoData);
                            }
                        },
                        function(err) {
                            ModalServiceExt.showError(err);
                        }
                    )
                    .then(showDueReminder)
                    // "['finally']" instead of just "finally" because in old android browsers "finally" is a reserved keyword
                    ['finally'](function() {
                        $scope.IsGettingDashboardInfo = false;
                        usSpinnerService.stop('spinner-1');
                    });
            };

            function showProductTour() {
                if (!utilli.isAdmin && !utilli.hasAgentRole() && !utilli.hasAssistantRole() 
                    && $scope.customerInfo.userinfo.Tour 
                    && !isMobileOrRipple()) // turn off for mobile for now because there are issues with positioning GNIS-2793
                    productTourService.startTour($scope.customerInfo.userinfo.Tour)
            }

            function showDueReminder() {
                if (DueReminderService.isReminderShown()) {
                    showProductTour();
                    return;
                }
                else
                    DueReminderService.markAsShown();

                if ((!$scope.customerInfo.userinfo
                    || !$scope.customerInfo.userinfo.DateDiff
                    || $scope.customerInfo.userinfo.TotalOpenBalance <= 0) &&
                    !($scope.customerInfo.userinfo.IsDisconnected && $scope.customerInfo.userinfo.TotalOpenBalance <= 0)) {
                    showProductTour();
                    return;
                }

                ModalService.showModal({
                    templateUrl: 'due-reminder',
                    controller: "ReminderController"
                }).then(function (modal) {
                    modal.element.modal();
                    modal.close.then(function () {
                        showProductTour();
                    });
                });
            }

            function acceptDashboardData(customerInfo) {

                localStorage.setItem('CurrentUtilityType', customerInfo.account.UtilliType);
                $scope.units.updateUnits();
                $scope.customerInfo = customerInfo;

                $scope.showDueDate = customerInfo.userinfo.TotalOpenBalance > 0 && customerInfo.userinfo.DueDate != '0001-01-01T00:00:00';
                $scope.showPastDue = false;
                $scope.showDisconnected = false;
                $scope.showDisconnectionPending = false;
                $scope.accountStatuses = [];

                $scope.LastPaymentAmount = customerInfo.userinfo.LastPaymentAmount == null
                    ? null
                    : getPositiveAmountString(customerInfo.userinfo.LastPaymentAmount);
                $scope.LastPaymentDate = TimeService.parseISOLocalDate(customerInfo.userinfo.LastPaymentDate);

                try {
                    $scope.customerInfo.dueDate = TimeService.parseISOLocalDate(customerInfo.userinfo.DueDate);
                    if ($scope.customerInfo.userinfo.IsDisconnected) {
                        $scope.showDisconnected = true;
                    }
                    else if ($scope.customerInfo.userinfo.IsAccountDisconnectionPending) {
                        $scope.showDisconnectionPending = true;
                    }
                    else if($scope.showDueDate && $scope.customerInfo.dueDate < utilli.getDateWithoutTime(new Date())) {
                        $scope.showPastDue = true;
                    }
                    $scope.accountStatuses = utilli.fillAccountStatuses($scope.customerInfo.account);
                } catch (ex) {
                    console.log(ex);
                }
            };
        }])
 .controller('ReminderController', ['$scope', 'close', '$state', '$http', 'usSpinnerService',
     'CommonDataService', 'CustomerInfoDataService', '$element',
     function ($scope, close, $state, $http, usSpinnerService, CommonDataService,
         CustomerInfoDataService, $element) {

        $scope.isHc = utilli.isHc();
        CustomerInfoDataService.getCachedData().then(
            function(data) {
                $scope.customerInfo = data;
            },
            function() {
                // error message is shown during the first call in dashboard controller
            });

        CommonDataService.getCommonData().then(function (commonData) {
            $scope.SupportPhone = commonData.SupportPhone;
        });

         $scope.close = function () {
            closeModal();
         }

         var closeModal = function () {
             // https://github.com/dwmkerr/angular-modal-service/issues/124
             // http://stackoverflow.com/a/20109519/292787
             // my explanation: modal('hide') hides the modal, this removes backdrop div that adds
             // opacity for backgroud. once hide is completed we can close the modal - this removes
             // div from body completely. it is necessary to call close only after hide is finished
             // because it works async. otherwise if just call it this way:
             // $element.modal('hide');
             // close();
             // then close will destroy the modal and hide will not find what to hide
             $element.modal('hide').on('hidden.bs.modal', function () {
                 close();
             });
         };

        //todo: need to be tested (closing popup by Esc pressing)
        // $scope.$on('keyup', function (event, e) {
        //     if (e.which == 27) {
        //         $element.modal('hide').on('hidden.bs.modal', function () {
        //             close();
        //         });
        //     }
        // })

         $scope.gotoPayment = function () {
             closeModal();
             goTo('PayNow');
         }

         $scope.gotoPaymentOptions = function () {
             closeModal();
             goTo('PaymentOptions');
         }

         function getDate(dateSource) {
             var dateAsString = dateSource.substr(0, 10);
             var result = kendo.parseDate(dateAsString, "yyyy-MM-dd");
             return result;
         }

         $scope.getFormatedDueDate = function () {
             if (!$scope.customerInfo || !$scope.customerInfo.userinfo)
                 return '';
             var date = getDate($scope.customerInfo.userinfo.DueDate);
             var result = kendo.toString(date, "d");
             return result;
         }

         $scope.getFormatedDisconnectDate = function () {
             if (!$scope.customerInfo || !$scope.customerInfo.userinfo)
                 return '';
             var date = getDate($scope.customerInfo.userinfo.DisconnectDate);
             var result = kendo.toString(date, "d");
             return result;
         }

         function goTo(address) {
             usSpinnerService.spin('spinner-1');
             CommonDataService.getCommonData()
                 .then(function () {
                     usSpinnerService.stop('spinner-1');
                     $state.goMainLayout(address);
                 }, function () {
                     usSpinnerService.stop('spinner-1');
                     ModalServiceExt.showError($scope._t('Sevice is unavailable now. Try again later.'));
                 });
        }
 }]);
'use strict';
angular.module('utilliApp')
.controller('WelcomeController', ['$scope', 'LeftMenuService', '$state', 'CommonDataService',
    'ServiceProvidersService', '$sce', 'usSpinnerService', '$http', 'CommonHeaderService',
function ($scope, LeftMenuService, $state, CommonDataService, ServiceProvidersService, $sce,
    usSpinnerService, $http, CommonHeaderService) {
    CommonHeaderService.setUp();

    $scope.isMultipleProviders = !DeploymentSettings.currentServiceProvider;
    $scope.appUrls = Config.appUrls;
    $scope.enableOutageMap = false;

    if (utilli.goesToDefaultPage($state)) return;

    $state.goFromWelcomeTo('SignIn.Credentials')
        .then(function () {
            $state.goFromWelcomeTo('QuickPay.Step1');
        });

    $scope.goToQuickPay = function (){
        $state.go('TopMenuLayout.QuickPay.Step1');
    };

    $scope.goToOutages = function () {
        $state.go('TopMenuLayout.OutageCenter', { anonymous: true });
    };

    if (DeploymentSettings.currentServiceProvider.length > 0) {
        $scope.serviceProviderName = Config.providers[DeploymentSettings.currentServiceProvider].SiteName;
        $scope.helpEmail = Config.providers[DeploymentSettings.currentServiceProvider].HelpEmail;
        $scope.showPhoneNumbers = Config.providers[DeploymentSettings.currentServiceProvider].EnablePhoneNumbersOnLoginPage;
        $scope.enableOutageMap = Config.providers[DeploymentSettings.currentServiceProvider].EnableOutageMap;
    }
    else {
        $scope.serviceProviderName = 'Utilli';
        $scope.helpEmail = 'help@utilli.com';
    }
    $scope.phoneNumbers = $scope._t('loading...');
    $scope.loadPhoneNumbers = function (){
        ServiceProvidersService.getProviders()
            .then(
                function(providers) {
                    if (!providers || providers.length == 0) {
                        $scope.phoneNumbers = $scope._t("Server error. Try again later.");
                        return;
                    }

                    var currentServiceProvider = DeploymentSettings.currentServiceProvider;
                    if (currentServiceProvider.length == 0) {
                        $scope.phoneNumbers = $scope._t("Configuration error: can't get current service provider.");
                        return;
                    }

                    var currentProviderName = Config.providers[currentServiceProvider].Name;

                    var providersFiltered = $.grep(providers, function(item) {
                        return item.Name == currentProviderName;
                    });

                    if (!providersFiltered || providersFiltered.length !== 1) {
                        $scope.phoneNumbers = $scope._t("Configuration error: can't get current service provider.");
                        return;
                    }

                    $http({
                        url: providersFiltered[0].ApiUrl + 'api/StaticData/GetInqueriesPhoneNumbers',
                        method: "GET",
                    }).success(function(data) {
                        $scope.phoneNumbers = $sce.trustAsHtml(data);
                    }).error(function() {
                        $scope.phoneNumbers = $scope._t("Server error. Try again later.");
                    });
                },
                function() {
                    $scope.phoneNumbers = $scope._t("Server error. Try again later.");
                });
    }
}]);
'use strict';
angular.module('utilliApp')
.controller('WelcomePropertyManagerController', ['$scope', 'LeftMenuService', '$state', 'CommonDataService',
    'ServiceProvidersService', '$sce', 'usSpinnerService', '$http', 'CommonHeaderService',
function ($scope, LeftMenuService, $state, CommonDataService, ServiceProvidersService, $sce,
    usSpinnerService, $http, CommonHeaderService) {
    CommonHeaderService.setUp();

    $scope.appUrls = Config.appUrls;
    $scope.isPropertyManagerWelcomePage = true;
    var setApiUrl = function(callback){
        ServiceProvidersService.getProviderApiUrl().then(function(apiUrl){
            localStorage.setItem('ApiUrl', apiUrl);
            callback();
        })
    }
    if (utilli.goesToDefaultPage($state, setApiUrl)) return;

    var token = localStorage.getItem('SecurityToken');
    if (token)
    {
        $state.goMainLayout('PropertyList');
        return;
    }

    $state.go('TopMenuLayout.WelcomePropertyManager.SignIn.Credentials');

    $scope.goToRequestMeterRevocation = function() {
        $state.go('TopMenuLayout.RequestMeterSharingRevoke');
    }

    if (DeploymentSettings.currentServiceProvider) {
        $scope.serviceProviderName = Config.providers[DeploymentSettings.currentServiceProvider].SiteName;
        $scope.helpEmail = Config.providers[DeploymentSettings.currentServiceProvider].HelpEmail;
        $scope.showPhoneNumbers = Config.providers[DeploymentSettings.currentServiceProvider].EnablePhoneNumbersOnLoginPage;
    }
    else {
        $scope.helpEmail = 'help@utilli.com';
    }
    $scope.phoneNumbers = 'loading...';
    $scope.loadPhoneNumbers = function (){
        if ($scope.phoneNumbersLoaded){
            return;
        }
        ServiceProvidersService.getProviders()
            .then(
                function(providers) {
                    if (!providers || providers.length == 0) {
                        $scope.phoneNumbers = "Server error. Try again later.";
                        return;
                    }

                    var currentServiceProvider = DeploymentSettings.currentServiceProvider;
                    if (currentServiceProvider.length == 0) {
                        $scope.phoneNumbers = "Configuration error: can't get current service provider.";
                        return;
                    }

                    var currentProviderName = Config.providers[currentServiceProvider].Name;

                    var providersFiltered = $.grep(providers, function(item) {
                        return item.Name == currentProviderName;
                    });

                    if (!providersFiltered || providersFiltered.length !== 1) {
                        $scope.phoneNumbers = "Configuration error: can't get current service provider.";
                        return;
                    }

                    $http({
                        url: providersFiltered[0].ApiUrl + 'api/StaticData/GetInqueriesPhoneNumbers',
                        method: "GET",
                    }).success(function(data) {
                        $scope.phoneNumbers = $sce.trustAsHtml(data);
                        $scope.phoneNumbersLoaded = true;
                    }).error(function() {
                        $scope.phoneNumbers = "Server error. Try again later.";
                    });
                },
                function() {
                    $scope.phoneNumbers = "Server error. Try again later.";
                });
    }
}]);
'use strict';
angular.module('utilliApp')
.controller('SignUpPropertyManagerController', ['$scope', '$rootScope', '$window', '$state', 'CommonHeaderService',
    function ($scope, $rootScope, $window, $state,
// ReSharper disable InconsistentNaming
        CommonHeaderService) {
// ReSharper restore InconsistentNaming
        CommonHeaderService.hideMenuToggleButton();

        $scope.Model = $scope.Model || {
            firstName: '',
            lastName: '',
            agency: '',
            phoneNumber: '',
            userName : '',
            email: '',
            password: '',
            securityQuestion: '',
            securityAnswer: ''
        };
        
    }])
.controller('SignUpPropertyManagerStep1Controller', ['$scope', '$rootScope', '$http', '$state', 'moduleServices',
    'usSpinnerService', 'ServiceProvidersService', '$stateParams', 'CheckVersionService', '$q', 'ModalServiceExt',
    function ($scope, $rootScope, $http, $state, $moduleServices, usSpinnerService,
        // ReSharper disable InconsistentNaming
        ServiceProvidersService, $stateParams, CheckVersionService, $q, ModalServiceExt) {
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming

        $scope.isProviderListVisible = !DeploymentSettings.currentServiceProvider;
        usSpinnerService.spin("spinner-1");
        if ($scope.isProviderListVisible) {
            ServiceProvidersService.getProviders()
                .then(function (allProviders) {
                    usSpinnerService.stop("spinner-1");
                    if (allProviders && allProviders.length == 1) {
                        $scope.isProviderListVisible = false;
                        $rootScope.webServicesUrl = allProviders[0].ApiUrl;
                        $rootScope.serviceUrl = allProviders[0].ApiUrl + 'api/Registration/Register/';
                        return;
                    }

                    $scope.providers = allProviders;
                    $scope.provider = allProviders[0];
                },
                function () {
                    usSpinnerService.stop("spinner-1");
                    $scope.errors.push(utilli.errors.serverErrorMessage);
                });
        } else {
            ServiceProvidersService.getCurrentProvider().then(
                function (providerData) {
                    usSpinnerService.stop("spinner-1");
                    $rootScope.webServicesUrl = providerData.ApiUrl;
                    $rootScope.serviceUrl = providerData.ApiUrl + 'api/Registration/Register/';
                },
                function () {
                    usSpinnerService.stop("spinner-1");
                    $scope.errors.push(utilli.errors.serverErrorMessage);
                });
        }

        $scope.cancel = function () {
            ModalServiceExt.showYesNoMessage(_t('Confirmation'), _t('Are you sure you want to cancel registration process?'), function () {
                $state.go('TopMenuLayout.WelcomePropertyManager', null, { reload: true });
            });
        };

        $scope.phoneNumberMask = Config.phoneNumberMask;

        $scope.checkUserInfoFormSubmit = function () {
            usSpinnerService.spin("spinner-1");
            if (!$scope.formUserInfo.$valid) {
                $scope.submitted = true;
                usSpinnerService.stop("spinner-1");
                return;
            }

            if ($scope.isProviderListVisible) {
                $rootScope.webServicesUrl = $scope.provider.ApiUrl;
                $rootScope.serviceUrl = $scope.provider.ApiUrl + 'api/Registration/Register/';
            }

            $state.goRelativeTo(
                'SignUpPropertyManager',
                'Step2',
                {
                    email: $stateParams.email,
                    regData: {
                        firstName: $.trim($scope.firstName),
                        lastName: $.trim($scope.lastName),
                        agency: $.trim($scope.agency),
                        phoneNumber: $.trim($scope.phoneNumber)
                    }
                });
            usSpinnerService.stop("spinner-1");
        }
    }])
.controller('SignUpPropertyManagerStep2Controller', ['$scope', '$rootScope', '$http', '$state', 'moduleServices',
    'CommonDataService', 'usSpinnerService', '$stateParams', 'ServiceProvidersService', 'ModalServiceExt',
    // ReSharper disable InconsistentNaming
    function ($scope, $rootScope, $http, $state, $moduleServices, CommonDataService,
        usSpinnerService, $stateParams, ServiceProvidersService, ModalServiceExt) {
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming

        $scope.isEmailPredefined = $stateParams.email != null;
        if ($scope.isEmailPredefined)
        {
            $scope.Model.email = $stateParams.email;
            $scope.Model.email2 = $stateParams.email;
        }

        $scope.Model.password = '';
        $scope.passwdErrors = [];

        $scope.emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        var isEmailValid = function () {
            var matched = $scope.emailPattern.test($scope.Model.email);
            if (!matched) {
                return false;
            }
            return true;
        }

        $scope.cancel = function () {
            $state.goRelativeTo('SignUpPropertyManager', 'Step1');
        };

        $scope.errors = [];

        var loadingText = _t('Loading...');
        $scope.passRequirements = [loadingText];
        $scope.SecurityQuestions = [loadingText];
        $scope.Model.securityQuestion = loadingText;

        usSpinnerService.spin("spinner-1");
        CommonDataService.getCommonData($rootScope.webServicesUrl)
            .then(function (data) {
                usSpinnerService.stop('spinner-1');
                $scope.paswdMinLength = data.PasswordLength;
                $scope.passRequirements = data.PasswordRequirements;
                $scope.minUserIdLength = data.MinUserIdLength;
            },
            function () {
                usSpinnerService.stop("spinner-1");
                $scope.errors.push(utilli.errors.serverErrorMessage);
            });

        $http.get($rootScope.webServicesUrl + 'api/StaticData/GetSecurityQuestions/')
            .then(function (resp) {
                var sequrityQeuestions = JSON.parse(resp.data);
                $scope.SecurityQuestions = sequrityQeuestions;
                $scope.Model.securityQuestion = $scope.SecurityQuestions[0];
            },
            function () {
                $scope.errors.push(utilli.errors.serverErrorMessage);
            });

        $scope.getPasswdMinLength = function () {
            var result = $scope.paswdMinLength ? $scope.paswdMinLength : 1;
            return result;
        }

        function find(list, key) {
            return _.find(list, function (item) { return item.Key === key; });
        }

        $scope.isPasswdValid = function () { 
            $scope.passwdErrors = utilli.validatePassword($scope.Model.password, $scope.Model.userName, $scope.passRequirements, $scope.paswdMinLength);
            $scope.passwordsNotMatch = $scope.Model.password && $scope.Model.password !== $scope.confirmPassword
                ? $scope._t('Passwords do not match.')
                : null;
            var result = $scope.passwdErrors.length == 0 && !$scope.passwordsNotMatch;
            return result;
        }

        $scope.errors = [];

        function checkForScrollTop() {
            if (!validateUserID() || $scope.formUserInfo.email.$valid || $scope.formUserInfo.email2.$valid)
                utilli.scrollTop();
        }

        function validateUserID() {
            return $scope.formUserInfo.userName.$valid && $scope.formUserInfo.userName.$viewValue.length >= $scope.minUserIdLength;
        }

        $scope.checkLoginInfoFormSubmit = function () {
            usSpinnerService.spin("spinner-1");
            $scope.submitted = true;
            var isPasswordValid = $scope.isPasswdValid();
            var isUserIDValid = validateUserID();
            if (!isUserIDValid || !isPasswordValid || $scope.Model.email != $scope.Model.email2 || !isEmailValid()) {
                usSpinnerService.stop("spinner-1");
                checkForScrollTop();
                return;
            }

            var data = {
                firstName: $.trim($scope.Model.firstName),
                lastName: $.trim($scope.Model.lastName),
                agency: $.trim($scope.Model.agency),
                phoneNumber: $.trim($scope.Model.phoneNumber),

                userName: $.trim($scope.Model.userName),
                email: $.trim($scope.Model.email),
                password: $.trim($scope.Model.password),
                securityQuestion: $scope.Model.securityQuestion,
                securityAnswer: $.trim($scope.Model.securityAnswer)
            };

            $http({
                url: $rootScope.webServicesUrl + 'api/PropertyManagers/ValidateRegisterData/',
                method: "POST",
                data: data
            }).success(function (response) {
                if (response == undefined || response.HasErrors == undefined) {
                    ModalServiceExt.showServerError();
                    usSpinnerService.stop("spinner-1");
                    return;
                }
                if (response.HasErrors) {
                    $scope.errors = response.Errors;
                    utilli.scrollTop();
                }
                else {
                    $state.goRelativeTo('SignUpPropertyManager', 'Step3');
                }
                usSpinnerService.stop("spinner-1");
            }).error(function () {
                usSpinnerService.stop("spinner-1");
                ModalServiceExt.showError(utilli.errors.serverErrorMessage);
            });
        }
    }])
.controller('SignUpPropertyManagerStep3Controller', ['$scope', '$rootScope', '$http', '$state', '$stateParams', 'moduleServices',
    'CommonDataService', 'usSpinnerService', '$sce', 'ModalServiceExt',
    // ReSharper disable InconsistentNaming
    function ($scope, $rootScope, $http, $state, $stateParams, $moduleServices, CommonDataService, usSpinnerService,
        $sce, ModalServiceExt) {
        // ReSharper restore InconsistentNaming
        $scope.errors = [];

        $scope.cancel = function () {
            $state.goRelativeTo('SignUpPropertyManager', 'Step2');
        };

        $scope.loadTermsAndConditions = function () {
            usSpinnerService.spin("spinner-1");
            var url = $rootScope.webServicesUrl + 'api/StaticData/GetTermsAndConditions';
            $http({
                url: url,
                method: 'GET'
            }).success(function(data) {
                usSpinnerService.stop("spinner-1");
                $scope.html = $sce.trustAsHtml(data);
            }).error(function() {
                usSpinnerService.stop("spinner-1");
                $scope.errors.push(utilli.errors.serverErrorMessage);
            });
        }

        $scope.TermAndConditionsFormSubmit = function () {
            usSpinnerService.spin("spinner-1");
            $moduleServices.hideKeyboard();
            checkTermAndConditionsFormSubmit();
        };

        function checkTermAndConditionsFormSubmit() {
            var data = {
                firstName: $.trim($scope.Model.firstName),
                lastName: $.trim($scope.Model.lastName),
                agency: $.trim($scope.Model.agency),
                phoneNumber: $.trim($scope.Model.phoneNumber),

                userName: $.trim($scope.Model.userName),
                email: $.trim($scope.Model.email),
                password: $.trim($scope.Model.password),
                securityQuestion: $scope.Model.securityQuestion,
                securityAnswer: $.trim($scope.Model.securityAnswer),
                client: isMobileOrRipple() ? utilli.clientEnum.mobileApp : utilli.clientEnum.portal
            };

            $http({
                url: $rootScope.webServicesUrl + 'api/PropertyManagers/Register/',
                method: "POST",
                data: data
            }).success(function (response) {
                if (response == undefined || response.HasErrors == undefined) {
                    ModalServiceExt.showServerError();
                    usSpinnerService.stop("spinner-1");
                    return;
                }
                if (response.HasErrors) {
                    ModalServiceExt.showError(response.Errors[0]);
                }
                else {
                    $state.goRelativeTo('SignUpPropertyManager', 'Success');
                }
                usSpinnerService.stop("spinner-1");
            }).error(function () {
                usSpinnerService.stop("spinner-1");
                ModalServiceExt.showError(utilli.errors.serverErrorMessage);
            });
        }

    }])
.controller('SignUpPropertyManagerSuccessController', ['$scope', '$rootScope', 'CommonDataService',
    'usSpinnerService', '$state',
// ReSharper disable InconsistentNaming
    function ($scope, $rootScope, CommonDataService, usSpinnerService, $state) {
// ReSharper restore InconsistentNaming
        $scope.errors = [];
        CommonDataService.getCommonData($rootScope.webServicesUrl)
            .then(function (commonData) {
                $scope.companyNameLong = commonData.CompanyNameLong;
                $scope.companyNameLongWithoutTrailingPeriod = commonData.CompanyNameLongWithoutTrailingPeriod;
                $scope.helpEmail = commonData.CompanyHelpEmail;
                usSpinnerService.stop('spinner-1');

                $scope.SuccessOk = function () {
                    $state.go('TopMenuLayout.WelcomePropertyManager', null, { reload: true });
                }
            });
    }]);
'use strict';
angular.module('utilliApp')
    .controller('PropertyManagerProfileController', ['$scope', '$rootScope', '$http', '$window', 'usSpinnerService', '$state', '$stateParams',
        'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt', 'avatarsService',
        function ($scope, $rootScope, $http, $window, usSpinnerService, $state, $stateParams, 
        // ReSharper disable InconsistentNaming
        LeftMenuService, CommonHeaderService, ModalServiceExt,
        // ReSharper restore InconsistentNaming
        avatarsService) {

        // ReSharper disable once InconsistentNaming
        var _t = $scope._t;
        CommonHeaderService.setUp(_t('Profile'));
        LeftMenuService.setCurrentTab('PropertyManagerProfile');
        CommonHeaderService.setUpBackButton($scope._t('Profile'));

        $scope.phoneNumberMask = Config.phoneNumberMask;
        var apiUrl = localStorage.getItem('ApiUrl');
        $scope.errors = [];
        $scope.enableLanguagePack = utilli.isLanguagePackEnabled();
        $scope.espmConnected = false;

        init();

        $scope.espmAccountDisconnect = function ()
        {
            ModalServiceExt.showYesNoMessage(
                _t('Disconnection from ESPM Account'),
                _t('Are you sure you want to disconnect your Utilli Account from this ESPM Account? All Properties will be deleted on Utilli side but will remain on ESPM Account side.'),
                function () {
                    usSpinnerService.spin('spinner-1');
                    $http({
                        method: "POST",
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/DisconnectFromEspmAccount/',
                        params: {
                            UserName: $state.params.userId
                        }
                    }).success(function (response) {
                        usSpinnerService.stop('spinner-1');
                        if (response.Errors && response.Errors.length > 0) {
                            ModalServiceExt.showServerError();
                            return;
                        }
                        else
                        {
                            $scope.espmConnected = false;
                        }
                        if (callback)
                            callback();
                    }).error(function () {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                    });
                });
        }

        $scope.save = function () {
            $scope.submitted = true;
            if(!$scope.editProfileForm.$valid){
                return;
            }
            usSpinnerService.spin('spinner-1');
            var postData = {};
            $window.jQuery.extend(postData, $scope.userData);
            var countryCode = utilli.getCountryPhoneNumberCode();
            postData.PhoneNumber = countryCode + postData.PhoneNumber;
            postData.UserName = $state.params.userId;
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/EditProfile/',
                method: "POST",
                data: postData
            }).success(function (response) {
                utilli.handleAjaxResponse(response, ModalServiceExt, function () {
                    $rootScope.$broadcast('profile-updated');
                    ModalServiceExt.showInfo(_t('Your profile has been saved.'));
                });
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                $scope.errors.push({ Message: utilli.serverErrorMessage });
            });
        }

        $scope.changeAvatar = function () {
            $state.goMainLayout('Avatars', { forPropertyManager: true });
        };

        $scope.changeLanguage = function () {
            $state.goMainLayout('Languages');
        };

        $scope.securityQuestions = [];

        function init() {
            usSpinnerService.spin('spinner-1');
            $http({
                method: 'GET',
                url: apiUrl + 'api/PropertyManagers/GetProfile',
                params: { userName: $state.params.userId }
            }).success(function(data) {
                usSpinnerService.stop('spinner-1');
                $scope.securityQuestions = data.Data.SecurityQuestions;
                $scope.userData = data.Data.UserData;

                $scope.userData.PhoneNumber = utilli.adjustPhoneNumber($scope.userData.PhoneNumber);
                
                if (!$scope.userData.SecurityQuestion) {
                    $scope.userData.SecurityQuestion = $scope.securityQuestions[0];
                } else if (!_.some($scope.securityQuestions, function (item) { return item === $scope.userData.SecurityQuestion } )) {
                        $scope.securityQuestions.push($scope.userData.SecurityQuestion);
                }

                avatarsService.setCurrentAvatar(apiUrl + $scope.userData.AvatarPath);
            }).error(function() {
                usSpinnerService.stop('spinner-1');
                $scope.errors.push({ Message: utilli.serverErrorMessage });
                });


            usSpinnerService.spin('spinner-1');

            $http({
                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetEnergyStarInfo/',
                method: "GET",
                params: { userName: $state.params.userId }
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');

                if (response.Data == null) {
                    $scope.espmConnected = false;
                }
                else {
                    $scope.espmConnected = true;
                    $scope.espmFirstName = response.Data.FirstName;
                    $scope.espmLastName = response.Data.LastName;
                    $scope.espmAddressLine1 = response.Data.Address1;
                    $scope.espmAddressLine2 = response.Data.Address2;
                    $scope.espmCity = response.Data.City;
                    $scope.espmState = response.Data.State;
                    $scope.espmZip = response.Data.PostalCode;
                    $scope.espmEmail = response.Data.Email;
                    $scope.espmOrganization = response.Data.Organization;
                    $scope.espmJobTitle = response.Data.JobTitle;
                    $scope.espmPhone = response.Data.Phone;
                }
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        };
    }]);
'use strict';
angular.module('utilliApp')
    .controller('BillingController', ['$scope', '$http', '$window', 'usSpinnerService', '$state',
        'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt', '$timeout',
        function ($scope, $http, $window, usSpinnerService, $state, 
        // ReSharper disable InconsistentNaming
        LeftMenuService, CommonHeaderService, ModalServiceExt,
        // ReSharper restore InconsistentNaming
        $timeout) {

        // ReSharper disable once InconsistentNaming
        var _t = $scope._t;
        CommonHeaderService.setUp(_t('Billing'));
        LeftMenuService.setCurrentTab('Billing');
        CommonHeaderService.setUpBackButton($scope._t('Billing'));

        $scope.autoPayEnabled = true;
        $scope.reminderEnabled = true;
        $scope.confirmationEnabled = true;

        $scope.reminderSms = false;
        $scope.reminderEmail = false;
        $scope.confirmationSms = false;
        $scope.confirmationEmail = false;

        $scope.accountBalance = '-'
        $scope.paymentHistory = [];

        $scope.settings = utilli;
        $scope.requestQueue = 0;

        loadData();

        $scope.getPoListLabel = function (paymentOption) { 
            if(paymentOption.PaymentType == utilli.paymentTypes.card)
                return 'credit card **** ' + paymentOption.Info;
            else
                return 'check **** ' + paymentOption.Info;
        }

        $scope.toogleAutoPay = function () {
            $scope.autoPayEnabled = !$scope.autoPayEnabled;
            $scope.saveAutopaySettings();
        }

        $scope.toogleReminder = function () {
            $scope.reminderEnabled = !$scope.reminderEnabled;
            $scope.saveAutopaySettings();
        }

        $scope.toogleConfirmation = function () {
            $scope.confirmationEnabled = !$scope.confirmationEnabled;
            $scope.saveAutopaySettings();
        }

        $scope.goToPaymentHistory = function () { 
            $state.goMainLayout('BillsAndPayments');
        }

        $scope.goToPayNow = function () {
            $state.goMainLayout('PayNow');
        }

        $scope.goToPaymentOptionEdit = function (id, paymentType) { 
            if (paymentType == utilli.paymentTypes.card)
                $state.goMainLayout('Card', id);
            else if (paymentType == utilli.paymentTypes.card)
                $state.goMainLayout('BankAccount', id);
            else
                $state.goMainLayout('PaymentOptions');
        }

        $scope.goToPaymentOptions = function () { 
            $state.goMainLayout('PaymentOptions');
        }

        $scope.saveAutopaySettings = function  () {
            $scope.savingStatus = 'saving';
            $scope.requestQueue ++;
            $timeout(function () {
                if($scope.requestQueue > 1) {
                    $scope.requestQueue--;
                }
                else if($scope.requestQueue == 1) {
                    $scope.requestQueue--;
                    $scope.savingStatus = null;
                }
            }, 1000)
        }

        function loadData() {
            usSpinnerService.spin('spinner-1');
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/PmBilling/GetBillingInfo/',
                method: "GET"
            }).success(function(response) {
                usSpinnerService.stop('spinner-1');
                utilli.handleAjaxResponse(response, ModalServiceExt, function() {
                    $scope.paymentHistory = response.Data.PaymentHistory;
                    $scope.accountBalance = response.Data.AccountBalance;
                    
                    $scope.reminderSms = response.Data.ReminderSetting == utilli.notificationTypes.sms || response.Data.ReminderSetting == utilli.notificationTypes.smsAndEmail;
                    $scope.reminderEmail = response.Data.ReminderSetting == utilli.notificationTypes.email || response.Data.ReminderSetting == utilli.notificationTypes.smsAndEmail;
                    $scope.confirmationSms = response.Data.ConfirmationSetting == utilli.notificationTypes.sms || response.Data.ReminderSetting == utilli.notificationTypes.smsAndEmail;
                    $scope.confirmationEmail = response.Data.ConfirmationSetting == utilli.notificationTypes.email || response.Data.ReminderSetting == utilli.notificationTypes.smsAndEmail;

                    $scope.paymentMethods = response.Data.PaymentOptions;
                });
            }).error(function() {
                usSpinnerService.stop('spinner-1');
                $scope.errors.push({ Message: $scope._t("Server is unavailable, please try again later.") });
            });
        }
    }]);
'use strict';

angular.module('utilliApp')
    .controller('PropertyStackedDashboardController',
    [
        '$scope', '$rootScope', '$http', '$window', '$filter', 'usSpinnerService',
        'ModalServiceExt', 'LeftMenuService', '$state', 'CommonHeaderService',
        'DefaultPropertyService', 'UnitsService', 'PropertyService', 'PropertyListService', 'CommonDataService',
        function ($scope, $rootScope, $http, $window, $filter, usSpinnerService,
// ReSharper disable InconsistentNaming
            ModalServiceExt, LeftMenuService, $state, CommonHeaderService,
            DefaultPropertyService, UnitsService, PropertyService, PropertyListService, CommonDataService) {
            // ReSharper restore InconsistentNaming

            LeftMenuService.setCurrentTab('Dashboard');
            CommonHeaderService.setUpNotificationButton();

            usSpinnerService.spin('spinner-1');
            PropertyListService.getPropertyList().success(function (response) {
                utilli.handleAjaxResponse(response, ModalServiceExt,
                    function () {
                        if (!response.Data || response.Data.length === 0) {
                            $scope.noProperties = true;
                            $scope.noData = true;
                        }
                        else {
                            initPage();
                        }
                    });
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });

            var chart = null;
            var meterColors = [];

            function initPage() {
                DefaultPropertyService.getAggregation($state.params.userId).then(function(aggregation) {
                    if (!aggregation || aggregation.Type !== utilli.aggregationTypes.property) {
                        // https://stackoverflow.com/a/39461700/292787
                        $state.goMainLayout('GroupStackedDashboard', null, { location: 'replace' });
                        return;
                    }

                    if (aggregation.MetersCount >= Config.maxMetersOnStackedDashboard) {
                        // https://stackoverflow.com/a/39461700/292787
                        $state.goMainLayout('PropertyBarDashboard', null, { location: 'replace' });
                        return;
                    }

                    $scope.property = aggregation;

                    PropertyService.loadProperty($scope.property, $scope.getStackedGraph);

                    function setMetersColor() {
                        chart.options.series.forEach(function (seria) {
                            if (!_.find(meterColors, function (item) { return item.meter === seria.name; }))
                                meterColors.push({ meter: seria.name, colorIndex: seria._colorIndex });
                        });
                    }

                    $scope.previousPage = function() {
                        if (!$scope.disablePrev) {
                            $scope.currentPage++;
                            setMetersColor();
                            $scope.getStackedGraph();
                        }
                    };
    
                    $scope.nextPage = function() {
                        if (!$scope.disableNext) {
                            $scope.currentPage--;
                            setMetersColor();
                            $scope.getStackedGraph();
                        }
                    };
    
                    $scope.getStackedGraph();
                });
                
                $scope.units = UnitsService;
                $scope.currentPage = 0;
                $scope.pageSize = 12;
            }

            function fillChartData(consumptionData, chartOptions) {
                var i;
                $scope.units.setSelectedUnitsIfEmpty(consumptionData.Uom);
                var coefficient = $scope.units.getCoefficient(consumptionData.Uom);

                $scope.tableData = [];
                $scope.disablePrev = consumptionData.TableData.length <= $scope.pageSize;
                $scope.disableNext = $scope.currentPage <= 0;
                // shift because TableData.length can be bigger than pageSize.
                // if it's bigger than we understand that one more page exists (Prev button should be enabled)
                var shift = consumptionData.TableData.length < $scope.pageSize ? 0
                    : consumptionData.TableData.length - $scope.pageSize;
                for (i = shift; i < consumptionData.TableData.length; i++) {
                    var item = consumptionData.TableData[i];
                    var clone = $.extend({}, item);

                    clone.Consumption = utilli.trimFloat2(clone.Consumption * coefficient);
                    clone.ConsumptionString = utilli.formatNumber(clone.Consumption);
                    clone.AvgConsumption = utilli.trimFloat2(clone.AvgConsumption * coefficient);
                    clone.AvgConsumptionString = utilli.formatNumber(clone.AvgConsumption);

                    clone.Unit = $scope.units.selectedUnitsType.name;
                    clone.Date = new Date(clone.Year, clone.Month - 1, 1);
                    $scope.tableData.push(clone);
                }

                consumptionData.MeterConsumptions.forEach(function (meter, index) {

                    var colorIndex;
                    if (meterColors.length > 0) {
                        var meterColor = _.find(meterColors, function (item) { return item.meter === meter.MeterNumber; });
                        if (meterColor)
                            colorIndex = meterColor.colorIndex;
                    }

                    var seria = { name: meter.MeterNumber, _colorIndex: colorIndex, data: [] };

                    for (i = shift; i < consumptionData.TableData.length; i++) {
                        var consumption = meter.Consumptions[i];
                        var stringFixed = (consumption * coefficient).toFixed(2);
                        var convertedConsumption = parseFloat(stringFixed);
                        seria.data.push(convertedConsumption);
                    }
                    chartOptions.series.push(seria);
                });

                for (i = shift; i < consumptionData.TableData.length; i++) {
                    var date = consumptionData.Dates[i];
                    chartOptions.xAxis.categories.push(date.Year + '-' + date.Month);
                }
            }

            var plotStackedChart = function (consumptionResponse) {

                var unitsName = $scope.unitsName;
                if ($scope.units.selectedUnitsType.name != '') {
                    unitsName = $scope.units.selectedUnitsType.name;
                }

                var chartOptions = {
                    chart: {
                        type: 'area',
                        colorCount: Config.maxMetersOnStackedDashboard
                    },
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: ''
                    },
                    subtitle: {
                        text: ''
                    },
                    xAxis: {
                        categories: [],
                        tickmarkPlacement: 'on',
                        title: {
                            enabled: false
                        },
                        labels: {
                            rotation: -45
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Consumption (' + unitsName + ')'
                        },
                        labels: {
                            formatter: function () {
                                return this.value;
                            }
                        }
                    },
                    tooltip: {
                        split: true,
                        valueSuffix: ' ' + unitsName
                    },
                    plotOptions: {
                        area: {
                            stacking: 'normal',
                            lineColor: '#666666',
                            lineWidth: 1,
                            marker: {
                                lineWidth: 1,
                                lineColor: '#666666'
                            }
                        }
                    },
                    series: [],
                    credits: {
                        enabled: false
                    }
                };

                fillChartData(consumptionResponse.Data, chartOptions);
                // ReSharper disable once UndeclaredGlobalVariableUsing
                chart = Highcharts.chart('stackedGraphHere', chartOptions);
            }

            $scope.getStackedGraph = function () {
                usSpinnerService.spin('spinner-1');
                var propertyId = utilli.getCurrentPropertyId();

                CommonDataService.getCommonData()
                    .then(function (commonData) {
                        $scope.enableIndividualMeters = commonData.EnablePropertyManagersDashboardIndividualMeters || utilli.isAdmin;

                        var urlForConumptions = 'api/Consumption/GetPropertyConsumptionStackedAllMetersAggregated/';
                        if (commonData.EnablePropertyManagersDashboardIndividualMeters || utilli.isAdmin) {
                            urlForConumptions = 'api/Consumption/GetPropertyConsumptionStacked/'
                        }

                        $http({
                            url: localStorage.getItem('ApiUrl') + urlForConumptions,
                            method: "GET",
                            params: {
                                propertyId: propertyId,
                                skip: $scope.currentPage * $scope.pageSize, // currentPage starts with 0
                                pageSize: $scope.pageSize + 1,
                                userName: $state.params.userId
                            }
                        }).success(function (consumptionResponse) {
                            usSpinnerService.stop('spinner-1');
                            utilli.handleAjaxResponse(consumptionResponse,
                                ModalServiceExt,
                                function () {
                                    $scope.unitsName = consumptionResponse.Data.Uom;
                                    plotStackedChart(consumptionResponse);
                                });
                        }).error(function () {
                            usSpinnerService.stop('spinner-1');
                            ModalServiceExt.showServerError();
                        });
                    } 
                );
            };

            $scope.backToBarGraph = function () {
                $state.goMainLayout("PropertyBarDashboard");
            };

            $scope.getExcelData = function () {
                var propertyId = utilli.getCurrentPropertyId();
                var apiUrl = localStorage.getItem('ApiUrl') + 'api/Consumption/GeneratePropertyStackedExcel/';
                usSpinnerService.spin('spinner-1');
                $http({
                    url: apiUrl,
                    method: "GET",
                    params: { propertyId: propertyId, uom: $scope.units.selectedUnitsType.name, userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response == undefined || response.HasErrors == undefined) {
                        ModalServiceExt.showServerError();
                        return;
                    }
                    if (response.HasErrors) {
                        ModalServiceExt.showError(response.Errors[0]);
                    }
                    else {
                        var url = utilli.getFileUrlWithToken(response.Data);
                        utilli.downloadFile(url);
                    }
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showError(error.Message);
                });
            }

            $scope.getGreenButtonData = function () {
                var propertyId = utilli.getCurrentPropertyId();
                var apiUrl = localStorage.getItem('ApiUrl') + 'api/Consumption/GeneratePropertyStackedGreenButton/'
                    + '?propertyId=' + propertyId;
                usSpinnerService.spin('spinner-1');
                $http({
                    url: apiUrl,
                    method: "GET",
                    params: { userName: $state.params.userId}
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response == undefined || response.HasErrors == undefined) {
                        ModalServiceExt.showServerError();
                        return;
                    }
                    if (response.HasErrors) {
                        ModalServiceExt.showError(response.Errors[0]);
                    }
                    else {
                        var url = utilli.getFileUrlWithToken(response.Data);
                        utilli.downloadFile(url, "GreenButtonData.xml");
                    }
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showError(error.Message);
                });
            }

            $scope.refreshScore = function () {
                PropertyService.refreshScore($scope.property, $scope.getStackedGraph);
            };
       }
    ]);
 
'use strict';
angular.module('utilliApp')
    .controller('GroupStackedDashboardController',
    [
        '$scope', '$rootScope', '$http', '$window', '$filter', 'usSpinnerService', 'ModalServiceExt',
        'LeftMenuService', '$state', 'CommonHeaderService', 'DefaultPropertyService', 'UnitsService',
// ReSharper disable InconsistentNaming
        function($scope, $rootScope, $http, $window, $filter, usSpinnerService, ModalServiceExt,
            LeftMenuService, $state, CommonHeaderService, DefaultPropertyService, UnitsService) {
// ReSharper restore InconsistentNaming
            LeftMenuService.setCurrentTab('Dashboard');
            CommonHeaderService.setUpNotificationButton();
            $scope.units = UnitsService;

            DefaultPropertyService.getAggregation().then(function(aggregation) {
                    if (aggregation.Type === utilli.aggregationTypes.property) {
                        // https://stackoverflow.com/a/39461700/292787
                        $state.goMainLayout('PropertyStackedDashboard', null, { location: 'replace' });
                        return;
                    }

                    $scope.groupName = aggregation.Name;
                    $scope.delegatingUser = aggregation.DelegatingUser;
                    $scope.delegatingUserPhone = aggregation.DelegatingUserPhone;
                    $scope.delegatingUserEmail = aggregation.DelegatingUserEmail;
                    $scope.NumberOfProperties = aggregation.PropertiesCount;
                    $scope.currentPage = 0;
                    $scope.pageSize = 12;

                    function fillChartData(consumptionData, chartOptions) {
                        var i;
                        var coefficient = $scope.units.getCoefficient(consumptionData.Uom);

                        $scope.tableData = [];
                        $scope.disablePrev = consumptionData.TableData.length < $scope.pageSize;
                        $scope.disableNext = $scope.currentPage <= 0;
                        // shift because TableData.length can be bigger than pageSize.
                        // if it's bigger than we understand that one more page exists (Prev button should be enabled)
                        var shift = consumptionData.TableData.length < $scope.pageSize ? 0
                            : consumptionData.TableData.length - $scope.pageSize;
                        for (i = shift; i < consumptionData.TableData.length; i++) {
                            var item = consumptionData.TableData[i];
                            var clone = $.extend({}, item);

                            clone.Consumption = utilli.trimFloat2(clone.Consumption * coefficient);
                            clone.ConsumptionString = utilli.formatNumber(clone.Consumption);
                            clone.AvgConsumption = utilli.trimFloat2(clone.AvgConsumption * coefficient);
                            clone.AvgConsumptionString = utilli.formatNumber(clone.AvgConsumption);
                            clone.AmountString = utilli.formatCurrency(clone.Amount);

                            clone.Unit = $scope.units.selectedUnitsType.name;
                            clone.Date = new Date(clone.Year, clone.Month - 1, 1);
                            $scope.tableData.push(clone);
                        }

                        consumptionData.PropertyConsumptions.forEach(function (property) {
                            var seria = { name: property.PropertyAddress, data: [] };

                            for (i = shift; i < consumptionData.TableData.length; i++) {
                                var consumption = property.Consumptions[i];
                                var stringFixed = (consumption * coefficient).toFixed(2);
                                var convertedConsumption = parseFloat(stringFixed);
                                seria.data.push(convertedConsumption);
                            }
                            chartOptions.series.push(seria);
                        });

                        for (i = shift; i < consumptionData.TableData.length; i++) {
                            var date = consumptionData.Dates[i];
                            chartOptions.xAxis.categories.push(date.Year + '-' + date.Month);
                        }
                    }

                    var plotStackedChart = function (consumptionResponse) {

                        $scope.units.setSelectedUnitsIfEmpty(consumptionResponse.Data.Uom);

                        var chartOptions = {
                            chart: {
                                type: 'area'
                            },
                            exporting: {
                                enabled: false
                            },
                            title: {
                                text: ''
                            },
                            subtitle: {
                                text: ''
                            },
                            xAxis: {
                                categories: [],
                                tickmarkPlacement: 'on',
                                title: {
                                    enabled: false
                                },
                                labels: {
                                    rotation: -45
                                }
                            },
                            yAxis: {
                                title: {
                                    text: $scope._t('Consumption') + ' (' + $scope.units.selectedUnitsType.name + ')'
                                },
                                labels: {
                                    formatter: function() {
                                        return this.value;
                                    },
                                    rotation: -45
                                }
                            },
                            tooltip: {
                                split: true,
                                pointFormat: '<b>{point.y}</b>',
                                valueSuffix: ' ' + $scope.units.selectedUnitsType.name
                            },
                            plotOptions: {
                                area: {
                                    stacking: 'normal',
                                    lineColor: '#666666',
                                    lineWidth: 1,
                                    marker: {
                                        lineWidth: 1,
                                        lineColor: '#666666'
                                    }
                                }
                            },
                            series: [],
                            credits: {
                                enabled: false
                            }
                        };

                        fillChartData(consumptionResponse.Data, chartOptions);
                        // ReSharper disable once UndeclaredGlobalVariableUsing
                        Highcharts.chart('stackedGraphHere', chartOptions);
                    }

                    $scope.getStackedGraph = function() {
                        usSpinnerService.spin('spinner-1');
                        var groupId = utilli.getCurrentGroupId();
                        $http({
                            url: localStorage.getItem('ApiUrl') + 'api/Consumption/GetGroupConsumptionStacked/',
                            method: "GET",
                            params: {
                                groupId: groupId,
                                skip: $scope.currentPage * $scope.pageSize, // currentPage starts with 0
                                pageSize: $scope.pageSize + 1,
                                userName: $state.params.userId
                            }
                        }).success(function (consumptionResponse) {
                            usSpinnerService.stop('spinner-1');
                            utilli.handleAjaxResponse(consumptionResponse,
                                ModalServiceExt,
                                function () {
                                    plotStackedChart(consumptionResponse);
                                });
                        }).error(function () {
                            usSpinnerService.stop('spinner-1');
                            ModalServiceExt.showServerError();
                        });
                    };

                    $scope.previousPage = function() {
                        if (!$scope.disablePrev) {
                            $scope.currentPage++;
                            $scope.getStackedGraph();
                        }
                    };

                    $scope.nextPage = function() {
                        if (!$scope.disableNext) {
                            $scope.currentPage--;
                            $scope.getStackedGraph();
                        }
                    };

                    $scope.getStackedGraph();
                });

            $scope.backToBarGraph = function () {
                $state.goMainLayout("PropertyBarDashboard");
            };

            $scope.getExcelData = function () {
                var groupId = utilli.getCurrentGroupId();
                var apiUrl = localStorage.getItem('ApiUrl') + 'api/Consumption/GenerateGroupStackedExcel/';
                usSpinnerService.spin('spinner-1');
                $http({
                    url: apiUrl,
                    method: "GET",
                    params: { groupId: groupId, uom: $scope.units.selectedUnitsType.name, userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response == undefined || response.HasErrors == undefined) {
                        ModalServiceExt.showServerError();
                        return;
                    }
                    if (response.HasErrors) {
                        ModalServiceExt.showError(response.Errors[0]);
                    }
                    else {
                        var url = utilli.getFileUrlWithToken(response.Data);
                        utilli.downloadFile(url);
                    }
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showError(error.Message);
                });
            }

            $scope.getGreenButtonData = function () {
                var groupId = utilli.getCurrentGroupId();
                var apiUrl = localStorage.getItem('ApiUrl') + 'api/Consumption/GenerateGroupStackedGreenButton/';
                usSpinnerService.spin('spinner-1');
                $http({
                    url: apiUrl,
                    method: "GET",
                    params: { groupId: groupId, userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response == undefined || response.HasErrors == undefined) {
                        ModalServiceExt.showServerError();
                        return;
                    }
                    if (response.HasErrors) {
                        ModalServiceExt.showError(response.Errors[0]);
                    }
                    else {
                        var url = utilli.getFileUrlWithToken(response.Data);
                        utilli.downloadFile(url, "GreenButtonData.xml");
                    }
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showError(error.Message);
                });
            }
       }
    ]);
 
'use strict';

angular.module('utilliApp').controller('PropertyBarDashboardController',
    ['$scope', '$rootScope', '$http', '$window', '$filter', 'usSpinnerService', 'ModalServiceExt', 'LeftMenuService',
        '$state', 'CommonHeaderService', 'DefaultPropertyService', 'UnitsService', 'PropertyService', 'CommonDataService',
        // ReSharper disable InconsistentNaming
        function ($scope, $rootScope, $http, $window, $filter, usSpinnerService, ModalServiceExt, LeftMenuService,
            $state, CommonHeaderService, DefaultPropertyService, UnitsService, PropertyService, CommonDataService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming

            LeftMenuService.setCurrentTab('Dashboard');
            CommonHeaderService.setUpNotificationButton();
            $scope.formatNumber = utilli.formatNumber;
            $scope.units = UnitsService;
            $scope.maxMetersOnStackedDashboard = Config.maxMetersOnStackedDashboard;

            $scope.enableIndividualMeters = false;

            CommonDataService.getCommonData()
                .then(function (commonData) {
                    $scope.enableIndividualMeters = commonData.EnablePropertyManagersDashboardIndividualMeters || utilli.isAdmin;
                }
            );

            $scope.meters = [''];
            $scope.currentMeter = '';

            DefaultPropertyService.getAggregation($state.params.userId).then(function (aggregation) {
                if (aggregation.Type !== utilli.aggregationTypes.property) {
                    // https://stackoverflow.com/a/39461700/292787
                    $state.goMainLayout('GroupDashboard', null, { location: 'replace' });
                    return;
                }

                var getMeters = function () {
                    var propertyId = utilli.getCurrentPropertyId();
                    $http({
                        url: localStorage.getItem('ApiUrl') + 'api/Consumption/GetMeterNumbers/',
                        method: "GET",
                        params: {
                            propertyId: propertyId,
                            userName: $state.params.userId
                        }
                    }).success(function (consumptionResponse) {
                        utilli.handleAjaxResponse(consumptionResponse,
                            ModalServiceExt,
                            function () {
                                $scope.meters = _.map(consumptionResponse.Data, function (item) {
                                    return { id: item, value: item };
                                });
                                $scope.meters.unshift({ id: '', value: _t('All Meters') });
                            });
                    }).error(function () {
                        ModalServiceExt.showServerError();
                    });
                }

                getMeters();

                $scope.property = aggregation;
                PropertyService.loadProperty($scope.property, $scope.getBarGraph);

                $scope.previousPage = function () {
                    if (!$scope.disablePrev) {
                        $scope.currentPage++;
                        $scope.getBarGraph();
                    }
                };

                $scope.nextPage = function () {
                    if (!$scope.disableNext) {
                        $scope.currentPage--;
                        $scope.getBarGraph();
                    }
                };

                $scope.getBarGraph();
            });

            $scope.currentPage = 0;
            $scope.pageSize = 12;

            var consumptionReadingIndex = 0;
            //var amountIndex = 1;
            var averageTemperatureIndex = 1;
            var temperatureRangeIndex = 2;

            function fillChartData(consumptionData, chartOptions) {
                var i;
                $scope.units.setSelectedUnitsIfEmpty(consumptionData.Uom);
                var coefficient = $scope.units.getCoefficient(consumptionData.Uom);

                $scope.tableData = [];
                $scope.disablePrev = consumptionData.TableData.length <= $scope.pageSize;
                $scope.disableNext = $scope.currentPage <= 0;
                var shift = consumptionData.TableData.length < $scope.pageSize ? 0
                    : consumptionData.TableData.length - $scope.pageSize;
                for (i = shift; i < consumptionData.TableData.length; i++) {
                    var item = consumptionData.TableData[i];
                    var clone = $.extend({}, item);
                    clone.Consumption = utilli.trimFloat2(clone.Consumption * coefficient);
                    clone.ConsumptionString = utilli.formatNumber(clone.Consumption);
                    clone.AvgConsumption = utilli.trimFloat2(clone.AvgConsumption * coefficient);
                    clone.AvgConsumptionString = utilli.formatNumber(clone.AvgConsumption);
                    clone.AmountString = utilli.formatCurrency(clone.Amount);
                    clone.Unit = $scope.units.selectedUnitsType.name;
                    clone.Date = new Date(clone.Year, clone.Month - 1, 1);
                    $scope.tableData.push(clone);

                    var date = clone.Year + '-' + clone.Month;
                    chartOptions.series[consumptionReadingIndex].data.push({
                        name: date,
                        y: clone.Consumption,
                        label: clone.ConsumptionString,
                        // custom data
                        unit: $scope.units.selectedUnitsType.name
                    });

                    //chartOptions.series[amountIndex].data.push({
                    //    name: date,
                    //    y: clone.Amount,
                    //    label: clone.AmountString
                    //});

                    chartOptions.series[averageTemperatureIndex].data.push({
                        name: date,
                        y: clone.AvgTemperature,
                        low: clone.MonthMinTemperature,
                        high: clone.MonthMaxTemperature
                    });

                    chartOptions.series[temperatureRangeIndex].data.push({
                        name: date,
                        low: item.MonthMinTemperature,
                        high: item.MonthMaxTemperature
                    });

                }
            }

            var plotBarChart = function (consumptionResponse) {
                var series = [
                    {
                        name: 'Consumption',
                        data: [],
                        tooltip: {
                            pointFormat: '{point.label} {point.unit}',
                            headerFormat: ''
                        },
                        yAxis: 1
                    },
                    //{
                    //    type: 'spline',
                    //    name: 'Amount',
                    //    data: [],
                    //    tooltip: {
                    //        pointFormat: '{point.label}',
                    //        headerFormat: ''
                    //    }
                    //},
                    {
                        type: 'spline',
                        name: 'Average Temperature',
                        data: [],
                        tooltip: {
                            pointFormat: '{point.y}F (' + _t('Range') + ': {point.low}F-{point.high}F)',
                            headerFormat: ''
                        },
                        yAxis: 2
                    }, {
                        name: 'Temperature Range',
                        type: 'errorbar',
                        data: [],
                        enableMouseTracking: false,
                        yAxis: 2
                    }
                ];
                var chartOptions = {
                    chart: {
                        spacingTop: 40,
                        spacingBottom: 60,
                        type: 'column'
                    },
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
                        type: 'category', labels: { rotation: -45 }
                    },
                    yAxis: [{
                        labels: {
                            formatter: function () {
                                return utilli.formatNumber(this.value);
                            }
                        },
                        title: {
                            //text: _t('Amount ($)')
                            text: _t('')
                        },
                        min: 0
                    }, {
                        labels: {
                            formatter: function () {
                                return utilli.formatNumber(this.value);
                            }
                        },
                        title: {
                            text: _t('Consumption') + ' (' + $scope.units.selectedUnitsType.name + ')'
                        },
                        opposite: true
                    }, {
                        labels: {
                            format: ''
                        },
                        title: {
                            text: ''
                        },
                        min: 0,
                        visible: false
                    }],
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        y: 60,
                        floating: true,
                        // ReSharper disable UndeclaredGlobalVariableUsing
                        backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                        // ReSharper restore UndeclaredGlobalVariableUsing
                        borderColor: '#CCC',
                        borderWidth: 0,
                        shadow: false
                    },
                    tooltip: {
                        shared: false,
                        useHTML: true
                    },
                    plotOptions: {
                        series: {
                            cursor: $scope.currentMeter === '' ? 'pointer' : '',
                            point: {
                                events: {
                                    click: function () {
                                        if ($scope.enableIndividualMeters){
                                            $state.goMainLayout('PropertyDetailedDashboard',
                                                { selectedPeriodString: this.name });
                                        }
                                    }
                                }
                            }
                        }
                    },
                    series: series,
                    credits: {
                        enabled: false
                    }
                };

                fillChartData(consumptionResponse.Data, chartOptions);
                // ReSharper disable once UndeclaredGlobalVariableUsing
                Highcharts.chart('barGraphHere', chartOptions);
            }

            $scope.getBarGraph = function () {
                usSpinnerService.spin('spinner-1');
                var propertyId = utilli.getCurrentPropertyId();
                $http({
                    url: localStorage.getItem('ApiUrl') + 'api/Consumption/GetPropertyConsumptionBars/',
                    method: "GET",
                    params: {
                        propertyId: propertyId,
                        skip: $scope.currentPage * $scope.pageSize, // currentPage starts with 0
                        pageSize: $scope.pageSize + 1,
                        meterNumber: $scope.currentMeter,
                        userName: $state.params.userId
                    }
                }).success(function (consumptionResponse) {
                    usSpinnerService.stop('spinner-1');
                    utilli.handleAjaxResponse(consumptionResponse,
                        ModalServiceExt,
                        function () {
                            plotBarChart(consumptionResponse);
                        });
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            };

            $scope.backToStackedGraph = function () {
                $state.goMainLayout("PropertyStackedDashboard");
            };

            $scope.getExcelData = function () {
                var propertyId = utilli.getCurrentPropertyId();
                var apiUrl = localStorage.getItem('ApiUrl') + 'api/Consumption/GeneratePropertyBarExcel/';
                usSpinnerService.spin('spinner-1');
                $http({
                    url: apiUrl,
                    method: "GET",
                    params: {
                        propertyId: propertyId,
                        uom: $scope.units.selectedUnitsType.name,
                        meterNumber: $scope.currentMeter,
                        userName: $state.params.userId
                    }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response == undefined || response.HasErrors == undefined) {
                        ModalServiceExt.showServerError();
                        return;
                    }
                    if (response.HasErrors) {
                        ModalServiceExt.showError(response.Errors[0]);
                    }
                    else {
                        var url = utilli.getFileUrlWithToken(response.Data);
                        utilli.downloadFile(url);
                    }
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showError(error.Message);
                });
            }

            $scope.getGreenButtonData = function () {
                var propertyId = utilli.getCurrentPropertyId();
                var apiUrl = localStorage.getItem('ApiUrl') + 'api/Consumption/GeneratePropertyBarGreenButton/'
                    + '?propertyId=' + propertyId;
                usSpinnerService.spin('spinner-1');
                $http({
                    url: apiUrl,
                    method: "GET",
                    params: { userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response == undefined || response.HasErrors == undefined) {
                        ModalServiceExt.showServerError();
                        return;
                    }
                    if (response.HasErrors) {
                        ModalServiceExt.showError(response.Errors[0]);
                    }
                    else {
                        var url = utilli.getFileUrlWithToken(response.Data);
                        utilli.downloadFile(url, "GreenButtonData.xml");
                    }
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showError(error.Message);
                });
            }

            $scope.refreshScore = function () {
                PropertyService.refreshScore($scope.property, $scope.getBarGraph);
            };
        }
    ]);
 
'use strict';

angular.module('utilliApp')
    .controller('PropertyDetailedDashboardController',
    [
        '$scope', '$rootScope', '$http', '$window', '$filter', 'usSpinnerService', 'ModalServiceExt',
        'LeftMenuService', '$state', 'CommonHeaderService', 'DefaultPropertyService', 'UnitsService',
        'PropertyService',
        // ReSharper disable InconsistentNaming
        function($scope, $rootScope, $http, $window, $filter, usSpinnerService, ModalServiceExt, LeftMenuService,
            $state, CommonHeaderService, DefaultPropertyService, UnitsService, PropertyService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming

            LeftMenuService.setCurrentTab('Dashboard');
            CommonHeaderService.setUpNotificationButton();
            $scope.formatNumber = utilli.formatNumber;
            $scope.units = UnitsService;
            $scope.selectedPeriodString = $state.params.selectedPeriodString;

            DefaultPropertyService.getAggregation($state.params.userId).then(function (aggregation) {
                if (aggregation.Type !== utilli.aggregationTypes.property) {
                    // https://stackoverflow.com/a/39461700/292787
                    $state.goMainLayout('GroupDashboard', null, { location: 'replace' });
                    return;
                }

                $scope.property = aggregation;
                PropertyService.loadProperty($scope.property, $scope.getBarGraph);
                $scope.getBarGraph();
            });

            function fillChartData(consumptionData, chartOptions, treeMapChartOptions) {
                var i;
                $scope.units.setSelectedUnitsIfEmpty(consumptionData.Uom);
                var coefficient = $scope.units.getCoefficient(consumptionData.Uom);

                $scope.tableData = [];
                for (i = 0; i < consumptionData.MeterConsumptions.length; i++) {
                    var item = consumptionData.MeterConsumptions[i];
                    var clone = $.extend({}, item);
                    clone.Consumption = utilli.trimFloat2(clone.Consumption * coefficient);
                    clone.ConsumptionString = utilli.formatNumber(clone.Consumption);
                    clone.AvgConsumption = utilli.trimFloat2(clone.AvgConsumption * coefficient);
                    clone.AvgConsumptionString = utilli.formatNumber(clone.AvgConsumption);
                    clone.Unit = $scope.units.selectedUnitsType.name;
                    clone.MeterNumber = clone.MeterNumber;
                    $scope.tableData.push(clone);

                    chartOptions.series[0].data.push({
                        name: clone.MeterNumber,
                        y: clone.Consumption,
                        label: clone.ConsumptionString,
                        // custom data
                        unit: $scope.units.selectedUnitsType.name
                    });

                    treeMapChartOptions.series[0].data.push({
                        name: clone.MeterNumber,
                        value: clone.Consumption,
                        colorValue: clone.Consumption
                    });
                }
            }

            var plotBarChart = function (consumptionResponse) {
                var series = [
                    {
                        name: 'Consumption',
                        data: [],
                        tooltip: {
                            pointFormat: '{point.label} {point.unit}',
                            headerFormat: ''
                        }
                    }
                ];
                var chartOptions = {
                    chart: {
                        type: 'column'
                    },
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: _t('Consumption Bar Chart')
                    },
                    xAxis: {
                        type: 'category', labels: { rotation: -45 }
                    },
                    yAxis: [{
                        labels: {
                            formatter: function () {
                                return utilli.formatNumber(this.value);
                            }
                        },
                        title: {
                            text: _t('Consumption') + ' (' + $scope.units.selectedUnitsType.name + ')'
                        }
                    }],
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        y: 60,
                        floating: true,
                        // ReSharper disable UndeclaredGlobalVariableUsing
                        backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                        // ReSharper restore UndeclaredGlobalVariableUsing
                        borderColor: '#CCC',
                        borderWidth: 1,
                        shadow: false
                    },
                    tooltip: {
                        shared: false,
                        useHTML: true
                    },
                    series: series,
                    credits: {
                        enabled: false
                    }
                };

                var treeMapChartOptions = {
                    colorAxis: {
                        minColor: '#FFFFFF',
                        maxColor: Highcharts.getOptions().colors[0]
                    },
                    exporting: {
                        enabled: false
                    },
                    series: [{
                        type: 'treemap',
                        layoutAlgorithm: 'squarified',
                        data: []
                    }],
                    title: {
                        text: _t('Consumption Treemap Chart')
                    },
                    tooltip: {
                        formatter: function () {
                            return '<b> ' + _t('Meter') + ': ' + this.point.name + '</b><br/>' +
                                '<b>' + _t('Consumption') + ': ' + this.point.value + ' ' + $scope.units.selectedUnitsType.name + '</b><br/>'
                        }
                    }
                };

                fillChartData(consumptionResponse.Data, chartOptions, treeMapChartOptions);
                // ReSharper disable UndeclaredGlobalVariableUsing
                Highcharts.chart('barGraphHere', chartOptions);
                Highcharts.chart('treeGraphHere', treeMapChartOptions);
                // ReSharper restore UndeclaredGlobalVariableUsing
            }

            $scope.getBarGraph = function () {
                usSpinnerService.spin('spinner-1');
                var propertyId = utilli.getCurrentPropertyId();
                $http({
                    url: localStorage.getItem('ApiUrl') + 'api/Consumption/GetPropertyDetailedConsupmtion/',
                    method: "GET",
                    params: {
                        propertyId: propertyId,
                        period: $state.params.selectedPeriodString,
                        userName: $state.params.userId
                    }
                }).success(function (consumptionResponse) {
                    usSpinnerService.stop('spinner-1');
                    utilli.handleAjaxResponse(consumptionResponse,
                        ModalServiceExt,
                        function () {
                            plotBarChart(consumptionResponse);
                        });
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            };

            $scope.back = function () {
                $state.goMainLayout("PropertyBarDashboard");
            };

            $scope.refreshScore = function () {
                PropertyService.refreshScore($scope.property, $scope.getBarGraph);
            };
       }
    ]);
 
'use strict';
// ReSharper disable once UndeclaredGlobalVariableUsing
angular.module('utilliApp')
    .controller('PropertyListController', ['$scope', '$rootScope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', 'GetAccountsService', '$stateParams',
        'CommonHeaderService', 'DueReminderService', 'ModalServiceExt', 'PropertyListService', 'PropertyService',
        'propertyManagerTourService',
    // ReSharper disable InconsistentNaming
    function ($scope, $rootScope, $http, $timeout, $window, usSpinnerService, LeftMenuService, $state,
        GetAccountsService, $stateParams, CommonHeaderService, DueReminderService, ModalServiceExt,
        PropertyListService, PropertyService, propertyManagerTourService) {
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming
        LeftMenuService.setCurrentTab('MyProperties');

        if (localStorage.getItem('showEsScoreInfoPopup') == 'true') {
            localStorage.setItem('showEsScoreInfoPopup', 'false');
            ModalServiceExt.showOkMessage($scope._t('Energy Star Score Information'), $scope._t('Please ensure that all gas meters at each property are registered with the Washington Gas Property Manager application for accurate submission to Energy Star Portfolio Manager.<br/>Your Energy Star score:<br/>Includes calculations for all gas, electric and water consumption being reported to the Energy Star Portfolio Manager by property.<br/>Is calculated by Energy Star Portfolio Manager based on the meters submitted for each property.'));
        }

        var addProperty = function () {
            usSpinnerService.spin('spinner-1');

            $http({
                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetEnergyStarInfo/',
                method: "GET",
                params: { userName: $state.params.userId }
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
               
                if (response.Data != null) {
                    $state.goMainLayout("AddProperty.PropertyOverview", { stepsCount: 5, step: 0 });
                } else {
                    $state.goMainLayout("AddProperty.LinkEnergyStarAccount", { stepsCount: 6, step: 0 });
                }
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });

        };
        CommonHeaderService.setUpNotificationButton(_t('My Properties'));

        $scope.addProperty = addProperty;

        $scope.importProperty = function () {
            usSpinnerService.spin('spinner-1');

            $http({
                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetEnergyStarInfo/',
                method: "GET",
                params: { userName: $state.params.userId }
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');

                if (response.Data != null) {
                    $state.goMainLayout("AddProperty.ShareExistingEnergyStarPropertyInstructions", { stepsCount: 2 });
                } else {
                    //$state.goMainLayout("AddProperty.LinkEnergyStarAccountForPropertyImport", { stepsCount: 3 });
                    $state.goMainLayout("AddProperty.LinkEnergyStarAccountForPropertyImportInstructions", { stepsCount: 3 });
                }
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        };

        $scope.errors = [];

        $scope.refreshScore = function (property) {
            PropertyListService.refreshScore($scope, property);
        };

        $scope.why = function (property) {
            $state.goMainLayout('ReasonsForNoScore', { propertyId: property.Id });
        }

        $scope.goToAuth = function (property) {
            $state.goMainLayout('Authorizations');
        }

        $scope.deleteProperty = function (property) {
            ModalServiceExt.showYesNoMessage(
                _t('Delete Property'),
                _t('Please be advised that all historical aggregated consumption for meters being reported so far, will be moved from this account and with Energy Star Portfolio Manager. Are you sure you want to delete this property?'),
                function () {
                    usSpinnerService.spin('spinner-1');
                    $http({
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/DeleteProperty/',
                        method: "POST",
                        params: { propertyId: property.Id, userName: $state.params.userId }
                    }).success(function (response) {
                        usSpinnerService.stop('spinner-1');
                        utilli.handleAjaxResponse(response, ModalServiceExt,
                            function () {
                                // if we delete the currently selected property then select another property as current
                                var currentAggregation = utilli.getCurrentAggregation();
                                if (currentAggregation && currentAggregation.Type === utilli.aggregationTypes.property && property.Id === currentAggregation.Id) {
                                    if ($scope.propertyList && $scope.propertyList.length > 1) {
                                        var newCurrentProperty = $scope.propertyList.find(function (item) {
                                            return item.Id !== property.Id;
                                        });
                                        newCurrentProperty.Type = utilli.aggregationTypes.property;
                                        localStorage.setItem('currentAggregation', JSON.stringify(newCurrentProperty));
                                    } else {
                                        localStorage.removeItem('currentAggregation');
                                    }
                                }
                                $state.goMainLayout('PropertyList', null, { reload: true });
                            });
                    }).error(function () {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                    });
                });
        }

        $scope.viewProperty = function (property) {
            property.Type = utilli.aggregationTypes.property;
            localStorage.setItem('currentAggregation', JSON.stringify(property));
            PropertyService.goToDashboard(property, $state);
        }

        $scope.editProperty = function (property) {
            //$state.goMainLayout('AddProperty.PropertyOverview', { id: property.Id, mode: 'edit', stepsCount: 5, step: 0 });
            //$state.goMainLayout('Property', { propertyId: property.Id });

            $state.goMainLayout('EditProperty', { id: property.Id });
        }

        usSpinnerService.spin('spinner-1');

        // first time load with error handlers. on the next subsequent reloads don't show error messages
        // to avoid creation of too many identical error messages
        PropertyListService.getPropertyList().success(function (response) {
            utilli.handleAjaxResponse(response, ModalServiceExt,
                function () {
                    PropertyListService.loadPropertyList($scope, response);

                    if (propertyManagerTourService.isTourActive()) {
                        usSpinnerService.stop('spinner-1');
                        propertyManagerTourService.resumeTour('Dashboard');
                    }
                    else
                        propertyManagerTourService.startTour(function () { usSpinnerService.stop('spinner-1'); });
                });
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }])
;
'use strict';
angular.module('utilliApp')
    .controller('ReasonsForNoScoreController', ['$scope', '$http', 
        'usSpinnerService', 'LeftMenuService', '$state', '$stateParams', 'CommonHeaderService',
        'ModalServiceExt',
    // ReSharper disable InconsistentNaming
    function ($scope, $http, usSpinnerService, LeftMenuService, $state,
        $stateParams, CommonHeaderService, ModalServiceExt) {
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming
        LeftMenuService.setCurrentTab('MyProperties');
        CommonHeaderService.setUpBackButton(_t('Score Reason'));

        usSpinnerService.spin('spinner-1');
        $http({
            url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/WhyEmptyScore/',
            method: "GET",
            params: { propertyId: $stateParams.propertyId, userName: $state.params.userId }
        }).success(function (response) {
            usSpinnerService.stop('spinner-1');
            utilli.handleAjaxResponse(response, ModalServiceExt,
                function () {
                    if (response.Data) {
                        $scope.reaons = response.Data;
                    }
                    else {
                        $scope.reaons = _t("Reason is not determined.");
                    }
                });
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });

    }]);
'use strict';
angular.module('utilliApp')
    .controller('PropertyGroupListController', ['$scope', '$rootScope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', '$stateParams', 'CommonHeaderService',
        'DueReminderService', 'ModalServiceExt', 'PropertyListService',
    // ReSharper disable InconsistentNaming
    function ($scope, $rootScope, $http, $timeout, $window, usSpinnerService, LeftMenuService, $state,
        $stateParams, CommonHeaderService, DueReminderService, ModalServiceExt, PropertyListService) {
            var _t = $scope._t;
        // ReSharper restore InconsistentNaming
            LeftMenuService.setCurrentTab('MyPropertyGroups');
            CommonHeaderService.setUpNotificationButton(_t('My Property Groups'));

        $scope.addGroup = function () {
            if ($scope.noProperties) {
                $state.goMainLayout("Property");
            } else {
                $state.goMainLayout("AddPropertyGroup");
            }
        };

        $scope.errors = [];

        $scope.createProperty = function() {
            $state.goMainLayout("PropertyList");
        }

        $scope.deleteGroup = function (group) {
            ModalServiceExt.showYesNoMessage(_t('Delete Group'), _t('Are you sure that you want to delete the group?'),
                function () {
                    usSpinnerService.spin('spinner-1');
                    $http({
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/DeletePropertyGroup/',
                        method: "POST",
                        params: { propertyGroupId: group.Id, userName: $state.params.userId }
                    }).success(function (response) {
                        utilli.handleAjaxResponse(response, ModalServiceExt,
                            function () {
                                // if we delete the currently selected group then select another group as current
                                var currentAggregation = utilli.getCurrentAggregation();
                                if (currentAggregation && currentAggregation.Type === utilli.aggregationTypes.group && group.Id === currentAggregation.Id) {
                                    if ($scope.groupList && $scope.groupList.length > 1) {
                                        var newCurrentGroup = $scope.groupList.find(function(item) {
                                            return item.Id !== group.Id;
                                        });
                                        newCurrentGroup.Type = utilli.aggregationTypes.group;
                                        localStorage.setItem('currentAggregation', JSON.stringify(newCurrentGroup));
                                    } else {
                                        localStorage.removeItem('currentAggregation');
                                    }
                                }

                                $state.goMainLayout('PropertyGroupList', null, { reload: true });
                            });
                        usSpinnerService.stop('spinner-1');
                    }).error(function () {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                    });
                });
        }

        $scope.viewGroup = function (group) {
            group.Type = utilli.aggregationTypes.group;
            localStorage.setItem('currentAggregation', JSON.stringify(group));
            $state.goMainLayout('GroupStackedDashboard');
        }

        $scope.editGroup = function (group) {
            $state.goMainLayout('EditPropertyGroup', { propertyGroupId: group.Id });
        }

        usSpinnerService.spin('spinner-1');
        $http({
            url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetPropertyGroupList/',
            method: "GET",
            params: { userName: $state.params.userId }
        }).success(function (response) {
            usSpinnerService.stop('spinner-1');
            utilli.handleAjaxResponse(response, ModalServiceExt,
                function () {
                    if (!response.Data || response.Data.length === 0) {
                        $scope.groupList = [];

                        usSpinnerService.spin('spinner-1');
                        PropertyListService.getPropertyList().success(function (response) {
                            utilli.handleAjaxResponse(response, ModalServiceExt,
                                function () {
                                    if (!response.Data || response.Data.length === 0) {
                                        $scope.noProperties = true;
                                    }
                                });
                            usSpinnerService.stop('spinner-1');
                        }).error(function () {
                            usSpinnerService.stop('spinner-1');
                            ModalServiceExt.showServerError();
                        });
                    }
                    else {
                        usSpinnerService.stop('spinner-1');
                        $scope.groupList = response.Data;
                    }
                });
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }])
;
'use strict';
angular.module('utilliApp')
    .controller('AddPropertyController', ['$scope', 'LeftMenuService', '$state', '$stateParams', 'CommonHeaderService',
// ReSharper disable InconsistentNaming
        function ($scope, LeftMenuService, $state, $stateParams, CommonHeaderService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Add Properties'));

            if ($state.params)
                $scope.mode = $state.params.mode;

            $scope.step = 0;

            $scope.cancel = function () {
                if ($scope.mode !== 'edit') {
                $state.goMainLayout('PropertyList');
            }
                else if ($scope.mode === 'edit') {
                    $state.goMainLayout('EditProperty', { id: $state.params.id });
                }
            }
        }])
    .controller('PropertyOverviewController', ['$scope', '$http', 'usSpinnerService', 'LeftMenuService', '$state', '$stateParams', 'CommonHeaderService',
        'ModalServiceExt', 'PropertyDataService', 'propertyManagerTourService',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, LeftMenuService, $state, $stateParams, CommonHeaderService,
            ModalServiceExt, PropertyDataService, propertyManagerTourService) {
            var _t = $scope._t;
            
            $scope.isIosMobile = isMobileOrRipple() && iOS();
            
            // ReSharper restore InconsistentNaming
            if ($stateParams.mode === 'edit') {
                $scope.headerText = _t('Edit Property - Property Overview');
                $scope.mode = 'edit';
            } else {
                $scope.headerText = _t('Add Property - Property Overview');
                $scope.mode = 'add';
            }

            $scope.currentYear = new Date().getFullYear();

            $scope.deactivateOldMeters = true;

            if ($state.params) {
                $scope.$parent.overallStepsCount = $state.params.stepsCount;
                $scope.$parent.step = $state.params.step;
            }

            if ($stateParams.id) {
                PropertyDataService.getProperty($stateParams.id, function (property) {
                    $scope.propertyName = property.PropertyName;
                    $scope.propertyPrimaryFunction = property.PrimaryPropertyFunction;
                    $scope.address1 = property.Address1;
                    $scope.address2 = property.Address2;
                    $scope.city = property.City;
                    $scope.state = property.State;
                    $scope.postalCode = property.Zip;
                    $scope.grossFloorArea = property.GrossFloorArea;
                    $scope.grossFloorAreaUnits = property.GrossFloorAreaUnits.toString();
                    $scope.yearBuilt = property.YearBuilt;
                    $scope.irrigatedArea = property.IrrigatedArea;
                    $scope.irrigatedAreaUnits = property.IrrigatedAreaUnits.toString();
                    $scope.occupancy = property.Occupancy.toString();
                    $scope.numberOfBuildings = property.NumberOfUnits;
                    //$scope.virtualMeters = property.VirtualMeters;
                    //$scope.currentVirtualMeter = _.find(
                    //    property.VirtualMeters,
                    //    function (virtualMeter) { return virtualMeter.MeterId === property.EnergyStarMeterId; });
                });
            }

            if (propertyManagerTourService.isTourActive()) {
                propertyManagerTourService.resumeTour('PropertyOverview');
            }

            $scope.next = function () {
                $scope.form.$submitted = true;
                if (!$scope.form.$valid)
                    return;

                usSpinnerService.spin('spinner-1');
                var url = localStorage.getItem('ApiUrl') + 'api/PropertyManagers/SavePropertyOverview/';
                $http({
                    method: 'POST',
                    url: url,
                    data: {
                        Id: $stateParams.id,
                        PropertyName: $scope.propertyName,
                        PrimaryPropertyFunction: $scope.propertyPrimaryFunction,
                        Address1: $scope.address1,
                        Address2: $scope.address2,
                        City: $scope.city,
                        State: $scope.state,
                        Zip: $scope.postalCode,
                        GrossFloorArea: {
                            Area: $scope.grossFloorArea,
                            Units: $scope.grossFloorAreaUnits
                        },
                        YearBuilt: $scope.yearBuilt,
                        IrrigatedArea: {
                            Area: $scope.irrigatedArea,
                            Units: $scope.irrigatedAreaUnits
                        },
                        Occupancy: $scope.occupancy,
                        NumberOfBuildings: $scope.numberOfBuildings,
                        DeactivateOldMeters: $scope.deactivateOldMeters
                    },
                    params: { userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    utilli.handleAjaxResponse(response, ModalServiceExt, function () {
                        if ($scope.mode !== 'edit') {
                            $state.goMainLayout("AddProperty.PropertyType",
                                {
                                    id: response.Data.PropertyId,
                                    mode: $stateParams.mode,
                                    stepsCount: $scope.$parent.overallStepsCount,
                                    step: 1 + $scope.$parent.step * 1
                                });
                        }
                        else if ($scope.mode === 'edit') {
                            $state.goMainLayout('EditProperty', { id: response.Data.PropertyId });
                        }
                    });
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }
        }])
    .controller('PropertyTypeController', ['$scope', '$http', 'usSpinnerService', 'LeftMenuService', '$state', '$stateParams',
        'CommonHeaderService', 'ModalServiceExt', 'PropertyDataService', 'PropertySettingsService', 'propertyManagerTourService',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, LeftMenuService, $state, $stateParams,
            CommonHeaderService, ModalServiceExt, PropertyDataService, PropertySettingsService, propertyManagerTourService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            if ($stateParams.mode === 'edit')
                $scope.headerText = _t('Edit Property - Property Types');
            else
                $scope.headerText = _t('Add Property - Property Types');

            if ($state.params) {
                $scope.$parent.overallStepsCount = $state.params.stepsCount;
                $scope.$parent.step = $state.params.step;
            }

            if (propertyManagerTourService.isTourActive()) {
                propertyManagerTourService.resumeTour('PropertyTypes');
            }

            $scope.propertyTypes = [];
            PropertySettingsService.getPropertyTypeNames()
                .forEach(function (type, index) {
                    $scope.propertyTypes.push({ typeId: index + 1, caption: type });
                });

            $scope.chosenPropertyTypes = [];
            PropertyDataService.getProperty($stateParams.id, function (property) {
                property.PropertyTypes.forEach(function (type) {
                    var propType = { id: type.Id, name: type.Name, typeId: type.TypeId, caption: $scope.propertyTypes[type.TypeId - 1] };
                    if (propType.name == '' || propType.name == null)
                    {
                        propType.name = 'not specified yet';
                    }
                    $scope.chosenPropertyTypes.push(propType);
                });

                if ($scope.chosenPropertyTypes.length === 0)
                    $scope.chosenPropertyTypes.push({ typeId: -1, caption: '', name: 'not specified yet' });
            });

            $scope.addPropertyType = function () {
                $scope.chosenPropertyTypes.push({ typeId: -1, caption: '', name: 'not specified yet' });
            }

            $scope.deletePropertyType = function ($index) {
                $scope.chosenPropertyTypes.splice($index, 1);
            }

            $scope.back = function () {
                $state.goMainLayout('AddProperty.PropertyOverview', { id: $stateParams.id, mode: $stateParams.mode, stepsCount: $scope.$parent.overallStepsCount, step: $scope.$parent.step - 1 });
            }

            var validate = function () {
                $scope.chosenPropertyTypes.forEach(function (item, index) {
                    var empty = !item || item.typeId < 0;
                    $scope.form['propertyType' + index].$setValidity('required', !empty);
                });
            }

            $scope.next = function () {
                $scope.form.$submitted = true;
                validate();
                if (!$scope.form.$valid)
                    return;

                usSpinnerService.spin('spinner-1');
                var url = localStorage.getItem('ApiUrl') + 'api/PropertyManagers/SavePropertyTypes/';
                $http({
                    method: 'POST',
                    url: url,
                    data: {
                        PropertyId: $stateParams.id,
                        PropertyTypes: _.map($scope.chosenPropertyTypes, function (type) {
                            return {Id: type.id, Name: type.name, TypeId: type.typeId };
                        })
                    }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showServerError();
                        return;
                    }

                    // This is removed to fix UCXPM-67
                    // Not clear why we are changing collection  $scope.chosenPropertyTypes. We will go away from this controller anyway
                    //PropertyDataService.getProperty($stateParams.id, function (property) {
                    //    property.PropertyTypes.forEach(function (type) {
                    //        $scope.chosenPropertyTypes.push({ id: type.Id, name: type.Name, typeId: type.TypeId, caption: PropertySettingsService.propertyTypeNames[type.TypeId - 1] });
                    //    });
                    //});

                    $state.goMainLayout("AddProperty.PropertyDetails", { id: $stateParams.id, type: 0, mode: $stateParams.mode, stepsCount: $scope.$parent.overallStepsCount, step: 1 + $scope.$parent.step*1 });
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }
        }])
    .controller('PropertyDetailsController', ['$scope', '$http',
        'usSpinnerService', 'LeftMenuService', '$state', '$stateParams', 'CommonHeaderService', 'ModalServiceExt',
        'PropertyDataService', 'PropertySettingsService', 'propertyManagerTourService',
        // ReSharper disable InconsistentNaming
        function ($scope, $http,
            usSpinnerService, LeftMenuService, $state, $stateParams, CommonHeaderService, ModalServiceExt,
            PropertyDataService, PropertySettingsService, propertyManagerTourService) {
           // $scope.isNumber = angular.isNumber;
            $scope.isNumber = function (n) {
                return !isNaN(parseFloat(n)) && isFinite(n);
            }
            $scope.propertyDetailsName = '';
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            if ($stateParams.mode === 'edit')
                $scope.headerText = _t('Edit Property - Property Details');
            else
                $scope.headerText = _t('Add Property - Property Details');

            if ($state.params) {
                $scope.$parent.overallStepsCount = $state.params.stepsCount;
                $scope.$parent.step = $state.params.step;
            }

            var handledPropertyTypesCount = $stateParams.type;
            if (handledPropertyTypesCount == 0 && propertyManagerTourService.isTourActive()) {
                propertyManagerTourService.resumeTour('PropertyDetails');
            }

            function setPropertyType() {
                $scope.currentPropertyType = $scope.propertyTypes[handledPropertyTypesCount];
                $scope.propertyDetailsName = $scope.currentPropertyType.Name;
                var propTymeNames = PropertySettingsService.getPropertyTypeNames();
                $scope.currentPropertyTypeGoodName = propTymeNames[$scope.currentPropertyType.TypeId - 1];
                if ($scope.currentPropertyType.FieldsJson) {
                    var fields = angular.fromJson($scope.currentPropertyType.FieldsJson);
                    // Need to sort to gaurantee that order of controls after deserialization from json is still desirable 
                    $scope.currentPropertyFieldSettings.fieldsList = _.sortBy(fieldsObjectToArray(fields), function (itm) { return itm.num; }); 
                } else {
                    $scope.currentPropertyFieldSettings = PropertySettingsService.getPropertyFieldsSettings()[$scope.currentPropertyType.TypeId];
                   $scope.currentPropertyFieldSettings.fieldsList.forEach(
                        function (control) {
                            if (control.units != null && control.units != '') {
                                control.units = '';
                            }
                            control.value = '';
                        });
                }
            }

            $scope.currentPropertyFieldSettings = { fieldsList: [] };
            var yearBuilt;
            PropertyDataService.getProperty($stateParams.id, function (property) {
                $scope.propertyTypes = property.PropertyTypes;
                yearBuilt = property.YearBuilt;
                setPropertyType();
            });

            $scope.fieldCaptionByFieldName = PropertySettingsService.getFieldCaptionByFieldName();
            $scope.fieldDescriptionByFieldName = PropertySettingsService.getFieldDescriptionByFieldName();

            function fieldsObjectToArray(fieldsObject) {
                var array = [];
                for (var field in fieldsObject) {
                    if (fieldsObject.hasOwnProperty(field)) {
                        fieldsObject[field].controlType = PropertySettingsService.controlTypeByFieldName[field];//"grossFloorAreaType";
                            fieldsObject[field].name = field;
                            array.push(fieldsObject[field]);
                    }
                }
                return array;
            }

            var getPropertyUsage = function (propertyFieldSettings) {
                var result = {};
                var dateString = 'January 1, ' + yearBuilt + ' 23:15:30';
                var itemNum = 0;
                propertyFieldSettings.fieldsList.forEach(function (setting) {
                    result[setting.name] = {
                        'value': setting.value,
                        'units': setting.units,
                        'currentAsOf': new Date(dateString),
                        'valueSpecified': true,
                        'currentAsOfSpecified': true,
                        'temporary': false,
                        'temporarySpecified': true,
                        'controlType': setting.controlType,
                        'name': setting.name,
                        'num': itemNum // for sorting after recreation list of controls from json stored in db. will sort by this field
                    }
                    itemNum++
                });
                
                return result;
            }
            
            $scope.back = function () {
                if (handledPropertyTypesCount <= 0) {
                    $state.goMainLayout('AddProperty.PropertyType', { id: $stateParams.id, mode: $stateParams.mode, stepsCount: $scope.$parent.overallStepsCount, step: $scope.$parent.step - 1 });
                    return;
                }
                handledPropertyTypesCount--;
                $state.goMainLayout(
                    'AddProperty.PropertyDetails',
                    { id: $stateParams.id, type: handledPropertyTypesCount, mode: $stateParams.mode, stepsCount: $scope.$parent.overallStepsCount, step: $scope.$parent.step });
            }

            function validateUsageDetails () {
                var result = true;
                if ($scope.propertyDetailsName === '')
                    result = false;
                $scope.currentPropertyFieldSettings.fieldsList.forEach(function (inputField) {
                    if (inputField.value === '' || inputField.units === '')
                        result = false;
                    if (inputField.controlType == 'grossFloorAreaType' && !$scope.isNumber(inputField.value))
                        result = false;
                    if (inputField.controlType == 'lengthType' && !$scope.isNumber(inputField.value))
                        result = false;
                    if (inputField.controlType == 'useDecimalType' && !$scope.isNumber(inputField.value))
                        result = false;
                    if (inputField.controlType == 'weeklyOperatingHoursType' && !$scope.isNumber(inputField.value))
                        result = false;
                    if (inputField.controlType == 'intNumberType' && !$scope.isNumber(inputField.value))
                        result = false;
                });
                return result;
            }

            $scope.next = function () {
                $scope.form.$submitted = true;
                if (!$scope.form.$valid || !validateUsageDetails())
                    return;

                $scope.form.$submitted = false;

                usSpinnerService.spin('spinner-1');

                var currentType = $.extend({}, $scope.currentPropertyType);
                currentType.Name = $scope.propertyDetailsName;
                currentType.FieldsJson = angular.toJson(getPropertyUsage($scope.currentPropertyFieldSettings));

                var url = localStorage.getItem('ApiUrl') + 'api/PropertyManagers/SavePropertyTypeDetails/';
                $http({
                    method: 'POST',
                    url: url,
                    data: {
                        PropertyId: $stateParams.id,
                        PropertyType: currentType
                    },
                    params: { userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');

                    utilli.handleAjaxResponse(response, ModalServiceExt, function () {
                        handledPropertyTypesCount++;
                        if ($scope.propertyTypes.length <= handledPropertyTypesCount) {
    
                            if ($scope.mode != 'edit') {
                                $state.goMainLayout("AddProperty.AddMeters",
                                    {
                                        id: $stateParams.id,
                                        mode: $stateParams.mode,
                                        stepsCount: $scope.$parent.overallStepsCount,
                                        step: 1 + $scope.$parent.step * 1
                                    });
                            }
                            else if ($scope.mode == 'edit') {
                                $state.goMainLayout("EditProperty",
                                    {
                                        id: $stateParams.id,
                                    });
                            }
                        } else {
                            $state.goMainLayout(
                                'AddProperty.PropertyDetails',
                                {
                                    id: $stateParams.id,
                                    type: handledPropertyTypesCount,
                                    mode: $stateParams.mode,
                                    stepsCount: $scope.$parent.overallStepsCount,
                                    step: $scope.$parent.step
                                });
                        }
                    });
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }
        }])
    .controller('AddMetersController', ['$scope', '$http', 'usSpinnerService', 'LeftMenuService',
        '$state', '$stateParams', 'CommonHeaderService', 'ModalServiceExt', 'PropertyDataService', 'BulkMetersService',
        'PropertyService', 'propertyManagerTourService',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, LeftMenuService, $state, $stateParams, CommonHeaderService,
            ModalServiceExt, PropertyDataService, BulkMetersService, PropertyService, propertyManagerTourService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            if ($stateParams.mode === 'edit')
                $scope.headerText = _t('Edit Property - Edit Meters');
            else
                $scope.headerText = _t('Add Property - Add Meters');
            if ($state.params) {
                $scope.$parent.overallStepsCount = $state.params.stepsCount;
                $scope.$parent.step = $state.params.step;
            }
            $scope.serviceAddressMismatchErrorCode = utilli.pm.meterErrorCodes.serviceAddressMismatch;
            $scope.mode = $stateParams.mode;
            $scope.getErrorInfo = PropertyDataService.getErrorInfo;

            if (propertyManagerTourService.isTourActive()) {
                propertyManagerTourService.resumeTour('AddMeters');
            }

            $scope.setCurrentMeterVisible = function () {
                setTimeout(function () {
                    $('#meter' + $scope.topMeterId)[0].scrollIntoView();
                }, 500);
            }

            function loadMeters() {
                usSpinnerService.spin('spinner-1');
                $http({
                    method: 'GET',
                    url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetPropertyMeters/',
                    params: { propertyId: $stateParams.id, userName: $state.params.userId }
                }).success(function(response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showServerError();
                        return;
                    }
                    $scope.meters = response.Data.Meters;
                    $scope.meters.forEach(function(m) {
                        m.checked = !m.HasMultipleAddresses
                            && m.ErrorCode === utilli.pm.meterErrorCodes.serviceAddressMismatch;
                    });
                    var bulkMeters = BulkMetersService.getMeters();
                    if (bulkMeters && bulkMeters.length > 0) {
                        bulkMeters.forEach(function(meter) {
                            $scope.meters.push({ Id: 0, MeterNumber: meter });
                        });
                        BulkMetersService.clear();
                    }

                    if ($scope.meters.length === 0)
                        $scope.meters.push({ Id: 0, MeterNumber: '' })
                    else if ($stateParams.topMeter)
                        $scope.topMeterId = $stateParams.topMeter;
                    else if ($scope.canMassVerifyServiceAddress($scope.failedMeters))
                        utilli.scrollBottom();

                    // We need our own client unique meter Id to delete/update meters since filter will broke angular index:
                    var clientUtilliIdCounter = 0;
                    $scope.meters.forEach(function(meter) {
                        meter.clientUtilliId = clientUtilliIdCounter;
                        meter.numberForSearch =
                            meter
                            .MeterNumber; // it is for search because if search by MeterNumber than meter will dissapear during edit and this suxx
                        clientUtilliIdCounter++;
                    });
                }).error(function() {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            loadMeters();

            $scope.getMetersCount = function () {
                var filteredMeters = _.filter($scope.meters, function (mtr) { return mtr.numberForSearch !== undefined && mtr.numberForSearch !== ''; });
                return filteredMeters.length;
            }

            $scope.isDeleteAllAvailable = function () {
                //var filteredMeters = _.filter($scope.meters, function (mtr) { return mtr.numberForSearch !== '' || mtr.MeterNumber !== ''; });
                //return filteredMeters.length > 0;
                return $scope.meters != undefined && $scope.meters != null && $scope.getMetersCount() > 0;
            }

            $scope.bulkInput = function () {
                // push currently added but not yet submitted meters
                var addedMeters = _.filter($scope.meters, function (m) { return m.Id === 0 && m.MeterNumber !==''; });
                var addedMeterNumbers = _.map(addedMeters, function(m) { return m.MeterNumber; });
                BulkMetersService.addMeters(addedMeterNumbers);
                $state.goMainLayout('AddProperty.BulkMetersInput', { id: $stateParams.id, mode: $stateParams.mode, stepsCount: $stateParams.stepsCount, step: $stateParams.step});
            }

            $scope.canMassVerifyServiceAddress = function() {
                return PropertyService.canMassVerifyServiceAddress($scope.meters);
            }

            $scope.verifyAllAddresses = function() {
                PropertyService.verifyAllAddresses($stateParams.id, $scope.meters, loadMeters);
            }

            $scope.deleteAllMeters = function () {
                ModalServiceExt.showYesNoMessage(
                    _t('Delete all meters'),
                    _t('Are you sure you want to delete all meters?'),
                    function () {
                        $scope.meters.slice().forEach(function (meter) {
                            PropertyService.deleteMeterWithoutConfirmation($scope.meters, meter.clientUtilliId);
                        });
                            usSpinnerService.stop('spinner-1');
                    });
            }

            $scope.copyMeters = function () {
                var $temp = $("<input>");
                $("body").append($temp);

                var copiedMeters = '';
                if ($scope.meters && $scope.meters.length > 0) {
                    copiedMeters = _.pluck($scope.meters, 'MeterNumber').join();
                }

                $temp.val(copiedMeters).select();
                document.execCommand("copy");
                $temp.remove();

                ModalServiceExt.showInfo('Meter numbers were copied to clipboard.');
            }

            $scope.addMeter = function () {
                var maxId = 0;
                $scope.meters.forEach(function (meter) {
                    if (meter.clientUtilliId >= maxId)
                    {
                        maxId = meter.clientUtilliId + 1;
                    }
                });

                $scope.meters.push({ Id: 0, MeterNumber: '', clientUtilliId: maxId, numberForSearch: '' });
            }

            $scope.deleteMeter = function (clientUtilliId) {
                usSpinnerService.spin('spinner-1');
                PropertyService.deleteMeter($scope.meters, clientUtilliId);
                usSpinnerService.stop('spinner-1');
            }

            $scope.back = function () {
                PropertyDataService.getProperty($stateParams.id,
                    function(property) {
                        var typeIndex = property.PropertyTypes.length - 1;
                        $state.goMainLayout(
                            'AddProperty.PropertyDetails',
                            {
                                id: $stateParams.id,
                                type: typeIndex,
                                mode: $stateParams.mode,
                                stepsCount: $scope.$parent.overallStepsCount,
                                step: $scope.$parent.step - 1
                            });
                    });
            }

            $scope.next = function () {
                $scope.form.$submitted = true;
                if (!$scope.form.$valid)
                    return;

                usSpinnerService.spin('spinner-1');
                var url = localStorage.getItem('ApiUrl') + 'api/PropertyManagers/SaveMeters/';
                $http({
                    method: 'POST',
                    url: url,
                    data: {
                        PropertyId: $stateParams.id,
                        Meters: $scope.meters
                    },
                    params: { userName: $state.params.userId }
                }).then(function(httpResponse) {
                        var response = httpResponse.data;
                        utilli.handleAjaxResponse(response, ModalServiceExt, function() {
                            
                            if (response.Data.Meters && response.Data.Meters.length > 0) {
                                $state.goMainLayout("AddProperty.FailedMeters",
                                    {
                                        id: $stateParams.id,
                                        mode: $stateParams.mode,
                                        stepsCount: $scope.$parent.overallStepsCount,
                                        step: $scope.$parent.step
                                    });
                            }
                            else if ($stateParams.mode === 'edit') {
                                if(response.Data.NeedMetersApproval)
                                    PropertyDataService.showAuthorizationMetersWarningDialog($stateParams.id, function () {
                                        ModalServiceExt.showInfo(
                                            _t("Property is successfully edited but consumption data will not be submitted to Energy Star until tenants authorize data sharing."),
                                            function () { $state.goMainLayout("EditProperty", { id: $stateParams.id });  });
                                    });
                                else
                                    $state.goMainLayout("EditProperty", { id: $stateParams.id });
                            } else {
                                $state.goMainLayout("AddProperty.Authorization",
                                    {
                                        id: $stateParams.id,
                                        stepsCount: $scope.$parent.overallStepsCount,
                                        step: $scope.$parent.step * 1 + 1
                                    });
                            }
                        });
                    },
                    function() {
                        ModalServiceExt.showServerError();
                    })['finally'](function() {
                    usSpinnerService.stop('spinner-1');
                });
            }
        }])
    .controller('FailedMetersController', ['$scope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', '$stateParams', 'GetAccountsService', 'CommonHeaderService',
        'ModalServiceExt', 'PropertyDataService', 'PropertyService',
            // ReSharper disable InconsistentNaming
        function ($scope, $http, $timeout, $window, usSpinnerService, LeftMenuService, $state, $stateParams,
            GetAccountsService, CommonHeaderService, ModalServiceExt, PropertyDataService, PropertyService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            if ($stateParams.mode === 'edit')
                $scope.headerText = _t('Edit Property - Validation Error');
            else
                $scope.headerText = _t('Add Property - Validation Error');

            if ($state.params) {
                $scope.$parent.overallStepsCount = $state.params.stepsCount;
                $scope.$parent.step = $state.params.step;
            }
            $scope.serviceAddressMismatchErrorCode = utilli.pm.meterErrorCodes.serviceAddressMismatch;

            $scope.property = {};

            $scope.setCurrentMeterVisible = function () {
                setTimeout(function () {
                    $('#meter' + $scope.topMeterId)[0].scrollIntoView();
                }, 500);
            }

            function loadMeters() {
                usSpinnerService.spin('spinner-1');
                $http({
                    method: "GET",
                    url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetFailedMeters/',
                    params: { propertyId: $stateParams.id, userName: $state.params.userId }
                }).success(function(response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showServerError();
                        return;
                    }

                    if (response.Data.Meters && response.Data.Meters.length > 0) {
                        $scope.failedMeters = response.Data.Meters;
                        $scope.failedMeters.forEach(function(mtr) {
                            mtr.clientUtilliId = mtr.Id;
                            mtr.checked = !mtr.HasMultipleAddresses &&
                                mtr.ErrorCode === utilli.pm.meterErrorCodes.serviceAddressMismatch;
                        });

                        if ($stateParams.topMeter)
                            $scope.topMeterId = $stateParams.topMeter;
                        else if ($scope.canMassVerifyServiceAddress($scope.failedMeters))
                            utilli.scrollBottom();
                    } 
                    else if ($stateParams.mode === 'edit') {
                        var requestParams = { id: $state.params.id };
                        if (response.Data.NeedMetersApproval)
                            requestParams.showAuthorizationMetersWarning = true;
                        $state.goMainLayout('EditProperty', requestParams);
                    } 
                    else {
                        $state.goMainLayout("AddProperty.Authorization",
                            {
                                id: $stateParams.id,
                                stepsCount: $scope.$parent.overallStepsCount,
                                step: $scope.$parent.step * 1 + 1
                            });
                    }
                }).error(function() {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            loadMeters();


            $scope.verifyAllAddresses = function () {
                PropertyService.verifyAllAddresses($stateParams.id, $scope.failedMeters, loadMeters);
            }

            $scope.getErrorInfo = PropertyDataService.getErrorInfo;
            $scope.deleteMeter = function (utilliIndex) {
                PropertyService.deleteMeter($scope.failedMeters, utilliIndex, function() {
                    if ($scope.failedMeters.length === 0)
                        $state.goMainLayout('AddProperty.AddMeters', {
                            id: $stateParams.id,
                            stepsCount: $scope.$parent.overallStepsCount,
                            step: $scope.$parent.step,
                            mode: $stateParams.mode
                        });
                });
            }

            $scope.canMassVerifyServiceAddress = function () {
                return PropertyService.canMassVerifyServiceAddress($scope.failedMeters);
            }

            $scope.back = function () {
                $state.goMainLayout('AddProperty.AddMeters',
                    {
                        id: $stateParams.id,
                        mode: $stateParams.mode,
                        stepsCount: $scope.$parent.overallStepsCount,
                        step: $scope.$parent.step - 1
                    });
            }

            $scope.verify = function () {
                $scope.form.$submitted = true;
                if (!$scope.form.$valid)
                    return;

                usSpinnerService.spin('spinner-1');
                var url = localStorage.getItem('ApiUrl') + 'api/PropertyManagers/SaveMeters/';
                $http({
                    method: 'POST',
                    url: url,
                    data: {
                        PropertyId: $stateParams.id,
                        Meters: $scope.failedMeters
                    },
                    params: { userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.Errors && response.Errors.length > 0)
                        ModalServiceExt.showServerError();
                    else if (response.Data.Meters && response.Data.Meters.length > 0)
                        $scope.failedMeters = response.Data.Meters;
                    else if ($stateParams.mode === 'edit')
                    {
                        if(response.Data.NeedMetersApproval)
                            PropertyDataService.showAuthorizationMetersWarningDialog($stateParams.id, function () {
                                ModalServiceExt.showInfo(
                                    _t("Property is successfully edited but consumption data will not be submitted to Energy Star until tenants authorize data sharing."),
                                    function () { 
                                        $state.goMainLayout("EditProperty", { id: $stateParams.id });
                                    });
                            });
                        else
                            $state.goMainLayout('EditProperty', { id: $state.params.id });
                    }                        
                    else
                        $state.goMainLayout("AddProperty.Authorization", { id: $stateParams.id, stepsCount: $scope.$parent.overallStepsCount, step: 1 + $scope.$parent.step*1 });
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }
        }])
    .controller('AuthorizationController', ['$scope', '$rootScope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', '$stateParams', 'GetAccountsService',
        'CommonHeaderService', 'ModalServiceExt', 'PropertyDataService', 'propertyManagerTourService',
        // ReSharper disable InconsistentNaming
        function ($scope, $rootScope, $http, $timeout, $window,
            usSpinnerService, LeftMenuService, $state, $stateParams, GetAccountsService,
            CommonHeaderService, ModalServiceExt, PropertyDataService, propertyManagerTourService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            $scope.headerText = _t('Add Property - Authorization');
            if ($state.params) {
                $scope.$parent.overallStepsCount = $state.params.stepsCount;
                $scope.$parent.step = $state.params.step;
            }

            if (propertyManagerTourService.isTourActive()) {
                propertyManagerTourService.resumeTour('Authorization');
            }

            PropertyDataService.getProperty($stateParams.id, function (property) {
                if (property.Authorized)
                    $state.goMainLayout('PropertyList');
            });

            $scope.back = function () {
                $state.goMainLayout('AddProperty.AddMeters', { id: $stateParams.id, stepsCount: $scope.$parent.overallStepsCount, step: $scope.$parent.step - 1 });
            }

            $scope.submit = function () {
                usSpinnerService.spin('spinner-1');
                $http({
                    method: 'POST',
                    url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/AuthorizeProperty/',
                    params: { propertyId: $stateParams.id, userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');

                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showServerError();
                        return;
                    }

                    if (response.Data && response.Data.NeedsAuthorization)
                        PropertyDataService.showAuthorizationMetersWarningDialog($stateParams.id, function () {
                            ModalServiceExt.showInfo(
                                _t("Property is successfully created but consumption data will not be submitted to Energy Star until tenants authorize data sharing."),
                                function () { $state.goMainLayout('PropertyList'); });
                        });
                    else
                        ModalServiceExt.showInfo(_t("Property is successfully created."), function () { $state.goMainLayout('PropertyList'); });
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                });
            }
        }])
        .controller('LinkEnergyStarAccountController', ['$scope', '$rootScope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', '$stateParams', 'GetAccountsService', 'CommonHeaderService', 'ModalServiceExt', 'PropertyDataService',
        // ReSharper disable InconsistentNaming
        function ($scope, $rootScope, $http, $timeout, $window,
            usSpinnerService, LeftMenuService, $state, $stateParams, GetAccountsService, CommonHeaderService, ModalServiceExt, PropertyDataService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            $scope.headerText = _t('Add Property - Link Energy Star Account');
            $scope.data = PropertyDataService.data;
            $scope.emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Add Properties'));

            if ($state.params) {
                $scope.$parent.overallStepsCount = $state.params.stepsCount;
                $scope.$parent.step = $state.params.step;
            }

            usSpinnerService.spin('spinner-1');
            $http({
                method: 'GET',
                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetProfile',
                params: { userName: $state.params.userId }
            }).success(function (data) {
                usSpinnerService.stop('spinner-1');
                utilli.handleAjaxResponse(data, ModalServiceExt,
                    function () {
                        $scope.userData = data.Data.UserData;
                        $scope.firstName = $scope.userData.FirstName;
                        $scope.lastName = $scope.userData.LastName;
                        $scope.email = $scope.userData.Email;
                        $scope.phone = $scope.userData.PhoneNumber;
                        $scope.organizationName = $scope.userData.Agency;
                    });           
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                $scope.errors.push({ Message: utilli.serverErrorMessage });
            });

            $scope.next = function () {
                if ($scope.radioEnergyStarAccountType === 'linkExistingEnergyStarAccount') {
                    $state.goMainLayout("AddProperty.LinkEnergyStarAccountInstructions", { stepsCount: $state.params.stepsCount, step: $scope.$parent.step });
                    $scope.radioEnergyStarAccountType = null;
                }
                else if ($scope.radioEnergyStarAccountType === 'createNewEnergyStarAccount') {
                    $scope.form.$submitted = true;
                    if (!$scope.form.$valid)
                        return;

                    usSpinnerService.spin('spinner-1');
                    $http({
                        method: 'POST',
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/CreateNewEsAccountForCurrentUserRequest/',
                        data: {
                            FirstName: $scope.firstName,
                            LastName: $scope.lastName,
                            Address1: $scope.address1,
                            Address2: $scope.address2,
                            City: $scope.city,
                            State: $scope.state,
                            PostalCode: $scope.postalCode,
                            Email: $scope.email, 
                            Phone: $scope.phone, 
                            JobTitle: $scope.jobTitle,
                            OrganizationName: $scope.organizationName,
                            PrimaryBusiness: $scope.primaryBusiness,
                            OtherBusinessDescription: $scope.otherBusinessDescription,
                            EnergyStarPartner: $scope.energyStarPartner,
                            EnergyStarPartnerType: $scope.energyStarPartnerType,
                            OtherEnergyStarPartnerTypeDescription: $scope.otherEnergyStarPartnerTypeDescription
                        },
                        params: { userName: $state.params.userId }
                    }).success(function (response) {
                        usSpinnerService.stop('spinner-1');
                        if (response.Errors && response.Errors.length > 0) {
                            ModalServiceExt.showInfo('Error in procces of new Energy Star Account creation. Please try again later.');
                            return;
                        } else {
                            $state.goMainLayout("AddProperty.PropertyOverview", { stepsCount: $state.params.stepsCount, step: $scope.$parent.step * 1 + 1 });
                        }
                    }).error(function () {
                        usSpinnerService.stop('spinner-1');
                    });
                }
            }
        }])
        .controller('LinkEnergyStarAccountForPropertyImportController', ['$scope', '$rootScope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', '$stateParams', 'GetAccountsService', 'CommonHeaderService', 'ModalServiceExt', 'PropertyDataService',
        // ReSharper disable InconsistentNaming
        function ($scope, $rootScope, $http, $timeout, $window,
            usSpinnerService, LeftMenuService, $state, $stateParams, GetAccountsService, CommonHeaderService, ModalServiceExt, PropertyDataService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            $scope.headerText = _t('Import Property - Link Energy Star Account');
            $scope.data = PropertyDataService.data;

            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Add Properties'));

            $scope.step = 0;

            if ($state.params) {
                $scope.$parent.overallStepsCount = $state.params.stepsCount;
                $scope.$parent.step = 0;
            }

            $scope.next = function () {
                if ($scope.radioEnergyStarAccountType === 'linkExistingEnergyStarAccount') {
                    $state.goMainLayout("AddProperty.LinkEnergyStarAccountForPropertyImportInstructions", { stepsCount: $state.params.stepsCount, step: 1 + $scope.$parent.step*1 });
                    $scope.radioEnergyStarAccountType = null;
                }
                else if ($scope.radioEnergyStarAccountType === 'createNewEnergyStarAccount') {
                    usSpinnerService.spin('spinner-1');
                    $http({
                        method: 'POST',
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/CreateNewEsAccountForCurrentUserRequest/',
                        data: {}
                    }).success(function (response) {
                        usSpinnerService.stop('spinner-1');
                        if (response.Errors && response.Errors.length > 0) {
                            ModalServiceExt.showInfo(response.Errors[0]);
                            return;
                        } else {
                            $state.goMainLayout("AddProperty.ShareExistingEnergyStarPropertyInstructions", { stepsCount: $state.params.stepsCount, step: 1 + $scope.$parent.step*1 });
                        }
                    }).error(function () {
                        usSpinnerService.stop('spinner-1');
                    });
                }
            }
        }])
       .controller('LinkEnergyStarAccountInstructionsController', ['$scope', '$rootScope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', '$stateParams', 'GetAccountsService', 'CommonHeaderService', 'ModalServiceExt', 'PropertyDataService',
        // ReSharper disable InconsistentNaming
        function ($scope, $rootScope, $http, $timeout, $window,
            usSpinnerService, LeftMenuService, $state, $stateParams, GetAccountsService, CommonHeaderService, ModalServiceExt, PropertyDataService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            $scope.headerText = _t('Add Property - Link Energy Star Account');
            $scope.currentUserName = utilli.isAdmin ? $state.params.userId : localStorage.getItem('current_user');

            $scope.data = PropertyDataService.data;

            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Add Properties'));

            if ($state.params) {
                $scope.$parent.overallStepsCount = $state.params.stepsCount;
                $scope.$parent.step = $state.params.step;
            }

            $scope.isBackVisible = function(){ return true;}

            $scope.back = function () {
                $state.goMainLayout('AddProperty.LinkEnergyStarAccount', { stepsCount: $scope.$parent.overallStepsCount, step: $scope.$parent.step - 1 });
            }

            $scope.next = function () {
                    usSpinnerService.spin('spinner-1');
                    $http({
                        method: 'POST',
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/AcceptEsConnectionRequestForCurrentUser/',
                        data: {},
                        params: { userName: $state.params.userId }
                    }).success(function (response) {
                        usSpinnerService.stop('spinner-1');
                        if (response.Errors && response.Errors.length > 0) {
                            ModalServiceExt.showInfo( response.Errors[0]);
                            return;
                        } else {
                            $state.goMainLayout("AddProperty.PropertyOverview", { stepsCount: $scope.$parent.overallStepsCount, step: 1 + $scope.$parent.step * 1 });
                        }
                    }).error(function () {
                        usSpinnerService.stop('spinner-1');
                    });
                
            }
        }])
        .controller('LinkEnergyStarAccountForPropertyImportInstructionsController', ['$scope', '$rootScope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', '$stateParams', 'GetAccountsService', 'CommonHeaderService', 'ModalServiceExt', 'PropertyDataService',
        // ReSharper disable InconsistentNaming
        function ($scope, $rootScope, $http, $timeout, $window,
            usSpinnerService, LeftMenuService, $state, $stateParams, GetAccountsService, CommonHeaderService, ModalServiceExt, PropertyDataService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            $scope.headerText = _t('Import Property - Link Energy Star Account');
            $scope.data = PropertyDataService.data;

            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Add Properties'));

            $scope.currentUserName = utilli.isAdmin ? $state.params.userId : localStorage.getItem('current_user');

            $scope.step = 0;

            $scope.isBackVisible = function () { return false; }

            if ($state.params) {
                $scope.$parent.overallStepsCount = $state.params.stepsCount;
                $scope.$parent.step = 0;
            }

            $scope.back = function () {
                $state.goMainLayout('AddProperty.LinkEnergyStarAccountForPropertyImport', { stepsCount: $state.params.stepsCount });
            }

            $scope.next = function () {
                usSpinnerService.spin('spinner-1');
                $http({
                    method: 'POST',
                    url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/AcceptEsConnectionRequestForCurrentUser/',
                    data: {},
                    params: { userName: $state.params.userId } 
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showInfo(response.Errors[0]);
                        return;
                    } else {
                        $state.goMainLayout("AddProperty.ShareExistingEnergyStarPropertyInstructions", { stepsCount: $state.params.stepsCount });
                    }
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                });

            }
        }])
        .controller('ShareExistingEnergyStarPropertyInstructionsController', ['$scope', '$rootScope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', '$stateParams', 'GetAccountsService', 'CommonHeaderService', 'ModalServiceExt', 'PropertyDataService',
        // ReSharper disable InconsistentNaming
        function ($scope, $rootScope, $http, $timeout, $window,
            usSpinnerService, LeftMenuService, $state, $stateParams, GetAccountsService, CommonHeaderService, ModalServiceExt, PropertyDataService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            if ($state.params) {
                $scope.$parent.overallStepsCount = $state.params.stepsCount;
                $scope.$parent.step = $scope.$parent.overallStepsCount - 2;
            }

            $scope.headerText = _t('Import Property - Share Property');
            $scope.data = PropertyDataService.data;

            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Add Properties'));

            $scope.back = function () {
                $state.goMainLayout('AddProperty.AddNewOrShareExisting');
            }

            $scope.next = function () {
                usSpinnerService.spin('spinner-1');
                $http({
                    method: 'POST',
                    url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/AcceptEsSharingRequestsForCurrentUser/',
                    params: { userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    $scope.$parent.PropertySharingResult = response.Data;
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showInfo(response.Errors[0]);
                        return;
                    } else {
                        $state.goMainLayout("AddProperty.PropertySharingResults", { stepsCount: $state.params.stepsCount });
                    }
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                });
            }
        }])
       .controller('PropertySharingResultsController', ['$scope', '$rootScope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', '$stateParams', 'GetAccountsService', 'CommonHeaderService', 'ModalServiceExt', 'PropertyDataService',
        // ReSharper disable InconsistentNaming
        function ($scope, $rootScope, $http, $timeout, $window,
            usSpinnerService, LeftMenuService, $state, $stateParams, GetAccountsService, CommonHeaderService, ModalServiceExt, PropertyDataService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            if ($state.params) {
                $scope.$parent.overallStepsCount = $state.params.stepsCount;
                $scope.$parent.step = $scope.$parent.overallStepsCount;
            }

            $scope.headerText = _t('Import Property - Result');
            $scope.data = PropertyDataService.data;

            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Add Properties'));

            $scope.next = function () {
                $state.goMainLayout("PropertyList");
            }
        }])
       .factory('PropertyDataService', ['$http', 'usSpinnerService', 'ModalServiceExt', '$state', '$stateParams',
// ReSharper disable InconsistentNaming
            function ($http, usSpinnerService, ModalServiceExt, $state, $stateParams) {
// ReSharper restore InconsistentNaming
                var getProperty = function (id, callback) {
                    usSpinnerService.spin('spinner-1');
                    $http({
                        method: 'GET',
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetProperty/',
                        params: { propertyId: id, userName: $state.params.userId }
                    }).success(function (response) {
                        usSpinnerService.stop('spinner-1');
                        if (response.Errors && response.Errors.length > 0) {
                            ModalServiceExt.showServerError();
                            return;
                        }
                        callback(response.Data);
                    }).error(function () {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                    });
                }

                var showAuthorizationMetersWarningDialog = function (propertyId, noCallback) { 
                    ModalServiceExt.showYesNoMessage(
                        utilli._t("Authorization Required"),
                        utilli._t("When a property has less than 5 meters, it is required to get authorizations from tenants. Do you want to be redirected to the Send Authorization Requests page?"),
                        function () { $state.goMainLayout('SendInvitation', { propertyId: propertyId }) },
                        noCallback
                    );
                }

                return {
                    getProperty: getProperty,
                    getErrorInfo: function (meter, parent, from) {
                        var fromState = from ? utilli.getStateNameWithoutLayout($state.current.name) : null;
                        if (!meter.ApprovedByPM)
                            $state.goMainLayout('MeterNeedsApproval',
                                {
                                    propertyId: $stateParams.id,
                                    meterId: meter.Id,
                                    meterNumber: meter.MeterNumber,
                                    mode: $stateParams.mode,
                                    stepsCount: parent.overallStepsCount,
                                    step: parent.step,
                                    from: fromState
                                });
                        else if (meter.ErrorCode === 1) {
                            $state.goMainLayout('MeterDoesNotExist', {
                                propertyId: $stateParams.id,
                                meterId: meter.Id,
                                mode: $stateParams.mode,
                                stepsCount: parent.overallStepsCount,
                                step: parent.step,
                                from: fromState
                            });
                        }
                        else if (meter.ErrorCode === 2)
                            $state.goMainLayout('MeterDuplicated',
                                {
                                    propertyId: $stateParams.id,
                                    meterId: meter.Id,
                                    mode: $stateParams.mode,
                                    stepsCount: parent.overallStepsCount,
                                    step: parent.step,
                                    from: fromState
                                });
                        else if (meter.ErrorCode === 7)
                            $state.goMainLayout('MultipleTiedMeters',
                                {
                                    propertyId: $stateParams.id,
                                    meterId: meter.Id,
                                    mode: $stateParams.mode,
                                    stepsCount: parent.overallStepsCount,
                                    step: parent.step,
                                    from: fromState
                                });
                        else if (meter.ErrorCode === 8)
                            $state.goMainLayout('MeterIsUsed',
                                {
                                    propertyId: $stateParams.id,
                                    meterId: meter.Id,
                                    mode: $stateParams.mode,
                                    stepsCount: parent.overallStepsCount,
                                    step: parent.step,
                                    from: fromState
                                });
                        else if (meter.ErrorCode === 3)
                            $state.goMainLayout('ServiceAddressMismatches',
                                {
                                    propertyId: $stateParams.id,
                                    meterId: meter.Id,
                                    mode: $stateParams.mode,
                                    stepsCount: parent.overallStepsCount,
                                    step: parent.step,
                                    from: fromState
                                });
                    },
                    showAuthorizationMetersWarningDialog: showAuthorizationMetersWarningDialog
                };
        }]);
'use strict';
angular.module('utilliApp')
    .service('PropertySettingsService', function () {
        var _t = utilli._t;

        var primaryPropertyFunctions = {
            'AdultEducation' : 'Adult Education',
            'AmbulatorySurgicalCenter' :'Ambulatory Surgical Center',
            'Aquarium' :'Aquarium',
            'AutomobileDealership' :'Automobile Dealership',
            'BankBranch' :'Bank Branch',
            'BarNightclub' :'Bar/Nightclub',
            'Barracks' :'Barracks',
            'BowlingAlley' :'Bowling Alley',
            'Casino' :'Casino',
            'CollegeUniversity' :'College/University',
            'ConvenienceStorewithGasStation' :'Convenience Store with Gas Station',
            'ConvenienceStorewithoutGasStation' :'Convenience Store without Gas Station',
            'ConventionCenter' :'Convention Center',
            'Courthouse' :'Courthouse',
            'DataCenter' :'Data Center',
            'DistributionCenter' :'Distribution Center',
            'DrinkingWaterTreatmentDistribution' :'Drinking Water Treatment & Distribution',
            'EnclosedMall' :'Enclosed Mall',
            'EnergyPowerStation' :'Energy/Power Station',
            'FastFoodRestaurant' :'Fast Food Restaurant',
            'FinancialOffice' :'Financial Office',
            'FireStation' :'Fire Station',
            'FitnessCenterHealthClubGym' :'Fitness Center/Health Club/Gym',
            'FoodSales' :'Food Sales',
            'FoodService' :'Food Service',
            'HospitalGeneralMedicalSurgical' :'Hospital (General Medical & Surgical)',
            'Hotel' :'Hotel',
            'IceCurlingRink' :'Ice/Curling Rink',
            'IndoorArena' :'Indoor Arena',
            'K12School' :'K-12 School',
            'Laboratory' :'Laboratory',
            'Library' :'Library',
            'LifestyleCenter' :'Lifestyle Center',
            'MailingCenterPostOffice' :'Mailing Center/Post Office',
            'ManufacturingIndustrialPlant' :'Manufacturing/Industrial Plant',
            'MedicalOffice' :'Medical Office',
            'MixedUseProperty' :'Mixed Use Property',
            'MovieTheater' :'Movie Theater',
            'MultifamilyHousing' :'Multifamily Housing',
            'Museum' :'Museum',
            'NonRefrigeratedWarehouse' :'Non-Refrigerated Warehouse',
            'Office' :'Office',
            'OtherEducation' :'Other - Education',
            'OtherEntertainmentPublicAssembly' :'Other - Entertainment/Public Assembly',
            'OtherLodgingResidential' :'Other - Lodging/Residential',
            'OtherMall' :'Other - Mall',
            'OtherPublicServices' :'Other - Public Services',
            'OtherRecreation' :'Other - Recreation',
            'OtherRestaurantBar' :'Other - Restaurant/Bar',
            'OtherServices' :'Other - Services',
            'OtherStadium' :'Other - Stadium',
            'OtherTechnologyScience' :'Other - Technology/Science',
            'OtherUtility' :'Other - Utility',
            'Other' :'Other',
            'OtherSpecialtyHospital' :'Other/Specialty Hospital',
            'OutpatientRehabilitationPhysicalTherapy' :'Outpatient Rehabilitation/Physical Therapy',
            'Parking' :'Parking',
            'PerformingArts' :'Performing Arts',
            'PersonalServicesHealthBeautyDryCleaningetc' :'Personal Services (Health/Beauty, Dry Cleaning, etc)',
            'PoliceStation' :'Police Station',
            'PreschoolDaycare' :'Pre-school/Daycare',
            'PrisonIncarceration' :'Prison/Incarceration',
            'RaceTrack' :'Race Track',
            'RefrigeratedWarehouse' :'Refrigerated Warehouse',
            'RepairServicesVehicleShoeLocksmithetc' :'Repair Services (Vehicle, Shoe, Locksmith, etc)',
            'ResidenceHallDormitory' :'Residence Hall/Dormitory',
            'ResidentialCareFacility' :'Residential Care Facility',
            'Restaurant' :'Restaurant',
            'RetailStore' :'Retail Store',
            'RollerRink' :'Roller Rink',
            'SelfStorageFacility' :'Self-Storage Facility',
            'SeniorCareCommunity' :'Senior Care Community',
            'SingleFamilyHome' :'Single Family Home',
            'SocialMeetingHall' :'Social/Meeting Hall',
            'StadiumClosed' :'Stadium (Closed)',
            'StadiumOpen' :'Stadium (Open)',
            'StripMall' :'Strip Mall',
            'SupermarketGroceryStore' :'Supermarket/Grocery Store',
            'SwimmingPool' :'Swimming Pool',
            'TransportationTerminalStation' :'Transportation Terminal/Station',
            'UrgentCareClinicOtherOutpatient' :'Urgent Care/Clinic/Other Outpatient',
            'VeterinaryOffice' :'Veterinary Office',
            'VocationalSchool' :'Vocational School',
            'WastewaterTreatmentPlant' :'Wastewater Treatment Plant',
            'WholesaleClubSupercenter' :'Wholesale Club/Supercenter',
            'WorshipFacility' :'Worship Facility',
            'Zoo' :'Zoo'
        };

        

        var getPropertyTypeNames = function () {
            var result = [
                _t("Adult Education"),
                _t("Ambulatory Surgical Center"),
                _t("Aquarium"),
                _t("Automobile Dealership"),
                _t("Bank Branch"),
                _t("Bar/Nightclub"),
                _t("Barracks"),
                _t("Bowling Alley"),
                _t("Casino"),
                _t("College/University"),
                _t("Convenience Store with Gas Station"),
                _t("Convenience Store without Gas Station"),
                _t("Convention Center"),
                _t("Courthouse"),
                _t("Data Center"),
                _t("Distribution Center"),
                _t("Drinking Water Treatment & Distribution"),
                _t("Enclosed Mall"),
                _t("Energy/Power Station"),
                _t("Fast Food Restaurant"),
                _t("Financial Office"),
                _t("Fire Station"),
                _t("Fitness Center/Health Club/Gym"),
                _t("Food Sales"),
                _t("Food Service"),
                _t("Hospital (General Medical & Surgical)"),
                _t("Hotel"),
                _t("Ice/Curling Rink"),
                _t("Indoor Arena"),
                _t("K-12 School"),
                _t("Laboratory"),
                _t("Library"),
                _t("Lifestyle Center"),
                _t("Mailing Center/Post Office"),
                _t("Manufacturing/ Industrial Plan"),
                _t("Mixed Use Property"),
                _t("Medical Office"),
                _t("Movie Theater"),
                _t("Multifamily Housing"),
                _t("Museum"),
                _t("Non-Refrigerated Warehouse"),
                _t("Office"),
                _t("Other"),
                _t("Other - Education"),
                _t("Other - Entertainment/Public Assembly"),
                _t("Other - Lodging/Residential"),
                _t("Other - Mall"),
                _t("Other - Public Services"),
                _t("Other - Recreation"),
                _t("Other - Restaurant/Bar"),
                _t("Other - Services"),
                _t("Other - Stadium"),
                _t("Other - Technology/Science"),
                _t("Other - Utility"),
                _t("Other - Specialty Hospital"),
                _t("Outpatient Rehabilitation/Physical Therapy"),
                _t("Parking"),
                _t("Performing Arts"),
                _t("Personal Services (Health/Beauty, Dry Cleaning, etc)"),
                _t("Police Station"),
                _t("Pre-school/Daycare"),
                _t("Prison/Incarceration"),
                _t("Race Track"),
                _t("Refrigerated Warehouse"),
                _t("Repair Services (Vehicle, Shoe, Locksmith, etc)"),
                _t("Residential Care Facility"),
                _t("Residence Hall/Dormitory"),
                _t("Restaurant"),
                _t("Retail Store"),
                _t("Roller Rink"),
                _t("Self-Storage Facility"),
                _t("Senior Care Community"),
                _t("Single Family Home"),
                _t("Social/Meeting Hall"),
                _t("Stadium (Closed)"),
                _t("Stadium (Open)"),
                _t("Strip Mall"),
                _t("Supermarket/ Grocery Store"),
                _t("Swimming Pool"),
                _t("Transportation Terminal/Station"),
                _t("Urgent Care/Clinic/Other Outpatient"),
                _t("Veterinary Office"),
                _t("Vocational School"),
                _t("Wastewater Treatment Plant"),
                _t("Wholesale Club/Supercenter"),
                _t("Worship Facility"),
                _t("Zoo")
            ];
            return result;
        }

        var getFieldDescriptionByFieldName = function () {
            var result = {
                amountOfLaundryProcessedAnnually: _t('Quantity of laundry processed at the property.'),
                averageEffluentBiologicalOxygenDemand: _t('The concentration of effluent Biological Oxygen Demand (BOD5) at a wastewater treatment plant.'),
                averageInfluentBiologicalOxygenDemand: _t('The concentration of influent Biological Oxygen Demand (BOD5) at a wastewater treatment plant.'),
                averageNumberOfResidents: _t('Annual average number of residents at the property.'),
                completelyEnclosedFootage: _t('Area of parking garage that is completely enclosed.'),
                cookingFacilities: _t('Whether there are Cooking Facilities.'),
                coolingEquipmentRedundancy: _t('Level of redundancy for the cooling equipment in a Data Center.'),
                exteriorEntranceToThePublic: _t('Whether there is an Exterior Entrance to the Public.'),
                fixedFilmTrickleFiltrationProcess: _t('Whether there is a Fixed Film Trickle Filtration Process.'),
                fullServiceSpaFloorArea: _t('Floor area associated with a Full Service Spa.'),
                areaOfAllWalkInRefrigerationUnits: _t('Area of all walk-in refrigeration/freezer units - include only commercial type units that a person actually walks into to retrieve goods.  See numberOfWalkInRefrigerationUnits for more information.'),
                lengthOfAllOpenClosedRefrigerationUnits: _t('Length of all open or closed Refrigeration or Freezer cases that are used for the sale or storage of perishable goods. Include display-type refrigerated open or closed cases and cabinets, as well as display-type freezer units. These are typically found on the sales floor.'),
                enclosedFloorArea: _t('Total enclosed floor area at a Stadium/Arena.'),
                governmentSubsidizedHousing: _t('Whether this is housing that is subsidized by the local, state, or Federal government.'),
                gymCenterFloorArea: _t('Floor area associated with a Gym/Fitness Center.'),
                hasComputerLab: _t('Whether there is a Computer Lab.'),
                hasDiningHall: _t('Whether there is a Dining Hall.'),
                hasLaboratory: _t('Presence of a laboratory (Yes/No).'),
                hoursPerDayGuestsOnsite: _t('Number of hours per day a typical guest spends at the property (Less Than 15, 15 To 19, More Than 20)'),
                isHighSchool: _t('Presence of a High School, as indicated by education of grades 10, 11, and/or 12 (Yes/No).'),
                isTertiaryCare: _t('Presence of tertiary medical care, specialized care beyond a typical secondary level, such as Level 1 trauma centers, organ transplant, or prenatal intensive care units (Yes/No).'),
                iceEvents: _t('Are there ice-related events such as Hockey, Skating, Ice Capades?'),
                numberOfConcertShowEventsPerYear: _t('Number of concert/show events per year.'),
                numberOfSpecialOtherEventsPerYear: _t('Number of special/other events per year at a stadium/arena (i.e. events that are neither concerts/shows nor athletic events).'),
                numberOfSportingEventsPerYear: _t('Number of sporting/athletic events per year.'),
                numberOfSurgicalOperatingBeds: _t('Number of beds associated with surgical operation at a medial office/outpatient healthcare facility.'),
                sizeOfElectronicScoreBoards: _t('The total size of electronic score boards at a stadium/arena.'),
                surgeryCenterFloorArea: _t('The area within a medical office or outpatient healthcare property devoted to surgery.'),
                itEnergyMeterConfiguration: _t('The IT Energy Configuration/location of IT Energy meters at a data center.'),
                itEnergyConfiguration: _t('The IT Energy Configuration/location of IT Energy meters at a data center.'),
                laundryFacility: _t('Type of laundry processed at the property (linens, Terry, Linens &amp; Terry)'),
                maximumNumberOfFloors: _t('Maximum number of floors in the tallest building at the property.'),
                maximumResidentCapacity: _t('Maximum capacity of residents, based on the design of the facility.'),
                licensedBedCapacity: _t('Licensed Bed Capacity is the total number of beds that your hospital is licensed to have in operation. This may be more than your Staffed Beds, which are those that are set up and ready for use.'),
                monthsInUse: _t('Number of months per year the property is in use.'),
                numberOfBedrooms: _t('Number of bedrooms.'),
                numberOfCashRegisters: _t('Number of cash registers.'),
                numberOfCommercialRefrigerationUnits: _t('Number of Commercial Refrigeration/Freezer cases, including any open or closed commercial type case, and including any walk-in units.'),
                numberOfCommercialWashingMachines: _t('Number of commercial-type washing machines.  (This does not include residential or coin-operated machines)'),
                numberOfComputers: _t('Number of computers and servers at the property.'),
                numberOfResidentialLivingUnitsLowRiseSetting: _t('Number of units located in individual buildings that are 1 to 4 stories in height, as well as units located wings/portions of larger buildings that fall in this height range (e.g. if Wing A is 6 stories and Wing B is 3 stories, only units in Wing B would be counted here).'),
                numberOfFTEWorkers: _t('Number of full-time equivalent workers (total number of hours worked by all workers, divided by the standard hours in a full time shift).'),
                numberOfGuestMealsServedPerYear: _t('Total number of guest meals (also called meal covers) served each year.'),
                numberOfLaundryHookupsInAllUnits: _t('The total number of laundry hookups in all individual living units (counting hookups, whether or not there is a machine).'),
                numberOfLaundryHookupsInCommonArea: _t('The total number of laundry hookups in all common areas (counting hookups, whether or not there is a machine).'),
                numberOfMriMachines: _t('Number of MRI Machines.'),
                numberOfOpenClosedRefrigerationUnits: _t('The Number of Open or Closed Refrigeration/Freezer Units is the count of open or closed cases that are used for the sale or storage of perishable goods. This includes display-type refrigerated open or closed cases and cabinets as well as display-type freezer units typically found on a sales floor. Each case or cabinet section, typically 4 to 12 feet in length, should be considered 1 unit. Include those cases located inside and immediately adjacent to the building. These units may be portable or permanent, and may have doors, plastic strips, or other flexible cover. This count should not include vending machines. If your property is in the design phase, use your best estimate for the intended conditions when the property is fully operational.'),
                numberOfPeople: _t('Number of people living in the home.'),
                numberOfResidentialLiftSystems: _t('Number of residential electronic lift systems.'),
                numberOfResidentialLivingUnits: _t('Total number of residential living units (apartments or condominiums) at the property. This value must equal the sum of the number of residential living units in a low-rise setting, mid-rise setting, and high-rise setting.  A 0.9 tolerance is allowed.'),
                numberOfResidentialWashingMachines: _t('Number of residential-type washing machines.'),
                numberOfRooms: _t('Total number of rooms for a lodging type of property (hotel, dormitory, etc).'),
                numberOfHotelRooms: _t('Total number of rooms for a lodging type of property (hotel).'),
                numberOfStaffedBeds: _t('Number of beds set up and staffed for use at a hospital.'),
                numberOfWalkInRefrigerationUnits: _t('Number of walk-in refrigeration/freezer units - including only those commercial type units that you can completely enter to retrieve goods.'),
                numberOfWeekdaysOpen: _t('Number of weekdays (Monday through Friday) the property is open.  This will be an number between 0 and 5.'),
                numberOfWorkers: _t('The total number of workers during the primary (largest shift) - this is only a total number of people in the building at a single time.'),
                gymnasiumFloorArea: _t('Floor area associated with a gymnasium at a K12 School.'),
                studentSeatingCapacity: _t('The number of students the school can accommodate (including portable classrooms).'),
                nutrientRemoval: _t('Presence of a nutrient removal system at a wastewater treatment plant (Yes/No).'),
                onSiteLaundryFacility: _t('Presence of an on-site Laundry Facility (Yes/No).'),
                openFootage: _t('Total area of open parking lots/areas.'),
                openOnWeekends: _t('Indication of regular activities that occur on either Saturday or Sunday (Yes/No).'),
                ownedBy: _t('Indication of whether the property is owned by a private, not-for profit, or government organization.'),
                partiallyEnclosedFootage: _t('Total area of all parking structures that are only partially enclosed (i.e. multi-level structures that only have partial walls).'),
                percentCooled: _t('The percent of the property that can be cooled by mechanical cooling equipment.'),
                percentHeated: _t('The percent of the property that can be heated by mechanical heating equipment.'),
                numberOfResidentialLivingUnitsMidRiseSetting: _t('Number of units located in individual buildings that are 5 to 9 stories in height, as well as units located wings/portions of larger buildings that fall in this height range (e.g. if Wing A is 6 stories and Wing B is 3 stories, only units in Wing A would be counted here).'),
                percentOfGrossFloorAreaThatIsCommonSpaceOnly: _t('The percent of the Gross Floor Area that is common space (not individual tenant areas)'),
                plantDesignFlowRate: _t('The designed flow rate of a wastewater treatment plant (e.g. the capacity of the plant)'),
                poolLocation: _t('Indication of whether a pool is indoor or outdoor.'),
                poolSize: _t('Approximate size of a swimming pool (Short Course, Recreational, Olympic).'),
                numberOfResidentialLivingUnitsHighRiseSetting: _t('Number of units located in individual buildings that are 10 or more stories in height, as well as units located in wings/portions of buildings that fall in this range (e.g. if Wing A is 10 stories and Wing B is 5 stories, only units in Wing A would be counted here).'),
                residentPopulation: _t('An indication of the type of residents living at the property, if applicable (e.g. student, military, senior, etc).'),
                schoolDistrict: _t('The school district in which the school is located.'),
                seatingCapacity: _t('The seating capacity associated with the main areas of worship in a worship facility.'),
                singleStore: _t('Indication that a Retail Store is a single store (Yes/No).'),
                upsSystemRedundancy: _t('Level of redundancy for the Uninterruptible Power Supply (UPS) system in a Data Center.'),
                supplementalHeating: _t('Presence of supplemental heating systems in a parking garage (Yes/No).'),
                weeklyOperatingHours: _t('The total number of hours per week that the property is occupied by the majority of the employees.  It does not include hours when the property is occupied only by maintenance, security, or other support personnel.'),
                totalGrossFloorArea: _t('The total gross floor area of all buildings at the property, measured at the exterior boundary of the enclosing walls, including all areas within the building (common, tenant, maintenance, etc).'),
                numberOfIndoorIceRinks: _t('Number of indoor ice rinks used for indoor hockey, ringette, public or figure skating. This does not include curling sheets.'),
                totalIceRinkSurfaceAreaForAllRinks: _t('The indoor ice rink surface area is the total area covered by ice of all the ice rinks used for indoor hockey, ringette, public or figure skating and can be estimated by multiplying the length of the ice surface with the width of the ice surface and adding together the calculated area for each ice rink in the facility. This surface area does not include curling sheets.'),
                numberOfWeeklyIceResurfacingForAllRinks: _t('Total number of floods in a week using ice resurfacing machines after typical ice rink use for all indoor hockey, ringette, public or figure skating ice rinks in the facility. This does not include curling sheet resurfacing or pebbling. For multiple rinks, sum the total number of weekly resurfacing for all rinks.'),
                numberOfCurlingSheets: _t('Number of ice sheets specifically for the purpose of the game of curling.'),
                spectatorSeatingCapacity: _t('Seating capacity.'),
                monthsMainIndoorIceRinkInUse: _t('Number of months per year the property is in use.'),
            };
            return result;
        }

        var getFieldCaptionByFieldName = function () {
            var result = {
                amountOfLaundryProcessedAnnually: _t('Quantity of laundry processed at the property annually'),
                averageEffluentBiologicalOxygenDemand: _t('The concentration of effluent Biological Oxygen Demand (BOD5)'),
                averageInfluentBiologicalOxygenDemand: _t('The concentration of influent Biological Oxygen Demand (BOD5)'),
                averageNumberOfResidents: _t('Annual average number of residents'),
                completelyEnclosedFootage: _t('Enclosed Footage'),
                cookingFacilities: _t('Cooking Facilities'),
                coolingEquipmentRedundancy: _t('Cooling Equipment Redudancy'),
                exteriorEntranceToThePublic: _t('Exterior Entrance to the Public'),
                fixedFilmTrickleFiltrationProcess: _t('Fixed Film Trickle Filtration Process'),
                fullServiceSpaFloorArea: _t('Full Service Spa Floor Area'),
                areaOfAllWalkInRefrigerationUnits: _t('Area of all walk-in refrigeration/freezer units'),
                lengthOfAllOpenClosedRefrigerationUnits: _t('Length of all open or closed Refrigeration or Freezer cases'),
                enclosedFloorArea: _t('Total enclosed floor area at a Stadium/Arena'),
                governmentSubsidizedHousing: _t('Subsidized by the local, state, or Federal government'),
                gymCenterFloorArea: _t('Gym/Fitness Center Floor Area'),
                hasComputerLab: _t('Computer Lab'),
                hasDiningHall: _t('Dining Hall'),
                hasLaboratory: _t('Presence of a laboratory'),
                hoursPerDayGuestsOnsite: _t('Hours Per Day Guests Onsite'),
                isHighSchool: _t('Presence of a High School'),
                isTertiaryCare: _t('Presence of tertiary medical care'),
                iceEvents: _t('Ice Events'),
                numberOfConcertShowEventsPerYear: _t('Number of concert/show events per year'),
                numberOfSpecialOtherEventsPerYear: _t('Number of special/other events per year'),
                numberOfSportingEventsPerYear: _t('Number of sporting/athletic events per year'),
                numberOfSurgicalOperatingBeds: _t('Number of beds associated with surgical operation medial office'),
                sizeOfElectronicScoreBoards: _t('Size of electronic score boards'),
                surgeryCenterFloorArea: _t('Surgery Center Floor Area'),
                itEnergyMeterConfiguration: _t('The IT Energy Configuration/location'),
                itEnergyConfiguration: _t('The IT Energy Configuration/location'),
                laundryFacility: _t('Type of laundry processed at the property'),
                maximumNumberOfFloors: _t('Maximum number of floors'),
                maximumResidentCapacity: _t('Maximum capacity of residents,'),
                licensedBedCapacity: _t('Licensed Bed Capacity'),
                monthsInUse: _t('Months In Use'),
                numberOfBedrooms: _t('Number of bedrooms'),
                numberOfCashRegisters: _t('Number of cash registers'),
                numberOfCommercialRefrigerationUnits: _t('Number of Commercial Refrigeration/Freezer cases'),
                numberOfCommercialWashingMachines: _t('Number of commercial-type washing machines'),
                numberOfComputers: _t('Number of computers'),
                numberOfResidentialLivingUnitsLowRiseSetting: _t('Low Rise Residential Lining Units Number'),
                numberOfFTEWorkers: _t('Number of full-time equivalent workers'),
                numberOfGuestMealsServedPerYear: _t('Number of guest meals served each year.'),
                numberOfLaundryHookupsInAllUnits: _t('Number of laundry hookups in all individual living units'),
                numberOfLaundryHookupsInCommonArea: _t('Number of laundry hookups in all common areas'),
                numberOfMriMachines: _t('Number of MRI Machines.'),
                numberOfOpenClosedRefrigerationUnits: _t('The Number of Open or Closed Refrigeration/Freezer Units'),
                numberOfPeople: _t('Number of people'),
                numberOfResidentialLiftSystems: _t('Number of residential electronic lift systems'),
                numberOfResidentialLivingUnits: _t('Total number of residential living units'),
                numberOfResidentialLivingUnitsMidRiseSetting: _t('Number of Residential Units Mid Rise'),
                numberOfResidentialWashingMachines: _t('Number of residential-type washing machines'),
                numberOfRooms: _t('Total number of rooms'),
                numberOfHotelRooms: _t('Total number of rooms'),
                numberOfStaffedBeds: _t('Number of beds'),
                numberOfWalkInRefrigerationUnits: _t('Number of walk-in refrigeration/freezer units'),
                numberOfWeekdaysOpen: _t('Number of weekdays (Monday through Friday) the property is open'),
                numberOfWorkers: _t('The total number of workers'),
                gymnasiumFloorArea: _t('Floor area associated with a gymnasium'),
                studentSeatingCapacity: _t('The number of students'),
                nutrientRemoval: _t('Presence of a nutrient removal system'),
                onSiteLaundryFacility: _t('Presence of an on-site Laundry Facility'),
                openFootage: _t('Open Footage'),
                openOnWeekends: _t('Open On Weekends'),
                ownedBy: _t('Owned By'),
                partiallyEnclosedFootage: _t('Partially Enclosed Footage'),
                percentCooled: _t('Percent Cooled'),
                percentHeated: _t('Percent Heated'),
                percentOfficeCooled: _t('Percent Office Cooled'),
                percentOfficeHeated: _t('Percent Office Heated'),
                percentOfGrossFloorAreaThatIsCommonSpaceOnly: _t('The percent of the Gross Floor Area that is common space'),
                plantDesignFlowRate: _t('Designed Flow Rate'),
                poolLocation: _t('Pool Location'),
                poolSize: _t('Pool Size'),
                numberOfResidentialLivingUnitsHighRiseSetting: _t('Number of units High Rise'),
                residentPopulation: _t('Resident Population'),
                schoolDistrict: _t('School District'),
                seatingCapacity: _t('Seating Capacity'),
                singleStore: _t('Single Store'),
                upsSystemRedundancy: _t('UPS System Redudancy'),
                supplementalHeating: _t('Supplement Heating'),
                weeklyOperatingHours: _t('Weekly Operating Hours'),
                totalGrossFloorArea: _t('Total Gross Floor Area'),
                enrollment: _t('Enrollment'),
                grantDollars: _t('Grant Dollars'),
                numberOfIndoorIceRinks: _t('Number of indoor ice rinks'),
                totalIceRinkSurfaceAreaForAllRinks: _t('The indoor ice rink surface area'),
                numberOfWeeklyIceResurfacingForAllRinks: _t('Total number of floods in a week using ice resurfacing machines'),
                numberOfCurlingSheets: _t('Number of ice sheets'),
                spectatorSeatingCapacity: _t('Number of seats for spectators'),
                monthsMainIndoorIceRinkInUse: _t('Months in use'),
            };
            return result;
        }

        var controlTypeByFieldName = {
            amountOfLaundryProcessedAnnually: 'amountOfLaundryProcessedAnnuallyType',
            averageEffluentBiologicalOxygenDemand: 'useDecimalType',
            averageInfluentBiologicalOxygenDemand: 'useDecimalType',
            averageNumberOfResidents: 'useDecimalType',
            completelyEnclosedFootage: 'grossFloorAreaType',
            cookingFacilities: 'yesNoType',
            coolingEquipmentRedundancy: 'equipmentRedundancyType',
            exteriorEntranceToThePublic: 'yesNoType',
            fixedFilmTrickleFiltrationProcess: 'yesNoType',
            fullServiceSpaFloorArea: 'grossFloorAreaType',
            areaOfAllWalkInRefrigerationUnits: 'grossFloorAreaType',
            lengthOfAllOpenClosedRefrigerationUnits: 'lengthType',
            enclosedFloorArea: 'grossFloorAreaType',
            governmentSubsidizedHousing: 'yesNoType',
            gymCenterFloorArea: 'grossFloorAreaType',
            hasComputerLab: 'yesNoType',
            hasDiningHall: 'yesNoType',
            hasLaboratory: 'yesNoType',
            hoursPerDayGuestsOnsite: 'hoursPerDayGuestsOnsiteType',
            isHighSchool: 'yesNoType',
            isTertiaryCare: 'yesNoType',
            iceEvents: 'yesNoType',
            numberOfConcertShowEventsPerYear: 'intNumberType',
            numberOfSpecialOtherEventsPerYear: 'intNumberType',
            numberOfSportingEventsPerYear: 'intNumberType',
            numberOfSurgicalOperatingBeds: 'useDecimalType',
            sizeOfElectronicScoreBoards: 'grossFloorAreaType',
            surgeryCenterFloorArea: 'grossFloorAreaType',
            itEnergyMeterConfiguration: 'useStringType',
            itEnergyConfiguration: 'itEnergyConfigurationType',
            laundryFacility: 'laundryFacilityType',
            maximumNumberOfFloors: 'intNumberType',
            maximumResidentCapacity: 'useDecimalType',
            licensedBedCapacity: 'useDecimalType',
            monthsInUse: 'useDecimalType',
            numberOfBedrooms: 'useDecimalType',
            numberOfCashRegisters: 'useDecimalType',
            numberOfCommercialRefrigerationUnits: 'useDecimalType',
            numberOfCommercialWashingMachines: 'useDecimalType',
            numberOfComputers: 'useDecimalType',
            numberOfResidentialLivingUnitsLowRiseSetting: 'useDecimalType',
            numberOfFTEWorkers: 'useDecimalType',
            numberOfGuestMealsServedPerYear: 'intNumberType',
            numberOfLaundryHookupsInAllUnits: 'intNumberType',
            numberOfLaundryHookupsInCommonArea: 'intNumberType',
            numberOfMriMachines: 'useDecimalType',
            numberOfOpenClosedRefrigerationUnits: 'useDecimalType',
            numberOfPeople: 'intNumberType',
            numberOfResidentialLiftSystems: 'useDecimalType',
            numberOfResidentialLivingUnits: 'useDecimalType',
            numberOfResidentialWashingMachines: 'useDecimalType',
            numberOfRooms: 'intNumberType',
            numberOfHotelRooms: 'useDecimalType',
            numberOfStaffedBeds: 'useDecimalType',
            numberOfWalkInRefrigerationUnits: 'useDecimalType',
            numberOfWeekdaysOpen: 'numberOfWeekdaysType',
            numberOfWorkers: 'useDecimalType',
            gymnasiumFloorArea: 'grossFloorAreaType',
            studentSeatingCapacity: 'useDecimalType',
            nutrientRemoval: 'yesNoType',
            onSiteLaundryFacility: 'yesNoType',
            openFootage: 'grossFloorAreaType',
            openOnWeekends: 'yesNoType',
            ownedBy: 'ownedByType',
            partiallyEnclosedFootage: 'grossFloorAreaType',
            percentCooled: 'percentsOver10',
            percentHeated: 'percentsOver10',
            percentOfficeCooled: 'percentOfficeCooledType',
            percentOfficeHeated: 'percentOfficeHeatedType',
            numberOfResidentialLivingUnitsMidRiseSetting: 'useDecimalType',
            percentOfGrossFloorAreaThatIsCommonSpaceOnly: 'useStringType',
            plantDesignFlowRate: 'plantDesignFlowRateType',
            poolLocation: 'poolType',
            poolSize: 'poolSizeType',
            numberOfResidentialLivingUnitsHighRiseSetting: 'useDecimalType',
            residentPopulation: 'residentPopulationType',
            schoolDistrict: 'useStringType',
            seatingCapacity: 'useDecimalType',
            singleStore: 'yesNoType',
            upsSystemRedundancy: 'equipmentRedundancyType',
            supplementalHeating: 'yesNoType',
            weeklyOperatingHours: 'weeklyOperatingHoursType',
            totalGrossFloorArea: 'grossFloorAreaType',
            enrollment: 'useDecimalType',
            grantDollars: 'useDecimalType',
            numberOfIndoorIceRinks: 'intNumberType',
            totalIceRinkSurfaceAreaForAllRinks: 'grossFloorAreaType',
            numberOfWeeklyIceResurfacingForAllRinks: 'intNumberType',
            numberOfCurlingSheets: 'intNumberType',
            spectatorSeatingCapacity: 'intNumberType',
            monthsMainIndoorIceRinkInUse: 'intNumberType',
        }

        // ReSharper disable InconsistentNaming
        function TotalGrossFloorArea() {
            this.name = 'totalGrossFloorArea';
            this.controlType = 'grossFloorAreaType';
            this.value = '';
            this.units = '';
        }

        function AreaOfAllWalkInRefrigerationUnitsElement() {
            this.name = 'areaOfAllWalkInRefrigerationUnits';
            this.controlType = 'grossFloorAreaType';
            this.value = '';
            this.units = '';
        }

        function GymnasiumFloorAreaElement() {
            this.name = 'gymnasiumFloorArea';
            this.controlType = 'grossFloorAreaType';
            this.value = '';
            this.units = '';
        }

        function CoolingEquipmentRedundancyElement() {
            this.name = 'coolingEquipmentRedundancy';
            this.controlType = 'equipmentRedundancyType';
            this.value = '';
        }

        function ItEnergyConfigurationElement() {
            this.name = 'itEnergyConfiguration';
            this.controlType = 'itEnergyConfigurationType';
            this.value = '';
        }

        function UpsSystemRedundancyElement() {
            this.name = 'upsSystemRedundancy';
            this.controlType = 'equipmentRedundancyType';
            this.value = '';
        }

        function LengthOfAllOpenClosedRefrigerationUnitsElement() {
            this.name = 'lengthOfAllOpenClosedRefrigerationUnits';
            this.controlType = 'lengthType';
            this.value = '';
            this.units = '';
        }

        function NumberOfWorkers() {
            this.name = 'numberOfWorkers';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfComputers() {
            this.name = 'numberOfComputers';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function WeeklyOperatingHours() {
            this.name = 'weeklyOperatingHours';
            this.controlType = 'weeklyOperatingHoursType';
            this.value = '';
        }

        function OtherProperty() {
            this.fieldsList = [
                new TotalGrossFloorArea(),
                new NumberOfWorkers(),
                new NumberOfComputers(),
                new WeeklyOperatingHours()
            ];
        }

        function HeatingElement() {
            this.name = 'percentOfficeHeated';
            this.controlType = 'percentOfficeHeatedType';
            this.value = '';
        }

        function CoolingElement() {
            this.name = 'percentOfficeCooled';
            this.controlType = 'percentOfficeCooledType';
            this.value = '';
        }

        function HeatingPercentElement() {
            this.name = 'percentCooled';
            this.controlType = 'percentsOver10';
            this.value = '';
        }

        function CoolingPercentElement() {
            this.name = 'percentHeated';
            this.controlType = 'percentsOver10';
            this.value = '';
        }

        function HasComputerLabElement() {
            this.name = 'hasComputerLab';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function CookingFacilitiesElement() {
            this.name = 'cookingFacilities';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function NumberOfWalkInRefrigerationUnitsElement() {
            this.name = 'numberOfWalkInRefrigerationUnits';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfCashRegistersElement() {
            this.name = 'numberOfCashRegisters';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfOpenClosedRefrigerationUnitsElement() {
            this.name = 'numberOfOpenClosedRefrigerationUnits';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function HasDiningHallElement() {
            this.name = 'hasDiningHall';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function OpenOnWeekendsElement() {
            this.name = 'openOnWeekends';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function HasLaboratoryElement() {
            this.name = 'hasLaboratory';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function OnSiteLaundryFacilityElement() {
            this.name = 'onSiteLaundryFacility';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function LaundryFacilityElement() {
            this.name = 'laundryFacility';
            this.controlType = 'laundryFacilityType';
            this.value = '';
        }

        function MaximumNumberOfFloorsElement() {
            this.name = 'maximumNumberOfFloors';
            this.controlType = 'intNumberType';
            this.value = '';
        }

        function NumberOfStaffedBedsElement() {
            this.name = 'numberOfStaffedBeds';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfMriMachinesElement() {
            this.name = 'numberOfMriMachines';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function ownedByElement() {
            this.name = 'ownedBy';
            this.controlType = 'ownedByType';
            this.value = '';
        }

        function IsTertiaryCareElement() {
            this.name = 'isTertiaryCare';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function LicensedBedCapacityElement() {
            this.name = 'licensedBedCapacity';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function IsHighSchoolElement() {
            this.name = 'isHighSchool';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function MonthsInUseElement() {
            this.name = 'monthsInUse';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function SchoolDistrictElement() {
            this.name = 'schoolDistrict';
            this.controlType = 'useStringType';
            this.value = '';
        }

        function StudentSeatingCapacityElement() {
            this.name = 'studentSeatingCapacity';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfRoomsElement() {
            this.name = 'numberOfRooms';
            this.controlType = 'intNumberType';
            this.value = '';
        }

        function NumberOfFteWorkersElement() {
            this.name = 'numberOfFTEWorkers';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function EnrollmentElement() {
            this.name = 'enrollment';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function GrantDollarsElement() {
            this.name = 'grantDollars';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function FullServiceSpaFloorAreaElement() {
            this.name = 'fullServiceSpaFloorArea';
            this.controlType = 'grossFloorAreaType';
            this.value = '';
        }

        function GymCenterFloorAreaAreaElement() {
            this.name = 'gymCenterFloorArea';
            this.controlType = 'grossFloorAreaType';
            this.value = '';
        }

        function HoursPerDayGuestsOnsiteElement() {
            this.name = 'hoursPerDayGuestsOnsite';
            this.controlType = 'hoursPerDayGuestsOnsiteType';
            this.value = '';
        }

        function NumberOfCommercialRefrigerationUnitsElement() {
            this.name = 'numberOfCommercialRefrigerationUnits';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfGuestMealsServedPerYearElement() {
            this.name = 'numberOfGuestMealsServedPerYear';
            this.controlType = 'intNumberType';
            this.value = '';
        }

        function NumberOfHotelRoomsElement() {
            this.name = 'numberOfHotelRooms';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function AmountOfLaundryProcessedAnnuallyElement() {
            this.name = 'amountOfLaundryProcessedAnnually';
            this.controlType = 'amountOfLaundryProcessedAnnuallyType';
            this.value = '';
            this.units = '';
        }

        function EnclosedFloorAreaElement() {
            this.name = 'enclosedFloorArea';
            this.controlType = 'grossFloorAreaType';
            this.value = '';
        }

        function NumberOfSportingEventsPerYearElement() {
            this.name = 'numberOfSportingEventsPerYear';
            this.controlType = 'intNumberType';
            this.value = '';
        }


        function NumberOfConcertShowEventsPerYearElement() {
            this.name = 'numberOfConcertShowEventsPerYear';
            this.controlType = 'intNumberType';
            this.value = '';
        }

        function NumberOfSpecialOtherEventsPerYearElement() {
            this.name = 'numberOfSpecialOtherEventsPerYear';
            this.controlType = 'intNumberType';
            this.value = '';
        }

        function SizeOfElectronicScoreBoardsElement() {
            this.name = 'sizeOfElectronicScoreBoards';
            this.controlType = 'grossFloorAreaType';
            this.value = '';
        }

        function IceEventsElement() {
            this.name = 'iceEvents';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function NumberOfSurgicalOperatingBedsElement() {
            this.name = 'numberOfSurgicalOperatingBeds';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function SurgeryCenterFloorAreaElement() {
            this.name = 'surgeryCenterFloorArea';
            this.controlType = 'grossFloorAreaType';
            this.value = '';
        }

        function NumberOfResidentialLivingUnitsElement() {
            this.name = 'numberOfResidentialLivingUnits';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfBedroomsElement() {
            this.name = 'numberOfBedrooms';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfResidentialLivingUnitsMidRiseSettingElement() {
            this.name = 'numberOfResidentialLivingUnitsMidRiseSetting';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfLaundryHookupsInAllUnitsElement() {
            this.name = 'numberOfLaundryHookupsInAllUnits';
            this.controlType = 'intNumberType';
            this.value = '';
        }

        function NumberOfLaundryHookupsInCommonAreaElement() {
            this.name = 'numberOfLaundryHookupsInCommonArea';
            this.controlType = 'intNumberType';
            this.value = '';
        }

        function NumberOfResidentialLivingUnitsLowRiseSettingElement() {
            this.name = 'numberOfResidentialLivingUnitsLowRiseSetting';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfResidentialLivingUnitsHighRiseSettingElement() {
            this.name = 'numberOfResidentialLivingUnitsHighRiseSetting';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function ResidentPopulationElement() {
            this.name = 'residentPopulation';
            this.controlType = 'residentPopulationType';
            this.value = '';
        }

        function GovernmentSubsidizedHousingElement() {
            this.name = 'governmentSubsidizedHousing';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function SupplementalHeatingElement() {
            this.name = 'supplementalHeating';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function OpenFootageElement() {
            this.name = 'openFootage';
            this.controlType = 'grossFloorAreaType';
            this.value = '';
        }

        function CompletelyEnclosedFootageElement() {
            this.name = 'completelyEnclosedFootage';
            this.controlType = 'grossFloorAreaType';
            this.value = '';
        }

        function PartiallyEnclosedFootageElement() {
            this.name = 'partiallyEnclosedFootage';
            this.controlType = 'grossFloorAreaType';
            this.value = '';
        }

        function AverageNumberOfResidentsElement() {
            this.name = 'averageNumberOfResidents';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function MaximumResidentCapacityElement() {
            this.name = 'maximumResidentCapacity';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfCommercialWashingMachinesElement() {
            this.name = 'numberOfCommercialWashingMachines';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfResidentialWashingMachinesElement() {
            this.name = 'numberOfResidentialWashingMachines';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfResidentialLiftSystemsElement() {
            this.name = 'numberOfResidentialLiftSystems';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function SingleStoreElement() {
            this.name = 'singleStore';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function ExteriorEntranceToThePublicElement() {
            this.name = 'exteriorEntranceToThePublic';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function NumberOfPeopleElement() {
            this.name = 'numberOfPeople';
            this.controlType = 'intNumberType';
            this.value = '';
        }

        function PoolSizeElement() {
            this.name = 'poolSize';
            this.controlType = 'poolSizeType';
            this.value = '';
        }

        function PoolLocationElement() {
            this.name = 'poolLocation';
            this.controlType = 'poolType';
            this.value = '';
        }

        function AverageInfluentBiologicalOxygenDemandElement() {
            this.name = 'averageInfluentBiologicalOxygenDemand';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function AverageEffluentBiologicalOxygenDemandElement() {
            this.name = 'averageEffluentBiologicalOxygenDemand';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function PlantDesignFlowRateElement() {
            this.name = 'plantDesignFlowRate';
            this.controlType = 'plantDesignFlowRateType';
            this.value = '';
            this.units = '';
        }

        function FixedFilmTrickleFiltrationProcessElement() {
            this.name = 'fixedFilmTrickleFiltrationProcess';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function NutrientRemovalElement() {
            this.name = 'nutrientRemoval';
            this.controlType = 'yesNoType';
            this.value = '';
        }

        function SeatingCapacityElement() {
            this.name = 'seatingCapacity';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfWeekdaysOpenElement() {
            this.name = 'numberOfWeekdaysOpen';
            this.controlType = 'numberOfWeekdaysType';
            this.value = '';
        }

        function MonthsMainIndoorIceRinkInUseElement() {
            this.name = 'monthsMainIndoorIceRinkInUse';
            this.controlType = 'useDecimalType';
            this.value = '';
        }

        function NumberOfWeeklyIceResurfacingForAllRinksElement() {
            this.name = 'numberOfWeeklyIceResurfacingForAllRinks';
            this.controlType = 'intNumberType';
            this.value = '';
        }

        function NumberOfIndoorIceRinksElement() {
            this.name = 'numberOfIndoorIceRinks';
            this.controlType = 'intNumberType';
            this.value = '';
        }

        function NumberOfCurlingSheetsElement() {
            this.name = 'numberOfCurlingSheets';
            this.controlType = 'intNumberType';
            this.value = '';
        }

        function TotalIceRinkSurfaceAreaForAllRinksElement() {
            this.name = 'totalIceRinkSurfaceAreaForAllRinks';
            this.controlType = 'grossFloorAreaType';
            this.value = '';
        }

        function SpectatorSeatingCapacityElement() {
            this.name = 'spectatorSeatingCapacity';
            this.controlType = 'intNumberType';
            this.value = '';
        }

        // ReSharper restore InconsistentNaming

        var adultEducationFields = new OtherProperty();

        var ambulatorySurgicalCenterFields = new OtherProperty();

        var aquariumFields = new OtherProperty();

        var automobileDealershipFields = new OtherProperty();

        var bankBranchFields = new OtherProperty();
        bankBranchFields.fieldsList.push(new HeatingElement());
        bankBranchFields.fieldsList.push(new CoolingElement());

        var barNightclubFields = new OtherProperty();

        var barracksFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new HasComputerLabElement(),
                new HasDiningHallElement(),
                new NumberOfRoomsElement(),
                new HeatingPercentElement(),
                new CoolingPercentElement()]
        }
        
        var bowlingAlleyFields = new OtherProperty();

        var casinoFields = new OtherProperty();

        var collegeUniversityFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new WeeklyOperatingHours(),
                new NumberOfComputers(),
                new EnrollmentElement(),
                new GrantDollarsElement(),
                new NumberOfFteWorkersElement()]
        }
        
        var convenienceStoreWithGasStationFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new WeeklyOperatingHours(),
                new NumberOfWorkers(),
                new NumberOfComputers(),
                new CookingFacilitiesElement(),
                new NumberOfWalkInRefrigerationUnitsElement(),
                new NumberOfOpenClosedRefrigerationUnitsElement(),
                new NumberOfCashRegistersElement(),
                new HeatingPercentElement(),
                new CoolingPercentElement(),
                new AreaOfAllWalkInRefrigerationUnitsElement(),
                new LengthOfAllOpenClosedRefrigerationUnitsElement()]
        }
        
        var convenienceStoreWithoutGasStationFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new WeeklyOperatingHours(),
                new NumberOfWorkers(),
                new NumberOfComputers(),
                new CookingFacilitiesElement(),
                new NumberOfWalkInRefrigerationUnitsElement(),
                new NumberOfOpenClosedRefrigerationUnitsElement(),
                new NumberOfCashRegistersElement(),
                new HeatingPercentElement(),
                new CoolingPercentElement(),
                new AreaOfAllWalkInRefrigerationUnitsElement(),
                new LengthOfAllOpenClosedRefrigerationUnitsElement()]
        }
        
        var conventionCenterFields = new OtherProperty();

        var courthouseFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new WeeklyOperatingHours(),
                new NumberOfWorkers(),
                new NumberOfComputers(),
                new HeatingElement(),
                new CoolingElement()]
        }
        
        var dataCenterFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new CoolingEquipmentRedundancyElement(),
                new ItEnergyConfigurationElement(),
                new UpsSystemRedundancyElement()]
        }
        
        var distributionCenterFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new WeeklyOperatingHours(),
                new NumberOfWorkers(),
                new NumberOfWalkInRefrigerationUnitsElement(),
                new HeatingPercentElement(),
                new CoolingPercentElement()]
        }
                                                         
        var drinkingWaterTreatmentDistributionFields = {
            fieldsList: [ new TotalGrossFloorArea() ]
        }

        var enclosedMallFields = new OtherProperty();

        var energyPowerStationFields = new OtherProperty();

        var fastFoodRestaurantFields = new OtherProperty();

        var financialOfficeFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new WeeklyOperatingHours(),
                new NumberOfWorkers(),
                new NumberOfComputers(),
                new HeatingElement(),
                new CoolingElement()]
        }
        
        var fireStationFields = new OtherProperty();

        var fitnessCenterHealthClubGymFields = new OtherProperty();

        var foodSalesFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new WeeklyOperatingHours(),
                new NumberOfWorkers(),
                new NumberOfComputers(),
                new CookingFacilitiesElement(),
                new NumberOfWalkInRefrigerationUnitsElement(),
                new NumberOfOpenClosedRefrigerationUnitsElement(),
                new NumberOfCashRegistersElement(),
                new CoolingPercentElement(),
                new HeatingPercentElement(),
                new AreaOfAllWalkInRefrigerationUnitsElement(),
                new LengthOfAllOpenClosedRefrigerationUnitsElement()]
        }
        
        var foodServiceFields = new OtherProperty();

        var hospitalGeneralMedicalSurgicalFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new HasLaboratoryElement(),
                new OnSiteLaundryFacilityElement(),
                new MaximumNumberOfFloorsElement(),
                new NumberOfStaffedBedsElement(),
                new NumberOfFteWorkersElement(),
                new NumberOfMriMachinesElement(),
                new ownedByElement(),
                new IsTertiaryCareElement(),
                new LicensedBedCapacityElement(),
                new NumberOfWorkers(),
                new CoolingPercentElement(),
                new HeatingPercentElement()]
        }
        
        var hotelFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new FullServiceSpaFloorAreaElement(),
                new GymCenterFloorAreaAreaElement(),
                new HoursPerDayGuestsOnsiteElement(),
                new NumberOfCommercialRefrigerationUnitsElement(),
                new NumberOfGuestMealsServedPerYearElement(),
                new NumberOfHotelRoomsElement(),
                new LaundryFacilityElement(),
                new CoolingPercentElement(),
                new HeatingPercentElement(),
                new CookingFacilitiesElement(),
                new AmountOfLaundryProcessedAnnuallyElement(),
                new NumberOfWorkers()]
        }
        
        var iceCurlingRinkFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new NumberOfIndoorIceRinksElement(),
                new TotalIceRinkSurfaceAreaForAllRinksElement(),
                new MonthsMainIndoorIceRinkInUseElement(),
                new NumberOfWeeklyIceResurfacingForAllRinksElement(),
                new NumberOfFteWorkersElement(),
                new SpectatorSeatingCapacityElement()]
        }

        var indoorArenaFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new EnclosedFloorAreaElement(),
                new NumberOfSportingEventsPerYearElement(),
                new NumberOfConcertShowEventsPerYearElement(),
                new NumberOfSpecialOtherEventsPerYearElement(),
                new SizeOfElectronicScoreBoardsElement(),
                new IceEventsElement(),
                new NumberOfComputers(),
                new NumberOfWalkInRefrigerationUnitsElement(),
                new CoolingPercentElement(),
                new HeatingPercentElement()]
        }
        
        var k12SchoolFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new OpenOnWeekendsElement(),
                new NumberOfWalkInRefrigerationUnitsElement(),
                new CoolingPercentElement(),
                new HeatingPercentElement(),
                new NumberOfComputers(),
                new CookingFacilitiesElement(),
                new IsHighSchoolElement(),
                new MonthsInUseElement(),
                new SchoolDistrictElement(),
                new StudentSeatingCapacityElement(),
                new NumberOfWorkers(),
                new GymnasiumFloorAreaElement()]
        }
        
        var laboratoryFields = new OtherProperty();

        var libraryFields = new OtherProperty();

        var lifestyleCenterFields = new OtherProperty();

        var mailingCenterPostOfficeFields = new OtherProperty();

        var manufacturingIndustrialPlantFields = new OtherProperty();

        var medicalOfficeFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new NumberOfWorkers(),
                new CoolingPercentElement(),
                new HeatingPercentElement(),
                new WeeklyOperatingHours(),
                new NumberOfSurgicalOperatingBedsElement(),
                new SurgeryCenterFloorAreaElement(),
                new NumberOfMriMachinesElement()]
        }
                                                    
        var movieTheaterFields = new OtherProperty();

        var multifamilyHousingFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new NumberOfResidentialLivingUnitsElement(),
                new NumberOfResidentialLivingUnitsLowRiseSettingElement(),
                new NumberOfResidentialLivingUnitsMidRiseSettingElement(),
                new NumberOfResidentialLivingUnitsHighRiseSettingElement(),
                new NumberOfBedroomsElement(),
                new NumberOfLaundryHookupsInAllUnitsElement(),
                new NumberOfLaundryHookupsInCommonAreaElement(),
                new HeatingPercentElement(),
                new CoolingPercentElement(),
                new ResidentPopulationElement(),
                new GovernmentSubsidizedHousingElement()]
        }
                
        var museumFields = new OtherProperty();

        var nonRefrigeratedWarehouseFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new NumberOfWorkers(),
                new WeeklyOperatingHours(),
                new CoolingPercentElement(),
                new HeatingPercentElement(),
                new NumberOfWalkInRefrigerationUnitsElement()]
        }

        var officeFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new NumberOfWorkers(),
                new NumberOfComputers(),
                new CoolingElement(),
                new HeatingElement(),
                new WeeklyOperatingHours()
            ]
        }

        var otherFields = new OtherProperty();

        var otherEducationFields = new OtherProperty();

        var otherEntertainmentPublicAssemblyFields = new OtherProperty();

        var otherLodgingResidentialFields = new OtherProperty();

        var otherMallFields = new OtherProperty();

        var otherPublicServicesFields = new OtherProperty();

        var otherRecreationFields = new OtherProperty();

        var otherRestaurantBarFields = new OtherProperty();

        var otherServicesFields = new OtherProperty();

        var otherStadiumFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new EnclosedFloorAreaElement(),
                new NumberOfSportingEventsPerYearElement(),
                new NumberOfConcertShowEventsPerYearElement(),
                new NumberOfSpecialOtherEventsPerYearElement(),
                new SizeOfElectronicScoreBoardsElement(),
                new IceEventsElement(),
                new NumberOfComputers(),
                new NumberOfWalkInRefrigerationUnitsElement(),
                new CoolingPercentElement(),
                new HeatingPercentElement()
            ]
        }

        var otherTechnologyScienceFields = new OtherProperty();

        var otherUtilityFields = new OtherProperty();

        var otherSpecialityHospitalFields = new OtherProperty();

        var outpatientRehabilitationPhysicalTherapyFields = new OtherProperty();

        var parkingFields = {
            fieldsList: [
                new SupplementalHeatingElement(),
                new OpenFootageElement(),
                new CompletelyEnclosedFootageElement(),
                new PartiallyEnclosedFootageElement()
            ]
        }

        var performingArtsFields = new OtherProperty();

        var personalServicesHealthBeautyDryCleaningFields = new OtherProperty();

        var policeStationFields = new OtherProperty();

        var preSchoolDaycareFields = new OtherProperty();

        var prisonIncarcerationFields = new OtherProperty();

        var raceTrackFields = new OtherProperty();

        var refrigeratedWarehouseFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new NumberOfWorkers(),
                new WeeklyOperatingHours()
            ]
        }

        var repairServicesVehicleShoeLocksmithFields = new OtherProperty();

        var residentialCareFacilityFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new NumberOfResidentialLivingUnitsElement(),
                new AverageNumberOfResidentsElement(),
                new MaximumResidentCapacityElement(),
                new NumberOfWorkers(),
                new NumberOfComputers(),
                new NumberOfCommercialRefrigerationUnitsElement(),
                new NumberOfCommercialWashingMachinesElement(),
                new NumberOfResidentialLiftSystemsElement(),
                new CoolingPercentElement(),
                new HeatingPercentElement(),
                new LicensedBedCapacityElement()
            ]
        }

        var residenceHallDormitoryFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new NumberOfRoomsElement(),
                new HeatingPercentElement(),
                new CoolingPercentElement(),
                new HasComputerLabElement(),
                new HasDiningHallElement()
            ]
        }

        var restaurantFields = new OtherProperty();

        var retailStoreFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new WeeklyOperatingHours(),
                new NumberOfWorkers(),
                new NumberOfComputers(),
                new NumberOfCashRegistersElement(),
                new NumberOfWalkInRefrigerationUnitsElement(),
                new NumberOfOpenClosedRefrigerationUnitsElement(),
                new CoolingPercentElement(),
                new HeatingPercentElement(),
                new SingleStoreElement(),
                new ExteriorEntranceToThePublicElement(),
                new AreaOfAllWalkInRefrigerationUnitsElement(),
                new LengthOfAllOpenClosedRefrigerationUnitsElement(),
                new CookingFacilitiesElement()
            ]
        }

        var rollerRinkFields = new OtherProperty();

        var selfStorageFacilityFields = new OtherProperty();

        var seniorCareCommunityFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new NumberOfResidentialLivingUnitsElement(),
                new AverageNumberOfResidentsElement(),
                new MaximumResidentCapacityElement(),
                new NumberOfWorkers(),
                new NumberOfComputers(),
                new NumberOfCommercialRefrigerationUnitsElement(),
                new NumberOfCommercialWashingMachinesElement(),
                new NumberOfResidentialWashingMachinesElement(),
                new NumberOfResidentialLiftSystemsElement(),
                new CoolingPercentElement(),
                new HeatingPercentElement(),
                new LicensedBedCapacityElement()
            ]
        }

        var singleFamilyHomeFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new NumberOfBedroomsElement(),
                new NumberOfPeopleElement()
            ]
        }

        var socialMeetingHallFields = new OtherProperty();

        var stadiumClosedFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new EnclosedFloorAreaElement(),
                new NumberOfSportingEventsPerYearElement(),
                new NumberOfConcertShowEventsPerYearElement(),
                new NumberOfSpecialOtherEventsPerYearElement(),
                new SizeOfElectronicScoreBoardsElement(),
                new IceEventsElement(),
                new NumberOfComputers(),
                new NumberOfWalkInRefrigerationUnitsElement(),
                new CoolingPercentElement(),
                new HeatingPercentElement()
            ]
        }

        var stadiumOpenFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new EnclosedFloorAreaElement(),
                new NumberOfSportingEventsPerYearElement(),
                new NumberOfConcertShowEventsPerYearElement(),
                new NumberOfSpecialOtherEventsPerYearElement(),
                new SizeOfElectronicScoreBoardsElement(),
                new IceEventsElement(),
                new NumberOfComputers(),
                new NumberOfWalkInRefrigerationUnitsElement(),
                new CoolingPercentElement(),
                new HeatingPercentElement()
            ]
        }

        var stripMallFields = new OtherProperty();

        var supermarketGroceryStoreFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new WeeklyOperatingHours(),
                new NumberOfWorkers(),
                new NumberOfComputers(),
                new CookingFacilitiesElement(),
                new NumberOfWalkInRefrigerationUnitsElement(),
                new NumberOfOpenClosedRefrigerationUnitsElement(),
                new NumberOfCashRegistersElement(),
                new CoolingPercentElement(),
                new HeatingPercentElement(),
                new AreaOfAllWalkInRefrigerationUnitsElement(),
                new LengthOfAllOpenClosedRefrigerationUnitsElement()
            ]
        }

        var swimmingPoolFields = {
            fieldsList: [
                new PoolSizeElement(),
                new PoolLocationElement(),
                new MonthsInUseElement
            ]
        }

        var transportationTerminalStationFields = new OtherProperty();

        var urgentCareClinicOtherOutpatientFields = new OtherProperty();

        var veterinaryOfficeFields = new OtherProperty();

        var vocationalSchoolFields = new OtherProperty();

        var wastewaterTreatmentPlantFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new AverageInfluentBiologicalOxygenDemandElement(),
                new AverageEffluentBiologicalOxygenDemandElement(),
                new PlantDesignFlowRateElement(),
                new FixedFilmTrickleFiltrationProcessElement(),
                new NutrientRemovalElement()
            ]
        }

        var wholesaleClubSupercenterFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new ExteriorEntranceToThePublicElement(),
                new WeeklyOperatingHours(),
                new NumberOfWorkers(),
                new NumberOfCashRegistersElement(),
                new NumberOfComputers(),
                new NumberOfOpenClosedRefrigerationUnitsElement(),
                new NumberOfWalkInRefrigerationUnitsElement(),
                new HeatingPercentElement(),
                new CoolingPercentElement(),
                new SingleStoreElement(),
                new AreaOfAllWalkInRefrigerationUnitsElement(),
                new LengthOfAllOpenClosedRefrigerationUnitsElement(),
                new CookingFacilitiesElement()
            ]
        }

        var worshipFacilityFields = {
            fieldsList: [
                new TotalGrossFloorArea(),
                new WeeklyOperatingHours(),
                new NumberOfCommercialRefrigerationUnitsElement(),
                new NumberOfComputers(),
                new CookingFacilitiesElement(),
                new SeatingCapacityElement(),
                new NumberOfWeekdaysOpenElement()
            ]
        }

        var zooFields = new OtherProperty();

        function getPropertyFieldsSettings() {
            var propertyFieldSettings = {
                "1": adultEducationFields,
                "2": ambulatorySurgicalCenterFields,
                "3": aquariumFields,
                "4": automobileDealershipFields,
                "5": bankBranchFields,
                "6": barNightclubFields,
                "7": barracksFields,
                "8": bowlingAlleyFields,
                "9": casinoFields,
                "10": collegeUniversityFields,
                "11": convenienceStoreWithGasStationFields,
                "12": convenienceStoreWithoutGasStationFields,
                "13": conventionCenterFields,
                "14": courthouseFields,
                "15": dataCenterFields,
                "16": distributionCenterFields,
                "17": drinkingWaterTreatmentDistributionFields,
                "18": enclosedMallFields,
                "19": energyPowerStationFields,
                "20": fastFoodRestaurantFields,
                "21": financialOfficeFields,
                "22": fireStationFields,
                "23": fitnessCenterHealthClubGymFields,
                "24": foodSalesFields,
                "25": foodServiceFields,
                "26": hospitalGeneralMedicalSurgicalFields,
                "27": hotelFields,
                "28": iceCurlingRinkFields,
                "29": indoorArenaFields,
                "30": k12SchoolFields,
                "31": laboratoryFields,
                "32": libraryFields,
                "33": lifestyleCenterFields,
                "34": mailingCenterPostOfficeFields,
                "35": manufacturingIndustrialPlantFields,
                "36": otherFields, // TODO: understand what to put here
                "37": medicalOfficeFields,
                "38": movieTheaterFields,
                "39": multifamilyHousingFields,
                "40": museumFields,
                "41": nonRefrigeratedWarehouseFields,
                "42": officeFields,
                "43": otherFields,
                "44": otherEducationFields,
                "45": otherEntertainmentPublicAssemblyFields,
                "46": otherLodgingResidentialFields,
                "47": otherMallFields,
                "48": otherPublicServicesFields,
                "49": otherRecreationFields,
                "50": otherRestaurantBarFields,
                "51": otherServicesFields,
                "52": otherStadiumFields,
                "53": otherTechnologyScienceFields,
                "54": otherUtilityFields,
                "55": otherSpecialityHospitalFields,
                "56": outpatientRehabilitationPhysicalTherapyFields,
                "57": parkingFields,
                "58": performingArtsFields,
                "59": personalServicesHealthBeautyDryCleaningFields,
                "60": policeStationFields,
                "61": preSchoolDaycareFields,
                "62": prisonIncarcerationFields,
                "63": raceTrackFields,
                "64": refrigeratedWarehouseFields,
                "65": repairServicesVehicleShoeLocksmithFields,
                "66": residentialCareFacilityFields,
                "67": residenceHallDormitoryFields,
                "68": restaurantFields,
                "69": retailStoreFields,
                "70": rollerRinkFields,
                "71": selfStorageFacilityFields,
                "72": seniorCareCommunityFields,
                "73": singleFamilyHomeFields,
                "74": socialMeetingHallFields,
                "75": stadiumClosedFields,
                "76": stadiumOpenFields,
                "77": stripMallFields,
                "78": supermarketGroceryStoreFields,
                "79": swimmingPoolFields,
                "80": transportationTerminalStationFields,
                "81": urgentCareClinicOtherOutpatientFields,
                "82": veterinaryOfficeFields,
                "83": vocationalSchoolFields,
                "84": wastewaterTreatmentPlantFields,
                "85": wholesaleClubSupercenterFields,
                "86": worshipFacilityFields,
                "87": zooFields
            }
            return propertyFieldSettings;
        }

        return {
            getPropertyTypeNames: getPropertyTypeNames,
            getPropertyFieldsSettings: getPropertyFieldsSettings,
            getFieldDescriptionByFieldName: getFieldDescriptionByFieldName,
            getFieldCaptionByFieldName: getFieldCaptionByFieldName,
            controlTypeByFieldName: controlTypeByFieldName,
            getPropertyFieldsSettings: getPropertyFieldsSettings,
            primaryPropertyFunctions: primaryPropertyFunctions
        }
});
'use strict';
angular.module('utilliApp')
    .controller('AddPropertyGroupController', ['$scope', '$rootScope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', 'GetAccountsService', '$stateParams', 'CommonHeaderService',
        'DueReminderService', 'ModalServiceExt', 'PropertyListService',
    // ReSharper disable InconsistentNaming
    function ($scope, $rootScope, $http, $timeout, $window, usSpinnerService, LeftMenuService, $state,
        GetAccountsService, $stateParams, CommonHeaderService, DueReminderService, ModalServiceExt,
        PropertyListService) {
            var _t = $scope._t;
        // ReSharper restore InconsistentNaming
        LeftMenuService.setCurrentTab('MyPropertyGroups');
        CommonHeaderService.setUpBackButton(_t('Create Group'), true);

        $scope.errors = [];

        $scope.group = {
            Properties: [
                {
                    selectId: 0,
                    Address: ''
                },
                {
                    selectId: 1,
                    Address: ''
                }
            ]
        };

        $scope.addProperty = function () {
            var ticks = new Date().getTime();
            $scope.group.Properties.push({
                selectId: ticks,
                Address: ''
            });
        }

        $scope.removeProperty = function (property) {
            if ($scope.group.Properties.length <= 2) {
                ModalServiceExt.showMessage(_t('Error'), _t('Each group should have at least two properties.'));
                return;
            }
            var index = $scope.group.Properties.findIndex(function (e) { return e.selectId === property.selectId });
            $scope.group.Properties.splice(index, 1);
        }

        $scope.cancel = function() {
            $state.goMainLayout('PropertyGroupList');
        }

        $scope.submit = function() {
            $scope.form.$submitted = true;
            if (!$scope.form.$valid) {
                return;
            }
            usSpinnerService.spin('spinner-1');
            var ids = _.map($scope.group.Properties, function (property) { return property.Id; });
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/AddPropertyGroup/',
                method: "POST",
                data: {
                    UserName: $state.params.userId,
                    Name: $scope.group.Name,
                    PropertyIds: ids
                }
            }).success(function (response) {
                utilli.handleAjaxResponse(response, ModalServiceExt,
                    function () {
                        $state.goMainLayout('PropertyGroupList');
                    });
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }

        usSpinnerService.spin('spinner-1');
        var withoutDelegated = false;
        PropertyListService.getPropertyList(withoutDelegated).success(function (response) {
            utilli.handleAjaxResponse(response, ModalServiceExt,
                function () {
                    $scope.propertyList = response.Data;
                });
            usSpinnerService.stop('spinner-1');
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });

        $scope.getAvailableProperties = function(property) {
            var availableProperties = _.reject($scope.propertyList, function (p) {
                // note: compares int Id with string Id
                // ReSharper disable CoercedEqualsUsing
                var shouldBeRejected = p.Id != property.Id && _.some($scope.group.Properties,
                    function (gp) {
                        return gp.Id == p.Id;
                    });
                return shouldBeRejected;
                // ReSharper restore CoercedEqualsUsing
            });
            return availableProperties;
        }

    }]);
'use strict';
angular.module('utilliApp')
    .controller('EditPropertyGroupController', ['$scope', '$rootScope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', 'GetAccountsService', '$stateParams',
        'CommonHeaderService', 'DueReminderService', 'ModalServiceExt', '$q', 'PropertyListService',
        'PropertyService',
    // ReSharper disable InconsistentNaming
    function ($scope, $rootScope, $http, $timeout, $window, usSpinnerService, LeftMenuService, $state,
        GetAccountsService, $stateParams, CommonHeaderService, DueReminderService, ModalServiceExt, $q,
        PropertyListService, PropertyService) {
            var _t = $scope._t;
        // ReSharper restore InconsistentNaming
        LeftMenuService.setCurrentTab('MyPropertyGroups');
        CommonHeaderService.setUpBackButton(_t('Edit Property Group'), true);

        $scope.errors = [];

        $scope.addProperty = function () {
            if (!$scope.selectedPropertyToAdd)
                return;
            $scope.group.Properties.push($scope.selectedPropertyToAdd);
        }

        $scope.cancel = function () {
            $state.goMainLayout('PropertyGroupList');
        }

        $scope.submit = function() {
            $scope.form.$submitted = true;
            if (!$scope.form.$valid) {
                return;
            }
            usSpinnerService.spin('spinner-1');
            var ids = _.map($scope.group.Properties, function (property) { return property.Id; });
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/EditPropertyGroup/',
                method: "POST",
                data: {
                    Id: $state.params.propertyGroupId,
                    Name: $scope.group.Name,
                    PropertyIds: ids,
                    userName: $state.params.userId
                }
            }).success(function (response) {
                utilli.handleAjaxResponse(response, ModalServiceExt,
                    function () {
                        ModalServiceExt.showInfo(_t('Group was successfully changed.'), function () { $state.goMainLayout('PropertyGroupList'); });
                    });
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }

        $scope.getAvailableProperties = function () {
            var availableProperties = _.reject($scope.propertyList, function (p) {
                if (!$scope.group)
                    return null;
                // note: compares int Id with string Id
                // ReSharper disable CoercedEqualsUsing
                var shouldBeRejected = _.some($scope.group.Properties,
                    function (gp) {
                        return gp.Id == p.Id;
                    });
                return shouldBeRejected;
                // ReSharper restore CoercedEqualsUsing
            });

            if (availableProperties.length > 0 && !$scope.selectedPropertyToAdd)
                $scope.selectedPropertyToAdd = availableProperties[0];
            return availableProperties;
        }

        usSpinnerService.spin('spinner-1');

        var getGroup = function() {
            return $http({
                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetPropertyGroup/',
                method: "GET",
                params: { propertyGroupId: $state.params.propertyGroupId }
            });
        }
        $q.all([PropertyListService.getPropertyList(), getGroup()]).then(function (response) {
            utilli.handleAjaxResponse(response[0].data, ModalServiceExt,
                function() {
                    PropertyListService.loadPropertyList($scope, response[0].data);
                });
            utilli.handleAjaxResponse(response[1].data, ModalServiceExt,
                function () {
                    var group = response[1].data.Data;
                    group.Properties = _.map(group.Properties,
                        function (property) {
                            var propertyFromTheList = _.find($scope.propertyList,
                                function(p) {
                                    return p.Id === property.Id;
                                });
                            propertyFromTheList.selectId = property.Id;
                            return propertyFromTheList;
                        });
                    $scope.group = group;
                });
            usSpinnerService.stop('spinner-1');
        }).catch(function() {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });

        $scope.viewProperty = function(property) {
            property.Type = utilli.aggregationTypes.property;
            localStorage.setItem('currentAggregation', JSON.stringify(property));
            PropertyService.goToDashboard(property, $state);
        }

        $scope.editProperty = function (property) {
            $state.goMainLayout('EditProperty', { id: property.Id });
        }

        $scope.deleteProperty = function (property) {
            if($scope.group.Properties.length <=2)
            {
                ModalServiceExt.showMessage(_t('Error'), _t('Each group should have at least two properties.'));    
                return;   
            }
            ModalServiceExt.showYesNoMessage(
                _t('Delete Property'),
                _t('Are you sure that you want to delete the property from the group?'),
                function() {
                    var index = $scope.group.Properties.findIndex(function (e) { return e.Id === property.Id });
                    $scope.group.Properties.splice(index, 1);
                });
        }

        $scope.why = function (property) {
            $state.goMainLayout('ReasonsForNoScore', { propertyId: property.Id });
        }

        $scope.refreshScore = function (property) {
            PropertyListService.refreshScore($scope, property);
        };
    }]);
'use strict';
angular.module('utilliApp')
    .controller('AuthorizationsController', ['$scope', '$http', 'usSpinnerService',
        'LeftMenuService', '$state', 'CommonHeaderService', 'ModalServiceExt', 'GridService',
    // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, LeftMenuService, $state, 
            CommonHeaderService, ModalServiceExt, GridService) {
            var _t = $scope._t;
            LeftMenuService.setCurrentTab('Authorizations');
            CommonHeaderService.setUpBackButton(_t('Authorizations'), true);

            $scope.authorizations = [];
            var pageSize = 20;

            var apiUrl = localStorage.getItem('ApiUrl');

            $scope.fixScore = function (score)
            {
                if (score == 0) {
                    return 'N/A';
                } else {
                    return score;
                }
            }
                        
            $scope.getAuthorizations = function () {
                if ($scope.scrollingBusy)
                    return;
                $scope.scrollingBusy = true;

                usSpinnerService.spin('spinner-1');
                var url = apiUrl + 'api/PropertyManagers/GetAuthorizationsPaged';
                $http({
                    url: url,
                    method: 'GET',
                    params: {
                        skip: $scope.authorizations.length,
                        pageSize: pageSize,
                        userName: $state.params.userId
                    }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.Errors && response.Errors.length > 0)
                    {
                        ModalServiceExt.showError(response.Errors[0]);
                        $scope.authorizationsCompleted = true;
                        return;
                    }

                    if (!response.Data || response.Data.length < pageSize) {
                        $scope.scrollingBusy = false;
                        $scope.authorizationsCompleted = true;
                    }

                    for (var i = 0; i < response.Data.length; i++) {
                        $scope.authorizations.push(response.Data[i]);
                    }

                    $scope.scrollingBusy = false;
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    $scope.authorizationsCompleted = true;
                    ModalServiceExt.showServerError();
                });
            }

            $scope.view = function (id) {
                $state.goMainLayout('Invitations', { propertyId: id });
            }

            $scope.sendInvitation = function () {
                $state.goMainLayout('SendInvitation');
            }

            $scope.exportData = function () {
                var url = apiUrl + 'api/PropertyManagers/GenerateAuthorizationsExcelData';
                usSpinnerService.spin('spinner-1');
                $http({
                    url: url,
                    method: "GET",
                    params: { userName: $state.params.userId }
                }).success(function (response) {
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showError(response.Errors[0]);
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    var url = utilli.getFileUrlWithToken(response.Data);
                    utilli.downloadFile(url, "Authorizations.xlsx");
                    usSpinnerService.stop('spinner-1');
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showError(error.Message);
                });
            }
    }]);
'use strict';
angular.module('utilliApp')
    .controller('AuthorizationsGridController', ['$scope', '$http', 'usSpinnerService', '$state', 'ModalServiceExt', 'GridService',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, $state, ModalServiceExt, GridService) {
            var _t = $scope._t;

            var gridResizeFunc = GridService.getGridResizeFunc($("#AuthorizationsGrid"));
            $(window).resize(function () {
                gridResizeFunc($scope.authorizationsKendoGrid);
            });

            var apiUrl = localStorage.getItem('ApiUrl');

            $scope.gridOptions = {
                dataSource: {
                    transport: {
                        read: function (options) {
                            var webapi = new kendo.data.transports.webapi({ prefix: "" });
                            var params = webapi.parameterMap(options.data);
                            params.userName = $state.params.userId;
                            var url = apiUrl + 'api/PropertyManagers/GetAuthorizations';
                            $http.get(url, { params: params })
                                .success(function (data) {
                                    options.success(data);
                                    gridResizeFunc($scope.authorizationsKendoGrid);
                                })
                                .error(function () {
                                    options.error();
                                });
                        }
                    },
                    schema: { data: "Data.PageData", total: "Data.Count" },
                    pageSize: 10,
                    serverPaging: true,
                    serverSorting: true
                },
                resizable: true,
                sortable: true,
                pageable: {
                    pageSize: 25,
                    pageSizes: [10, 25, 50],
                    buttonCount: 3,
                    refresh: true
                },
                dataBound: function () { gridResizeFunc($scope.authorizationsKendoGrid); },
                columns: [
                    {
                        field: "PropertyAddress",
                        title: $scope._t("Property Address"),
                        width: 250
                    }, {
                        template: kendo.template($("#total-meters-template").html()),
                        field: "TotalMeters",
                        title: $scope._t("Total Meters"),
                        width: 80
                    }, {
                        template: kendo.template($("#approved-template").html()),
                        field: "Approved",
                        title: $scope._t("Data Authorizations Approved"),
                        width: 100
                    }, {
                        template: kendo.template($("#denied-template").html()),
                        field: "Denied",
                        title: $scope._t("Data Authorizations Denied"),
                        width: 100
                    }, {
                        template: kendo.template($("#pending-template").html()),
                        field: "Pending",
                        title: $scope._t("Data Authorizations Pending"),
                        width: 100
                    }, {
                        template: kendo.template($("#energy-star-score-template").html()),
                        field: "EnergyStarScore",
                        title: $scope._t("ENERGY STAR Score"),
                        width: 100
                    }, {
                        title: $scope._t("Details"),
                        template: kendo.template($("#commands-template").html()),
                        width: "100px"
                    }
                ]
            }
        }]);
'use strict';
angular.module('utilliApp')
    .controller('InvitationsController', ['$scope', '$http', 'usSpinnerService',
        'LeftMenuService', '$state', 'CommonHeaderService', 'ModalServiceExt', '$stateParams',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, LeftMenuService, $state,
            CommonHeaderService, ModalServiceExt, $stateParams) {
            var _t = $scope._t;
            $scope.noData = true;
            LeftMenuService.setCurrentTab('Authorizations');
            CommonHeaderService.setUpBackButton(_t('Invitations'), true);


            if (!$stateParams.propertyId)
                return;

            $scope.invitations = [];
            var pageSize = 20;

            var apiUrl = localStorage.getItem('ApiUrl');

            $scope.getInvitations = function () {
                if ($scope.scrollingBusy)
                    return;
                $scope.scrollingBusy = true;

                usSpinnerService.spin('spinner-1');
                var url = apiUrl + 'api/PropertyManagers/GetInvitationsPaged';
                $http({
                    url: url,
                    method: 'GET',
                    params: {
                        propertyId: $stateParams.propertyId,
                        skip: $scope.invitations.length,
                        pageSize: pageSize,
                        userName: $state.params.userId
                    }
                }).success(function (response) {
                    $scope.scrollingBusy = false;
                    usSpinnerService.stop('spinner-1');
                    if (response.Errors && response.Errors.length > 0) {
                        $scope.invitationsCompleted = true;
                        ModalServiceExt.showError(response.Errors[0]);
                        return;
                    }

                    $scope.noData = !response.Data || response.Data.length == 0;

                    if (!response.Data || response.Data.length < pageSize) {
                        $scope.invitationsCompleted = true;
                    }

                    for (var i = 0; i < response.Data.length; i++) {
                        $scope.invitations.push(response.Data[i]);
                    }

                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    $scope.invitationsCompleted = true;
                    $scope.scrollingBusy = false;
                    ModalServiceExt.showServerError();
                });
            }

            $scope.view = function (id, meterNumber) {
                $state.goMainLayout('RecipientInvitationView', { id: id, meterNumber: meterNumber });
            }

            $scope.sendInvitation = function () {
                $state.goMainLayout('SendInvitation');
            }

            $scope.exportData = function () {
                var url = apiUrl + 'api/PropertyManagers/GenerateInvitationsExcelData';
                usSpinnerService.spin('spinner-1');
                $http({
                    url: url,
                    method: "GET",
                    params: { propertyId: $stateParams.propertyId, userName: $state.params.userId }
                }).success(function (response) {
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showError(response.Errors[0]);
                        usSpinnerService.stop('spinner-1');
                        return;
                    }

                    var url = utilli.getFileUrlWithToken(response.Data);
                    utilli.downloadFile(url, "Invitations.xlsx");
                    usSpinnerService.stop('spinner-1');
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showError(error.Message);
                });
            }

        }]);
'use strict';
angular.module('utilliApp')
    .controller('InvitationsGridController', ['$scope', '$http', 'usSpinnerService', '$state', 'ModalServiceExt', 'GridService', '$stateParams',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, $state, ModalServiceExt, GridService, $stateParams) {
            var _t = $scope._t;

            if (!$stateParams.propertyId)
                return;

            var gridResizeFunc = GridService.getGridResizeFunc($("#InvitationsGrid"));
            $(window).resize(function () {
                gridResizeFunc($scope.invitationsKendoGrid);
            });

            var apiUrl = localStorage.getItem('ApiUrl');

            $scope.gridOptions = {
                dataSource: {
                    transport: {
                        read: function (options) {
                            var webapi = new kendo.data.transports.webapi({ prefix: "" });
                            var params = webapi.parameterMap(options.data);
                            params = $.extend(params, { propertyId: $stateParams.propertyId });
                            params.userName = $state.params.userId;
                            var url = apiUrl + 'api/PropertyManagers/GetInvitationRecipients';
                            $http.get(url, { params: params })
                                .success(function (data) {
                                    options.success(data);
                                    gridResizeFunc($scope.invitationsKendoGrid);
                                })
                                .error(function () {
                                    options.error();
                                });
                        }
                    },
                    schema: { data: "Data.PageData", total: "Data.Count" },
                    pageSize: 10,
                    serverPaging: true,
                    serverSorting: true
                },
                noRecords: true,
                messages:{
                    noRecords: $scope._t("No authorizations received"),
                },
                resizable: true,
                sortable: true,
                pageable: {
                    pageSize: 25,
                    pageSizes: [10, 25, 50],
                    buttonCount: 3,
                    refresh: true
                },
                dataBound: function () { gridResizeFunc($scope.invitationsKendoGrid); },
                columns: [
                    {
                        field: "Recipient",
                        title: $scope._t("Recipient Name/ Company Name"),
                        width: 230
                    }, {
                        field: "Email",
                        title: $scope._t("Email Address"),
                        width: 140
                    }, {
                        field: "MeterNumber",
                        title: $scope._t("Meter Number"),
                        width: 90
                    }, {
                        field: "Status",
                        title: $scope._t("Status"),
                        template: "#= DisplayedStatus #",
                        width: 90
                    }, {
                        field: "InvitationDate",
                        title: $scope._t("Date of Invitation"),
                        template: "#= DisplayedInvitationDate #",
                        width: 100
                    }, {
                        field: "ResponseDate",
                        title: $scope._t("Date of Response"),
                        template: "#= DisplayedResponseDate #",
                        width: 100
                    }, {
                        title: $scope._t("Details"),
                        template: kendo.template($("#commands-template").html()),
                        width: "100px"
                    }
                ]
            }
        }]);
'use strict';
angular.module('utilliApp')
    .controller('RecipientInvitationViewController', ['$scope', '$http', 'usSpinnerService',
        'LeftMenuService', '$state', 'CommonHeaderService', 'ModalServiceExt', '$stateParams', '$window',
        '$timeout',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, LeftMenuService, $state,
            CommonHeaderService, ModalServiceExt, $stateParams, $window, $timeout) {
            var _t = $scope._t;

            LeftMenuService.setCurrentTab('Authorizations');
            CommonHeaderService.setUpBackButton(_t('Invitation Details'), true);
            $scope.emailPattern = Config.emailPattern;

            initPage();

            function initPage() {
                var apiUrl = localStorage.getItem('ApiUrl');
                usSpinnerService.spin('spinner-1');
                $http({
                    url: apiUrl + 'api/PropertyManagers/GetRecipientInvitationDetails',
                    method: 'GET',
                    params: { id: $stateParams.id, meterNumber: $stateParams.meterNumber }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showError(response.Errors[0]);
                        return;
                    }
    
                    $scope.recipientInvitation = response.Data;
                    $scope.initRecipientInvitationData = {
                        Email: response.Data.Email,
                        Recipient:  response.Data.Recipient
                    };
                    
                    $scope.isPending = $scope.recipientInvitation.DisplayedStatus == "Pending";
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            $scope.saveChanges = function () {
                if(!$scope.editInvitationForm.$valid) {
                    return;
                }

                var hasChanges = $scope.initRecipientInvitationData.Email != $scope.recipientInvitation.Email 
                    || $scope.initRecipientInvitationData.Recipient != $scope.recipientInvitation.Recipient;
                if(!hasChanges)
                    return;


                var apiUrl = localStorage.getItem('ApiUrl');
                usSpinnerService.spin('spinner-1');
                $http({
                    url: apiUrl + 'api/PropertyManagers/EditRecipientInvitationDetails',
                    method: 'POST',
                    params: { 
                        id: $stateParams.id, 
                        recipientEmail: $scope.recipientInvitation.Email, 
                        recipientName: $scope.recipientInvitation.Recipient 
                    }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.Errors && response.Errors.length > 0) {
                        $scope.recipientInvitation.Email = $scope.initRecipientInvitationData.Email;
                        $scope.recipientInvitation.Recipient = $scope.initRecipientInvitationData.Recipient;
                        ModalServiceExt.showError(response.Errors[0]);
                        return;
                    }
                    $scope.initRecipientInvitationData.Email = $scope.recipientInvitation.Email;
                    $scope.initRecipientInvitationData.Recipient = $scope.recipientInvitation.Recipient;
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }
            
            $scope.setFocus = function (elSelector) {
                $timeout(function () {
                    var age = $window.document.getElementById(elSelector);
                    age.focus();
                });
                return true;
            };


            $scope.back = function () {
                $window.history.back();
            }

            $scope.getStatusClass = function () {
                if (!$scope.recipientInvitation)
                    return '';

                if ($scope.recipientInvitation.Status === 0)
                    return "blue-status";
                if ($scope.recipientInvitation.Status === 1)
                    return "green-status";
                if ($scope.recipientInvitation.Status === 2)
                    return "red-status";

                return '';
            }

            $scope.resend = function () {
                usSpinnerService.spin('spinner-1');
                var url = localStorage.getItem('ApiUrl') + 'api/PropertyManagers/ResendRecipientInvitation';
                $http({
                    url: url,
                    method: 'POST',
                    data: { '': $scope.recipientInvitation.Id },
                    params: { userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.Errors && response.Errors.length > 0)
                    {
                        ModalServiceExt.showError(response.Errors[0]);
                        return;
                    }

                    ModalServiceExt.showInfo("Invitation was successfully sent.");
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }
        }]);
'use strict';
angular.module('utilliApp')
    .controller('MeterDoesNotExistController', ['$rootScope', '$scope', 'usSpinnerService', 'LeftMenuService',
        '$state', '$stateParams', 'CommonHeaderService', 'ModalServiceExt', 'OpenFileService', '$window', 'SharedMetersCacheService', 'ServiceProvidersService',
// ReSharper disable InconsistentNaming
        function ($rootScope, $scope, usSpinnerService, LeftMenuService, $state, $stateParams, CommonHeaderService,
            ModalServiceExt, OpenFileService, $window, SharedMetersCacheService, ServiceProvidersService) {

            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Meter Validation Error'));
            $scope.helpEmail = utilli.getHelpEmail();
            $scope.supportPhoneNumber = utilli.getSupportPhoneNumber();

            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getCurrentProvider().then(
                function (providerData) {
                    usSpinnerService.stop('spinner-1');
                    $scope.provider = providerData;
                },
                function () {
                    ModalServiceExt.showServerError();
                    usSpinnerService.stop('spinner-1');
                });

            $scope.viewUnderstandYourBill = function () {
                OpenFileService.openUnderstandBillFile($scope.provider.ApiUrl);
            }

            $scope.close = function () {
                if (utilli.isAuthorized()) {
                    if ($stateParams.from) {
                        $state.goMainLayout(
                            $stateParams.from,
                            {
                                id: $stateParams.propertyId,
                                mode: $stateParams.mode,
                                stepsCount: $stateParams.stepsCount,
                                step: $stateParams.step,
                                topMeter: $stateParams.meterId
                            })
                    }
                    else
                        $window.history.back();
                }
                else
                    $state.go('TopMenuLayout.SendDataSharingInvitation', { useCachedMeters: true, token: $stateParams.token });
            }
        }]);

'use strict';
angular.module('utilliApp')
    .controller('MeterDuplicatedController', ['$scope', 'usSpinnerService', 'LeftMenuService', '$state',
        '$stateParams', 'CommonHeaderService', '$window',
// ReSharper disable InconsistentNaming
        function ($scope, usSpinnerService, LeftMenuService, $state, $stateParams, CommonHeaderService, $window) {
// ReSharper restore InconsistentNaming
            var _t = $scope._t;
            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Meter Validation Error'));
            $scope.helpEmail = utilli.getHelpEmail();
            $scope.supportPhoneNumber = utilli.getSupportPhoneNumber();

            var goBack = function () {
                if (utilli.isAuthorized()) {
                    if ($stateParams.from) {
                        $state.goMainLayout(
                            $stateParams.from,
                            {
                                id: $stateParams.propertyId,
                                mode: $stateParams.mode,
                                stepsCount: $stateParams.stepsCount,
                                step: $stateParams.step,
                                topMeter: $stateParams.meterId
                            })
                    }
                    else {
                        $window.history.back();
                    }
                }
                else
                    $state.go('TopMenuLayout.SendDataSharingInvitation', { useCachedMeters: true, token: $stateParams.token });
            }

            $scope.close = function () {
                goBack();
            }

            $scope.claim = function () {
                if (utilli.isAuthorized())
                    $state.goMainLayout('ClaimMeter', { propertyId: $stateParams.propertyId, meterId: $stateParams.meterId, mode: $stateParams.mode });
                else
                    $state.go('TopMenuLayout.ClaimMeter', { meterId: $stateParams.meterId, token: $stateParams.token });
            }
        }]);

'use strict';
angular.module('utilliApp')
    .controller('ServiceAddressMismatchesController', ['$scope', 'usSpinnerService', 'LeftMenuService', '$http',
        '$state', '$stateParams', 'CommonHeaderService', 'ModalServiceExt', '$window', 'ServiceProvidersService',
// ReSharper disable InconsistentNaming
        function ($scope, usSpinnerService, LeftMenuService, $http, $state, $stateParams, CommonHeaderService,
            ModalServiceExt, $window, ServiceProvidersService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Meter Validation Error'));
            $scope.helpEmail = utilli.getHelpEmail();
            $scope.supportPhoneNumber = utilli.getSupportPhoneNumber();

            var apiUrl = localStorage.getItem('ApiUrl');
            if (utilli.checkDefinedValue(apiUrl)) {
                usSpinnerService.spin('spinner-1');
                getServiceAddress();
            } else {
                usSpinnerService.spin('spinner-1');
                ServiceProvidersService.getCurrentProvider().then(
                    function (providerData) {
                        apiUrl = providerData.ApiUrl;
                        getServiceAddress();
                    },
                    function () {
                        ModalServiceExt.showServerError();
                        usSpinnerService.stop('spinner-1');
                    });
            }

            function getServiceAddress() {
                $http({
                    method: "GET",
                    url: apiUrl + 'api/PropertyManagers/GetMeterMismatchedAddresses/',
                    params: { meterId: $stateParams.meterId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showServerError();
                        return;
                    }

                    $scope.response = response.Data;
                    // ReSharper disable once UndeclaredGlobalVariableUsing
                    $scope.addresses = _.map(response.Data, function (address) {
                        return address.HouseNumber + ' ' + address.Street + ', ' + address.City + ', ' + address.State
                            + ', ' + address.Zip;
                    });

                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            $scope.addressChecked = function (index) {
                $scope.currentAddress = $scope.response[index];
                $scope.currentAddressIndex = index;
            }

            $scope.close = function () {
                goBack();
            }

            $scope.confirm = function () {
                usSpinnerService.spin('spinner-1');
                $http({
                    method: 'POST',
                    url: apiUrl + 'api/PropertyManagers/SaveConfirmedMeter/',
                    data: { 'MeterId': $stateParams.meterId, Address: $scope.currentAddress }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showServerError();
                        return;
                    }

                    //SharedMetersCacheService.deleteMeter($stateParams.meterId);
                    goBack();
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            function goBack() {
                if (utilli.isAuthorized()) {
                    if ($stateParams.from) {
                        $state.goMainLayout(
                            $stateParams.from,
                            {
                                id: $stateParams.propertyId,
                                mode: $stateParams.mode,
                                stepsCount: $stateParams.stepsCount,
                                step: $stateParams.step,
                                topMeter: $stateParams.meterId
                            })
                    }
                    else {
                        $window.history.back();
                    }
                }
                else
                    $state.go('TopMenuLayout.SendDataSharingInvitation', { useCachedMeters: true, token: $stateParams.token });
            }
        }]);

'use strict';
angular.module('utilliApp')
    .controller('ClaimMeterController', ['$scope', 'usSpinnerService', 'LeftMenuService', '$state', '$stateParams',
        '$http', 'CommonHeaderService', 'ModalServiceExt', 'OpenFileService', '$window', 'ServiceProvidersService',
// ReSharper disable InconsistentNaming
        function ($scope, usSpinnerService, LeftMenuService, $state, $stateParams, $http, CommonHeaderService,
            ModalServiceExt, OpenFileService, $window, ServiceProvidersService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Claim Meter'));

            $scope.accountMaxLength = Config.contractAccountMaxLength;

            var apiUrl = localStorage.getItem('ApiUrl');

            if (!utilli.checkDefinedValue(apiUrl)) {
                usSpinnerService.spin('spinner-1');
                ServiceProvidersService.getCurrentProvider().then(
                    function (providerData) {
                        usSpinnerService.stop('spinner-1');
                        apiUrl = providerData.ApiUrl;
                    },
                    function () {
                        ModalServiceExt.showError(utilli.errors.serverErrorMessage);
                        usSpinnerService.stop('spinner-1');
                    });
            }

            $scope.viewUnderstandYourBill = function () {
                OpenFileService.openUnderstandBillFile(apiUrl);
            }

            var goBack = function () {
                if (utilli.isAuthorized()) {
                    // history.back() doesn't accept parameters https://stackoverflow.com/a/32083943/292787
                    // $window.history.back(-2); 
                    $window.history.go(-2); //AddProperty.FailedMeters or SendDataSharingInvitation page
                } else {
                    $state.go('TopMenuLayout.SendDataSharingInvitation',
                        { useCachedMeters: true, token: $stateParams.token });
                }
            }

            $scope.close = function () {
                goBack();
            }

            $scope.change = function() {
                var split = $scope.accountNumber.split(/[,\s]/);
                split = _.map(split, function (x) { return x.trim(); });
                split = _.filter(split, function (x) { return x !== ''; });

                if (split.length === 3) {
                    $scope.accountNumber = split[0];
                    $scope.zip = split[1];
                    $scope.invoiceNumber = split[2];
                }
            }

            $scope.claim = function () {
                $scope.submitted = true;
                if (!$scope.claimMeterForm.$valid)
                    return;
                
                var recipientId;
                if ($stateParams.token) {
                    var payload = utilli.getPayload($stateParams.token);
                    recipientId = payload.RecipientId;
                }

                usSpinnerService.spin('spinner-1');
                $http({
                    method: 'POST',
                    url: apiUrl + 'api/PropertyManagers/ClaimMeter/',
                    data: {
                        MeterId: $stateParams.meterId,
                        AccountNumber: $scope.accountNumber,
                        Zip: $scope.zip,
                        RecipientId: recipientId
                    },
                    params: { userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    utilli.handleAjaxResponse(response, ModalServiceExt, function() {
                        if (response.Data) {
                            ModalServiceExt.showInfo(
                                _t('The meter has been added to your property.'),
                                function() {
                                    goBack();
                                });
                        } else {
                            ModalServiceExt.showMessage(
                                _t('Oops!'),
                                //_t('The information you gave me doesn\'t match my records, so I can\'t add the meter right now. I\'ve sent your request to a human for futher review. You can always check the status of your request by visiting the "Authorizations" page.'));
                                _t('The information you gave me doesn\'t match my records, so I can\'t add the meter right now. Please confirm your details, or contact aggregateddata@wgl.com if you need assistance.'));
                        }
                    });

                   
                }).error(function () {
                    usSpinnerService.spin('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }
        }]);

'use strict';
angular.module('utilliApp')
    .controller('MeterIsUsedController', ['$scope', 'usSpinnerService', 'LeftMenuService',
        '$state', '$stateParams', 'CommonHeaderService', 'ServiceProvidersService', 'ModalServiceExt',
        '$window', '$http',
        // ReSharper disable InconsistentNaming
        function ($scope, usSpinnerService, LeftMenuService, $state, $stateParams,
            CommonHeaderService, ServiceProvidersService, ModalServiceExt,
            $window, $http) {
            var _t = $scope._t;
            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Meter Validation Error'));
            $scope.helpEmail = utilli.getHelpEmail();
            $scope.supportPhoneNumber = utilli.getSupportPhoneNumber();

            $scope.close = function () {
                if ($stateParams.from) {
                    $state.goMainLayout(
                        $stateParams.from,
                        {
                            id: $stateParams.propertyId,
                            mode: $stateParams.mode,
                            stepsCount: $stateParams.stepsCount,
                            step: $stateParams.step,
                            topMeter: $stateParams.meterId
                        })
                }
                else {
                    $window.history.back();
                }
            }

            $scope.goEditProperty = function (property) {
                $state.goMainLayout("EditProperty", { id: property.Id });
            }

            ServiceProvidersService.getCurrentProvider().then(
                function (providerData) {
                    $scope.provider = providerData;

                    $http({
                        method: "GET",
                        url: $scope.provider.ApiUrl + 'api/PropertyManagers/FindPropertyWithThisMeter/',
                        params: {
                            propertyId: $stateParams.propertyId,
                            meterId: $stateParams.meterId
                        }
                    }).success(function (response) {
                        usSpinnerService.stop('spinner-1');
                        utilli.handleAjaxResponse(response,
                            ModalServiceExt,
                            function () {
                                $scope.propertiesWithTheSameMeter = response.Data;
                            });
                    }).error(function () {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                    });
                },
                function () {
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                    usSpinnerService.stop('spinner-1');
                });

        }]);

'use strict';
angular.module('utilliApp')
    .controller('MultipleTiedMetersController', ['$scope', 'usSpinnerService', 'LeftMenuService', 'ServiceProvidersService',
        '$state', '$stateParams', 'CommonHeaderService', 'ModalServiceExt', '$http', '$window', 'SharedMetersCacheService',
// ReSharper disable InconsistentNaming
        function ($scope, usSpinnerService, LeftMenuService, ServiceProvidersService,
            $state, $stateParams, CommonHeaderService, ModalServiceExt, $http, $window, SharedMetersCacheService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Meter Validation Error'));
            $scope.helpEmail = utilli.getHelpEmail();
            $scope.supportPhoneNumber = utilli.getSupportPhoneNumber();

            usSpinnerService.spin('spinner-1');

            ServiceProvidersService.getCurrentProvider().then(
                function (providerData) {
                    $scope.provider = providerData;

                    $http({
                        method: "GET",
                        url: $scope.provider.ApiUrl + 'api/PropertyManagers/GetTiedMeters/',
                        params: { meterId: $stateParams.meterId }
                    }).success(function (response) {
                        usSpinnerService.stop('spinner-1');
                        utilli.handleAjaxResponse(response,
                            ModalServiceExt,
                            function () {
                                $scope.tiedMeters = response.Data;
                            });
                    }).error(function () {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                    });
                },
                function () {
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                    usSpinnerService.stop('spinner-1');
                });
            
            $scope.close = function () {
                goBack();
            }

            $scope.acknowledge = function () {
                usSpinnerService.spin('spinner-1');
                $http({
                    method: 'POST',
                    url: $scope.provider.ApiUrl + 'api/PropertyManagers/ConfirmTiedMeters/',
                    data: { '': $stateParams.meterId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    utilli.handleAjaxResponse(response,
                        ModalServiceExt,
                        function () {
                            //SharedMetersCacheService.deleteMeter($stateParams.meterId);
                            goBack();
                        });
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            function goBack() {
                if (utilli.isAuthorized()) {
                    if ($stateParams.from) {
                        $state.goMainLayout(
                            $stateParams.from,
                            {
                                id: $stateParams.propertyId,
                                mode: $stateParams.mode,
                                stepsCount: $stateParams.stepsCount,
                                step: $stateParams.step,
                                topMeter: $stateParams.meterId
                            })
                    }
                    else {
                        $window.history.back();
                    }
                }
                else
                    $state.go('TopMenuLayout.SendDataSharingInvitation', { useCachedMeters: true, token: $stateParams.token });
            }
        }]);

'use strict';
angular.module('utilliApp')
    .controller('BulkMetersInputController', ['$scope', 'LeftMenuService', '$state', '$stateParams', 'CommonHeaderService', 'BulkMetersService',
        // ReSharper disable InconsistentNaming
        function ($scope, LeftMenuService, $state, $stateParams, CommonHeaderService, BulkMetersService) {
            var _t = $scope._t;
            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Add Meters'));

            $scope.cancel = function () {
                $state.goMainLayout('AddProperty.AddMeters', { id: $stateParams.id, mode: $stateParams.mode, stepsCount: $stateParams.stepsCount, step: $stateParams.step});
            }

            $scope.ok = function () {
                if ($scope.metersText) {
                    var meters = $scope.metersText.split(/[,\s]/);
                    meters = _.map(meters, function (meter) { return meter.trim(); });
                    meters = _.filter(meters, function(meter) { return meter !== ''; });
                    BulkMetersService.addMeters(meters);
                }

                $state.goMainLayout('AddProperty.AddMeters', { id: $stateParams.id, mode: $stateParams.mode, stepsCount: $stateParams.stepsCount, step: $stateParams.step });
            }
        }])
    .factory('BulkMetersService', function () {

        var metersNumbers = [];
        var clear = function () {
            metersNumbers = [];
        }
        var getMeters = function () {
            return metersNumbers;
        }
        var addMeters = function(meters) {
            metersNumbers = metersNumbers.concat(meters);
        }

        return {
            getMeters: getMeters,
            clear: clear,
            addMeters: addMeters
        };
    });
'use strict';
// ReSharper disable once UndeclaredGlobalVariableUsing
angular.module('utilliApp')
    .controller('SharedAccountsController', ['$scope', '$http', 'usSpinnerService', 'LeftMenuService', 
        'CommonHeaderService', 'ModalServiceExt', '$state',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, LeftMenuService, CommonHeaderService, ModalServiceExt, $state) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            LeftMenuService.setCurrentTab('SharedAccounts');
            CommonHeaderService.setUp(_t('Shared Accounts'));

            var takeRecords = 20;
            $scope.requests = [];

            $scope.getRequests = function () {
                if ($scope.scrollingBusy)
                    return;

                $scope.scrollingBusy = true;
                usSpinnerService.spin('spinner-1');

                $http({
                    method: 'GET',
                    url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetSharingAccountRequests/',
                    params: { userName: $state.params.userId, skip: $scope.requests.length, count: takeRecords }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    
                    if (response.HasErrors) {
                        ModalServiceExt.showError(response.Errors[0], function () { $scope.scrollingBusy = false; });
                        return;
                    }

                    if (response.Data.length === 0) {
                        $scope.requestsCompleted = true;
                        $scope.scrollingBusy = false;
                        return;
                    }

                    for (var i = 0; i < response.Data.length; i++) {
                        $scope.requests.push(response.Data[i]);
                    }
                    $scope.scrollingBusy = false;
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError(function () { $scope.scrollingBusy = false; });
                });
            }

            $scope.sendSharingAccountRequest = function () {
                $state.goMainLayout('SendSharingAccountRequest');
            }

            function changeRequestStatus(requestId, url, successMessage) {
                usSpinnerService.spin('spinner-1');
                
                $http({
                    method: 'POST',
                    url: url,
                    data: { '': requestId },
                    params: { userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');

                    if (response.HasErrors) {
                        ModalServiceExt.showError(response.Errors[0]);
                        return;
                    }

                    var index = _.findIndex($scope.requests, function (item) { return item.Id === response.Data.Id; })
                    if (index === -1) {
                        ModalServiceExt.showServerError();
                        return;
                    }

                    $scope.requests[index] = response.Data;
                    ModalServiceExt.showInfo(successMessage);
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            $scope.accept = function (requestId) {
                changeRequestStatus(
                    requestId,
                    localStorage.getItem('ApiUrl') + 'api/PropertyManagers/AcceptSharingAccountRequest/',
                    'Sharing request accepted.')
            }

            $scope.reject = function (requestId) {
                changeRequestStatus(
                    requestId,
                    localStorage.getItem('ApiUrl') + 'api/PropertyManagers/RejectSharingAccountRequest/',
                    'Sharing request rejected.')
            }

            $scope.revoke = function (requestId) {
                changeRequestStatus(
                    requestId,
                    localStorage.getItem('ApiUrl') + 'api/PropertyManagers/RevokeSharingAccountRequest/',
                    'Sharing request revoked.')
            }

            $scope.makeActive = function (requestId) {
                changeRequestStatus(
                    requestId,
                    localStorage.getItem('ApiUrl') + 'api/PropertyManagers/MakeActiveSharingAccountRequest/',
                    'Sharing request is active.')
            }

            $scope.delete = function (requestId) {
                ModalServiceExt.showYesNoMessage(
                    _t('Delete Sharing Request'),
                    _t('Are you sure that you want to delete the sharing request?'),
                    function () {
                        usSpinnerService.spin('spinner-1');
                        $http({
                            method: 'POST',
                            url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/DeleteSharingAccountRequest/',
                            data: { '': requestId },
                            params: { userName: $state.params.userId }
                        }).success(function (response) {
                            usSpinnerService.stop('spinner-1');
                            if (response.HasErrors) {
                                ModalServiceExt.showError(response.Errors[0]);
                                return;
                            }

                            $scope.requests = _.reject($scope.requests, function (item) { return item.Id === requestId; });
                            ModalServiceExt.showInfo(_t('Sharing request deleted.'));
                        }).error(function (error) {
                            usSpinnerService.stop('spinner-1');
                            ModalServiceExt.showServerError(response.Errors[0]);
                        });
                    });
            }
        }]);
'use strict';
// ReSharper disable once UndeclaredGlobalVariableUsing
angular.module('utilliApp')
    .controller('SendSharingAccountRequestController', ['$scope', '$http', 'usSpinnerService', 'LeftMenuService',
        'CommonHeaderService', 'ModalServiceExt', '$window', '$state',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, LeftMenuService, CommonHeaderService, ModalServiceExt, $window, $state) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            LeftMenuService.setCurrentTab('SharedAccounts');
            CommonHeaderService.setUp(_t('Send Sharing Account Request'));

            $scope.cancel = function () {
                $window.history.back();
            }

            $scope.send = function () {
                
                if (!$scope.userIdOrEmail) {
                    $scope.submitted = true;
                    return;
                }

                $scope.submitted = false;
                var params = { userIdOrEmail: $scope.userIdOrEmail };
                utilli.addUserName($state, params);
                usSpinnerService.spin('spinner-1');
                $http({
                    method: 'POST',
                    params: params,
                    url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/SendSharingAccountRequest/'
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');

                    if (response.HasErrors) {
                        if (response.Errors[0].indexOf('User with Id or Email') != -1) {
                            ModalServiceExt.showYesNoMessage(_t('Sending Email Invitation'), _t('We can not find user in our system by email you provided. Would you like us to invite person to register in UtilliCX by sending invitation email?'),
                                function () {
                                    $state.goMainLayout('SendSharingAccountRequestEmail', { email: $scope.userIdOrEmail });
                                    return;
                                },

                                function () {
                                    $state.goMainLayout('SharedAccounts');
                                    return;
                                });
                        }
                        else {
                            ModalServiceExt.showError(response.Errors[0]);
                            return;
                        }
                    }
                    else {
                        ModalServiceExt.showInfo(
                            _t('Sharing account request sent successfully.'),
                            function () { $window.history.back(); });
                    }
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }
        }]);
'use strict';
// ReSharper disable once UndeclaredGlobalVariableUsing
angular.module('utilliApp')
    .controller('SendSharingAccountRequestEmailController', ['$scope', '$http', 'usSpinnerService', 'LeftMenuService',
        'CommonHeaderService', 'ModalServiceExt', '$window', '$state',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, LeftMenuService, CommonHeaderService, ModalServiceExt, $window, $state) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            LeftMenuService.setCurrentTab('SharedAccounts');
            CommonHeaderService.setUp(_t('Send Sharing Account Request Email'));

            $scope.explanation = '';

            $scope.email = $state.params.email;
            $scope.emailPattern = window.Config.emailPattern;
            if (!$scope.emailPattern.test($scope.email))
            {
                $scope.email = '';
                $scope.explanation = _t('Please, enter email. We will use this email to send invitation.');
            }
            else
            {
                $scope.explanation = _t('Please, confirm email. We will use this email to send invitation.');
            }

            $scope.cancel = function () {
                //$window.history.back();
                $state.goMainLayout('SharedAccounts');
            }

            $scope.send = function () {
                
                if (!$scope.email) {
                    $scope.submitted = true;
                    return;
                }

                $scope.submitted = false;

                usSpinnerService.spin('spinner-1');
                var params = {
                    email: $scope.email
                };
                utilli.addUserName($state, params);
                $http({
                    method: 'POST',
                    params: params,
                    url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/SendInvitationEmail/',
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');

                    if (response.HasErrors) {
                        ModalServiceExt.showError(response.Errors[0]);
                        return;
                    }

                    ModalServiceExt.showInfo(
                        _t('Email Invitation was successfully sent.'),
                        function () { $state.goMainLayout('SharedAccounts'); });
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }
        }]);
'use strict';
angular.module('utilliApp')
    .controller('MeterNeedsApprovalController', ['$scope', '$http', 'usSpinnerService', 'LeftMenuService', '$state',
        '$stateParams', 'CommonHeaderService', 'ModalServiceExt', '$window',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, LeftMenuService, $state, $stateParams, CommonHeaderService,
            ModalServiceExt, $window) {

            var _t = $scope._t;
            LeftMenuService.setCurrentTab('Edit Property');
            CommonHeaderService.setUp(_t('Approve Property Meter'));

            $scope.meterNumber = $stateParams.meterNumber;

            usSpinnerService.spin('spinner-1');
            $http({
                method: 'GET',
                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetInvitationRecipient/',
                params: {
                    propertyId: $stateParams.propertyId,
                    meterId: $stateParams.meterId,
                    userName: $state.params.userId
                }
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
                if (response.HasErrors) {
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }
                $scope.tenantName = response.Data.Recipient;
            }).error(function (error) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });

            $scope.delete = function () {
                usSpinnerService.spin('spinner-1');
                var params = { meterId: $stateParams.meterId };
                utilli.addUserName($state, params);
                $http({
                    method: 'POST',
                    url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/DeleteMeter/',
                    params: params
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.HasErrors) {
                        ModalServiceExt.showError(response.Errors[0]);
                        return;
                    }

                    ModalServiceExt.showInfo(_t('Property meter deleted.'), function () { $window.history.back(); });
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            $scope.approve = function () {
                usSpinnerService.spin('spinner-1');
                $http({
                    method: 'POST',
                    url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/ApproveMeter/',
                    data: { '': $stateParams.meterId },
                    params: { userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.HasErrors) {
                        ModalServiceExt.showError(response.Errors[0]);
                        return;
                    }

                    ModalServiceExt.showInfo(_t('Property meter approved.'), function () { goBack(); });
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            function goBack() {
                if (utilli.isAuthorized()) {
                    if ($stateParams.from) {
                        $state.goMainLayout(
                            $stateParams.from,
                            {
                                id: $stateParams.propertyId,
                                mode: $stateParams.mode,
                                stepsCount: $stateParams.stepsCount,
                                step: $stateParams.step,
                                topMeter: $stateParams.meterId
                            })
                    }
                    else
                        $window.history.back();
                }
                else
                    $state.go('TopMenuLayout.SendDataSharingInvitation', { useCachedMeters: true, token: $stateParams.token });
            }
        }]);

'use strict';
angular.module('utilliApp')
.controller('WelcomeAgentController', ['$scope', 'LeftMenuService', '$state', 'CommonDataService',
    'ServiceProvidersService', '$sce', 'usSpinnerService', '$http', 'CommonHeaderService',
function ($scope, LeftMenuService, $state, CommonDataService, ServiceProvidersService, $sce,
    usSpinnerService, $http, CommonHeaderService) {
    CommonHeaderService.setUp();

    $scope.appUrls = Config.appUrls;

    var token = localStorage.getItem('SecurityToken');
    if (token)
    {
        $state.goMainLayout('Dashboard');
        return;
    }

    $state.go('TopMenuLayout.WelcomeAgent.SignIn.Credentials');

    if (DeploymentSettings.currentServiceProvider.length > 0) {
        $scope.serviceProviderName = Config.providers[DeploymentSettings.currentServiceProvider].SiteName;
        $scope.helpEmail = Config.providers[DeploymentSettings.currentServiceProvider].HelpEmail;
        $scope.showPhoneNumbers = Config.providers[DeploymentSettings.currentServiceProvider].EnablePhoneNumbersOnLoginPage;
    }
    else {
        $scope.helpEmail = 'help@utilli.com';
    }
    $scope.phoneNumbers = 'loading...';
    $scope.loadPhoneNumbers = function (){
        if ($scope.phoneNumbersLoaded){
            return;
        }
        ServiceProvidersService.getProviders()
            .then(
                function(providers) {
                    if (!providers || providers.length == 0) {
                        $scope.phoneNumbers = "Server error. Try again later.";
                        return;
                    }

                    var currentServiceProvider = DeploymentSettings.currentServiceProvider;
                    if (currentServiceProvider.length == 0) {
                        $scope.phoneNumbers = "Configuration error: can't get current service provider.";
                        return;
                    }

                    var currentProviderName = Config.providers[currentServiceProvider].Name;

                    var providersFiltered = $.grep(providers, function(item) {
                        return item.Name == currentProviderName;
                    });

                    if (!providersFiltered || providersFiltered.length !== 1) {
                        $scope.phoneNumbers = "Configuration error: can't get current service provider.";
                        return;
                    }

                    $http({
                        url: providersFiltered[0].ApiUrl + 'api/StaticData/GetInqueriesPhoneNumbers',
                        method: "GET",
                    }).success(function(data) {
                        $scope.phoneNumbers = $sce.trustAsHtml(data);
                        $scope.phoneNumbersLoaded = true;
                    }).error(function() {
                        $scope.phoneNumbers = "Server error. Try again later.";
                    });
                },
                function() {
                    $scope.phoneNumbers = "Server error. Try again later.";
                });
    }
}]);
'use strict';

angular.module('utilliApp')
    .controller('SearchController', ['$scope', '$rootScope', '$state', '$http', '$timeout', 'LeftMenuService',
        'CommonHeaderService', 'ModalServiceExt', 'usSpinnerService',
        function ($scope, $rootScope, $state, $http, $timeout,
// ReSharper disable InconsistentNaming
            LeftMenuService, CommonHeaderService, ModalServiceExt,
// ReSharper restore InconsistentNaming
            usSpinnerService) {

            // ReSharper disable once InconsistentNaming
            var _t = $scope._t;
            LeftMenuService.setCurrentTab('Search');
            CommonHeaderService.setUpNotificationButton(_t('Account/Property Search'));
            $scope.submitted = false;
            $scope.isSearchResultVisible = false;

            $scope.search = function () {
                $scope.submitted = true;
                if (!$scope.isRequiredFilled() || $scope.searchForm.accountNumber.$error.pattern && $scope.accountNumber) {
                    return;
                }
                $scope.submitted = false;
                var url;
                var parameters;
                if ($scope.accountNumber) {
                    url = localStorage.getItem('ApiUrl') + 'api/Agents/SearchByAccountNumber/';
                    parameters = { accountNumber: $scope.accountNumber };
                    searchBy(url, parameters);
                }
                else {
                    url = localStorage.getItem('ApiUrl') + 'api/Agents/SearchByAddress/';
                    parameters = {
                        houseNumber: $scope.HouseNumber,
                        street: $scope.Street,
                        city: $scope.City,
                        state: $scope.State,
                        zipCode: $scope.Zip,
                        unitApt: $scope.HouseNoSupplement
                    };
                    searchBy(url, parameters);
                }
            }

            function searchBy(url, parameters) {
                usSpinnerService.spin('spinner-1');
                parameters.saveSearch = true;
                $http({
                    url: url,
                    method: "GET",
                    params: parameters
                }).success(function (response) {
                    utilli.handleAjaxResponse(response, ModalServiceExt,
                        function () {
                            if (response.Data && response.Data.length > 0) {
                                $scope.searchResults = _.filter(response.Data, function(dataItem) { 
                                    return dataItem.MeterStatus != utilli.hcMeterStatuses.inActive; 
                                });
                                $scope.companyName = localStorage.getItem('ServiceProviderName');
                            }
                            else {
                                $scope.searchResults = [];
                            }
                            $scope.isSearchResultVisible = true;
                        });
                    usSpinnerService.stop('spinner-1');
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            $scope.onHouseNumberChange = function () {
                if (/\d*\s+[\w\s]+,[\w\s]+,[\w\s]+,\s*\d+/.test($scope.HouseNumber)) {
                    var splited = $scope.HouseNumber.split(',');
                    $scope.HouseNumber = splited[0].split(' ')[0];
                    $scope.Street = splited[0].replace($scope.HouseNumber, '');
                    $scope.City = splited[1];
                    $scope.State = splited[2];
                    $scope.Zip = splited[3].trim().substring(0, 5);
                }
            }

            $scope.isRequiredFilled = function() {
                var byAccountNumber = $scope.accountNumber;
                var byAddress = $scope.Street && $scope.Zip;
                return byAccountNumber || byAddress;
            }

            $scope.isZipCodeValid = function () {
                var matched = Config.zipCodeRegexp.test($scope.Zip);
                return matched;
            }

            var goToAccountDashboard = function (accountNumber, utilityType) {
                localStorage.setItem('CurrentAccountNumber', accountNumber);
                localStorage.setItem('CurrentUtilityType', utilityType);

                $rootScope.showSlideAnimation = true;

                $state.goMainLayout("Dashboard");

                $timeout(function () {
                    $rootScope.showSlideAnimation = false;
                }, 300);
            };

            $scope.askAboutSettlementProperty = function (searchResult) {
                //searchResult.AccountNumber, searchResult.UtilityType, searchResult.ServiceAddress
                var accountNumber = searchResult.AccountNumber, utilityType = searchResult.UtilityType,
                    address = searchResult.ServiceAddress;

                ModalServiceExt.showYesNoMessage(_t('Property settlement'), _t('Is this property going to settlement?'),
                    // 'Yes' was clicked
                    function () {
                        $state.goMainLayout('SettlementProperty',
                                {
                                    AccountNumber: accountNumber,
                                    Address: address
                                });
                    },
                    // 'No' was clicked
                    function () {
                        usSpinnerService.spin('spinner-1');
                        $http({
                            url: localStorage.getItem('ApiUrl') + 'api/Agents/NoSettlement',
                            method: 'POST',
                            data: {
                                contractAccountNumber: accountNumber,
                                addressLine: address
                            }
                        }).apiThen(
                            function () {
                                goToAccountDashboard(accountNumber, utilityType);
                            }, 
                            ModalServiceExt
                        )
                        .fixedFinally(function () {
                            usSpinnerService.stop('spinner-1');
                        });
                    }
                );
            }

            $scope.getUtilityImage = function (utilityType) {
                if (utilityType === 'Gas')
                    return 'gas-bgr';
                if (utilityType === 'Water')
                    return 'water-bgr';
                if (utilityType === 'Electricity')
                    return 'elctr-bgr';
                return '';
            }
        }]);
'use strict';

angular.module('utilliApp')
    .controller('SearchHistoryController', ['$scope', '$rootScope', '$state', '$http', '$timeout',
        'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt', 'TimeService', 'GridService',
        'usSpinnerService',
        // ReSharper disable InconsistentNaming
        function ($scope, $rootScope, $state, $http, $timeout, LeftMenuService, CommonHeaderService, ModalServiceExt,
            TimeService, GridService, usSpinnerService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            LeftMenuService.setCurrentTab('SearchHistory');
            CommonHeaderService.setUp(_t('Account/Property Search History'));

            TimeService.getTimeZone().then(function (timeZoneShift) {
                $scope.convertDate = function (date) {
                    date = kendo.parseDate(date);
                    date.addHours(timeZoneShift);
                    var result = kendo.toString(date, 'dd MMM yyyy HH:mm');
                    return result;
                }
                var gridResizeFunc = GridService.getGridResizeFunc($("#searchHistoryGrid"));

                $scope.mainGridOptions = {
                    dataSource: {
                        transport: {
                            read: function (options) {
                                // ReSharper disable once InconsistentNaming
                                var webapi = new kendo.data.transports.webapi({ prefix: "" });
                                var params = webapi.parameterMap(options.data);
                                var usersUrl = localStorage.getItem('ApiUrl') + 'api/Agents/GetSearchHistory/';
                                $http.get(usersUrl, { params: params })
                                    .success(function (data) {
                                        options.success(data);
                                        gridResizeFunc($scope.searchHistoryKenoGrid);
                                    })
                                    .error(function () {
                                        options.error();
                                    });
                            }
                        },
                        schema: { data: "Data.PageData", total: "Data.Count" },
                        pageSize: 20,
                        serverPaging: true,
                        serverSorting: true,
                        serverFiltering: true
                    },
                    sortable: true,
                    pageable: {
                        pageSize: 10,
                        pageSizes: [10, 25, 50],
                        buttonCount: 3,
                        refresh: true
                    },
                    dataBound: function () {
                        gridResizeFunc($scope.searchHistoryKenoGrid);
                    },
                    columns: [
                        {
                            field: "Date",
                            title: _t("Date"),
                            template: "<span ng-bind=convertDate(dataItem.Date)>#: data.Date# </span>",
                            width: 140
                        },
                        {
                            field: "AccountNumber",
                            title: _t("Account Number"),
                            width: 100
                        },
                        {
                            field: "Address",
                            title: _t("Address"),
                            width: 90
                        },
                        {
                            field: "UtillityType",
                            hidden: true
                        },
                        {
                            width: 70,
                            template: "<input type='button' class='btn btn-primary grid-button' value='View' ng-click='askAboutSettlementProperty(dataItem)' />"
                        }
                    ]
                }

                $scope.askAboutSettlementProperty = function (dataItem) {
                    var url = localStorage.getItem('ApiUrl') + 'api/Agents/SearchByAccountNumber/';
                    var parameters = { accountNumber: dataItem.AccountNumber, saveSearch: false };
                    usSpinnerService.spin('spinner-1');
                    $http({
                        url: url,
                        method: "GET",
                        params: parameters
                    }).success(function (response) {
                        utilli.handleAjaxResponse(response, ModalServiceExt,
                            function () {
                                if (response.Data && response.Data.length > 0) {
                                    dataItem.meterStatus = response.Data[0].MeterStatus;
                                    
                                    if(dataItem.meterStatus == utilli.hcMeterStatuses.inActive) {
                                        ModalServiceExt.showError("Contract Account " + dataItem.AccountNumber
                                            + " is Inactive");
                                        return;
                                    }

                                    askUser(dataItem);
                                }
                                else
                                    ModalServiceExt.showInfo(_t('The contract account number not found.'));
                            });
                        usSpinnerService.stop('spinner-1');
                    }).error(function () {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                    });
                }

                var goToOverview = function (dataItem) {
                    localStorage.setItem('CurrentAccountNumber', dataItem.AccountNumber);
                    localStorage.setItem('CurrentUtilityType', dataItem.UtilityType);

                    $state.goMainLayout("Dashboard");
                };

                function askUser(dataItem) {
                    ModalServiceExt.showYesNoMessage(_t('Property settlement'),
                        _t('Is this property going to settlement?'),
                        function () {
                            if(dataItem.meterStatus == utilli.hcMeterStatuses.inActive) {
                                ModalServiceExt.showError("Contract Account " + dataItem.AccountNumber 
                                    +" is Inactive");
                            }
                            else {
                                $state.goMainLayout('SettlementProperty',
                                    {
                                        AccountNumber: dataItem.AccountNumber,
                                        Address: dataItem.Address,
                                        UtilityType: dataItem.UtilityType
                                    });
                            }
                        }, function () {
                            goToOverview(dataItem);
                        });
                }
            });
        }]);
'use strict';

angular.module('utilliApp')
    .controller('SettlementPropertyController', ['$scope', '$rootScope', '$state', '$window', '$http', '$timeout',
         'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt', 'TimeService',
         'GridService', 'usSpinnerService', '$stateParams',
        function ($scope, $rootScope, $state, $window, $http, $timeout,
// ReSharper disable InconsistentNaming
            LeftMenuService, CommonHeaderService, ModalServiceExt, TimeService, GridService,
// ReSharper restore InconsistentNaming
            usSpinnerService, $stateParams) {

            // ReSharper disable once InconsistentNaming
            var _t = $scope._t;
            LeftMenuService.setCurrentTab('SearchHistory');
            CommonHeaderService.setUp(_t('Property Settlement'));

            initDatePicker();
            
            $scope.accountNumber = $stateParams.AccountNumber;
            $scope.propertyAddress = $stateParams.Address;

            $scope.submit = function () {
                $scope.submitted = true;
                if (!$scope.settlementPropertyForm.$valid)
                    return;
                $scope.submitted = false;

                usSpinnerService.spin('spinner-1');
                var requestData = {
                    accountNumber: $stateParams.AccountNumber,
                    addressLine: $stateParams.Address,
                    firstAndLastName: $scope.firstLastName,
                    mailingAddress: $scope.mailingAddress,
                    settlementDate: $scope.settlementDate.toUTCString()
                };
                $http.post(localStorage.getItem('ApiUrl') + 'api/Agents/SavePropertySettlementDetails',
                    requestData)
                    .success(function (response) {
                        utilli.handleAjaxResponse(response, ModalServiceExt, function () {
                            var dataItem = {
                                AccountNumber: $stateParams.AccountNumber,
                                UtilityType: $stateParams.UtilityType
                            };
                            localStorage.setItem('CurrentAccountNumber', dataItem.AccountNumber);
                            localStorage.setItem('CurrentUtilityType', dataItem.UtilityType);
                            $state.goMainLayout("Dashboard");
                        });
                        usSpinnerService.stop('spinner-1');
                    }).error(function () {
                        ModalServiceExt.showServerError();
                        usSpinnerService.stop('spinner-1');
                    });
            }

            $scope.back = function () {
                $window.history.back();
            }

            function initDatePicker() {
                $scope.settlementDate = new Date();

                $scope.dpOptions = utilli.datePickerOptions;

                $scope.format = 'shortDate';
                $scope.altInputFormats = ['M!/d!/yyyy'];

                $scope.datepickerPopup = {
                    opened: false
                };
            }
        }]);
'use strict';
angular.module('utilliApp')
.controller('SignUpAgentController', ['$scope', '$rootScope', '$window', '$state', 'CommonHeaderService',
    function ($scope, $rootScope, $window, $state,
// ReSharper disable InconsistentNaming
        CommonHeaderService) {
// ReSharper restore InconsistentNaming
        CommonHeaderService.hideMenuToggleButton();

        $scope.Model = $scope.Model || {
            firstName: '',
            lastName: '',
            agency: '',
            phoneNumber: '',
            userName : '',
            email: '',
            password: '',
            securityQuestion: '',
            securityAnswer: ''
        };
        
    }])
.controller('SignUpAgentStep1Controller', ['$scope', '$rootScope', '$http', '$state', 'moduleServices',
    'usSpinnerService', 'ServiceProvidersService', '$stateParams', 'CheckVersionService', '$q', 'ModalServiceExt',
    function ($scope, $rootScope, $http, $state, $moduleServices, usSpinnerService,
        // ReSharper disable InconsistentNaming
        ServiceProvidersService, $stateParams, CheckVersionService, $q, ModalServiceExt) {
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming

        $scope.cancel = function () {
            ModalServiceExt.showYesNoMessage(_t('Confirmation'), _t('Are you sure you want to cancel agent registration process?'), function () {
                $state.go('TopMenuLayout.WelcomeAgent', null, { reload: true });
            });
        };

        $scope.phoneNumberMask = Config.phoneNumberMask;

        $scope.checkUserInfoFormSubmit = function () {
            usSpinnerService.spin("spinner-1");
            if (!$scope.formUserInfo.$valid) {
                $scope.submitted = true;
                usSpinnerService.stop("spinner-1");
                return;
            }
            $state.goRelativeTo('SignUpAgent', 'Step2',
                           {
                               regData: {
                                   firstName: $.trim($scope.firstName),
                                   lastName: $.trim($scope.lastName),
                                   agency: $.trim($scope.agency),
                                   phoneNumber: $.trim($scope.phoneNumber)
                               }
                           });
            usSpinnerService.stop("spinner-1");
        }
    }])
.controller('SignUpAgentStep2Controller', ['$scope', '$rootScope', '$http', '$state', 'moduleServices',
    'CommonDataService', 'usSpinnerService', '$stateParams', 'ServiceProvidersService', 'ModalServiceExt',
    // ReSharper disable InconsistentNaming
    function ($scope, $rootScope, $http, $state, $moduleServices, CommonDataService,
        usSpinnerService, $stateParams, ServiceProvidersService, ModalServiceExt) {
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming

        $scope.Model.password = '';

        $scope.cancel = function () {
            $state.goRelativeTo('SignUpAgent', 'Step1');
        };

        $scope.errors = [];

        var loadingText = _t('Loading...');
        $scope.passRequirements = [loadingText];
        $scope.SecurityQuestions = [loadingText];
        $scope.Model.securityQuestion = loadingText;

        usSpinnerService.spin("spinner-1");
        ServiceProvidersService.getCurrentProvider().then(
            function(providerData) {
                $rootScope.webServicesUrl = providerData.ApiUrl;
                $rootScope.serviceUrl = providerData.ApiUrl + 'api/Registration/Register/';
                CommonDataService.getCommonData($rootScope.webServicesUrl)
                    .then(function(data) {
                            usSpinnerService.stop('spinner-1');
                            $scope.paswdMinLength = data.PasswordLength;
                            $scope.passRequirements = data.PasswordRequirements;
                            $scope.minUserIdLength = data.MinUserIdLength;
                        },
                        function() {
                            usSpinnerService.stop("spinner-1");
                            $scope.errors.push(utilli.errors.serverErrorMessage);
                        });

                $http.get(providerData.ApiUrl + 'api/StaticData/GetSecurityQuestions/')
                    .then(function(resp) {
                            var sequrityQeuestions = JSON.parse(resp.data);
                            $scope.SecurityQuestions = sequrityQeuestions;
                            $scope.Model.securityQuestion = $scope.SecurityQuestions[0];
                        },
                        function() {
                            $scope.errors.push(utilli.errors.serverErrorMessage);
                        });
            },
            function() {
                usSpinnerService.stop("spinner-1");
                $scope.errors.push(utilli.errors.serverErrorMessage);
            });

        
        $scope.isPasswdValid = function () { 
            $scope.passwdErrors = utilli.validatePassword($scope.Model.password, $scope.Model.userName, $scope.passRequirements,
                $scope.paswdMinLength, null, $scope.minUserIdLength);
            $scope.passwordsNotMatch = $scope.Model.password && $scope.Model.password !== $scope.confirmPassword 
                ? $scope._t('Passwords do not match.')
                : null;
            var result = $scope.passwdErrors.length == 0 && !$scope.passwordsNotMatch;
            return result;
        }

        $scope.errors = [];

        $scope.checkLoginInfoFormSubmit = function () {
            usSpinnerService.spin("spinner-1");
            var isPasswdValid = $scope.isPasswdValid();
            if (!$scope.formUserInfo.$valid || !isPasswdValid) {
                $scope.submitted = true;
                usSpinnerService.stop("spinner-1");
                return;
            }
            var data = {
                firstName: $.trim($scope.Model.firstName),
                lastName: $.trim($scope.Model.lastName),
                agency: $.trim($scope.Model.agency),
                phoneNumber: $.trim($scope.Model.phoneNumber),

                userName: $.trim($scope.Model.userName),
                email: $.trim($scope.Model.email),
                password: $.trim($scope.Model.password),
                securityQuestion: $scope.Model.securityQuestion,
                securityAnswer: $.trim($scope.Model.securityAnswer)
            };

            $rootScope.SecureData = {
                userNameOrEmail: ''
            };

            $rootScope.SecureData.userNameOrEmail = $.trim($scope.Model.email);

            $http({
                url: $rootScope.webServicesUrl + 'api/Agents/ValidateRegisterData/',
                method: "POST",
                data: data
            }).success(function (response) {
                if (response == undefined || response.HasErrors == undefined) {
                    ModalServiceExt.showServerError();
                    usSpinnerService.stop("spinner-1");
                    return;
                }
                if (response.HasErrors) {
                    $scope.errors = response.Errors;
                    utilli.scrollTop();
                }
                else {
                    $state.goRelativeTo('SignUpAgent', 'Step3');
                }
                usSpinnerService.stop("spinner-1");
            }).error(function () {
                usSpinnerService.stop("spinner-1");
                ModalServiceExt.showError(utilli.errors.serverErrorMessage);
            });
        }
    }])
.controller('SignUpAgentStep3Controller', ['$scope', '$rootScope', '$http', '$state', '$stateParams', 'moduleServices',
    'CommonDataService', 'usSpinnerService', '$sce', 'ModalServiceExt',
    // ReSharper disable InconsistentNaming
    function ($scope, $rootScope, $http, $state, $stateParams, $moduleServices, CommonDataService, usSpinnerService,
        $sce, ModalServiceExt) {
        // ReSharper restore InconsistentNaming
        $scope.errors = [];

        $scope.cancel = function () {
            $state.goRelativeTo('SignUpAgent', 'Step2');
        };

        $scope.loadTermsAndConditions = function () {
            usSpinnerService.spin("spinner-1");
            var url = $rootScope.webServicesUrl + 'api/StaticData/GetTermsAndConditions';
            $http({
                url: url,
                method: 'GET'
            }).success(function(data) {
                usSpinnerService.stop("spinner-1");
                $scope.html = $sce.trustAsHtml(data);
            }).error(function() {
                usSpinnerService.stop("spinner-1");
                $scope.errors.push(utilli.errors.serverErrorMessage);
            });
        }

        $scope.TermAndConditionsFormSubmit = function () {
            usSpinnerService.spin("spinner-1");
            $moduleServices.hideKeyboard();
            checkTermAndConditionsFormSubmit();
        };

        function checkTermAndConditionsFormSubmit() {
            var data = {
                firstName: $.trim($scope.Model.firstName),
                lastName: $.trim($scope.Model.lastName),
                agency: $.trim($scope.Model.agency),
                phoneNumber: $.trim($scope.Model.phoneNumber),

                userName: $.trim($scope.Model.userName),
                email: $.trim($scope.Model.email),
                password: $.trim($scope.Model.password),
                securityQuestion: $scope.Model.securityQuestion,
                securityAnswer: $.trim($scope.Model.securityAnswer)
            };

            $rootScope.SecureData = {
                userNameOrEmail: ''
            };
            
			$rootScope.SecureData.userNameOrEmail = $.trim($scope.Model.email);

            $http({
                url: $rootScope.webServicesUrl + 'api/Agents/Register/',
                method: "POST",
                data: data
            }).success(function (response) {
                if (response == undefined || response.HasErrors == undefined) {
                    ModalServiceExt.showServerError();
                    usSpinnerService.stop("spinner-1");
                    return;
                }
                if (response.HasErrors) {
                    ModalServiceExt.showError(response.Errors[0]);
                }
                else {
                    $state.goRelativeTo('SignUpAgent', 'Success');
                }
                usSpinnerService.stop("spinner-1");
            }).error(function () {
                usSpinnerService.stop("spinner-1");
                ModalServiceExt.showError(utilli.errors.serverErrorMessage);
            });
        }

    }])
.controller('SignUpAgentSuccessController', ['$scope', '$rootScope', 'CommonDataService',
    'usSpinnerService', '$state',
// ReSharper disable InconsistentNaming
    function ($scope, $rootScope, CommonDataService, usSpinnerService, $state) {
// ReSharper restore InconsistentNaming
        $scope.errors = [];
        CommonDataService.getCommonData($rootScope.webServicesUrl)
            .then(function (commonData) {
                $scope.companyNameLong = commonData.CompanyNameLong;
                $scope.companyNameLongWithoutTrailingPeriod = commonData.CompanyNameLongWithoutTrailingPeriod;
                $scope.helpEmail = commonData.CompanyHelpEmail;

                $scope.userEmail = $rootScope.SecureData.userNameOrEmail;

                usSpinnerService.stop('spinner-1');

                $scope.SuccessOk = function () {
                    $state.go('TopMenuLayout.WelcomeAgent', null, { reload: true });
                }
            });
    }]);
'use strict';
angular.module('utilliApp')
.controller('AgentProfileController', ['$scope', '$http', '$window', 'usSpinnerService', '$state', '$stateParams',
        'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt', 'avatarsService',
    function ($scope, $http, $window, usSpinnerService, $state, $stateParams, 
        // ReSharper disable InconsistentNaming
        LeftMenuService, CommonHeaderService, ModalServiceExt,
        // ReSharper restore InconsistentNaming
        avatarsService) {

        // ReSharper disable once InconsistentNaming
        var _t = $scope._t;
        CommonHeaderService.setUp(_t('Edit Agent Profile'));
        LeftMenuService.setCurrentTab('Profile');

        $scope.phoneNumberMask = Config.phoneNumberMask;
        var apiUrl = localStorage.getItem('ApiUrl');
        $scope.errors = [];

        init();

        $scope.save = function () {
            $scope.submitted = true;
            if(!$scope.editProfileForm.$valid){
                return;
            }
            usSpinnerService.spin('spinner-1');
            var postData = {};
            $window.jQuery.extend(postData, $scope.userData);
            var countryCode = utilli.getCountryPhoneNumberCode();
            postData.PhoneNumber = countryCode + postData.PhoneNumber;
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Agents/EditProfile/',
                method: "POST",
                data: postData
            }).success(function (response) {
                utilli.handleAjaxResponse(response, ModalServiceExt, function () {
                    LeftMenuService.changeAccount();
                    ModalServiceExt.showInfo(_t('Your profile has been saved.'));
                });
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                $scope.errors.push({ Message: utilli.serverErrorMessage });
            });
        }

        $scope.changeAvatar = function () {
            $state.goMainLayout('Avatars', { forAgent: true });
        };

        function init() {
            usSpinnerService.spin('spinner-1');
            $http({
                method: 'GET',
                url: apiUrl + 'api/Agents/GetProfile'
            }).success(function(data) {
                usSpinnerService.stop('spinner-1');
                $scope.userData = data.Data;
                avatarsService.setCurrentAvatar(apiUrl + $scope.userData.AvatarPath);
            }).error(function() {
                usSpinnerService.stop('spinner-1');
                $scope.errors.push({ Message: utilli.serverErrorMessage });
            });
        };
    }]);
'use strict';
angular.module('utilliApp')
.controller('WelcomeAssistantController', ['$scope', 'LeftMenuService', '$state', 'CommonDataService',
    'ServiceProvidersService', '$sce', 'usSpinnerService', '$http', 'CommonHeaderService',
function ($scope, LeftMenuService, $state, CommonDataService, ServiceProvidersService, $sce,
    usSpinnerService, $http, CommonHeaderService) {
    CommonHeaderService.setUp();

    $scope.appUrls = Config.appUrls;

    var token = localStorage.getItem('SecurityToken');
    if (token)
    {
        $state.goMainLayout('Dashboard');
        return;
    }

    $state.go('TopMenuLayout.WelcomeAssistant.SignIn.Credentials');

    if (DeploymentSettings.currentServiceProvider.length > 0) {
        $scope.serviceProviderName = Config.providers[DeploymentSettings.currentServiceProvider].SiteName;
        $scope.helpEmail = Config.providers[DeploymentSettings.currentServiceProvider].HelpEmail;
        $scope.showPhoneNumbers = Config.providers[DeploymentSettings.currentServiceProvider].EnablePhoneNumbersOnLoginPage;
    }
    else {
        $scope.helpEmail = 'help@utilli.com';
    }
    $scope.phoneNumbers = 'loading...';
    $scope.loadPhoneNumbers = function (){
        if ($scope.phoneNumbersLoaded){
            return;
        }
        ServiceProvidersService.getProviders()
            .then(
                function(providers) {
                    if (!providers || providers.length == 0) {
                        $scope.phoneNumbers = "Server error. Try again later.";
                        return;
                    }

                    var currentServiceProvider = DeploymentSettings.currentServiceProvider;
                    if (currentServiceProvider.length == 0) {
                        $scope.phoneNumbers = "Configuration error: can't get current service provider.";
                        return;
                    }

                    var currentProviderName = Config.providers[currentServiceProvider].Name;

                    var providersFiltered = $.grep(providers, function(item) {
                        return item.Name == currentProviderName;
                    });

                    if (!providersFiltered || providersFiltered.length !== 1) {
                        $scope.phoneNumbers = "Configuration error: can't get current service provider.";
                        return;
                    }

                    $http({
                        url: providersFiltered[0].ApiUrl + 'api/StaticData/GetInqueriesPhoneNumbers',
                        method: "GET",
                    }).success(function(data) {
                        $scope.phoneNumbers = $sce.trustAsHtml(data);
                        $scope.phoneNumbersLoaded = true;
                    }).error(function() {
                        $scope.phoneNumbers = "Server error. Try again later.";
                    });
                },
                function() {
                    $scope.phoneNumbers = "Server error. Try again later.";
                });
    }
}]);
'use strict';
angular.module('utilliApp').controller('WelcomeAlexaController', 
    ['$state', '$scope', '$http', 'ServiceProvidersService', 'usSpinnerService', 'ModalServiceExt', '$location',
    function ($state, $scope, $http, ServiceProvidersService, usSpinnerService, ModalServiceExt, $location) {
        var _t = $scope._t;
        $scope.errors = [];
        $scope.login = '';
        $scope.password = '';
        var queryParams = $location.search();
        if (!queryParams.state)
            $scope.errors.push(_t("Parameter 'state' is missing."));
        if (!queryParams.redirect_uri)
            $scope.errors.push(_t("Parameter 'redirect_uri' is missing."));
        if ($scope.errors.length)
            return;

        var apiUrlAsync = ServiceProvidersService.getProviderApiUrl();

        $scope.submit = function () {
            $scope.form.$submitted = true;
            if (!$scope.form.$valid)
                return;
            usSpinnerService.spin('spinner-1');
            apiUrlAsync.then(function (apiUrl) {
                return $http({
                    url: apiUrl + 'api/Account/AlexaLogin',
                    method: 'POST',
                    params: { userNameOrEmail: $scope.login, password: $scope.password }
                }).apiThen(function (data) {
                    utilli.setWindowLocation(queryParams.redirect_uri + '&state=' + queryParams.state + '&access_token=' 
                        + data.SecurityToken);
                }, $scope.errors);
            }).fixedFinally(function () {
                usSpinnerService.stop('spinner-1');
            });
        };

        $scope.togglePassword = function (pswId, iconId) {
            utilli.togglePasswordVisibility(pswId, iconId);
        };
    }]);
'use strict';
angular.module('utilliApp')
.controller('DelinquentsController', ['$scope', '$rootScope', '$http', '$window', '$timeout', 'usSpinnerService', '$state', '$stateParams',
        'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt', 'avatarsService', 
    function ($scope, $rootScope, $http, $window, $timeout, usSpinnerService, $state, $stateParams, LeftMenuService, CommonHeaderService, ModalServiceExt, avatarsService) {
        var _t = $scope._t;
        CommonHeaderService.setUp(_t('Delinquents List'));
        LeftMenuService.setCurrentTab('Delinquents');

        $scope.delinquents = null;

        $scope.sortSettings = {
            balance: null,
            fullName: null
        };
        
        loadData();

        $scope.sortBy = function (parameter) {
           var sortSetting = $scope.sortSettings[parameter];
            if (sortSetting == null) {
                $scope.sortSettings.balance = null;
                $scope.sortSettings.fullName = null;
                $scope.sortSettings[parameter] = "asc";
            }
            else{
                $scope.sortSettings.balance = null;
                $scope.sortSettings.fullName = null;
                $scope.sortSettings[parameter] = sortSetting == "desc" 
                    ? "asc" 
                    : "desc";
            }
            loadData(getRequestParams());
        }

        function getRequestParams () {
            var sortParam = $scope.sortSettings.fullName || $scope.sortSettings.balance 
                ? $scope.sortSettings
                : null;
            var searchParam = $scope.searchBy ? $scope.searchBy : null;
            var result = { 
                sortBy: sortParam,
                searchBy: searchParam
            };
            return result;
        }
        
        $scope.view = function (accountNumber, utilityType) {
            LeftMenuService.selectContractAccount(accountNumber);
        }

        $scope.pay = function (accountNumber, utilityType) {
            LeftMenuService.selectContractAccount(accountNumber, "PayNow");
        }

        $scope.search = function () {
            loadData(getRequestParams());
        }

        function loadData (parameters) {
            var url = localStorage.getItem('ApiUrl') + 'api/Assistant/GetDelinquents/';
            usSpinnerService.spin('spinner-1');
            $http({
                url: url,
                method: "POST",
                data: parameters
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
                utilli.handleAjaxResponse(response, ModalServiceExt,
                    function () {
                        $scope.delinquents = response.Data;
                    });
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
    
        }

        $scope.resetSearch = function () {
            $scope.searchBy = null;
            loadData();
        }

        var goTo = function (accountNumber, utilityType, state) {
            localStorage.setItem('CurrentAccountNumber', accountNumber);
            localStorage.setItem('CurrentUtilityType', utilityType);

            $rootScope.showSlideAnimation = true;

            $state.goMainLayout(state);

            $timeout(function () {
                $rootScope.showSlideAnimation = false;
            }, 300);
        };
    }]);
'use strict';

angular.module('utilliApp')
    .controller('AssistantSearchController', ['$scope', '$rootScope', '$state', '$http', '$timeout', 'LeftMenuService',
        'CommonHeaderService', 'ModalServiceExt', 'usSpinnerService',
        function ($scope, $rootScope, $state, $http, $timeout,
// ReSharper disable InconsistentNaming
            LeftMenuService, CommonHeaderService, ModalServiceExt,
// ReSharper restore InconsistentNaming
            usSpinnerService) {

            // ReSharper disable once InconsistentNaming
            var _t = $scope._t;
            LeftMenuService.setCurrentTab('AssistantSearch');
            CommonHeaderService.setUpNotificationButton(_t('Account/Property Search'));
            $scope.submitted = false;
            $scope.isSearchResultVisible = false;

            $scope.search = function () {
                $scope.submitted = true;
                if (!$scope.isRequiredFilled() || $scope.searchForm.accountNumber.$error.pattern && $scope.accountNumber) {
                    return;
                }
                $scope.submitted = false;
                var url;
                var parameters;
                if ($scope.accountNumber) {
                    url = localStorage.getItem('ApiUrl') + 'api/Agents/SearchByAccountNumber/';
                    parameters = { accountNumber: $scope.accountNumber };
                    searchBy(url, parameters);
                }
                else {
                    url = localStorage.getItem('ApiUrl') + 'api/Agents/SearchByAddress/';
                    parameters = {
                        houseNumber: $scope.HouseNumber,
                        street: $scope.Street,
                        city: $scope.City,
                        state: $scope.State,
                        zipCode: $scope.Zip,
                        unitApt: $scope.HouseNoSupplement
                    };
                    searchBy(url, parameters);
                }
            }

            function searchBy(url, parameters) {
                usSpinnerService.spin('spinner-1');
                parameters.saveSearch = false;
                $http({
                    url: url,
                    method: "GET",
                    params: parameters
                }).success(function (response) {
                    utilli.handleAjaxResponse(response, ModalServiceExt,
                        function () {
                            if (response.Data) {
                                $scope.searchResults = response.Data;
                                $scope.companyName = localStorage.getItem('ServiceProviderName');
                            }
                            else {
                                $scope.searchResults = [];
                            }
                            $scope.isSearchResultVisible = true;
                        });
                    usSpinnerService.stop('spinner-1');
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            $scope.onHouseNumberChange = function () {
                if (/\d*\s+[\w\s]+,[\w\s]+,[\w\s]+,\s*\d+/.test($scope.HouseNumber)) {
                    var splited = $scope.HouseNumber.split(',');
                    $scope.HouseNumber = splited[0].split(' ')[0];
                    $scope.Street = splited[0].replace($scope.HouseNumber, '');
                    $scope.City = splited[1];
                    $scope.State = splited[2];
                    $scope.Zip = splited[3].trim().substring(0, 5);
                }
            }

            $scope.isRequiredFilled = function() {
                var byAccountNumber = $scope.accountNumber;
                var byAddress = $scope.Street && $scope.Zip;
                return byAccountNumber || byAddress;
            }

            $scope.isZipCodeValid = function () {
                var matched = Config.zipCodeRegexp.test($scope.Zip);
                return matched;
            }

            var goTo = function (accountNumber, utilityType, state) {
                localStorage.setItem('CurrentAccountNumber', accountNumber);
                localStorage.setItem('CurrentUtilityType', utilityType);

                $rootScope.showSlideAnimation = true;

                $state.goMainLayout(state);

                $timeout(function () {
                    $rootScope.showSlideAnimation = false;
                }, 300);
            };

            $scope.view = function (accountNumber, utilityType) {
                LeftMenuService.selectContractAccount(accountNumber);
            }

            $scope.pay = function (accountNumber, utilityType) {
                goTo(accountNumber, utilityType, "PayNow");
            }

            $scope.getUtilityImage = function (utilityType) {
                if (utilityType === 'Gas')
                    return 'gas-bgr';
                if (utilityType === 'Water')
                    return 'water-bgr';
                if (utilityType === 'Electricity')
                    return 'elctr-bgr';
                return '';
            }
        }]);
'use strict';

angular.module('utilliApp')
    .controller('AssistantSearchHistoryController', ['$scope', '$rootScope', '$state', '$http', '$timeout',
        'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt', 'TimeService', 'GridService',
        'usSpinnerService',
        // ReSharper disable InconsistentNaming
        function ($scope, $rootScope, $state, $http, $timeout, LeftMenuService, CommonHeaderService, ModalServiceExt,
            TimeService, GridService, usSpinnerService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            LeftMenuService.setCurrentTab('AssistantSearchHistory');
            CommonHeaderService.setUp(_t('Account/Property Search History'));

            TimeService.getTimeZone().then(function (timeZoneShift) {
                $scope.convertDate = function (date) {
                    date = kendo.parseDate(date);
                    date.addHours(timeZoneShift);
                    var result = kendo.toString(date, 'dd MMM yyyy HH:mm');
                    return result;
                }
                var gridResizeFunc = GridService.getGridResizeFunc($("#searchHistoryGrid"));

                $scope.mainGridOptions = {
                    dataSource: {
                        transport: {
                            read: function (options) {
                                // ReSharper disable once InconsistentNaming
                                var webapi = new kendo.data.transports.webapi({ prefix: "" });
                                var params = webapi.parameterMap(options.data);
                                var usersUrl = localStorage.getItem('ApiUrl') + 'api/Agents/GetSearchHistory/';
                                $http.get(usersUrl, { params: params })
                                    .success(function (data) {
                                        options.success(data);
                                        gridResizeFunc($scope.searchHistoryKenoGrid);
                                    })
                                    .error(function () {
                                        options.error();
                                    });
                            }
                        },
                        schema: { data: "Data.PageData", total: "Data.Count" },
                        pageSize: 20,
                        serverPaging: true,
                        serverSorting: true,
                        serverFiltering: true
                    },
                    sortable: true,
                    pageable: {
                        pageSize: 10,
                        pageSizes: [10, 25, 50],
                        buttonCount: 3,
                        refresh: true
                    },
                    dataBound: function () {
                        gridResizeFunc($scope.searchHistoryKenoGrid);
                    },
                    columns: [
                        {
                            field: "Date",
                            title: _t("Date"),
                            template: "<span ng-bind=convertDate(dataItem.Date)>#: data.Date# </span>",
                            width: 140
                        },
                        {
                            field: "AccountNumber",
                            title: _t("Account Number"),
                            width: 100
                        },
                        {
                            field: "Address",
                            title: _t("Address"),
                            width: 90
                        },
                        {
                            field: "UtillityType",
                            hidden: true
                        },
                        {
                            width: 70,
                            template: "<input type='button' class='btn btn-primary grid-button' value='View' ng-click='view(dataItem)' />"
                        }
                    ]
                }

                $scope.view = function (dataItem) {
                    LeftMenuService.selectContractAccount(dataItem.AccountNumber);
                }
            });
        }]);
'use strict';
angular.module('utilliApp')
.controller('SignUpAssistantController', ['$scope', '$rootScope', '$window', '$state', 'CommonHeaderService',
    function ($scope, $rootScope, $window, $state,
// ReSharper disable InconsistentNaming
        CommonHeaderService) {
// ReSharper restore InconsistentNaming
        CommonHeaderService.hideMenuToggleButton();

        $scope.Model = $scope.Model || {
            firstName: '',
            lastName: '',
            agency: '',
            phoneNumber: '',
            userName : '',
            email: '',
            password: '',
            securityQuestion: '',
            securityAnswer: ''
        };
        
    }])
.controller('SignUpAssistantStep1Controller', ['$scope', '$rootScope', '$http', '$state', 'moduleServices',
    'usSpinnerService', 'ServiceProvidersService', '$stateParams', 'CheckVersionService', '$q', 'ModalServiceExt',
    function ($scope, $rootScope, $http, $state, $moduleServices, usSpinnerService,
        // ReSharper disable InconsistentNaming
        ServiceProvidersService, $stateParams, CheckVersionService, $q, ModalServiceExt) {
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming

        $scope.cancel = function () {
            ModalServiceExt.showYesNoMessage(_t('Confirmation'), _t('Are you sure you want to cancel assistant registration process?'), function () {
                $state.go('TopMenuLayout.WelcomeAssistant', null, { reload: true });
            });
        };

        $scope.phoneNumberMask = Config.phoneNumberMask;

        $scope.checkUserInfoFormSubmit = function () {
            usSpinnerService.spin("spinner-1");
            if (!$scope.formUserInfo.$valid) {
                $scope.submitted = true;
                usSpinnerService.stop("spinner-1");
                return;
            }
            $state.goRelativeTo('SignUpAssistant', 'Step2',
                           {
                               regData: {
                                   firstName: $.trim($scope.firstName),
                                   lastName: $.trim($scope.lastName),
                                   agency: $.trim($scope.agency),
                                   phoneNumber: $.trim($scope.phoneNumber)
                               }
                           });
            usSpinnerService.stop("spinner-1");
        }
    }])
.controller('SignUpAssistantStep2Controller', ['$scope', '$rootScope', '$http', '$state', 'moduleServices',
    'CommonDataService', 'usSpinnerService', '$stateParams', 'ServiceProvidersService', 'ModalServiceExt',
    // ReSharper disable InconsistentNaming
    function ($scope, $rootScope, $http, $state, $moduleServices, CommonDataService,
        usSpinnerService, $stateParams, ServiceProvidersService, ModalServiceExt) {
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming

        $scope.Model.password = '';

        $scope.cancel = function () {
            $state.goRelativeTo('SignUpAssistant', 'Step1');
        };

        $scope.errors = [];

        var loadingText = _t('Loading...');
        $scope.passRequirements = [loadingText];
        $scope.SecurityQuestions = [loadingText];
        $scope.Model.securityQuestion = loadingText;

        usSpinnerService.spin("spinner-1");
        ServiceProvidersService.getCurrentProvider().then(
            function(providerData) {
                $rootScope.webServicesUrl = providerData.ApiUrl;
                $rootScope.serviceUrl = providerData.ApiUrl + 'api/Registration/Register/';
                CommonDataService.getCommonData($rootScope.webServicesUrl)
                    .then(function(data) {
                            usSpinnerService.stop('spinner-1');
                            $scope.paswdMinLength = data.PasswordLength;
                            $scope.passRequirements = data.PasswordRequirements;
                            $scope.minUserIdLength = data.MinUserIdLength;
                        },
                        function() {
                            usSpinnerService.stop("spinner-1");
                            $scope.errors.push(utilli.errors.serverErrorMessage);
                        });

                $http.get(providerData.ApiUrl + 'api/StaticData/GetSecurityQuestions/')
                    .then(function(resp) {
                            var sequrityQeuestions = JSON.parse(resp.data);
                            $scope.SecurityQuestions = sequrityQeuestions;
                            $scope.Model.securityQuestion = $scope.SecurityQuestions[0];
                        },
                        function() {
                            $scope.errors.push(utilli.errors.serverErrorMessage);
                        });
            },
            function() {
                usSpinnerService.stop("spinner-1");
                $scope.errors.push(utilli.errors.serverErrorMessage);
            });

        $scope.getPasswdMinLength = function () {
            var result = $scope.paswdMinLength ? $scope.paswdMinLength : 1;
            return result;
        }

        $scope.isPasswordValid = function () {
            var isValid = utilli.isPasswordValid($scope.Model.userName, $scope.Model.password,
                $scope.confirmPassword, $scope.Model.paswdMinLength);
            return isValid;
        }

        $scope.hasDigits = function () {
            return utilli.hasDigits($scope.password);
        };

        $scope.hasLetters = function () {
            return utilli.hasLetters($scope.password);
        };

        $scope.errors = [];

        $scope.checkLoginInfoFormSubmit = function () {
            usSpinnerService.spin("spinner-1");
            if (!$scope.formUserInfo.$valid || !$scope.isPasswordValid()) {
                $scope.submitted = true;
                usSpinnerService.stop("spinner-1");
                return;
            }
            var data = {
                firstName: $.trim($scope.Model.firstName),
                lastName: $.trim($scope.Model.lastName),
                agency: $.trim($scope.Model.agency),
                phoneNumber: $.trim($scope.Model.phoneNumber),

                userName: $.trim($scope.Model.userName),
                email: $.trim($scope.Model.email),
                password: $.trim($scope.Model.password),
                securityQuestion: $scope.Model.securityQuestion,
                securityAnswer: $.trim($scope.Model.securityAnswer)
            };

            $http({
                url: $rootScope.webServicesUrl + 'api/Assistant/ValidateRegisterData/',
                method: "POST",
                data: data
            }).success(function (response) {
                if (response == undefined || response.HasErrors == undefined) {
                    ModalServiceExt.showServerError();
                    usSpinnerService.stop("spinner-1");
                    return;
                }
                if (response.HasErrors) {
                    $scope.errors = response.Errors;
                    utilli.scrollTop();
                }
                else {
                    $state.goRelativeTo('SignUpAssistant', 'Step3');
                }
                usSpinnerService.stop("spinner-1");
            }).error(function () {
                usSpinnerService.stop("spinner-1");
                ModalServiceExt.showError(utilli.errors.serverErrorMessage);
            });
        }
    }])
.controller('SignUpAssistantStep3Controller', ['$scope', '$rootScope', '$http', '$state', '$stateParams', 'moduleServices',
    'CommonDataService', 'usSpinnerService', '$sce', 'ModalServiceExt',
    // ReSharper disable InconsistentNaming
    function ($scope, $rootScope, $http, $state, $stateParams, $moduleServices, CommonDataService, usSpinnerService,
        $sce, ModalServiceExt) {
        // ReSharper restore InconsistentNaming
        $scope.errors = [];

        $scope.cancel = function () {
            $state.goRelativeTo('SignUpAssistant', 'Step2');
        };

        $scope.loadTermsAndConditions = function () {
            usSpinnerService.spin("spinner-1");
            var url = $rootScope.webServicesUrl + 'api/StaticData/GetTermsAndConditions';
            $http({
                url: url,
                method: 'GET'
            }).success(function(data) {
                usSpinnerService.stop("spinner-1");
                $scope.html = $sce.trustAsHtml(data);
            }).error(function() {
                usSpinnerService.stop("spinner-1");
                $scope.errors.push(utilli.errors.serverErrorMessage);
            });
        }

        $scope.TermAndConditionsFormSubmit = function () {
            usSpinnerService.spin("spinner-1");
            $moduleServices.hideKeyboard();
            checkTermAndConditionsFormSubmit();
        };

        function checkTermAndConditionsFormSubmit() {
            var data = {
                firstName: $.trim($scope.Model.firstName),
                lastName: $.trim($scope.Model.lastName),
                agency: $.trim($scope.Model.agency),
                phoneNumber: $.trim($scope.Model.phoneNumber),

                userName: $.trim($scope.Model.userName),
                email: $.trim($scope.Model.email),
                password: $.trim($scope.Model.password),
                securityQuestion: $scope.Model.securityQuestion,
                securityAnswer: $.trim($scope.Model.securityAnswer)
            };
            
            $rootScope.SecureData.userNameOrEmail = $.trim($scope.Model.email);

            $http({
                url: $rootScope.webServicesUrl + 'api/Assistant/Register/',
                method: "POST",
                data: data
            }).success(function (response) {
                if (response == undefined || response.HasErrors == undefined) {
                    ModalServiceExt.showServerError();
                    usSpinnerService.stop("spinner-1");
                    return;
                }
                if (response.HasErrors) {
                    ModalServiceExt.showError(response.Errors[0]);
                }
                else {
                    $state.goRelativeTo('SignUpAssistant', 'Success');
                }
                usSpinnerService.stop("spinner-1");
            }).error(function () {
                usSpinnerService.stop("spinner-1");
                ModalServiceExt.showError(utilli.errors.serverErrorMessage);
            });
        }

    }])
.controller('SignUpAssistantSuccessController', ['$scope', '$rootScope', 'CommonDataService',
    'usSpinnerService', '$state',
// ReSharper disable InconsistentNaming
    function ($scope, $rootScope, CommonDataService, usSpinnerService, $state) {
// ReSharper restore InconsistentNaming
        $scope.errors = [];
        CommonDataService.getCommonData($rootScope.webServicesUrl)
            .then(function (commonData) {
                $scope.companyNameLong = commonData.CompanyNameLong;
                $scope.companyNameLongWithoutTrailingPeriod = commonData.CompanyNameLongWithoutTrailingPeriod;
                $scope.helpEmail = commonData.CompanyHelpEmail;

                $scope.userEmail = $rootScope.SecureData.userNameOrEmail;
                usSpinnerService.stop('spinner-1');

                $scope.SuccessOk = function () {
                    $state.go('TopMenuLayout.WelcomeAssistant', null, { reload: true });
                }
            });
    }]);
'use strict';
angular.module('utilliApp')
.controller('AssistantProfileController', ['$scope', '$http', '$window', 'usSpinnerService', '$state', '$stateParams',
        'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt', 'avatarsService',
    function ($scope, $http, $window, usSpinnerService, $state, $stateParams, 
        // ReSharper disable InconsistentNaming
        LeftMenuService, CommonHeaderService, ModalServiceExt,
        // ReSharper restore InconsistentNaming
        avatarsService) {

        // ReSharper disable once InconsistentNaming
        var _t = $scope._t;
        CommonHeaderService.setUp(_t('Edit Assistant Profile'));
        LeftMenuService.setCurrentTab('AssistantProfile');

        $scope.phoneNumberMask = Config.phoneNumberMask;
        var apiUrl = localStorage.getItem('ApiUrl');
        $scope.errors = [];

        init();

        $scope.save = function () {
            $scope.submitted = true;
            if(!$scope.editProfileForm.$valid){
                return;
            }
            usSpinnerService.spin('spinner-1');
            var postData = {};
            $window.jQuery.extend(postData, $scope.userData);
            var countryCode = utilli.getCountryPhoneNumberCode();
            postData.PhoneNumber = countryCode + postData.PhoneNumber;
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Assistant/EditProfile/',
                method: "POST",
                data: postData
            }).success(function (response) {
                utilli.handleAjaxResponse(response, ModalServiceExt, function () {
                    ModalServiceExt.showInfo(_t('Your profile has been saved.'));
                });
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                $scope.errors.push({ Message: utilli.serverErrorMessage });
            });
        }

        $scope.changeAvatar = function () {
            $state.goMainLayout('Avatars', { forAssistant: true });
        };

        function init() {
            usSpinnerService.spin('spinner-1');
            $http({
                method: 'GET',
                url: apiUrl + 'api/Assistant/GetProfile'
            }).success(function(data) {
                usSpinnerService.stop('spinner-1');
                $scope.userData = data.Data;
                avatarsService.setCurrentAvatar(apiUrl + $scope.userData.AvatarPath);
            }).error(function() {
                usSpinnerService.stop('spinner-1');
                $scope.errors.push({ Message: utilli.serverErrorMessage });
            });
        };
    }]);
'use strict';
angular.module('utilliApp')
    .controller('WelcomeMobileController', ['$state', '$scope',
        function ($state, $scope) {
            if (utilli.goesToDefaultPage($state)) return;

            $scope.enableLanguagePack = utilli.isLanguagePackEnabled();

            var language = localStorage.getItem('language');
            var languageParams = _.find(utilli.languages[DeploymentSettings.providersGroupShortName.toLowerCase()], function (x) { return language === x.abbreviation });
            if (!languageParams)
                $scope.currentLanguage = 'English';
            else
                $scope.currentLanguage = languageParams.name;

            $scope.goToLanguages = function () {
                $state.go('TopMenuLayout.Languages');
            }

            $scope.goToSignIn = function () {
                $state.goToSignIn();
            }

            $scope.goToSignUp = function () {
                $state.goToSignUp();
            }
        }]);
'use strict';
angular.module('utilliApp')
.factory('SignInService', ['$http', '$rootScope', '$q', 'usSpinnerService', '$state', 'DueReminderService',
    'CommonDataService',
    function ($http, $rootScope, $q, usSpinnerService, $state, DueReminderService, CommonDataService) {
        var svc = {};
        svc.services = [];
        svc.errors = {};
        svc.showResentVerificationEmailField = false;

        svc.resetErrors = function() {
            svc.errors.errorFromServerReturned = false;
            svc.errors.serverErrorInformation = null;
            svc.errors.serverErrors = null;
            svc.errors.showServerErrors = false;
            svc.showResentVerificationEmailField = false;
        }

        function getFromPart(fromAddress) {
            if (utilli.isDebug)
                console.log('redirection from SignInService to Admin portal page ' + fromAddress);

            var redirectedFrom = JSON.parse(fromAddress);
            var fromPart = redirectedFrom.stateName

            if (redirectedFrom.stateParams) {
                _.each(redirectedFrom.stateParams, function (param) {
                    fromPart += '/' + param;
                });
            }

            return fromPart;
        }

        function redirect(state, defaulState) {
            var redirectTo = JSON.parse(state);
            // We need this check for scenario when user tried to enter admin portal by direct url in browser without loging in.
            // After this user will be redirected to sign in page with 'from' part in the url. But after being redirected to 'sign in' page 
            // user desided to log in as regular user (not admin). 
            // In this case 'from' state does not exist for user portal and we should ignore it.
            var checkState = $state.get(redirectTo.stateName);
            if (checkState) {
                if (utilli.isDebug)
                    console.log('redirection from SignInService to ' + state);
                $state.go(redirectTo.stateName, redirectTo.stateParams);
            }
            else {
                $state.goMainLayout(defaulState);
            }
        }

        function _getCurrentProviderName () { 
            var serviceProviderName = localStorage.getItem('ServiceProviderName');
            if(!utilli.checkDefinedValue(serviceProviderName))
                return null;
            for (var providerName in Config.providers){
                var provider = Config.providers[providerName];
                if (provider.Name && provider.Name == serviceProviderName)
                     return providerName;
            }
            return null;
        }

        /**
         * Sets on the scope touchIdAvailable field
         * @param {angularJs scope} scope 
         */
        svc.setIsTouchIdAvailable = function(scope){
            try {
                if (isMobileOrRipple()){
                    if (isAndroid()) {
                        FingerprintAuth.isAvailable(isAvailableSuccess, isAvailableError);
                    } else if (iOS()) {
                        window.plugins.touchid.isAvailable(isAvailableSuccess, isAvailableError);
                    }
                }
            }
            catch (e) {
                console.error('Failed to check if finger print API is available: ' + JSON.stringify(e));
            }

            function isAvailableSuccess(result) {
                console.log("FingerprintAuth available: " + JSON.stringify(result));
                if (isAndroid()) {
                    scope.touchIdAvailable = result.isAvailable && result.hasEnrolledFingerprints;
                }
                else if (iOS()) {
                    scope.touchIdAvailable = true;
                }
            }

            function isAvailableError(message) {
                console.log("isAvailableError(): " + message);
                scope.touchIdAvailable = false;
            }
        }

        svc.signIn = function (login, passwd, apiUrl, serviceProviderName, fromAddress, 
            isTouchIdAvailable, touchIdRefreshToken) {
            var result = $q.defer();
            usSpinnerService.spin('spinner-1');
            var parameters = {
                userNameOrEmail: $.trim(login),
                password: $.trim(passwd),
                client: isMobileOrRipple() ? utilli.clientEnum.mobileApp : utilli.clientEnum.portal,
                mobilePlatform: isMobileOrRipple() ? utilli.getPlatformName() : '',
                rememberMe: false,
                mobileDeviceToken: isMobileOrRipple() ? utilli.getDeviceToken() : '',
                isTouchIdAvailable: isTouchIdAvailable ? true : false,
                touchIdRefreshToken: touchIdRefreshToken
            };

            $http.post(apiUrl + 'api/Account/LogOn/', parameters)
            .success(function (response) {
                if (!response) {
                    var errorMessage = $rootScope._t("Server error. Try again later.");
                    result.reject(errorMessage);
                    svc.errors.errorFromServerReturned = true;
                    svc.errors.serverErrorInformation = errorMessage;
                }
                else if (response.ERROR_LIST.length > 0) {
                    svc.errors.showServerErrors = true;
                    svc.errors.serverErrors = response.ERROR_LIST;
                    if (response.ERROR_LIST[0].key == "IncompleteRegistrationError"){
                        svc.showResentVerificationEmailField = true;
                        CommonDataService.getCommonData(apiUrl).then(function (commonData) {
                            $rootScope.contactPhoneNumber = commonData.SupportPhone;
                            $rootScope.workingHours = commonData.WorkingHours;
                            $rootScope.billingEmailTo = commonData.BillingEmailTo;
                            $rootScope.serviceProviderName = commonData.CompanyName;
                            result.reject(response.ERROR_LIST[0].Message);
                            usSpinnerService.stop('spinner-1');
                        });
                        return;// return because the spinner must spin until common data is received
                    }
                    else {
                        svc.showResentVerificationEmailField = false;
                    }
                    result.reject(response.ERROR_LIST[0].Message);
                }
                else if (response.Valid != 1) {
                    var errorMessage = $rootScope._t("We cannot check your credentials. Please try again later.");
                    svc.errors.errorFromServerReturned = true;
                    svc.errors.serverErrorInformation = errorMessage;
                    result.reject(errorMessage);
                }
                else {
                    result.resolve();
                    svc.errors.errorFromServerReturned = false;
                    svc.errors.showServerErrors = false;

                    if (isTouchIdAvailable){
                        localStorage.setItem('touchIdData', JSON.stringify({
                            lastApiUrl: apiUrl,
                            lastServiceProviderName: serviceProviderName,
                            refreshToken: response.TouchIdRefreshToken
                        }));
                    }
                    localStorage.setItem('SecurityToken', response.SecurityToken);
                    localStorage.setItem('ApiUrl', apiUrl);
                    localStorage.setItem('ServiceProviderName', serviceProviderName);
                    localStorage.setItem('language', response.Language);

                    if (!DeploymentSettings.currentServiceProvider) 
                        DeploymentSettings.currentServiceProvider = _getCurrentProviderName();

                    if (!isMobileOrRipple() && response.IsAdmin) {
                        // TODO: may be admin portal url and user portal url should be saved in the config or DeploymentSettings.js
                        var adminUrl = window.location.origin + window.location.pathname + 'Admin/#/';
                        if (fromAddress)
                            adminUrl += getFromPart(fromAddress);
                        utilli.setWindowLocation(adminUrl);
                        return;
                    }

                    localStorage.setItem('CurrentAccountNumber', response.CurrentAccountNo);
                    localStorage.setItem('BusinessPartner', response.BusinessPartner);
                    localStorage.setItem('current_user', response.UserName);
                    localStorage.setItem('email', response.Email);

                    if (response.CurrentAccountNo) {
                        DueReminderService.unmarkAsShown();
                        if (fromAddress) {
                            redirect(fromAddress, 'Dashboard');
                        } else
                            $state.goMainLayout('Dashboard');
                    }
                    else if (utilli.hasAgentRole())
                        $state.goMainLayout('Search');
                    else if (utilli.hasAssistantRole())
                        $state.goMainLayout('AssistantSearch');
                    else if (utilli.hasFieldServiceEngineerRole())
                        $state.goMainLayout('WorkCenters');
                    else if (utilli.hasPropertyManagerRole()) {
                        localStorage.setItem('showEsScoreInfoPopup', 'true');
                        if (fromAddress) {
                            redirect(fromAddress, 'PropertyList');
                        } else {
                            $state.goMainLayout('PropertyList');
                        }
                    }
                }
                usSpinnerService.stop('spinner-1');
            }).error(function (e) {
                var errorMessage = $rootScope._t("Server error. Try again later.");
                result.reject(errorMessage);
                svc.errors.errorFromServerReturned = true;
                svc.errors.serverErrorInformation = errorMessage;
                usSpinnerService.stop('spinner-1');
            });
            return result.promise;
        };

        svc.resendVerificationEmail = function (login, passwd, apiUrl, serviceProviderName) {
            usSpinnerService.spin('spinner-1');
            var parameters = {
                userNameOrEmail: $.trim(login),
                password: $.trim(passwd),
            };
            $http({
                url: apiUrl + 'api/Account/SendChallengeEmail/',
                method: "POST",
                params: parameters
            }).success(function (response) {
                  usSpinnerService.stop('spinner-1');
                }).error(function (e) {
                    svc.errors.errorFromServerReturned = true;
                    svc.errors.serverErrorInformation = $rootScope._t("Server error. Try again later.");
                    usSpinnerService.stop('spinner-1');
            });
        };

        svc.showResendVerificationEmail = function () {
            return svc.showResentVerificationEmailField;
        }

        return svc;
    }]);

'use strict';
var app = angular.module('utilliApp');

app.controller('SignInPartController', ['$scope', '$rootScope', '$window', '$state', 'CommonHeaderService',
    function ($scope, $rootScope, $window, $state, CommonHeaderService) {
        CommonHeaderService.setUp();
        $rootScope.errorFromServerReturned = false;
        $rootScope.showServerErrors = false;
        $rootScope.serverErrorInformation = '';
        $rootScope.serverErrors = [];

        $scope.back = function() {
            $state.go('Welcome');
        };
    }]);
'use strict';
var app = angular.module('utilliApp');

app.controller('CredentialsController', ['$scope', '$state', '$http', 'usSpinnerService', 'SignInService', 
    '$stateParams', 'CommonHeaderService', 'CheckVersionService', '$q',
        function ($scope, $state, $http, usSpinnerService, SignInService, $stateParams, CommonHeaderService,
            CheckVersionService, $q) {
            var touchIdClientId = "UtilliTouchIdClientId";
            $scope.touchIdAvailable = false;
            SignInService.setIsTouchIdAvailable($scope);
            $scope.hasTouchIdData = localStorage.getItem('touchIdData') != null;

            $scope.loginWithTouchId = function () {
                if (!isMobileOrRipple())
                    return;
                if (isAndroid()) {
                    FingerprintAuth.encrypt({ clientId: touchIdClientId }, fingerPrintSuccess, fingerPrintError);
                } else if (iOS()) {
                    window.plugins.touchid.verifyFingerprint(
                        'Scan your fingerprint please', // this will be shown in the native scanner popup
                        fingerPrintSuccess, fingerPrintError
                    );
                }
            }

            function fingerPrintSuccess() {
                var touchIdDataString = localStorage.getItem('touchIdData');
                var touchIdData = touchIdDataString == null ? null : JSON.parse(touchIdDataString);
                SignInService.signIn(null, null,
                    touchIdData.lastApiUrl,
                    touchIdData.lastServiceProviderName,
                    $stateParams.from, $scope.touchIdAvailable, touchIdData.refreshToken);
            }

            function fingerPrintError(error) {
                console.log("FingerprintAuth Error: " + error);
            }
            
            var offline = localStorage.getItem('offline')
            console.log("Offline"+offline);
            if (offline === "1" && window.location.href.indexOf("Maintenance") == -1)
            {
                usSpinnerService.stop('spinner-1');
                $state.go('Maintenance');  
            }

            var checkVersionPromise = CheckVersionService.checkVersion();
            checkVersionPromise.then(function (res) {
                var offline = localStorage.getItem('offline')
                console.log("Offline"+offline);
                console.log(window.location.href.indexOf("Maintenance"))
                if (offline === "1" && window.location.href.indexOf("Maintenance") == -1)
                {
                    usSpinnerService.stop('spinner-1');
                    $state.go('Maintenance');  
                }
            });
            // var offline = localStorage.getItem('offline')
            // console.log("Offline"+offline);
            // if (offline === "1")
            // {
            //     $state.go('Maintenance');  
            // }
            
            localStorage.removeItem('ServiceProviderName');

            CommonHeaderService.hideMenuToggleButton();
            $scope.stepName = 'Login';
            $scope.errors = SignInService.errors;
            $scope.showResentVerificationEmail = function () {
                return SignInService.showResendVerificationEmail();
            }
            $scope.showResentVerificationEmailDone = false;

            var _lastLoginWithRequiredEmail;

            $scope.togglePassword = function (pswId, iconId) {
                utilli.togglePasswordVisibility(pswId, iconId);
            }

            $scope.$watch('credentials.login', function () {
                if ($scope.emailRequired)
                    $scope.emailRequired = false;
                if (_lastLoginWithRequiredEmail != undefined && $scope.credentials.login == _lastLoginWithRequiredEmail)
                    $scope.emailRequired = true;
            });

            if (!$scope.credentials) {
                $scope.credentials = {};
                if (Config.debug) {
                    $scope.credentials.login = 'testUser';
                    $scope.credentials.email = 'max.suhinin+63@gmail.com';
                    $scope.credentials.password = 'online123';
                }
            }

            var gotoAfterVersionChecking = function (state, params) {
                usSpinnerService.spin('spinner-1');
                checkVersionPromise.then(function () {
                    $state.go(state, params);
                    usSpinnerService.stop('spinner-1');
                });
            }

            $scope.goToForgotPassword = function () {
                var state = '';
                var params = null;
                if ($state.current.name.indexOf('WelcomeAgent') > 0 || utilli.isPropertyManagerApp()) {
                    state = 'TopMenuLayout.ForgotPasswordByEmail.Step1';
                    params = { from: $state.current.name }
                } else {
                    state = 'TopMenuLayout.ForgotPassword.Step1';
                }
                gotoAfterVersionChecking(state, params);
            }

            $scope.goToForgotUserId = function () {
                var state = '';
                var params = null;
                if ($state.current.name.indexOf('WelcomeAgent') > 0 || utilli.isPropertyManagerApp()) {
                    state = 'TopMenuLayout.ForgotUserIdByEmail.Step1';
                    params = { from: $state.current.name }
                } else {
                    state = 'TopMenuLayout.ForgotUserId.Step1';
                }
                gotoAfterVersionChecking(state, params);
            }

            $scope.backVisible = isMobileOrRipple();

            $scope.back = function () {
                $state.goToWelcome();
            };

            $scope.resentVerificationEmail = function () {
                var copyServices = SignInService.services.slice();

                SignInService.resendVerificationEmail($scope.credentials.login,
                    $scope.credentials.password,
                    copyServices[0].ApiUrl,
                    copyServices[0].Name);

                $scope.showResentVerificationEmailDone = true;
            }

            $scope.next = function () {
                SignInService.resetErrors();
                $scope.submitted = true;
                if (!$scope.loginForm.$valid || $scope.emailRequired && !$scope.credentials.email) {
                    return;
                }
                if (SignInService.services.length > 0 && $scope.emailRequired)
                {
                    var copyServices = SignInService.services.slice();
                    var i = 0;
                    var isMaintenance = _.any(copyServices, function (item) { return !item.IsAvailable })
                    while (i < copyServices.length)
                    {
                        if (!copyServices[i].UserData && isMaintenance) {
                            i++;
                            continue;
                        }
                        if ($scope.credentials.email.toUpperCase() != copyServices[i].UserData.Email.toUpperCase())
                        {
                            copyServices.splice(i, 1);
                            continue;
                        }
                        i++;
                    }

                    if (copyServices.length == 0)
                    {
                        // wrong email
                        $scope.emailError = 'There is no registered users with such email address.';
                    }
                    else if (copyServices.length == 1)
                    {
                        SignInService.signIn($scope.credentials.login,
                            $scope.credentials.password,
                            copyServices[0].ApiUrl,
                            copyServices[0].Name,
                            $stateParams.from, $scope.touchIdAvailable);
                    }
                    else
                    {
                        SignInService.services = copyServices;
                        $state.goFromWelcomeTo('SignIn.Providers', {
                            signInParams: {
                                from: $stateParams.from,
                                login: $scope.credentials.login,
                                passwd: $scope.credentials.password
                            }
                        });
                    }

                    return;
                }

                var checkProvidersPromise =  checkServiceProviders();
                $q.all([checkVersionPromise, checkProvidersPromise]).then(function (data) {
                    var checkVersionResult = data[0];
                    var checkProvidersSuccess = data[1];
                    if (CheckVersionService.isVersionCorrect(checkVersionResult)) {
                        if (checkProvidersSuccess) {
                            loginByProvider();
                        }
                    }
                    else if (CheckVersionService.isVersionWrong(checkVersionResult)) {
                        $state.go('UpdateApp');
                    }
                    else {
                        $state.go('NoConnection');
                    }
                }, function (err) {
                    setError(err && err.Message
                        ? err.Message
                        : err ? err : utilli.errors.serverErrorMessage);
                });
            };

            function resetErrors() {
                $scope.errors.errorFromServerReturned = false;
                $scope.errors.showServerErrors = false;
                $scope.errors.serverErrorInformation = '';
                $scope.errors.serverErrors = [];
                $scope.showResentVerificationEmailDone = false;
            }

            function setError(message) {
                $scope.errors.errorFromServerReturned = true;
                $scope.errors.serverErrorInformation = message;
            }

            function setErrors(errors, isVisible) {
                $scope.errors.serverErrors = errors;
                $scope.errors.showServerErrors = isVisible;
            }

            function checkServiceProviders() {
                usSpinnerService.spin('spinner-1');

                var deferred = $q.defer();

                $scope.submitted = false;
                resetErrors();

                var login = { login: $scope.credentials.login };
                var providersApiUrl = DeploymentSettings.providersServiceUrl;

                // most devices replace the first letter in login to capital case,
                // but login names are case insensitive, so Appreviewer is also correct
                if ($scope.credentials.login && $scope.credentials.login.toLowerCase() == 'appreviewer') {
                    if(DeploymentSettings.providersGroupShortName == Config.wglProvidersGroupShortName )
                        providersApiUrl = "https://apistaging.utilli.com/wgl-providers/api/";
                    else if (DeploymentSettings.providersGroupShortName == Config.hcProvidersGroupShortName)
                        providersApiUrl = "https://apistaging.utilli.com/hc-providers/api/";
                    else if (DeploymentSettings.providersGroupShortName == Config.pxProvidersGroupShortName)
                        providersApiUrl = "https://apistaging.utilli.com/px-providers/api/";
                    else
                        providersApiUrl = "https://apistaging.utilli.com/api/";
                }

                var url = providersApiUrl + 'Providers/GetProviders';
                $http({
                    url: url,
                    method: 'GET',
                    params: login
                }).success(function (data) {
                    if (!data) {
                        setError("Server error. Try again later.");
                        deferred.reject();
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    // if there is no items then userid wasn't found
                    if (data.length == 0) {
                        setError($scope._t("Login name") + " '" + login.login + "' " +  $scope._t("is not registered."));
                        deferred.reject($scope._t("Login name") + " '" + login.login + "' " + $scope._t("is not registered."));
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    SignInService.services = data;
                    usSpinnerService.stop('spinner-1');
                    deferred.resolve(data);
                }
                ).error(function () {
                    setError("Server error. Try again later.");
                    deferred.reject("Server error. Try again later.");
                    usSpinnerService.stop('spinner-1');
                });
                return deferred.promise;
            }

            function loginByProvider() {
                // if it's a regular portal then we should use only the provider that is relevant for the current portal
                if (!!DeploymentSettings.currentServiceProvider) {
                    var currentServiceProvider = DeploymentSettings.currentServiceProvider;
                    var currentProviderName = Config.providers[currentServiceProvider].Name;
                    var providersFiltered = $.grep(SignInService.services, function (item) {
                        return item.Name == currentProviderName;
                    });
                    if (!providersFiltered || providersFiltered.length !== 1) {
                        setError($scope._t("Login name") + " '" + $scope.credentials.login + "' " + $scope._t("is not registered."));
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    if (SignInService.services && SignInService.services.length == 1 
                        && !SignInService.services[0].IsAvailable) {
                        
                        usSpinnerService.stop('spinner-1');
                        $state.go('Maintenance');     
                        return;
                    }
                    SignInService.signIn($scope.credentials.login,
                            $scope.credentials.password,
                            providersFiltered[0].ApiUrl,
                            providersFiltered[0].Name,
                            $stateParams.from, $scope.touchIdAvailable);
                    return;
                }
                // if we are here then it's not a regular portal. it's either mobile/ripple or common portal (like portal.utilli.com).
                // and at least one result is found.
                // if it is only one result then just try login, since it's the case when
                // on mobile for a given user id we have only one user.
                // there is no need to ask into which service provider he wants to login
                if (SignInService.services.length == 1) {

                    SignInService.signIn($scope.credentials.login,
                            $scope.credentials.password,
                            SignInService.services[0].ApiUrl,
                            SignInService.services[0].Name,
                            $stateParams.from, $scope.touchIdAvailable);
                    return;
                }
                // if we are here then there are more than one users for different companies
                // if they all are registered using the same email then just go to the page
                // where this user can select company into which he wants to login
                if (!isEmailRequired(SignInService.services)) {
                    usSpinnerService.stop('spinner-1');
                    $state.goFromWelcomeTo('SignIn.Providers', {
                        signInParams: {
                            from: $stateParams.from,
                            login: $scope.credentials.login,
                            passwd: $scope.credentials.password
                        }
                    });
                }
                // if we are here then there are at least 2 emails for one userid
                // this can be a case when 2 users choosed one userid independently during
                // registration on portals where we don't check uniqueness of the userid
                // across all portals. hence we need to ask this user to specify his email
                // so that we will be able to identify his company.
                // idea is that such userid collisions will be very rare all not happen.
                // and if they happen then for such users it will be more convenient to login
                // using email
                $scope.credentials.email = '';
                $scope.emailRequired = true;
                _lastLoginWithRequiredEmail = $scope.credentials.login;
                usSpinnerService.stop('spinner-1');// stop the spinner to allow user to enter email
            }

            function isEmailRequired(data) {
                if (_.any(data, function (item) { return !item.IsAvailable })) {
                    return true;
                }
                //if all email is the same we return false
                var email = data[0].UserData.Email;
                for (var i = 1; i < data.length; i++) {
                    if (data[i].UserData.Email.toUpperCase() === email.toUpperCase())
                        continue;
                    else 
                        return true;
                }
                return false;
            }
        }
    ]).directive('capsLock', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {

                scope.capsLockFlags = [];
                scope.resetCapsLockFlags = function() {
                    scope.capsLockFlags.forEach(function(item) {
                        scope[item] = false;
                    });
                }

                // If element lost focus - hide warning
                element.bind('blur', function(e) {
                    scope.resetCapsLockFlags();
                });

                element.bind('keypress', function(e) {
                    // If letter is from a to z, set false
                    if (e.which >= 97 && e.which <= 122) {
                        scope.resetCapsLockFlags();
                        scope.$apply();
                    }
                    // If letter from A to Z and shift is not on, set true
                    else if (e.which >= 65 && e.which <= 90 && !e.shiftKey) {
                        scope[attr.capsLock] = true;
                        if (!scope.capsLockFlags.includes(attr.capsLock))
                            scope.capsLockFlags.push(attr.capsLock);
                        scope.$apply();
                    }
                });

                element.bind('keydown', function(e) {
                    if (e.which === 20) {
                        scope.resetCapsLockFlags();
                        scope.$apply();
                    }
                });
            }
        }
    });

'use strict';
var app = angular.module('utilliApp');

app.controller('ProvidersController', ['$scope', 'SignInService', '$state', '$stateParams',
    function ($scope, SignInService, $state, $stateParams) {
        $scope.stepName = 'Select Service Provider';
        $scope.services = SignInService.services;
        var selectedService = -1;
        $scope.touchIdAvailable = false;
        SignInService.setIsTouchIdAvailable($scope);

        $scope.radioClick = function(index)
        {
            if (selectedService >= 0)
            {
                $('#service' + selectedService).removeClass('service-active');
                $("input[name='radio" + selectedService + "']").prop('checked', false);
            }

            $('#service' + index).addClass('service-active');
            $("input[name='radio" + index + "']").prop('checked', true);
            selectedService = index;
            var provider = SignInService.services[selectedService];
            SignInService.signIn($stateParams.signInParams.login,
                            $stateParams.signInParams.passwd,
                            provider.ApiUrl,
                            provider.Name,
                            $stateParams.signInParams.from, 
                            $scope.touchIdAvailable).
                then(function () { }, function (error) {
                    $scope.error = error;
                    resetErrors();
                });
        }

        function resetErrors() {
            SignInService.errors.errorFromServerReturned = false;
            SignInService.errors.showServerErrors = false;
            SignInService.errors.serverErrorInformation = '';
            SignInService.errors.serverErrors = [];
        }

        $scope.back = function () {
            $state.goFromWelcomeTo('SignIn.Credentials');
        }
    }]);
'use strict';
angular.module('utilliApp')
.controller('SignUpController', ['$scope', '$state', 'CommonHeaderService', 'RegistrationInfoService', '$stateParams',
    function ($scope, $state, CommonHeaderService, RegistrationInfoService, $stateParams) {
        CommonHeaderService.hideMenuToggleButton();

        tryToInitRegistrationInfoService();
        $scope.cancel = function () {
            $state.goToWelcome();
        };
        function tryToInitRegistrationInfoService(){
            RegistrationInfoService.userInfo.accountnumber = $stateParams.accountnumber;
            RegistrationInfoService.userInfo.zip = $stateParams.zip;
            RegistrationInfoService.userInfo.token = $stateParams.token;
            RegistrationInfoService.userInfo.customerfullname = $stateParams.customerfullname;
        }
    }])
.controller('SignUpStep1Controller', ['$scope', '$rootScope', '$http', '$state', 'moduleServices',
    'usSpinnerService', 'ServiceProvidersService', '$stateParams', 'CheckVersionService', '$q', 'RegistrationInfoService',
    function ($scope, $rootScope, $http, $state, $moduleServices, usSpinnerService, ServiceProvidersService,
        $stateParams, CheckVersionService, $q, RegistrationInfoService) {

        utilli.fixSelectElementForMobile();

        var checkVersionPromise = CheckVersionService.checkVersion();
        $scope.accountMaxLength = Config.contractAccountMaxLength;
        $scope.providers = [];
        $scope.provider = {};
        $scope.errors = [];
        $scope.isProviderListVisible = false;

        getProviderInfo();

        $scope.initForm = function () {
            var isDataExist = RegistrationInfoService.userInfo.accountnumber != undefined 
                && RegistrationInfoService.userInfo.zip != undefined
                && RegistrationInfoService.userInfo.customerfullname != undefined;
            if (isDataExist) {
                $scope.AccountNumber = RegistrationInfoService.userInfo.accountnumber;
                $scope.ZipCode = RegistrationInfoService.userInfo.zip;
                $scope.FullName = RegistrationInfoService.userInfo.customerfullname;
            }
        };

        $scope.submit = function () {
            ServiceProvidersService.setCurrentProvider($scope.provider);
            usSpinnerService.spin("spinner-1");
            $moduleServices.hideKeyboard();

            if (!$scope.formAccountInfo.$valid) {
                $scope.submitted = true;
                usSpinnerService.stop("spinner-1");
                return;
            }

            $rootScope.serviceUrl = $scope.provider.ApiUrl + 'api/Registration/Register/';
            $rootScope.webServicesUrl = $scope.provider.ApiUrl;
            var checkAccountInfoPromise = checkAccountInfo();

            $q.all([checkVersionPromise, checkAccountInfoPromise]).then(function (data) {
                var checkVersionResult = data[0];
                var checkAccountInfoResult = data[1];
                if (CheckVersionService.isVersionCorrect(checkVersionResult)) {
                    if (checkAccountInfoResult) {
                        RegistrationInfoService.userInfo.accountnumber = $.trim($scope.AccountNumber);
                        RegistrationInfoService.userInfo.zip = $.trim($scope.ZipCode);
                        RegistrationInfoService.userInfo.customerfullname = $.trim($scope.FullName);
                        RegistrationInfoService.userInfo.token = $scope.token;
                        $state.goRelativeTo('SignUp', 'Step2');
                    }
                }
                else if (CheckVersionService.isVersionWrong(checkVersionResult)) {
                    $state.go('UpdateApp');
                }
                else {
                    $state.go('NoConnection');
                }
            }, function (err) {
                $scope.errors.push(err && err.Message ? err.Message : utilli.errors.serverErrorMessage);
            });
        };

        function getProviderInfo () { 
            usSpinnerService.spin("spinner-1");
            if (!DeploymentSettings.currentServiceProvider) {
                ServiceProvidersService.getProviders()
                    .then(
                        function(allProviders) {
                            usSpinnerService.stop("spinner-1");
                            $scope.isProviderListVisible = allProviders.length > 1;
                            $scope.providers = allProviders;
                            $scope.provider = allProviders[0];
                        },
                        function() {
                            usSpinnerService.stop("spinner-1");
                            $scope.errors.push(utilli.errors.serverErrorMessage);
                        }
                    );
            }
            else {
                ServiceProvidersService.getCurrentProvider()
                    .then(function (providerData) {
                        usSpinnerService.stop("spinner-1");
                        $scope.provider = providerData;
                    },
                    function () {
                        usSpinnerService.stop("spinner-1");
                        $scope.errors.push(utilli.errors.serverErrorMessage);
                    }
                );
            }
        }

        function checkAccountInfo() {
            var deferred = $q.defer();
            var data = {
                AccountNumber: $scope.AccountNumber,
                ZipCode: $scope.ZipCode,
                FullName: $scope.FullName,
                Step: 1,
                Client: isMobileOrRipple() ? utilli.clientEnum.mobileApp : utilli.clientEnum.portal
            }
            $http({
                url: $rootScope.serviceUrl,
                method: "POST",
                data: data
            }).success(function (response) {
                usSpinnerService.stop("spinner-1");
                if (response) {
                    if (response.Errors != null && response.Errors.length > 0) {
                        $scope.errors = response.Errors;
                        deferred.resolve(false);
                    }
                    else {
                        $scope.token = response.Token;
                        $scope.AccountNumber = response.NonLegacyAccount;
                        $scope.serviceProvider = $scope.provider;
                        deferred.resolve(true);
                    }
                }
                else {
                    $scope.errors.push(utilli.errors.serverErrorMessage);
                    deferred.resolve(false);
                }
            }).error(function () {
                deferred.reject();
                $scope.errors.push(utilli.errors.serverErrorMessage);
                usSpinnerService.stop("spinner-1");
            });
            return deferred.promise;
        }
    }])
.controller('SignUpStep2Controller', ['$scope', '$rootScope', '$http', '$state', 'CommonDataService', 
    'usSpinnerService', '$stateParams', 'ServiceProvidersService', 'RegistrationInfoService', '$q',
    // ReSharper disable InconsistentNaming
    function ($scope, $rootScope, $http, $state, CommonDataService, usSpinnerService, $stateParams,
        ServiceProvidersService, RegistrationInfoService,$q) {
        
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming

        if ($stateParams.email) {
            $scope.Email = $stateParams.email;
            $scope.Email2 = $stateParams.email;
        }

        var loadingText = _t('Loading...');
        $scope.errors = [];
        $scope.passRequirements = [{ Value: loadingText }];
        $scope.SecurityQuestions = [loadingText];
        $scope.SecurityQuestion = loadingText;

        init();
        initForm();

        utilli.fixSelectElementForMobile();

        $scope.isUserDataCorrect = function () { 
            var result = !$scope.formAccountInfo.UserID.$error.required && 
                !$scope.formAccountInfo.UserID.$error.pattern && 
                !$scope.formAccountInfo.Email.$error.required &&
                !$scope.formAccountInfo.SecurityAnswer.$error.required &&
                !$scope.formAccountInfo.SecurityAnswer.$error.pattern &&
                $scope.UserID.length >= $scope.minUserIdLength;
            return result;
        }

        $scope.isPasswdValid = function () { 
            $scope.passwdErrors = utilli.validatePassword($scope.Password, $scope.UserID, $scope.passRequirements, $scope.paswdMinLength, null, $scope.minUserIdLength);
            $scope.passwordsNotMatch = $scope.Password && $scope.Password !== $scope.ConfirmPassword 
                ? $scope._t('Passwords do not match.')
                : null;
            var result = $scope.passwdErrors.length == 0 && !$scope.passwordsNotMatch;
            return result;
        }

        $scope.submit = function () {
            usSpinnerService.spin('spinner-1');
            $scope.errors = [];
            
            var isUserDataCorrect = $scope.isUserDataCorrect();
            var isPasswdValid = $scope.isPasswdValid();

            if (!$scope.formAccountInfo.$valid || !isUserDataCorrect || !isPasswdValid) {
                $scope.errors.push(utilli.errors.validationErorrsMessage);
                utilli.scrollTop();
                $scope.submitted = true;
                usSpinnerService.stop('spinner-1');
                return;
            }
            
            var data = {
                AccountNumber: RegistrationInfoService.userInfo.accountnumber,
                ZipCode: RegistrationInfoService.userInfo.zip,
                Token: RegistrationInfoService.userInfo.token,
                UserName: $.trim($scope.UserID),
                Email: $.trim($scope.Email.toLowerCase()),
                Password: $scope.Password,
                ConfirmPassword: $scope.ConfirmPassword,
                SecurityQuestion1: $scope.SecurityQuestion,
                SecurityAnswer1: $scope.SecurityAnswer,
                Client: isMobileOrRipple() ? utilli.clientEnum.mobileApp : utilli.clientEnum.portal,
                Step: 2
            }

            $http({
                url: $rootScope.serviceUrl,
                method: "POST",
                data: data
            }).success(function (response) {
                if (response) {
                    if (response.Errors != null && response.Errors.length > 0) {
                        $scope.errors = response.Errors;
                    }
                    else {
                        usSpinnerService.spin('spinner-1');
                        CommonDataService.getCommonData($rootScope.webServicesUrl, true)
                            .then(function () {
                                RegistrationInfoService.userInfo.token = response.Token;
                                RegistrationInfoService.userInfo.user = $.trim($scope.UserID);
                                RegistrationInfoService.userInfo.email = $.trim($scope.Email.toLowerCase());
                                RegistrationInfoService.userInfo.psw = $scope.Password;
                                RegistrationInfoService.userInfo.question = $scope.SecurityQuestion;
                                RegistrationInfoService.userInfo.answer = $scope.SecurityAnswer;
                                $state.goRelativeTo('SignUp', 'Step3');
                                usSpinnerService.stop('spinner-1');
                            }, function () {
                                $scope.errors.push(utilli.errors.serverErrorMessage);
                                usSpinnerService.stop('spinner-1');
                            });
                    }
                }
                else {
                    $scope.errors.push(utilli.errors.serverErrorMessage);
                }
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                $scope.errors.push(utilli.errors.serverErrorMessage);
                usSpinnerService.stop('spinner-1');
            });
        };

        function initForm() {
            $scope.UserID = RegistrationInfoService.userInfo.user;
            $scope.Email = RegistrationInfoService.userInfo.email;
            $scope.Email2 = RegistrationInfoService.userInfo.email;
            $scope.SecurityAnswer = RegistrationInfoService.userInfo.answer;
            $scope.SecurityQuestion = RegistrationInfoService.userInfo.question;
        };

        function init () {
            usSpinnerService.spin("spinner-1");
            ServiceProvidersService.getCurrentProvider().then(
                function (providerData) {
                    $rootScope.webServicesUrl = providerData.ApiUrl;
                    $rootScope.serviceUrl = providerData.ApiUrl + 'api/Registration/Register/';
                    CommonDataService.getCommonData($rootScope.webServicesUrl)
                        .then(function(data) {
                                usSpinnerService.stop('spinner-1');
                                $scope.paswdMinLength = data.PasswordLength;
                                $scope.passRequirements = data.PasswordRequirements;
                                $scope.minUserIdLength = data.MinUserIdLength;
                            },
                            function() {
                                usSpinnerService.stop("spinner-1");
                                $scope.errors.push(utilli.errors.serverErrorMessage);
                            });
    
                    $http.get(providerData.ApiUrl + 'api/StaticData/GetSecurityQuestions/')
                        .then(function(resp) {
                                var sequrityQeuestions = JSON.parse(resp.data);
                                $scope.SecurityQuestions = sequrityQeuestions;
                                $scope.SecurityQuestion = RegistrationInfoService.userInfo.question 
                                    ? RegistrationInfoService.userInfo.question
                                    : $scope.SecurityQuestions[0];
                            },
                            function() {
                                $scope.errors.push(utilli.errors.serverErrorMessage);
                            });
                },
                function() {
                    usSpinnerService.stop("spinner-1");
                    $scope.errors.push(utilli.errors.serverErrorMessage);
                });
        }
    }])
.controller('SignUpStep3Controller', ['$scope', '$rootScope', '$http', '$state', '$stateParams', 'moduleServices',
    'usSpinnerService', '$sce', 'RegistrationInfoService',
    function ($scope, $rootScope, $http, $state, $stateParams, $moduleServices, usSpinnerService, $sce,
        RegistrationInfoService) {
        
        $scope.errors = [];
        $scope.emailNotificationsAccepted = true;

        $scope.loadTermsAndConditions = function () {
            if($rootScope.webServicesUrl)
                getTermsAndConditions($rootScope.webServicesUrl);
            else
                $state.go('TopMenuLayout.SignUp.Step1');
        }

        function getTermsAndConditions(baseUrl) { 
            usSpinnerService.spin("spinner-1");
            $http({
                url: baseUrl + 'api/StaticData/GetTermsAndConditions',
                method: 'GET'
            }).success(function(data) {
                usSpinnerService.stop("spinner-1");
                $scope.html = $sce.trustAsHtml(data);
            }).error(function() {
                usSpinnerService.stop("spinner-1");
                $scope.errors.push(utilli.errors.serverErrorMessage);
            });
        }

        $scope.TermAndConditionsFormSubmit = function () {
            usSpinnerService.spin("spinner-1");
            $moduleServices.hideKeyboard();
            checkTermAndConditionsFormSubmit();
        };

        function checkTermAndConditionsFormSubmit() {

            var language = localStorage.getItem('language');
            if (!language)
                language = 'en';

            var data = {
                AccountNumber: RegistrationInfoService.userInfo.accountnumber,
                ZipCode: RegistrationInfoService.userInfo.zip,
                Fullname: RegistrationInfoService.userInfo.customerfullname,
                UserName: RegistrationInfoService.userInfo.user,
                Email: RegistrationInfoService.userInfo.email,
                Password: RegistrationInfoService.userInfo.psw,
                SecurityQuestion1: RegistrationInfoService.userInfo.question,
                SecurityAnswer1: RegistrationInfoService.userInfo.answer,
                Token: RegistrationInfoService.userInfo.token,
                TermsAndConditions: $scope.termsAccepted,
                EmailNotificationsAccepted: $scope.emailNotificationsAccepted,
                Language: language,
                Client: isMobileOrRipple() ? utilli.clientEnum.mobileApp : utilli.clientEnum.portal,
                Step: 3
            };

            $http({
                url: $rootScope.serviceUrl,
                method: "POST",
                data: data
            }).success(function (response) {
                if (response) {
                    if (response.Errors && response.Errors.length > 0) 
                        $scope.errors = response.Errors;
                    else 
                        $state.goRelativeTo('SignUp', 'Success');
                }
                else {
                    $scope.errors.push(utilli.errors.serverErrorMessage);
                }
                usSpinnerService.stop("spinner-1");
            }).error(function () {
                usSpinnerService.stop("spinner-1");
                $scope.errors.push(utilli.errors.serverErrorMessage);
            });
        }
    }])
.controller('SignUpSuccessController', ['$scope', '$rootScope', 'CommonDataService', 
    'usSpinnerService', '$state',
    function ($scope, $rootScope, CommonDataService, usSpinnerService, $state) {
        $scope.errors = [];
        CommonDataService.getCommonData($rootScope.webServicesUrl)
            .then(function (commonData) {
                $scope.companyNameLong = commonData.CompanyNameLong;
                $scope.companyNameLongWithoutTrailingPeriod = commonData.CompanyNameLongWithoutTrailingPeriod;
                $scope.helpEmail = commonData.CompanyHelpEmail;
                usSpinnerService.stop('spinner-1');

                $scope.SuccessOk = function () {
                    $state.goToWelcome();
                }
            });
    }]);
'use strict';
var app = angular.module('utilliApp');

app.controller('QuickPayController', ['$scope', '$state', 'CommonHeaderService',
    function ($scope, $state, CommonHeaderService) {
        var offline = localStorage.getItem('offline')
        if (offline === "1" && window.location.href.indexOf("Maintenance") == -1)
        {
            $state.go('Maintenance');  
        }
        CommonHeaderService.hideMenuToggleButton();
        if ($state.is('QuickPay')) {
            $state.go('.Step1');
        }
    }]);



'use strict';
var app = angular.module('utilliApp');

app.controller('QuickPayHeaderController', ['$scope', '$state', 'ServiceProvidersService',
    function ($scope, $state, ServiceProvidersService) {
        
        var firebaseWebPushService;
        var apiUrl;

        ServiceProvidersService.getCurrentProvider()
            .then(function (providerData) {
                apiUrl = providerData.ApiUrl;

                if(utilli.isFirefox) {
                    firebaseWebPushService = createFirebaseWebPushService(providerData.ApiUrl);
                }        
            })
            .catch(function(){
                ModalServiceExt.showServerError();
            });

        $scope.isWebPushBellBoxVisible = function () {
            var result = (utilli.isFirefox && Notification.permission == "default")
                || (utilli.isSafari 
                    && 'safari' in window 
                    && 'pushNotification' in window.safari
                    && utilli.getSafariPushNotificationPermissionData().permission === 'default');
            
            return result;
        };

        $scope.askPermissionsForWebPush = function () { 
            if(utilli.isFirefox && !firebaseWebPushService) {
                firebaseWebPushService.subscribe($scope);
            }
            else if ('safari' in window && 'pushNotification' in window.safari) {
                utilli.checkSafariRemotePermission($scope, apiUrl, $state.params.accountNumber);
            }
        }
    }]);

'use strict';
var app = angular.module('utilliApp');

app.controller('QuickPayStep1Controller', ['$scope', '$state',
    function ($scope, $state) {

        $scope.goToStep2 = function (){
            $state.goRelativeTo("QuickPay", "Step2");
        };

        $scope.goToWelcome = function () {
            $state.goToWelcome();
        };
    }]);

'use strict';
var app = angular.module('utilliApp');

app.controller('QuickPayStep2Controller', ['$scope', '$timeout', '$state', '$location', '$http', 'usSpinnerService', 'LeftMenuService',
    'CommonDataService', '$q', 'ServiceProvidersService', 'ModalServiceExt', 'PaymentVerificationService', '$window',
    function ($scope, $timeout, $state, $location, $http, usSpinnerService, LeftMenuService, CommonDataService, $q, 
        ServiceProvidersService, ModalServiceExt, PaymentVerificationService, $window) {
    var browser = $window.navigator.userAgent;

    LeftMenuService.setCurrentTab('QuickPay');
    //CommonHeaderService.setUpBackButton('Quick Pay');
    
    $scope.showLoading = true;


    if (utilli.isAdmin) {
        $scope.imagesPath = "../Images";
    } else {
        $scope.imagesPath = "Images";
    }

    var apiUrl = '';

    $scope.isAdmin = utilli.isAdmin;
    $scope.accountNumber = '';
    $scope.houseNumber = '';
    $scope.streetName = '';
    $scope.zip = '';
    $scope.isPayNowEnabled = false;
    $scope.isPayNowBtnText = 'Next';
    $scope.velocityFee = '';

    $scope.onlyNumbers = /^\d+$/;
    $scope.firstLastNamePattern = /^(\S)+( \S+)+$/;
    $scope.emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    $scope.stepName = 'find';
    $scope.IsSuccessful = true;
    $("#cardCodeCvv").mask("999?9", { placeholder: "" });
    $scope.quickPayValidationType = 'InvoiceNumber'; // Can be: InvoiceNumber, BusinessPartnerNumber
    $scope.quickPayValidationCaption = $scope._t('Invoice Number');

    $scope.isFeeEnabled = false;

    function tryInitPageByUrlParams() {
        var accountNumber = $state.params.accountNumber;
        if(accountNumber) {
            $scope.radioSearchType = 'searchByAccount';
            $scope.accountNumber = accountNumber;
            find();
        }
        $scope.showLoading = false;
    }

    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getCurrentProvider()
        .then(function (providerData) {

                apiUrl = providerData.ApiUrl;
                utilli.resolveServiceProviderApiDeffered(apiUrl);
                CommonDataService.getCommonData(apiUrl).then(function (commonData) {
                        usSpinnerService.stop('spinner-1');
                        
                        $scope.largeConvenienceFeeBorder = commonData.LargeConvenienceFeeBorder;
                        $scope.smallConvenienceFee = commonData.SmallConvenienceFee;
                        $scope.largeConvenienceFee = commonData.LargeConvenienceFee;
                        $scope.paymentInfoText = commonData.FeeInformation;
                        $scope.commomData = commonData;

                        $scope.isBankAccountPaymentsEnabled = commonData.IsBankAccountPaymentsEnabled;
                        $scope.isCreditCardCvvEnabled = commonData.IsCreditCardCvvEnabled == 'True';
                        $scope.isCreditCardBillingAddressEnabled = commonData.IsCreditCardBillingAddressEnabled == 'True';
                        $scope.quickPayValidationType = commonData.QuickPayValidationType;
                        $scope.isFeeEnabled = false;

                        if ($scope.quickPayValidationType == 'BusinessPartnerNumber') {
                            $scope.quickPayValidationCaption = _t('Customer Number');
                        }
                        
                        tryInitPageByUrlParams();
                    },
                    function () {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                    }
                );
            },
            function(e) {
                utilli.rejectServiceProviderApiDeffered();
                usSpinnerService.stop('spinner-1');
                console.log(e);
                ModalServiceExt.showServerError();
            }
        );

    $scope.back = function () {
        $state.goRelativeTo('QuickPay', 'Step1');
    };

    $scope.cancel = function () {
        $state.goToWelcome();
    };

    function loadAccountInfo () { 
        alert('not implemented');
    }

    function resetPayBtn()
    {
        $scope.isPayNowBtnText = 'Next';
        $scope.isPayNowEnabled = false;
        $scope.velocityFee = '';
    }

    function getVelocityFee(newAmount, type) {
        var payAmount = utilli.parsePositiveFloat(newAmount);
        if (payAmount <= 0) {
            return;
        }
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/Payment/GetVelocityFee',

            method: "GET",
            params: { Card: $scope.cardNumber, Amount: $scope.amountDue, 
                AccountNumber: $scope.currentAccount.AccountNumber, Type: type  }
        }).success(function (res) {
            $scope.velocityFee = res.PPIFeeValue;
            $scope.isPayNowEnabled = true;
            $scope.isPayNowBtnText = 'Pay Now'
            usSpinnerService.stop('spinner-1');
        }).error(function (res) {
            usSpinnerService.stop('spinner-1');
        });
    }

    function getSavedInvoiceNumber(contractAccountNumber) {
        var deviceInfo = getSavedDeviceInfo(contractAccountNumber);
        return deviceInfo ? deviceInfo.invoiceNumber : '';
    }

    function getSavedDeviceToken(contractAccountNumber) {
        var deviceInfo = getSavedDeviceInfo(contractAccountNumber);
        return deviceInfo ? deviceInfo.deviceToken : '';
    }

    var deviceInfoKey = 'quick-pay-device-infos';

    function getSavedDeviceInfo(contractAccountNumber) {
        try {
            var deviceInfosJson = localStorage.getItem(deviceInfoKey);
            if (!deviceInfosJson)
                return null;
            var deviceInfos = JSON.parse(deviceInfosJson);
            return deviceInfos ? deviceInfos[contractAccountNumber] : null;
        }
        catch (e) {
            console.error('failed to get deviceInfo. ' + e);
            return null;
        }
    }

    function saveDeviceInfo(contractAccountNumber, invoiceNumber, deviceToken) {
        var savedInvoiceNumbers = {};
        try {
            var savedInvoiceNumbersString = localStorage.getItem(deviceInfoKey);
            if (savedInvoiceNumbersString)
                savedInvoiceNumbers = JSON.parse(savedInvoiceNumbersString);
        } catch (e) {
            console.error('failed to save device info. ' + e);
        }
        savedInvoiceNumbers[contractAccountNumber] = { invoiceNumber: invoiceNumber, deviceToken: deviceToken };
        localStorage.setItem(deviceInfoKey, JSON.stringify(savedInvoiceNumbers));
    }

    $scope.clear = function () {
        $scope.findResultVisible = false;
        // $scope.accountNumber = '';
        $scope.houseNumber = '';
        $scope.streetName = '';
        $scope.appartment = '';
        $scope.state = '';
        $scope.zip = '';
        $scope.informationMessage = '';
        $scope.invoiceNumber = '';
        $scope.invoiceNumberError = false;
        $scope.isInformationMessageShown = false;
        $scope.errorFromServerReturned = false;
        $scope.isPaymentInfoAgreeBank = false;
        $scope.isPaymentInfoAgreeCard = false;
    };

    $scope.clearAccountSearch = function () {
        $scope.findResultVisible = false;
        $scope.accountNumber = '';
        $scope.informationMessage = '';
        $scope.invoiceNumberError = false;
        $scope.isInformationMessageShown = false;
        $scope.errorFromServerReturned = false;
        $scope.isPaymentInfoAgreeBank = false;
        $scope.isPaymentInfoAgreeCard = false;
    };

    $scope.clearAddressSearch = function () {
        $scope.findResultVisible = false;
        $scope.houseNumber = '';
        $scope.streetName = '';
        $scope.appartment = '';
        $scope.state = '';
        $scope.zip = '';
        $scope.informationMessage = '';
        $scope.invoiceNumberError = false;
        $scope.isInformationMessageShown = false;
        $scope.errorFromServerReturned = false;
        $scope.isPaymentInfoAgreeBank = false;
        $scope.isPaymentInfoAgreeCard = false;
    };

    function find () {
        $scope.findResultVisible = false;
        $scope.amountDue = '';
        $scope.amountDueDisabled = '';

        if ($scope.accountNumber == '') {
            if ($scope.houseNumber == '' || $scope.streetName == '' || $scope.zip == '') {
                $scope.informationMessage = $scope._t('Account # or House #, Street Name and Zip must be filled') + '.';
                $scope.isInformationMessageShown = true;
                return;
            }
        }

        usSpinnerService.spin('spinner-1');

        $scope.informationMessage = '';
        $scope.isInformationMessageShown = false;
        $scope.showProceedAnyway = false;
        $scope.errorFromServerReturned = false;

        $scope.outputSearchType = 'address';

        if ($scope.accountNumber == '') {
            $scope.outputSearchType = 'accountNumber';
        }

        var searchRequest = {
            accountNumber: $scope.accountNumber,
            streetNumber: $scope.houseNumber,
            streetName: $scope.streetName,
            apartmentNumber: $scope.appartment,
            state: $scope.state,
            zip: $scope.zip,
            isAdmin: $scope.isAdmin
        };
        
        CommonDataService.getCommonData(apiUrl).then(function (commonData) {
            var url = apiUrl + 'api/Payment/FindAccounts'; //commonData.QuickPayAccountSearchUrl;
            $http({
                url: url,
                method: "GET",
                params: searchRequest
            }).success(function (data) {
                var jsondata = data;
                if (jsondata) {
                    if (jsondata.message == 'too many results') {
                        $scope.informationMessage = $scope._t('Too many results. Please add more search criteria') + '.';
                        $scope.isInformationMessageShown = true;
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    else if (jsondata.IsSuccessful == false) {
                        $scope.informationMessage = jsondata.Message;
                        $scope.isInformationMessageShown = true;
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    else if (jsondata.length == 0) {
                        $scope.informationMessage = $scope._t('Search returned no results') + '.';
                        $scope.isInformationMessageShown = true;
                    }
                    $scope.findResultList = jsondata;
                    usSpinnerService.stop('spinner-1');
                    $scope.findResultVisible = true;
                    utilli.scrollBottom(500);
                } else {
                    usSpinnerService.stop('spinner-1');
                    $scope.errorFromServerReturned = true;
                    $scope.serverErrorInformation = $scope._t('Server error. Try again later.');
                }
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                $scope.errorFromServerReturned = true;
                $scope.serverErrorInformation = $scope._t('Server error. Try again later.');
            });
        });
    };

    $scope.find = find;

    $scope.iKnowAccountNumberClick = function () {
        $scope.clearAddressSearch();
        $scope.radioSearchType = 'searchByAccount';
    };

    $scope.iKnowServiceAddressClick = function () {
        $scope.clearAccountSearch();
        $scope.radioSearchType = 'searchByAddress';
    };

    $scope.selectAccount = function (account) {
        $scope.clearPaymentSettings();
        $scope.currentAccount = account;
        $scope.stepName = 'selectPaymentOption';

        usSpinnerService.spin('spinner-1'); // stop - inside of function getConvFeeInfo
        $scope.getConvFeeInfo(account);

        $scope.amountDue = $scope.currentAccount.TotalOpenBallance;
        $scope.amountDueDisabled = $scope.currentAccount.TotalOpenBallance;
        $scope.updateConvinienceFee();
        //$scope.convinienceFee = $scope.currentAccount.ConvenienceFee;

        if ($scope.amountDue < 0) {
            $scope.amountDue = 0;
            $scope.totalAmount = "";
        } else {
            $scope.totalAmount = $scope.formatDecimal(parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee));
        }

        $scope.formatTotalAmount();
    }

    $scope.clearPaymentSettings = function () {
        $scope.cardNumber = '';
        $scope.nameOnCard = '';
        $scope.cardExpiryMonth = '';
        $scope.cardExpiryYear = '';

        $scope.billToAddress = '';
        $scope.billToCity = '';
        $scope.billToState = '';
        $scope.billToZip = '';
        $scope.cardCode = '';

        $scope.checkNameOnAccount = '';
        $scope.bankRoutingNumber = '';
        $scope.bankCheckingAccountNumber = '';
        $scope.bankCheckingAccountNumber2 = '';
        $scope.driversLicenseNumber = '';
        $scope.checkPaymentState = '';
        $scope.phone = '';
        $scope.email = '';
        //$scope.amountDue = '';
    }

    $scope.getConvFeeInfo = function (account) {

        var searchObject = {
            accountNumber: account.AccountNumber,
        };
        $http({
            url: apiUrl + 'api/Payment/GetConvFeeInfo/',
            method: "GET",
            params: searchObject
        }).success(function (data) {
            var jsondata = data;
            if (jsondata) {
                $scope.convFeeInfo = jsondata;
                $scope.updateConvinienceFee();
                if ($scope.convFeeInfo.Disconnected == $scope._t('Account Disconnected')) {
                    ModalServiceExt.showMessage($scope._t('Account is disconnected'), 
                    $scope._t('Your account is currently disconnected. After making the payment please contact Customer Service at')
                    + ' ' 
                    + $scope.convFeeInfo.SupportPhoneNumber);
                }
            } else {
            }
            usSpinnerService.stop('spinner-1');
        }).error(function (data) {
            ModalServiceExt.showMessage($scope._t('Error'), $scope._t('Server error. Please, try again later.'));
            $scope.stepName = 'find';
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.updateConvinienceFee = function () {
        if ($scope.amountDue == null || isNaN($scope.amountDue) || $scope.amountDue == '') {
            $scope.convinienceFee = '';
            return;
        }

        var info = $scope.convFeeInfo;

        if ($scope.isFeeEnabled) {
        if ($scope.stepName == 'payByCard') {
            if (info.FeeType == "percent") {
                $scope.convinienceFee = $scope.formatDecimal($scope.amountDue / 100 * info.FeeAmount);
            } else if (info.FeeType == "flat") {
                $scope.convinienceFee = $scope.formatDecimal(info.FeeAmount);
            }
            } else if ($scope.stepName == 'payByBankAccount') {
                if (info.FeeTypeAch == "percent") {
                    $scope.convinienceFee = $scope.formatDecimal($scope.amountDue / 100 * info.FeeAmountAch);
                } else if (info.FeeTypeAch == "flat") {
                    $scope.convinienceFee = $scope.formatDecimal(info.FeeAmountAch);
                }
            }
        }
        else {
            $scope.convinienceFee = 0;
        }

        $scope.totalAmount = $scope.formatDecimal(parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee));

    }

    $scope.formatDecimal = function (decimal) {

        var formated = Math.round(parseFloat(decimal) * 100) / 100;

        formated = formated.toString();
        if (formated.indexOf('.') == -1) formated += '.';
        while (formated.length < formated.indexOf('.') + 3) formated += '0';

        return formated;
    }

    $scope.onAmountChange = function () {
        if ($scope.amountDue == '-') {
            return;
        }
        if ($scope.amountDue == '' || $scope.amountDue == undefined) {
            $scope.totalAmount = '';
            $scope.updateConvinienceFee();
            return;
        }

        if ($scope.amountDue.slice(-1) == '.') {
            return;
        }

        if (isNaN($scope.amountDue) || isNaN(parseFloat($scope.amountDue))) {
            $scope.amountDue = '';
            $scope.totalAmount = '';
            $scope.updateConvinienceFee();
            return;
        }

        $scope.updateConvinienceFee();

        $scope.totalAmount = $scope.formatDecimal(parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee));
    }

    $scope.cancelPaymentOptionSelection = function () {
        $scope.clear();
        $scope.stepName = 'find';
    }


    $scope.selectPayByCard = function () {
        $scope.stepName = 'payByCard';
        $scope.invoiceNumber = getSavedInvoiceNumber($scope.currentAccount.AccountNumber);
        $scope.updateConvinienceFee();
    }

    $scope.selectPayByBankAccount = function () {
        $scope.stepName = 'payByBankAccount';
        $scope.updateConvinienceFee();
    }

    $scope.formatTotalAmount = function () {
        if ($scope.amountDue == undefined) {
            $scope.totalAmount = '';
            return;
        }

        if (isNaN(parseFloat($scope.amountDue))) {
            $scope.amountDue = '';
            $scope.totalAmount = '';
            return;
        }
        $scope.amountDue = $scope.formatDecimal(parseFloat($scope.amountDue));
    }

    $scope.cancelPayment = function () {
        $scope.bankAccountFormSubmitted = false;
        $scope.cardFormSubmitted = false;
        $scope.clear();
        $scope.clearPaymentSettings();
        resetPayBtn();
        $scope.stepName = 'selectPaymentOption';
    }

    $scope.payNow = function () {
        $scope.stepName = 'processingPayment';
        usSpinnerService.spin('spinner-1');
        $scope.$apply();
        $timeout(function () {
            usSpinnerService.stop('spinner-1');
            $scope.stepName = 'paymentResult';
        }, 3000);
    }

    function validateInvoiceNumber() {
        var deferred = $q.defer();

        if (utilli.isAdmin) {
            deferred.resolve(true);
            return deferred.promise;
        }

        var requestParams = {};
        var requestUrl = '';
        var deviceToken = getSavedDeviceToken($scope.currentAccount.AccountNumber);

        if ($scope.quickPayValidationType == 'InvoiceNumber') {
            requestParams =  { 
                accountNum: $scope.currentAccount.AccountNumber, 
                invoiceNum: $scope.invoiceNumber, 
                deviceToken: deviceToken 
            };
            requestUrl = 'api/Payment/IsInvoiceValid';
        }
        else if ($scope.quickPayValidationType == 'BusinessPartnerNumber') {
            requestParams = { 
                accountNum: $scope.currentAccount.AccountNumber,
                businessPartnerNum: $scope.invoiceNumber,
                deviceToken: deviceToken
            };
            requestUrl = 'api/Payment/IsBusinessPartnerValid';
        }

        $http({
            url: apiUrl + requestUrl,
            method: "GET",
            params: requestParams
        }).success(function(response) {
            if (response.Errors && response.Errors.length > 0) {
                alert(response.Errors[0]);
                deferred.reject(false);
            } else {
                var deviceToken = response.Data;
                var isValid = deviceToken != 'invalid';
                if (isValid)
                    saveDeviceInfo($scope.currentAccount.AccountNumber, $scope.invoiceNumber, response.Data);
                else
                    saveDeviceInfo($scope.currentAccount.AccountNumber, '', '');
                deferred.resolve(isValid);
            }
        }).error(function() {
            alert($scope._t('Server error. Try again later.'));
            deferred.resolve(false);
        });


        return deferred.promise;
    }

    $scope.payNowCard = function () {

        if ($scope.payCardAccount_form.cardNumber.$error.ccNumber ||
            $scope.payCardAccount_form.amountDue.$error.pattern) {
            return;
        }

        if ($scope.payCardAccount_form.cardNumber.$error.ccNumber
            || $scope.payCardAccount_form.amountDue.$error.pattern
            || $scope.payCardAccount_form.amountDue.$invalid
            || $scope.payCardAccount_form.phone.$invalid
            || $scope.payCardAccount_form.email.$invalid
            || $scope.payCardAccount_form.cardNumber.$invalid
            || $scope.payCardAccount_form.nameOnCard.$invalid
            || $scope.payCardAccount_form.cardExpiryMonth.$error.ccExpMonth
            || $scope.payCardAccount_form.cardExpiryYear.$error.ccExpYear
            || $scope.payCardAccount_form.$error.ccExp
            || $scope.payCardAccount_form.cardExpiryMonth.$invalid
            || $scope.payCardAccount_form.cardExpiryYear.$invalid
            || (!utilli.isAdmin && $scope.payCardAccount_form.invoiceNumber.$invalid)
            || $scope.payCardAccount_form.cardNumber.$type == 'JCB'
            || $scope.payCardAccount_form.cardNumber.$type == 'American Express'
            || $scope.payCardAccount_form.cardNumber.$type == 'Diners Club'
            || ($scope.isPaymentInfoAgreeCard == false && $scope.isFeeEnabled)
            || (utilli.isAdmin && $scope.proceededWithoutSearch && $scope.selectedCompany.companyCode == "0")

            || ($scope.isCreditCardBillingAddressEnabled == 'True' && $scope.payCardAccount_form.billToAddress.$invalid)
            || ($scope.isCreditCardBillingAddressEnabled == 'True' && $scope.payCardAccount_form.billToCity.$invalid)
            || ($scope.isCreditCardBillingAddressEnabled == 'True' && $scope.payCardAccount_form.billToState.$invalid)
            || ($scope.isCreditCardBillingAddressEnabled == 'True' && $scope.payCardAccount_form.billToZip.$invalid)
            || ($scope.isCreditCardCvvEnabled && $scope.payCardAccount_form.cardCode.$invalid)
            ) {
            return;
        }

        var postPayment = function (resolve) {
            $scope.invoiceNumberError = !resolve;
            if ($scope.invoiceNumberError) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showMessage($scope._t('Error'), $scope._t('Invalid Invoice Number'));
                return;
            }

            $scope.cardFormSubmitted = false;
            $scope.phone = '1' + $('#phone-cc').mask();
            //$scope.stepName = 'processingPayment';

            var companyCode = $scope.currentAccount.CompanyCode;
            if ($scope.proceededWithoutSearch) {
                companyCode = $scope.selectedCompany.companyCode;
            }

            var paymentObject = {
                accountNumber: $scope.currentAccount.AccountNumber,
                userId: -1,
                amountToPay: $scope.amountDue,
                dueAmount: $scope.amountDueDisabled,
                phone: $scope.phone,
                email: $scope.email,
                cardNumber: $scope.cardNumber,
                nameOnCard: $scope.nameOnCard,
                expirationDateYear: $scope.cardExpiryYear,
                expirationDateMonth: $scope.cardExpiryMonth,
                companyCode: companyCode,
                billToAddress: $scope.billToAddress,
                billToCity: $scope.billToCity,
                billToState: $scope.billToState,
                billToZip: $scope.billToZip,
                cardCode: $scope.cardCode,
                Browser: browser,
                ConvenienceFee: $scope.velocityFee
            };

            if (!utilli.isAdmin) {
                paymentObject.invoiceNumber = $scope.invoiceNumber;
                paymentObject.PaymentPage = 1;
            } else {
                paymentObject.invoiceNumber = '0';
                paymentObject.PaymentPage = 3;
            }

            $http({
                url: apiUrl + 'api/Payment/QuickPayUsingCard',
                method: "POST",
                data: paymentObject
            }).success(function (data) {
                var jsondata = data;
                if (jsondata) {
                    $scope.paymentResult = jsondata.Message;
                    $scope.IsSuccessful = jsondata.IsSuccessful;
                    resetPayBtn();
                    $scope.stepName = 'paymentResult';
                    usSpinnerService.stop('spinner-1');
                }
            }).error(function (data) {
                var jsondata = data;
                $scope.paymwntResult = jsondata.Message;
                $scope.IsSuccessful = jsondata.IsSuccessful;
                $scope.stepName = 'paymentResult';
                usSpinnerService.stop('spinner-1');
            });
        };
        if ($scope.isPayNowEnabled)
        {
            usSpinnerService.spin('spinner-1');
            PaymentVerificationService.verifyPaymentInfo($scope.amountDue, function(){
                usSpinnerService.spin('spinner-1');// spin it again because it could be stopped in verifyPaymentInfo
                validateInvoiceNumber().then(postPayment);
            });
        }
        else
        {
            getVelocityFee($scope.amountDue, "1")
        }
    }

    $scope.payNowBankAccount = function () {

        if ($scope.bankCheckingAccountNumber != $scope.bankCheckingAccountNumber2) {
            return;
        }

        if ($scope.payBankAccount_form.amountDue.$error.pattern) {
            return;
        }

        if ($scope.payBankAccount_form.amountDue.$error.pattern
            || $scope.payBankAccount_form.amountDue.$invalid
            || $scope.payBankAccount_form.phone.$invalid
            || $scope.payBankAccount_form.email.$invalid
            || $scope.payBankAccount_form.checkNameOnAccount.$invalid
            || $scope.payBankAccount_form.bankRoutingNumber.$invalid
            || $scope.payBankAccount_form.bankCheckingAccountNumber.$invalid
            || $scope.payBankAccount_form.bankCheckingAccountNumber2.$invalid
            || ($scope.isPaymentInfoAgreeBank == false && $scope.isFeeEnabled)
            || (utilli.isAdmin && $scope.proceededWithoutSearch && $scope.payCardAccount_form.selectedCompanyOption.$invalid)
            || ($scope.bankRoutingNumber == $scope.bankCheckingAccountNumber)
            ) {
            return;
        }

        if ($scope.isPayNowEnabled) {
            usSpinnerService.spin('spinner-1');

            PaymentVerificationService.verifyPaymentInfo($scope.amountDue, function () {
                usSpinnerService.spin('spinner-1');// spin it again because it could be stopped in verifyPaymentInfo
                validateRoutingNumber().then(function (resolve) {
                    $scope.routNumError = !resolve;
                    if ($scope.routNumError) {
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    bankAccountPay();
                });
            });
        }
        else {
            getVelocityFee($scope.amountDue, "3")
        }
    }

    function validateRoutingNumber() {
        //$scope.stepName = 'processingPayment';
        var deferred = $q.defer();
        var requestResult = false;
        $http({
            url: apiUrl + 'api/Payment/RoutingNumberValidate', //$scope.commomData.CheckRoutingNumberUrl, //window.OneTimePayments.checkRoutingNumberUrl,
            method: "GET",
            params: { routingNumber: $scope.bankRoutingNumber }
        }).success(function (response) {
            if (response.Errors && response.Errors.length > 0) {
                alert(response.Errors[0]);
                deferred.reject(requestResult);
            }
            else {
                requestResult = response.Data;
                deferred.resolve(response.Data);
            }
            $scope.stepName = 'payByBankAccount';
        }).error(function () {
            alert("Server error. Try again later.");
            deferred.resolve(requestResult);
            $scope.stepName = 'payByBankAccount';
        });
        return deferred.promise;
    }

    function bankAccountPay() {
        $scope.bankAccountFormSubmitted = false;
        $scope.phone = '1' + $('#phone-ba').mask();
        usSpinnerService.spin('spinner-1');

        var companyCode = $scope.currentAccount.CompanyCode;
        if ($scope.proceededWithoutSearch) {
            companyCode = $scope.selectedCompany.companyCode;
        }

        var paymentObject = {
            accountNumber: $scope.currentAccount.AccountNumber,
            userId: -1,
            amountToPay: $scope.amountDue,
            dueAmount: $scope.amountDueDisabled,
            phone: $scope.phone,
            email: $scope.email,
            nameOnAccount: $scope.checkNameOnAccount,
            bankRoutingNumber: $scope.bankRoutingNumber,
            checkingAccountNumber: $scope.bankCheckingAccountNumber,
            companyCode: companyCode,
            Browser: browser,
            ConvenienceFee: $scope.velocityFee
        };

        if (utilli.isAdmin) {
            paymentObject.PaymentPage = 3;
        }
        else {
            paymentObject.PaymentPage = 1;
        }

        $http({
            url: apiUrl + 'api/Payment/QuickPayByBankAccount', //$scope.commomData.BankAccountPayUrl, //window.OneTimePayments.bankAccountPayUrl,
            method: "POST",
            data: paymentObject
        }).success(function (data) {
            var jsondata = data;
            if (jsondata) {
                $scope.paymentResult = jsondata.Message;
                $scope.IsSuccessful = jsondata.IsSuccessful;
                resetPayBtn();
                $scope.stepName = 'paymentResult';
                usSpinnerService.stop('spinner-1');
            } else {
            }
        }).error(function (data) {
            $scope.paymwntResult = data.Message;
            $scope.IsSuccessful = data.IsSuccessful;
            $scope.stepName = 'paymentResult';
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.paymentOk = function () {
        $scope.clear();
        $scope.stepName = 'find';
        $scope.IsSuccessful = true;
    }

    $scope.viewUnderstandYourBill = function () {
        var viewurl = apiUrl + 'api/Bills/GetUnderstandMyBill';
        window.open(viewurl, '_blank');
    }

    $scope.phone = getMaskedPhoneNumberValue($scope.phone);

    $scope.proceedToRegistration = function () {
        $state.go('TopMenuLayout.SignUp.Step1', { 
            accountnumber: $scope.currentAccount.AccountNumber, 
            customerfullname: $scope.currentAccount.CustomerFullName, 
            zip: $scope.currentAccount.Zip.substring(0, 5) 
        });
    }

}]);
'use strict';
var app = angular.module('utilliApp');

app.factory('moduleServices',
    ["$rootScope", function ($rootScope) {
        return {
            hideKeyboard: function () {
                //hide keyboard
                document.activeElement.blur();
                //$("input").blur(); Yuriy Sokha: with operation leads to error in brouser console; todo
            },

            setError: function (message) {
                $rootScope.errors = [{ Message: message }];
            },

            setErrors: function (errors) {
                $rootScope.errors = errors;
            }
        };
    }]);

app.controller('ForgotUserIdController', ['$scope', '$rootScope', '$window', '$state', 'CommonHeaderService',
    function ($scope, $rootScope, $window, $state, CommonHeaderService) {
        CommonHeaderService.hideMenuToggleButton();
        $scope.cancel = function () {
            $state.goToWelcome();
        };
        $rootScope.SecureData = {
            userNameOrEmail: ''
        };
        $rootScope.serviceUrl = '';
    }]);

app.controller('ForgotUserIdStep1Controller', ['$scope', '$rootScope', '$http', '$state', 'moduleServices',
    'ServiceProvidersService', 'usSpinnerService',
    function ($scope, $rootScope, $http, $state, $moduleServices, ServiceProvidersService, usSpinnerService) {

        // this hack fixes a select element behavior in mobile (changing selected options).
        var allSelectElements = document.getElementsByTagName('select');
        for (var i = 0; i < allSelectElements.length; i++) {
            allSelectElements[i].addEventListener('touchstart', function (e) {
                //This is the important line
                e.stopPropagation();
            }, false);
        }

        $scope.showCsrLink = DeploymentSettings.currentServiceProvider != Config.hcProviderName;
        $scope.providers = [];
        $scope.provider = {};
        $rootScope.errors = [];

        $scope.isProviderListVisible = !DeploymentSettings.currentServiceProvider;
        if ($scope.isProviderListVisible) {
            ServiceProvidersService.getProviders()
                .then(
                    function(allProviders) {
                        $scope.providers = allProviders;
                        $scope.provider = allProviders[0];
                    },
                    function() {
                        $moduleServices.setError(utilli.errors.serverErrorMessage);
                    }
                );
        }
        else{
            ServiceProvidersService.getCurrentProvider()
                .then(
                function(providerData){
                    $scope.provider = providerData;
                },
                function(){
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
            );
        }

        $scope.CheckUserInfoFormSubmit = function () {
            $moduleServices.hideKeyboard();
            if (!$scope.frmCheckUserInfo.$valid) {
                $scope.submitted = true;
                return;
            }

            usSpinnerService.spin('spinner-1');

            $rootScope.serviceUrl = $scope.provider.ApiUrl;
            $rootScope.appUrl = $scope.provider.ApiUrl;
            $rootScope.SecureData.userNameOrEmail = $.trim($scope.Email);
            forgotPasswordValidation();
        };

        function forgotPasswordValidation() {
            $http({
                url: $rootScope.serviceUrl + 'api/Account/CheckForgotUserIdStep1/',
                method: "GET",
                params: {
                    email: $.trim($scope.Email),
                    zip: $.trim($scope.ZipCode)
                }
            }).success(function (response) {
                if (response) {
                    if (response.ERROR_LIST && response.ERROR_LIST.length > 0) {
                        $moduleServices.setErrors(response.ERROR_LIST);
                    } else {
                        $rootScope.SecurityQuestion = response.SecurityQuestions[0].Message;
                        $state.go('^.Step2');
                    }
                } else {
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                $moduleServices.setError(utilli.errors.serverErrorMessage);
                usSpinnerService.stop('spinner-1');
            });
        }
    }]);

app.controller('ForgotUserIdStep2Controller', ['$scope', '$rootScope', '$http', '$state',
    'moduleServices', 'usSpinnerService', 'ModalServiceExt',
    function ($scope, $rootScope, $http, $state, $moduleServices, usSpinnerService, ModalServiceExt) {

        usSpinnerService.stop('spinner-1');
        $rootScope.errors = [];

        $scope.SecurityQuestion = $rootScope.SecurityQuestion;
        $scope.CheckSecurityAnswerFormSubmit = function () {
            $moduleServices.hideKeyboard();
            if (!$scope.frmSecurityAnswer.$valid) {
                $scope.submitted = true;
                return;
            }
            usSpinnerService.spin('spinner-1');
            forgotPasswordValidation();
        };

        function forgotPasswordValidation() {
            $rootScope.errors = [];
            $http({
                url: $rootScope.serviceUrl + 'api/Account/CheckForgotUserIdStep2/',
                method: "GET",
                params: {
                    email: $rootScope.SecureData.userNameOrEmail,
                    securityAnswer: $.trim($scope.SecurityAnswer)
                }
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
                if (response.HasErrors) {
                    $rootScope.errors = [{Message: response.Errors[0]}];
                    return;
                }

                $state.go('^.Success');
            }).error(function () {
                $moduleServices.setError(utilli.errors.serverErrorMessage);
                usSpinnerService.stop('spinner-1');
            });
        }
    }]);

app.controller('ForgotUserIdSuccessController', ['$scope', '$rootScope', 'CommonDataService', 'usSpinnerService',
    '$http', 'moduleServices',
    function ($scope, $rootScope, CommonDataService, usSpinnerService, $http, $moduleServices) {
        $rootScope.errors = [];
        usSpinnerService.spin('spinner-1');
        CommonDataService.getCommonData($rootScope.appUrl, true)
            .then(function (commonData) {
                $scope.contactPhoneNumber = commonData.SupportPhone;
                $scope.workingHours = commonData.WorkingHours;
                $scope.billingEmailTo = commonData.BillingEmailTo;
                $scope.serviceProviderName = commonData.CompanyName;
                $scope.billingDepartment = commonData.BillingDepartment;
                usSpinnerService.stop('spinner-1');
            }, function () {
                $moduleServices.setError("utilli.errors.serverErrorMessage");
                usSpinnerService.stop('spinner-1');
            });
    }]);
'use strict';
var app = angular.module('utilliApp');

app.directive("repeatPassword",
    function() {
        return {
            require: "ngModel",
            link: function (scope, elem, attrs, ctrl) {
                var otherInput = elem.inheritedData("$formController")[attrs.repeatPassword];

                ctrl.$parsers.push(function (value) {
                    if (value === otherInput.$viewValue) {
                        ctrl.$setValidity("confirm", true);
                        return value;
                    }
                    ctrl.$setValidity("confirm", false);
                });

                otherInput.$parsers.push(function (value) {
                    ctrl.$setValidity("confirm", value === ctrl.$viewValue);
                    return value;
                });
            }
        };
    });

app.factory('moduleServices',
    ["$rootScope", function ($rootScope) {
        return {
            hideKeyboard: function () {
                //hide keyboard
                document.activeElement.blur();
                //$("input").blur(); Yuriy Sokha: with operation leads to error in brouser console; todo
            },

            setError: function (message) {
                $rootScope.errors = [{Message: message}];
            },

            setErrors: function (errors) {
                $rootScope.errors = errors;
            }
        };
    }]);

app.controller('ForgotPasswordController', ['$scope', '$rootScope', '$window', '$state', 'CommonHeaderService',
    function ($scope, $rootScope, $window, $state, CommonHeaderService) {
        CommonHeaderService.hideMenuToggleButton();
        $scope.cancel = function () {
            $state.goToWelcome();
        };

        $scope.goToCsr = function (){
            $state.go('ForgotPasswordCsr');
        }

        $scope.SecureData = {
            userNameOrEmail: '',
            zipCode: '',
            pstrAccountNumber: '',
            securityAnswer: '',
            password: '',
            confirmpassword: '',
            actionEvent: 'ForgotPassword'
        };

        $rootScope.serviceUrl = '';
        $rootScope.webServicesUrl = '';
    }]);

app.controller('ForgotPasswordStep1Controller', ['$scope', '$rootScope', '$http', '$state',
    'moduleServices', 'ServiceProvidersService', 'usSpinnerService',
    function ($scope, $rootScope, $http, $state, $moduleServices, ServiceProvidersService, usSpinnerService) {

        // this hack fixes a select element behavior in mobile (changing selected options).
        var allSelectElements = document.getElementsByTagName('select');
        for (var i = 0; i < allSelectElements.length; i++) {
            allSelectElements[i].addEventListener('touchstart', function (e) {
                //This is the important line
                e.stopPropagation();
            }, false);
        }

        $scope.showCsrLink = DeploymentSettings.currentServiceProvider != Config.hcProviderName;
        $scope.providers = [];
        $scope.provider = {};
        $rootScope.errors = [];
        $scope.isProviderListVisible = !DeploymentSettings.currentServiceProvider;
        if ($scope.isProviderListVisible) {
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getProviders()
                .then(
                function(allProviders){
                    usSpinnerService.stop('spinner-1');
                    $scope.providers = allProviders;
                    $scope.provider = allProviders[0];
                },
                function(){
                    usSpinnerService.stop('spinner-1');
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
            );
        }
        else{
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getCurrentProvider()
                .then(
                function(providerData){
                    usSpinnerService.stop('spinner-1');
                    $scope.provider = providerData;
                },
                function(){
                    usSpinnerService.stop('spinner-1');
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
            );
        }

        $scope.CheckUserInfoFormSubmit = function () {
            $moduleServices.hideKeyboard();
            if (!$scope.frmCheckUserInfo.$valid) {
                $scope.submitted = true;
                return;
            }

            usSpinnerService.spin('spinner-1');
            $rootScope.webServicesUrl = $scope.provider.ApiUrl;
            $scope.SecureData.userNameOrEmail = $.trim($scope.SecureData.userNameOrEmail);
            forgotPasswordValidation();
        };

        function forgotPasswordValidation() {
            $http({
                url: $rootScope.webServicesUrl + 'api/Account/CheckForgotPasswordStep1/',
                method: "GET",
                params: {
                    userNameOrEmail: $.trim($scope.SecureData.userNameOrEmail),
                    zip: $.trim($scope.SecureData.zipCode)
                }
            }).success(function (response) {
                if (response) {
                    if (response.ERROR_LIST && response.ERROR_LIST.length > 0) {
                        $moduleServices.setErrors(response.ERROR_LIST);
                    } else {
                        $scope.SecureData.securityQuestion = response.SecurityQuestions[0].Message;

                        $state.go('^.Step2');
                    }
                } else {
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                $moduleServices.setError(utilli.errors.serverErrorMessage);
                usSpinnerService.stop('spinner-1');
            });
        }
    }]);

app.controller('ForgotPasswordStep2Controller', ['$scope', '$rootScope', '$http', '$state',
    'moduleServices', 'usSpinnerService', 'ModalServiceExt',
    function ($scope, $rootScope, $http, $state, $moduleServices, usSpinnerService, ModalServiceExt) {

        usSpinnerService.stop('spinner-1');
        $rootScope.errors = [];

        $scope.CheckSecurityAnswerFormSubmit = function () {
            $moduleServices.hideKeyboard();
            if (!$scope.frmSecurityAnswer.$valid) {
                $scope.submitted = true;
                return;
            }
            $rootScope.errors = [];
            usSpinnerService.spin('spinner-1');
            $scope.SecureData.securityAnswer = $.trim($scope.SecureData.securityAnswer);
            forgotPasswordValidation();
        };

        function forgotPasswordValidation() {
            $http({
                url: $rootScope.webServicesUrl + 'api/Account/CheckForgotPasswordStep2/',
                method: "GET",
                params: {
                    userNameOrEmail: $scope.SecureData.userNameOrEmail,
                    securityAnswer: $scope.SecureData.securityAnswer
                }
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
                if (response.HasErrors) {
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }

                $state.go('^.Success');
            }).error(function () {
                $moduleServices.setError(utilli.errors.serverErrorMessage);
                usSpinnerService.stop('spinner-1');
            });
        }
    }]);
'use strict';
angular.module('utilliApp')
.controller('ForgotPasswordByEmailController', ['$scope', '$rootScope', '$window', '$state', 'CommonHeaderService',
    function ($scope, $rootScope, $window, $state, CommonHeaderService) {
        CommonHeaderService.hideMenuToggleButton();
        $scope.model = {
            from: '',
            userId: '',
            securityQuestion: '',
            securityAnswer: '',
            provider: {}
        };

        $scope.cancel = function () {
            if ($scope.model.from)
                $state.go($scope.model.from);
            else
                $state.goToWelcome();
        };
}])
.controller('ForgotPasswordByEmailStep1Controller', ['$scope', '$rootScope', '$http', '$state', '$stateParams',
    'ServiceProvidersService', 'moduleServices', 'ModalServiceExt', 'usSpinnerService',
    function ($scope, $rootScope, $http, $state, $stateParams, ServiceProvidersService, $moduleServices, ModalServiceExt, usSpinnerService) {

        $scope.model.from = $stateParams.from;

        if (!DeploymentSettings.currentServiceProvider) {
            usSpinnerService.spin('spinner-1');

            ServiceProvidersService.getProviders()
                .then(
                function (allProviders) {
                    usSpinnerService.stop('spinner-1');
                    $scope.providers = allProviders;
                    $scope.model.provider = allProviders[0];
                },
                function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
        } else {
            ServiceProvidersService.getCurrentProvider()
                .then(
                function (providerData) {
                    usSpinnerService.stop('spinner-1');
                    $scope.model.provider = providerData;
                },
                function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
        }
        
        $scope.submit = function () {
            $moduleServices.hideKeyboard();
            if (!$scope.frmCheckUserInfo.$valid) {
                $scope.submitted = true;
                return;
            }

            usSpinnerService.spin('spinner-1');
            $http({
                url: $scope.model.provider.ApiUrl + 'api/Account/CheckForgotPasswordByEmail/',
                method: "GET",
                params: {
                    userName: $.trim($scope.UserId),
                    email: $.trim($scope.Email)
                }
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
                if (response.HasErrors) {
                    ModalServiceExt.showError(response.Errors[0]);
                }
                else {
                    $scope.model.userId = $scope.UserId;
                    $scope.model.securityQuestion = response.Data;
                    $state.go('TopMenuLayout.ForgotPasswordByEmail.Success');
                }
                
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        };
}])
.controller('ForgotPasswordByEmailSuccessController', ['$scope', '$state', function ($scope, $state) {
    $scope.goToWelcome = function () {
        if ($scope.model.from)
            $state.go($scope.model.from);
        else
            $state.goToWelcome();
    }
}]);
'use strict';
var app = angular.module('utilliApp');

app.controller('ForgotUserIdByEmailController', ['$scope', '$rootScope', '$window', '$state', '$stateParams', 'CommonHeaderService',
    function ($scope, $rootScope, $window, $state, $stateParams, CommonHeaderService) {
        CommonHeaderService.hideMenuToggleButton();
        $scope.Model = { from: '' };
    }]);

app.controller('ForgotUserIdByEmailStep1Controller', ['$scope', '$rootScope', '$http', '$state', '$stateParams', 'moduleServices',
    'ServiceProvidersService', 'usSpinnerService', 'ModalServiceExt',
    function ($scope, $rootScope, $http, $state, $stateParams, $moduleServices, ServiceProvidersService, usSpinnerService, ModalServiceExt) {

        $scope.Model.from = $stateParams.from;
        $scope.isProviderListVisible = !DeploymentSettings.currentServiceProvider;
        
        if (!DeploymentSettings.currentServiceProvider) {
           usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getProviders()
                .then(
                function(allProviders){
                    usSpinnerService.stop('spinner-1');
                    $scope.providers = allProviders;
                    $scope.provider = allProviders[0];
                },
                function(){
                    usSpinnerService.stop('spinner-1');
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
            );
        }
        else {
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getCurrentProvider()
                .then(function(providerData){
                    usSpinnerService.stop('spinner-1');
                    $scope.provider = providerData;
                },
                function(){
                    usSpinnerService.stop('spinner-1');
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
            );
        }

        $scope.submit = function () {
            $rootScope.errors = null;
            $scope.submitted = true;
            if (!$scope.frmCheckUserInfo.$valid)
                return;
            usSpinnerService.spin('spinner-1');
            $http({
                url: $scope.provider.ApiUrl + 'api/Account/CheckForgotUserIdData/',
                method: "GET",
                params: {
                    lastName: $.trim($scope.lastName),
                    email: $.trim($scope.Email)
                }
            })
            .success(function (response) {
                if (response == undefined || response.HasErrors == undefined) {
                    ModalServiceExt.showServerError();
                    usSpinnerService.stop('spinner-1');
                    return;
                }
                if (response.HasErrors) {
                    $rootScope.errors = [{ Message: response.Errors[0] }];
                }
                else {
                    $state.go('TopMenuLayout.ForgotUserIdByEmail.Success');
                }
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                ModalServiceExt.showServerError();
                usSpinnerService.stop('spinner-1');
            });
        }

        $scope.cancel = function () {
            if ($scope.Model.from)
                $state.go($scope.Model.from);
            else
                $state.goToWelcome();
        };
    }]);

app.controller('ForgotUserIdByEmailSuccessController', ['$scope', '$state',
    function ($scope, $state) {
        $scope.goToWelcome = function () {

            if ($scope.Model.from)
                $state.go($scope.Model.from);
            else
                $state.goToWelcome();
        }
    }]);
'use strict';
angular.module('utilliApp')
.controller('SendInvitationController', ['$scope', '$state', '$rootScope', '$window', '$http', '$sce', '$timeout', 'LeftMenuService',
    '$stateParams', 'CommonHeaderService', 'usSpinnerService', 'ModalServiceExt', 'PropertyListService',
// ReSharper disable InconsistentNaming
function ($scope, $state, $rootScope, $window, $http, $sce, $timeout, LeftMenuService, $stateParams, CommonHeaderService, usSpinnerService,
          ModalServiceExt, PropertyListService) {
    var _t = $scope._t;
    // ReSharper restore InconsistentNaming
    LeftMenuService.show();
    CommonHeaderService.setUpBackButton($scope._t('New Invitation'));

    $scope.emailPattern = Config.emailPattern;

    getStaticData();
    $scope.userMessage = "loading...";

    $scope.recipients = [];
    loadData();

    $scope.addresses = {
        availableOptions: [],
        selectedOption: { id: '0', name: _t('loading...')}
    };

    $scope.addRecipient = function () {
        var ticks = new Date().getTime();
        $scope.recipients.push({
            id: ticks,
            email: '',
            name: ''
        });
    }

    $scope.addRecipient();

    $scope.removeRecipient = function (recipient) {
        if ($scope.recipients.length === 1) {
            ModalServiceExt.showMessage(_t('Error'), _t('Each invitation should have at least one recipient.'));
            return;
        }
        var index = $scope.recipients.findIndex(function (e) { return e.id === recipient.id });
        $scope.recipients.splice(index, 1);
    }

    $scope.send = function () {
        $scope.submitted = true;
        if ($scope.form.$invalid || $scope.addresses.selectedOption.id == null)
            return;
        usSpinnerService.spin('spinner-1');
        $http({
            url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/AddInvitation/',
            method: "POST",
            data: {
                recipient: 'Recipient',
                propertyId: $scope.addresses.selectedOption.id,
                recipients: $scope.recipients
            },
            params: { userName: $state.params.userId }
        }).success(function (response) {
            utilli.handleAjaxResponse(response, ModalServiceExt,
                function () {
                    ModalServiceExt.showInfo(_t('Your invitation has been successfully sent.'), function () {
                        if ($stateParams.propertyId)
                            $state.goMainLayout('PropertyList');
                        else
                            $window.history.back();
                    })
                });
            usSpinnerService.stop('spinner-1');
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }

    $scope.cancel = function () {
        $window.history.back();
    }

    function loadData() {
        usSpinnerService.spin('spinner-1');
        var params = {};
        utilli.addUserName($state, params);
        PropertyListService.getPropertyList().success(function (response) {
            utilli.handleAjaxResponse(response, ModalServiceExt,
                function () {
                    $scope.addresses.availableOptions.push({ id: null, name: ''});

                    _.each(response.Data, function (item) {
                        $scope.addresses.availableOptions.push({
                            id: item.Id,
                            name: item.Name
                        });
                    });
                    $scope.addresses.selectedOption = $scope.addresses.availableOptions[0]
                });
            usSpinnerService.stop('spinner-1');
        }).error(function (error) {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }

    function getStaticData() {
        usSpinnerService.spin('spinner-1');
        $http({
            url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetInvitationText/',
            method: 'GET',
            params: { recipientId: '' }
        }).success(function(response) {
            utilli.handleAjaxResponse(response, ModalServiceExt,
                function () {
                    $scope.userMessage = response.Data;
                });
            usSpinnerService.stop('spinner-1');
        }).error(function(error) {
            console.error(error);
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }
}]);
'use strict';
angular.module('utilliApp')
    .controller('SendDataSharingInvitationController', ['$scope', '$state', '$rootScope', '$window', '$http',
        '$timeout', 'LeftMenuService', '$stateParams', 'CommonHeaderService', 'usSpinnerService', 'ModalServiceExt',
        'ServiceProvidersService', 'PropertyDataService', 'SharedMetersCacheService', '$q', 'PropertyService',
// ReSharper disable InconsistentNaming
        function ($scope, $state, $rootScope, $window, $http, $timeout, LeftMenuService, $stateParams,
            CommonHeaderService, usSpinnerService, ModalServiceExt, ServiceProvidersService, PropertyDataService,
            SharedMetersCacheService, $q, PropertyService) {
            var _t = $scope._t;
            // ReSharper restore InconsistentNaming
            LeftMenuService.show();
            CommonHeaderService.setUpBackButton($scope._t('Send Invitation'));

            $scope.provider = {};
            $scope.Meters = [];
            $scope.userMessage = _t("loading...");

            $scope.meterIsUsedErrorCode = 8;

            $scope.addMeter = function () {
                var ticks = new Date().getTime();
                $scope.Meters.push({
                    Id: 0,
                    clientUtilliId: ticks,
                    Number: ''
                });
            }

            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getCurrentProvider().then(
                function (providerData) {
                    usSpinnerService.stop('spinner-1');
                    $scope.provider = providerData;
                    getStaticData();
                },
                function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });

            var invitationData = utilli.getPayload($stateParams.token);
            $scope.name = invitationData.Name;

            $scope.deleteMeter = function (clientUtilliId) {
                var meters = $scope.Meters;
                var meter = _.find(meters, function(mtr) { return mtr.clientUtilliId === clientUtilliId });
                    // if it's not saved meter then just delete it
                    if (meter.Id === 0) {
                        meters.splice(meters.indexOf(meter), 1);
                        return;
                    }
                    // if this is a saved meter then confirm
                    ModalServiceExt.showYesNoMessage(
                        _t('Unauthorize meter'),
                        _t('Are you sure you want to cancel authorization for this meter?'),
                        function () {
                            usSpinnerService.spin('spinner-1');
                            $http({
                                method: "POST",
                                url: $scope.provider.ApiUrl + 'api/PropertyManagers/UnauthorizeMeter/',
                                data: { MeterId: meter.Id, InvitationToken: $stateParams.token }
                            }).success(function (response) {
                                usSpinnerService.stop('spinner-1');
                                if (response.Errors && response.Errors.length > 0) {
                                    ModalServiceExt.showServerError();
                                    return;
                                }
                                meters.splice(meters.indexOf(meter), 1);
                            }).error(function () {
                                usSpinnerService.stop('spinner-1');
                                ModalServiceExt.showServerError();
                            });
                        });
            }

            $scope.getErrorInfo = function (meter) {
                var targetState = '';
                if (meter.ErrorCode === 1) {
                    targetState = 'TopMenuLayout.MeterDoesNotExist';
                } else if (meter.ErrorCode === 2) {
                    targetState = 'TopMenuLayout.MeterDuplicated';
                } else if (meter.ErrorCode === 3) {
                    targetState = 'TopMenuLayout.ServiceAddressMismatches';
                } else if (meter.ErrorCode === 7) {
                    targetState = 'TopMenuLayout.MultipleTiedMeters';
                }

                if (!targetState) {
                    console.log('Uknown meter validation error: ' + meter.Error);
                    return;
                }

                $state.go(targetState, { meterId: meter.Id, token: $stateParams.token });
                SharedMetersCacheService.setMeters($scope.Meters);
            }

            $scope.accept = function () {
                $scope.submitted = true;
                if ($scope.form.$invalid)
                    return;
                if ($scope.Meters.length === 0) {
                    ModalServiceExt.showError(_t('No meters added.'));
                    return;
                }
                usSpinnerService.spin('spinner-1');
                SharedMetersCacheService.clear();
                $http({
                    url: $scope.provider.ApiUrl + 'api/PropertyManagers/AcceptInvitation/',
                    method: "POST",
                    data: {
                        token: $stateParams.token,
                        meters: $scope.Meters,
                        comments: $scope.comments
                    }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    utilli.handleAjaxResponse(response, ModalServiceExt,
                        function () {
                            var failedMeter = _.find(response.Data.Meters, function (meter) { return meter.ErrorCode !== 0 && meter.ErrorCode != $scope.meterIsUsedErrorCode; });
                            $scope.Meters = response.Data.Meters;
                            $scope.Meters.forEach(function (v) { v.clientUtilliId = v.Id; });
                            // if no failed meters then end
                            if (response.Data.Meters.length > 0 && !failedMeter) {
                                ModalServiceExt.showInfo(_t('Your approval has been successfully received.'),
                                    function () { $state.goToPropertyManagersWelcome(); });
                            }
                        });
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            $scope.decline = function () {
                usSpinnerService.spin('spinner-1');
                SharedMetersCacheService.clear();
                $http({
                    url: $scope.provider.ApiUrl + 'api/PropertyManagers/DeclineInvitation/',
                    method: "POST",
                    data: {
                        token: $stateParams.token,
                        InvitationRecipientId: invitationData.RecipientId,
                        Meters: $scope.Meters,
                        Comments: $scope.comments
                    }
                }).success(function (response) {
                    utilli.handleAjaxResponse(response, ModalServiceExt,
                        function () {
                            ModalServiceExt.showInfo(_t('Your invitation has successfully declined.'),
                                function () { $state.goToPropertyManagersWelcome(); });
                        });
                    usSpinnerService.stop('spinner-1');
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            function getStaticData() {
                usSpinnerService.spin('spinner-1');
                var getInvitationText = $http({
                    url: $scope.provider.ApiUrl + 'api/PropertyManagers/GetInvitationText/',
                    method: 'GET',
                    params: {
                        recipientId: invitationData.RecipientId
                    }
                });
                var getMeters = $http({
                    url: $scope.provider.ApiUrl + 'api/PropertyManagers/GetRecipientMeters/',
                    method: 'GET',
                    params: {
                        invitationToken: $stateParams.token
                    }
                });
                $q.all([getInvitationText, getMeters]).then(function (responses) {
                    usSpinnerService.stop('spinner-1');
                    var invitationTextResponse = responses[0].data;
                    var metersResponse = responses[1].data;
                    utilli.handleAjaxResponse(invitationTextResponse, ModalServiceExt,
                        function () {
                            $scope.userMessage = invitationTextResponse.Data;
                        });
                    utilli.handleAjaxResponse(metersResponse, ModalServiceExt,
                        function () {
                            $scope.Meters = metersResponse.Data.Meters;
                            $scope.Meters.forEach(function (v) { v.clientUtilliId = v.Id; });
                            if ($scope.Meters.length === 0) {
                                $scope.addMeter();
                            }
                        });
                }, function (error) {
                    console.error(error);
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }
        }])
    .factory('SharedMetersCacheService', function () {
            var savedMeters = null;
            var setMeters = function (meters) {
                savedMeters = meters;
            }

            var getMeters = function () {
                return savedMeters;
            }

            var clear = function () {
                savedMeters = null;
            }

            var deleteMeter = function (meterId) {
                if (!savedMeters)
                    return;
                savedMeters = _.reject(savedMeters, function (meter) { return meter.Id == meterId; });
                if (savedMeters.length === 0)
                    savedMeters = null;
            }
        
            return {
                setMeters: setMeters,
                getMeters: getMeters,
                clear: clear,
                deleteMeter: deleteMeter
            }
        });
'use strict';
angular.module('utilliApp')
.controller('RequestMeterSharingRevokeController', ['$scope', '$state', '$rootScope', '$window', '$http', '$timeout', 'LeftMenuService',
    '$stateParams', 'CommonHeaderService', 'usSpinnerService', 'ModalServiceExt', 'ServiceProvidersService',
// ReSharper disable InconsistentNaming
function ($scope, $state, $rootScope, $window, $http, $timeout, LeftMenuService, $stateParams, CommonHeaderService, usSpinnerService,
          ModalServiceExt, ServiceProvidersService) {
    var _t = $scope._t;
    // ReSharper restore InconsistentNaming

    $scope.meter = '';
    $scope.provider = {};
    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getProvider(Config.currentServiceProvider)
        .then(
            function(providerData){
                $scope.provider = providerData;
                usSpinnerService.stop('spinner-1');
            },
            function () {
                ModalServiceExt.showError(utilli.errors.serverErrorMessage);
                usSpinnerService.stop('spinner-1');
            }
        );

    CommonHeaderService.setUpBackButton($scope._t('Revoke Access'), true);

    $scope.cancel = function () {
        $state.goToPropertyManagersWelcome();
    }

    $scope.submit = function () {
        $scope.submitted = true;
        if($scope.form.$invalid)
            return;

        usSpinnerService.spin('spinner-1');

        $http({
            url: $scope.provider.ApiUrl + 'api/PropertyManagers/RequestMeterSharingRevoke/',
            method: "POST",
            data: {
                MeterNumber: $scope.meter,
                Email: $scope.email,
                Comments: $scope.comments
            }
        }).success(function (response) {
            utilli.handleAjaxResponse(response, ModalServiceExt,
                function () {
                    if (response.Data) {
                        ModalServiceExt.showError(response.Data);
                    } else {
                        ModalServiceExt.showInfo(_t('Your request is successfully accepted. '
                            + 'Please check your email inbox for the link to continue.'),
                        function () {
                            var isAuthUser = !!localStorage.getItem('SecurityToken');
                            if (isAuthUser)
                                $state.goMainLayout('Authorizations');
                            else
                                $state.goToPropertyManagersWelcome();
                        });
                    }
                });
            usSpinnerService.stop('spinner-1');
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }

}]);
'use strict';
angular.module('utilliApp')
.controller('RevokeMeterSharingController', ['$scope', '$state', '$rootScope', '$window', '$http', '$timeout', 'LeftMenuService',
    '$stateParams', 'CommonHeaderService', 'usSpinnerService', 'ModalServiceExt', 'ServiceProvidersService',
// ReSharper disable InconsistentNaming
function ($scope, $state, $rootScope, $window, $http, $timeout, LeftMenuService, $stateParams, CommonHeaderService, usSpinnerService,
          ModalServiceExt, ServiceProvidersService) {
    var _t = $scope._t;
    // ReSharper restore InconsistentNaming

    $scope.provider = {};
    $scope.Meters = [];

    var invitationData = utilli.getPayload($stateParams.token);
    $scope.name = invitationData.Name;
    $scope.recipientId = invitationData.RecipientId;

    CommonHeaderService.setUpBackButton($scope._t('Withdraw Authorization'));

    $scope.removeMeter = function (meter) {
        if ($scope.Meters.length === 1) {
            ModalServiceExt.showMessage(_t('Error'), _t('The invitation should have at least one meter.'));
            return;
        }
        var index = $scope.Meters.findIndex(function (e) { return e.Id === meter.Id });
        $scope.Meters.splice(index, 1);
    }

    $scope.revoke = function () {
        $scope.submitted = true;
        if ($scope.form.$invalid)
            return;
        usSpinnerService.spin('spinner-1');
        $http({
            url: $scope.provider.ApiUrl + 'api/PropertyManagers/RevokeMeters/',
            method: "POST",
            data: {
                token: $stateParams.token,
                InvitationRecipientId: invitationData.RecipientId,
                meters: $scope.Meters,
                comments: $scope.comments
            }
        }).success(function (response) {
            utilli.handleAjaxResponse(response, ModalServiceExt,
                function () {
                    if (response.Data.Meters.length > 0) {
                        $scope.Meters.forEach(function(m) {
                            m.Error = null;
                        });
                        response.Data.Meters.forEach(function (v) {
                            var meter = $scope.Meters.find(function (m) {
                                return m.Id == v.Id;
                            });
                            meter.Error = v.Error;
                        });
                    } else {
                        exit(_t("Your request has been successfully accepted."));
                    }
                });
            usSpinnerService.stop('spinner-1');
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }

    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getCurrentProvider()
        .then(
            function(providerData){
                usSpinnerService.stop('spinner-1');
                $scope.provider = providerData;
                getStaticData();
            },
            function () {
                ModalServiceExt.showError(utilli.errors.serverErrorMessage);
                usSpinnerService.stop('spinner-1');
            }
        );

    function exit(message) {
        ModalServiceExt.showInfo(message,
            function () {
                var isAuthUser = !!localStorage.getItem('SecurityToken');
                if (isAuthUser)
                    $state.goMainLayout('Authorizations');
                else
                    $state.goToPropertyManagersWelcome();
            });
    }

    function getStaticData() {
        usSpinnerService.spin('spinner-1');
        $http({
            url: $scope.provider.ApiUrl + 'api/PropertyManagers/GetRecipientMeters/',
            method: 'GET',
            params: { invitationToken : $stateParams.token }
        }).success(function (response) {
            usSpinnerService.stop('spinner-1');
            utilli.handleAjaxResponse(response, ModalServiceExt,
                function () {
                    if (response.Data.Meters.length > 0) {
                        $scope.Meters = [];
                        response.Data.Meters.forEach(function(v) {
                            $scope.Meters.push({
                                Id: v.Id,
                                MeterNumber: v.MeterNumber
                            });
                        });
                    } else {
                        exit(_t("You don't have shared meters. There is nothing to revoke."));
                    }
                });
        }).error(function (error) {
            console.error(error);
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }
}]);
'use strict';
angular.module('utilliApp')
.controller('PropertyManagerEnergyEfficiencyController', ['$scope', '$rootScope', '$window', '$http', '$sce', '$timeout',
    'LeftMenuService', '$stateParams', 'CommonHeaderService', 'usSpinnerService', 'ModalService', 'ModalServiceExt',
    'DefaultPropertyService', '$state',
// ReSharper disable InconsistentNaming
function ($scope, $rootScope, $window, $http, $sce, $timeout, LeftMenuService, $stateParams, CommonHeaderService, usSpinnerService, 
    ModalService, ModalServiceExt, DefaultPropertyService, $state) {
    var _t = $scope._t;
// ReSharper restore InconsistentNaming
    LeftMenuService.setCurrentTab('EnergyEfficiency');
    CommonHeaderService.setUpBackButton($scope._t('Energy Insights'));

    $scope.radioGraphType = 'last12Monthes'; //'calendarYear';
    $scope.radioGraphTypeConsumption = 'absolute';   

    usSpinnerService.spin('spinner-1');
    DefaultPropertyService.getAggregation($state.params.userId).then(function(aggregation) {
        $scope.noData = false;
        $scope.noMeters = false;
        if (aggregation == null) {
            $scope.noData = true;
            usSpinnerService.stop('spinner-1');
            return;
        }
    
        $scope.AggregationName = aggregation.Type === utilli.aggregationTypes.property 
            ? _t('Address') 
            : _t('Group Name');
        $scope.AggregationValue = aggregation.Name;

        if (aggregation.MetersCount === 0) {
            usSpinnerService.stop('spinner-1');
            $scope.noMeters = true;
            $scope.noMetersMessage = _t("Your property") + ' \'' + aggregation.Name + '\' ' + _t("does not have meters.");
            return;
        }
    
        $scope.meters = [''];
        $scope.currentMeter = '';

        getMeterDataGraph();
        usSpinnerService.stop('spinner-1');
    });

    function getMeterDataGraph () {
        usSpinnerService.spin('spinner-1');
        var apiUrl = localStorage.getItem('ApiUrl');
        var groupId = utilli.getCurrentGroupId();
        var propertyId = utilli.getCurrentPropertyId();
        $http({
            url: apiUrl + 'api/Consumption/GetMeterInfoByGroupId/',
            method: "GET",
            params: { groupId: groupId, propertyId: propertyId }
        }).success(function (jsonData) {
            usSpinnerService.stop('spinner-1');
            utilli.handleAjaxResponse(jsonData,
                ModalServiceExt,
                function () {
                    $scope.meters = _.map(jsonData.Data, function (item) {
                        return { id: item, value: item };
                    });
                    $scope.meters.unshift({ id: '', value: _t('All Meters') });
                    $scope.initTables($scope.currentMeter, $scope.radioGraphType, $scope.radioGraphTypeConsumption);
                });
        }).error(function (error) {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showError(error.Message);
        });
    };

    $scope.selectMeter = function () {
        $scope.initTables($scope.currentMeter, $scope.radioGraphType, $scope.radioGraphTypeConsumption);
    }

    $scope.data = null;

    $scope.createChartFullYear = function (data) {
        if (!data.YearOverYearFullUsageData)
            return;
        var title = data.YearOverYearFullUsageData.EfficiencyInfo;
        $scope.title = title;
        var labelRotation = -90; // 90 degrees to the left to make labels vertical
        $("#comparChartFullYear").kendoChart({
            title: {
                //text: title,
            },
            legend: {
                position: "bottom",
                visible: true,
                labels: {
                    font: "10px Arial, Helvetica, sans-serif"
                }
            },
            seriesColors: window.themeSettings != undefined ? [themeSettings.consumptionReadingColor, themeSettings.costColor] : ["#c4c4c4", "#0069a5"],
            series: [
                {
                    axis: "Usage",
                    name: $scope._t("Cons. in") + " " + data.YearOverYearFullUsageData.PreviousYear,
                    data: data.YearOverYearFullUsageData.PreviousYearConsumptions,
                    tooltip: {
                        visible: true,
                        color: "white",
                        format: "{0} " + data.YearOverYearFullUsageData.ConsumptionUnit
                    }
                },
                {
                    axis: "Usage",
                    name: $scope._t("Cons. in") + " " + data.YearOverYearFullUsageData.ThisYear,
                    data: data.YearOverYearFullUsageData.ThisYearConsumptions,
                    tooltip: {
                        visible: true,
                        color: "white",
                        format: "{0} " + data.YearOverYearFullUsageData.ConsumptionUnit
                    }
                },
                {
                    axis: "Temperature",
                    type: "line",
                    name: $scope._t("Avg. Tem. in") + " " + data.YearOverYearFullUsageData.PreviousYear,
                    data: data.YearOverYearFullUsageData.PreviousYearMonthlyAverageTemperatures,
                    visibleInLegend: true,
                    tooltip: {
                        visible: true,
                        format: "{0} F",
                        color: "white"
                    }
                },
                {
                    axis: "Temperature",
                    type: "line",
                    name: $scope._t("Avg. Temp. in") + " " + data.YearOverYearFullUsageData.ThisYear,
                    
                    data: data.YearOverYearFullUsageData.ThisYearMonthlyAverageTemperatures,
                    visibleInLegend: true,
                    tooltip: {
                        visible: true,
                        format: "{0} F",
                        color: "white"
                    }
                }
            ],
            valueAxis: [
                {
                    name: "Usage",
                    line: {
                        visible: true
                    },
                    minorGridLines: {
                        visible: true
                    },
                    labels: {
                        rotation: "auto"
                    }
                },
            {
                name: "Temperature",
                labels: {
                    format: "{0} F"
                }
            }
            ],
            categoryAxis: {
                categories: data.YearOverYearFullUsageData.PeriodNames,
                axisCrossingValues: [0, 12],
                majorGridLines: {
                    visible: false
                },
                labels: {
                    rotation: labelRotation
                }
            }
        });

        // HACK: enable scrolling on Windows Phone when swiping over the chart
        //chartElement.css("-ms-touch-action", "auto");
    };

    $scope.createChartTable1 = function (data) {
        if (!data.SameYearDifference)
            return;
        var title = data.SameYearDifference.ConsumptionPercents;
        if (title > 0) {
            title = "+" + title;
        }

        $("#comparChartTable1").kendoChart({
            title: {
                text: $scope._t("Consumption") + ": " + title + "%"
            },
            chartArea: {
                height: 200
            },
            legend: {
                visible: false
            },
            seriesColors: window.themeSettings != undefined ? [themeSettings.consumptionReadingColor, themeSettings.costColor] : ["#0069a5", "#0098ee"],
            series: [{
                name: "Consumption",
                data: [data.SameYearOldPeriod.Consumption, data.SameYearNewPeriod.Consumption]
            }
            ],
            valueAxis: {
                max: Math.max(data.SameYearOldPeriod.Consumption, data.SameYearNewPeriod.Consumption) * 1.1,
                min: 0,
                line: {
                    visible: true
                },
                minorGridLines: {
                    visible: true
                },
                labels: {
                    rotation: "auto"
                }
            },
            categoryAxis: {
                categories: [data.SameYearOldPeriod.PeriodName, data.SameYearNewPeriod.PeriodName],
                majorGridLines: {
                    visible: false
                }
            },
            tooltip: {
                visible: true,
                template: "#= series.name #: #= value #"
            }
        });


        // HACK: enable scrolling on Windows Phone when swiping over the chart
        //chartElement.css("-ms-touch-action", "auto");
    };

    $scope.createChartTable2 = function (data) {
        if (!data.SameYearDifference)
            return;
        var title = data.SameYearDifference.BillAmountPercents;
        if (title > 0) {
            title = "+" + title;
        }
        $("#comparChartTable2").kendoChart({
            title: {
                text: $scope._t("Bill Amount") + ": " + title + "%"
            },
            chartArea: {
                height: 200
            },
            legend: {
                visible: false
            },
            seriesColors: window.themeSettings != undefined ? [themeSettings.consumptionReadingColor, themeSettings.costColor] : ["#0069a5", "#0098ee"],
            series: [{
                name: $scope._t("Bill Amount") + ":",
                data: [data.SameYearOldPeriod.BillAmount, data.SameYearNewPeriod.BillAmount]
            }
            ],
            valueAxis: {
                max: Math.max(data.SameYearOldPeriod.BillAmount, data.SameYearNewPeriod.BillAmount) * 1.1,
                min: 0,
                line: {
                    visible: true
                },
                minorGridLines: {
                    visible: true
                },
                labels: {
                    rotation: "auto"
                }
            },
            categoryAxis: {
                categories: [data.SameYearOldPeriod.PeriodName, data.SameYearNewPeriod.PeriodName],
                majorGridLines: {
                    visible: false
                }
            },
            tooltip: {
                visible: true,
                template: "#= series.name # $#= value #"
            }
        });
    };

    $scope.createChartTable3 = function (data) {
        if (!data.SameYearDifference)
            return;
        var title = data.SameYearDifference.EnergyCostGcrPercents;
        if (title > 0) {
            title = "+" + title;
        }
        $("#comparChartTable3").kendoChart({
            title: {
                text:  $scope._t("Energy Cost") + ": " + title + "%"
            },
            chartArea: {
                height: 200
            },
            legend: {
                visible: false
            },
            seriesColors: window.themeSettings != undefined ? [themeSettings.consumptionReadingColor, themeSettings.costColor] : ["#0069a5", "#0098ee"],
            series: [{
                name: "Energy Cost:",
                data: [data.SameYearOldPeriod.EnergyCostGcr, data.SameYearNewPeriod.EnergyCostGcr]
            }
            ],
            valueAxis: {
                max: Math.max(data.SameYearOldPeriod.EnergyCostGcr, data.SameYearNewPeriod.EnergyCostGcr) * 1.1,
                min: 0,
                line: {
                    visible: true
                },
                minorGridLines: {
                    visible: true
                },
                labels: {
                    rotation: "auto"
                }
            },
            categoryAxis: {
                categories: [data.SameYearOldPeriod.PeriodName, data.SameYearNewPeriod.PeriodName],
                majorGridLines: {
                    visible: false
                }
            },
            tooltip: {
                visible: true,
                template: "#= series.name # $#= value #"
            }
        });
    };

    $scope.createChartTable4 = function (data) {
        if (!data.YearOverYearDifference)
            return;
        var title = data.YearOverYearDifference.ConsumptionPercents;
        if (title > 0) {
            title = "+" + title;
        }
        $("#comparChartTable4").kendoChart({
            title: {
                text:  $scope._t("Consumption") + ": " + title + "%"
            },
            chartArea: {
                height: 200
            },
            legend: {
                visible: false
            },
            seriesColors: window.themeSettings != undefined ? [themeSettings.consumptionReadingColor, themeSettings.costColor] : ["#0069a5", "#0098ee"],
            series: [{
                name: "Consumption",
                data: [data.YearOverYearOldPeriod.Consumption, data.YearOverYearNewPeriod.Consumption]
            }
            ],
            valueAxis: {
                max: Math.max(data.YearOverYearOldPeriod.Consumption, data.YearOverYearNewPeriod.Consumption) * 1.1,
                min: 0,
                line: {
                    visible: true
                },
                minorGridLines: {
                    visible: true
                },
                labels: {
                    rotation: "auto"
                }
            },
            categoryAxis: {
                categories: [data.YearOverYearOldPeriod.PeriodName, data.YearOverYearNewPeriod.PeriodName],
                majorGridLines: {
                    visible: false
                }
            },
            tooltip: {
                visible: true,
                template: "#= series.name #: #= value #"
            }
        });
    };

    $scope.createChartTable5 = function (data) {
        if (!data.YearOverYearDifference)
            return;
        var title = data.YearOverYearDifference.BillAmountPercents;
        if (title > 0) {
            title = "+" + title;
        }
        $("#comparChartTable5").kendoChart({
            title: {
                text:  $scope._t("Bill Amount") + ": " + title + "%"
            },
            chartArea: {
                height: 200
            },
            legend: {
                visible: false
            },
            seriesColors: window.themeSettings != undefined ? [themeSettings.consumptionReadingColor, themeSettings.costColor] : ["#0069a5", "#0098ee"],
            series: [{
                name:  $scope._t("Bill Amount") + ":",
                data: [data.YearOverYearOldPeriod.BillAmount, data.YearOverYearNewPeriod.BillAmount]
            }
            ],
            valueAxis: {
                max: Math.max(data.YearOverYearOldPeriod.BillAmount, data.YearOverYearNewPeriod.BillAmount) * 1.1,
                min: 0,
                line: {
                    visible: true
                },
                minorGridLines: {
                    visible: true
                },
                labels: {
                    rotation: "auto"
                }
            },
            categoryAxis: {
                categories: [data.YearOverYearOldPeriod.PeriodName, data.YearOverYearNewPeriod.PeriodName],
                majorGridLines: {
                    visible: false
                }
            },
            tooltip: {
                visible: true,
                template: "#= series.name # $#= value #"
            }
        });
    };

    $scope.createChartTable6 = function (data) {
        if (!data.YearOverYearDifference)
            return;
        var title = data.YearOverYearDifference.EnergyCostGcrPercents;
        if (title > 0) {
            title = "+" + title;
        }
        $("#comparChartTable6").kendoChart({
            title: {
                text:  $scope._t("Energy Cost") + ": " + title + "%"
            },
            chartArea: {
                height: 200
            },
            legend: {
                visible: false
            },
            seriesColors: window.themeSettings != undefined ? [themeSettings.consumptionReadingColor, themeSettings.costColor] : ["#0069a5", "#0098ee"],
            series: [{
                name: "Energy Cost:",
                data: [data.YearOverYearOldPeriod.EnergyCostGcr, data.YearOverYearNewPeriod.EnergyCostGcr]
            }
            ],
            valueAxis: {
                max: Math.max(data.YearOverYearOldPeriod.EnergyCostGcr, data.YearOverYearNewPeriod.EnergyCostGcr) * 1.1,
                min: 0,
                line: {
                    visible: true
                },
                minorGridLines: {
                    visible: true
                },
                labels: {
                    rotation: "auto"
                }
            },
            categoryAxis: {
                categories: [data.YearOverYearOldPeriod.PeriodName, data.YearOverYearNewPeriod.PeriodName],
                majorGridLines: {
                    visible: false
                }
            },
            tooltip: {
                visible: true,
                template: "#= series.name # $#= value #"
            }
        });
    };

    $scope.createAllCharts = function (data) {
        $scope.createChartFullYear(data);
        $scope.createChartTable1(data);
        $scope.createChartTable2(data);
        $scope.createChartTable3(data);
        $scope.createChartTable4(data);
        $scope.createChartTable5(data);
        $scope.createChartTable6(data);
    }

    $scope.changeGraphType = function () {
        $scope.initTables($scope.currentMeter, $scope.radioGraphType, $scope.radioGraphTypeConsumption);
    }

    $scope.changeGraphTypeConsumption = function () {
        $scope.initTables($scope.currentMeter, $scope.radioGraphType, $scope.radioGraphTypeConsumption);
    }

    var resizeAction = function () {
        $scope.createAllCharts($scope.data);
    }
    $scope.initTables = function (currentMeter, graphType, graphTypeConsumption) {
        var apiUrl = localStorage.getItem('ApiUrl');
        var groupId = utilli.getCurrentGroupId();
        var propertyId = utilli.getCurrentPropertyId();
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/Consumption/GetPropertyEnergyEfficiency/',
            method: "GET",
            params: {
                groupId: groupId,
                propertyId: propertyId,
                meterNum: currentMeter,
                graphType: graphType,
                consumptionType: graphTypeConsumption,
                userName: $state.params.userId
            }
        }).success(function (json) {
            if (json) {
                if (json.Errors && json.Errors.length > 0) {
                    ModalServiceExt.showError(json.Errors[0]);
                }
                else {
                    $scope.data = json.Data;
                    $scope.createAllCharts($scope.data);
                    $(window).bind('resize', resizeAction);
                }
            } else {
                ModalServiceExt.showError($scope._t("Error occurred during consumption retrieval."));
            }
            usSpinnerService.stop('spinner-1');
        }).error(function (error) {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showError(error.Message);
        });
    }

    $scope.$on("$destroy", function () {
    angular.element($window).off('resize', resizeAction);
    });
}]);
'use strict';
angular.module('utilliApp')
    .controller('EditPropertyController', ['$scope', '$http', 'usSpinnerService', 'LeftMenuService', '$state', 
        '$stateParams', 'CommonHeaderService', 'PropertyDataService', 'PropertySettingsService', 'ModalServiceExt',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, LeftMenuService, $state, $stateParams, CommonHeaderService,
            PropertyDataService, PropertySettingsService, ModalServiceExt) {

            var _t = $scope._t;
            LeftMenuService.setCurrentTab('MyProperties');
            CommonHeaderService.setUp(_t('Edit Property'));

            $scope.NeedMetersApproval = false;

            $scope.propertyTypes = [];

            $scope.totalNumberOfMeters = '';
            $scope.numberOfErrors = '';

            PropertyDataService.getProperty($stateParams.id, function (property) {
                $scope.authorized = property.Authorized;
                $scope.propertyName = property.PropertyName;

                $scope.delegatingUser = property.DelegatingUser;
                $scope.delegatingUserPhone = property.DelegatingUserPhone;
                $scope.delegatingUserEmail = property.DelegatingUserEmail;

                $scope.propertyPrimaryFunctionName = PropertySettingsService.primaryPropertyFunctions[property.PrimaryPropertyFunction];

                $scope.address = property.Address1;
                if (property.Address2 != null && property.Address2 != '')
                    $scope.address += ' ' + property.Address2;

                $scope.NeedMetersApproval = property.NeedMetersApproval;

                $scope.address += ' ' + property.City;
                $scope.address += ' ' + property.State;
                $scope.address += ' ' + property.Zip;

                $scope.address1 = property.Address1;
                $scope.address2 = property.Address2;
                $scope.city = property.City;
                $scope.state = property.State;
                $scope.postalCode = property.Zip;
                $scope.grossFloorArea = property.GrossFloorArea;
                $scope.grossFloorAreaUnits = property.GrossFloorAreaUnits.toString();
                $scope.yearBuilt = property.YearBuilt;
                $scope.irrigatedArea = property.IrrigatedArea;
                $scope.irrigatedAreaUnits = property.IrrigatedAreaUnits.toString();
                $scope.occupancy = property.Occupancy.toString() + "%";
                $scope.numberOfBuildings = property.NumberOfUnits;
                $scope.numberOfMeters = property.NumberOfMeters;
                $scope.numberOfErrors = property.NumberOfErrors;

                if ($scope.grossFloorAreaUnits == 0) {
                    $scope.grossFloorAreaUnits = 'Sq.Ft.';
                }
                if ($scope.grossFloorAreaUnits == 1) {
                    $scope.grossFloorAreaUnits = 'Sq.M.';
                }
                if ($scope.irrigatedAreaUnits == 0) {
                    $scope.irrigatedAreaUnits = 'Sq.Ft.';
                }
                if ($scope.irrigatedAreaUnits == 1) {
                    $scope.irrigatedAreaUnits = 'Sq.M.';
                }
                if ($scope.irrigatedAreaUnits == 2) {
                    $scope.irrigatedAreaUnits = 'Acres';
                }
                if ($scope.irrigatedAreaUnits == 3) {
                    $scope.irrigatedAreaUnits = 'Item';
                }

                var propTypeNames = PropertySettingsService.getPropertyTypeNames();

                property.PropertyTypes.forEach(function (type) {
                    if (type.Name != null && type.Name != '') {
                        $scope.propertyTypes.push({ id: type.TypeId, caption: type.Name + ' (' + propTypeNames[type.TypeId - 1] + ')' });
                    }
                    else {
                        $scope.propertyTypes.push({ id: type.TypeId, name: type.Name, caption: propTypeNames[type.TypeId - 1] });
                    }
                });

                if($stateParams.showAuthorizationMetersWarning) {
                    PropertyDataService.showAuthorizationMetersWarningDialog($stateParams.id, function () {
                        ModalServiceExt.showInfo(
                            _t("Property is successfully edited but consumption data will not be submitted to Energy Star until tenants authorize data sharing."));
                    });
                }    
            });

            if ($state.params)
                $scope.propertyId = $state.params.id;

            $scope.cancel = function () {
                $state.goMainLayout('PropertyList');
            }

            $scope.editPropertyOverview = function() {
                $state.goMainLayout(
                    'AddProperty.PropertyOverview',
                    { id: $scope.propertyId, mode: 'edit', stepsCount: 5, step: 0 });
            };

            $scope.editPropertyDetails = function() {
                $state.goMainLayout("AddProperty.PropertyType",
                    {
                        id: $scope.propertyId,
                        mode: 'edit',
                        stepsCount: 1 + $scope.propertyTypes.length,
                        step: 0
                    });
            }

            $scope.editMeters = function () {
                $state.goMainLayout("AddProperty.AddMeters",
                    {
                        id: $scope.propertyId,
                        mode: 'edit',
                    });
            }

            $scope.submitAuth = function () {
                usSpinnerService.spin('spinner-1');
                $http({
                    method: 'POST',
                    url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/AuthorizeProperty/',
                    params: { propertyId: $stateParams.id, userName: $state.params.userId }
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');

                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showServerError();
                        return;
                    }

                    if (response.Data && response.Data.NeedsAuthorization) {
                        PropertyDataService.showAuthorizationMetersWarningDialog($stateParams.id, function () {
                            ModalServiceExt.showInfo(
                                _t("Property is successfully authorized but consumption data will not be submitted to Energy Star until tenants authorize data sharing."),
                                function () { $state.goMainLayout('EditProperty', { id: $stateParams.id }, { reload: true }); });
                        });
                    } else {
                        ModalServiceExt.showInfo(_t("Property is successfully authorized."), function () { $state.goMainLayout('EditProperty', { id: $stateParams.id }, { reload: true }); });
                    }
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                });
            }
        }])
'use strict';
angular.module('utilliApp')
.controller('UsageController', ['$scope', '$http', '$rootScope', 'usSpinnerService',
    'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt', '$state', 'UnitsService',
// ReSharper disable InconsistentNaming
function ($scope, $http, $rootScope, usSpinnerService, LeftMenuService, CommonHeaderService, ModalServiceExt, $state,
    UnitsService) {
    var _t = $scope._t;
    // ReSharper restore InconsistentNaming

    $scope.isHc = utilli.isHc();

    $scope.units = UnitsService;
    $scope.config = Config;
    if ($state.current.name == 'MainLayout.Usage') {
        LeftMenuService.setCurrentTab('Usage');
    }
    CommonHeaderService.setUpNotificationButton();
    $scope.isExportToExcelButtonVisible = !isMobileOrRipple();
    $scope.currentPage = 0;
    $scope.pageSize = 12;

    $scope.previousPage = function () {
        if (!$scope.disablePrev) {
            $scope.currentPage++;
            getGraph();
        }
    };

    $scope.nextPage = function () {
        if (!$scope.disableNext) {
            $scope.currentPage--;
            getGraph();
        }
    };

    $scope.tableData = [];

    function showChartLoading(){
        $scope.chart.showLoading('<img src="Styles/Material/loading-image.gif">');
    }

    var getMeterDataGraph = function () {
        // build empty chart so that loading.gif will be visible while data is being loaded via ajax call
        processGraphData({Count: 0, PageData: []});
        showChartLoading();
        getGraph();
    };

    $scope.getExcelData = function () {
        var apiUrl = localStorage.getItem('ApiUrl') + 'api/Consumption/GenerateConsumptionDataExcel/'
           + '?AccountNumber=' + localStorage.getItem('CurrentAccountNumber');
        startSpin();
        $http({
            url: apiUrl,
            method: "GET",
            params: { }
        }).success(function (response) {
            if (response == undefined || response.HasErrors == undefined) {
                ModalServiceExt.showServerError();
                stopSpin();
                return;
            }
            if (response.HasErrors) {
                ModalServiceExt.showError(response.Errors[0]);
            }
            else {
                var url = utilli.getFileUrlWithToken(response.Data);
                utilli.downloadFile(url, "Payments.xlsx");
            }
            stopSpin();
        }).error(function (error) {
            stopSpin();
            ModalServiceExt.showError(error.Message);
        });
    }

    $scope.getGreenButtonData = function () {
        var apiUrl = localStorage.getItem('ApiUrl') + 'api/Consumption/GenerateGreenButtonData/'
           + '?AccountNumber=' + localStorage.getItem('CurrentAccountNumber');
        startSpin();
        $http({
            url: apiUrl,
            method: "GET",
            params: {}
        }).success(function (response) {
            if (response == undefined || response.HasErrors == undefined) {
                ModalServiceExt.showServerError();
                stopSpin();
                return;
            }
            if (response.HasErrors) {
                ModalServiceExt.showError(response.Errors[0]);
            }
            else {
                var url = utilli.getFileUrlWithToken(response.Data);
                utilli.downloadFile(url, "Payments.xlsx");
            }
            stopSpin();
        }).error(function (error) {
            stopSpin();
            ModalServiceExt.showError(error.Message);
        });
    }

    /***
     * Enables/disables next/prev controls depending on current page and pointsTotalCount
     * @param pointsTotalCount count of available points for graph including those not visible on the current page
     */
    function analyzePointsTotalCount(pointsTotalCount) {
        // (currentPage + 1) because counting starts from zero
        $scope.disablePrev = ($scope.currentPage + 1) * $scope.pageSize >= pointsTotalCount;
        $scope.disableNext = $scope.currentPage == 0;
    }

    $scope.isFirstGraphLoad = true;
    /***
     * does everything needed to re-plot the chart with current parameters (page number, consumption units)
     */
    function getGraph() {
        var currentAccountNumber = localStorage.getItem('CurrentAccountNumber');
        var apiUrl = localStorage.getItem('ApiUrl');
        showChartLoading();

        $http({
            url: apiUrl + 'api/Consumption/GetConsumptionGraphPageForUsage/',
            method: "GET",
            params: {
                accountNumber: currentAccountNumber,
                skip: $scope.currentPage * $scope.pageSize,// currentPage starts with 0
                pageSize: $scope.pageSize
            }
        }).success(function (graphPageJson) {
            $scope.chart.hideLoading();
            if (graphPageJson) {
                if (graphPageJson.Errors && graphPageJson.Errors.length > 0) {
                    ModalServiceExt.showError(graphPageJson.Errors[0]);
                }
                else {
                    if ($scope.isFirstGraphLoad && graphPageJson.PageData.length > 0) {
                        $scope.isFirstGraphLoad = false;
                        $scope.units.setSelectedUnits(graphPageJson.PageData[0].Unit);
                    }
                    processGraphData(graphPageJson);
                }
            } else {
                ModalServiceExt.showError($scope._t("Error occurred during consumption retrieval."));
            }
        }).error(function (error) {
            $scope.chart.hideLoading();
            ModalServiceExt.showError(error.Message);
        });
    };

    /**
     * prepares data for the chart and the table below the chart
     * @param graphPageJson json with data received from our back-end
     */
    function processGraphData(graphPageJson) {

        if (graphPageJson.PageData == undefined)
            return;

        analyzePointsTotalCount(graphPageJson.Count);

        // points for the graph must be reset and filled with data in json
        $scope.graphPoints = graphPageJson.PageData;
        $scope.tableData = [];

        var tableData = convertChartUnits($scope.graphPoints);
        for (var i = 0; i < tableData.length; i++) {
            var reading = tableData[i];
            // add item in the table under the chart
            var tableDataItem = _.find($scope.tableData, function(item) { return item.date == reading.ReadingDateForTable });
            if (tableDataItem) {
                tableDataItem.consumption += reading.Consumption;
                tableDataItem.registers = tableDataItem.registers || [ { 
                    registerNum: tableDataItem.registerNum, 
                    consumption: tableDataItem.consumption} ];
                tableDataItem.registers.push({
                    registerNum: reading.RegisterNumber,
                    consumption: reading.Consumption
                });
            } else {
                tableDataItem = {};
                tableDataItem.date = reading.ReadingDateForTable;
                tableDataItem.amountString = utilli.formatCurrency(reading.Amount);
                tableDataItem.registerNum = reading.RegisterNumber;
                tableDataItem.consumption = reading.Consumption;
                tableDataItem.averageMonthlyTemperature = reading.MonthAverageTemperature;
                if (tableDataItem.averageMonthlyTemperature == "-99") {
                    tableDataItem.averageMonthlyTemperature = "";
                    reading.AverageMonthlyTemperature = null;
                }
                tableDataItem.unit = reading.Unit;
                // insert tableDataItem to the beginning of the array because elements were sorted by ReadingDate desc.
                $scope.tableData.unshift(tableDataItem);
            }
        }

        $scope.createChart();
    };

    $scope.getConsumptionString = function(consumptionHistoryItem){
        var selectedFraction = Config.getConsumptionUnitFraction($scope.units.selectedUnitsType.name);
        var sourceFraction = Config.getConsumptionUnitFraction(consumptionHistoryItem.unit)
        var number = consumptionHistoryItem.consumption * selectedFraction / sourceFraction;
        return utilli.formatNumber(number);
    }

    /**
     * converts consumption units for the graph data
     * (for example ccf -> gallons)
     * @param graphPoints points for the chart
     * @param targetUnitsType target type of the consumption units
     * @param sourceUnitsType source type of the consumption units
     * @returns {Array|*} cloned graphPoints with converted consumption values
     */
    function convertUnits(graphPoints, targetUnitsType, sourceUnitsType) {
        var consumptionUnits = $scope.units.currentUnits;
        var targetFraction = consumptionUnits[targetUnitsType];
        var sourceFraction = consumptionUnits[sourceUnitsType];
        var coefficient = targetFraction / sourceFraction;
        var graphData = $.map(graphPoints, function (item) {
            var clone = $.extend({}, item);
            var stringFixed = (clone.Consumption * coefficient).toFixed(2);
            clone.Consumption = parseFloat(stringFixed);
            clone.Unit = targetUnitsType;
            return clone;
        });
        return graphData;
    }

    var convertChartUnits = function(graphPoints){
        if (!$scope.graphPoints || $scope.graphPoints.length === 0)
            return [];
        var unitsType = $scope.units.getSelectedUnitsTypeName();
        var sourceUnitsType = $scope.graphPoints[0].Unit;
        return convertUnits(graphPoints, unitsType, sourceUnitsType);
    }

    var buildSeries = function(){
        var result = [
            {
                name: _t('Consumption'),
                data: [],
                tooltip: {
                    headerFormat: '',
                    pointFormatter: function (){
                        return '<span>' + this.unit + ': ' +  utilli.formatNumber(this.y) +'</span>';
                    }
                },
                yAxis: 1
            },
            {
                type: 'spline',
                name: _t('Amount'),
                data: [],
                tooltip: {
                    pointFormatter: function () {
                        return utilli.formatCurrency(this.y);
                    },
                    headerFormat: ''
                 }
            }
        ];
        if(!$scope.isHc) {
            result.push({
                type: 'spline',
                name: _t('Average Temperature'),
                data: [],
                tooltip: {
                    pointFormat: '{point.y}F (' + _t('Range') + ': {point.low}F-{point.high}F)',
                    headerFormat: ''
                },
                yAxis: 2
            });
            result.push({
                name: _t('Temperature Range'),
                type: 'errorbar',
                data: [],
                enableMouseTracking: false,
                yAxis: 2
            });
        }
        return result;
    }

    var buildChart = function (series) {
        $scope.chart = Highcharts.chart('chart', {
            credits: {
                enabled: false
            },
            chart: {
                spacingTop: 40,
                spacingBottom: 60,
                type: 'column'
            },
            title: {
                text: ''
            },
            xAxis: {
                type: 'category', labels: { rotation: 270 }
            },
            yAxis: [{
                labels: {
                    formatter: function () {
                        return utilli.formatCurrency(this.value);
                    }
                },
                title: {
                    text: _t('Amount')
                },
                min: 0
            }, {
                labels: {
                    formatter: function () {
                        return utilli.formatNumber(this.value) + ' ' + $scope.units.getSelectedUnitsTypeName();
                    }
                },
                title: {
                    text: _t('Consumption')
                },
                opposite: true
            }, {
                labels: {
                    format: ''
                },
                title: {
                    text: ''
                },
                min: 0,
                visible: false
            }],
            legend: {
                align: 'center',
                verticalAlign: 'bottom',
                y: 60,
                floating: true,
                backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                borderColor: '#CCC',
                borderWidth: 1,
                shadow: false
            },
            tooltip: {
                shared: false,
                useHTML: true
            },
            plotOptions: {
                series: {
                    cursor: 'pointer'
                }
            },
            exporting: {
                enabled: false
            },
            series: series
        });
    }

    /**
     * plots the chart using data points from the $scope
     */
    $scope.createChart = function() {
        var graphData = convertChartUnits($scope.graphPoints);
        
        var consumptionReadingIndex = 0;
        var amountIndex = 1;
        var averageTemperatureIndex = 2;
        var temperatureRangeIndex = 3;

        var series = buildSeries();

        var categories = [];

        graphData.forEach(function (item) {
            categories.push(item.ReadingDateForGraphCategory);

            series[consumptionReadingIndex].data.push({
                name: item.ReadingDateForGraphCategory,
                y: item.Consumption,
                unit: $scope.units.getSelectedUnitsTypeName()
            });

            series[amountIndex].data.push({
                name: item.ReadingDateForGraphCategory,
                y: item.Amount
            });

            if(!$scope.isHc) {
                series[averageTemperatureIndex].data.push({
                    name: item.ReadingDateForGraphCategory,
                    y: item.MonthAverageTemperature,
                    low: item.MonthMinTemperature,
                    high: item.MonthMaxTemperature
                });

                series[temperatureRangeIndex].data.push({
                    name: item.ReadingDateForGraphCategory,
                    low: item.MonthMinTemperature,
                    high: item.MonthMaxTemperature
                });
            }
        });

        buildChart(series);
    }

    var startSpin = function () {
        usSpinnerService.spin('spinner-1');
    };

    var stopSpin = function () {
        usSpinnerService.stop('spinner-1');
    };

    setTimeout(function () {
        // render chart after left menu. otherwise the width of the chart will be calculated wrong
        getMeterDataGraph();
    }, 100);
    
}]);
'use strict';
angular.module('utilliApp')
    .service('UnitsService', function() {
        var svc = {
            selectedUnitsType: { name: '' },
            dropDownItems: [{name: ''}]
        };
        svc.setSelectedUnits = function (unitsTypeName) {
            svc.selectedUnitsType = _.find(svc.dropDownItems, function (item) {
                return item.name === unitsTypeName;
            });
            if (!svc.selectedUnitsType)
                svc.selectedUnitsType = { name: unitsTypeName };
        }
        /**
         * Sets selected unit types if nothing is currently selected
         */
        svc.setSelectedUnitsIfEmpty = function (unitsTypeName) {
            if (svc.selectedUnitsType.name == null || svc.selectedUnitsType.name == '') {
                svc.setSelectedUnits(unitsTypeName);
            }
        }
        // updates values in the units drop down based on currently loaded account data
        svc.updateUnits = function() {
            svc.currentUnits = Config.getCurrentConsumptionUnits();
            svc.dropDownItems = $.map(svc.currentUnits, function(element, index) {
                return { name: index };
            });
        };
        svc.getSelectedUnitsTypeName = function(){
            return svc.selectedUnitsType ? svc.selectedUnitsType.name : '';
        }
        // set default units
        svc.updateUnits();
        /**
         * Get multiplier to convert given uom into currently selected uom.
         * @param {} uom source uom
         * @returns {} multiplier
         */
        svc.getCoefficient = function(uom) {
            var consumptionUnits = Config.getCurrentConsumptionUnits();
            var targetFraction = consumptionUnits[svc.selectedUnitsType.name];
            var sourceFraction = consumptionUnits[uom];
            var coefficient = targetFraction / sourceFraction;
            return coefficient;
        }
        return svc;
    });
'use strict';
// ReSharper disable once UndeclaredGlobalVariableUsing
angular.module('utilliApp')
    .service('PropertyListService',
        [
            '$http', 'ModalServiceExt', '$timeout', '$state', '$q',
// ReSharper disable InconsistentNaming
            function($http, ModalServiceExt, $timeout, $state, $q) {
                var _t = utilli._t;
// ReSharper restore InconsistentNaming
                var svc = {};
                svc.updateProperties = function(data, existingPropertyList) {
                    var areTherePropertiesInProgress = false;
                    if (data) {
                        _.each(data,
                            function(p) {
                                var existingProperty = _.find(existingPropertyList,
                                    function(ep) {
                                        return ep.Id === p.Id;
                                    });
                                if (!existingProperty)
                                    return;
                                existingProperty.Status = p.Status;
                                existingProperty.IsSyncInProcess = p.IsSyncInProcess;
                                existingProperty.DisplayedStatus = p.DisplayedStatus;
                                existingProperty.EnergyStarScore = p.EnergyStarScore;
                                existingProperty.CurrentConsumption = p.CurrentConsumption;

                                if (existingProperty.EnergyStarScore == 0)
                                {
                                    existingProperty.EnergyStarScore = 'N/A';
                                }

                                if (p.IsSyncInProcess) {
                                    areTherePropertiesInProgress = true;
                                }
                            });
                    }
                    return areTherePropertiesInProgress;
                };
                svc.getPropertyList = function(withoutDelegated) {
                    var requestData = { withoutDelegated: withoutDelegated ? true : false };
                    utilli.addUserName($state, requestData);
                    return $http({
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetPropertyList/',
                        method: "GET",
                        params: requestData
                    });
                };
                svc.loadPropertyList = function ($scope, response) {
                    if (svc.timeout) {
                        $timeout.cancel(svc.timeout);
                    }
                    if (response.Data) {
                        var areTherePropertiesInProgress = false;
                        // ReSharper disable once UndeclaredGlobalVariableUsing
                        _.each(response.Data,
                            function(p) {
                                if (p.IsSyncInProcess) {
                                    areTherePropertiesInProgress = true;
                                }
                            });
                        $scope.propertyList = response.Data;
                        if (areTherePropertiesInProgress) {
                            svc.timeout = $timeout(function() {
                                    svc.reloadPropertylist($scope, $state.current.name);
                                },
                                utilli.propertyRefreshTimeout);
                        }
                    } else {
                        $scope.propertyList = [];
                    }
                }
                svc.refreshScore = function ($scope, property) {
                    //Refresh score button should be always clickable GNIS-2303
                    //if (property.isLoading)
                    //    return;
                    property.isLoading = true;
                    $http({
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/RefreshPropertyScore/',
                        method: "POST",
                        params: { propertyId: property.Id }
                    })
                    .then(ModalServiceExt.checkApiResponseError, ModalServiceExt.catchAjaxError)
                    .then(function () {
                        svc.reloadPropertylist($scope, $state.current.name);
                    }, function (error) {
                        if (error === "PropertyIsNotCompleteError") {
                            // todo: add a link to the edit property page
                            ModalServiceExt.showError("Please complete property creation process.");
                        }
                        property.isLoading = false;
                    });
                }
                svc.reloadPropertylist = function($scope, stateName) {
                    // if the state is changed then stop updates
                    if ($state.current.name !== stateName)
                        return;
                    svc.getPropertyList().success(function(response) {
                        // ReSharper disable once VariableUsedInInnerScopeBeforeDeclared
                        if (response.Data) {
                            var areTherePropertiesInProgress =
                                svc.updateProperties(response.Data, $scope.propertyList);
                            if (areTherePropertiesInProgress) {
                                svc.timeout = $timeout(function () {
                                        svc.reloadPropertylist($scope, stateName);
                                    },
                                    utilli.propertyRefreshTimeout);
                            }
                        } else {
                            $scope.propertyList = [];
                        }
                    }).error(function(e) {
                        // i don't want to show user a new error popup every 5 seconds
                        console.log(e);
                    });
                }

                return svc;
            }
        ]);
'use strict';
// ReSharper disable once UndeclaredGlobalVariableUsing
angular.module('utilliApp')
    .service('PropertyService', ['$http', 'ModalServiceExt', '$timeout', '$state', 'usSpinnerService',
// ReSharper disable InconsistentNaming
            function ($http, ModalServiceExt, $timeout, $state, usSpinnerService) {
                var _t = utilli._t;
// ReSharper restore InconsistentNaming
                var svc = {};
                svc.updateProperty = function(freshProperty, existingProperty) {
                    if (!freshProperty|| !existingProperty)
                            return false;
                    existingProperty.Status = freshProperty.Status;
                    existingProperty.IsSyncInProcess = freshProperty.IsSyncInProcess;
                    existingProperty.DisplayedStatus = freshProperty.DisplayedStatus;
                    existingProperty.EnergyStarScore = freshProperty.EnergyStarScore;

                    if (existingProperty.EnergyStarScore == 0)
                    {
                        existingProperty.EnergyStarScore = 'N/A';
                    }

                    localStorage.setItem('currentAggregation', JSON.stringify(existingProperty));
                    return existingProperty.IsSyncInProcess;
                };
                svc.GetPropertyStatus = function (propertyId) {
                    return $http({
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetPropertyStatus/',
                        method: "GET",
                        params: { propertyId: propertyId }
                    });
                };
                svc.goToDashboard = function(property, state) {
                    if (property.MetersCount < Config.maxMetersOnStackedDashboard) {
                        state.goMainLayout('PropertyStackedDashboard');
                    } else {
                        state.goMainLayout('PropertyBarDashboard');
                    }
                }
                svc.deleteMeter = function (meters, clientUtilliId, callback) {
                    var meter = null;
                    meters.forEach(
                        function (mtr) {
                            if (mtr.clientUtilliId === clientUtilliId)
                            {
                                meter = mtr;
                            }
                        })
                    //var meter = meters[index];
                    // if it's not saved meter then just delete it
                    if (meter.Id === 0) {
                        meters.splice(meters.indexOf(meter), 1);
                        return;
                    }
                    // if this is a saved meter then confirm
                    ModalServiceExt.showYesNoMessage(
                        _t('Delete meter'),
                        _t('Are you sure you want to delete this meter?'),
                        function () {
                            usSpinnerService.spin('spinner-1');
                            var params = { meterId: meter.Id };
                            utilli.addUserName($state, params);
                            $http({
                                method: "POST",
                                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/DeleteMeter/',
                                params: params
                            }).success(function (response) {
                                usSpinnerService.stop('spinner-1');
                                if (response.Errors && response.Errors.length > 0) {
                                    ModalServiceExt.showServerError();
                                    return;
                                }
                                meters.splice(meters.indexOf(meter), 1);
                                if (callback)
                                    callback();
                            }).error(function () {
                                usSpinnerService.stop('spinner-1');
                                ModalServiceExt.showServerError();
                            });
                        });
                }

                svc.verifyAllAddresses = function(propertyId, meters, callback) {
                    ModalServiceExt.showYesNoMessage(
                        _t('Verify all meters'),
                        _t('Are you sure you want to verify all selected meters?'),
                        function () {
                            usSpinnerService.spin('spinner-1');
                            var selectedMeters = _.filter(meters, function (m) { return m.checked; });
                            var selectedIds = _.map(selectedMeters, function(m) { return m.Id; });
                            $http({
                                method: "POST",
                                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/MassVerifyServiceAddress/',
                                data: {
                                    PropertyId: propertyId,
                                    MeterIds: selectedIds,
                                    UserName: $state.params.userId
                                }
                            }).success(function (response) {
                                usSpinnerService.stop('spinner-1');
                                if (response.Errors && response.Errors.length > 0) {
                                    ModalServiceExt.showServerError();
                                    return;
                                }
                                if (callback)
                                    callback();
                            }).error(function () {
                                usSpinnerService.stop('spinner-1');
                                ModalServiceExt.showServerError();
                            });
                        });

                }

                svc.canMassVerifyServiceAddress = function(meters) {
                    return _.some(meters, function (m) {
                        return m.ErrorCode === utilli.pm.meterErrorCodes.serviceAddressMismatch
                            && !m.HasMultipleAddresses;
                    });
                }

                svc.deleteMeterWithoutConfirmation = function (meters, clientUtilliId, callback) {
                    var meter = null;
                    meters.forEach(
                        function(mtr) {
                            if (mtr.clientUtilliId === clientUtilliId) {
                                meter = mtr;
                            }
                        });
                    //var meter = meters[index];
                    // if it's not saved meter then just delete it
                    if (meter.Id === 0) {
                        meters.splice(meters.indexOf(meter), 1);
                        return;
                    }

                    var params = { meterId: meter.Id };
                    utilli.addUserName($state, params);
                    $http({
                        method: "POST",
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/DeleteMeter/',
                        params: params
                    }).success(function (response) {
                        usSpinnerService.stop('spinner-1');
                        if (response.Errors && response.Errors.length > 0) {
                            ModalServiceExt.showServerError();
                            return;
                        }
                        meters.splice(meters.indexOf(meter), 1);
                        if (callback)
                            callback();
                    }).error(function () {
                        ModalServiceExt.showServerError();
                    });
                }

                svc.refreshScore = function (property, reloadFinishCallback) {
                    //Refresh score button should be always clickable GNIS-2303
                    //if (property.IsSyncInProcess)
                    //    return;
                    property.IsSyncInProcess = true;
                    $http({
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/RefreshPropertyScore/',
                        method: "POST",
                        params: { propertyId: property.Id }
                    })

                    .then(ModalServiceExt.checkApiResponseError, ModalServiceExt.catchAjaxError)
                    .then(function () {
                            svc.reloadProperty(property, $state.current.name, reloadFinishCallback);
                    }, function (error) {
                        if (error === "PropertyIsNotCompleteError") {
                            // todo: add a link to the edit property page
                            ModalServiceExt.showError("Please complete property creation process.");
                        }
                        property.IsSyncInProcess = false;
                    });
                }
                /**
                 * Initiates things that are necessary to automatically update property status.
                 * @param {} property The property where status needs to be updated.
                 * @param {} reloadFinishCallback The callback that is called once property refresh is 
                 * completed (status changes to Completed)
                 * @returns {} void
                 */
                svc.loadProperty = function (property, reloadFinishCallback) {
                    if (svc.timeout) {
                        $timeout.cancel(svc.timeout);
                    }
                    if (property.IsSyncInProcess) {
                        svc.timeout = $timeout(function() {
                                svc.reloadProperty(property, $state.current.name, reloadFinishCallback);
                            },
                            utilli.propertyRefreshTimeout);
                    }
                }
                svc.reloadProperty = function (property, stateName, reloadFinishCallback) {
                    // if the state is changed then stop updates
                    if ($state.current.name !== stateName)
                        return;
                    svc.GetPropertyStatus(property.Id).success(function (response) {
                        // ReSharper disable once VariableUsedInInnerScopeBeforeDeclared
                        if (response.Data) {
                            svc.updateProperty(response.Data, property);
                            if (response.Data.IsSyncInProcess) {
                                svc.timeout = $timeout(function() {
                                        svc.reloadProperty(property, stateName, reloadFinishCallback);
                                    },
                                    utilli.propertyRefreshTimeout);
                            } else {
                                // if update is finished then call calback (to reload the chart on the dashboard)
                                if (reloadFinishCallback) {
                                    reloadFinishCallback();
                                }
                            }
                        }
                    }).error(function(e) {
                        // i don't want to show user a new error popup every 5 seconds
                        console.log(e);
                    });
                }
                return svc;
            }
        ]);
'use strict';
angular.module('utilliApp').service('PaymentVerificationService', ['CommonDataService', 'ModalServiceExt',
    'usSpinnerService',
    function (CommonDataService, ModalServiceExt, usSpinnerService) {
        var _t = utilli._t;
        var svc = {};
        /** checks that payment amount is not beyond max limit */
        svc.verifyPaymentInfo = function (amount, callback) {
            CommonDataService.getCommonData().then(function (data) {
                if (amount > data.MaxPaymentAmount) {
                    if (data.CanConfirmMaxPaymentAmount) {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showYesNoMessage(_t("Please Confirm"), data.MaxPaymentAmountWarningText, callback);
                    }
                    else {
                        ModalServiceExt.showError(data.MaxPaymentAmountErrorText);
                    }
                }
                else {
                    if (callback)
                        callback();
                }
            });
        };
        return svc;
    }]);
'use strict';
angular.module('utilliApp')
    .controller('EditAccountsController', ['$scope', '$rootScope', '$http', '$q', '$timeout', '$window',
    'usSpinnerService', 'LeftMenuService', '$state', 'GetAccountsService', 'ModalService', 'CommonHeaderService',
    'ModalServiceExt', 'DueReminderService', 'AccountListService',
    function ($scope, $rootScope, $http, $q, $timeout, $window, usSpinnerService, LeftMenuService, $state,
        GetAccountsService, ModalService, CommonHeaderService, ModalServiceExt, DueReminderService, AccountListService) {

        LeftMenuService.setCurrentTab('AccountList');
        $scope.AddAccount = function () {
            $state.goMainLayout("AddAccount");
        };
        CommonHeaderService.setUp($scope._t('Edit Accounts'), $scope._t('Add'), $scope.AddAccount, true);
        $scope.Errors = null;

        $scope.accountDataList = {};

        $scope.DeleteAccount = function (account) {
            if ($scope.accountDataList.length <= 1) {
                ModalServiceExt.showOkMessage($scope._t('Delete account.'), $scope._t('Last contract account cannot be deleted.'))
               return;
            }
            ModalServiceExt.showYesNoMessage($scope._t('Delete account'), $scope._t('Are you sure you want to delete this contract account?'), 
                function () {
                    deleteAccountInternal(account);
                });
        };

        function getNewPrimaryAccount(currentPrimaryAccount) {
            for(var i = 0; i < $scope.accountDataList.length; i++)
                if ($scope.accountDataList[i].AccountNumber != currentPrimaryAccount)
                    return $scope.accountDataList[i].AccountNumber;
        }

        function GoToAccountList(acc) {
            AccountListService.changeContractAccount(acc, function () {
                $state.goMainLayout('AccountList');
            });
        };

        function deleteAccountInternal (account) {
            var newPrimaryAccount = getNewPrimaryAccount(account.AccountNumber);

            var dataobj = { accountNumber: account.AccountNumber };
            utilli.addUserName($state, dataobj);

            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Account/DeleteAccount',
                method: "POST",
                params: dataobj
            }).success(function (data) {
                $scope.isLoading = false;
                var jsondata = data;
                if (jsondata) {
                    if (jsondata.ERROR_LIST && jsondata.ERROR_LIST.length > 0) {
                        ModalServiceExt.showError(jsondata.ERROR_LIST[0].Message);
                    } else {
                        var acc;
                        for (var i = 0; i < $scope.accountDataList.length; i++)
                        {
                            if ($scope.accountDataList[i].AccountNumber == newPrimaryAccount)
                                acc = $scope.accountDataList[i];
                        }
                        if (!acc)
                            ModalServiceExt.showError($scope._t("Cannot find the account with the account number ") + newPrimaryAccount);
                        GoToAccountList(acc);
                    }
                } else {
                    ModalServiceExt.showServerError();
                }
            }).error(function () {
                $scope.isLoading = false;
                ModalServiceExt.showServerError();
            });
        };

        $scope.GetAccountsList = function () {
            var promise = GetAccountsService.getAccounts();
            promise.then(function (response) {
                if (response.Errors && response.Errors.length > 0) {
                    ModalServiceExt.showError(response.Errors[0].Message);
                    return;
                }

                $scope.accountDataList = response.Accounts;
            }).catch(function (error) {
                ModalServiceExt.showError(error);
            });
        }

        function showDueDateInternal(account) {
            return account.TotalBalance > 0 && account.DueDate != '0001-01-01T00:00:00';
        }

        function showPastDueInternal(account) {
            if (showDueDateInternal(account))
                return account.dueDateTicks < Date.now();

            return false;
        }

        $scope.showDueDate = function (account) {
            return showDueDateInternal(account);
        }

        $scope.showPastDue = function (account) {
            return showPastDueInternal(account);
        }

        $scope.getTotalBalanceClass = function (account) {
            if (showPastDueInternal(account))
                return 'warnig-color';
            else
                return 'success-color';
        }

        $scope.getAccountBalanceClass = function (account) {
            if (showDueDateInternal(account))
                return '';

            return 'balance-without-dueDate';
        }

        $scope.getDueDateClass = function (account) {
            if (showPastDueInternal(account))
                return 'warnig-color';

            return '';
        }

        $scope.getUtilityImage = function (data) {
            if (data.UtilityType == 'Gas')
                return 'gas-bgr';
            if (data.UtilityType == 'Water')
                return 'water-bgr';
            return 'elctr-bgr';
        }
    }])
;
'use strict';
var app = angular.module('utilliApp');
app.controller('NoConnectionController', ['$scope', '$timeout', function ($scope, $timeout) {

    $scope.buttonMessage = 'Try to connect again';
    $scope.busy = false;

    $scope.getLogo = function () {
        if (DeploymentSettings.providersGroupShortName === 'wgl')
            return utilli.isAdmin ? '../Images/Wgl-logo.png' : 'Images/Wgl-logo.png';

        return utilli.isAdmin ? '../Images/Utilli-logo.png' : 'Images/Utilli-logo.png';
    }

    $scope.getLogoText = function () {
        if (DeploymentSettings.providersGroupShortName === 'wgl')
            return '';

        return "Utilli";
    }

    $scope.getText = function () {
        if (DeploymentSettings.providersGroupShortName === 'wgl')
            return 'WGL Property Manager by Utilli does not work without internet connection. Restore your connection in order to continue.';

        return "Utilli does not work without internet connection";
    }

    $scope.tryPing = function () {
        $scope.busy = true;
        $scope.buttonMessage = 'Checking connection...'
        $.ajax({
            url: DeploymentSettings.providersServiceUrl.replace('api/', '') + 'Sms/Ping',
            method: 'GET'
        }).done(function (d) {
            utilli.setWindowLocation(window.location.origin + window.location.pathname);
        }).fail(function (e) {
            // timeout here to have time to display 'Checking connection...' to user. 
            // Because it is confused for users to press button without some visual response to their actions.
            $timeout(function () {
                $scope.busy = false;
                $scope.buttonMessage = 'Try to connect again';
                console.log(e);
            }, 1000);
        });
    }
}]);

'use strict';
var app = angular.module('utilliApp');

app.controller('UpdateAppController', ['$scope', function ($scope) {
        $scope.UpdateApp = function () {
            // TODO: fill out references after the app will be deployed.
            var url = 'http://utilli.com';
            if (iOS())
                url = Config.appUrls.iOs;
            else if (isAndroid())
                url = Config.appUrls.android;
            else if (deviceIsWindowsPhone)
                url = Config.appUrls.winPhone;
            window.open(url, "_system", "location=yes,closebuttoncaption=Back");
        };
    }]);

'use strict';
angular.module('utilliApp')
.controller('AddAccountController', ['$scope', '$http', '$rootScope', '$state', '$window', 'LeftMenuService',
    'usSpinnerService', 'CommonHeaderService',
    function ($scope, $http, $rootScope, $state, $window, LeftMenuService, usSpinnerService, CommonHeaderService) {

        LeftMenuService.setCurrentTab('AccountList');
        CommonHeaderService.setUpBackButton();
        $scope.errors = null;
        $scope.name = '';
        $scope.zip = '';
        $scope.accountNumber = '';

        var specialCharacktersRegexp = /^[a-zA-Z0-9 '.&-]{1,}$/;

        $scope.nameValid = true;

        $scope.cancel = function () {
            $window.history.back();
        }

        function validate()
        {
            var validated = true;
            var matched;

            if (!$scope.accountNumber)
            {
                $scope.accountEmptyError = true;
                validated = false;
            }
            else 
            {
                var re = /^[0-9]*$/;
                matched = re.test($scope.accountNumber);
                if (!matched)
                {
                    $scope.accountFormatError = true;
                    validated = false;
                }
            }

            if (!$scope.zip) {
                $scope.zipEmptyError = true;
                validated = false;
            }
            else {
                matched = Config.zipCodeRegexp.test($scope.zip);
                if (!matched) {
                    $scope.zipFormatError = true;
                    validated = false;
                }
            }

            if (!$scope.name)
            {
                $scope.fullNameEmptyError = true;
                validated = false;
            }

            if($scope.name && !specialCharacktersRegexp.test($scope.name))
            {
                $scope.nameValid = false;
            }

            return validated;
        }

        function resetErrors()
        {
            $scope.accountEmptyError = false;
            $scope.accountFormatError = false;
            $scope.zipEmptyError = false;
            $scope.zipFormatError = false;
            $scope.fullNameEmptyError = false;
            $scope.errors = null;
        }

        $scope.addAccount = function () {

            usSpinnerService.spin('spinner-1');

            resetErrors();

            if (!validate())
            {
                usSpinnerService.stop('spinner-1');
                return;
            }

            $scope.errors = null;

            var dataObj = {
                AccountNumber: $scope.accountNumber,
                Zip: $scope.zip,
                FullName: $scope.name
            };

            utilli.addUserName($state, dataObj);

            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Account/AddAccount',
                method: "POST",
                data: dataObj
            }).success(function (data) {
                usSpinnerService.stop('spinner-1');
               
                if (data) {
                    if (data.Messages && data.Messages.length > 0) {
                        $scope.errors = data.Messages;
                    } else {
                        $state.goMainLayout('AccountList');
                    }
                } else {
                    $scope.errors = [utilli.errors.serverErrorMessage];
                }
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                $scope.errors = [utilli.errors.serverErrorMessage];
            });
        }
    }]);
angular.module('utilliApp')
.controller('PaymentHistoryItemController', ['$scope', function ($scope) {
    // $scope._t is used in PaymentHistoryItem.html
    $scope._t = utilli._t;

    $scope.isHc = utilli.isHc();
}]);
'use strict';

angular.module('utilliApp')
  .directive('paymentHistoryItem', function () {

      return {
          restrict: 'A',
          transclude: true,
          replace: true,
          scope: { paymentHistoryItem: '=paymentHistoryItem' },
          templateUrl: utilli.isAdmin ? '../Pages/PaymentHistoryItem/PaymentHistoryItem.html' : 'Pages/PaymentHistoryItem/PaymentHistoryItem.html',
          controller: 'PaymentHistoryItemController'
      };
  });


angular.module('utilliApp')
.controller('ConsumptionHistoryController', ['$scope', '$rootScope', '$http', '$window', 
    function ($scope, $rootScope, $http, $window) {
        $scope.config = $window.Config;
        $scope.formatNumber = utilli.formatNumber;
        $scope._t = $rootScope._t;
    }
]);
'use strict';

angular.module('utilliApp')
  .directive('consumptionHistoryItem', function () {

      return {
          restrict: 'A',
          replace: true,
          scope: { consumptionHistoryItem: '=historyItem', selectedUnitsType: '=' },
          templateUrl: 'Pages/UsageChart/ConsumptionHistoryItem/ConsumptionHistoryItem.html',
          controller: 'ConsumptionHistoryController'
      };
  });


'use strict';
angular.module('utilliApp')
.controller('ResetPasswordController', ['$scope', '$http', '$state', '$stateParams', 'usSpinnerService',
        'CommonDataService', 'ServiceProvidersService', 'ModalServiceExt',
function ($scope, $http, $state, $stateParams, usSpinnerService, CommonDataService, ServiceProvidersService,
    ModalServiceExt) {
    var _t = $scope._t;
    $scope.isLoading = true;
    usSpinnerService.spin('spinner-1');

    $scope.togglePassword = function (pswId, iconId) {
        utilli.togglePasswordVisibility(pswId, iconId);
    }

    var apiUrl = '';
    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider)
            .then(function (providerData) {
                apiUrl = providerData.ApiUrl;
                CommonDataService.getCommonData(providerData.ApiUrl).then(function (data) {
                    $scope.passRequirements = data.PasswordRequirements;
                    $scope.paswdMinLength = data.PasswordLength;
                    validateToken();
                }, function () {
                    usSpinnerService.stop('spinner-1');
                    $scope.errors.serverErrors = [$scope._t("Service is unavailable now. Try again later.")];
                });
            },
            function () {
                usSpinnerService.stop('spinner-1');
                $scope.errors.serverErrors = [$scope._t("Service is unavailable now. Try again later.")];
            });

    function validateToken () {
        
        usSpinnerService.spin('spinner-1');

        var url = apiUrl + 'api/User/ValidateToken';
        var requestData = {
            Token: $stateParams.token
        };

        $http({
            url: url,
            method: 'POST',
            data: requestData
        }).success(function (data) {
            usSpinnerService.stop('spinner-1');

            if (data.Errors != null && data.Errors.length > 0)
                $scope.errors.serverErrors = data.Errors;
            else {
                $scope.isLoading = false;
            }
        }).error(function () {
            $scope.errors.serverErrors = [$scope._t("Service is unavailable now. Try again later.")];
            usSpinnerService.stop('spinner-1');
        });
    }
    
    $scope.errors = {};

    if (!$stateParams.token) {
        $scope.errors.serverErrors = [$scope._t("Service is unavailable now. Try again later.")];
        return;
    }

    $scope.model = {};
    $scope.model.newPassword = '';
    $scope.model.confirmNewPassword = '';

    resetErrors();

    $scope.passRequirements = [$scope._t('Loading...')];

    $scope.changePassword = function () {
        resetErrors();

        if (!validate()) {
            utilli.scrollTop();
            return;
        }

        usSpinnerService.spin('spinner-1');

        var url = apiUrl + 'api/User/ResetPassword';
        var requestData = {
            Token: $stateParams.token,
            NewPassword: $scope.model.newPassword,
            ConfirmPassword: $scope.model.confirmNewPassword
        };

        $http({
            url: url,
            method: 'POST',
            data: requestData
        }).success(function (data) {
            usSpinnerService.stop('spinner-1');

            if (data.Errors != null && data.Errors.length > 0)
                $scope.errors.serverErrors = data.Errors;
            else {
                ModalServiceExt.showInfo(_t('Password was successfully changed.'), function () {
                    if (utilli.hasAgentRole($stateParams.token)){
                        $state.goToAgentsWelcome();
                    }
                    else{
                        $state.goToWelcome();
                    }
                });
            }
        }).error(function () {
            $scope.errors.serverErrors = [$scope._t("Service is unavailable now. Try again later.")];
            usSpinnerService.stop('spinner-1');
        });
 
    };

    function find(list, key) {
        return _.find(list, function (item) { return item.Key === key; });
    }

    function validate() {
        resetErrors();

        var valid = true;
        var requirement = find($scope.passRequirements, 'PasswordLength');
        if (requirement && (!$scope.model.newPassword || $scope.model.newPassword.length < $scope.paswdMinLength)) {
            $scope.errors.newPasswordLength = requirement.ErrorText;
            valid = false;
        }
        else if ((requirement = find($scope.passRequirements, 'DigitsNumber')) && !utilli.hasDigits($scope.model.newPassword)) {
            $scope.errors.newPasswordNoDigits = requirement.ErrorText;
            valid = false;
        }
        else if ((requirement = find($scope.passRequirements, 'Letters')) && (!utilli.hasLowerCaseLetters($scope.model.newPassword) || !utilli.hasUpperCaseLetters($scope.model.newPassword))) {
            $scope.errors.newPasswordNoLetters = requirement.ErrorText;
            valid = false;
        }
        else if ((requirement = find($scope.passRequirements, 'SpecialSymbols')) && !utilli.hasSpecialSymbols($scope.model.newPassword)) {
            $scope.errors.newPasswordNoSpecialSymbols = requirement.ErrorText;
            valid = false;
        }

        if (!$scope.model.confirmNewPassword || $scope.model.confirmNewPassword != $scope.model.newPassword) {
            $scope.errors.passwordsDontMatch = true;
            valid = false;
        }

        if (localStorage.getItem('current_user') == $scope.model.newPassword) {
            $scope.errors.pswSameAsUserNameError = $scope._t('Passwords cannot be your User ID.');
            valid = false;
        }

        return valid;
    };

    function resetErrors() {
        $scope.errors.serverErrors = null;
        $scope.errors.newPasswordEmpty = null;
        $scope.errors.passwordsDontMatch = null;
        $scope.errors.newPasswordLength = null;
        $scope.errors.newPasswordNoDigits = null;
        $scope.errors.newPasswordNoLetters = null;
        $scope.errors.newPasswordNoSpecialSymbols = null;
        $scope.errors.pswSameAsUserNameError = null;
    };
}]);

/// <reference path="../SignIn/Credentials.js" />
'use strict';
angular.module('utilliApp')
    .controller('BotAuthorizeController', [
        '$scope', '$http', '$sce', 'usSpinnerService',
        'ServiceProvidersService', 'CommonHeaderService', 'CheckVersionService', '$state', 
        function ($scope, $http, $sce, usSpinnerService, ServiceProvidersService, CommonHeaderService, CheckVersionService, $state) {
            CommonHeaderService.setUp();
            CommonHeaderService.hideMenuToggleButton();
            $scope.SuccessMessage = $scope._t('We are processing your request') + '...';

            var apiUrl = localStorage.getItem('ApiUrl');

            if ($state.params.logoutRequired == "logoutRequired") {
                utilli.clearLocalStorage();
                $state.params.logoutRequired = 'doNotLogout';
                $state.goToSignIn(true);
                return;
            }

            usSpinnerService.spin('spinner-1');
            var serviceUrl = atob($state.params.serviceUrl);
            var dataobj = {
                channelId: $state.params.channelId,
                fromId: $state.params.clientId,
                conversationId: $state.params.conversationId,
                serviceUrl: serviceUrl
            };

            $http({
                url: apiUrl + 'api/Account/AuthorizeBot/',
                method: "GET",
                params: dataobj
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
                if (response.Errors && response.Errors.length > 0) {
                    $scope.SuccessMessage = response.Errors[0];
                    return;
                }
                $scope.SuccessMessage = $scope._t('You have been successfully authorized. You can now use Utilli Bot.');
            }).error(function (data) {
                $scope.SuccessMessage = $scope._t('Error');
                usSpinnerService.stop('spinner-1');
            });

        }]);
'use strict';
angular.module('utilliApp')
.controller('BillDetailsController', ['$scope', '$http', 'BillsService', '$rootScope', 'ModalServiceExt',
        '$timeout', '$state', 'CommonHeaderService', 'OpenFileService', '$stateParams', 'usSpinnerService', 'LeftMenuService',
    function ($scope, $http, billsService, $rootScope, ModalServiceExt, $timeout, $state, CommonHeaderService,
        OpenFileService, $stateParams, usSpinnerService, LeftMenuService) {

        LeftMenuService.setCurrentTab('BillsAndPayments');
        CommonHeaderService.setUp($scope._t('Bill Details'), $scope._t('Pay'), function () {
            $state.goMainLayout('PayNow');
        });
        
        $scope.backFromBillDetails = function () {
            $state.goMainLayout('BillsAndPayments');
        }

        if (!$stateParams.billNumber) {
            $scope.backFromBillDetails();
            return;
        }

        $scope.loadBill = function () {

            usSpinnerService.spin('spinner-1');
            var accountNumber = localStorage.getItem('CurrentAccountNumber');
            
            var dataRequest = { accountNumber: accountNumber, billNumber: $stateParams.billNumber };
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Bills/GetBill/',
                method: "GET",
                params: dataRequest
            }).success(function (data) {
                usSpinnerService.stop('spinner-1');
                if (data) {
                    if (data.ERROR_LIST && data.ERROR_LIST.length > 0) {
                        ModalServiceExt.showError(data.ERROR_LIST[0].Message);
                    } else {
                        $scope.bill = data.Data;

                        $scope.bill.billDateUnix = $scope.bill.BillDate.getTime();
                        $scope.bill.dueDateUnix = $scope.bill.DueDate.getTime();
                        $scope.bill.Amount = $scope.bill.BillAmount;
                        $scope.bill.Charges = $scope.bill.LatePayAmount;
                    }
                } else {
                    ModalServiceExt.showServerError();
                }
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }

        $scope.billAmountClass = function () {
            if ($scope.bill) {
                if ($scope.bill.PaidStatus.toUpperCase() == 'UNPAID')
                    return "data-amount-unpaid";
                else if ($scope.bill.PaidStatus.toUpperCase().indexOf('PENDING') > -1)
                    return "data-amount-pending";
            }

            return "data-amount";
        };

        $scope.enableBillDownload = Config.enableBillDownload;

        $scope.isUnderstandLoading = false;

        $scope.ViewPdf = function () {
            OpenFileService.openBill($scope.bill.BillNumber, $scope.bill.AccountNumber);
        }

        $scope.understandBill = function () {
            OpenFileService.openUnderstandBillFile();
        }
    }]);
'use strict';
angular.module('utilliApp')
.controller('MoveServiceController', ['$scope', '$rootScope', '$window', '$http', '$state', 'StatesService',
        'CustomerInfoDataService', 'usSpinnerService', 'LeftMenuService', 'ModalServiceExt', 'CommonHeaderService',
function ($scope, $rootScope, $window, $http, $state, StatesService, CustomerInfoDataService, usSpinnerService,
          LeftMenuService, ModalServiceExt, CommonHeaderService) {

    LeftMenuService.setCurrentTab('MoveService');
    CommonHeaderService.setUpBackButton($scope._t('Move Service'));

    initPicker();

    function initPicker() {
        $scope.dpOptions = utilli.datePickerOptions;
        $scope.altInputFormats = ['M!/d!/yyyy'];
    }

    $scope.needConfirmAddress = false;
    $scope.confirmAddressText = '';

    $scope.errors = {};
    $scope.errors.addServerError = function (message) {
        $scope.errors.commonMessage = message;
        $scope.errors.hasErrors = true;
    };
    resetErrors();
    CustomerInfoDataService.getCachedData().then(
        function (customerInfo) {
            $scope.model = createModel(customerInfo);
            $scope.state = StatesService.states[0];
            $scope.states = StatesService.states;
            $scope.currentAddress = customerInfo.account.ServiceAddress;
        },
        function (errorInfo) {
            $scope.errors.addServerError(errorInfo);
        });

    $scope.moveService = function () {
        $scope.submitted = true;
        if (!validate()) {
            utilli.scrollTop();
            return;
        }

        usSpinnerService.spin('spinner-1');
        $scope.model.State = $scope.state.Abbreviation;
        
        // deep copy because i'm going to change the phone number below
        // and i don't want it to be changed on the model
        var modelCopy = jQuery.extend(true, {}, $scope.model);
        modelCopy.Phone = utilli.getCountryPhoneNumberCode() + $window.$('#phone').mask();
        modelCopy.StopServiceDate = modelCopy.StopServiceDate.toUTCString();
        modelCopy.StartServiceDate = modelCopy.StartServiceDate.toUTCString();

        $http({
            url: localStorage.getItem('ApiUrl') + 'api/Account/Move',
            method: 'POST',
            data: modelCopy
        }).success(function (data) {
            usSpinnerService.stop('spinner-1');
            if (data.Success)
            {
                ModalServiceExt.showInfo(
                    $scope._t('Your request has been submitted. We will contact you shortly to finish processing your request.'),
                    successDialogClosed);
                return;
            }
            if (data.NeedConfirmAddress)
            {
                $scope.needConfirmAddress = true;
                $scope.confirmAddressText = data.Message;
                // wrapped into a timeout to run after this method ends because right now 
                // the message about needConfirmAddress is not rendered 
                // and clientHeight is wrong
                setTimeout(utilli.scrollBottom, 0);
            }
            else
            {
                $scope.errors.addServerError(data.Message);
                // scroll to the top
                utilli.scrollTop();
            }
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            $scope.errors.addServerError($scope._t('Service is unavailable now. Try again later.'));
            utilli.scrollTop();
        });
    };

    function createModel(data) {
        var model = {};
        model.AccountNumber = data.account.AccountNumber;
        model.BusinessPartner = data.account.BusinessPartner;
        model.StartServiceDate = '';
        model.StopServiceDate = new Date();
        model.HouseNumber = '';
        model.AddressLine = '';
        model.HouseNoSupplement = '';
        model.AdditionalAccountName = '';
        model.City = '';
        model.State = '';
        model.Zip = '';
        model.Phone = getMaskedPhoneNumberValue(data.userinfo.Phone);
        model.Email = data.userinfo.Email;
        model.ProceedAddress = false;
        return model;
    };
    
    $scope.updateProceedAddress = function()
    {
        var proceedAddress = $scope.model.ProceedAddress;
        $scope.model.ProceedAddress = !proceedAddress;
    }

    function validate()
    {
        resetErrors();

        if (!$scope.model.Email)
        {
            $scope.errors.emptyEmail = true;
            $scope.errors.hasErrors = true;
        }
        else
        {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var matched = re.test($scope.model.Email);
            if (!matched) {
                $scope.errors.wrongEmail = true;
                $scope.errors.hasErrors = true;
            }
        }
        
        if (!$scope.model.HouseNumber)
        {
            $scope.errors.emptyHouseNumber = true;
            $scope.errors.hasErrors = true;
        }

        if (!$scope.model.City) {
            $scope.errors.emptyCity = true;
            $scope.errors.hasErrors = true;
        }

        if (!$scope.model.AddressLine) {
            $scope.errors.emptyStreet = true;
            $scope.errors.hasErrors = true;
        }

        if (!$scope.model.Zip) {
            $scope.errors.emptyZip = true;
            $scope.errors.hasErrors = true;
        }
        else if (/^(\d{5})?$|^$/.test($scope.model.Zip) == false)
        {
            $scope.errors.wrongZip = true;
            $scope.errors.hasErrors = true;
        }
        
        if (!$scope.model.StartServiceDate) {
            $scope.errors.emptyStartDate = true;
            $scope.errors.hasErrors = true;
        }

        if (!$scope.model.StopServiceDate) {
            $scope.errors.emptyStopDate = true;
            $scope.errors.hasErrors = true;
        }

        if ($scope.errors.hasErrors)
            $scope.errors.commonMessage = utilli.errors.validationErorrsMessage;

        return !$scope.errors.hasErrors;
    }

    function resetErrors()
    {
        $scope.errors.hasErrors = false;
        $scope.errors.wrongEmail = false;
        $scope.errors.emptyEmail = false;
        $scope.errors.emptyHouseNumber = false;
        $scope.errors.emptyCity = false;
        $scope.errors.emptyStreet = false;
        $scope.errors.emptyZip = false;
        $scope.errors.wrongZip = false;
        $scope.errors.emptyStartDate = false;
        $scope.errors.emptyStopDate = false;
        $scope.errors.commonMessage = '';
    };

    function successDialogClosed() {
        $state.goMainLayout('Dashboard');
    };
}]);
'use strict';
angular.module('utilliApp')
.controller('CancelServiceController', ['$scope', '$rootScope', '$window', '$http', '$state', 'usSpinnerService',
    'LeftMenuService', 'CommonHeaderService', 'CustomerInfoDataService', 'StatesService',
// ReSharper disable InconsistentNaming
function ($scope, $rootScope, $window, $http, $state, usSpinnerService, LeftMenuService,
    CommonHeaderService, CustomerInfoDataService, StatesService) {
    var _t = $scope._t;
    // ReSharper restore InconsistentNaming

    LeftMenuService.setCurrentTab('CancelService');
    CommonHeaderService.setUpBackButton(_t('Cancel Service'));

    $scope.isLoading = false;

    $scope.states = StatesService.states;
    $scope.state = {};

    usSpinnerService.spin('spinner-1');
    CustomerInfoDataService.getCachedData().then(
        function (customerInfo) {
            usSpinnerService.stop('spinner-1');
            $scope.model = {
                accountNumber: customerInfo.account.AccountNumber,
                phone: getMaskedPhoneNumberValue(customerInfo.userinfo.Phone),
                email: customerInfo.userinfo.Email,
                currentAddress: customerInfo.account.ServiceAddress,
                ForwardingAddress: {
                    HouseNumber: '',
                    HouseNoSupplement: '',
                    POBox: '',
                    AddressLine: '',
                    City: '',
                    State: '',
                    Zip: ''
                }
            };
        },
        function (errorInfo) {
            usSpinnerService.stop('spinner-1');
            $scope.errors.addServerError(errorInfo);
        });

    function resetErrors() {
        $scope.houseNumberPOBoxEmptyError = false;
        $scope.houseNumberPOBoxFilledError = false;
        $scope.invalidHouseNumberError = false;
        $scope.invalidPOBoxError = false;
        $scope.streetError = false;
        $scope.oddStreetError = false;
        $scope.cityError = false;
        $scope.invalidCityError = false;
        $scope.stateError = false;
        $scope.invalidStateError = false;
        $scope.zipError = false;
        $scope.zipFormatError = false;
    };

    function validate() {
        var valid = true;
        var matched;
        var regexp;

        var forwardingAddress = $scope.model.ForwardingAddress;
        if (forwardingAddress.POBox) {
            if (forwardingAddress.HouseNumber) {
                $scope.houseNumberPOBoxFilledError = true;
                valid = false;
            }

            if (forwardingAddress.AddressLine) {
                $scope.oddStreetError = true;
                valid = false;
            }
        }
        else {
            if (!forwardingAddress.HouseNumber) {
                $scope.houseNumberPOBoxEmptyError = true;
                valid = false;
            }

            if (!forwardingAddress.AddressLine) {
                $scope.streetError = true;
                valid = false;
            }
        }

        if (!$scope.houseNumberPOBoxFilledError && !$scope.houseNumberPOBoxEmptyError) {
            regexp = /^[0-9]+$/;
            if (forwardingAddress.HouseNumber) {
                matched = regexp.test(forwardingAddress.HouseNumber);
                if (!matched) {
                    $scope.invalidHouseNumberError = true;
                    valid = false;
                }
            } else {
                matched = regexp.test(forwardingAddress.POBox);
                if (!matched) {
                    $scope.invalidPOBoxError = true;
                    valid = false;
                }
            }
        }
        //
        if (!forwardingAddress.City) {
            $scope.cityError = true;
            valid = false;
        } else {
            regexp = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;
            matched = regexp.test(forwardingAddress.City);
            if (!matched) {
                $scope.invalidCityError = true;
                valid = false;
            }
        }

        //
        if (!$scope.state) {
            $scope.stateError = true;
            valid = false;
        } else {
            $scope.model.ForwardingAddress.State = $scope.state.Abbreviation;
        }

        //
        if (!forwardingAddress.Zip) {
            $scope.zipError = true;
            valid = false;
        }
        else {
            matched = Config.zipCodeRegexp.test(forwardingAddress.Zip);
            if (!matched) {
                $scope.zipFormatError = true;
                valid = false;
            }
        }

        if (!$scope.model.stopServiceDate) {
            valid = false;
        }

        return valid;
    }

    $scope.cancelService = function () {
        resetErrors();
        $scope.submitted = true;
        var valid = validate();
        if (!valid) {
            $scope.error = utilli.errors.validationErorrsMessage;
            utilli.scrollTop();
            return;
        }

        usSpinnerService.spin('spinner-1');
        $scope.error = '';

        $scope.model.stopServiceDate = $scope.model.stopServiceDate.toUTCString();
        $http({
            url: localStorage.getItem('ApiUrl') + 'api/Account/Cancel',
            method: 'POST',
            data: $scope.model
        }).success(function(data)
        {
            usSpinnerService.stop('spinner-1');
            if (data && data.Success)
                $state.goMainLayout('CancelSuccess');
            else 
                $scope.error = data 
                    ? data.Message
                    : utilli.errors.serverErrorMessage;
        }).error(function()
        {
            usSpinnerService.stop('spinner-1');
            $scope.error = utilli.errors.serverErrorMessage;
        });
    };
}]);
angular.module('utilliApp')
.controller('CancelSuccessController', ['$scope', '$state', function ($scope, $state)
{
    $scope.successMessage = $scope._t('Your request has been submitted. ' +
        'We will contact you shortly to finish processing your request.');

    $scope.ok = function () {
        $state.goMainLayout('Dashboard');
    };
}]);

'use strict';
angular.module('utilliApp')
.controller('ProgramEnrolmentsController', ['$scope', '$http', '$sce', '$state', 'LeftMenuService', 'CommonHeaderService',
    'ModalServiceExt', 'usSpinnerService', 'ProgramEnrollmentsSettings', '$timeout',
    function ($scope,  $http, $sce, $state, LeftMenuService, CommonHeaderService, ModalServiceExt, usSpinnerService,
              ProgramEnrollmentsSettings, $timeout) {

        LeftMenuService.setCurrentTab('ProgramEnrolments');
        CommonHeaderService.setUpBackButton($scope._t('Program Enrollments'));

        function loadSettings() {
            usSpinnerService.spin('spinner-1');
            ProgramEnrollmentsSettings
                .getSettings(null, true)
                .then(function (data) {
                    usSpinnerService.stop('spinner-1');
                    $scope.programs = data;
                }, function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
        }

        loadSettings();

        $scope.getStateRef = function (stateName) {
            if (utilli.isAdmin) {
                return '';
            } else {
                return $state.href('MainLayout.' + stateName);
            }
        }

        $scope.goTo = function(state, params) {
            $state.goMainLayout(state, params || {}, { reload: state });
        }

        $scope.learnMore = function (programName) {
            if (programName == 'Donation')
                alert('not implemented, go to ' + programName);
            else if (programName == 'SmsNotifications')
                alert('not implemented, go to ' + programName);
            else
                alert('not implemented ' + programName);
        }

        $scope.enrollEBilling = function () {
            usSpinnerService.spin('spinner-1');
            ProgramEnrollmentsSettings
                .toggleProgramEnrollment(ProgramEnrollmentsSettings.programEnrollmentsType.eBilling)
                .then(function (data) {
                    usSpinnerService.stop('spinner-1');
                    $scope.programs.EBilling.IsEnrolled = !$scope.programs.EBilling.IsEnrolled;
                    if(data)
                        ModalServiceExt.showInfo("Program is successfully enrolled.");
                    else
                        ModalServiceExt.showInfo("Program is successfully unenrolled.");
                }, function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                    console.error(error);
                });
            return;
        }

        $scope.enrollAutoPay = function (programName) {
            alert('not implemented ' + programName);
        }

        $scope.showNotImplemented = function () {
            alert('not implemented');
        }

        $scope.goDonationHistory = function () {
            $state.goMainLayout('DonationHistory');
        }

        $scope.enrollBudgetBillingAction = "Enroll";

        $scope.budgetBillingLearnMore = function () {
            $state.goMainLayout('BudgetBillingLearnMore');
        }

        $scope.budgetBillingAction = function () {
            if($scope.programs.BudgetBilling.IsEnrolled)
            {
                usSpinnerService.spin('spinner-1');
                ProgramEnrollmentsSettings
                    .toggleProgramEnrollment(ProgramEnrollmentsSettings.programEnrollmentsType.budgetBilling)
                    .then(function (data) {
                        usSpinnerService.stop('spinner-1');
                        $scope.programs.BudgetBilling.IsEnrolled = !$scope.programs.BudgetBilling.IsEnrolled;
                        ModalServiceExt.showInfo("Program is successfully unenrolled.")
                    }, function (error) {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                        console.error(error);
                    });
                return;
            }
            $state.goMainLayout('BudgetBilling');
        }

        $scope.unenrollSmsNotifications = function () {
            usSpinnerService.spin('spinner-1');
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/ProgramEnrollments/UnenrollSmsNotifications',
                method: 'POST',
                params: utilli.addUserName($state)
            }).success(function(response) {
                usSpinnerService.stop('spinner-1');
                utilli.handleAjaxResponse(response, ModalServiceExt, function () {
                    loadSettings();
                });
            }).error(function(error) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
                console.error(error);
            });
        }

        $scope.unenrollEmailNotifications = function () {
            usSpinnerService.spin('spinner-1');
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/ProgramEnrollments/UnenrollEmailNotifications',
                method: 'POST',
                params: utilli.addUserName($state)
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
                utilli.handleAjaxResponse(response, ModalServiceExt, function () {
                    loadSettings();
                });
            }).error(function (error) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
                console.error(error);
            });
        }

        $scope.goDonationProgramEnrollment = function () {
            // if($scope.programs.Donation.IsEnrolled)
            // {
            //     usSpinnerService.spin('spinner-1');
            //     ProgramEnrollmentsSettings
            //         .toggleProgramEnrollment(ProgramEnrollmentsSettings.programEnrollmentsType.donation)
            //         .then(function (data) {
            //             usSpinnerService.stop('spinner-1');
            //             $scope.programs.Donation.IsEnrolled = !$scope.programs.Donation.IsEnrolled;
            //             ModalServiceExt.showInfo("Program is successfully unenrolled.")
            //         }, function (error) {
            //             usSpinnerService.stop('spinner-1');
            //             ModalServiceExt.showServerError();
            //             console.error(error);
            //         });
            //     return;
            // }
            // var donationProgram = $scope.programs.Donation;
            // if(donationProgram.RoundUpEnabled && !donationProgram.FixedAmountEnabled && !donationProgram.PercentageEnabled)
            //     enrollRoundUpDonation();
            // else if(donationProgram.FixedAmountEnabled && !donationProgram.RoundUpEnabled && !donationProgram.PercentageEnabled)
            //     $state.goMainLayout('DonationEnrollment.PercentageEnrollmentStep2');
            // else if(donationProgram.PercentageEnabled && !donationProgram.FixedAmountEnabled && !donationProgram.RoundUpEnabled)
            //     $state.goMainLayout('DonationEnrollment.FixedAmountEnrollmentStep2');
            // else
            //     $state.goMainLayout("DonationEnrollment", { program: donationProgram });
            enrollRoundUpDonation(!$scope.programs.Donation.IsEnrolled);
        }

        function enrollRoundUpDonation (setEnrolled) {
            var params = {
                contractAccountNumber: localStorage.getItem('CurrentAccountNumber'),
                setEnrolled: setEnrolled
             };
            utilli.addUserName($state, params);
            usSpinnerService.spin('spinner-1');
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/ProgramEnrollments/EnrollRoundUpDonation',
                method: 'POST',
                params: params
            }).success(function(response) {
                usSpinnerService.stop('spinner-1');
                utilli.handleAjaxResponse(response, ModalServiceExt, function () {
                    loadSettings();
                });
            }).error(function(error) {
                ModalServiceExt.showServerError();
                console.error(error);
                usSpinnerService.stop('spinner-1');
            });
        }
    }]).
controller('DonationLearnMoreController', ['$scope', '$state', '$http', 'LeftMenuService', 'CommonHeaderService', '$stateParams',
    'usSpinnerService', 'ModalServiceExt', 'ProgramEnrollmentsSettings',
    function ($scope, $state, $http, LeftMenuService, CommonHeaderService, $stateParams, usSpinnerService, ModalServiceExt,
              ProgramEnrollmentsSettings) {
        LeftMenuService.setCurrentTab('ProgramEnrolments');
        CommonHeaderService.setUpBackButton($scope._t('Program Information'));

        function loadSettings(withoutCache){
            usSpinnerService.spin('spinner-1');
            ProgramEnrollmentsSettings
                .getSettings('Donation', withoutCache)
                .then(function(data) {
                    usSpinnerService.stop('spinner-1');
                    $scope.program = data;
                }, function() {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
        }
        loadSettings(false);

        $scope.toggleEnrollment = function () {
            // if($scope.program.IsEnrolled)
            // {
            //     usSpinnerService.spin('spinner-1');
            //     ProgramEnrollmentsSettings
            //         .toggleProgramEnrollment(ProgramEnrollmentsSettings.programEnrollmentsType.donation)
            //         .then(function (data) {
            //             usSpinnerService.stop('spinner-1');
            //             $scope.program.IsEnrolled = !$scope.program.IsEnrolled;
            //             ModalServiceExt.showInfo("Program is successfully unenrolled.")
            //         }, function (error) {
            //             usSpinnerService.stop('spinner-1');
            //             ModalServiceExt.showServerError();
            //             console.error(error);
            //         });
            //     return;
            // }
            // $state.goMainLayout('DonationEnrollment', { program: $scope.program });
            enrollRoundUpDonation(!$scope.program.IsEnrolled);
        }

        function enrollRoundUpDonation (setEnrolled) {
            var params = {
                contractAccountNumber: localStorage.getItem('CurrentAccountNumber'),
                setEnrolled: setEnrolled
             };
            utilli.addUserName($state, params);
            usSpinnerService.spin('spinner-1');
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/ProgramEnrollments/EnrollRoundUpDonation',
                method: 'POST',
                params: params
            }).success(function(response) {
                usSpinnerService.stop('spinner-1');
                utilli.handleAjaxResponse(response, ModalServiceExt, function () {
                    loadSettings(true);
                });
            }).error(function(error) {
                ModalServiceExt.showServerError();
                console.error(error);
                usSpinnerService.stop('spinner-1');
            });
        }
}]).
controller('SmsNotificationsLearnMoreController', ['$scope', 'LeftMenuService', 'CommonHeaderService',
    'usSpinnerService', 'ProgramEnrollmentsSettings', '$http', '$state', 'ModalServiceExt',
    function ($scope, LeftMenuService, CommonHeaderService, usSpinnerService, ProgramEnrollmentsSettings,
        $http, $state, ModalServiceExt) {
        LeftMenuService.setCurrentTab('ProgramEnrolments');
        CommonHeaderService.setUpBackButton($scope._t('Program Info'));

        usSpinnerService.spin('spinner-1');
        ProgramEnrollmentsSettings
            .getSettings('SmsNotifications')
            .then(function(data) {
                usSpinnerService.stop('spinner-1');
                $scope.program = data;
            }, function() {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });

        $scope.goTo = function(state, params) {
            $state.goMainLayout(state, params || {}, { reload: state });
        }

        function sendRequest(url, message) {
            usSpinnerService.spin('spinner-1');
            $http({
                method: 'POST',
                url: url,
                params: utilli.addUserName($state)
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
                if (response.Errors && response.Errors.length > 0) {
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }

                ModalServiceExt.showInfo(message, function () { $state.goMainLayout('ProgramEnrolments'); });
            }).error(function (error) {
                usSpinnerService.spin('spinner-1');
                ModalServiceExt.showServerError();
            }); 
        }

        $scope.enrollOrUnenroll = function () {
            if (!$scope.program.IsEnrolled) {
                sendRequest(
                    localStorage.getItem('ApiUrl') + 'api/ProgramEnrollments/EnrollSmsNotifications',
                    $scope._t('You have successfully enrolled'));
            } else {
                sendRequest(
                    localStorage.getItem('ApiUrl') + 'api/ProgramEnrollments/UnenrollSmsNotifications',
                    $scope._t('You have successfully unenrolled'));
            }
        }
    }]).
controller('EBillingLearnMoreController', ['$scope', 'LeftMenuService', 'CommonHeaderService',
    'usSpinnerService', 'ProgramEnrollmentsSettings',
    function ($scope, LeftMenuService, CommonHeaderService, usSpinnerService, ProgramEnrollmentsSettings) {
        LeftMenuService.setCurrentTab('ProgramEnrolments');
        CommonHeaderService.setUpBackButton($scope._t('eBilling Program Information'));

        usSpinnerService.spin('spinner-1');
        ProgramEnrollmentsSettings
            .getSettings('EBilling')
            .then(function(data) {
                usSpinnerService.stop('spinner-1');
                $scope.program = data;
            }, function() {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
    }]);

angular.module('utilliApp').factory('ProgramEnrollmentsSettings', ['$http', '$q', 'ModalServiceExt', '$state',
    function($http, $q, ModalServiceExt, $state) {
        var _cachedData = null;

        return {
            programEnrollmentsType: {
                donation: 'Donation',
                budgetBilling: 'BudgetBilling',
                eBilling: 'EBilling',
                autoPay: 'AutoPay',
            },
            toggleProgramEnrollment: function (programType) {
                var deferred = $q.defer();
                $http({
                    url: localStorage.getItem('ApiUrl') + 'api/ProgramEnrollments/ToggleProgramEnrollment',
                    method: 'POST',
                    params:  {
                        programType: programType,
                        caNumber: localStorage.getItem('CurrentAccountNumber')
                    }
                }).success(function(response) {
                    if (response == undefined || response.HasErrors == undefined)
                        deferred.reject(utilli.errors.serverErrorMessage);
                    else if (response.HasErrors)
                        deferred.reject(response.Errors[0]);
                    else
                        deferred.resolve(response.Data);
                }).error(function(error) {
                    console.error(error);
                    deferred.reject(utilli.errors.serverErrorMessage);
                });

                return deferred.promise;
            },
            getSettings: function (settingName, withoutCache) {
                var deferred = $q.defer();
                if (_cachedData && !withoutCache) {
                    var result = settingName
                        ? _cachedData[settingName]
                        : _cachedData;
                    deferred.resolve(result);
                    return deferred.promise;
                }
                $http({
                    url: localStorage.getItem('ApiUrl') + 'api/ProgramEnrollments/GetProgramEnrolments',
                    method: 'GET',
                    params: utilli.addUserName($state, { caNumber: localStorage.getItem('CurrentAccountNumber') })
                }).success(function(response) {
                    utilli.handleAjaxResponse(response, ModalServiceExt, function () {
                        _cachedData = response.Data;
                        var result = settingName
                            ? _cachedData[settingName]
                            : _cachedData;
                        deferred.resolve(result)
                    });
                }).error(function(error) {
                    console.error(error);
                    deferred.reject(utilli.errors.serverErrorMessage);
                });
                return deferred.promise;
            }
    };
}])
'use strict';
angular.module('utilliApp')
    .controller('EmailNotificationsLearnMoreController', ['$scope', '$http', '$sce', '$state', 'LeftMenuService', 'CommonHeaderService',
        'ModalServiceExt', 'usSpinnerService', 'ProgramEnrollmentsSettings', '$timeout',
        function ($scope, $http, $sce, $state, LeftMenuService, CommonHeaderService, ModalServiceExt, usSpinnerService,
            ProgramEnrollmentsSettings, $timeout) {

            LeftMenuService.setCurrentTab('ProgramEnrolments');
            CommonHeaderService.setUpBackButton($scope._t('Program Info'));

            usSpinnerService.spin('spinner-1');
            ProgramEnrollmentsSettings.getSettings('EmailNotifications')
                .then(function (data) {
                    usSpinnerService.stop('spinner-1');
                    $scope.program = data;
                }, function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });

            $scope.enrollOrUnenroll = function () {
                usSpinnerService.spin('spinner-1');
                if (!$scope.program.IsEnrolled) {
                    sendRequest(
                        localStorage.getItem('ApiUrl') + 'api/ProgramEnrollments/EnrollEmailNotifications',
                        $scope._t('You have    successfully enrolled'));
                } else {
                    sendRequest(
                        localStorage.getItem('ApiUrl') + 'api/ProgramEnrollments/UnenrollEmailNotifications',
                        $scope._t('You have successfully unenrolled'));
                }
            }

            function sendRequest(url, message) {
                $http({
                    method: 'POST',
                    url: url,
                    params: utilli.addUserName($state)
                }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showError(response.Errors[0]);
                        return;
                    }

                    ModalServiceExt.showInfo(message, function () { $state.goMainLayout('ProgramEnrolments'); });
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }
        }]);
'use strict';
angular.module('utilliApp')
    .controller('DonationEnrollmentStepsController', ['$scope', '$state', 'LeftMenuService',
        'CommonHeaderService', '$window', '$stateParams',
        function ($scope, $state, LeftMenuService, CommonHeaderService, $window, $stateParams) {
            LeftMenuService.setCurrentTab('ProgramEnrolments');
            CommonHeaderService.setUpBackButton($scope._t('Donation Enrollment'));

            $scope.model = $scope.model || {
                    program: null,
                    goToStep1: function () {
                        $state.goMainLayout('DonationEnrollment.DonationEnrollmentStep1');
                    },
                    back: function () {
                        $window.history.back();
                    }
                };

            if($stateParams.program)
                $scope.model.program = $stateParams.program;

            $scope.model.goToStep1();
    }])
    .controller('DonationEnrollmentStep1Controller', ['$scope', '$http', '$state', 'LeftMenuService',
        'usSpinnerService', 'ProgramEnrollmentsSettings', 'ModalServiceExt',
        function ($scope, $http, $state, LeftMenuService, usSpinnerService, ProgramEnrollmentsSettings, ModalServiceExt) {
            LeftMenuService.setCurrentTab('ProgramEnrolments');

            $scope.model.isDataLoaded = false;
            if(!$scope.model.program) {
                usSpinnerService.spin('spinner-1');
                ProgramEnrollmentsSettings
                    .getSettings('Donation')
                    .then(function(data) {
                        usSpinnerService.stop('spinner-1');
                        $scope.model.program = data;
                        checkSettings();
                        $scope.model.isDataLoaded = true;
                    }, function() {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                    });
            }
            else {
                checkSettings();
                $scope.model.isDataLoaded = true;
            }

            function enrollRoundUpDonation () {
                var params = { };
                utilli.addUserName($state, params);
                $http({
                    url: localStorage.getItem('ApiUrl') + 'api/ProgramEnrollments/EnrollRoundUpDonation',
                    method: 'POST',
                    params: params
                }).success(function(response) {
                    utilli.handleAjaxResponse(response, ModalServiceExt, function () {
                        
                    });
                }).error(function(error) {
                    ModalServiceExt.showServerError();
                    console.error(error);
                });
            }

            $scope.next = function () {
                $scope.submitted = true;
                if(!$scope.model.donationPreference) {
                    return;
                }
                if($scope.model.donationPreference == 'roundUp')
                {
                    usSpinnerService.spin('spinner-1');
                    ProgramEnrollmentsSettings
                        .toggleProgramEnrollment(ProgramEnrollmentsSettings.programEnrollmentsType.donation)
                        .then(function (data) {
                            usSpinnerService.stop('spinner-1');
                            ModalServiceExt.showInfo("Program is successfully enrolled.", function () {
                                $state.goMainLayout("ProgramEnrolments");
                            });
                        }, function (error) {
                            usSpinnerService.stop('spinner-1');
                            ModalServiceExt.showServerError();
                            console.error(error);
                        });
                }

                else if($scope.model.donationPreference == 'fixedAmount')
                    $state.goMainLayout('DonationEnrollment.FixedAmountEnrollmentStep2');
                else if($scope.model.donationPreference == 'percentage')
                    $state.goMainLayout('DonationEnrollment.PercentageEnrollmentStep2');
            }

            function checkSettings() {
                if(!$scope.model.program) {
                    return;
                }
                if($scope.model.program.RoundUpEnabled && !$scope.model.program.FixedAmountEnabled && !$scope.model.program.PercentageEnabled)
                    enrollRoundUpDonation();
                else if($scope.model.program.FixedAmountEnabled && !$scope.model.program.RoundUpEnabled && !$scope.model.program.PercentageEnabled)
                    $state.goMainLayout('DonationEnrollment.PercentageEnrollmentStep2');
                else if($scope.model.program.PercentageEnabled && !$scope.model.program.FixedAmountEnabled && !$scope.model.program.RoundUpEnabled)
                    $state.goMainLayout('DonationEnrollment.FixedAmountEnrollmentStep2');
                else
                    $scope.model.goToStep1();
            }
        }])
    .controller('FixedAmountEnrollmentStep2Controller', ['$scope', '$state', 'LeftMenuService', 'usSpinnerService',
        'ModalServiceExt', 'ProgramEnrollmentsSettings',
        function ($scope, $state, LeftMenuService, usSpinnerService, ModalServiceExt, ProgramEnrollmentsSettings) {
            LeftMenuService.setCurrentTab('ProgramEnrolments');

            $scope.isIosMobile = isMobileOrRipple() && iOS();
            
            if(!$scope.model.program)
                $scope.model.goToStep1();

            $scope.next = function () {
                $scope.submitted = true;
                if($scope.fixedAmountEnrollForm.$invalid)
                    return;
                usSpinnerService.spin('spinner-1');
                ProgramEnrollmentsSettings
                    .toggleProgramEnrollment(ProgramEnrollmentsSettings.programEnrollmentsType.donation)
                    .then(function (data) {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showInfo("Program is successfully enrolled.", function () {
                            $state.goMainLayout("ProgramEnrolments");
                        });
                    }, function (error) {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                        console.error(error);
                    });
            }
        }])
    .controller('PercentageEnrollmentStep2Controller', ['$scope', '$state', 'LeftMenuService', 'usSpinnerService',
        'ProgramEnrollmentsSettings', 'ModalServiceExt',
        function ($scope, $state, LeftMenuService, usSpinnerService, ProgramEnrollmentsSettings, ModalServiceExt) {
            LeftMenuService.setCurrentTab('ProgramEnrolments');

            if(!$scope.model.program)
                $scope.model.goToStep1();

            $scope.next = function () {
                $scope.submitted = true;
                if($scope.percentageEnrollmentForm.$invalid)
                    return;
                usSpinnerService.spin('spinner-1');
                ProgramEnrollmentsSettings
                    .toggleProgramEnrollment(ProgramEnrollmentsSettings.programEnrollmentsType.donation)
                    .then(function (data) {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showInfo("Program is successfully enrolled.", function () {
                            $state.goMainLayout("ProgramEnrolments");
                        });
                    }, function (error) {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                        console.error(error);
                    });
            }
        }]);
'use strict';
angular.module('utilliApp')
.controller('ChangePasswordController', ['$scope', '$rootScope', '$http', '$window', '$state', 'usSpinnerService',
        'LeftMenuService', 'ModalServiceExt', 'CommonDataService', 'CommonHeaderService',
// ReSharper disable InconsistentNaming
function ($scope, $rootScope, $http, $window, $state, usSpinnerService, LeftMenuService, ModalServiceExt,
    CommonDataService, CommonHeaderService) {
    var _t = $scope._t;
    // ReSharper restore InconsistentNaming
    LeftMenuService.setCurrentTab('ChangePassword');
    CommonHeaderService.setUpBackButton(_t('Change Password'));

    $scope.passRequirements = [{ Value: _t('Loading...') }];
    $scope.passwdErrors = [];

    usSpinnerService.spin('spinner-1');
    CommonDataService.getCommonData().then(function (data) {
        $scope.paswdMinLength = data.PasswordLength;
        $scope.passRequirements = data.ChangePasswordPasswordRequirements;
        usSpinnerService.stop('spinner-1');
    }, function () {
        ModalServiceExt.showServerError();
    });

    $scope.model = {};
    $scope.model.currentPassword = '';
    $scope.model.newPassword = '';
    $scope.model.confirmNewPassword = '';

    $scope.serverErrors = [];

    $scope.errors = {};

    $scope.togglePassword = function (pswId, iconId) {
        utilli.togglePasswordVisibility(pswId, iconId);
    }

    $scope.changePassword = function () {
        $scope.serverErrors = [];
        $scope.isButtonPressed = true;

        if (!$scope.isPasswdValid()) {
            $scope.serverErrors = [utilli.errors.validationErorrsMessage];
            utilli.scrollTop();
            return;
        }

        usSpinnerService.spin('spinner-1');

        var requestData = {
            CurrentPassword: $scope.model.currentPassword,
            NewPassword: $scope.model.newPassword,
            ConfirmPassword: $scope.model.confirmNewPassword
        };
        utilli.addUserName($state, requestData);

        $http({
            url: localStorage.getItem('ApiUrl') + 'api/Account/ChangePassword',
            method: 'POST',
            data: requestData
        }).success(function (data) {
            usSpinnerService.stop('spinner-1');

            if (data.Errors != null && data.Errors.length > 0)
                $scope.serverErrors = data.Errors;
            else
                ModalServiceExt.showInfo(_t('Password was changed successfully.'), function () {
                    utilli.goesToDefaultPage($state);
                });

        }).error(function () {
            $scope.serverErrors = [utilli.serverErrorMessage];
            usSpinnerService.stop('spinner-1');
        });
    };

    $scope.isPasswdValid = function () { 
        $scope.passwdErrors = utilli.validatePassword($scope.model.newPassword, localStorage.getItem('current_user'), 
            $scope.passRequirements, $scope.paswdMinLength, $scope.model.currentPassword);
        $scope.passwordsNotMatch = $scope.model.newPassword && $scope.model.newPassword !== $scope.model.confirmNewPassword 
            ? $scope._t('Passwords do not match.')
            : null;
        var result = $scope.passwdErrors.length == 0 && !$scope.passwordsNotMatch;
        return result;
    }

}]);
'use strict';
angular.module('utilliApp')
.controller('FaqsController', ['$scope', '$rootScope', '$window', '$http', '$sce', '$timeout', 'LeftMenuService', 
    '$stateParams', 'CommonHeaderService', 'usSpinnerService', 'ServiceProvidersService', 'ModalServiceExt',
function ($scope, $rootScope, $window, $http, $sce, $timeout, LeftMenuService, $stateParams, CommonHeaderService,
    usSpinnerService, ServiceProvidersService, ModalServiceExt) {
    LeftMenuService.setCurrentTab('Faqs');
    CommonHeaderService.setUpBackButton($scope._t('FAQs'));

    usSpinnerService.spin('spinner-1');
    var apiUrl = localStorage.getItem('ApiUrl');
    $scope.serverAddress = apiUrl;
    $scope.screen = $window.screen;
    if (!apiUrl) {
        ServiceProvidersService.getCurrentProvider().then(
            function (providerData) {
                apiUrl = providerData.ApiUrl;
                $scope.serverAddress = apiUrl;
                loadFAQ();
                loadSystemInfo();
            },
            function () {
                usSpinnerService.stop("spinner-1");
                ModalServiceExt.showError(utilli.serverErrorMessage);
            }
        );
    } else {
        loadFAQ();
        loadSystemInfo();
    }

    function loadFAQ() {
        $http({
            url: apiUrl + 'api/StaticData/GetFaqs/',
            method: "GET"
        }).success(function (jsonData) {
            usSpinnerService.stop('spinner-1');
            $scope.faqContent = JSON.parse(jsonData);
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showError(utilli.serverErrorMessage);
        });
    }

    function loadSystemInfo() {
        $http({
            url: apiUrl + 'api/StaticData/GetSystemInfo/',
            method: "GET",
        }).success(function (responseData) {
            $scope.serverInfo = responseData;
        }).error(function (errorData) {
            console.log(errorData);
        });
    }

    $scope.toHtml = function (htmlCode) {
        return $sce.trustAsHtml(htmlCode);
    }

    $scope.checkFaq = function (item) {
        if (item.param === 'directDebit' && $stateParams.directDebitParam === 'true')
            return true;

        if (item.param === 'donation' && $stateParams.donationParam === 'true')
            return true;

        return false;
    }

    $scope.processFaq = function () {
        if ($stateParams.directDebitParam !== 'true' && $stateParams.donationParam !== 'true')
            return;

        setTimeout(function () {
            $(".direct-debit-collapse").closest('.highlighted-region')[0].scrollIntoView(); }, 1000);
    }
    $scope.currentVersion = DeploymentSettings.currentVersion.replace('?v=', '');

    $scope.downloadManual = function (item) {
        var url = decodeURIComponent(item.param);
        utilli.downloadFile(url, "UserManual.pdf");
    }
}])
.directive('repeatDone', function () {
    return function (scope, element, attrs) {
        if (scope.$last) {
            scope.$eval(attrs.repeatDone);
        }
    }
})
.directive('compileTemplate', ["$compile", "$parse", function ($compile, $parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            var parsed = $parse(attr.ngBindHtml);
            //Recompile if the template changes
            scope.$watch(
                function () {
                    return (parsed(scope) || '').toString(); 
                }, function () {
                $compile(element, null, -9999)(scope);  //The -9999 makes it skip directives so that we do not recompile ourselves
            });
        }
    }
}]);
'use strict';
var app = angular.module('utilliApp');

app.factory('avatarsService', ["$rootScope", function ($rootScope) {
    var factory = {};

    factory.setCurrentAvatar = function (avatar) {
        $rootScope.avatar = avatar;
    };

    factory.getCurrentAvatar = function () {
        return $rootScope.avatar;
    };

    factory.getAvatars = function () {
        return $rootScope.avatars;
    };

    factory.setAvatars = function (avatars) {
        return $rootScope.avatars = avatars;
    };

    factory.clear = function () {
        $scope.avatars = [];
    };

    return factory;
}]);

app.controller('ProfileController', ['$scope', '$rootScope', '$state', '$http', 'avatarsService', '$window', 'usSpinnerService',
    'LeftMenuService', 'ModalServiceExt', 'CommonHeaderService', 'CommonDataService', 'NotificationBoxService', '$sce',
    function ($scope, $rootScope, $state, $http, avatarsService, $window, usSpinnerService, LeftMenuService,
         ModalServiceExt, CommonHeaderService, CommonDataService, NotificationBoxService, $sce)
    {
        var _t = $scope._t;
        LeftMenuService.setCurrentTab('Profile');

        // i save original phone number (that was before the user did any updates on the page) in this variable
        // to be able to detect if the user has changed the phone number. because if he has changed it then we need
        // to inform him that form SMS subscription he needs to confirm his phone number again.
        var originalPhoneNumber = '';
        $scope.customerPrefUrl = '';
        $scope.enableVerifyDiv = false;
        $scope.otpError = false;
        $scope.otp = '';
         CommonHeaderService.setUpBackButton($scope._t('Profile'));
         $scope.phoneNumberMask = Config.phoneNumberMask;
         $scope.accountInfoActive = true;
         $scope.mailingAddressDisabled = false;
         $scope.userInfoErrors = [];
         $scope.accountInfoErrors = [];
         $scope.otpErrors = [];
         $scope.enableLanguagePack = utilli.isLanguagePackEnabled();
         $scope.isAdmin = utilli.hasAdminOrCsrRole();

         var currentUser = localStorage.getItem('current_user');

         CommonDataService.getCommonData().then(function (data) {
             $scope.mailingAddressDisabled = !data.EnableMailingAddress;
             $scope.EnableProfileNameChange = data.EnableProfileNameChange;
             $scope.BillingEmailTo = data.BillingEmailTo;
             $scope.FullCustomerServiceInfo = data.FullCustomerServiceInfo;
             $scope.EnableSmsPayments = data.EnableSmsPayments;
             $scope.isPoBoxEnabled = data.IsPoBoxEnabled;
             $scope.phoneNumberSubscriptionText = data.EnableSmsPayments 
                ? _t('Register to receive SMS notifications and make bill payments using mobile phone:')
                : _t('Register to receive SMS notifications:');
         }, function () {
             ModalServiceExt.showServerError();
         });

         function addAccountError(error)
         {
             $scope.accountInfoErrors.push({Message:error});
         }

         function addUserInfoError(error) {
             $scope.userInfoErrors.push({ Message: error });
         }

         function addAccountErrors(errors) {
             $.merge($scope.accountInfoErrors, errors);
         }

         function addUserInfoErrors(errors) {
             $.merge($scope.userInfoErrors, errors);
         }

         function addOtpErrors(errors) {
            $.merge($scope.otpErrors, errors);
        }

         function clearAccountErrors() {
             $scope.accountInfoErrors = [];
         }

         function clearUserInfoErrors() {
             $scope.userInfoErrors = [];
         }

         function clearOtpErrors() {
            $scope.otpErrors = [];
        }

         $scope.getProfileData = function ()
         {
             usSpinnerService.spin('spinner-1');

             var accountNumber = localStorage.getItem('CurrentAccountNumber');
             var apiUrl = localStorage.getItem('ApiUrl');
             var requestData = { accountNumber: accountNumber };
             utilli.addUserName($state, requestData);
             $http({
                 url: apiUrl + 'api/Profile/GetProfile/',
                 method: "GET",
                 params: requestData
             }).success(function (data) {
                 if (data.Errors && data.Errors.length > 0)
                 {
                     addAccountErrors(data.Errors);
                     usSpinnerService.stop('spinner-1');
                     return;
                 }

                 $scope.profile = data.AccountData;
                 originalPhoneNumber = data.AccountData.PrimaryPhoneNumber;
                 // save full name to check if it's changed because we need to show a message to the user that 
                 // if he logs out then he will be locked.
                 $scope.initialFullName = data.AccountData.FirstAndLastNameOrCompanyName;
                 $scope.profile.PrimaryPhoneNumber = utilli.adjustPhoneNumber($scope.profile.PrimaryPhoneNumber);

                 avatarsService.setCurrentAvatar(apiUrl + data.AvatarURL);
                 usSpinnerService.stop('spinner-1');
                 $scope.getCustomerPrefLink();
             }).error(function () {
                 addAccountError($scope._t("Server error. Try again later."));
                 usSpinnerService.stop('spinner-1');
             });
         };

         $scope.getCustomerPrefLink = function ()
         {
             usSpinnerService.spin('spinner-1');

             var accountNumber = localStorage.getItem('CurrentAccountNumber');
             var apiUrl = localStorage.getItem('ApiUrl');
             var requestData = { accountNumber: accountNumber };
             utilli.addUserName($state, requestData);
             $http({
                 url: apiUrl + 'api/Profile/GetPreferenceLink/',
                 method: "GET",
                 params: requestData
             }).success(function (data) {
                 if (data.Errors && data.Errors.length > 0)
                 {
                     addAccountErrors(data.Errors);
                     usSpinnerService.stop('spinner-1');
                     return;
                 }
                 $scope.customerPrefUrl = $sce.trustAsResourceUrl(data.Url);
                 usSpinnerService.stop('spinner-1');
             }).error(function () {
                 addAccountError($scope._t("Server error. Try again later."));
                 usSpinnerService.stop('spinner-1');
             });
         };

         $scope.onIframeLoad = function(obj) {
            console.log(obj.toString())
        };

         $scope.dashboard = function ()
         {
             resetErrors();
             $state.goMainLayout('Dashboard');
         };

         $scope.toAccountInfo = function () {
             $scope.accountInfoActive = true;
             resetErrors();
             $scope.getProfileData();
         };

         $scope.toUserInfo = function () {
             $scope.accountInfoActive = false;
             resetErrors();
             $scope.getProfileData();
         };

         $scope.getUserInfoClasses = function()
         {
             if ($scope.accountInfoActive)
                 return 'profile-page-invisible';

             return 'profile-page-visible';
         }

         $scope.getAccountInfoClasses = function () {
             if ($scope.accountInfoActive)
                 return 'profile-page-visible';

             return 'profile-page-invisible';
         }

         $scope.changeAvatar = function () {
             $state.goMainLayout('Avatars');
             resetErrors();
         };

         $scope.openCustomerPrefUrl = function () {
            window.open($scope.customerPrefUrl, '_blank');
        };

         $scope.changeLanguage = function () {
             $state.goMainLayout('Languages');
             resetErrors();
         };

         function resetErrors() {
             clearAccountErrors();
             clearUserInfoErrors();
             clearOtpErrors();

             $scope.phoneNumberError = false;
             $scope.emailError = false;
             $scope.invalidEmailError = false;
             $scope.houseNumberPOBoxEmptyError = false;
             $scope.houseNumberPOBoxFilledError = false;
             $scope.invalidHouseNumberError = false;
             $scope.invalidPOBoxError = false;
             $scope.streetError = false;
             $scope.nameError = false;
             $scope.oddStreetError = false;
             $scope.cityError = false;
             $scope.invalidCityError = false;
             $scope.stateError = false;
             $scope.invalidStateError = false;
             $scope.zipError = false;
             $scope.zipFormatError = false;
             $scope.otpError = false;
         };
         function updateProfileData (){
            usSpinnerService.spin('spinner-1');
            var postData = {};
            $window.jQuery.extend(postData, $scope.profile);
            var countryCode = utilli.getCountryPhoneNumberCode();
            postData.PrimaryPhoneNumber = postData.PrimaryPhoneNumber == null 
                ? null : countryCode + postData.PrimaryPhoneNumber;
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Profile/UpdateProfile/',
                method: "POST",
                data: postData
            }).success(function (data) {
                usSpinnerService.stop('spinner-1');
                $rootScope.$broadcast('profile-updated');

                if (data.Errors && data.Errors.length > 0) {
                    addUserInfoErrors(data.Errors);
                }
                else {
                    $scope.enableVerifyDiv = false;
                    var message = $scope._t('Your profile has been saved.');
                    if ($scope.initialFullName.toUpperCase() != $scope.profile.FirstAndLastNameOrCompanyName.toUpperCase()){
                        message += " " + $scope._t('Once you log off your account will be locked for back office '
                        + 'processing, please allow 24 hours before logging back on. If you have any '
                        + 'payments that are due now, please ensure that you make them prior to logging off. If '
                        + 'your account is still locked after 24 hours, please contact Customer Service at '
                        + '%supportEmail% or %fullCustomerServiceInfo%')
                            .replace('%supportEmail%', $scope.BillingEmailTo)
                            .replace('%fullCustomerServiceInfo%', $scope.FullCustomerServiceInfo);
                    }
                    ModalServiceExt.showInfo(message);
                }
                if ($scope.profile.PrimaryPhoneNumber !== "")
                    NotificationBoxService.setSubscribeSmsVisibilityServerFlag(false);
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                addUserInfoError($scope._t("Server error. Try again later."));
            });
        };
        $scope.save = function (validatePhone) {
            resetErrors();
            //
            // function updateProfileData (){
            //     usSpinnerService.spin('spinner-1');
            //     var postData = {};
            //     $window.jQuery.extend(postData, $scope.profile);
            //     var countryCode = utilli.getCountryPhoneNumberCode();
            //     postData.PrimaryPhoneNumber = postData.PrimaryPhoneNumber == null 
            //         ? null : countryCode + postData.PrimaryPhoneNumber;
            //     $http({
            //         url: localStorage.getItem('ApiUrl') + 'api/Profile/UpdateProfile/',
            //         method: "POST",
            //         data: postData
            //     }).success(function (data) {
            //         usSpinnerService.stop('spinner-1');
            //         $rootScope.$broadcast('profile-updated');

            //         if (data.Errors && data.Errors.length > 0) {
            //             addUserInfoErrors(data.Errors);
            //         }
            //         else {
            //             $scope.enableVerifyDiv = false;
            //             var message = $scope._t('Your profile has been saved.');
            //             if ($scope.initialFullName.toUpperCase() != $scope.profile.FirstAndLastNameOrCompanyName.toUpperCase()){
            //                 message += " " + $scope._t('Once you log off your account will be locked for back office '
            //                 + 'processing, please allow 24 hours before logging back on. If you have any '
            //                 + 'payments that are due now, please ensure that you make them prior to logging off. If '
            //                 + 'your account is still locked after 24 hours, please contact Customer Service at '
            //                 + '%supportEmail% or %fullCustomerServiceInfo%')
            //                     .replace('%supportEmail%', $scope.BillingEmailTo)
            //                     .replace('%fullCustomerServiceInfo%', $scope.FullCustomerServiceInfo);
            //             }
            //             ModalServiceExt.showInfo(message);
            //         }
            //         if ($scope.profile.PrimaryPhoneNumber !== "")
            //             NotificationBoxService.setSubscribeSmsVisibilityServerFlag(false);
            //     }).error(function () {
            //         usSpinnerService.stop('spinner-1');
            //         addUserInfoError($scope._t("Server error. Try again later."));
            //     });
            // }
            // var valid = validate(validatePhone);
            // if (!valid) {
            //     addUserInfoError(utilli.errors.validationErorrsMessage);
            //     utilli.scrollTop();
            //     return;
            // }

            function sendEmailOtp (){
                // if (!$scope.otp) {
                //     $scope.otpError = true;
                //     valid = false;
                // }
                usSpinnerService.spin('spinner-1');
                var postData = {};
                $window.jQuery.extend(postData, $scope.profile);
                var countryCode = utilli.getCountryPhoneNumberCode();
                postData.PrimaryPhoneNumber = postData.PrimaryPhoneNumber == null 
                    ? null : countryCode + postData.PrimaryPhoneNumber;
                $http({
                    url: localStorage.getItem('ApiUrl') + 'api/Profile/SendEmailOtp/',
                    method: "POST",
                    data: postData
                }).success(function (data) {
                    usSpinnerService.stop('spinner-1');
                    $rootScope.$broadcast('profile-updated');

                    if (data.Errors && data.Errors.length > 0) {
                        addUserInfoErrors(data.Errors);
                    }
                    else {
                        if (data.Result)
                        {
                            if (data.Result == "allowed")
                            {
                                updateProfileData();
                            }
                            else
                            {
                                var message = $scope._t(data.Result);
                                ModalServiceExt.showInfo(message);
                                $scope.enableVerifyDiv = true;
                            }
                        }
                        else
                        {
                            var message = $scope._t('Saved successfully.');
                            ModalServiceExt.showInfo(message);
                        }
                    }
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                    addUserInfoError($scope._t("Server error. Try again later."));
                });
            }
            if (!utilli.arePhoneNumbersEqual(originalPhoneNumber, $scope.profile.PrimaryPhoneNumber) && 
                $scope.profile.SubscribeForSmsNotification == '1') {
                var noCallback = function () {
                    // do nothing
                };
                ModalServiceExt.showYesNoMessage(_t('Warning'), _t('Since you changed your phone number we must unregister you from SMS notifications. You will need to register for SMS notifications with the updated phone number. Do you want to continue?'),
                    function () {
                        $scope.profile.SubscribeForSmsNotification = '0';
                        updateProfileData();
                    }, noCallback, false, noCallback);
            }
            else {
                // updateProfileData();
                sendEmailOtp();
            }
        };

        $scope.verify = function () {
            resetErrors();
            function verifyEmailOtp (){
                if (!$scope.otp) {
                    $scope.otpError = true;
                    valid = false;
                }
                usSpinnerService.spin('spinner-1');
                var accountNumber = localStorage.getItem('CurrentAccountNumber');
                var apiUrl = localStorage.getItem('ApiUrl');
                var requestData = { accountNumber: accountNumber, username: $scope.profile.userId, otp: $scope.otp };
                $http({
                    url: apiUrl + 'api/Profile/VerifyEmailOtp/',
                    method: "GET",
                    params: requestData
                }).success(function (data) {
                    if (data.Errors && data.Errors.length > 0)
                    {
                        addOtpErrors(data.Errors);
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    else if (data.Result == "success")
                    {
                        usSpinnerService.stop('spinner-1');
                        updateProfileData();
                    }
                    usSpinnerService.stop('spinner-1');
                }).error(function () {
                    addAccountError($scope._t("Server error. Try again later."));
                    usSpinnerService.stop('spinner-1');
                });
            }
            // function updateProfileData (){
            //     usSpinnerService.spin('spinner-1');
            //     var postData = {};
            //     $window.jQuery.extend(postData, $scope.profile);
            //     var countryCode = utilli.getCountryPhoneNumberCode();
            //     postData.PrimaryPhoneNumber = postData.PrimaryPhoneNumber == null 
            //         ? null : countryCode + postData.PrimaryPhoneNumber;
            //     $http({
            //         url: localStorage.getItem('ApiUrl') + 'api/Profile/UpdateProfile/',
            //         method: "POST",
            //         data: postData
            //     }).success(function (data) {
            //         usSpinnerService.stop('spinner-1');
            //         $rootScope.$broadcast('profile-updated');

            //         if (data.Errors && data.Errors.length > 0) {
            //             addUserInfoErrors(data.Errors);
            //         }
            //         else {
            //             $scope.enableVerifyDiv = false;
            //             var message = $scope._t('Your profile has been saved.');
            //             if ($scope.initialFullName.toUpperCase() != $scope.profile.FirstAndLastNameOrCompanyName.toUpperCase()){
            //                 message += " " + $scope._t('Once you log off your account will be locked for back office '
            //                 + 'processing, please allow 24 hours before logging back on. If you have any '
            //                 + 'payments that are due now, please ensure that you make them prior to logging off. If '
            //                 + 'your account is still locked after 24 hours, please contact Customer Service at '
            //                 + '%supportEmail% or %fullCustomerServiceInfo%')
            //                     .replace('%supportEmail%', $scope.BillingEmailTo)
            //                     .replace('%fullCustomerServiceInfo%', $scope.FullCustomerServiceInfo);
            //             }
            //             ModalServiceExt.showInfo(message);
            //         }
            //         if ($scope.profile.PrimaryPhoneNumber !== "")
            //             NotificationBoxService.setSubscribeSmsVisibilityServerFlag(false);
            //     }).error(function () {
            //         usSpinnerService.stop('spinner-1');
            //         addUserInfoError($scope._t("Server error. Try again later."));
            //     });
            // }
            verifyEmailOtp();
        };

        $scope.subscribeYes = function () {
            $scope.profile.SubscribeForEmailNotification = '1';
        };

         $scope.subscribeNo = function () {
             $scope.profile.SubscribeForEmailNotification = '0';
         };

         $scope.phoneSubscribeYes = function () {
            var noCallback = function(){
                $scope.profile.SubscribeForSmsNotification = '0';
            }
            ModalServiceExt.showYesNoMessage(_t('Confirm Phone Number'), 
                _t('To subscribe for SMS notifications you need to confirm your phone number. Do you want to continue?'), 
                function(){
                    $state.goMainLayout('MobilePhoneConfirmation', { phoneNumber: $scope.profile.PrimaryPhoneNumber });
                },
                noCallback, false, noCallback
            );
         };

         $scope.phoneSubscribeNo = function () {
             $scope.profile.SubscribeForSmsNotification = '0';
         };
         
         $scope.changePhoneNumber = function () {
             $state.goMainLayout('MobilePhoneConfirmation');
         }

         function validate(validatePhone) {
             var valid = true;
             var matched;
             var regexp = '';

             if (!$scope.profile.Email) {
                 $scope.emailError = true;
                 valid = false;
             }
             else {
                 // if input type is 'email' then the validation below is not required because when 
                 // format is wrong the value will be empty, but i decided to leave this check for the case
                 // if someone will decide to change input type to text and forgot to add custom validation
                 regexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                 matched = regexp.test($scope.profile.Email);
                 if (!matched) {
                     $scope.invalidEmailError = true;
                     valid = false;
                 }
             }

             // For some companies Full Name is editable (for example, Howard County)
             if ($scope.EnableProfileNameChange && !$scope.profile.FirstAndLastNameOrCompanyName) {
                $scope.nameError = true;
                valid = false;
            }

            if (validatePhone && !$scope.profile.PrimaryPhoneNumber){
                    $scope.phoneNumberError = true;
                    valid = false;
                }

             // For some companies Mailing Address is not editable. Then there is nothing else to validate.
             if ($scope.mailingAddressDisabled)
                 return valid;

            // in HC PoBox is not used and house number is not required
            if ($scope.isPoBoxEnabled){
                if ($scope.profile.POBox) {
                    if ($scope.profile.HouseNumber) {
                        $scope.houseNumberPOBoxFilledError = true;
                        valid = false;
                    }

                    if ($scope.profile.AddressLine) {
                        $scope.oddStreetError = true;
                        valid = false;
                    }
                }
                else
                {
                    if (!$scope.profile.HouseNumber) {
                        $scope.houseNumberPOBoxEmptyError = true;
                        valid = false;
                    }

                    if (!$scope.profile.AddressLine) {
                        $scope.streetError = true;
                        valid = false;
                    }
                }

                if (!$scope.houseNumberPOBoxFilledError && !$scope.houseNumberPOBoxEmptyError) {
                    regexp = /^[0-9]+$/;
                    if ($scope.profile.HouseNumber) {
                        matched = regexp.test($scope.profile.HouseNumber);
                        if (!matched) {
                            $scope.invalidHouseNumberError = true;
                            valid = false;
                        }
                    } else {
                        matched = regexp.test($scope.profile.POBox);
                        if (!matched) {
                            $scope.invalidPOBoxError = true;
                            valid = false;
                        }
                    }
                }
            }
            else {
                // but in street name in HC is required!
                if (!$scope.profile.AddressLine) {
                    $scope.streetError = true;
                    valid = false;
                }
            }
             //
             if (!$scope.profile.City) {
                 $scope.cityError = true;
                 valid = false;
             } else {
                // todo: moved to server side to unify validation, for PCI DSS fix
                //  regexp = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;
                //  matched = regexp.test($scope.profile.City);
                //  if (!matched) {
                //      $scope.invalidCityError = true;
                //      valid = false;
                //  }
             }

             //
             if (!$scope.profile.State) {
                 $scope.stateError = true;
                 valid = false;
             } else {
                // todo: moved to server side to unify validation, for PCI DSS fix
                //  regexp = /^[a-zA-Z]{2}$/;
                //  matched = regexp.test($scope.profile.State);
                //  if (!matched) {
                //      $scope.invalidStateError = true;
                //      valid = false;
                //  }
             }

             //
             if (!$scope.profile.Zip) {
                 $scope.zipError = true;
                 valid = false;
             }
             else {
                 matched = Config.zipCodeRegexp.test($scope.profile.Zip);
                 if (!matched) {
                     $scope.zipFormatError = true;
                     valid = false;
                 }
             }

             return valid;
         }
     }]);

app.controller('AvatarsController', ['$scope', '$http', '$state', 'avatarsService',
    'usSpinnerService', 'LeftMenuService', 'CommonHeaderService', '$stateParams',
     function ($scope, $http, $state, avatarsService, usSpinnerService, LeftMenuService, CommonHeaderService, $stateParams) {

        var _t = $scope._t;
        
         CommonHeaderService.setUpBackButton(_t('Profile'), true);
         $scope.selectedImage = avatarsService.getCurrentAvatar();
         $scope.errors = [];
         
         $scope.loadAvatars = function ()
         {
             $scope.avatars = avatarsService.getAvatars();
             if ($scope.avatars && $scope.avatars.length > 0)
                 return;
          
             usSpinnerService.spin('spinner-1');

             var apiUrl = localStorage.getItem('ApiUrl');
             var accountNumber = localStorage.getItem('CurrentAccountNumber');
             var userData = { accountNumber: accountNumber };

             $http({
                 url: apiUrl + 'api/Profile/GetAvatars/',
                 method: "GET",
                 params: userData
             }).success(function (data) {
                 if (data.length > 0)
                 {
                     var avatars = data.map(function (imageUrl) {
                         return apiUrl + imageUrl;
                     });
                     avatarsService.setAvatars(avatars);
                     $scope.avatars = avatars;
                 }

                 usSpinnerService.stop('spinner-1');
             }).error(function () {
                 $scope.errors.push({ Message: $scope._t("Server error. Try again later.") });
                 usSpinnerService.stop('spinner-1');
             });
         }

         function getValidAvatarPath() {
             var length = localStorage.getItem('ApiUrl').length;
             var path = $scope.selectedImage.slice(length);
             return path;
         };

         $scope.selectAvatar = function (index)
         {
             $scope.selectedImage = $scope.avatars[index];
             var avatarPath = getValidAvatarPath();
             var avatarData = { path: avatarPath };
             utilli.addUserName($state, avatarData);

             usSpinnerService.spin('spinner-1');
             $http({
                 url: localStorage.getItem('ApiUrl') + 'api/Profile/UpdateAvatar/',
                 method: "POST",
                 params: avatarData
             }).success(function (data) {
                 usSpinnerService.stop('spinner-1');
                 if (data == 'success') {
                     avatarsService.setCurrentAvatar($scope.selectedImage);
                     LeftMenuService.avatar = $scope.selectedImage;
                     $state.goMainLayout(getBackStateName());
                     return;
                 }
                 $scope.errors.push({ Message: data });
             }).error(function () {
                 usSpinnerService.spin('spinner-1');
                 $scope.errors.push({ Message: $scope._t("Server error. Try again later.") });
             });
         };

         function getBackStateName() {
             var result = 'Profile';
             if ($stateParams.forAgent)
                 result = 'AgentProfile';
            else if ($stateParams.forAssistant)
                 result = 'AssistantProfile';
             else if ($stateParams.forPropertyManager)
                 result = 'PropertyManagerProfile';
             return result;
         }
     }])
     app.directive('iframeSetDimensionsOnload', ["$window", function($window) {
        return {
          restrict: 'A',
          link: function(scope, element, attrs) {
       
            var contentMinWidth = 1200;
       
            element.on('load', setSizeWithZoom());
       
            angular.element($window).bind('resize', function() {
              setSizeWithZoom();
              scope.$digest();
            });
       
            function setSize() {
              var iFrameWidth = element[0].contentWindow.parent.document.body.offsetWidth;
              var iFrameHeight = element[0].contentWindow.parent.document.body.offsetHeight;
              element.css('width', iFrameWidth + 'px');
              element.css('height', iFrameHeight + 'px');
            }
       
              function setSizeWithZoom() {
                  if (element[0].contentWindow) {
                      var iFrameWidth = element[0].contentWindow.parent.document.body.offsetWidth;
                      var iFrameHeight = element[0].contentWindow.parent.document.body.offsetHeight;

                      var scale = iFrameWidth / contentMinWidth;
                      scale = scale > 1 ? 1 : scale;
                      var zoom = 1 / scale;

                      //   element.css('width', '100%');
                      element.css('height', iFrameHeight + 'px');
                      //   element.css('-webkit-transform', 'scale(' + scale + ')');
                      //   element.css('-ms-transform', 'scale(' + scale + ')');
                      //   element.css('transform', 'scale(' + scale + ')');
                      //   element.css('zoom', zoom);
                  }
              }
          }
        }
      }]);
'use strict';
var app = angular.module('utilliApp');
app.controller('OutageCenterController',
['$scope', '$state', 'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt', 'usSpinnerService',
    'GetAccountsService', '$http', 'ServiceProvidersService', '$stateParams',
    function ($scope, $state, LeftMenuService, CommonHeaderService, ModalServiceExt, usSpinnerService,
        GetAccountsService, $http, ServiceProvidersService, $stateParams) {

        LeftMenuService.setCurrentTab('OutageCenter');
        CommonHeaderService.setUpBackButton($scope._t('Outage Center'), true);

        $scope.outageMapDescription = $scope._t('View a map displaying all currently reported outages.');
        $scope.outageListDescription = $scope._t('View a list of all currently reported outages.');
        $scope.outageSafetyDescription = $scope._t('View important outage safety information and severe weather planning tips.');
        $scope.outageHistoryDescription = $scope._t('View your previously reported outages and information about them.');

        $scope.anonymous = $stateParams.anonymous;

        usSpinnerService.spin('spinner-1');

        var apiUrl = '';
        if ($scope.anonymous) {
            ServiceProvidersService.getProviderApiUrl().then(function (result) {
                if (!result) {
                    ModalServiceExt.showServerError();
                    $state.goToSignIn();
                    return;
                }

                apiUrl = result;
                getOutagesStatistic();
            },
            function () {
                ModalServiceExt.showServerError();
                $state.goToSignIn();
            });
        } else {
            apiUrl = localStorage.getItem('ApiUrl');
            getOutagesStatistic();
        }

        function getOutagesStatistic() {

            var url = apiUrl + 'api/Outages/GetOutagesStatistic/';
            $http({
                method: 'GET',
                url: url
            })
            .success(function (result) {

                usSpinnerService.stop('spinner-1');

                if (result.Errors && result.Errors.length > 0) {
                    ModalServiceExt.showError(result.Errors[0]);
                    return;
                }

                $scope.reportsCount = result.Data.Count;
                $scope.avgRestorationHours = result.Data.AverageRestorationTime.Hours;
                $scope.hoursAbbreviation = 'h';
                $scope.avgRestorationMins = result.Data.AverageRestorationTime.Minutes;
                $scope.minutesAbbreviation = 'm';
            })
            .error(function (error) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }

        $scope.outageMap = function () {
            if ($scope.anonymous)
                $state.go('TopMenuLayout.OutageMap', { anonymous: true });
            else
                $state.goMainLayout('OutageMap');
        }

        $scope.outageList = function () {
            if ($scope.anonymous)
                $state.go('TopMenuLayout.OutageList', { anonymous: true });
            else
                $state.goMainLayout('OutageList');
        }

        $scope.outageSafety = function () {
            if ($scope.anonymous)
                $state.go('TopMenuLayout.OutageSafety', { anonymous: true });
            else
                $state.goMainLayout('OutageSafety');
        }

        $scope.outageHistory = function () {
            $state.goMainLayout('OutageHistory');
        }
    }
]);
'use strict';
var app = angular.module('utilliApp');
app.controller('OutageMapController', ['$scope', '$interval', '$state', 'LeftMenuService', 'CommonHeaderService',
    '$http', 'ModalServiceExt', 'usSpinnerService', '$timeout', '$stateParams', 'ServiceProvidersService', 'OutagesService',
    function ($scope, $interval, $state, LeftMenuService, CommonHeaderService,
        $http, ModalServiceExt, usSpinnerService, $timeout, $stateParams, ServiceProvidersService, OutagesService) {
        LeftMenuService.setCurrentTab('OutageMap');
        CommonHeaderService.setUpBackButton($scope._t('Outage Map'), true);

        $scope.anonymous = $stateParams.anonymous;
        $scope.isRootDetailsVisible = false;
        usSpinnerService.spin('spinner-1');

        var mapOptions = {
            zoom: 8,
            center: new google.maps.LatLng(38.967576, -77.077550),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            }
        }

        $scope.map = new google.maps.Map(document.getElementById('map'), mapOptions);
        adjustSize();
        var geocoder = new google.maps.Geocoder();

        var apiUrl = '';
        if ($scope.anonymous) {
            ServiceProvidersService.getProviderApiUrl().then(function (result) {
                if (!result) {
                    ModalServiceExt.showServerError();
                    $state.goToSignIn();
                    return;
                }

                apiUrl = result;
                getOutages();
                //getWorkCenters();
            },
                function () {
                    ModalServiceExt.showServerError();
                    $state.goToSignIn();
                });
        }
        else {
            apiUrl = localStorage.getItem('ApiUrl');
            getOutages();
            //getWorkCenters();
        }

        function getOutages() {

            var url = apiUrl + 'api/Outages/GetOutagesForMap/';
            $scope.outages = [];
            $http({
                method: 'GET',
                url: url
            }).success(function (result) {

                if (result.Errors && result.Errors.length > 0) {
                    adjustSize();
                    usSpinnerService.stop('spinner-1');
                    return;
                }

                if (result.Data && result.Data.length === 0) {
                    adjustSize();
                    usSpinnerService.stop('spinner-1');
                    return;
                }

                $scope.outages = result.Data;
                $scope.outages.forEach(function (outage, index) {

                    var location = { lat: outage.Coordinate.Latitude, lng: outage.Coordinate.Longitude };
                    var marker = new google.maps.Marker({
                        map: $scope.map,
                        position: location,
                        title: outage.Location
                    });
                    var icon = $scope.getIcon(outage.Status);
                    marker.setIcon(icon);
                    marker.addListener('click', function () {
                        markerClicked(marker, outage);
                    });

                    if (index === $scope.outages.length - 1) {
                        adjustSize();
                        $scope.map.setCenter(location);
                        usSpinnerService.stop('spinner-1');
                    }
                });

            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }

        var updateWorkCentersPositionstimerId;

        function getWorkCenters() {

            var url = apiUrl + 'api/TurnOffService/GetWorkCentersForMap/';
            $scope.outages = [];
            $http({
                method: 'GET',
                url: url
            }).success(function (result) {

                if (result.Errors && result.Errors.length > 0) {
                    adjustSize();
                    usSpinnerService.stop('spinner-1');
                    return;
                }

                if (result.Data && result.Data.length === 0) {
                    adjustSize();
                    usSpinnerService.stop('spinner-1');
                    return;
                }

                $scope.workCentersMarkers = [];

                $scope.workCenters = result.Data;
                $scope.workCenters.forEach(function (workCenter, index) {

                    var location = { lat: workCenter.Latitude, lng: workCenter.Longitude };
                    var marker = new google.maps.Marker({
                        map: $scope.map,
                        position: location,
                        title: workCenter.Id
                    });
                    var icon = OutagesService.common.getWorkCenterIcon(2);
                    marker.setIcon(icon);
                    marker.addListener('click', function () {
                        workCentrClicked(marker, workCenter);
                    });
                    $scope.workCentersMarkers.push({ mapMarker: marker, workCenter: workCenter });

                    if (index === $scope.workCenters.length - 1) {
                        adjustSize();
                        $scope.map.setCenter(location);
                        usSpinnerService.stop('spinner-1');
                    }
                });

                //updateWorkCentersPositionstimerId = setInterval(updateWorkCentersPositions, 1000);

            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });

        }

        var directionsService = new google.maps.DirectionsService();
        var directionsDisplay = new google.maps.DirectionsRenderer();
        directionsDisplay.setMap($scope.map);

        $scope.resizeMap = true;
        function calcRoute(start, end) {
            //var start = 'chicago, il';
            //var end = 'st louis, mo';
            var request = {
                origin: start,
                destination: end,
                travelMode: 'DRIVING'
            };
            directionsService.route(request, function (result, status) {
                if (status == 'OK') {
                    directionsDisplay.setOptions({ suppressMarkers: true, preserveViewport: !$scope.resizeMap });
                    directionsDisplay.setDirections(result);
                    //console.log(result);
                    var distance = result.routes[0].legs[0].distance.text;
                    var duration = result.routes[0].legs[0].duration.text;
                    $scope.routeDistance = distance;
                    $scope.routeDuration = duration;
                    $scope.$apply();

                    $scope.resizeMap = false;
                }
            });
        }

        $scope.refreshEstimation = function () {
            calcRoute(workCenterMarker.position, orderMarker.position);
        }

        var orderMarker = null;
        var workCenterMarker = null;

        function getWorkOrderInfo() {
            var url = apiUrl + 'api/TurnOffService/GetWorkOrderInfo/';
            $http({
                method: 'GET',
                url: url,
                params: {
                    accountNumber: localStorage.getItem('CurrentAccountNumber')
                }
            }).success(function (result) {

                if (result.Errors && result.Errors.length > 0) {
                    adjustSize();
                    //usSpinnerService.stop('spinner-1');
                    $scope.isRootDetailsVisible = false;
                    return;
                }

                if (result.Data == null || result.Data.length === 0) {
                    adjustSize();
                    directionsDisplay.setDirections({ routes: [] });
                   // usSpinnerService.stop('spinner-1');
                    $scope.isRootDetailsVisible = false;
                    $scope.resizeMap = true;
                    if (orderMarker != null) {
                        orderMarker.setMap(null);
                    }
                    if (workCenterMarker != null) {
                        workCenterMarker.setMap(null);
                    }
                    return;
                }

                var workCenterInfo = result.Data;

                var orderLocation = { lat: workCenterInfo.CurrentWorkOrderLatitude, lng: workCenterInfo.CurrentWorkOrderLongitude };
                var workCenterLocation = { lat: workCenterInfo.Latitude, lng: workCenterInfo.Longitude };

                if (orderMarker == null) {
                    orderMarker = new google.maps.Marker({
                        map: $scope.map,
                        position: orderLocation,
                        title: workCenterInfo.Id
                    });
                    var workOrderIcon = OutagesService.common.getWorkOrderIcon(0);
                    orderMarker.setIcon(workOrderIcon);
                    orderMarker.addListener('click', function () {
                        //workOrderClicked(marker, workCenter);
                    });
                }

                if (workCenterMarker == null) {
                    workCenterMarker = new google.maps.Marker({
                        map: $scope.map,
                        position: workCenterLocation,
                        title: workCenterInfo.Id
                    });

                    var workCenterIcon = OutagesService.common.getWorkCenterIcon(2);
                    workCenterMarker.setIcon(workCenterIcon);
                    workCenterMarker.addListener('click', function () {
                        //workCenterClicked(marker, workCenter);
                    });

                    //getWorkOrderInfoMin();
                }

                if (!$scope.isRootDetailsVisible && workCenterMarker != null && orderMarker!= null ) {
                    orderMarker.setMap($scope.map);
                    orderMarker.setPosition(orderLocation);
                    workCenterMarker.setMap($scope.map);
                    workCenterMarker.setPosition(workCenterLocation);
                    calcRoute(workCenterMarker.position, orderMarker.position);
                }

                $scope.isRootDetailsVisible = true;
                //usSpinnerService.stop('spinner-1');

//                updateWorkCentersPositionstimerId = setInterval(updateWorkCentersPositions, 1000);

            }).error(function () {
                //usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });

        }

        if (!$scope.anonymous) {
            var getWorkOrderInfoInterval = $interval(getWorkOrderInfo, 2000);
        }

        var prevPosition = null;

        function getWorkOrderInfoMin() {
            var url = apiUrl + 'api/TurnOffService/GetWorkOrderInfo/';
            $http({
                method: 'GET',
                url: url,
                params: {
                    accountNumber: localStorage.getItem('CurrentAccountNumber')
                }
            }).success(function (result) {

                if (result.Errors && result.Errors.length > 0) {
                    adjustSize();
                    $scope.isRootDetailsVisible = false;
                    return;
                }

                if (result.Data == null || result.Data.length === 0) {
                    //return;
                    //adjustSize();
                    directionsDisplay.setDirections({ routes: [] });
                    // usSpinnerService.stop('spinner-1');
                    $scope.isRootDetailsVisible = false;
                    $scope.resizeMap = true;
                    if (orderMarker != null) {
                        orderMarker.setMap(null);
                    }
                    if (workCenterMarker != null) {
                        workCenterMarker.setMap(null);
                    }
                    //getWorkOrderInfoInterval = $interval(getWorkOrderInfo, 2000);
                    setTimeout(getWorkOrderInfoMin, 1000);
                    //$interval.cancel(getWorkOrderInfoInterval);
                    return;
                }

                var workCenterInfo = result.Data;
                var workCenterLocation = { lat: workCenterInfo.Latitude, lng: workCenterInfo.Longitude };
                
                if (prevPosition != null) {
                    //
                    workCenterMarker.setPosition(prevPosition);
                    prevPosition = workCenterLocation;
                    moveMarkerAnimation(workCenterMarker, workCenterLocation);
                    //calcRoute(workCenterMarker.position, orderMarker.position);
                }
                else
                {
                    $scope.resizeMap = true;
                    //calcRoute(workCenterMarker.position, orderMarker.position);
                    prevPosition = workCenterLocation;
                    //workCenterMarker.setPosition(workCenterLocation);
                    setTimeout(getWorkOrderInfoMin, 1000);
                }

            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });

        }

        if (!$scope.anonymous) {
                getWorkOrderInfo();
                getWorkOrderInfoMin();
        }
        //$scope.resizeMap = false;
        
        //var getWorkOrderInfoIntervalMin = $interval(getWorkOrderInfoMin, 1000);



        var updateWorkCentersPositions = function () {
            var url = apiUrl + 'api/TurnOffService/GetWorkCenterCoordinates/';
            $scope.workCentersMarkers.forEach(function (workCenterMarker, index) {
                $http({
                    method: 'GET',
                    url: url,
                    params: {
                        id: workCenterMarker.workCenter.Id
                    }
                }).success(function (result) {
                    workCenterMarker.mapMarker.setPosition(new google.maps.LatLng(result.Data.Latitude, result.Data.Longitude));

                    }).error(function () {
                        //clearTimeout(updateWorkCentersPositionstimerId);
                });

                //workCenterMarker.workCenter.Latitude += 0.0001
                //workCenterMarker.mapMarker.setPosition(new google.maps.LatLng(workCenterMarker.workCenter.Latitude, workCenterMarker.workCenter.Longitude));
            })
        }

        var numDeltas = 1000;
        var delay = 4; //milliseconds
        var i = 0;
        var deltaLat;
        var deltaLng;
        var currentLat;
        var currentLong;
        var markerAnimation;

        function moveMarkerAnimation(marker, newPosition) {
            i = 0;
            //var deltaLat = (result[0] - position[0]) / numDeltas;
            //var deltaLng = (result[1] - position[1]) / numDeltas;
            currentLat = marker.position.lat();
            currentLong = marker.position.lng();
            markerAnimation = marker;
            deltaLat = (newPosition.lat - marker.position.lat()) / numDeltas;
            deltaLng = (newPosition.lng - marker.position.lng()) / numDeltas;
            moveMarker();
            //map.setCenter({
            //    lat: marker.position.lat(),
            //    lng: marker.position.lng()
            //})
        }

        function moveMarker() {
            currentLat += deltaLat;
            currentLong += deltaLng;

            //currentLat = 50;
            //currentLong = 50;
            var latlng = new google.maps.LatLng(currentLat, currentLong);
            //marker.setTitle("Latitude:" + position[0] + " | Longitude:" + position[1]);
            markerAnimation.setPosition(latlng);
            if (i != numDeltas) {
                i++;
                setTimeout(moveMarker, delay);
            }
            else
            {
                getWorkOrderInfoMin();
            }
        }

        //var updateWorkCentersPositionsInterval = $interval(updateWorkCentersPositions, 10000);

        $scope.$on("$destroy", function () {
            if (!$scope.anonymous) {
                $interval.cancel(getWorkOrderInfoInterval);
            }
            //$interval.cancel(updateWorkCentersPositionsInterval);
        });

        $scope.closeOutageDetails = function (e) {
            OutagesService.common.closeDetails();
            $scope.selectedOutages = [];
            $scope.selectedOutage = null;

            if (e)
                e.stopPropagation();
        }

        $scope.currentOutage = null;    

        $scope.panelClicked = function (e, outage) {
            e.stopPropagation();
            OutagesService.big.handleClick(outage);
        }
        
        $scope.next = function () {
            OutagesService.small.next();
        }

        $scope.previous = function () {
            OutagesService.small.previous();
        }

        $scope.disablePrevious = function () {
            return OutagesService.small.disablePrevious();
        }

        $scope.disableNext = function () {
            return OutagesService.small.disableNext();
        }

        $scope.addressClicked = function () {
            OutagesService.small.addressClicked();
        }

        function displayDetails(outages) {
            outages = _.sortBy(outages, function (o) { return o.CreatedOn; }).reverse();
            $scope.selectedOutages = outages;
            OutagesService.common.init(outages, function (outage) { $scope.currentOutage = outage; });
            OutagesService.common.displayDetails();
        }

        function loadImagesAndDisplay(selectedOutages, withoutImage) {
            var ids = _.map(withoutImage, function (outage) { return outage.Id });
            var url = apiUrl + 'api/Outages/GetOutageImages/';
            $http({
                method: 'GET',
                url: url,
                params: { 'ids': ids }
            })
                .success(function (result) {
                    if (result.Errors && result.Errors.length > 0) {
                        ModalServiceExt.showServerError();
                        usSpinnerService.stop('spinner-1');
                        return;
                    }

                    if (!result.Data || result.Data.length === 0) {
                        usSpinnerService.stop('spinner-1');
                        displayDetails(selectedOutages);
                        return;
                    }

                    _.each(result.Data, function (data) {
                        var outage = _.find(selectedOutages, { 'Id': data.Id });
                        if (outage)
                            outage.Image = data.Image;
                    });
                    displayDetails(selectedOutages);
                    usSpinnerService.stop('spinner-1');
                })
                .error(function (error) {
                    ModalServiceExt.showServerError();
                    usSpinnerService.stop('spinner-1');
                });
        }

        function markerClicked(marker, outage) {

            usSpinnerService.spin('spinner-1');

            $scope.map.setCenter(marker.getPosition());

            var selectedOutages = _.filter($scope.outages, function (o) {
                return o.Coordinate.Latitude === outage.Coordinate.Latitude && o.Coordinate.Longitude === outage.Coordinate.Longitude;
            });
            var withoutImage = _.where(selectedOutages, { Image: null });
            if (withoutImage.length > 0) {
                loadImagesAndDisplay(selectedOutages, withoutImage);
                return;
            }

            $timeout(function () {
                displayDetails(selectedOutages);
                usSpinnerService.stop('spinner-1');
            }, 100);
        }

        function workCenterClicked(marker, workCenter) {
        }

        google.maps.event.addDomListener(window, "resize", function () {
            var center = $scope.map.getCenter();
            google.maps.event.trigger($scope.map, "resize");
            $scope.map.setCenter(center);
            adjustSize();
        });

        $scope.reportOutage = function () {

            if ($scope.anonymous) {

                ModalServiceExt.showLoginRequired(
                    $scope._t('Login Required'),
                    $scope._t("It's required to log in for reporting an outage"),
                    function () { $state.goToSignInWithRedirectTo('MainLayout.OutageMap') },
                    function () { $state.goTopMenuLayout('SignUp.Step1') });

                return;
            }

            $state.goMainLayout('ReportOutage');
        };

        $scope.getIcon = function (status) {
            return OutagesService.common.getStatusIcon(status);
        }

        function adjustSize() {
            var mapElement = $('#map');
            var contentContainerHeight = $('.y-scrollable').innerHeight();
            var containerOtherElemententsHeight = mapElement[0].getBoundingClientRect().top - $('.y-scrollable')[0].getBoundingClientRect().top;
            var height = contentContainerHeight - containerOtherElemententsHeight - 1;
            mapElement.height(height);
        }
    }]);
'use strict';
var app = angular.module('utilliApp');
app.controller('TurnOffMapController', ['$scope', '$interval', '$state', 'LeftMenuService', 'CommonHeaderService',
    '$http', 'ModalServiceExt', 'usSpinnerService', '$timeout', '$stateParams', 'ServiceProvidersService', 'OutagesService',
    function ($scope, $interval, $state, LeftMenuService, CommonHeaderService,
        $http, ModalServiceExt, usSpinnerService, $timeout, $stateParams, ServiceProvidersService, OutagesService) {
        LeftMenuService.setCurrentTab('TurnOffMap');
        CommonHeaderService.setUpBackButton($scope._t('TurnOff Map'), true);

        $scope.anonymous = $stateParams.anonymous;
        $scope.isRootDetailsVisible = false;

        usSpinnerService.spin('spinner-1');

        var mapOptions = {
            zoom: 8,
            center: new google.maps.LatLng(38.967576, -77.077550),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            }
        }

        $scope.map = new google.maps.Map(document.getElementById('map'), mapOptions);
        adjustSize();
        var geocoder = new google.maps.Geocoder();
        var directionsService = new google.maps.DirectionsService();
        var directionsDisplay = new google.maps.DirectionsRenderer();
        directionsDisplay.setMap($scope.map);

        function calcRoute(start, end) {
            //var start = 'chicago, il';
            //var end = 'st louis, mo';
            var request = {
                origin: start,
                destination: end,
                travelMode: 'DRIVING'
            };
            directionsService.route(request, function (result, status) {
                if (status == 'OK') {
                    directionsDisplay.setDirections(result);
                    console.log(result);
                }
            });
        }

        function calcRouteFromCurrentPosition(end) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    
                    var start = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                    var request = {
                        origin: start,
                        destination: end,
                        travelMode: 'DRIVING'
                    };
                    directionsService.route(request, function (result, status) {
                        if (status == 'OK') {
                            directionsDisplay.setMap($scope.map);
                            directionsDisplay.setOptions({ suppressMarkers: true, preserveViewport: !$scope.resizeMap });
                            directionsDisplay.setDirections(result);
                            var distance = result.routes[0].legs[0].distance.text;
                            var duration = result.routes[0].legs[0].duration.text;
                            $scope.routeDistance = distance;
                            $scope.routeDuration = duration;
                            $scope.$apply();

                            $scope.resizeMap = false;
                        }
                    });

                }, function () {
                    var i = 1;
                    //handleLocationError(true, infoWindow, map.getCenter());
                });
            } else {
                var i = 2;
                // Browser doesn't support Geolocation
                //handleLocationError(false, infoWindow, map.getCenter());
            }
        }

        //calcRoute();

        var apiUrl = '';
        if ($scope.anonymous) {
            ServiceProvidersService.getProviderApiUrl().then(function (result) {
                if (!result) {
                    ModalServiceExt.showServerError();
                    $state.goToSignIn();
                    return;
                }

                apiUrl = result;
                getOutages();
                getWorkCenters();
            },
                function () {
                    ModalServiceExt.showServerError();
                    $state.goToSignIn();
                });
        }
        else {
            apiUrl = localStorage.getItem('ApiUrl');
            getOutages();
            getWorkCenters();
        }

        var currentPositionMarker;

        function updateCurrentPosition() {
            if (currentPositionMarker == undefined) return;
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    currentPositionMarker.setPosition(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
                }, function () {
                    //handleLocationError(true, infoWindow, map.getCenter());
                    var i = 1;
                });
            } else {
                var i = 2;
                // Browser doesn't support Geolocation
                // handleLocationError(false, infoWindow, map.getCenter());
            }
        }

        function setCurrentPosition()
        {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    var pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    $scope.map.setCenter(pos);

                    //currentPositionMarker = new google.maps.Marker({
                    //    map: $scope.map,
                    //    position: pos,
                    //    title: "current position"
                    //});
                    //var icon = OutagesService.common.getWorkCenterIcon(2);
                    //var icon = $scope.getIcon(2);
                    //currentPositionMarker.setIcon(icon);
                    //setInterval(updateCurrentPosition, 1000);

                    //var start = 'chicago, il';

                   // var start = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                    //var start = new google.maps.LatLng(38.967576, -77.077550);
                    //var end = 'st louis, mo';
                    //var request = {
                    //    origin: start,
                    //    destination: end,
                    //    travelMode: 'DRIVING'
                    //};
                    //directionsService.route(request, function (result, status) {
                    //    if (status == 'OK') {
                    //        directionsDisplay.setDirections(result);
                    //    }
                    //});

                }, function () {
                    var i = 1;
                    //handleLocationError(true, infoWindow, map.getCenter());
                });
            } else {
                var i = 2;
                // Browser doesn't support Geolocation
                //handleLocationError(false, infoWindow, map.getCenter());
            }

        }

        setCurrentPosition();
        

        function getOutages() {

            var url = apiUrl + 'api/Outages/GetOutagesForMap/';
            $scope.outages = [];
            $http({
                method: 'GET',
                url: url
            }).success(function (result) {

                if (result.Errors && result.Errors.length > 0) {
                    adjustSize();
                    usSpinnerService.stop('spinner-1');
                    return;
                }

                if (result.Data && result.Data.length === 0) {
                    adjustSize();
                    usSpinnerService.stop('spinner-1');
                    return;
                }

                $scope.outages = result.Data;
                $scope.outages.forEach(function (outage, index) {

                    var location = { lat: outage.Coordinate.Latitude, lng: outage.Coordinate.Longitude };
                    var marker = new google.maps.Marker({
                        map: $scope.map,
                        position: location,
                        title: outage.Location
                    });
                    var icon = $scope.getIcon(outage.Status);
                    marker.setIcon(icon);
                    marker.addListener('click', function () {
                        markerClicked(marker, outage);
                    });

                    if (index === $scope.outages.length - 1) {
                        adjustSize();
                        //$scope.map.setCenter(location);
                        usSpinnerService.stop('spinner-1');
                    }
                });

            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }

        var updateWorkCentersPositionstimerId;

        function getWorkCenters() {

            var url = apiUrl + 'api/TurnOffService/GetWorkCentersForMap/';
            $scope.outages = [];
            $http({
                method: 'GET',
                url: url
            }).success(function (result) {

                if (result.Errors && result.Errors.length > 0) {
                    adjustSize();
                    usSpinnerService.stop('spinner-1');
                    return;
                }

                if (result.Data && result.Data.length === 0) {
                    adjustSize();
                    usSpinnerService.stop('spinner-1');
                    return;
                }

                $scope.workCentersMarkers = [];

                $scope.workCenters = result.Data;

                $scope.workCenters.forEach(function (workCenter, index) {

                    var location = { lat: workCenter.Latitude, lng: workCenter.Longitude };
                    var marker = new google.maps.Marker({
                        map: $scope.map,
                        position: location,
                        title: workCenter.Id
                    });
                    var icon = OutagesService.common.getWorkCenterIcon(2);
                    marker.setIcon(icon);
                    marker.addListener('click', function () {
                        workCentrClicked(marker, workCenter);
                    });
                    $scope.workCentersMarkers.push({ mapMarker: marker, workCenter: workCenter });

                    if (index === $scope.workCenters.length - 1) {
                        adjustSize();
                        //$scope.map.setCenter(location);
                        usSpinnerService.stop('spinner-1');
                    }
                });

                //updateWorkCentersPositionstimerId = setInterval(updateWorkCentersPositions, 1000);
                

            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });

        }

        $scope.resizeMap = true;
        var updateWorkCentersPositions = function () {
            var url = apiUrl + 'api/TurnOffService/GetWorkCenterCoordinates/';
            $scope.workCentersMarkers.forEach(function (workCenterMarker, index) {
                $http({
                    method: 'GET',
                    url: url,
                    params: {
                        id: workCenterMarker.workCenter.Id
                    }
                }).success(function (result) {
                    workCenterMarker.mapMarker.setPosition(new google.maps.LatLng(result.Data.Latitude, result.Data.Longitude));

                    }).error(function () {
                       // clearTimeout(updateWorkCentersPositionstimerId);
                });

                if ($scope.workOrder != null) {
                    calcRouteFromCurrentPosition($scope.workOrder.mapMarker.position);
                }
                //workCenterMarker.workCenter.Latitude += 0.0001
                //workCenterMarker.mapMarker.setPosition(new google.maps.LatLng(workCenterMarker.workCenter.Latitude, workCenterMarker.workCenter.Longitude));
            })
        }

        var updateWorkCentersPositionsInterval = $interval(updateWorkCentersPositions, 10000);

        $scope.$on("$destroy", function () {
            //$interval.cancel(getWorkOrderInfoInterval);
            $interval.cancel(updateWorkCentersPositionsInterval);
        });

        $scope.workOrderSelected = function () {
            workOrderClicked($scope.workOrder);
        }

        $scope.workOrdersMarkers = [];

        function getWorkOrders() {
            usSpinnerService.spin('spinner-1');
            var dataRequest = { centers: '', after:"0", count: 100 };
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/TurnOffService/GetWorkOrdersForMap/',
                method: "GET",
                params: dataRequest
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');

                if (response) {
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showError(response.Errors[0]);
                    } else {

                            

                            $scope.workOrders = response.Data;

                            $scope.workOrders.forEach(function (workOrder, index) {


                                geocoder.geocode({ 'address': workOrder.ServiceAddress }, function (results, status) {

                                    if (status === google.maps.GeocoderStatus.OK) {
                                        var googleLocation = results[0].geometry.location;
                                        var latitude = parseFloat(googleLocation.lat());
                                        var longitude = parseFloat(googleLocation.lng());
                                        var location = { lat:latitude, lng: longitude };
                                        var marker = new google.maps.Marker({
                                            map: $scope.map,
                                            position: location,
                                            title: workOrder.Id
                                        });
                                        var icon = OutagesService.common.getWorkOrderIcon(0);
                                        marker.setIcon(icon);
                                        var workOrderItem = { mapMarker: marker, workOrder: workOrder };
                                        marker.addListener('click', function () {
                                            workOrderClicked(workOrderItem);
                                        });
                                        $scope.workOrdersMarkers.push(workOrderItem);

                                    } else {
                                        usSpinnerService.stop('spinner-admin');
                                        ModalServiceExt.showError($scope._t('Can not get address coordinates.'));
                                    }
                                });
                            });
 
                    }
                } else {
                    ModalServiceExt.showServerError();
                }
            }).error(function () {
                ModalServiceExt.showServerError();
            })['finally'](function () {
                usSpinnerService.stop('spinner-1');
            });
        }

        getWorkOrders();

        $scope.isOrderSelected = false;
        $scope.pickupOrder = function() {
            usSpinnerService.spin('spinner-1');
            if ($scope.workOrder == null) return;
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/TurnOffService/PickupWorkOrder/',
                method: "POST",
                params: {
                    workOrderId: $scope.workOrder.workOrder.Number,
                    workCenterId: 1,
                    workOrderLatitude: $scope.workOrder.mapMarker.position.lat(),
                    workOrderLongitude: $scope.workOrder.mapMarker.position.lng(),
                    workOrderServiceAddress: $scope.workOrder.workOrder.ServiceAddress,
                    contractAccountNumber: $scope.workOrder.workOrder.AccountNumber
                }
            }).success(function (response) {
                    usSpinnerService.stop('spinner-1');
                }).error(function () {
                    usSpinnerService.stop('spinner-1');
                });

            workOrderClicked($scope.workOrder);
            $scope.isOrderSelected = true;
            //$scope.isRootDetailsVisible = true;
        }

        $scope.stopOrder = function () {
            usSpinnerService.spin('spinner-1');
            if ($scope.workOrder == null) return;
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/TurnOffService/StopWorkOrder/',
                method: "POST",
                params: {
                    workCenterId: 1,
                }
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                });

            $scope.workOrder = null;
            //directionsDisplay.setMap(null);
            directionsDisplay.setDirections({ routes: [] });
            $scope.isOrderSelected = false;

            //$scope.isRootDetailsVisible = false;
        }

        function workOrderClicked(workOrderItem) {

            usSpinnerService.spin('spinner-1');
            $scope.resizeMap = true;
            $scope.isRootDetailsVisible = true;
            $scope.workOrder = workOrderItem;
            $scope.map.setCenter(workOrderItem.mapMarker.getPosition());
            calcRouteFromCurrentPosition(workOrderItem.mapMarker.position);
            usSpinnerService.stop('spinner-1');

            //var selectedOutages = _.filter($scope.outages, function (o) {
            //    return o.Coordinate.Latitude === outage.Coordinate.Latitude && o.Coordinate.Longitude === outage.Coordinate.Longitude;
            //});
            //var withoutImage = _.where(selectedOutages, { Image: null });
            //if (withoutImage.length > 0) {
            //    loadImagesAndDisplay(selectedOutages, withoutImage);
            //    return;
            //}

            //$timeout(function () {
            //    displayDetails(selectedOutages);
            //    usSpinnerService.stop('spinner-1');
            //}, 100);
        }

        function workCenterClicked(marker, workCenter) {
        }

        $scope.closeOutageDetails = function (e) {
            OutagesService.common.closeDetails();
            $scope.selectedOutages = [];
            $scope.selectedOutage = null;

            if (e)
                e.stopPropagation();
        }

        $scope.currentOutage = null;    

        $scope.panelClicked = function (e, outage) {
            e.stopPropagation();
            OutagesService.big.handleClick(outage);
        }
        
        $scope.next = function () {
            OutagesService.small.next();
        }

        $scope.previous = function () {
            OutagesService.small.previous();
        }

        $scope.disablePrevious = function () {
            return OutagesService.small.disablePrevious();
        }

        $scope.disableNext = function () {
            return OutagesService.small.disableNext();
        }

        $scope.addressClicked = function () {
            OutagesService.small.addressClicked();
        }

        function displayDetails(outages) {
            outages = _.sortBy(outages, function (o) { return o.CreatedOn; }).reverse();
            $scope.selectedOutages = outages;
            OutagesService.common.init(outages, function (outage) { $scope.currentOutage = outage; });
            OutagesService.common.displayDetails();
        }

        function loadImagesAndDisplay(selectedOutages, withoutImage) {
            var ids = _.map(withoutImage, function (outage) { return outage.Id });
            var url = apiUrl + 'api/Outages/GetOutageImages/';
            $http({
                method: 'GET',
                url: url,
                params: { 'ids': ids }
            })
                .success(function (result) {
                    if (result.Errors && result.Errors.length > 0) {
                        ModalServiceExt.showServerError();
                        usSpinnerService.stop('spinner-1');
                        return;
                    }

                    if (!result.Data || result.Data.length === 0) {
                        usSpinnerService.stop('spinner-1');
                        displayDetails(selectedOutages);
                        return;
                    }

                    _.each(result.Data, function (data) {
                        var outage = _.find(selectedOutages, { 'Id': data.Id });
                        if (outage)
                            outage.Image = data.Image;
                    });
                    displayDetails(selectedOutages);
                    usSpinnerService.stop('spinner-1');
                })
                .error(function (error) {
                    ModalServiceExt.showServerError();
                    usSpinnerService.stop('spinner-1');
                });
        }

        function markerClicked(marker, outage) {

            usSpinnerService.spin('spinner-1');
            $scope.isRootDetailsVisible = true;
            $scope.workOrder = null;
            $scope.map.setCenter(marker.getPosition());
            calcRouteFromCurrentPosition(new google.maps.LatLng(outage.Coordinate.Latitude, outage.Coordinate.Longitude));

            var selectedOutages = _.filter($scope.outages, function (o) {
                return o.Coordinate.Latitude === outage.Coordinate.Latitude && o.Coordinate.Longitude === outage.Coordinate.Longitude;
            });
            var withoutImage = _.where(selectedOutages, { Image: null });
            if (withoutImage.length > 0) {
                loadImagesAndDisplay(selectedOutages, withoutImage);
                return;
            }

            $timeout(function () {
                displayDetails(selectedOutages);
                usSpinnerService.stop('spinner-1');
            }, 100);
        }

        function workCenterClicked(marker, workCenter) {
        }

        google.maps.event.addDomListener(window, "resize", function () {
            var center = $scope.map.getCenter();
            google.maps.event.trigger($scope.map, "resize");
            //$scope.map.setCenter(center);
            adjustSize();
        });

        $scope.reportOutage = function () {

            if ($scope.anonymous) {

                ModalServiceExt.showLoginRequired(
                    $scope._t('Login Required'),
                    $scope._t("It's required to log in for reporting an outage"),
                    function () { $state.goToSignInWithRedirectTo('MainLayout.OutageMap') },
                    function () { $state.goTopMenuLayout('SignUp.Step1') });

                return;
            }

            $state.goMainLayout('ReportOutage');
        };

        $scope.getIcon = function (status) {
            return OutagesService.common.getStatusIcon(status);
        }

        function adjustSize() {
            var mapElement = $('#map');
            var contentContainerHeight = $('.y-scrollable').innerHeight();
            var containerOtherElemententsHeight = mapElement[0].getBoundingClientRect().top - $('.y-scrollable')[0].getBoundingClientRect().top;
            var height = contentContainerHeight - containerOtherElemententsHeight - 1;
            mapElement.height(height);
        }
    }]);
'use strict';
var app = angular.module('utilliApp');
app.controller('ReportOutageController', ['$scope', '$state', '$stateParams', 'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt',
    'usSpinnerService', 'GetAccountsService', '$http', 'outageReportDataService', 'outageMyLocationService', '$timeout',
    function ($scope, $state, $stateParams, LeftMenuService, CommonHeaderService, ModalServiceExt,
        usSpinnerService, GetAccountsService, $http, outageReportDataService, outageMyLocationService, $timeout) {

        LeftMenuService.show();
        CommonHeaderService.setUpBackButton($scope._t('Report Outage'));
        LeftMenuService.setCurrentTab('ReportOutage');
        $scope.isLocationServiceTurnOff = false;
        $scope.isMobileOrRipple = isMobileOrRipple();
        $scope.data = outageReportDataService.getEmptyData();
        $scope.errors = $scope.data.errors;

        if($scope.isMobileOrRipple)
            cordova.plugins.locationAccuracy.canRequest(function(canRequest){
                $scope.isLocationServiceTurnOff = canRequest;
            });

         function getUtillityTypes() {
             return [
                 { val: 'Street Light', translated: $scope._t('Street Light') },
                 { val: 'Fire Hydrant', translated: $scope._t('Fire Hydrant') },
                 { val: 'Sewer', translated: $scope._t('Sewer') },
                 { val: 'Gas', translated: $scope._t('Gas') },
                 { val: 'Water', translated: $scope._t('Water') },
                 { val: 'Electricity', translated: $scope._t('Electricity') },
                 { val: 'Other', translated: $scope._t('Other') }
             ];
         };

         function getCurrentUtillityType() {

             var utillityTypes = getUtillityTypes();
             var utilliType = localStorage.getItem('CurrentUtilityType');
             if (utilliType) {
                 var currentType = _.find(utillityTypes, function (type) { return type.val === utilliType; });
                 return currentType;
             }

             return utillityTypes[0];
         }

         $scope.utillityTypes = getUtillityTypes();
         $scope.selectedUtillityType = getCurrentUtillityType();

         $scope.locations = [];
         $scope.selectedLocation = '';

         usSpinnerService.spin('spinner-1');
         GetAccountsService.getAccounts(true).then(function (response) {

             usSpinnerService.stop('spinner-1');

             if (response.Errors && response.Errors.length > 0) {
                 ModalServiceExt.showError(response.Errors[0].Message);
                 return;
             }

             response.Accounts.forEach(function(account) {
                 var accountAddress = { accountNumber: account.AccountNumber, serviceAddress: account.ServiceAddress, state: 'ServiceAddress' };
                 $scope.locations.push(accountAddress);
                 if (account.IsDefault)
                     $scope.selectedLocation = accountAddress;
             });

             $scope.locations.push({ accountNumber: null, serviceAddress: $scope._t('Nearby Address'), state: 'NearbyAddress' });
             $scope.locations.push({ accountNumber: null, serviceAddress: $scope._t('Nearby Cross Street'), state: 'NearbyCrossStreet' });
             $scope.locations.push({ accountNumber: null, serviceAddress: $scope._t('My Location'), state: 'MyLocation' });
         }).catch(function (e) {
             usSpinnerService.stop('spinner-1');
             console.log(e);
         });

         $scope.$watch('image', function () {
             if ($scope.image === $scope.data.image)
                 return;

             if (!$scope.image) {
                 $scope.data.image = null;
                 return;
             }

             var reader = new FileReader();
             reader.onload = function (loadEvent) {
                 $scope.data.image = loadEvent.target.result;
                 var container = $('#imageContainer' + $scope.selectedLocation.state);
                 container.css('background-image', 'url(' + $scope.data.image + ')');
             }
             reader.readAsDataURL($scope.image);
         });

        $scope.setCurrentLocation = function (notCached) { 
            usSpinnerService.spin('spinner-1');
                if($scope.map && !notCached){
                    usSpinnerService.stop('spinner-1'); 
                    return;
                }
                if($scope.isMobileOrRipple)
                    cordova.plugins.locationAccuracy.canRequest(function(canRequest){
                        $scope.isLocationServiceTurnOff = canRequest;
                    });
                 $timeout(function () {// $timeout - to fix issue related to google maps (it doesn't appear)
                    $scope.map = outageMyLocationService.getMap('myLocationMap');
                    outageMyLocationService.setCurrentLocation($scope.map, $scope.data, function (rejected) { 
                        $timeout(function () { // $timeout - to smooth location changing    
                            if(rejected) //because cordova.plugins.locationAccuracy.canRequest always return true for android (v2.2.1) 
                            {
                                usSpinnerService.stop('spinner-1'); 
                                $scope.isLocationServiceTurnOff = true;
                                $scope.$apply();
                            }
                            else
                                if($scope.isMobileOrRipple){
                                    cordova.plugins.locationAccuracy.canRequest(function(canRequest){
                                        usSpinnerService.stop('spinner-1'); 
                                        $scope.isLocationServiceTurnOff = isAndroid() ? !canRequest : canRequest;
                                        $scope.$apply();
                                    });
                                }
                                else {
                                    usSpinnerService.stop('spinner-1'); 
                                }
                            }, 500);
                    });
                }, 0);
        }

         $scope.locationChanged = function () {
             $scope.data.clear();
             $scope.image = null;
             $scope.data.clearErrors();

             if (!$scope.selectedLocation)
                 return;

             if ($scope.selectedLocation.state === 'MyLocation')
                 $scope.setCurrentLocation();
         }

         function validateServiceAddress() {
             if (!$scope.data.problemDescription) {
                 $scope.data.errors.descriptionEmptyError = true;
                 return false;
             }

             return true;
         }

         function validateNearbyAddress() {
             var isValid = true;

             if (!$scope.data.houseNumber) {
                 $scope.data.errors.houseNumberEmptyError = true;
                isValid = false;
            }

             if (!$scope.data.street) {
                 $scope.data.errors.streetEmptyError = true;
                isValid = false;
            }

            var regexp;
            var matched;
            if (!$scope.data.city) {
                $scope.data.errors.cityEmptyError = true;
                isValid = false;
            } else {
                regexp = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;
                matched = regexp.test($scope.data.city);
                if (!matched) {
                    $scope.data.errors.invalidCityError = true;
                    isValid = false;
                }
            }

            if (!$scope.data.state) {
                $scope.data.errors.stateEmptyError = true;
                isValid = false;
            } else {
                regexp = /^[a-zA-Z]{2}$/;
                matched = regexp.test($scope.data.state);
                if (!matched) {
                    $scope.data.errors.invalidStateError = true;
                    isValid = false;
                }
            }

            if (!$scope.data.zip) {
                $scope.data.errors.zipEmptyError = true;
                isValid = false;
            } else {
                regexp = /^(\d{5})?$|^$|^(\d{5}-\d{4})?$/;
                matched = regexp.test($scope.data.zip);
                if (!matched) {
                    $scope.data.errors.invalidZipError = true;
                    isValid = false;
                }
            }

            if (!$scope.data.problemDescription) {
                $scope.data.errors.descriptionEmptyError = true;
                isValid = false;
            }

            return isValid;
         }

         function validateNearbyCrossStreet() {
             var isValid = true;

             if (!$scope.data.street || !$scope.data.street2) {
                 $scope.data.errors.streetEmptyError = true;
                 isValid = false;
             }

             var regexp;
             var matched;
             if (!$scope.data.city) {
                 $scope.data.errors.cityEmptyError = true;
                 isValid = false;
             } else {
                 regexp = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;
                 matched = regexp.test($scope.data.city);
                 if (!matched) {
                     $scope.data.errors.invalidCityError = true;
                     isValid = false;
                 }
             }

             if (!$scope.data.state) {
                 $scope.data.errors.stateEmptyError = true;
                 isValid = false;
             } else {
                 regexp = /^[a-zA-Z]{2}$/;
                 matched = regexp.test($scope.data.state);
                 if (!matched) {
                     $scope.data.errors.invalidStateError = true;
                     isValid = false;
                 }
             }

             if (!$scope.data.zip) {
                 $scope.data.errors.zipEmptyError = true;
                 isValid = false;
             } else {
                 regexp = /^(\d{5})?$|^$|^(\d{5}-\d{4})?$/;
                 matched = regexp.test($scope.data.zip);
                 if (!matched) {
                     $scope.data.errors.invalidZipError = true;
                     isValid = false;
                 }
             }

             if (!$scope.data.problemDescription) {
                 $scope.data.errors.descriptionEmptyError = true;
                 isValid = false;
             }

             return isValid;
         }

         function validateMyLocation() {
             var isValid = true;

             if (!$scope.data.lat || !$scope.data.lng) {
                 $scope.data.errors.wrongLocation = true;
                 isValid = false;
             }

             if (!$scope.data.problemDescription) {
                 $scope.data.errors.descriptionEmptyError = true;
                 isValid = false;
             }

             return isValid;
         }

         function validate() {
             if (!$scope.selectedLocation)
                 return false;

             if ($scope.selectedLocation.state === $scope._t('ServiceAddress'))
                 return validateServiceAddress();
             else if ($scope.selectedLocation.state === $scope._t('NearbyAddress'))
                 return validateNearbyAddress();
             else if ($scope.selectedLocation.state === $scope._t('NearbyCrossStreet'))
                 return validateNearbyCrossStreet();
             else
                 return validateMyLocation();
         }

         function clearErrors() {
             $scope.data.clearErrors();
         }

        function isServiceAddressSelected() {
            return $scope.selectedLocation.state === 'ServiceAddress';
        }

        function isNearbyAddressSelected() {
            return $scope.selectedLocation.state === 'NearbyAddress';
        }

        function isNearbyCrossStreetSelected() {
            return $scope.selectedLocation.state === 'NearbyCrossStreet';
        }

        function isMyLocationSelected() {
            return $scope.selectedLocation.state === 'MyLocation';
        }

        function collectDataAndSend() {
            usSpinnerService.spin('spinner-1');

            var geocoder = new google.maps.Geocoder();
            if (isMyLocationSelected()) {
                var geoLocation = {
                    Latitude: $scope.data.lat,
                    Longitude: $scope.data.lng
                };
                var data = {
                    UtillityType: $scope.selectedUtillityType.val,
                    OutageLocation: $scope.selectedLocation.state,
                    ContractAccount: null,
                    Description: $scope.data.problemDescription,
                    Address: null,
                    Coordinate: geoLocation,
                    Image: $scope.data.image
                }
                // https://developers.google.com/maps/documentation/javascript/examples/geocoding-reverse
                var latlng = {lat: geoLocation.Latitude, lng: geoLocation.Longitude};
                geocoder.geocode({'location': latlng}, function(results, status) {
                    if (status === 'OK') {
                        if (results[0]) {
                            function getAddressComponent(address_components, type){
                                return _.find(address_components, function (component) { 
                                    return _.any(component.types, function (t) { return t == type; } ); 
                                }).long_name;
                            }
                            var street_number = getAddressComponent(results[0].address_components, "street_number");
                            var route = getAddressComponent(results[0].address_components, "route");
                            var locality = getAddressComponent(results[0].address_components, "locality");
                            var postal_code = getAddressComponent(results[0].address_components, "postal_code");
                            var administrative_area_level_1 = getAddressComponent(results[0].address_components, "administrative_area_level_1");
                            data.Address = {
                                HouseNumber: street_number,
                                AddressLine: route,
                                City: locality,
                                State: administrative_area_level_1,
                                Zip: postal_code
                            };
                            sendReport(data);
                        } else {
                            usSpinnerService.stop('spinner-1');
                            ModalServiceExt.showError($scope._t('No results found.'));
                        }
                    } else {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showError($scope._t('Cannot get address by coordinates.'));
                    }
                  });
            } else {
                var position = '';
                var address = null;
                if (isServiceAddressSelected()) {
                    position = $scope.selectedLocation.serviceAddress;
                } else {
                    position = $scope.data.getPosition($scope.selectedLocation.state);
                    address = $scope.data.getAddress($scope.selectedLocation.state);
                }

                geocoder.geocode({ 'address': position }, function (results, status) {

                    if (status === google.maps.GeocoderStatus.OK) {
                        var googleLocation = results[0].geometry.location;
                        var latitude = parseFloat(googleLocation.lat());
                        var longitude = parseFloat(googleLocation.lng());
                        var geoLocation = { Latitude: latitude, Longitude: longitude };

                        var data = {
                            UtillityType: $scope.selectedUtillityType.val,
                            OutageLocation: $scope.selectedLocation.state,
                            ContractAccount: $scope.selectedLocation.accountNumber,
                            Description: $scope.data.problemDescription,
                            Address: address,
                            Coordinate: geoLocation,
                            Image: $scope.data.image
                        }
                        sendReport(data);
                    } else {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showError($scope._t('Can not get address coordinates.'));
                    }
                });
            }
         }

        $scope.report = function () {
            clearErrors();

            if (!validate())
                return;

            collectDataAndSend();
         };

         function sendReport(data) {
             var url = localStorage.getItem('ApiUrl') + 'api/Outages/CreateOutageReport/';

             $http({
                 method: 'POST',
                 url: url,
                 data: data
             })
             .success(function (result) {

                 usSpinnerService.stop('spinner-1');

                 if (result.Errors && result.Errors.length > 0) {
                     ModalServiceExt.showError(result.Errors[0]);
                     return;
                 }

                 ModalServiceExt.showInfo(
                     $scope._t('Outage was successfully reported.'),
                     function() {
                         $scope.data.clear();
                         $state.goMainLayout('OutageMap');
                     });
             })
             .error(function (error) {
                 usSpinnerService.stop('spinner-1');
                 ModalServiceExt.showError(error);
             });
         };

         $scope.back = function () {
             $state.goMainLayout('OutageMap');
         };

     }])
.directive("fileUpload", [function () {
    return {
        scope: {
            fileUpload: '='
        },
        link: function (scope, element, attributes) {
            element.bind("change", function (changeEvent) {
                scope.$apply(function () {
                    scope.fileUpload = changeEvent.target.files[0];
                });
            });
        }
    }
}]);

'use strict';
angular.module('utilliApp')
    .service('outageReportDataService', function () {

        function getReportData(report) {
            var data = this.getEmptyData();
            if (report.Address) {
                data.houseNumber = report.Address.HouseNumber;
                data.street = report.Address.AddressLine;
                data.street2 = report.Address.AddressLine2;
                data.city = report.Address.City;
                data.state = report.Address.State;
                data.zip = report.Address.Zip;
            }

            if (report.Coordinate) {
                data.lat = report.Coordinate.Latitude;
                data.lng = report.Coordinate.Longitude;
            }

            data.problemDescription = report.Description;
            data.image = report.Image;
            data.contractAccount = report.ContractAccount;
            return data;
        }

        function getEmptyData() {
            return {
                houseNumber: '',
                street: '',
                street2: '',
                city: '',
                state: '',
                zip: '',
                problemDescription: '',
                image: null,
                contractAccount: '',
                lat: 0,
                lng: 0,
                getPosition: function (location) {
                    if (location === 'NearbyAddress') {
                        return this.houseNumber + ' ' + this.street + ' ' + this.city + ' ' + this.state + ' ' + this.zip;
                    } else if (location === 'NearbyCrossStreet') {
                        // to get geocode for cross street we should use request format: [StreetName A & StreetName B, City].
                        // http://www.nodalbits.com/bits/google-maps-intersections/
                        return this.street + ' & ' + this.street2 + ', ' + this.city + ' ' + this.state + ' ' + this.zip;
                    } else return '';
                },
                getAddress: function (location) {
                    if (location === 'NearbyAddress') {
                        return {
                            HouseNumber: this.houseNumber,
                            HouseNoSupplement: this.unit,
                            AddressLine: this.street,
                            City: this.city,
                            State: this.state,
                            Zip: this.zip
                        }
                    } else if (location === 'NearbyCrossStreet') {
                        return {
                            AddressLine: this.street,
                            AddressLine2: this.street2,
                            City: this.city,
                            State: this.state,
                            Zip: this.zip
                        }
                    } else return null;
                },
                clear: function () {
                    this.houseNumber = '';
                    this.street = '';
                    this.street2 = '';
                    this.city = '';
                    this.state = '';
                    this.zip = '';
                    this.problemDescription = '';
                    this.image = null;
                    this.contractAccount = '';
                    this.lat = 0;
                    this.lng = 0;
                },
                clearExcept: function (location) {
                    if (location === 'ServiceAddress') {
                        this.houseNumber = '';
                        this.street = '';
                        this.street2 = '';
                        this.city = '';
                        this.state = '';
                        this.zip = '';
                        this.lat = 0;
                        this.lng = 0;
                    } else if (location === 'NearbyAddress') {
                        this.street2 = '';
                        this.contractAccount = '';
                        this.lat = 0;
                        this.lng = 0;
                    } else if (location === 'NearbyCrossStreet') {
                        this.houseNumber = '';
                        this.contractAccount = '';
                        this.lat = 0;
                        this.lng = 0;
                    } else {
                        this.houseNumber = '';
                        this.street = '';
                        this.street2 = '';
                        this.city = '';
                        this.state = '';
                        this.zip = '';
                        this.contractAccount = '';
                    }
                },
                errors: {
                    houseNumberEmptyError: false,
                    streetEmptyError: false,
                    cityEmptyError: false,
                    invalidCityError: false,
                    stateEmptyError: false,
                    invalidStateError: false,
                    zipEmptyError: false,
                    invalidZipError: false,
                    descriptionEmptyError: false,
                    wrongLocation: false
                },
                clearErrors: function () {
                    this.errors.houseNumberEmptyError = false;
                    this.errors.streetEmptyError = false;
                    this.errors.cityEmptyError = false;
                    this.errors.invalidCityError = false;
                    this.errors.stateEmptyError = false;
                    this.errors.invalidStateError = false;
                    this.errors.zipEmptyError = false;
                    this.errors.invalidZipError = false;
                    this.errors.descriptionEmptyError = false;
                    this.errors.wrongLocation = false;
                }
            }
        }

        return {
            getEmptyData: getEmptyData,
            getReportData: getReportData
        }
    });
'use strict';
angular.module('utilliApp')
    .service('outageMyLocationService', ['ModalServiceExt', 'usSpinnerService', function (ModalServiceExt, usSpinnerService) {

        function getMap(elementId) {
            var mapOptions = {
                zoom: 15,
                center: new google.maps.LatLng(38.967576, -77.077550),//Chevy Chase, Bethesda
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                streetViewControl: false,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                }
            }

            return new google.maps.Map(document.getElementById(elementId), mapOptions);
        }

        function setLocation(googleMap, lat, lng) {
            var latLng = new google.maps.LatLng(lat, lng);
            new google.maps.Marker({
                map: googleMap,
                position: latLng
            });
            googleMap.setCenter(latLng);
        }

        function setCurrentLocation(googleMap, data, fnCallback) {
            navigator.geolocation.getCurrentPosition(function (location) {
                var latLng = new google.maps.LatLng(location.coords.latitude, location.coords.longitude);
                new google.maps.Marker({
                    map: googleMap,
                    position: latLng
                });
                googleMap.setCenter(latLng);
                data.lat = latLng.lat();
                data.lng = latLng.lng();
                if(fnCallback)
                    fnCallback();
            }, function (error) {
                if(fnCallback)
                    fnCallback();
                console.log(error);
                if(error.code == 1)
                    ModalServiceExt.showError(utilli._t('Permission denied.'));
                else if(error.code == 3)
                    ModalServiceExt.showError(utilli._t('Position retrieval timed out (30 seconds). Please try later again.'));
                else
                    ModalServiceExt.showError(utilli._t('Can not get current position. Please try later again.'));
            },
            {
                maximumAge: 0,
                // timeout is mandatory here. otherwise error function will not be called in case an error.
                timeout: 30000,
                enableHighAccuracy: true
            });
        }

        document.addEventListener("resume", onResume, false);
        function onResume() {
            if(isAndroid()){
                localStorage.removeItem("lastLocationServiceStatus");
                return;
            }
            setTimeout(function() {
                handleNewLocationServiceStatus();
            }, 0);
        }

        function handleNewLocationServiceStatus () {
            if(utilli.localStorageItemNotNull("lastLocationServiceStatus"))
                {
                    var lastStatus = localStorage.getItem("lastLocationServiceStatus");
                    var turnOnStatus = "0";
                    cordova.plugins.locationAccuracy.canRequest(function(canRequest){
                        if(lastStatus != turnOnStatus && canRequest.toString() != lastStatus){
                            var reportOutageControllerScope = angular.element(document.getElementById('selectedLocation')).scope();
                            reportOutageControllerScope.setCurrentLocation(true);
                        }
                        localStorage.removeItem("lastLocationServiceStatus")
                    });
                } 
        }

        function requestAcuracyAndSetPosition(googleMap, data, fnCallback) {
            if (isMobileOrRipple()) {
                function onRequestSuccess(success) {
                    if(isAndroid())
                        setCurrentLocation(googleMap, data, fnCallback);
                    else if(fnCallback)
                        fnCallback();
                    console.log("Location request successful");
                }

                function onRequestFailure(error) {
                    console.error("Request failed");
                    if (error && error.code !== cordova.plugins.locationAccuracy.ERROR_USER_DISAGREED) {
                        // Android only
                        console.error("error code="+error.code+"; error message="+error.message);
                        if (window.confirm(utilli._t("Failed to set current location. Would you like to switch on Geolocation Service manually?"))) {
                            cordova.plugins.diagnostic.switchToLocationSettings();
                        }
                    }
                    if(fnCallback)
                        fnCallback(true);
                }

                cordova.plugins.locationAccuracy.canRequest(function(canRequest) {
                    if(canRequest){
                        localStorage.setItem("lastLocationServiceStatus", canRequest);
                        // this plugin check device's geolocation service is on. if not - ask the user to switch it on in the native popup.
                        cordova.plugins.locationAccuracy.request(
                            onRequestSuccess,
                            onRequestFailure,
                            cordova.plugins.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY);
                    }
                    else {
                        setCurrentLocation(googleMap, data, fnCallback);
                    }
                });

            } else {
                setCurrentLocation(googleMap, data, fnCallback);
            }
        }

        return {
            getMap: getMap,
            setCurrentLocation: requestAcuracyAndSetPosition,
            setLocation: setLocation
        }
    }]);
'use strict';
var app = angular.module('utilliApp');
app.controller('OutageListController',
['$scope', '$state', 'LeftMenuService', 'CommonHeaderService', '$http', 'ModalServiceExt', 'usSpinnerService', 'GridService', '$stateParams', 'ServiceProvidersService',
    function ($scope, $state, LeftMenuService, CommonHeaderService, $http, ModalServiceExt, usSpinnerService, GridService, $stateParams, ServiceProvidersService) {

        CommonHeaderService.setUpBackButton($scope._t('Outage List'), true);
        LeftMenuService.setCurrentTab('OutageList');

        $scope.getScrollContainer = function () {
            return $state.includes('TopMenuLayout') ? '#screen' : '#panel';
        }

        $scope.outages = [];
        $scope.scrollInProcess = false;
        $scope.listFinished = false;
        var pageSize = 20;
        var apiUrl = '';

        $scope.getOutages = function () {
            
            usSpinnerService.spin("spinner-1");

            if ($stateParams.anonymous) {
                ServiceProvidersService.getProviderApiUrl().then(function (result) {
                    if (!result) {
                        usSpinnerService.stop("spinner-1");
                        ModalServiceExt.showServerError();
                        $state.goToSignIn();
                        return;
                    }

                    apiUrl = result;
                    getOutagesInternal();
                },
                function () {
                    usSpinnerService.stop("spinner-1");
                    ModalServiceExt.showServerError();
                    $state.goToSignIn();
                });
            }
            else {
                apiUrl = localStorage.getItem('ApiUrl');
                getOutagesInternal();
            }
            
        }

        function getOutagesInternal() {

            if ($scope.scrollInProcess) {
                usSpinnerService.stop("spinner-1");
                return;
            }

            $scope.scrollInProcess = true;

            var dataRequest = {
                skip: $scope.outages.length,
                pageSize: pageSize
            };

            $http({
                method: 'GET',
                url: apiUrl + 'api/Outages/GetOutagesPageable',
                params: dataRequest
            })
            .success(function (result) {

                usSpinnerService.stop("spinner-1");

                if (result.Errors && result.Errors.length > 0) {
                    $scope.scrollInProcess = false;
                    ModalServiceExt.showError(result.Errors[0]);
                    return;
                }

                Array.prototype.push.apply($scope.outages, result.Data);

                if (result.Data.length < pageSize)
                    $scope.listFinished = true;

                $scope.scrollInProcess = false;
            })
            .error(function (error) {
                usSpinnerService.stop("spinner-1");
                $scope.scrollInProcess = false;
                ModalServiceExt.showServerError();
            });
        }

        $scope.view = function(id) {
            if ($stateParams.anonymous)
                $state.go('TopMenuLayout.OpenOutageReport', { Id: id, mode: 'view', anonymous: true });
            else
                $state.goMainLayout('OpenOutageReport', { Id: id, mode: 'view' });
        }
}]);
'use strict';
var app = angular.module('utilliApp');
app.controller('OutageListGridController',
['$scope', '$state', 'LeftMenuService', 'CommonHeaderService', '$http', 'ModalServiceExt', 'usSpinnerService', 'GridService', '$stateParams', 'ServiceProvidersService',
    function ($scope, $state, LeftMenuService, CommonHeaderService, $http, ModalServiceExt, usSpinnerService, GridService, $stateParams, ServiceProvidersService) {

        LeftMenuService.setCurrentTab('OutageList');
        CommonHeaderService.setUpBackButton($scope._t('Outage List'), true);

        var gridResizeFunc = GridService.getGridResizeFunc($("#outagesGrid"));
        $(window).resize(function () {
            gridResizeFunc($scope.outagesKendoGrid);
        });

        var apiUrl = '';
        if ($stateParams.anonymous) {
            ServiceProvidersService.getProviderApiUrl().then(function (result) {
                if (!result) {
                    ModalServiceExt.showServerError();
                    $state.goToSignIn();
                    return;
                }

                apiUrl = result;
                setupGridOptions();
            },
            function () {
                ModalServiceExt.showServerError();
                $state.goToSignIn();
            });
        }
        else {
            apiUrl = localStorage.getItem('ApiUrl');
            setupGridOptions();
        }

        function setupGridOptions() {
            $scope.gridOptions = {
                dataSource: {
                    transport: {
                        read: function (options) {
                            var webapi = new kendo.data.transports.webapi({ prefix: "" });
                            var params = webapi.parameterMap(options.data);
                            var url = apiUrl + 'api/Outages/GetOutagesPageable';
                            $http.get(url, { params: params })
                                .success(function (data) {
                                    options.success(data);
                                    gridResizeFunc($scope.outagesKendoGrid);
                                })
                                .error(function () {
                                    options.error();
                                });
                        }
                    },
                    schema: { data: "Data.PageData", total: "Data.Count" },
                    pageSize: 10,
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true
                },
                resizable: true,
                sortable: false,
                filterable: false,
                pageable: {
                    pageSize: 25,
                    pageSizes: [10, 25, 50],
                    buttonCount: 3,
                    refresh: true
                },
                dataBound: function () { gridResizeFunc($scope.outagesKendoGrid); },
                columns: [
                    {
                        field: "Location",
                        title: $scope._t('Address'),
                        width: 100
                    }, {
                        field: "Date",
                        title: $scope._t('Created On'),
                        template: "#= DisplayedCreatedOn #",
                        width: 100
                    }, {
                        field: "StatusDisplayingName",
                        title: $scope._t('Status'),
                        width: 70
                    }, {
                        field: "UtillityType",
                        title: $scope._t('Type'),
                        width: 40
                    }, {
                        title: $scope._t('Actions'),
                        template: kendo.template($("#commands-template").html()),
                        width: "50px"
                    }
                ]
            }
        }

        $scope.resizeGrid = function () {
            // timeout because grid size calculation should happen after action collapse finish it's animation
            setTimeout(function () {
                gridResizeFunc($scope.outagesKendoGrid);
            }, 1);
        };

        $scope.view = function (id) {
            if ($stateParams.anonymous)
                $state.go('TopMenuLayout.OpenOutageReport', { Id: id, mode: 'view', anonymous: true });
            else
                $state.goMainLayout('OpenOutageReport', { Id: id, mode: 'view' });
        };
    }]);
'use strict';
var app = angular.module('utilliApp');
app.controller('OutageHistoryController',
['$scope', '$state', 'LeftMenuService', 'CommonHeaderService', '$http', 'ModalServiceExt', 'usSpinnerService', 'GridService', '$stateParams', 'ServiceProvidersService',
    function ($scope, $state, LeftMenuService, CommonHeaderService, $http, ModalServiceExt, usSpinnerService, GridService, $stateParams, ServiceProvidersService) {

        LeftMenuService.setCurrentTab('OutageCenter');
        CommonHeaderService.setUpBackButton($scope._t('Outage List'), true);

        usSpinnerService.spin("spinner-1");

        $scope.outages = [];
        $scope.scrollInProcess = false;
        $scope.listFinished = false;
        var pageSize = 20;
        var apiUrl = '';

        $scope.getOutages = function () {

            usSpinnerService.spin("spinner-1");

            if ($stateParams.anonymous) {
                ServiceProvidersService.getProviderApiUrl().then(function (result) {
                    if (!result) {
                        usSpinnerService.stop("spinner-1");
                        ModalServiceExt.showServerError();
                        $state.goToSignIn();
                        return;
                    }

                    apiUrl = result;
                    getOutagesInternal();
                },
                function () {
                    usSpinnerService.stop("spinner-1");
                    ModalServiceExt.showServerError();
                    $state.goToSignIn();
                });
            }
            else {
                apiUrl = localStorage.getItem('ApiUrl');
                getOutagesInternal();
            }

        }

        function getOutagesInternal() {

            if ($scope.scrollInProcess) {
                usSpinnerService.stop("spinner-1");
                return;
            }

            $scope.scrollInProcess = true;

            var dataRequest = {
                userName: utilli.getCurrentUserName(),
                skip: $scope.outages.length,
                pageSize: pageSize
            };

            $http({
                method: 'GET',
                url: apiUrl + 'api/Outages/GetOutagesHistory',
                params: dataRequest
            })
            .success(function (result) {

                usSpinnerService.stop("spinner-1");

                if (result.Errors && result.Errors.length > 0) {
                    $scope.scrollInProcess = false;
                    ModalServiceExt.showError(result.Errors[0]);
                    return;
                }

                Array.prototype.push.apply($scope.outages, result.Data);

                if (result.Data.length < pageSize)
                    $scope.listFinished = true;

                $scope.scrollInProcess = false;
            })
            .error(function (error) {
                usSpinnerService.stop("spinner-1");
                $scope.scrollInProcess = false;
                ModalServiceExt.showServerError();
            });
        }

        $scope.edit = function (id) {
            $state.goMainLayout('OpenOutageReport', { Id: id, mode: 'edit' });
        }
    }]);
'use strict';
var app = angular.module('utilliApp');
app.controller('OutageHistoryGridController',
['$scope', '$state', 'LeftMenuService', 'CommonHeaderService', '$http', 'ModalServiceExt', 'usSpinnerService', 'GridService',
    function ($scope, $state, LeftMenuService, CommonHeaderService, $http, ModalServiceExt, usSpinnerService, GridService) {

        LeftMenuService.setCurrentTab('OutageCenter');
        CommonHeaderService.setUpBackButton($scope._t('Outage History'), true);

        var gridResizeFunc = GridService.getGridResizeFunc($("#outagesGrid"));
        $(window)
            .resize(function () {
                gridResizeFunc($scope.outagesKendoGrid);
            });

        var apiUrl = localStorage.getItem('ApiUrl');

        $scope.gridOptions = {
            dataSource: {
                transport: {
                    read: function (options) {
                        var webapi = new kendo.data.transports.webapi({ prefix: "" });
                        var params = webapi.parameterMap(options.data);
                        params.userName = utilli.getCurrentUserName();
                        var url = apiUrl + 'api/Outages/GetOutagesHistory';
                        $http.get(url, { params: params })
                            .success(function (data) {
                                options.success(data);
                                gridResizeFunc($scope.outagesKendoGrid);
                            })
                            .error(function () {
                                options.error();
                            });
                    }
                },
                schema: { data: "Data.PageData", total: "Data.Count" },
                pageSize: 10,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true
            },
            resizable: true,
            sortable: false,
            filterable: false,
            pageable: {
                pageSize: 25,
                pageSizes: [10, 25, 50],
                buttonCount: 3,
                refresh: true
            },
            dataBound: function () { gridResizeFunc($scope.outagesKendoGrid); },
            columns: [
                {
                    field: "Location",
                    title: $scope._t('Address'),
                    width: 100
                }, {
                    field: "Date",
                    title: $scope._t('Created On'),
                    template: "#= DisplayedCreatedOn #",
                    width: 100
                }, {
                    field: "StatusDisplayingName",
                    title: $scope._t('Status'),
                    width: 70
                }, {
                    field: "UtillityType",
                    title: $scope._t('Type'),
                    width: 40
                }, {
                    title: $scope._t('Actions'),
                    template: kendo.template($("#commands-template").html()),
                    width: "50px"
                }
            ]
        }

        $scope.resizeGrid = function () {
            // timeout because grid size calculation should happen after action collapse finish it's animation
            setTimeout(function () {
                gridResizeFunc($scope.outagesKendoGrid);
            }, 1);
        };

        $scope.edit = function (id) {
            $state.goMainLayout('OpenOutageReport', { Id: id, mode: 'edit' });
        };

    }]);
'use strict';
var app = angular.module('utilliApp');
app.controller('OpenOutageReportController',
['$scope', '$state', 'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt', 'usSpinnerService',
    'GetAccountsService', '$http', '$stateParams', 'ServiceProvidersService', 'outageReportDataService', 'outageMyLocationService', '$timeout',
    function ($scope, $state, LeftMenuService, CommonHeaderService, ModalServiceExt, usSpinnerService,
        GetAccountsService, $http, $stateParams, ServiceProvidersService, outageReportDataService, outageMyLocationService, $timeout) {

        LeftMenuService.setCurrentTab('OutageCenter');
        
        $scope.editMode = $stateParams.mode === 'edit';
        if ($scope.editMode)
            CommonHeaderService.setUpBackButton($scope._t('Edit Outage Report'));
        else
            CommonHeaderService.setUpBackButton($scope._t('Outage Report'));

        if (!$stateParams.Id) {
            console.error('Outage report Id is empty.');
            return;
        }

        usSpinnerService.spin('spinner-1');

        $scope.locations = [];
        $scope.selectedLocation = '';

        var apiUrl = '';
        if ($stateParams.anonymous) {
            ServiceProvidersService.getProviderApiUrl()
            .then(function(result) {
                if (!result) {
                    ModalServiceExt.showServerError();
                    $state.goToSignIn();
                    return;
                }

                apiUrl = result;
                loadOutageReport();
            },
            function() {
                ModalServiceExt.showServerError();
                $state.goToSignIn();
            });
        } else {
            apiUrl = localStorage.getItem('ApiUrl');
            loadOutageReport();
        }

        function loadOutageReport() {
            var url = apiUrl + 'api/Outages/GetOutageReport/';
            $http({
                method: 'GET',
                url: url,
                params: { id: $stateParams.Id }
            }).success(function (result) {
                if (result.Errors && result.Errors.length > 0) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showError(result.Errors[0]);
                    return;
                }

                $scope.data = outageReportDataService.getReportData(result.Data.OutageReport);
                $scope.locations = result.Data.Locations;
                $scope.locations.push({ AccountNumber: null, Location: $scope._t('Nearby Address'), State: 'NearbyAddress' });
                $scope.locations.push({ AccountNumber: null, Location: $scope._t('Nearby Cross Street'), State: 'NearbyCrossStreet' });
                $scope.locations.push({ AccountNumber: null, Location: $scope._t('My Location'), State: 'MyLocation' });

                $scope.outageReport = result.Data.OutageReport;
                if ($scope.outageReport.DisplayedOutageLocation === 'ServiceAddress')
                    $scope.selectedLocation = _.find($scope.locations, function (location) { return location.AccountNumber === $scope.outageReport.ContractAccount });
                else
                    $scope.selectedLocation = _.find($scope.locations, function (location) { return location.State === $scope.outageReport.DisplayedOutageLocation });

                if ($scope.outageReport.DisplayedOutageLocation === 'MyLocation') {
                    $scope.map = outageMyLocationService.getMap('myLocationMap');

                    $timeout(function () {
                        outageMyLocationService.setLocation(
                            $scope.map,
                            $scope.outageReport.Coordinate.Latitude,
                            $scope.outageReport.Coordinate.Longitude);
                    }, 300);
                }

                $scope.utillityTypes = result.Data.UtillityTypes;
                $scope.selectedUtillityType = $scope.outageReport.UtillityType;

                if ($scope.outageReport.Image)
                    setImage();

                usSpinnerService.stop('spinner-1');
            }).error(function (error) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }

        function setImage() {
            var container = $('#imageContainer' + $scope.selectedLocation.State);
            container.css('background-image', 'url(' + $scope.data.image + ')');
        }

        $scope.locationChanged = function () {
            $scope.data.clearExcept($scope.selectedLocation.State);
            if ($scope.data.image)
                setImage();
            $scope.data.clearErrors();

            if (!$scope.selectedLocation)
                return;

            if ($scope.selectedLocation.State === 'MyLocation') {
                if ($scope.map)
                    return;

                $scope.map = outageMyLocationService.getMap('myLocationMap');
                if ($scope.outageReport.DisplayedOutageLocation === 'MyLocation') {
                    $timeout(function () {
                        outageMyLocationService.setLocation(
                            $scope.map,
                            $scope.outageReport.Coordinate.Latitude,
                            $scope.outageReport.Coordinate.Longitude);
                    }, 300);
                } else {
                    $timeout(function () {
                        outageMyLocationService.setCurrentLocation($scope.map, $scope.data);
                    }, 300);
                }
            }
        }

        function clearErrors() {
            $scope.data.clearErrors();
        }

        function validateServiceAddress() {
            if (!$scope.data.problemDescription) {
                $scope.data.errors.descriptionEmptyError = true;
                return false;
            }

            return true;
        }
            
        $scope.wrongLocation = function () {
            $scope.selectedLocation = $scope.selectedLocation = _.find($scope.locations, function (location) { return location.State === 'NearbyAddress' });
            $scope.locationChanged();
        }

        function validateNearbyAddress() {
            var isValid = true;

            if (!$scope.data.houseNumber) {
                $scope.data.errors.houseNumberEmptyError = true;
                isValid = false;
            }

            if (!$scope.data.street) {
                $scope.data.errors.streetEmptyError = true;
                isValid = false;
            }

            var regexp;
            var matched;
            if (!$scope.data.city) {
                $scope.data.errors.cityEmptyError = true;
                isValid = false;
            } else {
                regexp = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;
                matched = regexp.test($scope.data.city);
                if (!matched) {
                    $scope.data.errors.invalidCityError = true;
                    isValid = false;
                }
            }

            if (!$scope.data.state) {
                $scope.data.errors.stateEmptyError = true;
                isValid = false;
            } else {
                regexp = /^[a-zA-Z]{2}$/;
                matched = regexp.test($scope.data.state);
                if (!matched) {
                    $scope.data.errors.invalidStateError = true;
                    isValid = false;
                }
            }

            if (!$scope.data.zip) {
                $scope.data.errors.zipEmptyError = true;
                isValid = false;
            } else {
                regexp = /^(\d{5})?$|^$|^(\d{5}-\d{4})?$/;
                matched = regexp.test($scope.data.zip);
                if (!matched) {
                    $scope.data.errors.invalidZipError = true;
                    isValid = false;
                }
            }

            if (!$scope.data.problemDescription) {
                $scope.data.errors.descriptionEmptyError = true;
                isValid = false;
            }

            return isValid;
        }

        function validateNearbyCrossStreet() {
            var isValid = true;

            if (!$scope.data.street || !$scope.data.street2) {
                $scope.data.errors.streetEmptyError = true;
                isValid = false;
            }

            var regexp;
            var matched;
            if (!$scope.data.city) {
                $scope.data.errors.cityEmptyError = true;
                isValid = false;
            } else {
                regexp = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;
                matched = regexp.test($scope.data.city);
                if (!matched) {
                    $scope.data.errors.invalidCityError = true;
                    isValid = false;
                }
            }

            if (!$scope.data.state) {
                $scope.data.errors.stateEmptyError = true;
                isValid = false;
            } else {
                regexp = /^[a-zA-Z]{2}$/;
                matched = regexp.test($scope.data.state);
                if (!matched) {
                    $scope.data.errors.invalidStateError = true;
                    isValid = false;
                }
            }

            if (!$scope.data.zip) {
                $scope.data.errors.zipEmptyError = true;
                isValid = false;
            } else {
                regexp = /^(\d{5})?$|^$|^(\d{5}-\d{4})?$/;
                matched = regexp.test($scope.data.zip);
                if (!matched) {
                    $scope.data.errors.invalidZipError = true;
                    isValid = false;
                }
            }

            if (!$scope.data.problemDescription) {
                $scope.data.errors.descriptionEmptyError = true;
                isValid = false;
            }

            return isValid;
        }

        function validateMyLocation() {
            var isValid = true;

            if (!$scope.data.lat || !$scope.data.lng) {
                $scope.data.errors.wrongLocation = true;
                isValid = false;
            }

            if (!$scope.data.problemDescription) {
                $scope.data.errors.descriptionEmptyError = true;
                isValid = false;
            }

            return isValid;
        }

        function validate() {
            if (!$scope.selectedLocation)
                return false;

            if (isServiceAddressSelected())
                return validateServiceAddress();
            else if (isNearbyAddressSelected())
                return validateNearbyAddress();
            else if (isNearbyCrossStreetSelected())
                return validateNearbyCrossStreet();
            else
                return validateMyLocation();
        }

        function isServiceAddressSelected() {
            return $scope.selectedLocation.State === 'ServiceAddress';
        }

        function isNearbyAddressSelected() {
            return $scope.selectedLocation.State === 'NearbyAddress';
        }

        function isNearbyCrossStreetSelected() {
            return $scope.selectedLocation.State === 'NearbyCrossStreet';
        }

        function isMyLocationSelected() {
            return $scope.selectedLocation.State === 'MyLocation';
        }

        function collectDataAndSend() {
            usSpinnerService.spin('spinner-1');

            if (isMyLocationSelected()) {
                var geoLocation = {
                    Latitude: $scope.data.lat,
                    Longitude: $scope.data.lng
                };
                var data = {
                    Id: $scope.outageReport.Id,
                    UtillityType: $scope.selectedUtillityType,
                    OutageLocation: $scope.selectedLocation.State,
                    ContractAccount: null,
                    Description: $scope.data.problemDescription,
                    Address: null,
                    Coordinate: geoLocation,
                    Image: $scope.data.image
                }
                updateReport(data);
            } else {
                var position = '';
                var address = null;
                if (isServiceAddressSelected()) {
                    position = $scope.selectedLocation.Location;
                } else {
                    position = $scope.data.getPosition($scope.selectedLocation.State);
                    address = $scope.data.getAddress($scope.selectedLocation.State);
                }

                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({ 'address': position }, function (results, status) {

                    if (status === google.maps.GeocoderStatus.OK) {
                        var googleLocation = results[0].geometry.location;
                        var latitude = parseFloat(googleLocation.lat());
                        var longitude = parseFloat(googleLocation.lng());
                        var geoLocation = { Latitude: latitude, Longitude: longitude };

                        var data = {
                            Id: $scope.outageReport.Id,
                            UtillityType: $scope.selectedUtillityType,
                            OutageLocation: $scope.selectedLocation.State,
                            ContractAccount: $scope.selectedLocation.AccountNumber,
                            Description: $scope.data.problemDescription,
                            Address: address,
                            Coordinate: geoLocation,
                            Image: $scope.data.image
                        }
                        updateReport(data);
                    } else {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showError($scope._t('Can not get address coordinates.'));
                    }
                });
            }
        }

        $scope.save = function() {

            clearErrors();

            if (!validate())
                return;

            collectDataAndSend();
        };

        function updateReport(data) {
            var url = localStorage.getItem('ApiUrl') + 'api/Outages/UpdateOutageReport/';

            $http({
                    method: 'POST',
                    url: url,
                    data: data
                })
                .success(function(result) {

                    usSpinnerService.stop('spinner-1');

                    if (result.Errors && result.Errors.length > 0) {
                        ModalServiceExt.showError(result.Errors[0]);
                        return;
                    }

                    ModalServiceExt.showInfo($scope._t('Outage was successfully updated.'), function() { $scope.cancel(); } );
                })
                .error(function(error) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showError(error);
            });
        };

        $scope.$watch('image', function () {
            if (!$scope.data || $scope.image === $scope.data.image)
                return;

            if (!$scope.image) {
                $scope.data.image = null;
                return;
            }

            var reader = new FileReader();
            reader.onload = function (loadEvent) {
                $scope.data.image = loadEvent.target.result;
                setImage();
            }
            reader.readAsDataURL($scope.image);
        });

        $scope.cancel = function () {
            window.history.back();
        };
    }
]);

'use strict';
var app = angular.module('utilliApp');
app.controller('OutageSafetyController',
['$scope', '$state', 'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt', 'usSpinnerService',
    '$http', 'ServiceProvidersService', '$stateParams', '$sce',
    function ($scope, $state, LeftMenuService, CommonHeaderService, ModalServiceExt, usSpinnerService,
        $http, ServiceProvidersService, $stateParams, $sce) {

        LeftMenuService.setCurrentTab('OutageCenter');
        CommonHeaderService.setUpBackButton($scope._t('Outage Safety'), true);

        usSpinnerService.spin('spinner-1');

        var apiUrl = '';
        if ($stateParams.anonymous) {
            ServiceProvidersService.getProviderApiUrl()
            .then(function (result) {
                if (!result) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                    $state.goToSignIn();
                    return;
                }

                apiUrl = result;
                loadOutageSafety();
            },
            function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
                $state.goToSignIn();
            });
        } else {
            apiUrl = localStorage.getItem('ApiUrl');
            loadOutageSafety();
        }

        function loadOutageSafety() {
            $http({
                method: 'GET',
                url: apiUrl + 'api/StaticData/GetOutageSafety'
            })
            .success(function(result) {
                if (result.Errors && result.Errors.length > 0) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showError(result.Errors[0]);
                    return;
                }

                $scope.html = $sce.trustAsHtml(result.Data);
                usSpinnerService.stop('spinner-1');
            })
            .error(function (error) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }
    }
]);
'use strict';
angular.module('utilliApp')
.controller('MeterDataController', ['$scope', '$rootScope', '$window', '$http', '$sce', '$timeout',
    'LeftMenuService', '$stateParams', 'CommonHeaderService', 'usSpinnerService',  'ModalServiceExt', 'CommonDataService',
    function($scope, $rootScope, $window, $http, $sce, $timeout, LeftMenuService, $stateParams, CommonHeaderService, usSpinnerService, ModalServiceExt, CommonDataService) {

        LeftMenuService.setCurrentTab('MeterData');
        CommonHeaderService.setUpBackButton($scope._t('Meter Data'));

        $scope.isDisputeEnabled = false;
        $scope.isEditMeterReadingEnabled = false;
        $scope.noMeterReadings = false;

        CommonDataService.getCommonData().then(function(commonData) {
            var grid = $('#readsGrid').data('kendoGrid');
            if (!commonData.EnablePaymentDispute) {
                utilli.hideColumnByTitle(grid, $scope._t('Dispute'));
            }
            $scope.isEditMeterReadingEnabled = commonData.EnableAddDeleteMeterRead;
            if (!commonData.EnableAddDeleteMeterRead) {
                utilli.hideColumnByTitle(grid, $scope._t('Delete'));
            }
        },
        function() {
            ModalServiceExt.showServerError();
        });

        var startSpin = function() {
            usSpinnerService.spin('spinner-1');
        };

        var stopSpin = function() {
            usSpinnerService.stop('spinner-1');
        };

        $scope.disputeCollection = [];

        $scope.selectMeter = function() {
            $scope.meterNum = $scope.currentMeter.MeterNum;
            $scope.RefreshScrollingList();
        }

        $scope.sendDispute = function() {
            ModalServiceExt.showInfo($scope._t('Information for Dispute was successfully sent.'), function() {
                $scope.disputeCollection = [];
                $('#readsGrid').data('kendoGrid').dataSource.read();
                $('#readsGrid').data('kendoGrid').refresh();
            });
        }

        $scope.disputeMeterRead = function(reading) {
            ModalServiceExt.showInfo($scope._t('Information for Dispute was successfully sent.'), function() {
            });
        }

        $scope.meterNum = "";

        $scope.readingValue = '';
        $scope.registerValue = '001';

        var postMeterReading = function() {

            var token = localStorage.getItem('SecurityToken');
            token = decodeURIComponent(token);

            var dataRequest = {
                token: token,
                accountNumber: localStorage.getItem('CurrentAccountNumber'),
                meterNumber: $scope.meterNum,
                registerNumber: $scope.registerValue,
                meterReadValue: $scope.readingValue
            };

            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Consumption/AddMeterRead',
                method: "GET",
                params: dataRequest
            }).success(function (response) {
                if (response.Errors && response.Errors.length > 0) {
                    stopSpin();
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }

                ModalServiceExt.showInfo($scope._t('Meter read data has been successfully uploaded.'), function () {
                    $scope.readingValue = '';
                    $scope.registerValue = '001';
                    $scope.formSubmitted = false;
                    $scope.disputeCollection = [];
                    $('#readsGrid').data('kendoGrid').dataSource.read();
                    $('#readsGrid').data('kendoGrid').refresh();

                    $scope.RefreshScrollingList();
                });

               stopSpin();
            }).error(function () {
                stopSpin();
                ModalServiceExt.showServerError();
            });
        }

        $scope.submitReading = function() {
            if ($scope.readingValue != '' && $scope.registerValue != '' &&
                $scope.readingValue != undefined && $scope.registerValue != undefined) {

                startSpin();


                if ($scope.imageFormData != null) {
                    var apiUrl = localStorage.getItem('ApiUrl');
                    var uploadUrl = apiUrl + 'api/Consumption/UploadImage';
                    $http.post(uploadUrl, $scope.imageFormData, {
                            withCredentials: false,
                            headers: { 'Content-Type': undefined },
                            transformRequest: angular.identity
                        })
                        .success(
                            function () {
                                postMeterReading();
                                $scope.imageFormData = null;
                                stopSpin();
                                //ModalServiceExt.showInfo('Meter read image was uploaded successfully.', function () { });
                            }
                        )
                    .error(function () {
                            stopSpin();
                            //ModalServiceExt.showError('Error when attempt to upload meter read image');
                        }
                    );
                } else {
                    postMeterReading();
                }
            }
        }

        function isGetMetersError(jsonData) {
            return jsonData.HasErrors;
        }

        function useMeterData(jsonObject) {
            if (jsonObject.length > 0) {
                if (jsonObject.length == 1)
                    useSingleMeterData(jsonObject);
                else
                    useMiltipleMetersData(jsonObject);
            }
        };

        function useSingleMeterData(jsonObject) {
            var jsonMeterNumIs = jsonObject[0].MeterNum;
            $scope.meterNum = jsonMeterNumIs;
            if (jsonMeterNumIs == "" || jsonMeterNumIs == null) {
                $scope.isMultipleMeters = false;
            } else {
                $scope.isMultipleMeters = false;

                setCurrentMeter(jsonObject[0]);
            }
        }

        function useMiltipleMetersData(jsonObject) {
            $scope.isMultipleMeters = true;
            $scope.meterOptions = [];

            if (jsonObject.length > 0) {
                fillMeterOptions(jsonObject);
                setCurrentMeter(jsonObject[0]);
            }
        }

        function fillMeterOptions(jsonObject) {
            for (var i = 0; i < jsonObject.length; i++) {
                $scope.meterOptions.push(jsonObject[i]);
            }
        }

        function setCurrentMeter(meterInfo) {
            $scope.currentMeter = meterInfo;
            $scope.meterNum = meterInfo.MeterNum;
            $scope.RefreshScrollingList();
        }


    $scope.getMeterDataGraph = function () {
        startSpin();

        var apiUrl = localStorage.getItem('ApiUrl');
        var accountNumber = localStorage.getItem('CurrentAccountNumber');
        
        $http({
            url: apiUrl + 'api/Consumption/GetMeterInfo/',
            method: "GET",
            params: { accountNumber: accountNumber }
        }).success(function (jsonData) {
            stopSpin();
            if (jsonData) {
                if (isGetMetersError(jsonData)) {
                    ModalServiceExt.showError(jsonData[0].ERROR_LIST[0].Message);
                } else {
                    useMeterData(jsonData);
                }
            } else {
                ModalServiceExt.showError(utilli.errors.serverErrorMessage);
            }
        }).error(function (error) {
            stopSpin();
            ModalServiceExt.showError(error.Message);
        });
    };

    $scope.deleteMeterRead = function (meterRead) {
        startSpin();

        var apiUrl = localStorage.getItem('ApiUrl');
        var accountNumber = localStorage.getItem('CurrentAccountNumber');

        $http({
            url: apiUrl + 'api/Consumption/DeleteMeterRead/',
            method: "GET",
            params: { accountNumber: accountNumber, meterNumber: $scope.meterNum, registerNumber: meterRead.RegisterNum, meterReadDate: meterRead.DateString, }
        }).success(function (jsonData) {
            stopSpin();
            if (jsonData) {
                if (isGetMetersError(jsonData)) {
                    ModalServiceExt.showError(jsonData.Errors[0]);
                } else {
                    ModalServiceExt.showInfo($scope._t('Meter read was successfully deleted.'), function () {
                        $('#readsGrid').data('kendoGrid').dataSource.read();
                        $('#readsGrid').data('kendoGrid').refresh();

                        $scope.RefreshScrollingList();
                    });
                }
            } else {
                ModalServiceExt.showError(utilli.errors.serverErrorMessage);
            }
        }).error(function (error) {
            stopSpin();
            ModalServiceExt.showError(error.Message);
        });

    }

    $scope.RefreshScrollingList = function() {
        $scope.meterReadingInfoBusy = false;
        $scope.meterReadingInfoForScrolling = [];
        $scope.meterReadingInfoEndReached = false;

        $scope.getMeterReadingInfoForScrolling();
    }

    $scope.meterReadingInfoBusy = false;
    var pageSize = 10;
    $scope.meterReadingInfoForScrolling = [];
    $scope.meterReadingInfoEndReached = false;

    $scope.getMeterReadingInfoForScrolling = function () {

        if ($scope.meterReadingInfoBusy)
            return;
        $scope.meterReadingInfoBusy = true;

        var accountNumber = localStorage.getItem('CurrentAccountNumber');
        var meterNumber= $scope.meterNum;
        if (meterNumber == undefined || meterNumber == '') {
            $scope.meterReadingInfoBusy = false;
            return;
        }

        var dataRequest = {
            meterNumber: meterNumber,
            accountNumber: accountNumber,
            skip: $scope.meterReadingInfoForScrolling.length,
            pageSize: pageSize,
            withTotalCount: false
        };
        usSpinnerService.spin('spinner-1');
        $http({
            url: localStorage.getItem('ApiUrl') + 'api/Consumption/GetConsumptionGraphPageAllReadings/',
            method: "GET",
            params: dataRequest
        }).success(function (data) {
            usSpinnerService.stop('spinner-1');
            $scope.meterReadingInfoBusy = false;
            var jsondata = data;
            if (jsondata) {
                if (jsondata.Errors && jsondata.Errors.length > 0) {
                    $scope.meterReadingInfoEndReached = true;
                    ModalServiceExt.showError(jsondata.Errors[0]);
                } else {
                    $scope.acceptMeterReadingInfoForScrolling(data);
                }
            } else {
                $scope.meterReadingInfoEndReached = true;
                ModalServiceExt.showServerError();
            }
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            $scope.meterReadingInfoBusy = false;
            ModalServiceExt.showServerError();
        });
    };

    $scope.acceptMeterReadingInfoForScrolling = function (data) {
        if (data.PageData) {
            for (var i = 0; i < data.PageData.length; i++) {
                $scope.meterReadingInfoForScrolling.push(data.PageData[i]);
            }
            if (data.PageData.length < pageSize) {
                $scope.meterReadingInfoEndReached = true;
            }
        } else {
            $scope.meterReadingInfoEndReached = true;
        }
        $scope.meterReadingInfoBusy = false;
        $scope.noMeterReadings = $scope.meterReadingInfoForScrolling.length === 0;
    };

    $scope.imageFormData = null;

    $scope.createImageDataForUpload = function (files) {
        $scope.imageFormData = new FormData();
        //Take the first selected file
        var accountNumber = localStorage.getItem('CurrentAccountNumber');
        var meterNumber = $scope.meterNum;
        var registerNumber = $scope.registerValue;
        var fileExtension = files[0].name.split('.').pop();

        var nameForFile = accountNumber + '_' + meterNumber + '_' + registerNumber + '_' + fileExtension;
        //$scope.imageFormData.append(files[0].name, files[0]);
        $scope.imageFormData.append(nameForFile, files[0]);
    }

    $scope.uploadImageFile = function() {
        if ($scope.imageFormData != null) {
            var apiUrl = localStorage.getItem('ApiUrl');
            var uploadUrl = apiUrl + 'api/Consumption/UploadImage';
            $http.post(uploadUrl, $scope.imageFormData, {
                    withCredentials: false,
                    headers: { 'Content-Type': undefined },
                    transformRequest: angular.identity
                })
                //.success(ModalServiceExt.showInfo('Meter read image was uploaded successfully.', function() {}))
                .error(function() {
                    ModalServiceExt.showError($scope._t('Error when attempt to upload meter read image'));
                }
            );
        }
    };

}])
;
'use strict';

angular.module('utilliApp')
    .controller('MeterReadsGridCtrl', [
        '$scope', '$rootScope', '$http', 'BillsService', '$state', 'OpenFileService', 'GridService',
        function ($scope, $rootScope, $http, BillsService, $state, OpenFileService, GridService) {
            var readsGridResizeFunc = GridService.getGridResizeFunc($("#readsGrid"), 85);

            $(window).resize(function () {
                readsGridResizeFunc($scope.readsKendoGrid);
            });

            $rootScope.$on('subscribe-notification-hide', function (event, args) {
                readsGridResizeFunc($scope.readsKendoGrid);
            })

            var accountNumber = localStorage.getItem('CurrentAccountNumber');

            var watchForChange = function () {
                return $scope.$parent.meterNum;
            }

            $scope.$watch(watchForChange, function (newValue, oldValue) {
                if (newValue != '') {
                    $scope.readsKendoGrid.dataSource.read();
                    $scope.readsKendoGrid.refresh();
                }
            });

            $scope.delete = function (dataItem) {
                $scope.$parent.deleteMeterRead(dataItem);
                //$scope.readsKendoGrid.dataSource.read();
                //$scope.readsKendoGrid.refresh();
            }

            $scope.dispute = function (dataItem) {
                var filteredArray = $scope.$parent.disputeCollection.filter(function (entry) {
                    return entry != dataItem;
                });

                if (filteredArray.length != $scope.$parent.disputeCollection.length) {
                    $scope.$parent.disputeCollection = filteredArray;
                    return;
                } else {
                    $scope.$parent.disputeCollection.push(dataItem);
                }
            }

            $scope.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function (options) {
                            var webapi = new kendo.data.transports.webapi({ prefix: "" });
                            var params = webapi.parameterMap(options.data);
                            params = $.extend(params, { 
                                meterNumber: $scope.$parent.meterNum,
                                accountNumber: accountNumber,
                                skip: (params.page - 1) * params.pageSize,
                                pageSize: params.pageSize,
                                withTotalCount: true,
                            });
                            var url = localStorage.getItem('ApiUrl') + 'api/Consumption/GetConsumptionGraphPageAllReadings';
                            $http.get(url, { params: params })
                                .success(function (data) {
                                    options.success(data);
                                    readsGridResizeFunc($scope.usersKendoGrid);
                                })
                                .error(function () {
                                    options.error();
                                });
                        }
                    },
                    schema: {
                        data: function (response) {
                            // resize is useful here for the case when number of items per page is changed.
                            // i call resize to handle that the grid can expand or shrink.
                            // timeout is necessary to process resize after data is loaded
                            setTimeout(function () { readsGridResizeFunc($scope.readsKendoGrid); }, 0);
                            $scope.$parent.disputeCollection = [];
                            return response.PageData;
                        },
                        total: "Count"
                    },
                    pageSize: 20,
                    serverPaging: true
                },
                autoBind: false,
                sortable: true,
                resizable: true,
                pageable: {
                    pageSize: 10,
                    pageSizes: [10, 25, 50],
                    buttonCount: 3,
                    refresh: true
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                dataBound: function () { readsGridResizeFunc($scope.readsKendoGrid); },
                columns: [
                ]
            };
            $scope.mainGridOptions.columns.push({
                field: "DateOfReading",
                title: $scope._t("Date"),
                template: "<span>#: DateString #</span>"
            });
            $scope.mainGridOptions.columns.push({
                field: "Days",
                title: $scope._t("Days"),
                template: "<span>#: Days #</span>"
            });
            if (DeploymentSettings.currentServiceProvider != Config.hcProviderName) {
                $scope.mainGridOptions.columns.push({
                    field: "Cost",
                    title: $scope._t("Cost"),
                    template: "<span>#: utilli.formatCurrency(Cost) #</span>"
                });
            }
            $scope.mainGridOptions.columns.push({
                field: "RegisterNum",
                title: $scope._t("Register"),
                template: "<span>#: RegisterNum #</span>"
            });
            $scope.mainGridOptions.columns.push({
                field: "RunningMeterReading",
                title: $scope._t("Meter Reading"),
                template: "<span>#: RunningMeterReading #</span>"
            });
            $scope.mainGridOptions.columns.push({
                field: "Consumption",
                title: $scope._t("Usage"),
                template: "<span>#: Consumption #</span>"
            });
            $scope.mainGridOptions.columns.push({
                field: "UnitsOfMeasure",
                title: $scope._t("Units"),
                template: "<span>#: UnitOfMeasure #</span>"
            });
            if (DeploymentSettings.currentServiceProvider != Config.hcProviderName) {
                $scope.mainGridOptions.columns.push({
                    field: "DailyAverageString",
                    title: $scope._t("Daily Average"),
                    template: "<span>#: DailyAverageString #</span>"
                });
            }
            $scope.mainGridOptions.columns.push({
                field: "",
                title: $scope._t("Dispute"),
                template: "<input type='checkbox' value='View' ng-click='dispute(dataItem)' />",
                sortable: false,
            });
            $scope.mainGridOptions.columns.push({
                field: "",
                title: $scope._t("Delete"),
                template: "# if ( CanBeDeleted )  { # <a href='\\#' ng-click='delete(dataItem)'>delete</> # } #",
                sortable: false,
            });
        }
    ]);
'use strict';
angular.module('utilliApp')
.controller('AccountMenuController', ['$scope', '$http', '$rootScope', '$window', '$state', '$timeout',
    function ($scope, $http, $rootScope, $window, $state, $timeout) {

    $scope.backFromBillDetails = function () {
        $rootScope.showSlideBackAnimation = true;
        $state.goMainLayout('BillsAndPayments');
        $timeout(function () { $rootScope.showSlideBackAnimation = false; }, 1000);
    }

    $scope.showNotifications = function () {
        $rootScope.showSlideAnimation = true;
        $state.goMainLayout('Notifications');
        $timeout(function () { $rootScope.showSlideAnimation = false; }, 1000);
    }

}]);
'use strict';
angular.module('utilliApp')
.controller('PayNowController', ['$scope', '$rootScope', '$window', '$http', '$state', '$stateParams', 
    'CommonDataService', 'usSpinnerService', 'LeftMenuService', 'CommonHeaderService', 'GetAccountsService', 
    'ModalServiceExt', 'AccountListService', 'CustomerInfoDataService', 'TimeService',
    function ($scope, $rootScope, $window, $http, $state, $stateParams, CommonDataService, usSpinnerService, 
        LeftMenuService, CommonHeaderService, GetAccountsService, ModalServiceExt, AccountListService,
        CustomerInfoDataService, TimeService) {

    LeftMenuService.setCurrentTab('PayNow');
    CommonHeaderService.setUpBackButton($scope._t('Pay Now'));
    $scope.customerInfo = {};
    $scope.customerInfo.account = {};
    var loading = $scope._t('loading...');
    $scope.customerInfo.account.AccountNumber = loading;
    $scope.customerInfo.account.ServiceAddress = loading;
    $scope.customerInfo.account.CustomerFullName = loading;

    $scope.customerInfo.userinfo = {};

    var token = localStorage.getItem('SecurityToken');
    if (!token) {
        // if user clicks on make payment button in an email and he is not logged in then silently redirect to welcome
        // to avoid pop-up saying that session has expired.
        $state.goToSignIn(true);
    }
    $scope.agreed = false;
    $scope.isFeeEnabled = false;
    $scope.isCashOnly = false;

    if($stateParams.AccountNumber)
    {
        localStorage.setItem('CurrentAccountNumber', $stateParams.AccountNumber);
    }
    if ($stateParams.AccountNumber && $stateParams.AccountNumber != AccountListService.getCurrentContractAccount())
        checkContractAccount($stateParams.AccountNumber);
    else
        getFeeInfo();

    function getFeeInfo() {
        usSpinnerService.spin('spinner-1');
        $http({
            url: localStorage.getItem('ApiUrl') + 'api/Payment/GetConvFeeInfo/',
            method: "GET",
            params: { accountNumber: localStorage.getItem('CurrentAccountNumber') }
        })
        .then(function (res) {
            var data = res.data;
            $scope.feeInformation = data.FeeInfoTextAchAndCard;
            $scope.isFeeEnabled = false;
            $scope.isCashOnly = data.IsCashOnly;
            $scope.isDirectDebitInProcess = data.IsDirectDebitInProgress;
            $scope.isCashOnlyInformation = data.IsCashOnlyInformation;
            if (data.IsCashOnly || data.IsDirectDebitInProgress) {
                return CommonDataService.getCommonData().then(function(data) {
                    $scope.FullCustomerServiceInfo = data.FullCustomerServiceInfo;
                });
            }
        }, ModalServiceExt.showAjaxError)
        .fixedFinally(function(){
            usSpinnerService.stop('spinner-1');
        });
    }
    $scope.getUtilityImage = function () {
        var utilliType = localStorage.getItem('CurrentUtilityType');
        if (utilliType == 'Gas')
            return 'gas-bgr';
        if (utilliType == 'Water')
            return 'water-bgr';
        if (utilliType == 'Electricity')
            return 'elctr-bgr';

        return '';
    }

    CustomerInfoDataService.getCustomerInfoData()
    .then(
        function(customerInfo) {
            if (!customerInfo) {
                ModalServiceExt.showServerError();
                return;
            }
            localStorage.setItem('CurrentUtilityType', customerInfo.account.UtilliType);
            $scope.customerInfo = customerInfo;

            $scope.showDueDate = customerInfo.userinfo.TotalOpenBalance > 0 && customerInfo.userinfo.DueDate != '0001-01-01T00:00:00';
            $scope.showPastDue = false;
            $scope.showDisconnected = false;
            $scope.showDisconnectionPending = false;
            $scope.accountStatuses = [];

            $scope.LastPaymentAmount = customerInfo.userinfo.LastPaymentAmount == null
                ? null
                : getPositiveAmountString(customerInfo.userinfo.LastPaymentAmount);
            $scope.LastPaymentDate = TimeService.parseISOLocalDate(customerInfo.userinfo.LastPaymentDate);
            try {
                $scope.customerInfo.dueDate = TimeService.parseISOLocalDate(customerInfo.userinfo.DueDate);
                if ($scope.customerInfo.userinfo.IsDisconnected) {
                    $scope.showDisconnected = true;
                }
                else if ($scope.customerInfo.userinfo.IsAccountDisconnectionPending) {
                    $scope.showDisconnectionPending = true;
                }
                else if($scope.showDueDate && $scope.customerInfo.dueDate < utilli.getDateWithoutTime(new Date())) {
                    $scope.showPastDue = true;
                }
                $scope.accountStatuses = utilli.fillAccountStatuses($scope.customerInfo.account);
            } catch (ex) {
                console.log(ex);
            }
        },
        function(err) {
            ModalServiceExt.showError(err);
        }
    )
    // .then(showDueReminder)
    // // "['finally']" instead of just "finally" because in old android browsers "finally" is a reserved keyword
    // ['finally'](function() {
    //     $scope.IsGettingDashboardInfo = false;
    //     usSpinnerService.stop('spinner-1');
    // });

    function checkContractAccount(caNumber) {
        usSpinnerService.spin('spinner-1');
        GetAccountsService
            .getAccounts(true)
            .then(function (response) {
                usSpinnerService.stop('spinner-1');

                if (response.Errors && response.Errors.length > 0) {
                    ModalServiceExt.showError(response.Errors[0].Message);
                }
                else {
                    var contractAccount = _.findWhere(response.Accounts, { AccountNumber: caNumber });
                    if (contractAccount) {
                        AccountListService.changeContractAccount(contractAccount);
                        getFeeInfo();
                    }
                    else {
                        ModalServiceExt.showError($scope._t('Using an incorrect contract account number.'));
                    }
                }
            }).catch(function (e) {
                usSpinnerService.stop('spinner-1');
                console.log(e);
            });
    }

    $scope.updateAgreed = function()
    {
        if ($scope.agreed)
            $scope.agreed = false;
        else
            $scope.agreed = true;
    };

    $scope.payByCard = function()
    {
        $state.goMainLayout('PayByCard');
    }

    $scope.payByCheck = function ()
    {
        $state.goMainLayout('PayByCheck');
    }

    $scope.cancel = function () {
        $window.history.back();
    };
}]);
'use strict';
angular.module('utilliApp').controller('InstallmentPlanController', ['$scope', '$http', '$state', 'usSpinnerService',
    'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt',
    function ($scope, $http, $state, usSpinnerService, LeftMenuService, CommonHeaderService, ModalServiceExt) {
        CommonHeaderService.setUpBackButton($scope._t('Installment Plans'));
        LeftMenuService.setCurrentTab('PaymentOptions');
        var _t = $scope._t;

        $scope.startDate = new Date();
        $scope.installmentNumber = 6;

        initPicker();
        function initPicker() {
            $scope.dpOptions = utilli.datePickerOptions;
            $scope.altInputFormats = ['M!/d!/yyyy'];
            $scope.format = 'shortDate';
        }

        function loadPlanTypes() {
            $scope.isLoading = true;
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/InstallmentPlan/GetInstallmentPlanTypes/',
                method: "GET"
            })
                .apiThen(function (data) {
                    $scope.planTypes = data;
                    $scope.planTypeId = $scope.planTypeId ? $scope.planTypeId : data[0].Id;
                }, ModalServiceExt)
                .fixedFinally(function () {
                    $scope.isLoading = false;
                });
        }
        loadPlanTypes();

        function loadCurrentPlan() {
            usSpinnerService.spin('spinner-1');
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/InstallmentPlan/GetInstallmentPlan',
                method: 'GET',
                params: { contractAccountNumber: localStorage.getItem('CurrentAccountNumber') }
            })
                .apiThen(function (data) {
                    $scope.readOnly = data.length;
                    data.forEach(function (element) {
                        element.InstallmentAmountString = "$" + element.InstallmentAmount;
                        element.OpenAmountString = element.OpenAmount === 0
                            ? "—" : "$" + element.OpenAmount;
                    });
                    $scope.planItems = data;
                }, ModalServiceExt)
                .fixedFinally(function () {
                    usSpinnerService.stop('spinner-1');
                });
        };
        loadCurrentPlan();

        $scope.cancel = function () {
            $window.history.back();
        };

        $scope.enroll = function () {
            $scope.form.$submitted = true;
            var utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
            $scope.today = new Date(utc);
            if ($scope.startDate < $scope.today)
            {
                $scope.form.$valid = false;
                return;
            }
            if (!$scope.form.$valid)
                return;

            usSpinnerService.spin('spinner-1');
            var x = $http({
                url: localStorage.getItem('ApiUrl') + 'api/InstallmentPlan/Enroll',
                method: 'POST',
                data: {
                    contractAccountNumber: localStorage.getItem('CurrentAccountNumber'),
                    planTypeId: $scope.planTypeId,
                    installmentNumber: $scope.installmentNumber,
                    startDate: $scope.startDate.toUTCString()
                }
            }).apiThen(function () {
            }, ModalServiceExt
            ).then(loadCurrentPlan, function(){
                usSpinnerService.stop('spinner-1');
            });
        };

        $scope.unEnroll = function () {
            $scope.form.$submitted = true;
            if (!$scope.form.$valid)
                return;

            usSpinnerService.spin('spinner-1');
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/InstallmentPlan/Unenroll',
                method: 'POST',
                params: { contractAccountNumber: localStorage.getItem('CurrentAccountNumber') }
            }).apiThen(function () {
            }, ModalServiceExt
            ).then(loadCurrentPlan, function(){
                usSpinnerService.stop('spinner-1');
            });
        };

    }]);
'use strict';

angular.module('utilliApp')
    .controller('PayByCardController', ['$scope', '$http', '$state', '$window', '$timeout',
        '$stateParams', 'usSpinnerService', 'LeftMenuService', 'ModalServiceExt', 'CommonHeaderService',
        'CommonDataService', '$q', 'PaymentVerificationService',
        function ($scope, $http, $state, $window, $timeout, $stateParams,usSpinnerService, LeftMenuService,
            ModalServiceExt, CommonHeaderService, CommonDataService, $q, PaymentVerificationService) {
            LeftMenuService.setCurrentTab('PayByCard');
            CommonHeaderService.setUpCancelButton();
            var browser = $window.navigator.userAgent;

            $scope.isDonationEnabled = false;
            $scope.isPayNowEnabled = false;
            $scope.isPayNowBtnText = 'Next';
            $scope.velocityFee = '';
            $scope.oneTimeDonationAmount = 1.00;
            $scope.donateRadio = "false";
            $scope.enrollRadio = "false";
            if (utilli.isAdmin) {
                $scope.imagesPath = "../Images";
            } else {
                $scope.imagesPath = "Images";
            }

            $scope.isMobile = isMobileOrRipple();
            $scope.isIosMobile = isMobileOrRipple() && iOS();
            $scope.deviceIsWindowsPhone = deviceIsWindowsPhone;

            initPicker();

            $scope.errors = [];

            $scope.savedCards = [];
            $scope.currentSavedCard = {};
            $scope.useSavedCard = false;
            $scope.savedCardsVisible = false;

            $scope.cardNumber = '';
            $scope.nameOnCard = '';
            $scope.cardExpiryMonth = '';
            $scope.cardExpiryYear = '';
            $scope.saveThisCard = false;

            $scope.enableSaveBankAccounts = false;
            $scope.enableSaveCreditCards = false;

            $scope.paymentResultData = '';
            $scope.isResultShowing = false;

            $scope.isFeeEnabled = false;

            $scope.phoneNumberMask = Config.phoneNumberMask;
            $scope.emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            $scope.firstLastNamePattern = /^(\S)+( \S+)+$/;

            $scope.amount = '';

            $scope.minimumPaymentAmountToAllowDonation = 0;

            function getAmount() {
                var amount = parseFloat($scope.amount);
                return  amount;
            }

            function getDonationAmount() {
                var amount = parseFloat($scope.oneTimeDonationAmount);
                return amount;
            }

            $scope.requestSchedulePayment = function () {
                usSpinnerService.spin('spinner-1');
                var params = {
                    contractAccountNumber: localStorage.getItem('CurrentAccountNumber'),
                    amount: getAmount(),
                    paymentType: 'Credit Card',
                    paymentDate: $scope.scheduleDate.toUTCString()
                };
                utilli.addUserName($state, params);
                $http({
                    url: localStorage.getItem('ApiUrl') + 'api/Payment/SchedulePayment/',
                    method: "POST",
                    data: params
                }).success(function (data) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showMessage(
                        $scope._t('Schedule Payment'),
                        $scope._t('Your request to schedule a payment has been received. Thank you for your payment.'),
                        function(){ $state.goMainLayout('Dashboard'); });
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            $scope.availablePaymentTypes = [
                { name: 'Credit Card', id: 'CreditCard' },
                { name: 'Debit Card', id: 'DebitCard' }
            ];

            function initPicker() {
                $scope.dpOptions = utilli.datePickerOptions;
                $scope.altInputFormats = ['M!/d!/yyyy'];
            }

            $scope.goDonationFaq = function () {
                $state.goMainLayout('Faqs', { donationParam: 'true' });
            }

            $scope.back = function ()
            {
                $state.goMainLayout('PayNow');
            }

            $scope.updateConvenienceFee = function (amountToPay) {
                var payAmount = utilli.parsePositiveFloat(amountToPay);
                if (payAmount === 0) {
                    $scope.totalAmount = '';
                    $scope.convenienceFee = ''; // because fee may be some percentage from amount
                    return;
                }

                var fee = 0;
                if ($scope.isFeeEnabled) {
                    var feeInfo = $scope.convFeeInfo;
                    if (feeInfo == null) return;
                    if (feeInfo.FeeType == "percent") {
                        fee = amountToPay / 100 * feeInfo.FeeAmount;
                    } else if (feeInfo.FeeType == "flat") {
                        fee = feeInfo.FeeAmount;
                    }
                }
                $scope.convenienceFee = $scope.formatDecimal(fee);

                var donation = 0;
                if ($scope.isDonationEnabled && $scope.donateRadio == "true") {
                    donation = utilli.parsePositiveFloat($scope.oneTimeDonationAmount);
                }

                $scope.totalAmount = $scope.formatDecimal(payAmount + fee + donation);
            }

            $scope.savedCardChanged = function () {
                setCurrentSavedCardAttributes();
            }

            $scope.useSavedCardChanged = function () {
                if ($scope.useSavedCard) {
                    $scope.currentSavedCard = $scope.savedCards[0];
                    for (var i = 0; i < $scope.savedCards.length; i++) {
                        var cardInfo = $scope.savedCards[i];
                        if (cardInfo.card.IsPrimary) {
                            $scope.currentSavedCard = cardInfo;
                            break;
                        }
                    }

                    setCurrentSavedCardAttributes();
                } else {
                    $scope.cardNumber = '';
                    $scope.nameOnCard = '';
                    $scope.cardExpiryMonth = '';
                    $scope.cardExpiryYear = '';
                }
            };

            function setCurrentSavedCardAttributes() {
                $scope.nameOnCard = $scope.currentSavedCard.card.HolderName;
                $scope.cardExpiryMonth = $scope.currentSavedCard.card.ExpMonth;
                $scope.cardExpiryYear = "20" + $scope.currentSavedCard.card.ExpYear;
            }

            var init = function () {
                usSpinnerService.spin('spinner-1');

                var commonDataRequest = CommonDataService.getCommonData();
                var setCommonData = function (commonData) {
                    $scope.showSchedulePayment = commonData.EnablePaymentScheduling;
                    $scope.enableSaveBankAccounts = commonData.EnableSaveBankAccounts;
                    $scope.enableSaveCreditCards = commonData.EnableSaveCards;
                    $scope.isFeeEnabled = false;
                };

                var accountNumber = localStorage.getItem('CurrentAccountNumber');
                var apiUrl = localStorage.getItem('ApiUrl');
                var savedCardsRequestParams = { accountNumber: accountNumber };
                utilli.addUserName($state, savedCardsRequestParams);
                var savedCardsRequest = $http({
                    url: apiUrl + 'api/ProfileCardManage/GetUserCards',
                    method: "GET",
                    params: savedCardsRequestParams
                });
                function setSavedCards(data) {
                    if (data == null || data.length == 0) {
                        $scope.useSavedCard = false;
                        $scope.savedCardsVisible = false;
                        return;
                    }
                    $scope.useSavedCard = true;
                    $scope.savedCardsVisible = true;

                    var foundPrimary = false;
                    for (var i = 0; i < data.length; i++) {
                        var card = data[i];
                        var cardInfo = { title: $scope._t('Card ending with ') + card.LastPart, card: card };
                        $scope.savedCards.push(cardInfo);

                        if (card.IsPrimary) {
                            $scope.currentSavedCard = cardInfo;
                            foundPrimary = true;
                        }
                    }

                    if (!foundPrimary)
                        $scope.currentSavedCard = $scope.savedCards[0];

                    setCurrentSavedCardAttributes();
                };

                var feeInfoRequest = $http({
                    url: apiUrl + 'api/Payment/GetConvFeeInfo/',
                    method: "GET",
                    params: { accountNumber: accountNumber }
                });
                var setFeeInfo = function(data){
                    if (data) {
                        $scope.convFeeInfo = data;
                        $scope.updateConvenienceFee($scope.amount);
                    }
                }

                var profileRequestParams = { accountNumber: accountNumber };
                utilli.addUserName($state, profileRequestParams);
                var profileRequest = $http({
                    url: apiUrl + 'api/Profile/GetProfile/',
                    method: "GET",
                    params: profileRequestParams
                });
                var setProfileData = function (data){
                    if (data.Errors && data.Errors.length > 0) {
                        ModalServiceExt.showServerError();
                        return;
                    }

                    $scope.profile = data.AccountData;
                    $scope.isDonationEnabled = !data.AccountData.IsRoundUpEnrolled;
                    if ($scope.profile.PrimaryPhoneNumber && $scope.profile.PrimaryPhoneNumber.length === 11) {
                        $scope.phoneNumber = $scope.profile.PrimaryPhoneNumber.substr(1);
                    }

                    $scope.email = $scope.profile.Email;
                }

                var customerInfoRequestParams = { contractAccountNumber: accountNumber };
                utilli.addUserName($state, customerInfoRequestParams);
                var customerInfoRequest = $http({
                    url: apiUrl + 'api/Customer/GetCustomerInfo/',
                    method: "GET",
                    params: customerInfoRequestParams
                });
                var setCustomerInfo = function (data) {
                    if (data) {
                        if (data.ERROR_LIST && data.ERROR_LIST.length > 0) {
                            ModalServiceExt.showError(data.ERROR_LIST[0].Message);
                        } else {
                            $scope.contractAccountNumber = data.account.AccountNumber;
                            $scope.amount = data.userinfo.TotalOpenBalance > 0 ? $scope.formatDecimal(data.userinfo.TotalOpenBalance) : "0.00";

                            $scope.minimumPaymentAmountToAllowDonation = data.userinfo.TotalOpenBalance > 0 ? data.userinfo.TotalOpenBalance : 0;

                            $scope.updateConvenienceFee($scope.amount);
                        }
                    } else {
                        ModalServiceExt.showServerError();
                    };
                }

                $q.all([commonDataRequest, savedCardsRequest, feeInfoRequest, profileRequest, customerInfoRequest])
                .then(
                    function(data){
                        usSpinnerService.stop('spinner-1');
                        setCommonData(data[0]);
                        setSavedCards(data[1].data);
                        setFeeInfo(data[2].data);
                        setProfileData(data[3].data);
                        setCustomerInfo(data[4].data);
                    }
                )
                .catch(function() {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });

                var minServiceAppointmentDate = (function () {
                    var tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    return tomorrow;
                })();
            }

            init();

            $scope.cancel = function () {
                $window.history.back();
            }

            $scope.okAfterSuccessfulPayment = function () {
                $state.goMainLayout('Dashboard');
            }

            $scope.dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;

            var validateFormData = function () {
                // amount validation
                $scope.amountError = parseFloat($scope.amount) <= 0;

                if (!$scope.amountError && getDonationAmount() > 0 && getAmount() < $scope.minimumPaymentAmountToAllowDonation)
                {
                    $scope.amountError = true;
                    ModalServiceExt.showError('You need to pay at least amount due to make donation.');
                }

                if ($scope.amount == '' || $scope.amount == undefined)
                    $scope.amountEmptyError = true;
                else
                    $scope.amountEmptyError = false;

                // donation amount validation
                if ($scope.donateRadio == "true"){
                    var donation = utilli.parsePositiveFloat($scope.oneTimeDonationAmount);
                    $scope.oneTimeDonationAmountError = donation === 0;
                } else {
                    $scope.oneTimeDonationAmountError = false;
                }

                if ($scope.pay_form.email.$invalid
                        || $scope.pay_form.phoneNumber.$invalid
                        || $scope.pay_form.email.$invalid
                        || ($scope.pay_form.cardNumber.$invalid && !$scope.useSavedCard)
                        || $scope.pay_form.nameOnCard.$invalid
                        || ($scope.pay_form.cardExpiryMonth.$error.ccExpMonth && !$scope.useSavedCard)
                        || ($scope.pay_form.cardExpiryYear.$error.ccExpYear && !$scope.useSavedCard)
                        || ($scope.pay_form.$error.ccExp && !$scope.useSavedCard)
                        || ($scope.pay_form.cardExpiryMonth.$invalid && !$scope.useSavedCard)
                        || ($scope.pay_form.cardExpiryYear.$invalid && !$scope.useSavedCard)
                        || $scope.pay_form.cardNumber.$type == 'JCB'
                        || $scope.pay_form.cardNumber.$type == 'American Express'
                        || $scope.pay_form.cardNumber.$type == 'Diners Club'
                        || $scope.amountEmptyError
                        || $scope.amountError) {
                    return false;
                } else {
                    return true;
                }
            }

            $scope.makePaymentApi = function () {
                $scope.errors = [];
                if ($scope.scheduleButtonClicked && $scope.scheduleDate) {
                    usSpinnerService.spin('spinner-1');
                    $timeout(function () {
                        usSpinnerService.stop('spinner-1');
                        $scope.requestSchedulePayment();
                    }, 1500);
                    return;
                }
                if (!validateFormData()) {
                    $scope.errors = [{ Message: utilli.errors.validationErorrsMessage }];
                    return;
                }
                if ($scope.isPayNowEnabled) {
                    utilli.scrollTop();
                    usSpinnerService.spin('spinner-1');
                    PaymentVerificationService.verifyPaymentInfo(getAmount(), function () {
                        if ($scope.useSavedCard)
                            payBySavedCard()
                        else
                            payByNewCard()
                    });
                }
                else {
                    getVelocityFee($scope.totalAmount);
                }
            }

            function payByNewCard () {
                var expDate = formExpiryDate();
                var dataRequest = {
                    ContractAccountNumber: localStorage.getItem('CurrentAccountNumber'),
                    CardNumber: $scope.cardNumber,
                    Amount: getAmount(),
                    CardholderName: $scope.nameOnCard,
                    ExpirationDate: expDate,
                    Email: $scope.email,
                    PhoneNumber: utilli.getFullPhoneNumber($scope.phoneNumber),
                    SaveThisCard: $scope.saveThisCard,
                    EnrollInRoundUp: $scope.enrollRadio == "true",
                    DoOneTimeDonation: $scope.donationRadio == "true",
                    OneTimeDonationAmount: getDonationAmount(),
                    Browser: browser,
                    ConvenienceFee: parseFloat($scope.velocityFee),
                };
                utilli.addUserName($state, dataRequest);
                usSpinnerService.spin('spinner-1');
                $http({
                    url: localStorage.getItem('ApiUrl') + 'api/Payment/PayByCard/',
                    method: "POST",
                    data: dataRequest
                }).success(function (data) {
                    handlePaymentSuccess(data);
                }).error(function (error, status) {
                    if (status === 0) {
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            function payBySavedCard () {
                var payDataRequest = {
                    Card: $scope.currentSavedCard.card,
                    AccountNumber: localStorage.getItem('CurrentAccountNumber'),
                    Amount: getAmount(),
                    Email: $scope.email,
                    PhoneNumber: utilli.getFullPhoneNumber($scope.phoneNumber),
                    userId: $stateParams.userId,
                    EnrollInRoundUp: $scope.enrollRadio == "true",
                    DoOneTimeDonation: $scope.donationRadio == "true",
                    OneTimeDonationAmount: getDonationAmount(),
                    Browser: browser,
                    ConvenienceFee: $scope.velocityFee
                };

                usSpinnerService.spin('spinner-1');
                $http({
                    url: localStorage.getItem('ApiUrl') + 'api/Payment/PayBySavedCard/',
                    method: "POST",
                    data: payDataRequest
                }).success(function (data) {
                    handlePaymentSuccess(data);
                }).error(function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
            }

            function resetPayBtn()
            {
                $scope.isPayNowBtnText = 'Next';
                $scope.isPayNowEnabled = false;
                $scope.velocityFee = '';
            }

            function getVelocityFee(newAmount) {
                var payAmount = utilli.parsePositiveFloat(newAmount);
                if (payAmount <= 0) {
                    return;
                }
                
                usSpinnerService.spin('spinner-1');
                $http({
                    url: localStorage.getItem('ApiUrl') + 'api/Payment/GetVelocityFee/',
                    method: "GET",
                    params: { Card: $scope.cardNumber , Amount: payAmount, 
                        AccountNumber: localStorage.getItem('CurrentAccountNumber'), Type: "1"  }
                })
                .then(function (res) {
                    $scope.velocityFee = res.data.PPIFeeValue;
                    $scope.isPayNowEnabled = true;
                    $scope.isPayNowBtnText = 'Pay Now'
                }, ModalServiceExt.showAjaxError)
                .fixedFinally(function(){
                    usSpinnerService.stop('spinner-1');
                });
            }

            function formExpiryDate() {
                var expiryYear = $scope.cardExpiryYear.toString();
                if (expiryYear.length > 2)
                    expiryYear = expiryYear.substr(expiryYear.length - 2);

                var expiryMonth = $scope.cardExpiryMonth.toString();
                if (expiryMonth.length < 2)
                    expiryMonth = '0' + expiryMonth;

                var expiryDate = expiryMonth.concat(expiryYear);
                return expiryDate;
            }

            function handlePaymentSuccess(data) {
                $scope.isPayNowEnabled = false;
                $scope.isPayNowBtnText = 'Next'
                usSpinnerService.stop('spinner-1');
                if (data) {
                    if (data.Errors && data.Errors.length > 0) {
                        ModalServiceExt.showError(data.Errors[0]);
                    } else {
                        $scope.acceptBillsData(data);
                    }
                } else {
                    ModalServiceExt.showServerError();
                }
            }

            $scope.acceptBillsData = function (data) {
                CommonHeaderService.setUp();
                $scope.isResultShowing = true;
                $scope.paymentResultMessage = data.Data;
            }

            $scope.acceptPaymentResultData = function (data) {
                $scope.paymentResultData = data;
            }

            $scope.$watch('cardNumber', function (newValue, oldValue) {
                resetPayBtn();
            });

            $scope.$watch('amount', function (newValue, oldValue) {
                    $scope.updateConvenienceFee(parseFloat($scope.amount));
                    resetPayBtn();

                    if (parseFloat($scope.amount) <= 0)
                        $scope.amountError = true;
                    else
                        $scope.amountError = false;

                    if ($scope.amount == '' || $scope.amount == undefined)
                        $scope.amountEmptyError = true;
                    else
                        $scope.amountEmptyError = false;
            });

            $scope.$watch('oneTimeDonationAmount', function (newValue, oldValue) {
                if ($scope.donateRadio == "true") {
                    resetPayBtn();
                    $scope.updateConvenienceFee(parseFloat($scope.amount));
                    $scope.oneTimeDonationAmountError = utilli.parsePositiveFloat($scope.oneTimeDonationAmount) === 0;
                }
                else {
                    $scope.oneTimeDonationAmountError = false;
                }
            });

            $scope.$watch('donateRadio', function (newValue, oldValue) {
                resetPayBtn();
                $scope.updateConvenienceFee(parseFloat($scope.amount));
                if (newValue == 'false') {
                    $scope.oneTimeDonationAmount = '';
                    $scope.oneTimeDonationAmountError = false;
                }
            });

            $scope.formatDecimal = function (decimal) {

                var formated = Math.round(parseFloat(decimal) * 100) / 100;

                formated = formated.toString();
                if (formated.indexOf('.') == -1) formated += '.';
                while (formated.length < formated.indexOf('.') + 3) formated += '0';

                return formated;
            }

            function onCardIOComplete(response) {
                $scope.cardNumber = response["cardNumber"];
                $scope.cardExpiryYear = response["expiryYear"];
                $scope.cardExpiryMonth = response["expiryMonth"];
                $scope.$apply();

                $("#inptCcNum").trigger("input");
            }

            function onCardIOCancel() {
                //alert("card.io scan cancelled");
            }

            $scope.scanCreditCard = function () {
                // from Ibrahim A. :// this is now a no-op, we've disabled card scanning entirely since the card.io plugin we use is outdated and no longer works
                // CardIO.scan({
                //     "requireExpiry": true,
                //     "scanExpiry": true,
                //     "requirePostalCode": false,
                //     "requireCVV": false,
                //     "restrictPostalCodeToNumericOnly": true,
                //     "hideCardIOLogo": true,
                //     "suppressScan": false,
                //     "keepApplicationTheme": true
                // }, onCardIOComplete, onCardIOCancel);
            }

            $scope.donateYesClick = function () {
                $scope.oneTimeDonationAmount = "1.00";
            }

        }
    ])
    .directive('numericonly', function () {  
        return {  
            require: 'ngModel',  
            link: function (scope, element, attr, ngModelCtrl) {  
                function fromUser(text) {  
                    var transformedInput = text.replace(/[^0-9.]/g, '');  
                    if (transformedInput !== text) {  
                        ngModelCtrl.$setViewValue(transformedInput);  
                        ngModelCtrl.$render();  
                    }  
                    return transformedInput;   
                }  
                ngModelCtrl.$parsers.push(fromUser);  
            }  
        };  
    }); 

'use strict';
angular.module('utilliApp')
.controller('PayByCheckController', ['$scope', '$http', '$state', '$window',
    '$stateParams', 'PayByCheckService', '$timeout', 'usSpinnerService', 'LeftMenuService', 
    'ModalServiceExt', 'CommonHeaderService', 'CommonDataService', '$q', 'PaymentVerificationService',
function ($scope, $http, $state, $window, $stateParams, PayByCheckService, $timeout,
    usSpinnerService, LeftMenuService, ModalServiceExt, CommonHeaderService, CommonDataService, $q,
    PaymentVerificationService) {

    LeftMenuService.setCurrentTab('PayByCheck');
    CommonHeaderService.setUpCancelButton();

    $scope.isIosMobile = isMobileOrRipple() && iOS();
    
    $scope.isDonationEnabled = true;
    $scope.isPayNowEnabled = false;
    $scope.isPayNowBtnText = 'Next';
    $scope.velocityFee = '';
    $scope.oneTimeDonationAmount = 0.00;
    $scope.donateRadio = "false";
    $scope.enrollRadio = "false";
    $scope.phoneNumberMask = Config.phoneNumberMask;
    $scope.errors = [];
    $scope.savedAccountsVisible = false;
    $scope.useSavedBankAccount = false;
    $scope.currentSavedAccount = {};
    $scope.savedAccounts = [];

    $scope.model = {};
    $scope.model.nameOnAccount = '';

    $scope.saveThisBankAccount = false;

    $scope.enableEnrollBankAccount = false;
    $scope.enrollThisBankAccount = false;
    $scope.isAssistant = utilli.hasAssistantRole(localStorage.getItem('SecurityToken'));
    $scope.isDirectDebitInProgress = false;

    $scope.emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    $scope.onlyNumbers = /^\d+$/;
    $scope.firstLastNamePattern = /^(\S)+( \S+)+$/;

    $scope.model.bankRoutingNumber = '';
    $scope.model.checkingAccountNumber = '';
    $scope.model.reenterCheckingAccountNumber = '';
    $scope.model.accountNumber = '';

    $scope.model.totalAmount = '';

    $scope.enableSaveBankAccounts = false;
    $scope.enableSaveCreditCards = false;

    $scope.isFeeEnabled = false;

    $scope.minimumPaymentAmountToAllowDonation = 0;

    initPicker();

    $scope.useSavedAccountClicked = function ()
    {
        if ($scope.useSavedBankAccount)
            $scope.useSavedBankAccount = false;
        else
            $scope.useSavedBankAccount = true;

        $scope.useSavedAccountChanged();
    }

    $scope.useSavedAccountChanged = function()
    {
        if ($scope.useSavedBankAccount)
        {
            $scope.currentSavedAccount = $scope.savedAccounts[0];
            for (var i = 0; i < $scope.savedAccounts.length; i++) {
                var bankAccountInfo = $scope.savedAccounts[i];
                if (bankAccountInfo.bankAccount.IsPrimary) {
                    $scope.currentSavedAccount = bankAccountInfo;
                    break;
                }
            }

            setCurrentSavedBankAccountAttributes();
        }
        else
        {
            $scope.model.bankRoutingNumber = '';
            $scope.model.checkingAccountNumber = '';
            $scope.model.reenterCheckingAccountNumber = '';
            $scope.model.nameOnAccount = '';

            if(!$scope.isDirectDebitInProgress)
            {
                $scope.enableEnrollBankAccount = true;
            }
        }
    }
    $scope.back = function ()
    {
        $state.goMainLayout('PayNow');
    }

    $scope.goDirectDebitFaq = function () {
        $state.goMainLayout('Faqs', { directDebitParam: 'true' });
    }

    $scope.getEnrollMessage = function () {
       
        var accountNumber = localStorage.getItem('CurrentAccountNumber');
        var url = localStorage.getItem('ApiUrl') + 'api/DirectDebit/GetEnrollMessageForOneTimePayment';
        $http({
            method: 'GET',
            url: url,
            params: { paymentType: '1', accountNumber: accountNumber, id: $stateParams.Id }
        }).success(function (data) {
            $scope.enrollMessage = data.Data.Message;
        }).error(function () {
        });
    }

    $scope.enrollInDirectDebitChanged = function()
    {
        if($scope.enrollThisBankAccount) {
            $scope.saveThisBankAccount = $scope.enrollThisBankAccount;
        }
        // if ($scope.useSavedBankAccount)
        // {
        //     $scope.currentSavedAccount = $scope.savedAccounts[0];
        //     for (var i = 0; i < $scope.savedAccounts.length; i++) {
        //         var bankAccountInfo = $scope.savedAccounts[i];
        //         if (bankAccountInfo.bankAccount.IsPrimary) {
        //             $scope.currentSavedAccount = bankAccountInfo;
        //             break;
        //         }
        //     }

        //     setCurrentSavedBankAccountAttributes();
        // }
    }

    $scope.goDirectDebitFaq = function () {
        $state.goMainLayout('Faqs', { directDebitParam: 'true' });
    }

    $scope.getEnrollMessage = function () {
       
        var accountNumber = localStorage.getItem('CurrentAccountNumber');
        var url = localStorage.getItem('ApiUrl') + 'api/DirectDebit/GetEnrollMessageForOneTimePayment';
        $http({
            method: 'GET',
            url: url,
            params: { paymentType: '1', accountNumber: accountNumber, id: $stateParams.Id }
        }).success(function (data) {
            $scope.enrollMessage = data.Data.Message;
        }).error(function () {
        });
    }

    $scope.enrollInDirectDebitChanged = function()
    {
        if($scope.enrollThisBankAccount) {
            $scope.saveThisBankAccount = $scope.enrollThisBankAccount;
        }
        // if ($scope.useSavedBankAccount)
        // {
        //     $scope.currentSavedAccount = $scope.savedAccounts[0];
        //     for (var i = 0; i < $scope.savedAccounts.length; i++) {
        //         var bankAccountInfo = $scope.savedAccounts[i];
        //         if (bankAccountInfo.bankAccount.IsPrimary) {
        //             $scope.currentSavedAccount = bankAccountInfo;
        //             break;
        //         }
        //     }

        //     setCurrentSavedBankAccountAttributes();
        // }
    }

    function setCurrentSavedBankAccountAttributes()
    {
        $scope.model.bankRoutingNumber = $scope.currentSavedAccount.bankAccount.RoutingNumber;
        $scope.model.checkingAccountNumber = $scope.currentSavedAccount.shortTitle;
        $scope.model.reenterCheckingAccountNumber = $scope.currentSavedAccount.shortTitle;
        $scope.model.nameOnAccount = $scope.currentSavedAccount.bankAccount.NameOnAccount;

        if(!$scope.isDirectDebitInProgress && $scope.currentSavedAccount.bankAccount.IsEnrolled)
        {
            $scope.enableEnrollBankAccount = false;
        }

        if(!$scope.isDirectDebitInProgress && !$scope.currentSavedAccount.bankAccount.IsEnrolled)
        {
            $scope.enableEnrollBankAccount = true;
        }
    }

    function resetPayBtn() {
        $scope.isPayNowBtnText = 'Next';
        $scope.isPayNowEnabled = false;
        $scope.velocityFee = '';
    }

    function getVelocityFee(newAmount) {
        var payAmount = utilli.parsePositiveFloat(newAmount);
        if (payAmount <= 0) {
            return;
        }
        
        usSpinnerService.spin('spinner-1');
        $http({
            url: localStorage.getItem('ApiUrl') + 'api/Payment/GetVelocityFee/',
            method: "GET",
            params: { Card: " ", Amount: payAmount, 
                AccountNumber: localStorage.getItem('CurrentAccountNumber'), Type: "3"  }
        })
        .then(function (res) {
            $scope.velocityFee = res.data.PPIFeeValue;
            $scope.isPayNowEnabled = true;
            $scope.isPayNowBtnText = 'Pay Now'
        }, ModalServiceExt.showAjaxError)
        .fixedFinally(function(){
            usSpinnerService.stop('spinner-1');
        });
    }

    function setSavedAccounts(data)
    {
        var foundPrimary = false;
        $scope.enableEnrollBankAccount = true;

        for (var i = 0; i < data.length; i++)
        {
            var bankAccount = data[i];

            var enrolledInfo = '';

            if(bankAccount.IsEnrolled)
            {
                enrolledInfo = 'Enrolled in Direct Debit'
            }
            else
            {
                enrolledInfo = 'Not enrolled in Direct Debit'
            }

            var accountInfo = { 
                title: $scope._t('Account ending with') + ' ' + bankAccount.BankAccountNumber + ' ' + enrolledInfo,
                shortTitle: $scope._t('Account ending with') + ' ' + bankAccount.BankAccountNumber,
                bankAccount: bankAccount 
            };

            $scope.savedAccounts.push(accountInfo);

            if (bankAccount.IsPrimary)
            {
                $scope.currentSavedAccount = accountInfo;
                foundPrimary = true;
            }

            if(bankAccount.IsDirectDebitInProgress)
            {
                $scope.isDirectDebitInProgress = true;
                $scope.enableEnrollBankAccount = false;
            }
        }

        if (!foundPrimary)
            $scope.currentSavedAccount = $scope.savedAccounts[0];

        if($scope.isAssistant)
        {
            $scope.enableEnrollBankAccount = false;
        }   

        setCurrentSavedBankAccountAttributes();
    };

    $scope.savedAccountChanged = function()
    {
        setCurrentSavedBankAccountAttributes();
    }

    function init()
    {
        usSpinnerService.spin('spinner-1');

        $scope.getEnrollMessage();

        var commonDataRequest = CommonDataService.getCommonData();
        var setCommonData = function (commonData) {
            $scope.showSchedulePayment = commonData.EnablePaymentScheduling;
            $scope.enableSaveBankAccounts = commonData.EnableSaveBankAccounts;
            $scope.enableSaveCreditCards = commonData.EnableSaveCards;
            $scope.isFeeEnabled = false;
        };
    
        var contractAccountNumber = localStorage.getItem('CurrentAccountNumber');
        var apiUrl = localStorage.getItem('ApiUrl');

        var customerInfoRequestParams = { contractAccountNumber: contractAccountNumber };
        utilli.addUserName($state, customerInfoRequestParams);
        var customerInfoRequest = $http({
            url: apiUrl + 'api/Customer/GetCustomerInfo/',
            method: "GET",
            params: customerInfoRequestParams
        });
        var setCustomerInfo = function (data) {
            var jsondata = data;
            if (jsondata) {
                if (jsondata.ERROR_LIST && jsondata.ERROR_LIST.length > 0) {
                    ModalServiceExt.showError(jsondata.ERROR_LIST[0].Message);
                } else {
                    var currentAccountData = data;
                    $scope.model.accountNumber = currentAccountData.account.AccountNumber;
                    $scope.model.payAmount = $scope.formatDecimal(Math.max(currentAccountData.userinfo.TotalOpenBalance, 0));

                    $scope.minimumPaymentAmountToAllowDonation = Math.max(currentAccountData.userinfo.TotalOpenBalance, 0);
                }
            } else {
                ModalServiceExt.showServerError();
            };
        };

        var profileRequestParams = { accountNumber: contractAccountNumber };
        utilli.addUserName($state, profileRequestParams);
        var profileRequest = $http({
            url: apiUrl + 'api/Profile/GetProfile/',
            method: "GET",
            params: profileRequestParams
        });
        var setProfileData = function (data) {
            if (data.Errors && data.Errors.length > 0) {
                ModalServiceExt.showServerError();
                return;
            }
            $scope.profile = data.AccountData;
            $scope.isDonationEnabled = !data.AccountData.IsRoundUpEnrolled;
            // we have mask that ensures that all phone numbers are stored in database as
            // 11 digit number that starts with 1, but ui-mask expect phone number 
            // to be 10 digits - the unmasked part
            if ($scope.profile.PrimaryPhoneNumber && $scope.profile.PrimaryPhoneNumber.length === 11) {
                $scope.model.phoneNumber = $scope.profile.PrimaryPhoneNumber.substr(1);
            }
            $scope.model.email = $scope.profile.Email;
        };

        var bankAccountsRequestParams = { accountNumber: contractAccountNumber };
        utilli.addUserName($state, bankAccountsRequestParams);
        var bankAccountsRequest = $http({
            url: apiUrl + 'api/ProfileBankAccountManage/GetBankAccounts',
            method: "GET",
            params: bankAccountsRequestParams
        });
        var setBankAccounts = function (data) {
            if (data == null || data.length == 0) {
                $scope.useSavedBankAccount = false;
                $scope.savedAccountsVisible = false;
            }
            else {
                $scope.useSavedBankAccount = true;
                $scope.savedAccountsVisible = true;
                setSavedAccounts(data);
            }
        };

        var feeInfoRequestParams = {
            accountNumber: contractAccountNumber
        };
        var feeInfoRequest = $http({
            url: apiUrl + 'api/Payment/GetConvFeeInfo/',
            method: "GET",
            params: feeInfoRequestParams
        });
        var setFeeInfo = function (data) {
            var jsondata = data;
            if (jsondata) {
                $scope.convFeeInfo = jsondata;
                $scope.updateAmounts();
            }
        };

        $q.all([commonDataRequest, customerInfoRequest, profileRequest, bankAccountsRequest, feeInfoRequest])
        .then(
            function(data){
                usSpinnerService.stop('spinner-1');
                setCommonData(data[0]);
                setCustomerInfo(data[1].data);
                setProfileData(data[2].data);
                setBankAccounts(data[3].data);
                setFeeInfo(data[4].data);
            }
        )
        .catch(function() {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });

        var minServiceAppointmentDate = (function () {
            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            return tomorrow;
        })();

        // init datepicker components
        $('input[name="scheduleDate"]').datepicker({
            autoclose: true,
            format: "m/d/yyyy",
            startDate: minServiceAppointmentDate,
            todayHighlight: true
        });
    }

    init();

    $scope.requestSchedulePayment = function () {
        usSpinnerService.spin('spinner-1');
        var params = { 
            contractAccountNumber: localStorage.getItem('CurrentAccountNumber'), 
            amount: $scope.model.payAmount, 
            paymentType: 'Check',
            paymentDate: $scope.scheduleDate.toUTCString()
        };
        utilli.addUserName($state, params);
        $http({
            url: localStorage.getItem('ApiUrl') + 'api/Payment/SchedulePayment/',
            method: "POST",
            data: params
        }).success(function (data) {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showMessage(
                $scope._t('Schedule Payment'),
                $scope._t('Your request to schedule a payment has been received. Thank you for your payment.'),
                function(){ $state.goMainLayout('Dashboard'); });
        }).error(function (error) {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }

    $scope.goDonationFaq = function () {
        $state.goMainLayout('Faqs', { donationParam: 'true' });
    }

    $scope.$watch('model.payAmount', function () {
        $scope.updateAmounts();
        $scope.amountError = utilli.parsePositiveFloat($scope.model.payAmount) === 0;
        resetPayBtn();
    });

    $scope.$watch('oneTimeDonationAmount', function (newValue, oldValue) {
        if ($scope.donateRadio == "true") {
            resetPayBtn();
            $scope.updateAmounts();
            $scope.oneTimeDonationAmountError = utilli.parsePositiveFloat($scope.oneTimeDonationAmount) === 0;
        }
        else {
            $scope.oneTimeDonationAmountError = false;
        }
    });

    $scope.$watch('donateRadio', function (newValue, oldValue) {
        $scope.updateAmounts();
        resetPayBtn();
        if (newValue == 'false') {
            $scope.oneTimeDonationAmount = '';
            $scope.oneTimeDonationAmountError = false;
        }
    });

    $scope.updateAmounts = function (amountToPay) {
        var payAmount = utilli.parsePositiveFloat($scope.model.payAmount);
        if (payAmount === 0) {
            $scope.model.totalAmount = '';
            $scope.model.convenienceFee = ''; // because fee may be some percentage from amount
            return;
        }

        var fee = 0;
        if ($scope.isFeeEnabled) {
            var feeInfo = $scope.convFeeInfo;
            if (feeInfo == null) return;
            if (feeInfo.FeeTypeAch == "percent") {
                fee = payAmount / 100 * feeInfo.FeeAmountAch;
            } else if (feeInfo.FeeTypeAch == "flat") {
                fee = feeInfo.FeeAmountAch;
            }
        }
        $scope.model.convenienceFee = $scope.formatDecimal(fee);

        var donation = 0;
        if ($scope.isDonationEnabled && $scope.donateRadio == "true") {
            donation = utilli.parsePositiveFloat($scope.oneTimeDonationAmount);
        }

        $scope.model.totalAmount = $scope.formatDecimal(payAmount + fee + donation);
    }

    $scope.model = $.extend({}, $scope.model, PayByCheckService.model); // restore form data

    $scope.paymentResultData = '';
    $scope.isResultShowing = false;

    $scope.cancel = function () {
        $window.history.back();
    };

    var getFormData = function () {

        var data = {
            AccountNumber: $scope.model.accountNumber,
            AmountToPay: $scope.model.payAmount,
            BankRoutingNumber: $scope.model.bankRoutingNumber,
            CheckingAccountNumber: $scope.model.checkingAccountNumber,
            Email: $scope.model.email,
            NameOnAccount: $scope.model.nameOnAccount,
            PhoneNumber: utilli.getFullPhoneNumber($scope.model.phoneNumber)
        };

        return data;
    };

    $scope.okAfterSuccessfulPayment = function () {
        $state.goMainLayout('Dashboard');
    }

    $scope.validate = function () {
        var result = true;
        var re, matched;

        $scope.amountError = false;

        $scope.errors = [];
        $scope.amountError = utilli.parsePositiveFloat($scope.model.payAmount) === 0;
        if ($scope.amountError) {
            result = false;
        }

        if (!$scope.amountError && parseFloat($scope.oneTimeDonationAmount) > 0 && utilli.parsePositiveFloat($scope.model.payAmount) < $scope.minimumPaymentAmountToAllowDonation) {
            result = false;
            ModalServiceExt.showError('You need to pay at least amount due to make donation.');
        }

        if (!$scope.model.bankRoutingNumber) {
            result = false;
        }
        else {
            re = /^[0-9]{9}$/i;
            matched = re.test($scope.model.bankRoutingNumber);
            if (!matched) {
                result = false;
            }
        }

        if (!$scope.useSavedBankAccount && !$scope.model.checkingAccountNumber) {
            result = false;
        }
        else if (!$scope.useSavedBankAccount) {
            re = /^[0-9]{0,17}$/i;
            matched = re.test($scope.model.checkingAccountNumber);
            if (!matched) {
                result = false;
            }
        }

        if ($scope.model.reenterCheckingAccountNumber == $scope.model.bankRoutingNumber) {
            result = false;
        }

        if ($scope.model.reenterCheckingAccountNumber != $scope.model.checkingAccountNumber) {
            result = false; // this is important!
        }

        if ($scope.payForm.$error.confirmCheckingAccount) {
            result = false;
        }

        if (!$scope.model.email) {
            result = false;
        }
        else {
            re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            matched = re.test($scope.model.email);
            if (!matched) {
                result = false;
            }
        }

        if ($scope.model.nameOnAccount == undefined || !$scope.model.nameOnAccount) {
            result = false;
        }

        if ($scope.model.nameOnAccount.length < 1) {
            result = false;
        }

        if (!$scope.model.phoneNumber) {
            result = false;
        }
        return result;
    }

    $scope.formatDecimal = function (decimal) {

        var formated = Math.round(parseFloat(decimal) * 100) / 100;

        formated = formated.toString();
        if (formated.indexOf('.') == -1) formated += '.';
        while (formated.length < formated.indexOf('.') + 3) formated += '0';

        return formated;
    }

    function initPicker() {
        $scope.dpOptions = utilli.datePickerOptions;
        $scope.altInputFormats = ['M!/d!/yyyy'];
    }

    $scope.pay = function () {
        if ($scope.scheduleButtonClicked) {
            if ($scope.scheduleDate) {
                usSpinnerService.spin('spinner-1');
                $timeout(function () {
                    usSpinnerService.stop('spinner-1');
                    $scope.requestSchedulePayment();
                }, 1500);
                return;
            }
        }


        var validated = $scope.validate();
        if (!validated) {
            $scope.errors = [{ Message: utilli.errors.validationErorrsMessage }];
            utilli.scrollTop();
            return;
        }
        if ($scope.isPayNowEnabled) {
            utilli.scrollTop();
            var apiUrl = localStorage.getItem('ApiUrl');
            var accountNumber = localStorage.getItem('CurrentAccountNumber');
            var requestData;
            if ($scope.useSavedBankAccount) {
                apiUrl += 'api/Payment/PayBySavedCheck';
                var bankAccountInfo = $scope.currentSavedAccount.bankAccount;
                requestData = {
                    bankAccountId: bankAccountInfo.Id,
                    AccountNumber: accountNumber,
                    AmountToPay: $scope.model.payAmount,
                    Phone: utilli.getFullPhoneNumber($scope.model.phoneNumber),
                    Email: $scope.model.email,
                    userId: $stateParams.userId
                };
            }
            else {
                apiUrl += 'api/Payment/PayByCheck';
                requestData = getFormData($('form[name="payForm"]'));
                requestData.saveThisBankAccount = $scope.saveThisBankAccount;
            }
            requestData.EnrollInRoundUp = $scope.enrollRadio == "true";
            requestData.DoOneTimeDonation = $scope.donationRadio == "true";
            requestData.OneTimeDonationAmount = parseFloat($scope.oneTimeDonationAmount);
            requestData.ConvenienceFee = parseFloat($scope.velocityFee);
            requestData.EnrollInDirectDebit = $scope.enrollThisBankAccount;


            /** sends payment info to the server */
            var postPayment = function () {
                usSpinnerService.spin('spinner-1');
                $http({
                    url: apiUrl,
                    method: "POST",
                    data: requestData
                }).success(function (response) {
                    if (response.IsSuccessful) {
                        PayByCheckService.paymentConfirmation = response.Message;
                        usSpinnerService.stop('spinner-1');

                        $state.goMainLayout('PayByCheckConfirmation');
                    }
                    else {
                        $scope.errors.push({ Message: response.Message });
                        usSpinnerService.stop('spinner-1');
                        utilli.scrollTop();
                        ModalServiceExt.showError(response.Message);
                    }
                }).error(function (data) {
                    PayByCheckService.model = $scope.model;
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showError(data);
                });
            }
            usSpinnerService.spin('spinner-1');
            PaymentVerificationService.verifyPaymentInfo(requestData.AmountToPay, postPayment);
        }
        else {
            getVelocityFee($scope.model.totalAmount);
        }
    };

    $scope.donateYesClick = function () {
        $scope.oneTimeDonationAmount = "1.00";
    };
}])
.directive("repeatAccount", function () {
    return {
        require: "ngModel",
        link: function (scope, elem, attrs, ctrl) {
            var otherInput = elem.inheritedData("$formController")[attrs.repeatAccount];

            ctrl.$parsers.push(function (value) {
                if (value === otherInput.$viewValue) {
                    ctrl.$setValidity("confirmCheckingAccount", true);
                    return value;
                }
                ctrl.$setValidity("confirmCheckingAccount", false);
            });

            otherInput.$parsers.push(function (value) {
                ctrl.$setValidity("confirmCheckingAccount", value === ctrl.$viewValue);
                return value;
            });
        }
    };
})
.directive('numericonly', function () {  
    return {  
        require: 'ngModel',  
        link: function (scope, element, attr, ngModelCtrl) {  
            function fromUser(text) {  
                var transformedInput = text.replace(/[^0-9.]/g, '');  
                if (transformedInput !== text) {  
                    ngModelCtrl.$setViewValue(transformedInput);  
                    ngModelCtrl.$render();  
                }  
                return transformedInput;   
            }  
            ngModelCtrl.$parsers.push(fromUser);  
        }  
    };  
}); 
angular.module('utilliApp')
    .controller('PayByCheckConfirmationController', ['$scope', 'PayByCheckService', '$state', 'CommonHeaderService',
        function ($scope, PayByCheckService, $state, CommonHeaderService) {
            CommonHeaderService.setUp();
            
            $scope.ok = function(){
                $state.goMainLayout('Dashboard');
            };
            $scope.init = function () {
                $scope.paymentResultMessage = PayByCheckService.paymentConfirmation;
                if ($scope.paymentResultMessage == '') {
                    $state.goMainLayout('Dashboard');
                }
            };
        }]);

angular.module('utilliApp')
    .service('PayByCheckService', function () {
        var _model = {};
        var _paymentConfirmation = '';
        return {
            model: _model,
            paymentConfirmation: _paymentConfirmation
        };
    });

'use strict';

angular.module('utilliApp')
.controller('PaymentOptionsController', ['$scope', '$rootScope', '$window', '$state', '$http', 'usSpinnerService',
        'LeftMenuService', 'ModalServiceExt', 'CommonHeaderService', 'CommonDataService',
function ($scope, $rootScope, $window, $state, $http, usSpinnerService, LeftMenuService, ModalServiceExt, CommonHeaderService, CommonDataService) {
    LeftMenuService.setCurrentTab('PaymentOptions');
    CommonHeaderService.setUp($scope._t('Payment Options/Direct Debit'));

    $scope.enableSaveBankAccounts = false;
    $scope.enableSaveCreditCards = false;

    $scope.isDataLoaded = false;
    $scope.PaymentOptions = [];
    //todo: to config

    CommonDataService.getCommonData().then(
    function (commonData) {
        $scope.showSchedulePayment = commonData.EnablePaymentScheduling;
        $scope.enableSaveBankAccounts = commonData.EnableSaveBankAccounts;
        $scope.enableSaveCreditCards = commonData.EnableSaveCards;
    },
    function () {
        ModalServiceExt.showServerError();
    });

    getPaymentOptions();

    $scope.addBa = function () {
        $state.goMainLayout('AddBankAccount');
    }

    $scope.addCard = function () {
        $state.goMainLayout('AddCard');
    }

    $scope.toCard = function (id) {
        $state.goMainLayout('Card', { Id: id });
    };

    $scope.toBankAccount = function (id) {
        $state.goMainLayout('BankAccount', { Id: id });
    };

    $scope.isOverdue = function(month, year)
    {
        var nowDate = new Date();
        var nowMonth = nowDate.getMonth() + 1;
        var nowYear = nowDate.getFullYear().toString().substr(2, 2);
        return nowYear > year || nowYear == year && nowMonth > month;
    }

    function getPaymentOptions() {
        startSpin();
        
        var params = { accountNumber: localStorage.getItem('CurrentAccountNumber') };
        utilli.addUserName($state, params);
        $http.get(
            localStorage.getItem('ApiUrl') + 'api/DirectDebit/GetPaymentOptions',
            { params: params })
                .success(function (response) {
                if (response.Errors && response.Errors.length > 0) {
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                } else if (response.Data != null && response.Data.Count > 0) {
                    $scope.PaymentOptions = response.Data.PageData;
                }
                $scope.isDataLoaded = true;
                stopSpin();
            }).
            error(function() {
                stopSpin();
                ModalServiceExt.showServerError();
            });
    }

    function startSpin() {
        usSpinnerService.spin('spinner-1');
    }

    function stopSpin() {
        usSpinnerService.stop('spinner-1');
    }
}]);
'use strict';
angular.module('utilliApp')
.controller('AddBankAccountController', ['$scope', '$http', '$q', '$rootScope', '$window', '$state', 'usSpinnerService',
    'LeftMenuService', 'ModalServiceExt', 'ModalService', 'CommonHeaderService', 
    function ($scope, $http, $q, $rootScope, $window, $state, usSpinnerService, LeftMenuService, ModalServiceExt, ModalService, CommonHeaderService) {
    var _t = $scope._t;
    // ReSharper restore InconsistentNaming

    LeftMenuService.setCurrentTab('AddBankAccount');
    CommonHeaderService.setUpCancelButton(_t('New Bank Account'));
    //todo: to config

    $scope.firstLastNamePattern = /^(\S)+( \S+)+$/;

    var bankAccount = {
        Id: '',
        BankAccountNumber: '',
        NameOnAccount: '',
        RoutingNumber: '',
        AccountType: '01',
        IsPrimary: false,
        IsEnrolled: false,
        EnrollmentType: '1'
    };
    $scope.BankAccount = bankAccount;

    $scope.submit = function () {
        if (!$scope.baDialog.$valid) {
            $scope.submitted = true;
            return;
        }
        startSpin();

        var requestData = {
            nameOnAccount: $scope.BankAccount.NameOnAccount,
            bankRoutingNumber: $scope.BankAccount.RoutingNumber,
            bankAccountNumber: $scope.BankAccount.BankAccountNumber,
            accountType: $scope.BankAccount.AccountType,
            accountNumber: localStorage.getItem('CurrentAccountNumber')
        };

        $http.post(localStorage.getItem('ApiUrl') + 'api/ProfileBankAccountManage/AddSavedBankAccount',
            requestData)
            .success(function (response) {
                if (response.Errors && response.Errors.length > 0) {
                    ModalServiceExt.showError(response.Errors[0]);
                }
                else {
                    // for HC we don't allow users to enroll a new BA in DD if DD is already in progress
                    if (utilli.isHc() && response.Data && response.Data.IsDirectDebitInProgress) {
                        stopSpin();
                        $state.goMainLayout('PaymentOptions');
                        return;
                    }
                    ModalServiceExt.showInfo(_t('Bank account information successfully stored'), function () {
                        if ($scope.BankAccount.EnrollmentType == '2')
                        {
                            $http.get(localStorage.getItem('ApiUrl') + 'api/DirectDebit/GetBankAccountSapIdByBankAccountAndRoutingNumber',
                                {
                                    params: {
                                        accountNumber: localStorage.getItem('CurrentAccountNumber'),
                                        bankAccountNumber: $scope.BankAccount.BankAccountNumber,
                                        routingNumber: $scope.BankAccount.RoutingNumber
                                    }
                                })
                            .success(function (response) {
                                if (response.Errors && response.Errors.length > 0) {
                                    ModalServiceExt.showError(response.Errors[0]);
                                    return;
                                } else if (response.Data != null) {
                                    var sapBankId = response.Data;
                                    $state.goMainLayout('EnrollBankAccountMessage', { Id: sapBankId });
                                }
                                $scope.isDataLoaded = true;
                                stopSpin();
                            })
                            .error(function () {
                                stopSpin();
                                ModalServiceExt.showServerError();
                            });
                        }
                        else 
                        {
                            $state.goMainLayout('PaymentOptions');
                        }
                    });
                    // ModalServiceExt.showYesNoMessage(
                    //     $scope._t('Enroll in Direct Debit'), 
                    //     $scope._t('Do you want to enroll this bank account in the Direct Debit Program?'), 
                    //     function () {
                    //         debugger
                    //         $http.get(localStorage.getItem('ApiUrl') + 'api/DirectDebit/GetBankAccountSapIdByBankAccountAndRoutingNumber',
                    //             {
                    //                 params: {
                    //                     accountNumber: localStorage.getItem('CurrentAccountNumber'),
                    //                     bankAccountNumber: $scope.BankAccount.BankAccountNumber,
                    //                     routingNumber: $scope.BankAccount.RoutingNumber
                    //                 }
                    //             })
                    //         .success(function (response) {
                    //             if (response.Errors && response.Errors.length > 0) {
                    //                 ModalServiceExt.showError(response.Errors[0]);
                    //                 return;
                    //             } else if (response.Data != null) {
                    //                 var sapBankId = response.Data;
                    //                 $state.goMainLayout('EnrollBankAccountMessage', { Id: sapBankId });
                    //             }
                    //             $scope.isDataLoaded = true;
                    //             stopSpin();
                    //         })
                    //         .error(function () {
                    //             stopSpin();
                    //             ModalServiceExt.showServerError();
                    //         });
                    //     },
                    //     function(){ $state.goMainLayout('PaymentOptions'); },
                    //     true,
                    //     function(){ $state.goMainLayout('PaymentOptions'); }
                    // );
                }
                stopSpin();
            }).error(function () {
                ModalServiceExt.showServerError();
                stopSpin();
            });
    }

    function startSpin() {
        usSpinnerService.spin('spinner-1');
    };

    function stopSpin() {
        usSpinnerService.stop('spinner-1');
    };
}]);
'use strict';
angular.module('utilliApp')
.controller('AddCardController', ['$scope', '$http', '$q', '$rootScope', '$window', 'usSpinnerService', '$state',
        'LeftMenuService', 'ModalServiceExt', 'CommonHeaderService',
// ReSharper disable InconsistentNaming
function ($scope, $http, $q, $rootScope, $window, usSpinnerService, $state, LeftMenuService,
    ModalServiceExt, CommonHeaderService) {
    var _t = $scope._t;
    // ReSharper restore InconsistentNaming

    $scope.firstLastNamePattern = /^(\S)+( \S+)+$/;

    $scope.isMobile = isMobileOrRipple();
    $scope.deviceIsWindowsPhone = deviceIsWindowsPhone;

    LeftMenuService.setCurrentTab('AddCard');
    CommonHeaderService.setUpCancelButton(_t('New Card'));

    $scope.cancel = function () {
        $window.history.back();
    };

    var card = {
        id: '',
        number: '',
        holderName: '',
        isPrimary: false,
        enrolled: false,
        expMonth: '',
        expYear: ''
    };
    $scope.Card = card;

    $scope.submit = function () {
        if (!$scope.addCardDialog.$valid) {
            $scope.submitted = true;
            return;
        }

        if ($scope.addCardDialog.number.$type === 'JCB'
            || $scope.addCardDialog.number.$type === 'American Express'
            || $scope.addCardDialog.number.$type === 'Diners Club') {
            return;
        }

        usSpinnerService.spin('spinner-1');
        var requestData = {
            cardNumber: $scope.Card.number,
            expirationDate: '' + $scope.Card.expMonth + $scope.Card.expYear,
            cardHolderName: $scope.Card.holderName,
            accountNumber: localStorage.getItem('CurrentAccountNumber')
        };
        utilli.addUserName($state, requestData);
        $http.post(localStorage.getItem('ApiUrl') + 'api/ProfileCardManage/AddSavedCard',
            requestData)
            .success(function (response) {
                usSpinnerService.stop('spinner-1');
                if (response.Errors && response.Errors.length > 0) {
                    ModalServiceExt.showError(response.Errors[0]);
                } else if (response.Data == null) {
                    ModalServiceExt.showUnexpectedError();
                }
                else {
                    ModalServiceExt.showInfo(_t('Credit card information successfully stored'), function () {
                        $state.goMainLayout('PaymentOptions');
                    });
                }
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
    }

    function onCardIOComplete(response) {
        $scope.Card.number = response["cardNumber"];
        $scope.Card.expYear = response["expiryYear"];
        $scope.Card.expMonth = response["expiryMonth"];
        $scope.$apply();

        $("#inptCcNum").trigger("input");
    }

    function onCardIOCancel() {
        //alert("card.io scan cancelled");
    }

    $scope.scanCreditCard = function () {
        // from Ibrahim A. :// this is now a no-op, we've disabled card scanning entirely since the card.io plugin we use is outdated and no longer works
        // CardIO.scan({
        //     "requireExpiry": true,
        //     "scanExpiry": true,
        //     "requirePostalCode": false,
        //     "requireCVV": false,
        //     "restrictPostalCodeToNumericOnly": true,
        //     "hideCardIOLogo": true,
        //     "suppressScan": false,
        //     "keepApplicationTheme": true
        // }, onCardIOComplete, onCardIOCancel);
    }
}]);
angular.module('utilliApp')
.controller('BankAccountController', ['$scope', '$http', '$q', '$rootScope', '$window', 'usSpinnerService', '$state',
        'ModalService', 'ModalServiceExt', 'LeftMenuService', 'CommonDataService', 'CommonHeaderService', '$stateParams',
function ($scope, $http, $q, $rootScope, $window, usSpinnerService, $state, ModalService, ModalServiceExt,
    LeftMenuService, CommonDataService, CommonHeaderService, $stateParams) {
        var _t = $scope._t;

    LeftMenuService.setCurrentTab('BankAccount');
    CommonHeaderService.setUpBackButton($scope._t('Bank Account'));

    $scope.enableDirectDebit = false;
    $scope.isAssistant = utilli.hasAssistantRole(localStorage.getItem('SecurityToken'));

    initBa();

    $scope.cancel = function () {
        $state.goMainLayout('PaymentOptions');
    };

    $scope.goDirectDebitFaq = function () {
        $state.goMainLayout('Faqs', { directDebitParam: 'true' });
    }

    $scope.togglePrimaryBankAccount = function () {
        startSpin();
        $http({
            url: localStorage.getItem('ApiUrl') + 'api/ProfileBankAccountManage/SetPrimarySavedBankAccount',
            method: 'POST',
            data: {
                bankAccountId: $scope.BankAccount.Id,
                accountNumber: localStorage.getItem('CurrentAccountNumber')
            }
        }).success(function (response) {
            if (response.Errors && response.Errors.length > 0) {
                stopSpin();
                ModalServiceExt.showError(response.Errors[0]);
                return;
            }
            $scope.BankAccount.IsPrimary = !$scope.BankAccount.IsPrimary;
            stopSpin();
            if ($scope.BankAccount.IsPrimary)
                ModalServiceExt.showInfo($scope._t('Successfully set as primary account'));
            else
                ModalServiceExt.showInfo($scope._t('Successfully removed as primary account'));
        }).error(function (data) {
            stopSpin();
            ModalServiceExt.showServerError();
        });
    }

    $scope.showDeleteConfirmation = function () {
        ModalServiceExt.showYesNoMessage($scope._t('Yes or No?'), $scope._t('Are you sure you want to delete this bank account?'), deleteBankAccount);
    };

    function deleteBankAccount() {
        startSpin();
        
        $http({
            url: localStorage.getItem('ApiUrl') + 'api/ProfileBankAccountManage/DeleteSavedBankAccount',
            method: 'POST',
            data: {
                bankAccountId: $scope.BankAccount.Id,
                accountNumber: localStorage.getItem('CurrentAccountNumber')
            }
        }).success(function (response) {
            if (response.Errors && response.Errors.length > 0) {
                stopSpin();
                ModalServiceExt.showError(response.Errors[0]);
                return;
            }

            stopSpin();

            ModalServiceExt.showInfo($scope._t('Bank Account information successfully removed.'), function () {
                $state.goMainLayout('PaymentOptions');
            });
        }).error(function (data) {
            stopSpin();
            ModalServiceExt.showServerError();
        });
    }

    $scope.toggleEnrollment = function () {
        if (utilli.isHc() && $scope.BankAccount.IsDirectDebitInProgress) {
            ModalServiceExt.showError(_t("Unsuccessful! Reason: direct debit is pending."));
            return;
        }
        if ($scope.BankAccount.IsEnrolled) {
            $state.goMainLayout('UnenrollBankAccountMessage', { Id: $stateParams.Id });
        }
        else {
            $state.goMainLayout('EnrollBankAccountMessage', { Id: $stateParams.Id });
        }
    }

    function initBa() {
        if (!$stateParams.Id)
        {
            $state.goMainLayout('PaymentOptions');
            return;
        }
            
        startSpin();
        
        $http.get(localStorage.getItem('ApiUrl') + 'api/ProfileBankAccountManage/GetBankAccount', {
            params: {
                accountNumber: localStorage.getItem('CurrentAccountNumber'),
                baId: $stateParams.Id
            }
        }).success(function(response) {
            if (response.Errors && response.Errors.length > 0) {
                ModalServiceExt.showError(response.Errors[0], function() {
                    $state.goMainLayout('PaymentOptions');
                });
                stopSpin();
                return;
            }
            $scope.BankAccount = response.Data;

            CommonDataService.getCommonData()
                .then(function(commonData) {
                    $scope.enableDirectDebit = commonData.EnableSavedBankAccountsInDirectDebitGrid;
                });

            stopSpin();
        }).error(function() {
            stopSpin();
            ModalServiceExt.showServerError();
        });
    }

    function startSpin() {
        usSpinnerService.spin('spinner-1');
    };

    function stopSpin() {
        usSpinnerService.stop('spinner-1');
    };
}]);
'use strict';
angular.module('utilliApp')
    .controller('EnrollBankAccountMessageController', ['$scope', '$http', '$rootScope', '$window', '$state',
        'usSpinnerService', 'LeftMenuService', 'ModalServiceExt', 'CommonHeaderService', '$stateParams',
    function ($scope, $http, $rootScope, $window, $state, usSpinnerService, LeftMenuService,
        ModalServiceExt, CommonHeaderService, $stateParams) {

        LeftMenuService.setCurrentTab('EnrollBankAccountMessage');
        CommonHeaderService.setUpBackButton($scope._t('Enroll'), true);
        $scope.enrollMessage = $scope._t('loading...');
        $scope.errors = [];

        if (!$stateParams.Id)
            $state.goMainLayout('PaymentOptions');

        $scope.init = function () {
            startSpin();
            
            var accountNumber = localStorage.getItem('CurrentAccountNumber');
            var url = localStorage.getItem('ApiUrl') + 'api/DirectDebit/GetEnrollMessage';
            $http({
                method: 'GET',
                url: url,
                params: { paymentType: '1', accountNumber: accountNumber, id: $stateParams.Id }
            }).success(function (data) {
                $scope.enrollMessage = data.Data.Message;

                if (data.Data.WasEnrolled) {
                    $scope.wasEnrolled = true;
                    $scope.errors.push({ Message: $scope._t('This Bank Account was already enrolled.') });
                }

                stopSpin();
            }).error(function () {
                stopSpin();
            });
        }

        $scope.enroll = function () {
            startSpin();

            var url = localStorage.getItem('ApiUrl') + 'api/DirectDebit/EnrollSavedBankAccount';
            $http({
                url: url,
                method: 'POST',
                data: {
                    id: $stateParams.Id,
                    accountNumber: localStorage.getItem('CurrentAccountNumber'),
                    userId: $stateParams.userId
                }
            }).success(function (response) {
                if (response.Errors && response.Errors.length > 0) {
                    stopSpin();
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }

                stopSpin();
                ModalServiceExt.showInfo($scope._t('Bank account was successfully enrolled.'), function () {
                    $state.goMainLayout('BankAccount', { Id: $stateParams.Id });
                });
            }).error(function () {
                stopSpin();
                ModalServiceExt.showServerError();
            });
        }

        $scope.cancel = function () {
            $window.history.back();
        }

        function startSpin() {
            usSpinnerService.spin('spinner-1');
        };

        function stopSpin() {
            usSpinnerService.stop('spinner-1');
        };
    }])
'use strict';
angular.module('utilliApp')
.controller('CardController',
['$scope', '$http', '$q', '$rootScope', '$window', '$state', 'usSpinnerService', 'ModalService', 'ModalServiceExt',
    'LeftMenuService', 'CommonDataService', 'CommonHeaderService', '$stateParams', 
    // ReSharper disable InconsistentNaming
    function ($scope, $http, $q, $rootScope, $window, $state, usSpinnerService, ModalService, ModalServiceExt,
        LeftMenuService, CommonDataService, CommonHeaderService, $stateParams) {
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming

        LeftMenuService.setCurrentTab('Card');
        CommonHeaderService.setUpBackButton(_t('Credit/Debit Card'));

        $scope.enableDirectDebit = false;
        $scope.isAssistant = utilli.hasAssistantRole(localStorage.getItem('SecurityToken'));

        initCard();

        $scope.cancel = function () {
            $state.goMainLayout('PaymentOptions');
        };

        $scope.goDirectDebitFaq = function () {
            $state.goMainLayout('Faqs', { directDebitParam: 'true' });
        }

        $scope.togglePrimaryCard = function () {
            startSpin();
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/ProfileCardManage/SetPrimarySavedCard',
                method: 'POST',
                data: {
                    cardId: $scope.Card.Id,
                    accountNumber: localStorage.getItem('CurrentAccountNumber')
                }
            }).success(function(response) {
                if (response.Errors && response.Errors.length > 0) {
                    stopSpin();
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }
                $scope.Card.IsPrimary = !$scope.Card.IsPrimary;
                stopSpin();
                if ($scope.Card.IsPrimary)
                    ModalServiceExt.showInfo(_t('Successfully set as primary account'));
                else
                    ModalServiceExt.showInfo(_t('Successfully removed as primary account'));
            }).error(function() {
                stopSpin();
                ModalServiceExt.showServerError();
            });
        }

        function deleteCard() {
            startSpin();
            var deleteRequest = {
                id: $scope.Card.Id,
                accountNumber: localStorage.getItem('CurrentAccountNumber')
            };
            utilli.addUserName($state, deleteRequest);
            $http.post(localStorage.getItem('ApiUrl') + 'api/ProfileCardManage/DeleteSavedCard', deleteRequest)
            .success(function(response) {
                if (response.Errors && response.Errors.length > 0) {
                    stopSpin();
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }
                stopSpin();

                ModalServiceExt.showInfo(_t('Credit Card information successfully removed.'), function () {
                    $state.goMainLayout('PaymentOptions');
                });
            }).error(function() {
                stopSpin();
                ModalServiceExt.showServerError();
            });
        }

        $scope.toggleEnrollment = function () {
            if ($scope.Card.IsEnrolled) {
                $state.goMainLayout('UnenrollCardMessage', { Id: $stateParams.Id });
            }
            else {
                $state.goMainLayout('EnrollCardMessage', { Id: $stateParams.Id });
            }
        }

        $scope.showDeleteConfirmation = function () {
            ModalServiceExt.showYesNoMessage(_t('Yes or No?'), _t('Are you sure you want to delete this card?'),
                deleteCard);
        };

        function initCard() {
            if (!$stateParams.Id) {
                $state.goMainLayout('PaymentOptions');
                return;
            }

            startSpin();
            
            var params = {
                accountNumber: localStorage.getItem('CurrentAccountNumber'),
                cardId: $stateParams.Id
            };
            utilli.addUserName($state, params);
            $http.get(localStorage.getItem('ApiUrl') + 'api/ProfileCardManage/GetCreditCard', {
                params: params
            }).success(function(response) {
                if (response.Errors && response.Errors.length > 0) {
                    ModalServiceExt.showError(response.Errors[0], function() {
                        $state.goMainLayout('PaymentOptions');
                    });

                    stopSpin();
                    return;
                }
                $scope.Card = response.Data;
                CommonDataService.getCommonData()
                    .then(function(commonData) {
                        $scope.enableDirectDebit = commonData.EnableSavedCreditCardsInDirectDebitGrid;
                    });

                stopSpin();
            }).error(function() {
                stopSpin();
                ModalServiceExt.showServerError();
            });
        }

        function startSpin() {
            usSpinnerService.spin('spinner-1');
        };

        function stopSpin() {
            usSpinnerService.stop('spinner-1');
        };
    }])
 ;

'use strict';
angular.module('utilliApp')
    .controller('EnrollCardMessageController', ['$scope', '$http', '$rootScope', '$window', '$state', 'usSpinnerService',
        'LeftMenuService', 'ModalServiceExt', 'CommonHeaderService', '$stateParams',
        function ($scope, $http, $rootScope, $window, $state, usSpinnerService, LeftMenuService, ModalServiceExt,
            CommonHeaderService, $stateParams) {

        LeftMenuService.setCurrentTab('EnrollCardMessage');
        CommonHeaderService.setUpBackButton($scope._t('Enroll'), true);
        $scope.enrollMessage = $scope._t('loading...');
        $scope.errors = [];

        if (!$stateParams.Id)
            $state.goMainLayout('PaymentOptions');

        $scope.init = function ()
        {
            startSpin();
            
            var accountNumber = localStorage.getItem('CurrentAccountNumber');
            var url = localStorage.getItem('ApiUrl') + 'api/DirectDebit/GetEnrollMessage';
            $http({
                method: 'GET',
                url: url,
                params: {
                    paymentType: '0',
                    accountNumber: accountNumber,
                    id: $stateParams.Id,
                    userId: $stateParams.userId
                }
            }).success(function (data) {
                $scope.enrollMessage = data.Data.Message;

                if (data.Data.WasEnrolled) {
                    $scope.wasEnrolled = true;
                    $scope.errors.push({ Message: $scope._t('This Card was already enrolled.') });
                }

                stopSpin();
            }).error(function () {
                stopSpin();
            });
        }

        $scope.enroll = function ()
        {
            startSpin();

            var url = localStorage.getItem('ApiUrl') + 'api/DirectDebit/EnrollSavedCreditCard';
            $http({
                url: url,
                method: 'POST',
                data: {
                    id: $stateParams.Id,
                    accountNumber: localStorage.getItem('CurrentAccountNumber')
                }
            }).success(function (response) {
                if (response.Errors && response.Errors.length > 0) {
                    stopSpin();
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }

                stopSpin();
                ModalServiceExt.showInfo($scope._t('Card was successfully enrolled.'), function () {
                    $state.goMainLayout('Card', { Id: $stateParams.Id });
                });
            }).error(function () {
                stopSpin();
                ModalServiceExt.showServerError();
            });
        }

        $scope.cancel = function ()
        {
            $window.history.back();
        }

        function startSpin() {
            usSpinnerService.spin('spinner-1');
        };

        function stopSpin() {
            usSpinnerService.stop('spinner-1');
        };
    }])
'use strict';
angular.module('utilliApp')
    .controller('UnenrollCardMessageController', ['$scope', '$http', '$rootScope', '$window', '$state', 'usSpinnerService',
        'LeftMenuService', 'ModalServiceExt', 'CommonHeaderService', '$stateParams',
    function ($scope, $http, $rootScope, $window, $state, usSpinnerService, LeftMenuService,
        ModalServiceExt, CommonHeaderService, $stateParams) {

        LeftMenuService.setCurrentTab('EnrollCardMessage');
        CommonHeaderService.setUpBackButton($scope._t('Unenroll'), true);
        $scope.unenrollMessage = 'loading...';
        $scope.errors = [];

        if (!$stateParams.Id)
            $state.goMainLayout('PaymentOptions');

        $scope.init = function ()
        {
            startSpin();
            
            var url = localStorage.getItem('ApiUrl') + 'api/DirectDebit/GetUnenrollMessage';
            $http({
                method: 'GET',
                url: url,
                params: {
                    accountNumber: localStorage.getItem('CurrentAccountNumber'),
                    optionId: $stateParams.Id,
                    paymentType: '0'
                }
            }).success(function (data) {
                $scope.unenrollMessage = data.Data.Message;

                if (!data.Data.WasEnrolled) {
                    $scope.wasUnenrolled = true;
                    $scope.errors.push({ Message: $scope._t('This Card is not enrolled or was already unenrolled.') });
                }

                stopSpin();
            }).error(function () {
                stopSpin();
            });
        }

        $scope.unenroll = function () {
            startSpin();
            var url = localStorage.getItem('ApiUrl') + 'api/DirectDebit/DbUnenroll';
            $http({
                url: url,
                method: 'POST',
                data: {
                    id: $stateParams.Id,
                    accountNumber: localStorage.getItem('CurrentAccountNumber'),
                    userId: $stateParams.userId
                }
            }).success(function (response) {
                if (response.Errors && response.Errors.length > 0) {
                    stopSpin();
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }
                stopSpin();
                ModalServiceExt.showInfo($scope._t('Card was successfully unenrolled.'), function () {
                    $state.goMainLayout('Card', { Id: $stateParams.Id });
                });
            }).error(function () {
                stopSpin();
                ModalServiceExt.showServerError();
            });
        }

        $scope.cancel = function ()
        {
            $window.history.back();
        }

        function startSpin() {
            usSpinnerService.spin('spinner-1');
        };

        function stopSpin() {
            usSpinnerService.stop('spinner-1');
        };
    }])
'use strict';
angular.module('utilliApp')
    .controller('UnenrollBankAccountMessageController', ['$scope', '$http', '$rootScope', '$window', '$state',
        'usSpinnerService', 'LeftMenuService', 'ModalServiceExt', 'CommonHeaderService', '$stateParams',
    function ($scope, $http, $rootScope, $window, $state, usSpinnerService, LeftMenuService,
        ModalServiceExt, CommonHeaderService, $stateParams) {

        LeftMenuService.setCurrentTab('EnrollBankAccountMessage');
        CommonHeaderService.setUpBackButton($scope._t('Unenroll'), true);
        $scope.unenrollMessage = $scope._t('loading...');
        $scope.errors = [];

        if (!$stateParams.Id)
            $state.goMainLayout('PaymentOptions');

        $scope.init = function () {
            startSpin();
            var url = localStorage.getItem('ApiUrl') + 'api/DirectDebit/GetUnenrollMessage';
            $http({
                method: 'GET',
                url: url,
                params: {
                    accountNumber: localStorage.getItem('CurrentAccountNumber'),
                    optionId: $stateParams.Id,
                    paymentType: '1'
                }
            }).success(function (data) {
                $scope.unenrollMessage = data.Data.Message;

                if (!data.Data.WasEnrolled) {
                    $scope.wasUnenrolled = true;
                    $scope.errors.push({ Message: $scope._t('This Bank Account is not enrolled or was already unenrolled.') });
                }

                stopSpin();
            }).error(function () {
                stopSpin();
            });
        }

        $scope.unenroll = function () {
            startSpin();
            
            var url = localStorage.getItem('ApiUrl') + 'api/DirectDebit/DbUnenroll';
            $http({
                url: url,
                method: 'POST',
                data: {
                    id: $stateParams.Id,
                    accountNumber: localStorage.getItem('CurrentAccountNumber'),
                    userId: $stateParams.userId
                }
            }).success(function (response) {
                if (response.Errors && response.Errors.length > 0) {
                    stopSpin();
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }
                stopSpin();
                ModalServiceExt.showInfo($scope._t('Bank account was successfully unenrolled.'), function () {
                    $state.goMainLayout('BankAccount', { Id: $stateParams.Id });
                });
            }).error(function () {
                stopSpin();
                ModalServiceExt.showServerError();
            });
        }

        $scope.cancel = function () {
            $window.history.back();
        }

        function startSpin() {
            usSpinnerService.spin('spinner-1');
        };

        function stopSpin() {
            usSpinnerService.stop('spinner-1');
        };
    }])
'use strict';
angular.module('utilliApp')
.controller('MaintenanceController', ['$scope', '$http', '$state', '$q', 'usSpinnerService', '$window',
    '$timeout', 'ServiceProvidersService', '$sce', 'CheckVersionService',
    function ($scope, $http, $state, $q, usSpinnerService, $window, $timeout, ServiceProvidersService, $sce,
        CheckVersionService) {

    var intervalId = -1;
    $scope.isLoading = true;
    initProviders();

    function getProviderNamesFor(shortGroupName) {
        var result = [];
        for (var providerName in Config.providers) {
            var shortName = Config.providers[providerName].providersGroupShortName;
            if(shortName && shortName == shortGroupName)
                result.push(providerName);
        }
        return result;
    } 
    
    function initProviders() {
        if(!isMobileOrRipple()){
            getContactPhones(DeploymentSettings.currentServiceProvider);
            return;
        }
        $scope.providers = getProviderNamesFor(DeploymentSettings.providersGroupShortName);
        if($scope.providers.length == 1)
            getContactPhones($scope.providers[0]);
    }

    $timeout(function () {//todo: refactor it - now $timeout is used to the spinner can work
        initPing();
    }, 0);

    function initPing() {
        // set checking interval 1 minute.
        intervalId = setInterval($scope.check, 60000);
        ping();
    }

    $scope.providerChanged = function () { 
        if($scope.serviceProvider){
            getContactPhones($scope.serviceProvider);
            return;
        }
        $scope.contactsInfo = null;
    }

    function ping() {
        $scope.check();
    }

    function getContactPhones(serviceProvider) {
        usSpinnerService.spin('spinner-1');
        var url = DeploymentSettings.providersServiceUrl
            + 'StaticData/GetContactPhonesHtml/?serviceProvider='
            + serviceProvider;
        $http({
            url: url
        }).success(function (data) {
            usSpinnerService.stop('spinner-1');
            $scope.contactsInfo = $sce.trustAsHtml(data);
            $scope.phoneLoaded = true;
            $scope.hasContacts = true;
            $scope.isLoading = false;
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            $scope.failedAttempt = true;
            $scope.isLoading = false;
            $scope.hasContacts = false;
        });
    }

    $scope.check = function () {
        var url = localStorage.getItem('ApiUrl');
        if (!url && isMobileOrRipple()) {
            if (intervalId != -1)
                clearInterval(intervalId);
            // if we are running in a phone then we might not have ApiUrl because the user hasn't ever login yet.
            // hence we need to use providersApiUrl to check for maintenance. but providers web api we can't put 
            // on maintenance using AppOffline.htm approach because we need it to be working to get support phone
            // number. hence we change compatible version to '-2' in UtilliConfig.json for providers web api
            // and catch it here.
            usSpinnerService.spin('spinner-1');

            $http.get(DeploymentSettings.providersServiceUrl + "Version/IsProvidersWebApiOnMaintenance")
                .then(function (result) {
                    if (!result.data){
                        $state.goToSignIn();
                    }
                }).fixedFinally(function() {
                usSpinnerService.stop('spinner-1');
            });
            return;
        }
        else if (url) {
            usSpinnerService.spin('spinner-1');
            url += 'api/System/Check';
            makeChecking(url)
                .then(function () {
                    usSpinnerService.stop('spinner-1');
                });
        }
        else {
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getProviderApiUrl()
                .then(function (apiUrl) {
                    usSpinnerService.stop('spinner-1');
                    url = apiUrl + 'api/System/Check';
                    return makeChecking(url);
                })
                .then(function () {
                    usSpinnerService.stop('spinner-1');
                }).catch(function (error) {
                    usSpinnerService.stop('spinner-1');
                });
        }
    }

    function makeChecking(url) {
        var result = $q.defer();
        $http({
            url: url,
            method: 'GET'
        }).success(function (data) {
            if (data !== 'success') {
                result.resolve();
                return;
            }

            if (intervalId != -1)
                clearInterval(intervalId);

            localStorage.removeItem("offline");
            var token = localStorage.getItem('SecurityToken');
            var account = localStorage.getItem('CurrentAccountNumber');
            if (!token || !account) {
                $state.goToSignIn();
                result.resolve();
                return;
            }

            if (!utilli.isPropertyManagerApp()) 
                $state.goMainLayout('Dashboard');
            else 
                $state.goMainLayout('PropertyStackedDashboard');

            result.resolve();

        }).error(function (e) {
            result.resolve();
        });
        return result.promise;
    }
}]);
'use strict';
angular.module('utilliApp')
.controller('AboutUsController', ['$scope', '$http', '$q', '$rootScope', '$window', 'usSpinnerService', '$state',
        'LeftMenuService', 'ModalServiceExt', 'CommonHeaderService', '$sce', 'OpenFileService',
function ($scope, $http, $q, $rootScope, $window, usSpinnerService, $state, LeftMenuService,
    ModalServiceExt, CommonHeaderService, $sce, OpenFileService) {

    LeftMenuService.setCurrentTab('AboutUs');
    CommonHeaderService.setUpBackButton($scope._t('About Us'));

    $scope.aboutUsHtml = '';

    $scope.cancel = function () {
        $window.history.back();
    };

    $scope.openPdf = function(filePath){
        usSpinnerService.spin('spinner-1');
        OpenFileService.openPdf(filePath).catch(function(err){ 
            ModalServiceExt.showError(err);
        }).fixedFinally(function(){
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.init = function () {
        var apiUrl = localStorage.getItem('ApiUrl');
        var url = apiUrl + 'api/StaticData/GetAboutUsText/';
        startSpin();
            $http({
                url: url,
                method: "GET"
            }).success(function (data) {
                $scope.aboutUsHtml = $sce.trustAsHtml(data);
                stopSpin();
            }).error(function () {
                stopSpin();
            });

    }

    //todo: improve the service
    function startSpin() {
        usSpinnerService.spin('spinner-1');
    };

    function stopSpin() {
        usSpinnerService.stop('spinner-1');
    };
}]);
'use strict';
angular.module('utilliApp')
.controller('DonationHistoryController', ['$scope', 'LeftMenuService', 'CommonHeaderService', '$window', '$http', 'usSpinnerService', 'ModalServiceExt',
    function ($scope, LeftMenuService, CommonHeaderService, $window, $http, usSpinnerService, ModalServiceExt) {

        var _t = $scope._t; 
        LeftMenuService.setCurrentTab('ProgramEnrolments');
        CommonHeaderService.setUpBackButton(_t('Donation History'));

        var apiUrl = localStorage.getItem('ApiUrl');
        var accountNumber = localStorage.getItem('CurrentAccountNumber');
        $scope.years = [''];
        $scope.year = $scope.years[0];
        $scope.donations = null;

        usSpinnerService.spin('spinner-1');

        getDonations();

        function getDonations() {
            $http({
                url: apiUrl + 'api/Donation/GetDonationHistory',
                method: 'GET',
                params: { accountNumber: accountNumber, year: $scope.year }
            })
            .success(function (result) {
                usSpinnerService.stop('spinner-1');
                if (result.Errors && result.Errors.length > 0) {
                    ModalServiceExt.showError(result.Errors[0]);
                    return;
                }
                $scope.donations = result.Data;
                $scope.years = [];
                _.each($scope.donations, function (item) {
                    var year = new Date(Date.parse(item.Date)).getFullYear();
                    if (!_.contains($scope.years, year)) {
                        $scope.years.push(year);
                    }
                });
                //$scope.years.push('');
                $scope.year = $scope.years[0];
                $scope.yearChanged();
            })
            .error(function (error) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }

        $scope.gridOptions = {
            columns: [
                //{
                //    field: "InvoiceNumber",
                //    title: $scope._t("Document Number"),
                //    width: 100
                //}, 
                {
                    field: "Date",
                    title: $scope._t("Date"),
                    template: "#= DisplayedDate #",
                    width: 70
                },
                {
                    field: "Donation",
                    title: $scope._t("Donation"),
                    template: "#= kendo.toString(Donation, 'C') #",
                    width: 50
                },
                {
                    field: "Status",
                    title: $scope._t("Status"),
                    template: "#= TranslatedStatus #",
                    width: 50
                }
            ]
        }
        
        $scope.yearChanged = function() {
            if ($scope.year === ''){
                $scope.donationsKendoGrid.dataSource.data($scope.donations);
                return;
            }
            var selectedYearDonations = _.filter($scope.donations, function (item) {
                var year = new Date(Date.parse(item.Date)).getFullYear();
                return year == $scope.year;
            });
            $scope.donationsKendoGrid.dataSource.data(selectedYearDonations);
        }

        $scope.back = function() {
            $window.history.back();
        }

        $scope.emailReport = function () {
            usSpinnerService.spin('spinner-1');
            $http({
                url: apiUrl + 'api/Donation/SendEmailReport',
                method: 'POST',
                data: { AccountNumber: accountNumber, Year: $scope.year }
            }).success(function(result) {
                usSpinnerService.stop('spinner-1');
                if (result.Errors && result.Errors.length > 0)
                    ModalServiceExt.showError(result.Errors[0]);
                else
                    ModalServiceExt.showInfo($scope._t('Report was successfully sent to') + ' ' + result.Data + '.');
            }).error(function(error) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }
    }]);
'use strict';
angular.module('utilliApp')
.controller('BudgetBillingLearnMoreController',
[
    '$scope', '$window', '$http', '$state', 'usSpinnerService', 'LeftMenuService', 'CommonHeaderService', '$sce',
    'ProgramEnrollmentsSettings', 'ModalServiceExt',
    function ($scope, $window, $http, $state, usSpinnerService, LeftMenuService, CommonHeaderService, $sce,
              ProgramEnrollmentsSettings, ModalServiceExt) {

        LeftMenuService.setCurrentTab('ProgramEnrolments');
        CommonHeaderService.setUpBackButton($scope._t('Learn More'), true);

        var apiUrl = localStorage.getItem('ApiUrl');
        usSpinnerService.spin('spinner-1');

        $scope.infoHtmlCode = '';

        $http({
            url: apiUrl + 'api/BudgetBilling/GetLearnMoreInfo',
            method: 'GET'
        }).success(function (response) {
            usSpinnerService.stop('spinner-1');
            $scope.infoHtmlCode = $sce.trustAsHtml(response.Data);
        }).error(function(error) {
            usSpinnerService.stop('spinner-1');
        });

        usSpinnerService.spin('spinner-1');
        ProgramEnrollmentsSettings
            .getSettings('BudgetBilling')
            .then(function(data) {
                usSpinnerService.stop('spinner-1');
                $scope.program = data;
            }, function() {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });

        $scope.toggleEnrollment = function () {
            if($scope.program.IsEnrolled)
            {
                usSpinnerService.spin('spinner-1');
                ProgramEnrollmentsSettings
                    .toggleProgramEnrollment(ProgramEnrollmentsSettings.programEnrollmentsType.budgetBilling)
                    .then(function (data) {
                        usSpinnerService.stop('spinner-1');
                        $scope.program.IsEnrolled = !$scope.program.IsEnrolled;
                        ModalServiceExt.showInfo("Program is successfully unenrolled.")
                    }, function (error) {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                        console.error(error);
                    });
                return;
            }
            $state.goMainLayout('BudgetBilling');
        }

        $scope.back = function() {
            $window.history.back();
        }
    }
]);
'use strict';
angular.module('utilliApp')
.controller('BudgetBillingController',
['$scope', '$http', '$state', 'usSpinnerService', 'LeftMenuService', 'CommonHeaderService', '$window', 'ModalServiceExt',
    'ProgramEnrollmentsSettings',
    function ($scope, $http, $state, usSpinnerService, LeftMenuService, CommonHeaderService, $window, ModalServiceExt,
              ProgramEnrollmentsSettings) {
        
        LeftMenuService.setCurrentTab('ProgramEnrolments');
        CommonHeaderService.setUpBackButton($scope._t('Budget Billing'), true);

        $scope.enrollStep = 'step1';
        var apiUrl = localStorage.getItem('ApiUrl');
        var accountNumber = localStorage.getItem('CurrentAccountNumber');

        usSpinnerService.spin('spinner-1');

        $http({
            method: 'GET',
            url: apiUrl + 'api/BudgetBilling/GetBudgetBillingData',
            params: { accountNumber: accountNumber }
        }).success(function (result) {

            usSpinnerService.stop('spinner-1');

            if (result.Errors && result.Errors.length > 0) {
                ModalServiceExt.showError(result.Errors[0]);
                return;
            }

            $scope.billingData = result.Data;

        }).error(function (error) {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });

        $scope.viewBillingHistory = function() {
            $state.goMainLayout('BillsAndPayments');
        }

        $scope.next = function() {
            $scope.enrollStep = 'step2';
        }

        $scope.enroll = function () {
            usSpinnerService.spin('spinner-1');
            ProgramEnrollmentsSettings
                .toggleProgramEnrollment(ProgramEnrollmentsSettings.programEnrollmentsType.budgetBilling)
                .then(function (data) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showInfo($scope._t('You have successfully enrolled.'), function () {
                        $state.goMainLayout("ProgramEnrolments");
                    });
                }, function (error) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                    console.error(error);
                });
            usSpinnerService.spin('spinner-1');
        }

        $scope.back = function () {
            if ($scope.enrollStep === 'step1')
                $window.history.back();

            if ($scope.enrollStep === 'step2')
                $scope.enrollStep = 'step1';
        }
    }
]);
'use strict';
angular.module('utilliApp')
.controller('LanguagesController', ['$scope', '$http', '$state', 'usSpinnerService', 'LeftMenuService',
    'CommonHeaderService', '$resource', 'ModalServiceExt', '$window', 'CommonDataService',
// ReSharper disable InconsistentNaming
    function ($scope, $http, $state, usSpinnerService, LeftMenuService, CommonHeaderService, $resource,
        ModalServiceExt, $window, CommonDataService) {
// ReSharper restore InconsistentNaming
        if (!utilli.isLanguagePackEnabled()) {
            $window.history.back();
            return;
        }

        if (utilli.isAuthorized()) {
            LeftMenuService.setCurrentTab('Profile');
        }
        
        CommonHeaderService.setUpBackButton($scope._t('Languages'), true);

        $scope.languages = utilli.languages[DeploymentSettings.providersGroupShortName.toLowerCase()];

        $scope.selectLanguage = function (index) {
            usSpinnerService.spin('spinner-1');

            try {
                var language = $scope.languages[index].abbreviation;
                utilli.changeLanguage($resource, language, saveLanguage);
                CommonDataService.refresh();
            }
            catch (e) {
                usSpinnerService.stop('spinner-1');
            }
        }

        function saveLanguage(language) {
            if (!utilli.isAuthorized()) {
                usSpinnerService.stop('spinner-1');
                back();
                return;
            }

            var apiUrl = localStorage.getItem('ApiUrl');
            $http({
                method: 'POST',
                url: apiUrl + 'api/Profile/SaveLanguage',
                data: { 'Language': language, 'UserName': '' }
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
                if (response.Errors && response.Errors.length > 0) {
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }

                back();
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }

        function back() {
            // if Languages page is opened by a direct link in chrome then $window.history.length is 2
            // chrome starts counter from 1 and the first page is the empty page
            if ($window.history.length > 2) {
                $window.history.back();
            } else {
                $state.goToWelcome();
            }
        }
    }]);
angular.module('utilliApp')
    .service('BillsService', function() {

        var currentBill = null;

        var getCurrentBill = function() {
            return currentBill;
        }

        var setCurrentBill = function(bill) {
            currentBill = bill;
        }

        return {
            getCurrentBill: getCurrentBill,
            setCurrentBill: setCurrentBill,
        };

    });

'use strict';
angular.module('utilliApp')
    .service('CustomerInfoDataService', ['$http', '$q', '$state', function ($http, $q, $state) {
        var cache = null;
        var getCustomerInfoData = function () {
            var deferred = $q.defer();

            var accountNumber = localStorage.getItem('CurrentAccountNumber');
            var securityToken = localStorage.getItem('SecurityToken');
            var apiUrl = localStorage.getItem('ApiUrl');
            if (!apiUrl || !securityToken || !accountNumber)
            {
                $state.goToSignIn(true);
                return deferred.promise;
            }

            var params = { contractAccountNumber: accountNumber }
            var url = apiUrl + 'api/Customer/GetCustomerInfo/';
            $http({
                url: url,
                method: "GET",
                params: params
            }).success(function (data) {
                if (!data) {
                    deferred.reject(utilli.errors.serverErrorMessage);
                    return;
                }
                if (data.ERROR_LIST && data.ERROR_LIST.length > 0) {
                    deferred.reject(data.ERROR_LIST[0].Message);
                    return;
                }
                deferred.resolve(data);
                cache = data;
            }).error(function (errorInfo) {
                deferred.reject(errorInfo);
            });
            return deferred.promise;
        }

        return {
            getCustomerInfoData: getCustomerInfoData,
            /**
            * Cached data can be used on pages where it's not required to show fields that can be changed.
            * For example, service address or utillity type can't be changed, 
            * hence we can use cached data for this cases.
            */
            getCachedData: function () {
                // cache can be empty if user pressed F5
                if (!cache) {
                    return this.getCustomerInfoData();
                }
                var deferred = $q.defer();
                deferred.resolve(cache);
                return deferred.promise;
            }
        };
    }]);
angular.module('utilliApp')
    .service('AddPropertyService', function () {

    var currentProperty = null;

    var getCurrentProperty = function () {
        return currentProperty;
    }

    var setCurrentProperty = function (property) {
        currentProperty = property;
    }

    return {
        getCurrentProperty: getCurrentProperty,
        setCurrentProperty: setCurrentProperty
    };

});
angular.module('utilliApp')
    .service('ModalServiceExt', ['ModalService', '$window', '$rootScope', '$q', 
    function (ModalService, $window, $rootScope, $q) {
        var messagesQueue = [];

        var iconError = 'icon-exclamation-triangle';
        var iconInfo = 'icon-info-circle';
        var iconQuestion = 'icon-question-circle';
        var iconWarning = 'icon-exclamation-circle';

        var messageTypes = {
            yesNo: 'yesNo',
            ok: 'ok',
            loginRequired: 'loginRequired'
        }

        function addMessageToQueue(message, typeMessage, showModalCallback) {
            messagesQueue.push({
                message: message,
                messageType: typeMessage,
                showModalCallback: showModalCallback
            });
        }

        function removeMessage(message, messageType) {
            messagesQueue = _.without(messagesQueue, _.findWhere(messagesQueue, {
                message: message,
                messageType: messageType
            }));
        }

        function processQueue(message, messageType) {
            removeMessage(message, messageType);
            if (messagesQueue.length > 0)
                messagesQueue[messagesQueue.length - 1].showModalCallback();
        }

        function isMessagesQueueContains(message, messageType) {
            var result = _.some(messagesQueue, function (item) {
                return item.message === message && item.messageType === messageType;
            });
            return result;
        }

        var Service = function (isBackdropStatic) {
            //if _isBackdropStatic is false then we can close modal window 
            //by clicking on backdrop area (not modal window)
            var service = this;

            this._isBackdropStatic = isBackdropStatic || false;

            this.withStaticBackdrop = function () {
                var result = new Service(true);
                return result;
            };

            this.clear = function () {
                messagesQueue = [];
                $window.$('.modal').modal('hide');
            }

            this.showYesNoMessage = function (title, message, yesCallback, noCallback, needHideCloseButton, closedCallback) {
                var that = this;
                if (isMessagesQueueContains(message, messageTypes.yesNo))
                    return;
                else
                    addMessageToQueue(message, messageTypes.yesNo,
                        function () { that._showYesNoMessageTask(title, message, yesCallback, noCallback, needHideCloseButton, closedCallback) });

                if (messagesQueue.length === 1)
                    that._showYesNoMessageTask(title, message, yesCallback, noCallback, needHideCloseButton, closedCallback);
            }

            this._showYesNoMessageTask = function (title, message, yesCallback, noCallback, needHideCloseButton, closedCallback) {
                var templateUrl = this._getYesNoTemplateUrl();
                var closeModal = null;
                ModalService.showModal({
                    templateUrl: templateUrl,
                    controller: ["$scope","close", function ($scope, close) {
                        closeModal = close;
                        $scope.iconClass = iconQuestion;
                        $scope.title = title;
                        $scope.message = message;
                        $scope.needToHide = needHideCloseButton;
                        $scope.close = function (action) {
                            if (action === 'Yes') {
                                if (yesCallback)
                                    yesCallback();
                            }
                            else if (action === 'No') {
                                if (noCallback)
                                    noCallback();
                            } else
                                service.showError(utilli.errors.serverErrorMessage);
                        };
                    }]
                }).then(function (modal) {
                    modal.element.modal();
                    modal.element.on('hidden.bs.modal', function () {
                        // Why this is here? I dont what No callback. We have No and Yes callback running at the same time: https://atrinova.atlassian.net/browse/GNIS-2599
                        // I see that Daniel added this when he was fixing this GNIS-2522. I can not reproduce GNIS-2522 after I commented this out:
                        //if (noCallback) {
                        //    noCallback();
                        //}
                        if (closedCallback) {
                            closedCallback();
                        }
                        if (closeModal)
                            closeModal();
                        processQueue(message, messageTypes.yesNo);
                    });

                    modal.scope.$on('keyup', function (event, e) {
                        if (e.which == 27) {
                            modal.element.modal('hide');
                        }
                    })
                });
            }
            
            this.showOkMessage = function (title, message, closedCallback) {
                var that = this;
                if (isMessagesQueueContains(message, messageTypes.ok))
                    return;
                else
                    addMessageToQueue(message, messageTypes.ok,
                        function () { that._showOkMessageTask(title, message, closedCallback) });

                if (messagesQueue.length === 1)
                    that._showOkMessageTask(title, message, closedCallback);
            }

            this._showOkMessageTask = function (title, message, closedCallback, iconClass) {
                if (!message)
                    return;
                var that = this;
                var templateUrl = this._getSimpleOkTemplateUrl();
                var closeModal = null;
                ModalService.showModal({
                    templateUrl: templateUrl,
                    controller: ["$scope","close", function ($scope, close) {
                        closeModal = close;
                        $scope.iconClass = iconClass ? iconClass : iconInfo;
                        $scope.title = title;
                        $scope.message = message;
                        $scope.backdrop = that._isBackdropStatic ? "static" : true;
                        $scope.close = function () { };
                    }]
                }).then(function (modal) {
                    //modal.element.modal();
                    modal.element.modal({backdrop: that._isBackdropStatic ? "static" : true });
                    modal.element.on('hidden.bs.modal', function () {
                        if (closedCallback) {
                            closedCallback();
                        }
                        if (closeModal)
                            closeModal();
                        processQueue(message, messageTypes.ok);
                    });

                    modal.scope.$on('keyup', function (event, e) {
                        if (e.which == 27) {
                            modal.element.modal('hide');
                        }
                    })
                });
            };

            this.showError = function (message, closedCallback) {
                console.error(message);
                var that = this;
                if (isMessagesQueueContains(message, messageTypes.ok))
                    return;
                else
                    addMessageToQueue(message, messageTypes.ok,
                        function () { that._showErrorTask(message, closedCallback) });

                if (messagesQueue.length === 1)
                    that._showErrorTask(message, closedCallback);
            }

            this._showErrorTask = function (message, closedCallback) {
                this._showOkMessageTask(utilli._t('Error'), message, closedCallback, iconError);
            };

            this.checkApiResponseError = function(response) {
                if (response == undefined || response.data == undefined
                    || response.data.HasErrors == undefined
                    || response.data.Errors == undefined) {
                    return $q.reject('Unexpected response format.');
                }
                if (response.data.HasErrors) {
                    return $q.reject(response.data.Errors[0]);
                }
                return $q.resolve(response);
            };
            this.catchAjaxError = function () {
                return $q.reject(utilli.errors.serverErrorMessage);
            };
            this.showAjaxError = function (error) {
                if (error)
                    console.error(error);
                service.showError(utilli.errors.serverErrorMessage);
                return $q.reject();
            };

            this.showServerError = function (closedCallback) {
                var that = this;
                var message = utilli.errors.serverErrorMessage;
                if (isMessagesQueueContains(message, messageTypes.ok))
                    return;
                else
                    addMessageToQueue(message, messageTypes.ok,
                        function () { that._showServerErrorTask(message, closedCallback) });

                if (messagesQueue.length === 1)
                    that._showServerErrorTask(message, closedCallback);
            }

            this._showServerErrorTask = function (message, closedCallback) {
                this._showOkMessageTask(utilli._t('Error'), message, closedCallback, iconError);
            };

            this.showUnexpectedError = function (closedCallback) {
                var that = this;
                var message = utilli._t('Unexpected error. Try to restart the application.');
                if (isMessagesQueueContains(message, messageTypes.ok))
                    return;
                else
                    addMessageToQueue(message, messageTypes.ok,
                        function () { that._showUnexpectedErrorTask(message, closedCallback) });

                if (messagesQueue.length === 1)
                    that._showUnexpectedErrorTask(message, closedCallback);
            }

            this._showUnexpectedErrorTask = function (message, closedCallback) {
                this._showOkMessageTask(utilli._t('Error'), message, closedCallback, iconError);
            };
            
            this.showInfo = function (message, closedCallback) {
                var that = this;
                if (isMessagesQueueContains(message, messageTypes.ok))
                    return;
                else
                    addMessageToQueue(message, messageTypes.ok,
                        function () { that._showInfoTask(message, closedCallback) });

                if (messagesQueue.length === 1)
                    that._showInfoTask(message, closedCallback);
            }

            this._showInfoTask = function (message, closedCallback) {
                this._showOkMessageTask(utilli._t('Info'), message, closedCallback, iconInfo);
            };

            this.showMessage = function (title, message, closedCallback) {
                var that = this;
                if (isMessagesQueueContains(message, messageTypes.ok))
                    return;
                else
                    addMessageToQueue(message, messageTypes.ok,
                        function () { that._showOkMessageTask(title, message, closedCallback, iconInfo) });

                if (messagesQueue.length === 1)
                    that._showOkMessageTask(title, message, closedCallback, iconInfo);
            }

            this.showLoginRequired = function (title, message, loginCallback, registerCallback) {
                var that = this;
                if (isMessagesQueueContains(message, messageTypes.loginRequired))
                    return;
                else
                    addMessageToQueue(message, messageTypes.loginRequired,
                        function () { that._showLoginRequired(title, message, loginCallback, registerCallback) });
                if (messagesQueue.length === 1)
                    that._showLoginRequired(title, message, loginCallback, registerCallback);
            }

            this._showLoginRequired = function (title, message, loginCallback, registerCallback) {
                if (!message)
                    return;

                var templateUrl = this._getLoginRequiredTemplateUrl();
                var closeModal = null;
                ModalService.showModal({
                    templateUrl: templateUrl,
                    controller: ["$scope","close", function ($scope, close) {
                        closeModal = close;
                        $scope.iconClass = iconWarning;
                        $scope.title = title;
                        $scope.message = message;
                        $scope.close = function (action) {
                            if (action === 'Login') {
                                if (loginCallback)
                                    loginCallback();
                            }
                            else if (action === 'Register') {
                                if (registerCallback)
                                    registerCallback();
                            }
                        };
                    }]
                }).then(function (modal) {
                    modal.element.modal();
                    modal.element.on('hidden.bs.modal', function () {
                        if (closeModal)
                            closeModal();
                        processQueue(message, messageTypes.loginRequired);
                    });

                    modal.scope.$on('keyup', function (event, e) {
                        if (e.which == 27) {
                            modal.element.modal('hide');
                        }
                    })
                });
            };

            this._getYesNoTemplateUrl = function () {
                var result = utilli.isAdmin
                            ? '../Pages/Modals/yes-no-template.html'
                            : 'Pages/Modals/yes-no-template.html';
                return result;
            }

            this._getSimpleOkTemplateUrl = function () {
                var result = utilli.isAdmin
                            ? '../Pages/Modals/simple-ok-template.html'
                            : 'Pages/Modals/simple-ok-template.html';
                return result;
            }

            this._getLoginRequiredTemplateUrl = function() {
                return 'Pages/Modals/signin-register-template.html';
            }

        };


        return new Service();
    }])
    .controller('ModalController', ["$scope", "close", function ($scope, close) {
        $scope._t = utilli._t;
        $scope.close = function (result) {
            close(result, 500);
        };
    }]);
angular.module('utilliApp')
	.service('StatesService', function () {
		return { states : [
			{
				"Name": "Alabama",
				"Abbreviation": "AL"
			},
			{
				"Name": "Alaska",
				"Abbreviation": "AK"
			},
			{
				"Name": "American Samoa",
				"Abbreviation": "AS"
			},
			{
				"Name": "Arizona",
				"Abbreviation": "AZ"
			},
			{
				"Name": "Arkansas",
				"Abbreviation": "AR"
			},
			{
				"Name": "California",
				"Abbreviation": "CA"
			},
			{
				"Name": "Colorado",
				"Abbreviation": "CO"
			},
			{
				"Name": "Connecticut",
				"Abbreviation": "CT"
			},
			{
				"Name": "Delaware",
				"Abbreviation": "DE"
			},
			{
				"Name": "District Of Columbia",
				"Abbreviation": "DC"
			},
			{
				"Name": "Federated States Of Micronesia",
				"Abbreviation": "FM"
			},
			{
				"Name": "Florida",
				"Abbreviation": "FL"
			},
			{
				"Name": "Georgia",
				"Abbreviation": "GA"
			},
			{
				"Name": "Guam",
				"Abbreviation": "GU"
			},
			{
				"Name": "Hawaii",
				"Abbreviation": "HI"
			},
			{
				"Name": "Idaho",
				"Abbreviation": "ID"
			},
			{
				"Name": "Illinois",
				"Abbreviation": "IL"
			},
			{
				"Name": "Indiana",
				"Abbreviation": "IN"
			},
			{
				"Name": "Iowa",
				"Abbreviation": "IA"
			},
			{
				"Name": "Kansas",
				"Abbreviation": "KS"
			},
			{
				"Name": "Kentucky",
				"Abbreviation": "KY"
			},
			{
				"Name": "Louisiana",
				"Abbreviation": "LA"
			},
			{
				"Name": "Maine",
				"Abbreviation": "ME"
			},
			{
				"Name": "Marshall Islands",
				"Abbreviation": "MH"
			},
			{
				"Name": "Maryland",
				"Abbreviation": "MD"
			},
			{
				"Name": "Massachusetts",
				"Abbreviation": "MA"
			},
			{
				"Name": "Michigan",
				"Abbreviation": "MI"
			},
			{
				"Name": "Minnesota",
				"Abbreviation": "MN"
			},
			{
				"Name": "Mississippi",
				"Abbreviation": "MS"
			},
			{
				"Name": "Missouri",
				"Abbreviation": "MO"
			},
			{
				"Name": "Montana",
				"Abbreviation": "MT"
			},
			{
				"Name": "Nebraska",
				"Abbreviation": "NE"
			},
			{
				"Name": "Nevada",
				"Abbreviation": "NV"
			},
			{
				"Name": "New Hampshire",
				"Abbreviation": "NH"
			},
			{
				"Name": "New Jersey",
				"Abbreviation": "NJ"
			},
			{
				"Name": "New Mexico",
				"Abbreviation": "NM"
			},
			{
				"Name": "New York",
				"Abbreviation": "NY"
			},
			{
				"Name": "North Carolina",
				"Abbreviation": "NC"
			},
			{
				"Name": "North Dakota",
				"Abbreviation": "ND"
			},
			{
				"Name": "Northern Mariana Islands",
				"Abbreviation": "MP"
			},
			{
				"Name": "Ohio",
				"Abbreviation": "OH"
			},
			{
				"Name": "Oklahoma",
				"Abbreviation": "OK"
			},
			{
				"Name": "Oregon",
				"Abbreviation": "OR"
			},
			{
				"Name": "Palau",
				"Abbreviation": "PW"
			},
			{
				"Name": "Pennsylvania",
				"Abbreviation": "PA"
			},
			{
				"Name": "Puerto Rico",
				"Abbreviation": "PR"
			},
			{
				"Name": "Rhode Island",
				"Abbreviation": "RI"
			},
			{
				"Name": "South Carolina",
				"Abbreviation": "SC"
			},
			{
				"Name": "South Dakota",
				"Abbreviation": "SD"
			},
			{
				"Name": "Tennessee",
				"Abbreviation": "TN"
			},
			{
				"Name": "Texas",
				"Abbreviation": "TX"
			},
			{
				"Name": "Utah",
				"Abbreviation": "UT"
			},
			{
				"Name": "Vermont",
				"Abbreviation": "VT"
			},
			{
				"Name": "Virgin Islands",
				"Abbreviation": "VI"
			},
			{
				"Name": "Virginia",
				"Abbreviation": "VA"
			},
			{
				"Name": "Washington",
				"Abbreviation": "WA"
			},
			{
				"Name": "West Virginia",
				"Abbreviation": "WV"
			},
			{
				"Name": "Wisconsin",
				"Abbreviation": "WI"
			},
			{
				"Name": "Wyoming",
				"Abbreviation": "WY"
			}
		]};
	});
'use strict';
angular.module('commonServices', [])
    .service('CommonDataService', ['$http', '$q', function ($http, $q) {

        var commonData = {};
        var hasCommonData = false;

        var hasData = function () {
            return hasCommonData;
        };

        var getCommonData = function (webServiceUrl, isNewRequest) {
            var deferred = $q.defer();
            var url = webServiceUrl 
                ? webServiceUrl + 'api/Account/GetCommonData/'
                : localStorage.getItem('ApiUrl') + 'api/Account/GetCommonData/';

            if (isNewRequest || !hasData()) {
                $http({
                    url: url,
                    method: "GET"
                }).success(function(data) {
                    if (data.Success) {
                        commonData = data.Data;
                        hasCommonData = true;
                        deferred.resolve(commonData);
                    }
                }).error(function() {
                    deferred.reject(null);
                });
            } else {
                deferred.resolve(commonData);
            }
            return deferred.promise;
        }

        return {
            getCommonData: getCommonData,
            refresh: function() { hasCommonData = false; }
        };
    }]);
'use strict';
angular.module('utilliApp')
.service('LeftMenuService', ['$http', '$state', '$q', 'ModalServiceExt', 'NotificationBoxService',
    '$rootScope', '$timeout',
    function ($http, $state, $q, ModalServiceExt, NotificationBoxService, $rootScope, $timeout) {
        var fullMenu = {
            Avatar: { isVisible: true },
            SignOut: { isVisible: true },
            AccountList: { isVisible: true },
            Dashboard: { isVisible: true },
            BillsAndPayments: { isVisible: true },
            Usage: { isVisible: true },
            PaymentOptions: { isVisible: true },
            MeterData: { isVisible: true },
            ChangePassword: { isVisible: true },
            Profile: { isVisible: true },
            CancelService: { isVisible: true },
            MoveService: { isVisible: true },
            OutageCenter: { isVisible: true },
            EnergyEfficiency: { isVisible: true },
            Faqs: { isVisible: true },
            AboutUs: { isVisible: true },
            Notifications: { isVisible: true },
            ProgramEnrolments: { isVisible: true },

            // Agents:
            Search: { isVisible: true },
            SearchHistory: { isVisible: true },
            AgentProfile: { isVisible: true },
            // Assistants:
            Delinquents: { isVisible: true },
            AssistantSearch: { isVisible: true },
            AssistantSearchHistory: { isVisible: true },
            AssistantProfile: { isVisible: true },
            AssistantDisconnections: { isVisible: true },
            // PropertyManagers:
            MyPropertyGroups: { isVisible: true },
            MyProperties: { isVisible: true },
            PropertyManagerProfile: { isVisible: true },
            Authorizations: { isVisible: true },
            SharedAccounts: { isVisible: true },

            // Turn Off:
            WorkCenters: { isVisible: true },
            WorkOrders: { isVisible: true },
            TurnOffMap: { isVisible: true },
            LookUp: { isVisible: true },
            LookUpLog: { isVisible: true },
            //QuickPay: { isVisible: true },
            PaymentHistory: { isVisible: true },
        };

        var saveAsPrimaryAccount = function (userNameId) {
            var deferred = $q.defer();
            // i removed spinner here because i think that it's not necessary here and because it interferes
            // with spinners started in other places (a page may start its own spinner but here it will be turned off)
            // in general i think that we shouldn't start spinners in LeftMenuService. if spinner is really necessary
            // here then it's better to rewrite the code to return promise, start spinner in the page controller code,
            // launch the method of LeftMenuService and stop the spinner in 'than' method of the returned promise.
            //usSpinnerService.spin('spinner-1');
            var userName = userNameId;
            if (userName == null) {
                userName = localStorage.getItem('current_user');
            }
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Account/SetPrimaryContractAccount/',
                method: "POST",
                params: {
                    accountNumber: localStorage.getItem('CurrentAccountNumber'),
                    userName: userName
                }
            }).success(function (response) {
                if (response.Errors && response.Errors.length > 0) {
                    deferred.reject();
                }
                deferred.resolve(response);
            }).error(function () {
                deferred.reject();
            });
            return deferred.promise;
        }

        function saveContractAccountNumberInSearchHistory(contractAccountNumber){
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Agents/SaveSearchHistory/',
                method: "POST",
                params: { contractAccountNumber: contractAccountNumber }
            });
        }

        var leftMenuService = {
            isMenuItemVisible: function (menuItem) {
                return this.currentMenu[menuItem] && this.currentMenu[menuItem].isVisible;
            },
            currentMenu: fullMenu,
            setFull: function () {
                this.currentMenu = fullMenu;
            },
            currentTab: 'Dashboard',
            setCurrentTab: function (tab) {
                this.show();
                this.currentTab = tab;
                loadTop3SearchHistoryItems(leftMenuService);
            },
            isVisible: false,
            hide: function () {
                this.isVisible = false;
            },
            show: function () {
                this.isVisible = true;
            },
            firstAndLastNameOrCompanyName: $rootScope._t('loading...'),
            avatar: utilli.isAdmin ? '../Images/Icons/avatar_unknown.png' : 'Images/Icons/avatar_unknown.png',
            contractAccounts: [],
            findContractAccount: function (contractAccountNumber) {
                var self = this;
                return _.find(self.contractAccounts, function (item) {
                    return item.contractAccountNumber === contractAccountNumber;
                });
            },
            isLoadingSearchHistory: true,
            selectContractAccount: function (contractAccountNumber, state) {
                var self = this;
                var contractAccountIndex = _.findIndex(self.contractAccounts, function (item) {
                    return item.contractAccountNumber === contractAccountNumber;
                });
                if (contractAccountIndex < 0) {
                    saveContractAccountNumberInSearchHistory(contractAccountNumber);
                    self.contractAccounts.unshift({
                        contractAccountNumber: contractAccountNumber
                    });
                }
                if (self.contractAccounts.length > 3) {
                    self.contractAccounts.pop();
                }
                // We should set options.reload as state name instead of 'true', because if we set it as 'true' 
                // all the parent states of the target state will reload with their previous parameters 
                // that can be not actual for the moment (at list for the nested customer app in the admin portal) and we will have
                // tricky issues with wrong data.
                $state.goMainLayout(state ? state : "Dashboard", {}, { reload: state });

                var currentContractAccountNumber = localStorage.getItem('CurrentAccountNumber');
                // don't collapse if we click on menu items within the same contract account
                if (currentContractAccountNumber === contractAccountNumber)
                    return;
                if (currentContractAccountNumber) {
                    $('#menuItem-' + currentContractAccountNumber).collapse('hide');
                }
                localStorage.setItem('CurrentAccountNumber', contractAccountNumber);
                $timeout(function () {
                    $('#menuItem-' + contractAccountNumber).collapse('show');
                }, 100);
            },
            setContractAccountInfo: function (contractAccountInfo) {
                var self = this;
                var contractAccount = self.findContractAccount(contractAccountInfo.account.AccountNumber);
                // if menu item is not loaded from search history then add it
                if (!contractAccount){
                    contractAccount = { contractAccountNumber: contractAccountInfo.account.AccountNumber};
                    self.contractAccounts.push(contractAccount);
                }
                contractAccount.ServiceAddress = contractAccountInfo.account.ServiceAddress;
                contractAccount.CustomerFullName = contractAccountInfo.account.CustomerFullName;
                // take only HouseNumber and StreetName but skip everything else that goes after first comma.
                // for example, "8574 N HIGH ST, MINERAL CITY, OH, 44656" -> "8574 N HIGH ST"
                var addressParts = contractAccount.ServiceAddress.split(',');
                contractAccount.addressString = addressParts.length > 0 ? addressParts[0] : contractAccount.ServiceAddress;
            },
            isActive: function (contractAccountNumber, state) {
                var self = this;
                return self.currentTab === state && contractAccountNumber == localStorage.getItem('CurrentAccountNumber');
            },
            goToForAccount: function (contractAccountNumber, state) {
                var self = this;

            },
            changeAccount: function (accountNumber) {
                var self = this;
                self.avatar = utilli.isAdmin ? '../Images/Icons/avatar_unknown.png' : 'Images/Icons/avatar_unknown.png';
                self.firstAndLastNameOrCompanyName = $rootScope._t('loading...');

                var apiUrl = localStorage.getItem('ApiUrl');
                var requestData;
                var isAgent = utilli.hasAgentRole();
                if (isAgent || utilli.hasPropertyManagerRole() || utilli.hasAssistantRole()) {
                    // i removed spinner here. see comments in saveAsPrimaryAccount
                    //usSpinnerService.spin('spinner-1');
                    var isAssistant = utilli.hasAssistantRole();
                    var url = isAgent || isAssistant ? apiUrl + 'api/Agents/GetProfile'
                        : apiUrl + 'api/PropertyManagers/GetProfile';
                    requestData = {};
                    utilli.addUserName($state, requestData);
                    $http({
                        method: 'GET',
                        url: url,
                        params: { userName: $state.params.userId }
                    }).success(function (data) {
                        var userData = isAgent || isAssistant ? data.Data : data.Data.UserData;
                        self.firstAndLastNameOrCompanyName = userData.FirstName + ' ' + userData.LastName;
                        self.avatar = apiUrl + userData.AvatarPath;
                    }).error(function () {
                        ModalServiceExt.showMessage(utilli.serverErrorMessage);
                    });
                }
                else if (utilli.checkDefinedValue(accountNumber)) {
                    requestData = { accountNumber: accountNumber };
                    utilli.addUserName($state, requestData);
                    $http({
                        url: apiUrl + 'api/Profile/GetProfile/',
                        method: "GET",
                        params: requestData,
                        notCancelled: true
                    }).success(function (data) {
                        //if (data.Errors && data.Errors.length > 0) {
                        //    $moduleServices.setErrors(data.Errors);
                        //    return;
                        //}
                        if (data.AccountData) {
                            self.firstAndLastNameOrCompanyName = data.AccountData.FirstAndLastNameOrCompanyName;
                            self.avatar = apiUrl + data.AvatarURL;
                            saveAsPrimaryAccount(data.AccountData.UserId);
                            if (!utilli.hasAgentRole() && !utilli.hasPropertyManagerRole())
                                NotificationBoxService.setSubscribeSmsVisibilityServerFlag(
                                    data.AccountData.PrimaryPhoneNumber === "");
                        }
                    }).error(function (data) {
                        console.log(data);
                    });
                }
            },
            signOut: function () {
                if (utilli.isAdmin) {
                    ModalServiceExt.showMessage($rootScope._t('Customer sign out does not work from admin.'));
                } else {
                    $state.goToWelcome();
                    NotificationBoxService.resetSmsSubscribeNotification();
                    utilli.clearLocalStorage();
                }
            },
        };

        var isTop3MenuItemLoaded = false;
        function loadTop3SearchHistoryItems(leftMenuService) {
            // run it only once per page load and only for assistants
            if (isTop3MenuItemLoaded || !utilli.hasAssistantRole())
                return;
            isTop3MenuItemLoaded = true;
            leftMenuService.isLoadingSearchHistory = true;
            $http.get(localStorage.getItem('ApiUrl') + 'api/Agents/GetSearchHistory/', {
                params: {
                    filter: "", group: "", page: 1, pageSize: 3, sort: ""
                }
            })
                .success(function (data) {
                    leftMenuService.isLoadingSearchHistory = false;
                    if (!data || !data.Data || !data.Data.PageData)
                        return;
                    leftMenuService.contractAccounts = [];
                    data.Data.PageData.forEach(function(searchHistoryItem) {
                        var contractAccount = leftMenuService.findContractAccount(searchHistoryItem.AccountNumber);
                        // menu item may already exist, for example if it was set from dashboard with other info
                        if (contractAccount)
                            return;
                        contractAccount = {
                            contractAccountNumber: searchHistoryItem.AccountNumber
                        };
                        var address = searchHistoryItem.Address;
                        // take only HouseNumber and StreetName but skip everything else that goes after first comma.
                        // for example, "8574 N HIGH ST, MINERAL CITY, OH, 44656" -> "8574 N HIGH ST"
                        var addressParts = address.split(',');
                        contractAccount.addressString = addressParts.length > 0 ? addressParts[0] : address;
                        leftMenuService.contractAccounts.push(contractAccount);
                    });
                    // if current page is related to contract account (sub menu) then we need expand it.
                    if (leftMenuService.currentTab === 'Dashboard' 
                        || leftMenuService.currentTab === 'BillsAndPayments') {
                        var menuItemId = '#menuItem-' + localStorage.getItem('CurrentAccountNumber');
                        // timeout is required here because menu items are not rendered yet
                        $timeout(function(){
                            var menuElement = $(menuItemId);
                            menuElement.collapse();
                        }, 0);
                    }
                })
                .error(function () {
                    leftMenuService.isLoadingSearchHistory = false;
                });
        }

        return leftMenuService;
    }]
);

'use strict';
angular.module('utilliApp')
    .service('DefaultPropertyService',
    [
        '$http', '$state', '$q', 'ModalServiceExt',
// ReSharper disable InconsistentNaming
        function($http, $state, $q, ModalServiceExt) {
// ReSharper restore InconsistentNaming
            return {
                getAggregation: function(userName) {
                    var deferred = $q.defer();
                    var aggregation = utilli.getCurrentAggregation();
                    var params = { propertyId: null, userName: userName };
                    if (aggregation != null && aggregation.Type != null && aggregation.Type == utilli.aggregationTypes.group) {
                        deferred.resolve(aggregation);
                    }
                    else {
                        if (aggregation != null) {
                            params.propertyId = aggregation.Id
                        } 
                        $http({
                            url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetDefaultProperty/',
                            method: "GET",
                            params: params
                        }).success(function(response) {
                            utilli.handleAjaxResponse(response,
                                ModalServiceExt,
                                function() {
                                    var aggregation = response.Data;
                                    if(aggregation){
                                        aggregation.Type = utilli.aggregationTypes.property;
                                        localStorage.setItem('currentAggregation', JSON.stringify(aggregation));
                                        deferred.resolve(response.Data);
                                    }
                                    deferred.resolve(null);
                                });
                        }).error(function(d) {
                            ModalServiceExt.showServerError();
                            deferred.reject(d);
                        });
                    }
                    return deferred.promise;
                }
            }
        }
    ]);
'use strict';
angular.module('utilliApp')
    .factory('NotificationBoxService', ['$rootScope', '$http', '$state', 'ModalServiceExt', function ($rootScope, $http, $state, ModalServiceExt) {
        var _settingsKey = 'notificationBoxSettings';
        var observerCallbacks = [];
        var tempVisibility = false;

        var notifyObservers = function () {
            angular.forEach(observerCallbacks, function (callback) {
                callback();
            });
        };

        var defaultNotificationBoxSettings = {
            SmsSubscribeNotification: {
                isVisibleByServer: false,
                isVisibleByUser: true
            }
        };

        function getSettings () {
            var result = JSON.parse(localStorage.getItem(_settingsKey)) || defaultNotificationBoxSettings;
            return result;
        }

        function saveSettings(settings) {
            localStorage.setItem(_settingsKey, JSON.stringify(settings));
        }

        return {
            registerObserverCallback: function (callback) {
                observerCallbacks.push(callback);
            },

            isSmsSubscribeNotificationVisible: function () {
                // if (utilli.hasAssistantRole())
                //     return false;
                var settings = getSettings();
                var result = settings.SmsSubscribeNotification.isVisibleByUser 
                    && settings.SmsSubscribeNotification.isVisibleByServer;
                return result;
            },

            hideSmsSubscribeNotification: function () {
                //todo: may be we should use user id in _settingsKey
                var settings = getSettings();
                settings.SmsSubscribeNotification.isVisibleByUser = false;
                $rootScope.$broadcast('subscribe-notification-hide');
                saveSettings(settings);
            },

            stopReminding: function () {
                $http({
                    method: 'POST',
                    url: localStorage.getItem('ApiUrl') + 'api/User/StopRemindingSmsSubscription',
                    data: { '': $state.params.userId }
                }).success(function (response) {
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showEror(response.Errors[0]);
                        return;
                    }

                    var settings = getSettings();
                    settings.SmsSubscribeNotification.isVisibleByUser = false;
                    settings.SmsSubscribeNotification.isVisibleByServer = false;
                    saveSettings(settings);
                }).error(function (error) {
                    console.log(error);
                    ModalServiceExt.showServerError();
                });
            },

            resetSmsSubscribeNotification: function() {
                var settings = getSettings();
                settings.SmsSubscribeNotification.isVisibleByUser = true;
                settings.SmsSubscribeNotification.isVisibleByServer = false;
                saveSettings(settings);
            },

            setSubscribeSmsVisibilityServerFlag: function (flag) {
                var settings = getSettings();
                settings.SmsSubscribeNotification.isVisibleByServer = flag;
                if (flag)
                    settings.SmsSubscribeNotification.isVisibleByUser = true;
                saveSettings(settings);
                notifyObservers();
            },
            isTemporarilyHidden: function () {
                return tempVisibility;
            },
            setTemporarilyHide: function (flag) {
                tempVisibility = flag;
                notifyObservers();
            }
        };
    }
]);
angular.module('utilliApp')
    .service('OpenFileService', ['$http', '$q', 'ModalServiceExt', 'usSpinnerService',
        function ($http, $q, ModalServiceExt, usSpinnerService) {
            var _t = utilli._t;

        var openBill = function (billNumber, accountNumber)
        {
            usSpinnerService.spin('spinner-1');
            var billTab;
            if (!isMobileOrRipple()) {
                billTab = window.open("about:blank", "_blank");
            }
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Bills/DoesBillExists/',
                params: { accountNumber: accountNumber, invoiceNumber: billNumber },
                method: "GET"
            }).success(function (data) {
                if (data != null && data.Exists) {
                    var billUrl = data.BillPdfUrl;
                    openPdf(billUrl, billNumber, billTab).catch(function(err){ 
                        ModalServiceExt.showError(err); 
                    }).fixedFinally(function(){
                        usSpinnerService.stop('spinner-1');
                    });
                }
                else {
                    if (billTab)
                        billTab.close();
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showInfo(_t("Bill PDF does not exist yet."));
                }
            }).error(function (data) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }

        var openUnderstandBillFile = function (apiUrl)
        {
            apiUrl = apiUrl ? apiUrl : localStorage.getItem('ApiUrl');
            var url = apiUrl + 'api/Bills/GetUnderstandMyBill';
            usSpinnerService.spin('spinner-1');
            openPdf(url, 'understandYourBill').catch(function(err){ 
                ModalServiceExt.showError(err);
            }).fixedFinally(function(){
                usSpinnerService.stop('spinner-1');
            });
        }

        /**
         * Opens a PDF on any platform.
         * @param {string} url Path to the file - it can be either http:// or https:// or file://
         * @param {*} fileName optional. name of the file. it's relevant if the user will decide to save the file.
         * @param {*} billTab optional. for bills we can first check if the bill exists and if it doesn't exist then 
         * show a message. but we do it using ajax request. and the problem is that we can't run window.open from ajax
         * callback because browser will complain and show a notification to the user that the page tries to open new
         * tabs. we don't want this notification. the workaround we found is to open the new tab before starting ajax
         * request and if bill doesn't exist then close the tab. if the bill exist then we update URL of the already
         * opened tab.
         */
        function openPdf(url, fileName, billTab){
            if (!isMobileOrRipple()) {
                if (billTab){
                    billTab.location = url;
                }
                else {
                    window.open(url, '_blank');
                }
                return $q.resolve();
            }
            else if (isAndroid()) {
                return androidOpenPdf(url, fileName);
            }
            else {// iOS
                // window.open stopped to work. 
                // see: https://github.com/apache/cordova-ios/issues/898#issuecomment-643697420
                cordova.InAppBrowser.open(url, "_system");
                return $q.resolve();
            }
        }

        /** opens pdf file using cordova plugin for android */
        function androidOpenPdf(url, fileName) {
            var deferred = $q.defer();
            if(!cordova.plugins.fileOpener2) {
                var message = _t('Current version of application doesn\'t support this functionality. You need to update your app!');
                ModalServiceExt.showError(message);
                usSpinnerService.stop('spinner-1');
                deferred.reject(message);
                return deferred.promise;
            }
            checkPermissions()
            .then(function (status) {
                if(!status.hasPermission)
                    return askPermissions();
                return Promise.resolve(true);
            }, function (e) {
                console.error(e);
                deferred.reject(e);
            })
            .then(function (hasStoragePermissions) { 
                if(!hasStoragePermissions) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showError(_t("You don't have permission to access this feature"));
                    return;
                }
                var requestFileSystemSuccessFn = function (dirEntry) {
                    // if there is no fileName specified then try to get it from url
                    fileName = fileName ? fileName :
                        url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('.pdf'));
                    var targetFilePath = dirEntry.toURL() + fileName + ".pdf";
                    var fileTransfer = new FileTransfer();
                    var downloadErrorFn = function (error) {
                        var errorCodeDesc = "";
                        switch (error.code) {
                            case 1:
                                errorCodeDesc = "FILE_NOT_FOUND_ERR";
                                break;
                            case 2:
                                errorCodeDesc = "INVALID_URL_ERR";
                                break;
                            case 3:
                                errorCodeDesc = "CONNECTION_ERR";
                                break;
                            default:
                                errorCodeDesc = "unknown (" + error.code + ")";
                        }
                        console.error("Error downloading PDF from URL: " + url);
                        console.error("Error code = " + errorCodeDesc + ", http_status = " + error.http_status 
                            + ", source = " + error.source + ", target = " + error.target + ", body = " + error.body);
                        deferred.reject("There was an error while downloading the file. Please try again.");
                    };
                    var downloadSuccessFn = function (entry) {
                        cordova.plugins.fileOpener2.open(
                            entry.toURL(),
                            'application/pdf',
                            {
                                error : function(e) {
                                    console.error(e);
                                    deferred.reject("There was an error while downloading the file. Please try again.");
                                },
                                success : function () {
                                    deferred.resolve();
                                    console.log('file opened successfully');
                                }
                            }
                        );
                    };
                    fileTransfer.download(url, targetFilePath, downloadSuccessFn, downloadErrorFn, true);
                }
                var requestFileSystemErrorFn = function (error) {
                    deferred.reject("There was an error while reaching to the file system. Code = " + error.code);
                }
                var androidDownloadsPath = cordova.file.externalRootDirectory + "Download/";
                window.resolveLocalFileSystemURL(androidDownloadsPath, requestFileSystemSuccessFn, requestFileSystemErrorFn);
            },function (e) {
                deferred.reject(e);
            });
            return deferred.promise;
        }

        function checkPermissions () {
            var deferred = $q.defer();
            var androidVersionOfApiLevel23 = 6;
            if(device.version.split('.')[0] < androidVersionOfApiLevel23)
            {
                deferred.resolve({
                    hasPermission: true
                });
                return deferred.promise;
            }
            var permissions = cordova.plugins.permissions;
            var successCallback = function (status) {
                console.log(status);
                deferred.resolve(status);
            };
            var errorCallback = function () {
                var errorMessage = 'Storage permission is not turned on';
                ModalServiceExt.showError(_t('Storage permission is not turned on')); 
                console.warn(errorMessage);
                deferred.reject(errorMessage);
            }
            permissions.checkPermission(permissions.WRITE_EXTERNAL_STORAGE, successCallback, errorCallback);
            return deferred.promise;
        }

        function askPermissions () {
            var deferred = $q.defer();
            var permissions = cordova.plugins.permissions;
            var successCallback = function (status) {
                console.log(status);
                deferred.resolve(status.hasPermission);
            };
            var errorCallback = function () {
                var errorMessage = 'Storage permission is not turned on';
                ModalServiceExt.showError(_t('Storage permission is not turned on')); 
                console.warn(errorMessage);
                deferred.reject(errorMessage);
            }
            permissions.requestPermission(permissions.WRITE_EXTERNAL_STORAGE, successCallback, errorCallback);
            return deferred.promise;
        }

        return {
            openBill: openBill,
            openUnderstandBillFile: openUnderstandBillFile,
            openPdf: openPdf
        };
    }]);
'use strict';
angular.module('utilliApp')
    .factory('ServiceProvidersService', ['$http', '$q', function($http, $q) {

        var isCached = false;
        var cachedData = {};
        var currentProvider = null;

        return {
            /**
             * Returns a promise with data about all service providers
             * @returns an array of objects with Name, LongName, Url
             */
            getProviders: function () {
                var deferred = $q.defer();
                if (isCached) {
                    deferred.resolve(cachedData);
                    return deferred.promise;
                }

                var url = DeploymentSettings.providersServiceUrl + 'Providers/GetAllProviders';
                $http({
                    url: url,
                    method: "GET"
                }).success(function(data) {
                    if (!data || data.length == 0) {
                        deferred.reject(utilli.errors.serverErrorMessage);
                    }
                    cachedData = data;
                    isCached = true;
                    deferred.resolve(cachedData);
                }).error(function(data) {
                    console.error(data);
                    deferred.reject(utilli.errors.serverErrorMessage);
                });
                return deferred.promise;
            },
            /**
             * Returns a promise with data about a provider
             * @param providerShortName short name of a provider as it's in specified for
             * currentServiceProvider in DeploymentSettings
             * @returns an object with Name, LongName, Url
             */
            getProvider: function (providerShortName){
                return this.getProviders()
                    .then(function(providers){
                        var providerName = Config.providers[providerShortName].Name;
                        var providersFiltered = $.grep(providers, function(item){
                            return item.Name == providerName;
                        });
                        return providersFiltered[0];
                    });
            },
            getCurrentProvider: function () {
                return currentProvider 
                    ? $q.resolve(currentProvider) 
                    : this.getProvider(DeploymentSettings.currentServiceProvider);
            },
            setCurrentProvider: function (provider){
                currentProvider = provider;
            },
            getProviderApiUrl: function () {
                var result = $q.defer();
                this.getProviders()
                    .then(function (providers) {
                        try {
                            var currentServiceProvider = DeploymentSettings.currentServiceProvider;
                            if (currentServiceProvider.length == 0) {
                                console.log("Configuration error: can't get current service provider.");
                                result.reject();
                                return;
                            }
                            var currentProviderName = Config.providers[currentServiceProvider].Name;
                            var providersFiltered = $.grep(providers, function (item) {
                                return item.Name == currentProviderName;
                            });
                            if (!providersFiltered || providersFiltered.length !== 1) {
                                console.log("Configuration error: can't get current service provider.");
                                result.reject();
                                return;
                            }
                            result.resolve(providersFiltered[0].ApiUrl);
                        }
                        catch (e) {
                            result.reject();
                            console.log(e);
                        }
                    });
                return result.promise;
            }
        };
    }]);
angular.module('utilliApp')
    .service('GetAccountsService', ['$http', '$q', '$state', function ($http, $q, $state) {

        var accounts = {};
        var hasAccounts = false;

        var getAccounts = function (forceRequest) {
            var deferred = $q.defer();

            if (hasAccounts && !forceRequest)
            {
                deferred.resolve(accounts);
                return deferred.promise;
            }

            hasAccounts = false;
            var params = { };
            utilli.addUserName($state, params);

            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Account/GetAccountList/',
                method: "GET",
                params: params
            }).success(function (data) {

                if (!data)
                {
                    accounts = {}
                    accounts.Errors = [{ key: 'Error', Message: utilli.serverErrorMessage }];
                    deferred.resolve(accounts);
                }

                accounts = data;

                if (accounts.Accounts && accounts.Accounts.length > 0)
                {
                    hasAccounts = true;
                    var serviceProvider = localStorage.getItem('ServiceProviderName');

                    for (var i = 0; i < accounts.Accounts.length; i++) {
                        accounts.Accounts[i].companyName = serviceProvider;
                    }
                }
                
                deferred.resolve(accounts);
            }).error(function () {
                accounts = {};
                accounts.Errors = [{ key: 'Error', Message: utilli.serverErrorMessage }];
                deferred.resolve(accounts);
            });

            return deferred.promise;
        }

        return {
            getAccounts: getAccounts
        };

    }]);
angular.module('utilliApp')
    .service('RequestService', [
        '$q', function($q) {
            var requests = [];

            var add = function(config) {
                if (!config.url.startsWith('http://') && !config.url.startsWith('https://'))
                    return;

                var abortTimeout = $q.defer();
                config.timeout = abortTimeout.promise;
                requests.push({ timeout: abortTimeout, timestamp: new Date(), notCancelled: config.notCancelled });
            }

            /**
            * aborts all requests that were launched before the specified timestamp
            */
            var abort = function (timestamp) {
                if (!timestamp) {
                    timestamp = new Date();
                }
                var remainingRequests = [];
                requests.forEach(function (item) {
                    if (item.timestamp < timestamp && !item.notCancelled) {
                        item.timeout.promise.status = 499; //will be checked in utilliApp responseError interceptor.
                        item.timeout.resolve();
                    } else {
                        remainingRequests.push(item);
                    }
                });
                requests = remainingRequests;
            }

            var forcedAbort = function (request) {

                if (request.timeout) {
                    var remainingRequests = [];
                    requests.forEach(function (item) {
                        if (item == request) {
                            item.timeout.promise.status = 499; //will be checked in utilliApp responseError interceptor.
                            item.timeout.resolve();
                        } else {
                            remainingRequests.push(item);
                        }
                    });
                    requests = remainingRequests;
                    return;
                }

                var abortTimeout = $q.defer();
                request.timeout = abortTimeout.promise;
                abortTimeout.resolve();
            }

            return { add: add, abort: abort, forcedAbort: forcedAbort }
        }
    ]);
'use strict';
angular.module('utilliApp')
    .service('DueReminderService', function () {
        var _isReminderShown = true;

        var unmarkAsShown = function () {
            _isReminderShown = false;
        }

        var markAsShown = function () {
            _isReminderShown = true;
        }

        var isReminderShown = function () {
            return _isReminderShown;
        }

        return {
            markAsShown: markAsShown,
            unmarkAsShown: unmarkAsShown,
            isReminderShown: isReminderShown
        };

    });
angular.module('utilliApp')
    .service('CheckVersionService', ['$http', '$q', function ($http, $q) {
        var checkVersion = function () {
            var deferred = $q.defer();

            var version = Config.version.split('.')[1];
            var providersApiUrl = DeploymentSettings.providersServiceUrl;

            var url = providersApiUrl + "Version/CheckVersion?version=" + version;

            $http.get(url)
                .success(function (result) {
                    if (result == "maintenance")
                    {
                        localStorage.setItem("offline", "1");
                    }
                    else
                    {
                        localStorage.removeItem("offline");
                    }
                    deferred.resolve(result);
                })
                .error(function (err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        }

        return {
            checkVersion: checkVersion,
            // the case for old api (published before 2016-Sep-3) is 
            // just to submit new app to stores.
            // we need the new app to be running while old api is still deployed
            // appreviewer user needs to be able to login. he will be using apistaging.utilli.com
            // but the check here needs to be passed so that reviewer will be 
            // able to reach the signin page
            isVersionWrong: function (versionCheckResult) {
                return versionCheckResult === 'WrongVersion'// new api after 2016-Sep-3
                    || versionCheckResult === 'error';// old api before 2016-Sep-3
            },
            isVersionCorrect: function(versionCheckResult) {
                return versionCheckResult === 'Success'// new api after 2016-Sep-3
                || versionCheckResult === 'success';// old api before 2016-Sep-3
        }
    };
    }]);

'use strict';
angular.module('utilliApp')
    .service('ServerCacheService', [
        '$http', function($http) {
            
            return {
                clearServerCache: function() {
                    // if it was refresh (F5 pressed) then send request to refresh server cache.
                    var token = localStorage.getItem("SecurityToken");
                    if (!token)
                        return;
                    
                    var accountNumber = localStorage.getItem("CurrentAccountNumber");
                    if (!accountNumber || accountNumber === "null") {
                        if (utilli.hasPropertyManagerRole()) {
                            accountNumber = "propertyManager";
                        } else {
                            return;
                        }
                    }

                    var apiUrl = localStorage.getItem("ApiUrl");
                    var url = apiUrl + "api/Account/ClearCache";
                    $http({
                        url: url,
                        method: "POST",
                        params: { accountNumber: accountNumber }
                    })
                    .success(function () { })
                    .error(function () { });
                }
            }

        }])
'use strict';
angular.module('utilliApp').factory('HeaderServiceFactory', [
    '$window', '$state', '$rootScope', 'AccountListService', '$http', 'ModalServiceExt',
// ReSharper disable InconsistentNaming
    function ($window, $state, $rootScope, AccountListService, $http, ModalServiceExt) {
// ReSharper restore InconsistentNaming
        var getHeaderSerivce = function() {

            var backButtonClick = function() {
                $window.history.back();
            };

            var svc = {
                // i use underscore prefixes '_' because i want to emphasise that these fields should 
                // be used only for reading values from them, not for setting values. 
                // use setUp* methods if you want to set values. this will ensure absense of
                // bugs when you set a filed in one controller and forgot to set it to default
                // value in another
                _title: "",
                // _isDefaultTitle is used in css to hide default title when logo replaces it
                _isDefaultTitle: false,
                _rightButtonText: null,
                _rightButtonClick: null,
                _isRightButtonVisible: false,
                _isRightButtonAlwaysVisible: false,
                _areNotificationsVisible: false,
                _isMenuToggleButtonVisible: false,
                _notificationsClick: function() {
                    $state.goMainLayout('UserNotifications');
                },
                showInsect: DeploymentSettings.deploymentEnvironment === 'Qa',
                logoClick: function () {
                    if (!this.showInsect && !utilli.hasAgentRole() && !utilli.hasPropertyManagerRole())
                        $state.goToWelcome();
                    else
                         this.showInsect = false;
                },
                _unreadNotificationCount: 0
            };

            var loadUnreadNotificationCount = function () {
                var apiUrl = localStorage.getItem('ApiUrl');
                var dataRequest = {};
                if (utilli.hasPropertyManagerRole()) {
                    dataRequest.accountNumber = 'propertyManager';
                    dataRequest.userName = localStorage.getItem('current_user');
                } else {
                    dataRequest.accountNumber = AccountListService.getCurrentContractAccount();
                }
                utilli.addUserName($state, dataRequest);
                $http({
                    url: apiUrl + 'api/NotificationsLog/GetPortalNotificationsCount/',
                    method: "GET",
                    params: dataRequest
                }).success(function (response) {
                    utilli.handleAjaxResponse(response,
                        ModalServiceExt,
                        function() {
                            svc._unreadNotificationCount = response.Data;
                        });
                }).error(function (data) {
                    ModalServiceExt.showError(utilli._t("Cannot get unread notifications count."));
                    console.error(data);
                });
            }

            svc.setTitle = function(title) {
                this._isDefaultTitle = !title;
                this._title = title ? title : this.getDefaultTitle();
            };

            /**
            * Sets up header configuration.
            * title - optional, default value is defaultTitle
            * rightButtonText - optional, if not specified then the right button is not visible
            * rightButtonClick - optional
            * isRightButtonAlwaysVisible - optional, false by default. 
            * if isRightButtonAlwaysVisible is true then the button doesn't get hidden on desktop screen sizes
            */
            svc.setUp = function(title, rightButtonText, rightButtonClick, isRightButtonAlwaysVisible) {
                this.setTitle(title);
                this._rightButtonText = rightButtonText;
                // the right button is visible only if a button text is specified
                this._isRightButtonVisible = !!rightButtonText;
                this._rightButtonClick = rightButtonClick;
                this._areNotificationsVisible = false;
                this._isMenuToggleButtonVisible = true;
                // usually the right button is the back button and it needs to be visible only in mobile apps 
                // because it's possible that a mobile device doesn't have hardware back button
                // but for custom buttons such as 'Add' or 'Edit' it is required to show the button always
                this._rightButtonClass = isRightButtonAlwaysVisible
                    ? '' : isMobileOrRipple()
                    ? '' : 'visible-xs';
            };

            /**
            * Sets up a header with a back button on the right
            * title - optional, default value is defaultTitle
            * isRightButtonAlwaysVisible - optional, false by default. 
            * if isRightButtonAlwaysVisible is true then the button doesn't get hidden on desktop screen sizes
            */
            svc.setUpBackButton = function(title, isRightButtonAlwaysVisible) {
                this.setUp(title, $rootScope._t('Back'), backButtonClick, isRightButtonAlwaysVisible);
                return this;
            }

            /**
            * Sets up a header with a back button on the right.
            * The only difference from setUpBackButton is the text on the right button.
            * title - optional, default value is defaultTitle
            */
            svc.setUpCancelButton = function(title) {
                this.setUp(title, $rootScope._t('Cancel'), backButtonClick);
                return this;
            };

            /**
            * Sets up a header with a notifications button on the right.
            * title - optional, default value is defaultTitle
            */
            svc.setUpNotificationButton = function(title) {
                this.setTitle(title);
                this._isRightButtonVisible = false;
                this._areNotificationsVisible = true;
                loadUnreadNotificationCount();
                this._isMenuToggleButtonVisible = true;
                return this;
            };

            svc.hideMenuToggleButton = function() {
                this._isMenuToggleButtonVisible = false;
                return this;
            };

            // Note: getDefaultTitle is overriden in admin in AdminHeaderService
            svc.getDefaultTitle = function() {
                var serviceProviderName = localStorage.getItem('ServiceProviderName');
                return serviceProviderName ? serviceProviderName : 'Utilli';
            };

            svc.setTitle();

            return svc;
        };

        return {
            getHeaderSerivce: getHeaderSerivce
        };
    }
]);

'use strict';
angular.module('utilliApp')
.factory('TimeService', ['$q', 'CommonDataService', 'ModalServiceExt',
    function ($q, CommonDataService, ModalServiceExt) {

        function createCurrentDate(timeZoneShift) {
            var currentDate = new Date();
            var currentUtcDate = currentDate.getTime() + (currentDate.getTimezoneOffset() * 60000);
            var currentServerDate = new Date(currentUtcDate + (3600000 * timeZoneShift));
            return currentServerDate;
        }

        function getTimeZone() {
            var resultPromise = $q.defer();

            CommonDataService.getCommonData()
                .then(function (data) {
                    resultPromise.resolve(data.TimeZoneShift);
                }, function () {
                    resultPromise.reject(null);
                });

            return resultPromise.promise;
        }

        var getTimeZoneDateAndCurrentDate = function (dateString) {
            var deferred = $q.defer();

            CommonDataService.getCommonData()
                .then(function (data) {
                    
                    var currentServerDate = createCurrentDate(data.TimeZoneShift);
                    var timeZoneDate = kendo.parseDate(dateString, data.DateTimeFormat);

                    deferred.resolve({
                        currentServerDate: currentServerDate,
                        timeZoneDate: timeZoneDate
                    });
                });

            return deferred.promise;
        };

        var getCurrentDate = function () {
            var deferred = $q.defer();

            CommonDataService.getCommonData()
                .then(function (data) {
                    var currentServerDate = createCurrentDate(data.TimeZoneShift);
                    deferred.resolve(currentServerDate);
                });

            return deferred.promise;
        };

        var getDateString = function (date) {
            date = new Date(date); //if date is string
            var stringDate = kendo.toString(date, 'dd MMM yyyy HH:mm');
            return stringDate;
        };

        var getLocalDate = function (dateAsString) {
            var result = new Date(Date.parse(dateAsString));
            return result;
        }

        //parse date as date in local time zone
        function parseISOLocalDate(s) {
            var b = s.split(/\D/);
            return new Date(b[0], b[1]-1, b[2], b[3], b[4], b[5]);
        }

        return {
            getCurrentDate: getCurrentDate,
            getDateString: getDateString,
            getTimeZone: getTimeZone,
            getTimeZoneDateAndCurrentDate: getTimeZoneDateAndCurrentDate,
            parseISOLocalDate: parseISOLocalDate
        }
    }]);
angular.module('utilliApp')
    .service('PushHandlerService',['$state', function ($state) {
        function redirectToUserNotifications () {
            $state.goMainLayout('UserNotifications');
        }

        return {
            redirectToUserNotifications: redirectToUserNotifications
        };
    }]);

'use strict';
angular.module('utilliApp').service('OutagesService', ['$timeout', function ($timeout) {

    var _currentOutage = null;
    var _selectedOutages = [];
    var _callBack = null;

    var common = {
        init: function (outages, callBack) {
            _selectedOutages = outages;
            if (_selectedOutages && _selectedOutages.length > 0)
                _currentOutage = outages[0];

            if (callBack) {
                _callBack = callBack;
                _callBack(_currentOutage);
            }
        },
        setCurrent: function (outage, displayImage) {
            small.setCurrent(outage, displayImage);
            big.setCurrent(outage);
            this.callBack();
        },
        setCurrentById: function (id) {
            small.setCurrentById(id);
            big.setCurrentById(id);
        },
        closeDetails: function close() {
            small.close();
            big.close();
        },
        getStatusIcon: function (status) {
            var preffix = utilli.isAdmin ? '../' : '';
            if (status === 0) // Unverified
                return preffix + 'Images/map-markers/blue-dot.png';
            if (status === 1) // Verified
                return preffix + 'Images/map-markers/green-dot.png';
            if (status === 2) // In Progress
                return preffix + 'Images/map-markers/yellow-dot.png';

            return preffix + 'Images/map-markers/red-dot.png';
        },

        getWorkCenterIcon: function (truckType) {
            var preffix = utilli.isAdmin ? '../' : '';
            if (truckType === 0) // Unverified
                return preffix + 'Images/map-markers/truck3.png';
            if (truckType === 1) // Verified
                return preffix + 'Images/map-markers/bluetruck.png';
            if (truckType === 2) // In Progress
                return preffix + 'Images/map-markers/bluetrucktransparent.png';

            return preffix + 'Images/map-markers/truck3.png';
        },

        getWorkOrderIcon: function (orderType) {
            var preffix = utilli.isAdmin ? '../' : '';
            if (orderType === 0) // Unverified
                return preffix + 'Images/map-markers/workorder32.png';
            if (orderType === 1) // Verified
                return preffix + 'Images/map-markers/workorder32.png';
            if (orderType === 2) // In Progress
                return preffix + 'Images/map-markers/workorder32.png';

            return preffix + 'Images/map-markers/workorder32.png';
        },
        displayDetails: function () {
            small.displayDetails();
            big.displayDetails();
        },
        callBack: function () {
            if (_callBack)
                _callBack(_currentOutage);
        }
    };
    var small = {
        setCurrent: function (outage, displayImage) {
            _currentOutage = outage;
            var outageImage = $('#imageContainerSm');
            if (_currentOutage.Image && displayImage) {
                outageImage.removeClass('ng-hide');
                outageImage.css('background-image', 'url(' + _currentOutage.Image + ')');
                this.adjustImageSize();
            } else {
                if (!outageImage.hasClass('ng-hide'))
                    outageImage.addClass('ng-hide');
            }
            common.callBack();
        },
        setCurrentById: function (id) {
            var selectedOutage = _.find(_selectedOutages, function (outage) {
                return outage.Id === id;
            });
            this.setCurrent(selectedOutage);
        },
        next: function () {
            var index = _.indexOf(_selectedOutages, _currentOutage);
            if (index >= _selectedOutages.length - 1) {
                common.callBack();
                return;
            }

            index++;
            var nextOutage = _selectedOutages[index];
            var displayImage = this.allInfoShown();
            common.setCurrent(nextOutage, displayImage);

        },
        previous: function () {
            var index = _.indexOf(_selectedOutages, _currentOutage);
            if (index <= 0) {
                common.callBack();
                return;
            }

            index--;
            var previousOutage = _selectedOutages[index];
            var displayImage = this.allInfoShown();
            common.setCurrent(previousOutage, displayImage);
        },
        disablePrevious: function () {
            if (!_selectedOutages || !_currentOutage)
                return true;

            var isFirst = _currentOutage === _selectedOutages[0];
            return isFirst;
        },
        disableNext: function () {
            if (!_selectedOutages || !_currentOutage)
                return true;

            var isLast = _currentOutage === _selectedOutages[_selectedOutages.length - 1];
            return isLast;
        },
        addressClicked: function () {
            if (_currentOutage.Image) {
                var outageImage = $('#imageContainerSm');
                outageImage.css('background-image', 'url(' + _currentOutage.Image + ')');
                outageImage.removeClass('ng-hide');
                this.adjustImageSize();
            }

            var outageDetails = $('.state-details');
            outageDetails.removeClass('ng-hide');
        },
        allInfoShown: function () {
            var outageDetails = $('.state-details');
            var infoShown = !outageDetails.hasClass('ng-hide');
            return infoShown;
        },
        displayDetails: function () {
            this.setCurrent(_currentOutage);
            var outageDetailsSm = $('.outage-details-sm');
            outageDetailsSm.removeClass('ng-hide');
        },
        adjustImageSize: function () {
            var imageElement = $('#imageContainerSm');
            var contentContainerHeight = $('.y-scrollable').innerHeight();
            var containerOtherElemententsHeight = $('.y-scrollable')[0].getBoundingClientRect().bottom - imageElement[0].getBoundingClientRect().bottom;
            var height = contentContainerHeight - containerOtherElemententsHeight - 1;
            imageElement.height(height);
        },
        close: function () {
            var outageDetailsSm = $('.outage-details-sm');
            outageDetailsSm.addClass('ng-hide');

            var stateDetails = $('.state-details');
            stateDetails.addClass('ng-hide');

            var containerSm = $('#imageContainerSm');
            containerSm.addClass('ng-hide');
        }
    };

    var big = {
        handleClick: function (outage) {
            var panelCollapse = $('#' + outage.Id);
            if (panelCollapse.hasClass('in')) {
                // panel expanded, collapse it
                this.collapse(panelCollapse);
            } else {
                // panel collapsed, expand it
                common.setCurrent(outage);
            }
            common.callBack();
        },
        setCurrentById: function (id) {
            var outage = _.find(_selectedOutages, function (item) {
                return item.Id == id;
            });
            this.setCurrent(outage);
        },
        setCurrent: function (outage) {
            _currentOutage = outage;
            var panel = $('#' + outage.Id);
            if (!panel.hasClass('in')) {
                // panel collapsed, expand it
                this.expand(panel);
            } else {
                this.adjustOutageDetailsSize(true);
            }

            common.callBack();
        },
        collapse: function (panel) {
            var outageDetails = $('.outage-details');
            var outageDetailsHeight = outageDetails.height() - panel.height();
            outageDetails.animate({ height: outageDetailsHeight }, 300);
            panel.slideToggle(300);
            panel.removeClass('in');
            panel.parents('.panel').children('.panel-heading').addClass('collapsed');
        },
        expand: function expand(panel) {
            // if there is expanded item - collapse it.
            var expanedPanels = $('.panel-collapse.collapse.in');
            if (expanedPanels.length > 0) {
                expanedPanels.slideToggle(100);
                expanedPanels.removeClass('in');
                expanedPanels.parents('.panel').children('.panel-heading').addClass('collapsed');
            }

            panel.slideToggle(100);
            panel.addClass('in');
            // if there is no expanded item - increase the height of outage-details div, in other case
            // the height is not changed because the panel-body area will appear instead of collapsed one in the begining of the function.
            var outageDetailsHeaderHeight = 43;
            var outageDetailsBodyHeight = 256;
            var height = _selectedOutages.length * outageDetailsHeaderHeight + outageDetailsBodyHeight;
            var outageDetails = $('.outage-details');
            outageDetails.animate({ height: height }, 100);

            panel.parents('.panel').children('.panel-heading.collapsed').removeClass('collapsed');
        },
        displayDetails: function () {
            var outageDetails = $('.outage-details');
            outageDetails.height(0);
            outageDetails.removeClass('ng-hide');

            var me = this;
            $timeout(function () {
                _.each(_selectedOutages, function (outage) {
                    if (!outage.Image)
                        return;

                    me.attachImage(outage);
                });
            }, 100);
            this.setCurrent(_currentOutage);
        },
        adjustOutageDetailsSize: function (expandedExist) {
            var details = $('.outage-details');
            var height = _selectedOutages.length * 43;
            if (expandedExist)
                height += 256;
            details.height(height);
        },
        attachImage: function (outage) {
            var container = $('#imageContainer' + outage.Id);
            container.css('background-image', 'url(' + outage.Image + ')');
        },
        close: function () {
            var outageDetails = $('.outage-details');
            outageDetails.height(0);
            outageDetails.addClass('ng-hide');
        }
    };

    return {
        common: common,
        small: small,
        big: big
    }
}]);

angular.module('utilliApp')
    .service('AccountListService', ["$rootScope", "LeftMenuService", "DueReminderService", "$timeout",
     function($rootScope, LeftMenuService, DueReminderService, $timeout) {

        var changeContractAccount = function(acc, fnCallback) {
            localStorage.setItem('CurrentAccountNumber', acc.AccountNumber);
            localStorage.setItem('CurrentUtilityType', acc.UtilityType);//todo: to constants structure
            DueReminderService.unmarkAsShown();

            // update current user in left menu (avatar, name)
            LeftMenuService.changeAccount(acc.AccountNumber);

            $rootScope.showSlideAnimation = true;

            if(fnCallback)
                fnCallback();

            $timeout(function () {
                $rootScope.showSlideAnimation = false;
            }, 300);
         }

        function getCurrentContractAccount () {
            var result = localStorage.getItem('CurrentAccountNumber');
            return result;
        }

        return {
            changeContractAccount: changeContractAccount,
            getCurrentContractAccount: getCurrentContractAccount,
        };

    }]);

angular.module('utilliApp')
    .service('productTourService', ['$http', 'ModalServiceExt', function ($http, ModalServiceExt) {

        var tour = null;
        var tourOptions = null;

        function isTourActive() {
            var tour = hopscotch.getCurrTour();
            if (tour)
                return true;
            return false;
        }

        function pauseTour() {
            hopscotch.unregisterHelper('onEndTour');
            var clearCookie = false;
            hopscotch.endTour(clearCookie);
        }

        function tourClosed(tourOptions, currentStep) {
            if (currentStep === tourOptions.steps.length - 1)
                return;

            ModalServiceExt.showYesNoMessage(
                utilli._t('Close tour'),
                utilli._t('Are you sure you want to stop this product tour?'),
                function () {
                    var clearCookie = true;
                    hopscotch.endTour(clearCookie);
                    tourDone(tourOptions.id);
                },
                function () {
                    hopscotch.startTour(tourOptions, currentStep);
                }, true);
        }

        function tourDone(tourId) {
            $('#panel')[0].onscroll = null;
            $('#menu')[0].onscroll = null;

            var url = localStorage.getItem('ApiUrl') + 'api/User/ProductTourDone';
            $http({
                method: 'POST',
                url: url,
                data: { '': tourId }
            }).success(function (response) {
                if (response.Errors && response.Errors.length > 0)
                    console.error('tourDone(): server returned [' + response.Errors[0] + '].');
            }).error(function (error) {
                console.error('tourDone(): error [' + err + '].');
            })
        }

        function scrollMenu() {
            var target = tour.getCurrTarget();
            var rect = target.getBoundingClientRect();
            var viewPortHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            if (rect.bottom > viewPortHeight) {
                var menuElement = $('#menu')[0];
                menuElement.scrollTop = menuElement.scrollHeight;
            }
        }

        function nextStep(tour) {
            var step = tour.getCurrStepNum();
            // for now only 4 the first tour bubbles attached to menu items that can be scrolled.
            if (step < 4) {
                return;
            }

            scrollMenu();
        }

        function startTour(tourJson) {
            tourOptions = JSON.parse(tourJson);
            tour = hopscotch.startTour(tourOptions);
            hopscotch.registerHelper('onCloseTour', function () {
                var currentStep = tour.getCurrStepNum();
                tourClosed(tourOptions, currentStep);
            });
            hopscotch.registerHelper('onEndTour', function () {
                tourDone(tourOptions.id);
            });
            hopscotch.registerHelper('onNextStep', function () {
                nextStep(tour);
            });

            $('#menu .collapse').on('hidden.bs.collapse', function () {
                tour.refreshBubblePosition();
            });
            $('#menu .collapse').on('shown.bs.collapse', function () {
                scrollMenu();
                tour.refreshBubblePosition();
            });

            $('#panel')[0].onscroll = function () {
                var currentStep = tour.getCurrStepNum();
                // step 2 for now points to notifications icon placed on top menu and should not be scrolled.
                // other following steps for now are attached to left menu and should not be scrolled with #panel.
                if (currentStep > 1)
                    return;

                tour.refreshBubblePosition();
                var currentTarget = tour.getCurrTarget();
                var rect = currentTarget.getBoundingClientRect();
                // Magic number 65 is height of top menu.
                if (rect.top + rect.height < 65) {
                    $('.hopscotch-bubble').hide();
                } else {
                    $('.hopscotch-bubble').show();
                }
            }

            $('#menu')[0].onscroll = function () {
                var currentStep = tour.getCurrStepNum();
                // tour bubbles attached to left menu begin from 4th. Number of steps in tour is zero based.
                if (currentStep < 3)
                    return;

                tour.refreshBubblePosition();
                var currentTarget = tour.getCurrTarget();
                var rect = currentTarget.getBoundingClientRect();
                // Magic number 65 is height of top menu.
                if (rect.top + rect.height < 65) {
                    $('.hopscotch-bubble').hide();
                } else {
                    $('.hopscotch-bubble').show();
                }
            }
        }

        return {
            startTour: startTour,
            isTourActive: isTourActive,
            pauseTour: pauseTour
        }
    }]);
angular.module('utilliApp')
    .service('propertyManagerTourService', ['$http', 'ModalServiceExt', function ($http, ModalServiceExt) {

        var tour = null;
        var tourOptions = null;
        var steps = [
            'ImportProperty',
            'AddProperty',
            'PropertyOverview',
            'PropertyTypes',
            'PropertyDetails',
            'AddMeters',
            'Authorization',
            'Dashboard',
            'Groups',
            'Profile',
            'EnergyInsights'
        ];

        function isTourActive() {
            var tourJson = localStorage.getItem("PropertyManagerTour");
            if (!utilli.checkDefinedValue(tourJson))
                return false;

            tourOptions = angular.fromJson(tourJson);
            var step = localStorage.getItem(tourOptions.id);
            if (utilli.checkDefinedValue(step))
                return true;
            return false;
        }

        function pauseTour() {
            hopscotch.unregisterHelper('onEndTour');
            localStorage.setItem(tourOptions.id, tour.getCurrStepNum());
            hopscotch.endTour();
        }

        function resumeTour(stepName) {
            if(isMobileOrRipple())
                return;
            var stepNumber = _.indexOf(steps, stepName);

            var tourJson = localStorage.getItem('PropertyManagerTour');
            var step = localStorage.getItem(tourOptions.id);
            var stepInt = parseInt(step);
            if (stepInt == stepNumber)
                startTourInternal(tourJson, stepInt);
        }

        function tourClosed(tourOptions, currentStep) {
            ModalServiceExt.showYesNoMessage(
                utilli._t('Close tour'),
                utilli._t('Are you sure you want to stop this product tour?'),
                function () {
                    var clearCookie = true;
                    hopscotch.endTour(clearCookie);
                    tourDone(tourOptions.id);
                },
                function () {
                    hopscotch.startTour(tourOptions, currentStep);
                }, true);
        }

        function tourDone(tourId) {
            $('#panel')[0].onscroll = null;

            localStorage.setItem(tourOptions.id, null);
            localStorage.setItem('PropertyManagerTour', null);

            var url = localStorage.getItem('ApiUrl') + 'api/PropertyManagers/TourDone';
            $http({
                method: 'POST',
                url: url,
                data: { '': tourId }
            }).success(function (response) {
                if (response.Errors && response.Errors.length > 0)
                    console.error('tourDone(): server returned [' + response.Errors[0] + '].');
            }).error(function (error) {
                console.error('tourDone() failed: ' + error);
            })
        }

        function nextStep(tour) {
            var step = localStorage.getItem(tourOptions.id);
            if (utilli.checkDefinedValue(step)) {
                var stepInt = parseInt(step);
                localStorage.setItem(tourOptions.id, stepInt + 1);
            } 
            else {
                step = 0;
                localStorage.setItem(tourOptions.id, step + 1);
            }

            if (tourOptions.steps[step].showSkip) {
                hopscotch.unregisterHelper('onEndTour');
                hopscotch.endTour();
            }
        }

        function startTour(callback) {
            if(isMobileOrRipple()){
                if (callback)
                    callback();
                return;
            }
            var tourJson = localStorage.getItem('PropertyManagerTour');
            if (utilli.checkDefinedValue(tourJson)) {
                var tourOptions = angular.fromJson(tourJson);
                var step = localStorage.getItem(tourOptions.id);
                if (utilli.checkDefinedValue(step)) {
                    var stepInt = parseInt(step);
                    startTourInternal(tourJson, stepInt);

                    if (callback)
                        callback();

                    return;
                }
            }

            $http({
                method: "GET",
                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetPropertyManagerTour/',
            }).success(function (response) {

                if (callback)
                    callback();

                if (!response.Data)
                    return;

                startTourInternal(response.Data);
            }).error(function (error) {
                if (callback)
                    callback();

                console.error("Get property manager tour error: ", error);
            });
        }

        function startTourInternal(tourJson, step) {
            sessionStorage.clear();
            tourOptions = JSON.parse(tourJson);
            // var addPropertyStep = _.find(tourOptions.steps, function (step) { return step.title == "Add Property"});
            // addPropertyStep.onNext = function () { };

            if (step) {
                tour = hopscotch.startTour(tourOptions, step);
            } else {
                tour = hopscotch.startTour(tourOptions);
                localStorage.setItem('PropertyManagerTour', tourJson);
            }

            hopscotch.registerHelper('onCloseTour', function () {
                var currentStep = tour.getCurrStepNum();
                tourClosed(tourOptions, currentStep);
            });
            hopscotch.registerHelper('onEndTour', function () {
                tourDone(tourOptions.id);
            });
            hopscotch.registerHelper('onNextStep', function () {
                nextStep(tour);
            });

            $('#menu .collapse').on('hidden.bs.collapse', function () {
                tour.refreshBubblePosition();
            });
            $('#menu .collapse').on('shown.bs.collapse', function () {
                scrollMenu();
                tour.refreshBubblePosition();
            });

            $('#panel')[0].onscroll = function () {
                var currentStep = tour.getCurrStepNum();
                // step 5 for now points to notifications icon placed on top menu and should not be scrolled.
                // other following steps for now are attached to left menu and should not be scrolled with #panel.
                if (currentStep > 5)
                    return;

                tour.refreshBubblePosition();
                var currentTarget = tour.getCurrTarget();
                var rect = currentTarget.getBoundingClientRect();
                // Magic number 65 is height of top menu.
                if (rect.top + rect.height < 65) {
                    $('.hopscotch-bubble').hide();
                } else {
                    $('.hopscotch-bubble').show();
                }
            }
        }

        return {
            startTour: startTour,
            isTourActive: isTourActive,
            pauseTour: pauseTour,
            resumeTour: resumeTour
        }
    }]);
angular.module('utilliApp')
    .service('RegistrationInfoService', function() {
        var userInfo =  {
            accountnumber: "",
            zip: "",
            customerfullname: "",
            token: ""
        }
     
        return {
            userInfo: userInfo
        };
    });

'use strict';
angular.module('utilliApp')
    .controller('NotificationDetailsController',
    [
        '$scope', '$http', 'usSpinnerService', '$state', '$stateParams', 'CommonHeaderService', 'ModalServiceExt',
        function ($scope, $http, usSpinnerService, $state, $stateParams, CommonHeaderService, ModalServiceExt) {

            CommonHeaderService.setUp($scope._t('Notification Details'));

            usSpinnerService.spin('spinner-1');

            var apiUrl = localStorage.getItem("ApiUrl");

            $http({
                url: apiUrl + 'api/NotificationsLog/GetPortalNotificationAndSetViewed',
                method: 'GET',
                params: { Id: $stateParams.Id }
            })
            .success(function (data) {
                usSpinnerService.stop('spinner-1');
                $scope.notificationLog = data.Data;
            })
            .error(function (error) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });

            $scope.cancel = function () {
                $state.goMainLayout('UserNotifications');
            }
        }
    ]);
'use strict';

angular.module('utilliApp')
.controller('UserNotificationsController', ['$scope', '$http', '$window', 'LeftMenuService',
    'CommonHeaderService', 'ModalServiceExt', '$state', 'usSpinnerService',
function ($scope, $http, $window, LeftMenuService, CommonHeaderService, ModalServiceExt, $state, usSpinnerService) {

    LeftMenuService.setCurrentTab('Messages');
    CommonHeaderService.setUpBackButton();
    CommonHeaderService.setTitle($scope._t('Notifications'));

    $scope.back = function () {
        $window.history.back();
    }

    $scope.isBusy = false;
    $scope.endReached = false;
    var notificationsLoadedCount = 0;
    var pageSize = 20;

    $scope.notificationsForScrolling = [];

    $scope.getNotifications = function () {

        if ($scope.isBusy)
            return;

        usSpinnerService.spin('spinner-1');

        $scope.isBusy = true;

        var accountNumber = utilli.hasPropertyManagerRole() ? 'propertyManager' : localStorage.getItem('CurrentAccountNumber');

        var dataRequest = { accountNumber: accountNumber, skip: notificationsLoadedCount, pageSize: pageSize };
        if (utilli.hasPropertyManagerRole()) {
            dataRequest.userName = localStorage.getItem('current_user');
        }
        utilli.addUserName($state, dataRequest);
        $http({
            url: localStorage.getItem('ApiUrl') + 'api/NotificationsLog/GetUserPortalNotifications/',
            method: "GET",
            params: dataRequest
        }).success(function (data) {
            if (data.Errors && data.Errors.length > 0) {
                ModalServiceExt.showError(data.Errors[0]);
            } else {
                acceptNotifications(data.Data);
            }

            usSpinnerService.stop('spinner-1');
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    };

    function acceptNotifications(notifications) {
        if (notifications.length === 0)
        {
            $scope.isBusy = false;
            $scope.endReached = true;
            return;
        }

        for (var i = 0; i < notifications.length; i++) {
            $scope.notificationsForScrolling.push(notifications[i]);
            notificationsLoadedCount++;
        }

        if (notifications.length < pageSize) {
            $scope.endReached = true;
        }

        $scope.isBusy = false;
    };

    $scope.setViewed = function (notification) {

        if (notification.IsViewed)
            return;

        $http({
            method: 'POST',
            url: localStorage.getItem('ApiUrl') + 'api/NotificationsLog/SetNotificationViewed',
            data: { '': notification.Id }
        })
        .success(function(response) {
            if (response.Errors && response.Errors.length > 0) {
                ModalServiceExt.showError(response.Errors[0]);
                return;
            }

            notification.IsViewed = true;
        })
        .error(function() {
            ModalServiceExt.showServerError();
        });
    }
}]);
'use strict';

angular.module('utilliApp')
    .controller('UserNotificationsGridController', [
        '$scope', '$http', '$state', '$stateParams', 'GridService', 'ModalServiceExt',
        function($scope, $http, $state, $stateParams, GridService, ModalServiceExt) {
            var gridResizeFunc = GridService.getGridResizeFunc($("#notificationsGrid"));

            $(window)
                .resize(function() {
                    gridResizeFunc($scope.notificationsKendoGrid);
                });

            $scope.viewDetails = function(id) {
                $state.goMainLayout('NotificationDetails', { Id: id });
            }

            var apiUrl = localStorage.getItem('ApiUrl');
            var accountNumber = localStorage.getItem('CurrentAccountNumber');

            $scope.gridOptions = {
                dataSource: {
                    transport: {
                        read: function(options) {
                            var webapi = new kendo.data.transports.webapi({ prefix: "" });
                            var params = webapi.parameterMap(options.data);
                            params = $.extend(params,
                                {
                                    accountNumber: utilli.hasPropertyManagerRole() ? "propertyManager" : accountNumber
                                });
                            if (utilli.hasPropertyManagerRole()) {
                                params.userName = localStorage.getItem('current_user');
                            }

                            var notificationsUrl = apiUrl + 'api/NotificationsLog/GetUserPortalNotifications/';
                            $http.get(notificationsUrl, { params: params })
                                .success(function(data) {
                                    options.success(data);
                                    gridResizeFunc($scope.notificationsKendoGrid);
                                })
                                .error(function() {
                                    options.error();
                                });
                        }
                    },
                    schema: { data: "Data.PageData", total: "Data.Count" },
                    pageSize: 20,
                    serverPaging: true
                },
                sortable: true,
                pageable: {
                    pageSize: 10,
                    pageSizes: [10, 25, 50],
                    buttonCount: 3,
                    refresh: true
                },
                filterable: {
                    extra: false,
                    operators: {
                        string: {
                            contains: $scope._t('Contains'),
                            startswith: $scope._t("Starts with"),
                            eq: $scope._t("Is equal to"),
                            neq: $scope._t("Is not equal to")
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                dataBound: function() { gridResizeFunc($scope.notificationsKendoGrid); },
                columns: [
                {
                    field: "ContractAccountNumber",
                    title: $scope._t("Account Number"),
                    width: 100
                }, {
                    field: "UserId",
                    title: $scope._t("User"),
                    template: "#= UserName #",
                    width: 100
                },
                {
                    field: "ScheduledOn",
                    title: $scope._t("Scheduled On"),
                    template: "#= DisplayedScheduledOn #",
                    width: 100,
                    type: "date",
                    filterable: {
                        ui: dateTimeFilter
                    }
                },
                {
                    field: "IsViewed",
                    title: $scope._t("Viewed"),
                    template: "#= DisplayedIsViewed #",
                    width: 100,
                    filterable: {
                        ui: viewedFilter,
                        operators: {
                            string: {
                                eq: $scope._t('Is equal to'),
                                neq: $scope._t('Is not equal to')
                            }
                        }
                    }
                },
                {
                    title: $scope._t("Actions"),
                    template: kendo.template($("#commands-template").html()),
                    width: "100px"
                }]
            }

            function dateTimeFilter(element) {
                element.kendoDateTimePicker({
                    format: "MM/dd/yyyy HH:mm:ss",
                    timeFormat: "HH:mm:ss"
                });
            }

            function viewedFilter(element) {
                element.kendoDropDownList({
                    dataTextField: "Name",
                    dataValueField: "Value",
                    dataSource: {
                        transport: { 
                            read: function (options) {
                                var webapi = new kendo.data.transports.webapi({ prefix: "" });
                                var params = webapi.parameterMap(options.data);
                                params = $.extend(params, { search: $scope.searchingText });
                                var url = localStorage.getItem('ApiUrl') + 'api/CommonData/GetNotificationViewedStatusesNames';
                                $http.get(url, { params: params })
                                    .success(function (data) {
                                        options.success(data);
                                        gridResizeFunc($scope.usersKendoGrid);
                                    })
                                    .error(function () {
                                        options.error();
                                    });
                            }   
                         },
                        schema: { data: "Data" }
                    },
                    optionLabel: $scope._t("--Select Value--")
                });
            }
        }
    ]);
'use strict';
angular.module('utilliApp')
    .controller('AccountListController', ['$scope', '$rootScope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', 'GetAccountsService', '$stateParams', 'CommonHeaderService',
        'DueReminderService', 'ModalServiceExt', 'AccountListService',
    function ($scope, $rootScope, $http, $timeout, $window, usSpinnerService, LeftMenuService, $state,
        GetAccountsService, $stateParams, CommonHeaderService, DueReminderService, ModalServiceExt, AccountListService) {
            var _t = $scope._t;
            LeftMenuService.setCurrentTab('AccountList');

        $scope.DeleteAccount = function () {
            $state.goMainLayout("EditAccounts");
        };
        CommonHeaderService.setUp(_t('My Accounts'), _t('Edit'), $scope.DeleteAccount, true);
        $scope.errors = [];
        $scope.accountDataList = {};
        //it is copypast of the EditAccountCtrl.js -> GoToAccountList
        $scope.GoToAccountDashboard = function (acc) {
            AccountListService.changeContractAccount(acc, function () {
                if (utilli.isAdmin)
                    $state.params.contractAccountNumber = acc.AccountNumber;
                $state.goMainLayout("Dashboard", $state.params);
            });
        };

        function getBalance(account)
        {
            var url = localStorage.getItem('ApiUrl') + 'api/Account/GetAccountBalance/';
            var params = { accountNumber: account.AccountNumber };
            utilli.addUserName($state, params);

            $http({
                url: url,
                method: "GET",
                params: params
            }).success(function (data) {

                account.isBalanceLoaded = true;

                if (!data || data.Errors.length > 0)
                {
                    $scope.errors = data.Errors;
                    return;
                }
                
                account.TotalBalance = data.TotalBalance;
                account.DueDate = data.DueDate;
                account.dueDateTicks = Date.parse(account.DueDate);
                account.IsAccountDisconnected = data.IsAccountDisconnected;
                account.IsAccountDisconnectionPending = data.IsAccountDisconnectionPending;
            }).error(function () {
                account.isBalanceLoaded = true;
                $scope.errors = [{Message: utilli.errors.serverErrorMessage}];
            });
        }

        function showDueDateInternal(account)
        {
            return account.TotalBalance > 0 && account.DueDate != '0001-01-01T00:00:00';
        }

        function showPastDueInternal(account) {
            if (showDueDateInternal(account))
                return new Date(account.dueDateTicks) < utilli.getDateWithoutTime();

            return false;
        }

        $scope.showDueDate = function (account) {
            return showDueDateInternal(account);
        }

        $scope.showPastDue = function (account)
        {
            return !account.IsAccountDisconnected && !account.IsAccountDisconnectionPending && showPastDueInternal(account);
        }

        $scope.getTotalBalanceClass = function (account) {

            if (showPastDueInternal(account))
                return 'warnig-color';
            else
                return 'success-color';
        }

        $scope.getAccountBalanceClass = function (account) {
            if (showDueDateInternal(account))
                return '';

            return 'balance-without-dueDate';
        }

        $scope.getDueDateClass = function (account) {
            if (showPastDueInternal(account))
                return 'warnig-color';

            return '';
        }

        $scope.getUtilityImage = function(data)
        {
            if (data.UtilityType == 'Gas')
                return 'gas-bgr';
            if (data.UtilityType == 'Water')
                return 'water-bgr';
            if (data.UtilityType == 'Electricity')
                return 'elctr-bgr';

            return '';
        }

        function logout() {
            utilli.clearLocalStorage();

            $state.goToWelcome();
        }

        usSpinnerService.spin('spinner-1');

        var promise = GetAccountsService.getAccounts(true);
        promise.then(function (response) {

            usSpinnerService.stop('spinner-1');

            if (response.Errors && response.Errors.length > 0) {
                ModalServiceExt.showError(response.Errors[0].Message);
                return;
            }

            if ($stateParams.redirectIfSingle === 'true' && response.Accounts.length == 1) {
                $scope.GoToAccountDashboard(response.Accounts[0]);
            }
            else {
                $scope.accountDataList = response.Accounts;

                $scope.accountDataList.forEach(function(item) {
                    getBalance(item);
                });
            }

        }).catch(function (e) {
            usSpinnerService.stop('spinner-1');
            console.log(e);
        });
    }])
;
'use strict';
function InitSideMenu(){
    // turn off touches for windows phone and old iOS because we haven't fixed issues for them
    var isTouchDisabled = deviceIsWindowsPhone || (iOS() && getIosVersionFloat() < 7);
    if (deviceIsWindowsPhone) {
        window.slideout = new Slideout({
            'panel': document.getElementById('panel'),
            'menu': document.getElementById('menu'),
            'padding': 260,
            'tolerance': 70,
            'touch': !isTouchDisabled
        });

        $('body').on('click', '.toggle-show-menu, .main-panel-blocker', function () {
            window.slideout.toggle();
        });
    }
    else {
        window.snapper = new Snap({
            element: document.getElementById('panel'),
            disable: 'right',
            maxPosition: 260,
            minPosition: -260
        });
        $('body').on('click', '.toggle-show-menu, .main-panel-blocker', function () {
            if (snapper.state().state == "left") {
                snapper.close();
            } else {
                snapper.open('left');
            }
        });
        // enable drag only on mobile
        if (!isMobileOrRipple()) {
            snapper.disable();
        }
    }
}
'use strict';
angular.module('utilliApp')
.controller('MainLayoutController', [
    function () {
        InitSideMenu();
    }]);
'use strict';
angular.module('utilliApp')
    .controller('WelcomeFooterController', ['$scope', '$state',
        function ($scope, $state) {

            $scope.enableLanguagePack = utilli.isLanguagePackEnabled();
            if (!$scope.enableLanguagePack)
                return;

            var language = localStorage.getItem('language');
            var languageParams = _.find(utilli.languages[DeploymentSettings.providersGroupShortName.toLowerCase()], function (x) { return language === x.abbreviation });
            if (!languageParams)
                $scope.currentLanguage = 'English';
            else
                $scope.currentLanguage = languageParams.name;

            $scope.goToLanguages = function () {
                $state.go('TopMenuLayout.Languages');
            }

            $scope.enablePropertyManagerLink = Config.providers[DeploymentSettings.currentServiceProvider].EnablePropertyManagerLink;
            $scope.isSsoLinkVisible = DeploymentSettings.currentServiceProvider === Config.wglProviderName && !isMobileOrRipple();
        }]);
'use strict';
angular.module('utilliApp')
    .controller('LeftMenuController', ['$scope', '$interval', '$rootScope', '$http', 'LeftMenuService', '$window', '$state',
        'CommonDataService', 'RequestService', 'usSpinnerService', 'ModalServiceExt', '$timeout',
        function ($scope, $interval, $rootScope, $http, LeftMenuService, $window, $state, CommonDataService,
            RequestService, usSpinnerService, ModalServiceExt, $timeout) {
            setMenuTemplate();
            // init the left menu for a current user and a current contract account if it's already selected
            $scope.deviceIsWindowsPhone = deviceIsWindowsPhone;
            
            var accountNumber = localStorage.getItem('CurrentAccountNumber');
            LeftMenuService.changeAccount(accountNumber);

            $scope.leftMenu = LeftMenuService;
            $scope.isMenuLoaded = false;
            $scope.signOut = LeftMenuService.signOut;
            $scope.isAdmin = utilli.isAdmin;
            $scope.isPx = utilli.isPx();

            $rootScope.$on('profile-updated', function (event, args) {
                var accountNumber = localStorage.getItem('CurrentAccountNumber');
                LeftMenuService.changeAccount(accountNumber);
            })

            $scope.goTo = function (state, contractAccountNumber) {
                
                // NB!!!: this goTo is for unusual cases such as customer view in admin or for assistants where we
                // change current contract account when the user clicks on the left menu item.
                // for regular navigation we use ng-href because this way it's possible to open pages in separate tab
                // by ctrl+click or middle mouse button click.

                usSpinnerService.stop('spinner-1');
                if ($window.slideout)
                    $window.slideout.toggle();
                else
                    if ($window.snapper) {
                        $window.snapper.close();
                    }
                RequestService.abort();
                // contractAccountNumber is not empty for second level menu items in assistants
                if (contractAccountNumber){
                    LeftMenuService.selectContractAccount(contractAccountNumber, state);
                    // return because state.go happens in LeftMenuService.selectContractAccount
                    return;
                }

                if ($scope.checkAccess(state) && utilli.isAdmin) {
                    // We should set options.reload as state name instead of 'true', because if we set it as 'true' 
                    // all the parent states of the target state will reload with their previous parameters 
                    // that can be not actual for the moment (at list for the nested customer app in the admin portal) 
                    // and we will have tricky issues with wrong data.
                    $state.goMainLayout(state, {}, { reload: state });
                } else {
                    $state.goMainLayout(state, {}, { reload: state });
                }
            };

            var mapping = {
                'AccountList': '#account-manager-menu-items',
                'Profile': '#account-manager-menu-items',
                'ChangePassword': '#account-manager-menu-items',

                'PayNow': '#bill-payment-menu-items',
                'PaymentOptions': '#bill-payment-menu-items',
                'BillsAndPayments': '#bill-payment-menu-items',

                'Messages': '#notifications-menu-items',
                'Preferences': '#notifications-menu-items',

                'ReportOutage': '#outage-center-menu-items',
                'OutageMap': '#outage-center-menu-items',
                'OutageList': '#outage-center-menu-items',
                'OutageCenter': '#outage-center-menu-items',

                'MeterData': '#service-center-menu-items',
                'MoveService': '#service-center-menu-items',
                'CancelService': '#service-center-menu-items',
            }

            var expandCurrentMenuItem = function () {
                var menuElement;
                // don't expand for sub-menu-items for assistants because we do it right after loading
                // top 3 search history items in LeftMenuService.loadTop3SearchHistoryItems
                if (utilli.hasAssistantRole() && (LeftMenuService.currentTab === 'Dashboard' 
                    || LeftMenuService.currentTab === 'BillsAndPayments')) {
                    return;
                }
                menuElement = $(mapping[LeftMenuService.currentTab]);
                menuElement.collapse();
            };
            // includeContentLoaded here because left menu is loaded via ngInclude
            $scope.$on('$includeContentLoaded', function(){
                // nest function here for easy debug
                expandCurrentMenuItem(); 
            });

            $scope.checkAccess = function (e, stateName) {
                var isAccountDataValid = utilli.localStorageItemNotNull('CurrentAccountNumber') && utilli.localStorageItemNotNull('CurrentUtilityType'); 
                if (utilli.hasAgentRole() && isProtectedPage(stateName) && !isAccountDataValid) {
                    e.preventDefault();
                    ModalServiceExt.showInfo($scope._t("You need to choose a contract account (by search or search history pages)."));
                    return false;
                }

                return true;
            }

            function isProtectedPage (stateName) {
                var result = stateName == 'Dashboard' || stateName  == 'BillsAndPayments' || stateName  == 'MeterData';
                return result;
            }

            function itemNotNull(name) {
                var result = localStorage.getItem(name) != null && localStorage.getItem(name) != "null";
                return result;
            }

            $scope.getStateRef = function (stateName) {
                if (utilli.isAdmin) {
                    return '';
                } else {
                    return $state.href('MainLayout.' + stateName);
                }
            }

            CommonDataService.getCommonData()
                .then(function (commonData) {
                    LeftMenuService.currentMenu.OutageCenter.isVisible = commonData.EnableOutageMap;
                    LeftMenuService.currentMenu.CancelService.isVisible = commonData.EnableCancelService;
                    LeftMenuService.currentMenu.MoveService.isVisible = commonData.EnableMoveService;
                    LeftMenuService.currentMenu.MeterData.isVisible = commonData.EnableMeterDataPage;
                    LeftMenuService.currentMenu.EnergyEfficiency.isVisible = commonData.EnableEnergyEfficiencyPage;
                    LeftMenuService.currentMenu.ProgramEnrolments.isVisible = commonData.EnableProgramEnrolments;
                    $scope.isMenuLoaded = true;
                },
                    function () {
                        $scope.isMenuLoaded = true;
                        // error handling happens in other places for getCommonData
                    }
                );

            function setMenuTemplate() {
                if (utilli.hasAgentRole())
                    $scope.menuTemplate = utilli.isAdmin ? '../Pages/Agents/LeftMenu.html' : 'Pages/Agents/LeftMenu.html';
                else if (utilli.hasAssistantRole())
                    $scope.menuTemplate = utilli.isAdmin ? '../Pages/Assistants/LeftMenu.html' : 'Pages/Assistants/LeftMenu.html';
                else if (utilli.hasPropertyManagerRole())
                    $scope.menuTemplate = utilli.isAdmin ? '../Pages/PropertyManagers/LeftMenu.html' : 'Pages/PropertyManagers/LeftMenu.html';
                else if (utilli.hasFieldServiceEngineerRole()) {
                    $scope.menuTemplate = utilli.isAdmin ? '../Pages/FieldServiceEngineer/LeftMenu.html' : 'Pages/FieldServiceEngineer/LeftMenu.html';

                    // todo: remove the code below from left menu. and make sure that it doesn't lead to errors in console for regular users
                    // var sendCurrentPositionToServer = function ()
                    // {
                    //     navigator.geolocation.getCurrentPosition(function (location) {
                    //         console.log(location.coords.latitude);
                    //         console.log(location.coords.longitude);
                    //         console.log(location.coords.accuracy);

                    //         $http({
                    //             url: localStorage.getItem('ApiUrl') + 'api/TurnOffService/ReportCoordinates/',
                    //             method: "POST",
                    //             params: {
                    //                 Id: 1,
                    //                 Longitude: location.coords.longitude,
                    //                 Latitude: location.coords.latitude
                    //             }
                    //         }).success(function (response) {
                    //         }).error(function () {
                    //         });
                    //     });
                    // }
                    // var updateWorkCentersPositionsInterval = $interval(sendCurrentPositionToServer, 1500);
                    //setInterval(sendCurrentPositionToServer, 5000);
                }
                else
                    $scope.menuTemplate = utilli.isAdmin ? '../Pages/LeftMenu.html' : 'Pages/LeftMenu.html';
            }

            // $scope.$on("$destroy", function () {
            //     $interval.cancel(updateWorkCentersPositionsInterval);
            // });
        }]);
'use strict';
angular.module('utilliApp')
    .controller('NotificationBoxController', ['$scope', '$rootScope', '$http', '$window', '$state',
        'CommonDataService', 'usSpinnerService', 'NotificationBoxService',
        function ($scope, $rootScope, $http, $window, $state, CommonDataService,
            usSpinnerService, NotificationBoxService) {
            $scope.isTemporarilyHidden = false;
            NotificationBoxService.setTemporarilyHide(false);

            $scope.hideSubscribeSmsNotification = function () {
                NotificationBoxService.hideSmsSubscribeNotification();
                $scope.subscribeSmsNotificationFlag = false;
            }

            $scope.goToSubscribe = function () {
                $state.goMainLayout('Profile');
            }

            $scope.stopReminding = function () {
                NotificationBoxService.stopReminding();
                $scope.subscribeSmsNotificationFlag = false;
            }

            NotificationBoxService.registerObserverCallback(function () {
                $scope.subscribeSmsNotificationFlag = NotificationBoxService.isSmsSubscribeNotificationVisible();
                $scope.isTemporarilyHidden = NotificationBoxService.isTemporarilyHidden();
            });
        }]);
'use strict';
angular.module('utilliApp')
.controller('EnergyEfficiencyController', ['$scope', '$rootScope', '$window', '$http', '$sce', '$timeout',
    'LeftMenuService', '$stateParams', 'CommonHeaderService', 'usSpinnerService', 'ModalService', 'ModalServiceExt',
function ($scope, $rootScope, $window, $http, $sce, $timeout, LeftMenuService, $stateParams, CommonHeaderService, usSpinnerService, ModalService, ModalServiceExt) {

    LeftMenuService.setCurrentTab('EnergyEfficiency');
    CommonHeaderService.setUpBackButton($scope._t('Insights'));

    $scope.needEnergyCost = DeploymentSettings.currentServiceProvider != Config.hcProviderName;

    $scope.radioGraphType = 'calendarYear'; //'last12Monthes';
    $scope.radioGraphTypeConsumption = 'absolute';
    var _t = $scope._t;
    function isGetMetersError(jsonData) {
        return jsonData.HasErrors;
    }

    $scope.getMeterDataGraph = function () {
        startSpin();

        var apiUrl = localStorage.getItem('ApiUrl');
        var accountNumber = localStorage.getItem('CurrentAccountNumber');

        $http({
            url: apiUrl + 'api/Consumption/GetMeterInfo/',
            method: "GET",
            params: { accountNumber: accountNumber }
        }).success(function (jsonData) {
            stopSpin();
            if (jsonData) {
                if (isGetMetersError(jsonData)) {
                    ModalServiceExt.showError(jsonData[0].ERROR_LIST[0].Message);
                } else {
                    useMeterData(jsonData);
                }
            } else {
                ModalServiceExt.showError(utilli.errors.serverErrorMessage);
            }
        }).error(function (error) {
            stopSpin();
            ModalServiceExt.showError(error.Message);
        });
    };

    function useMeterData(jsonObject) {
        if (jsonObject.length > 0) {
            if (jsonObject.length == 1)
                useSingleMeterData(jsonObject);
            else
                useMiltipleMetersData(jsonObject);
        }
    };

    function useSingleMeterData(jsonObject) {
        var jsonMeterNumIs = jsonObject[0].MeterNum;
        $scope.meterNum = jsonMeterNumIs;
        if (jsonMeterNumIs == "" || jsonMeterNumIs == null) {
            $scope.isMultipleMeters = false;
        } else {
            $scope.isMultipleMeters = false;

            setCurrentMeter(jsonObject[0]);
        }
    }

    function useMiltipleMetersData(jsonObject) {
        $scope.isMultipleMeters = true;
        $scope.meterOptions = [];

        if (jsonObject.length > 0) {
            fillMeterOptions(jsonObject);
            setCurrentMeter(jsonObject[0]);
        }

        $scope.meterOptions.push({ MeterNum: $scope._t('All meters') });
    }

    function fillMeterOptions(jsonObject) {
        for (var i = 0; i < jsonObject.length; i++) {
            $scope.meterOptions.push(jsonObject[i]);
        }
    }

    function setCurrentMeter(meterInfo) {
        $scope.currentMeter = meterInfo;
        $scope.meterNum = meterInfo.MeterNum;
        $scope.initTables($scope.meterNum, $scope.radioGraphType, $scope.radioGraphTypeConsumption);
    }

    $scope.selectMeter = function () {
        setCurrentMeter($scope.currentMeter);
    }

    $scope.data = null;

    var getConsumptionEfficiency = function (value, unit) {
        return value + " " + unit;
    }

    $scope.createChartFullYear = function (data) {
        var title = data.YearOverYearFullUsageData.EfficiencyInfo;

        var unitsType = data.YearOverYearFullUsageData.ConsumptionUnit;

        var consumptionReadingIndexPreviousYear = 0;
        var consumptionReadingIndexThisYear = 1;
        var averageTemperatureIndexPreviousYear = 2;
        var averageTemperatureIndexThisYear = 3;

        var series = [
            {
                color: '#c4c4c4',
                name: $scope._t("Consumption in") + " " + data.YearOverYearFullUsageData.PreviousYear,
                data: [],
                tooltip: {
                    pointFormat: 'Consumption: {point.y} ' + unitsType,
                    headerFormat: ''
                },
                yAxis: 1
            },
            {
                color: '#099aed',
                name: $scope._t("Consumption in") + " " + data.YearOverYearFullUsageData.ThisYear,
                data: [],
                tooltip: {
                    pointFormat: 'Consumption: {point.y} ' + unitsType,
                    headerFormat: ''
                },
                yAxis: 1
            },
             {
                 color: '#a4a4a4',
                 type: 'spline',
                 name: $scope._t("Avg. Temperature in") + " " + data.YearOverYearFullUsageData.PreviousYear,
                 data: [],
                 tooltip: {
                     pointFormat: 'Average Temperature: {point.y}F',
                     headerFormat: ''
                 },
                 yAxis: 2
             },
             {
                 color: '#0069a5',
                 type: 'spline',
                 name: $scope._t("Avg. Temperature in") + " " + data.YearOverYearFullUsageData.ThisYear,
                 data: [],
                 tooltip: {
                     pointFormat: 'Average Temperature: {point.y}F',
                     headerFormat: ''
                 },
                 yAxis: 2
             }
        ];

        var categories = [];

        categories = data.YearOverYearFullUsageData.PeriodNames;

        var i = 0;
        data.YearOverYearFullUsageData.PreviousYearConsumptions.forEach(function (item) {
            series[consumptionReadingIndexPreviousYear].data.push(
            {
                name: categories[i],
                y: item,
            }
            );
            i++;
        });

        i = 0;
        data.YearOverYearFullUsageData.PreviousYearMonthlyAverageTemperatures.forEach(function (item) {
            series[averageTemperatureIndexPreviousYear].data.push(
                {
                    name: categories[i],
                    y: item,
                }
            );
            i++;
        });

        i = 0;
        data.YearOverYearFullUsageData.ThisYearConsumptions.forEach(function (item) {
            series[consumptionReadingIndexThisYear].data.push(
            {
                name: categories[i],
                y: item,
            }
            );
            i++;
        });

        i = 0;
        data.YearOverYearFullUsageData.ThisYearMonthlyAverageTemperatures.forEach(function (item) {
            series[averageTemperatureIndexThisYear].data.push(
                {
                    name: categories[i],
                    y: item,
                }
            );
            i++;
        });

        Highcharts.chart('comparChartFullYearHighcharts', {
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            chart: {
                spacingTop: 40,
                spacingBottom: 60,
                type: 'column'
            },
            title: {
                text: title
            },
            xAxis: {
                type: 'category', labels: { rotation: 0 }
            },
            yAxis: [
            {
                labels: {
                    format: '{value:,.1f} ' + data.YearOverYearFullUsageData.ConsumptionUnit
                },
                title: {
                    text: _t('Average Temperature')
                },
                opposite: true,
                visible: false,
            },
            {
                labels: {
                    format: '{value:,.0f} ' + data.YearOverYearFullUsageData.ConsumptionUnit
                },
                title: {
                    text: _t('Consumption')
                },
                min: 0
            }, {
                labels: {
                    format: '{value:,1f}' + ' F'
                },
                title: {
                    text: _t('Average Temperature')
                },
                min: 0,
                visible: true,
                opposite: true
            }],
            legend: {
                align: 'center',
                verticalAlign: 'bottom',
                y: 60,
                floating: true,
                backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                borderColor: '#CCC',
                borderWidth: 1,
                shadow: false
            },
            tooltip: {
                shared: false,
                useHTML: true
            },
            plotOptions: {
                series: {
                    cursor: 'pointer'
                }
            },
            series: series
        });

        //$("#comparChartFullYear").kendoChart({
        //    title: {
        //        text: title
        //    },
        //    legend: {
        //        position: "bottom",
        //        visible: true
        //    },
        //    seriesColors: window.themeSettings != undefined ? [themeSettings.consumptionReadingColor, themeSettings.costColor] : ["#c4c4c4", "#0069a5"],
        //    series: [
        //    {
        //        axis: "Usage",
        //        name: $scope._t("Consumption in") + " " + data.YearOverYearFullUsageData.PreviousYear,
        //        data: data.YearOverYearFullUsageData.PreviousYearConsumptions,
        //        tooltip: {
        //            visible: true,
        //            color: "white",
        //            format: "{0:n} " + data.YearOverYearFullUsageData.ConsumptionUnit
        //        },
        //    },
        //    {
        //        axis: "Usage",
        //        name: $scope._t("Consumption in") + " " + data.YearOverYearFullUsageData.ThisYear,
        //        data: data.YearOverYearFullUsageData.ThisYearConsumptions,
        //        tooltip: {
        //            visible: true,
        //            color: "white",
        //            format: "{0:n} " + data.YearOverYearFullUsageData.ConsumptionUnit
        //        },
        //    },
        //    {
        //        axis: "Temperature",
        //        type: "line",
        //        name: $scope._t("Avg. Temperature in") + " " + data.YearOverYearFullUsageData.PreviousYear,
        //        data: data.YearOverYearFullUsageData.PreviousYearMonthlyAverageTemperatures,
        //        visibleInLegend: true,
        //        tooltip: {
        //            visible: true,
        //            format: "{0} F",
        //            color: "white",
        //        },
        //    },
        //    {
        //        axis: "Temperature",
        //        type: "line",
        //        name: $scope._t("Avg. Temperature in") + " " + data.YearOverYearFullUsageData.ThisYear,
        //        data: data.YearOverYearFullUsageData.ThisYearMonthlyAverageTemperatures,
        //        visibleInLegend: true,
        //        tooltip: {
        //            visible: true,
        //            format: "{0} F",
        //            color: "white",
        //        },
        //    }
        //    ],
        //    valueAxis: [
        //        {
        //            name: "Usage",
        //            line: {
        //                visible: true
        //            },
        //            minorGridLines: {
        //                visible: true
        //            },
        //            labels: {
        //                rotation: "auto",
        //            }
        //        },
        //        {
        //            name: "Temperature",
        //            labels: {
        //                format: "{0} F"
        //            }
        //        }
        //    ],
        //    categoryAxis: {
        //        categories: data.YearOverYearFullUsageData.PeriodNames,
        //        axisCrossingValues: [0, 12],
        //        majorGridLines: {
        //            visible: false
        //        }
        //    },
        //});



    };

    $scope.createChartTable1 = function (data) {
        var title = data.SameYearDifference.ConsumptionPercents;
        if (title > 0) {
            title = "+" + title;
        }


        Highcharts.chart('comparChartTable1', {
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            chart: {
                spacingTop: 40,
                spacingBottom: 60,
                type: 'column'
            },
            title: {
                text: $scope._t("Consumption") + ": " + title + "%"
            },
            xAxis: {
                type: 'category', labels: { rotation: 0 }
            },
            yAxis: [{
                labels: {
                    format: '{value}'
                },
                title: {
                    text: _t('Consumption') + ', ' + data.YearOverYearFullUsageData.ConsumptionUnit
                },
                min: 0
            }],
            legend: {
                align: 'center',
                verticalAlign: 'bottom',
                y: 60,
                floating: true,
                backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                borderColor: '#CCC',
                borderWidth: 1,
                shadow: false
            },
            tooltip: {
                formatter: function () {
                    console.log(this);
                    return 'Period: ' + this.key + '<br/>Consumption: ' + this.y + ' ' + data.YearOverYearFullUsageData.ConsumptionUnit;
                }
            },
            plotOptions: {
                series: {
                    cursor: 'pointer'
                }
            },
            series: [{
                name: "Consumption",
                showInLegend: false,
                data: [[data.SameYearOldPeriod.PeriodName, data.SameYearOldPeriod.Consumption], [data.SameYearNewPeriod.PeriodName, data.SameYearNewPeriod.Consumption]],
            }]
        });
    };

    $scope.createChartTable2 = function (data) {
        var title = data.SameYearDifference.BillAmountPercents;
        if (title > 0) {
            title = "+" + title;
        }

        Highcharts.chart('comparChartTable2', {
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            chart: {
                spacingTop: 40,
                spacingBottom: 60,
                type: 'column'
            },
            title: {
                text: $scope._t("Bill Amount") + ": " + title + "%"
            },
            xAxis: {
                type: 'category', labels: { rotation: 0 }
            },
            yAxis: [{
                labels: {
                    format: '{value}'
                },
                title: {
                    text: _t('Bill Amount') + ', ' + '$'
                },
                min: 0
            }],
            legend: {
                align: 'center',
                verticalAlign: 'bottom',
                y: 60,
                floating: true,
                backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                borderColor: '#CCC',
                borderWidth: 1,
                shadow: false
            },
            tooltip: {
                formatter: function () {
                    console.log(this);
                    return 'Period: ' + this.key + '<br/>Bill Amount: $' + this.y;
                }
            },
            plotOptions: {
                series: {
                    cursor: 'pointer'
                }
            },
            series: [{
                name: "Bill Amount",
                showInLegend: false,
                data: [[data.SameYearOldPeriod.PeriodName, data.SameYearOldPeriod.BillAmount], [data.SameYearNewPeriod.PeriodName, data.SameYearNewPeriod.BillAmount]],
            }]
        });
    };

    $scope.createChartTable3 = function (data) {
        var title = data.SameYearDifference.EnergyCostGcrPercents;
        if (title > 0) {
            title = "+" + title;
        }

        Highcharts.chart('comparChartTable3', {
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            chart: {
                spacingTop: 40,
                spacingBottom: 60,
                type: 'column'
            },
            title: {
                text: $scope._t("Energy Cost") + ": " + title + "%"
            },
            xAxis: {
                type: 'category', labels: { rotation: 0 }
            },
            yAxis: [{
                labels: {
                    format: '{value}'
                },
                title: {
                    text: _t('Energy Cost') + ', ' + '$'
                },
                min: 0
            }],
            legend: {
                align: 'center',
                verticalAlign: 'bottom',
                y: 60,
                floating: true,
                backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                borderColor: '#CCC',
                borderWidth: 1,
                shadow: false
            },
            tooltip: {
                formatter: function () {
                    console.log(this);
                    return 'Period: ' + this.key + '<br/>Energy Cost: $' + this.y;
                }
            },
            plotOptions: {
                series: {
                    cursor: 'pointer'
                }
            },
            series: [{
                name: "Bill Amount",
                showInLegend: false,
                data: [[data.SameYearOldPeriod.PeriodName, data.SameYearOldPeriod.EnergyCostGcr], [data.SameYearNewPeriod.PeriodName, data.SameYearNewPeriod.EnergyCostGcr]],
            }]
        });
    };

    $scope.createChartTable4 = function (data) {
        var title = data.YearOverYearDifference.ConsumptionPercents;
        if (title > 0) {
            title = "+" + title;
        }

        Highcharts.chart('comparChartTable4', {
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            chart: {
                spacingTop: 40,
                spacingBottom: 60,
                type: 'column'
            },
            title: {
                text: $scope._t("Consumption") + ": " + title + "%"
            },
            xAxis: {
                type: 'category', labels: { rotation: 0 }
            },
            yAxis: [{
                labels: {
                    format: '{value}'
                },
                title: {
                    text: _t('Consumption') + ', ' + data.YearOverYearFullUsageData.ConsumptionUnit
                },
                min: 0
            }],
            legend: {
                align: 'center',
                verticalAlign: 'bottom',
                y: 60,
                floating: true,
                backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                borderColor: '#CCC',
                borderWidth: 1,
                shadow: false
            },
            tooltip: {
                formatter: function () {
                    console.log(this);
                    return 'Period: ' + this.key + '<br/>Consumption: ' + this.y + ' ' + data.YearOverYearFullUsageData.ConsumptionUnit;
                }
            },
            plotOptions: {
                series: {
                    cursor: 'pointer'
                }
            },
            series: [{
                name: "Consumption",
                showInLegend: false,
                data: [[data.YearOverYearOldPeriod.PeriodName, data.YearOverYearOldPeriod.Consumption], [data.YearOverYearNewPeriod.PeriodName, data.YearOverYearNewPeriod.Consumption]],
            }]
        });
    };

    $scope.createChartTable5 = function (data) {
        var title = data.YearOverYearDifference.BillAmountPercents;
        if (title > 0) {
            title = "+" + title;
        }

        Highcharts.chart('comparChartTable5', {
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            chart: {
                spacingTop: 40,
                spacingBottom: 60,
                type: 'column'
            },
            title: {
                text: $scope._t("Bill Amount") + ": " + title + "%"
            },
            xAxis: {
                type: 'category', labels: { rotation: 0 }
            },
            yAxis: [{
                labels: {
                    format: '{value}'
                },
                title: {
                    text: _t('Bill Amount') + ', ' + '$'
                },
                min: 0
            }],
            legend: {
                align: 'center',
                verticalAlign: 'bottom',
                y: 60,
                floating: true,
                backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                borderColor: '#CCC',
                borderWidth: 1,
                shadow: false
            },
            tooltip: {
                formatter: function () {
                    console.log(this);
                    return 'Period: ' + this.key + '<br/>Bill Amount: $' + this.y;
                }
            },
            plotOptions: {
                series: {
                    cursor: 'pointer'
                }
            },
            series: [{
                name: "Consumption",
                showInLegend: false,
                data: [[data.YearOverYearOldPeriod.PeriodName, data.YearOverYearOldPeriod.BillAmount], [data.YearOverYearNewPeriod.PeriodName, data.YearOverYearNewPeriod.BillAmount]],
            }]
        });
    };

    $scope.createChartTable6 = function (data) {
        var title = data.YearOverYearDifference.EnergyCostGcrPercents;
        if (title > 0) {
            title = "+" + title;
        }

        Highcharts.chart('comparChartTable6', {
            // exporting: {
            //     enabled: false
            // },
            credits: {
                enabled: false
            },
            chart: {
                spacingTop: 40,
                spacingBottom: 60,
                type: 'column'
            },
            title: {
                text: $scope._t('Energy Cost') + ': ' + title + '%'
            },
            xAxis: {
                type: 'category', labels: { rotation: 0 }
            },
            yAxis: [{
                labels: {
                    format: '{value}'
                },
                title: {
                    text: _t('Energy Cost') + ', ' + '$'
                },
                min: 0
            }],
            legend: {
                align: 'center',
                verticalAlign: 'bottom',
                y: 60,
                floating: true,
                backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                borderColor: '#CCC',
                borderWidth: 1,
                shadow: false
            },
            tooltip: {
                formatter: function () {
                    console.log(this);
                    return 'Period: ' + this.key + '<br/>Energy Cost: $' + this.y;
                }
            },
            plotOptions: {
                series: {
                    cursor: 'pointer'
                }
            },
            series: [{
                name: "Consumption",
                showInLegend: false,
                data: [[data.YearOverYearOldPeriod.PeriodName, data.YearOverYearOldPeriod.EnergyCostGcr], [data.YearOverYearNewPeriod.PeriodName, data.YearOverYearNewPeriod.EnergyCostGcr]],
            }]
        });
    };

    $scope.createAllCharts = function (data) {
        try{
            $scope.createChartFullYear(data);
            $scope.createChartTable1(data);
            $scope.createChartTable2(data);
            $scope.createChartTable3(data);
            $scope.createChartTable4(data);
            $scope.createChartTable5(data);
            $scope.createChartTable6(data);
        }
        catch (e) {
            ModalServiceExt.showError($scope._t("An unexpected error occurred. Please try again later."));
            console.log(e);
        }
    }

    $scope.changeGraphType = function () {
        $scope.initTables($scope.meterNum, $scope.radioGraphType, $scope.radioGraphTypeConsumption);
    }

    $scope.changeGraphTypeConsumption = function () {
        $scope.initTables($scope.meterNum, $scope.radioGraphType, $scope.radioGraphTypeConsumption);
    }

    var onResizeAction = function() {
        $scope.createAllCharts($scope.data);
    }

    $scope.initTables = function (meterNum, graphType, graphTypeConsumption) {
        var currentAccountNumber = localStorage.getItem('CurrentAccountNumber');
        var apiUrl = localStorage.getItem('ApiUrl');
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/Consumption/GetEnergyEfficiencyReport/',
            method: "GET",
            params: {
                accountNumber: currentAccountNumber,
                meterNum: meterNum,
                graphType: graphType,
                graphTypeConsumption: graphTypeConsumption
            }
        }).success(function (json) {
            if (json) {
                if (json.Errors && json.Errors.length > 0) {
                    ModalServiceExt.showError(json.Errors[0]);
                }
                else {
                    $scope.data = json.Data;
                    $scope.isConsumptionsExist = !!$scope.data.SameYearNewPeriod;
                    if($scope.isConsumptionsExist)
                        $scope.createAllCharts($scope.data);
                    $(window).bind('resize', onResizeAction);
                }
            } else {
                ModalServiceExt.showError($scope._t("Error occurred during consumption retrieval."));
            }
            usSpinnerService.stop('spinner-1');
        }).error(function (error) {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showError(error.Message);
        });
    }

    //$scope.initTables();

    var startSpin = function () {
        usSpinnerService.spin('spinner-1');
    };

    var stopSpin = function () {
        usSpinnerService.stop('spinner-1');
    };

    $scope.getMeterDataGraph();

    $scope.$on("$destroy", function () {
        angular.element($window).off('resize', onResizeAction);
    });

}]);
angular.module('utilliApp')
    .service('WorkCentersService', ["$http", "$q", "$state", function ($http, $q, $state) {

        var workCenters = [];

        var getWorkCenters = function () {
            return workCenters;
        }

        var setWorkCenters = function (centers) {
            workCenters = centers;
        }

        var add = function (center) {
            workCenters.push(center);
        }

        var exists = function (center) {
            if (!center)
                return false;

            var index = _.findIndex(workCenters, { Id: center.Id, CompanyCode: center.CompanyCode });
            if (index === -1)
                return false;

            return true;
        }

        var remove = function (center) {
            if (!center)
                return;

            var index = _.findIndex(workCenters, { Id: center.Id, CompanyCode: center.CompanyCode });
            if (index === -1)
                return;

            workCenters.splice(index, 1);
        }

        var reset = function () {
            workCenters = [];
        }

        var empty = function () {
            return workCenters.length === 0;
        }

        return {
            getWorkCenters: getWorkCenters,
            setWorkCenters: setWorkCenters,
            add: add,
            exists: exists,
            remove: remove,
            empty: empty,
            reset: reset
        };

    }]);
angular.module('utilliApp')
    .service('LookUpLogService', ["$http", "$q", "$state", function ($http, $q, $state) {
        var _looUpLogKey = "lookUpLog";
        var _buffer = {};

        function addLogItem(accNumber, discDoc, serialNum, woNumber) {
            var log = JSON.parse(localStorage.getItem(_looUpLogKey)) || []
            var newItem = {
                date: new Date(),
                accNumber: accNumber,
                discDoc: discDoc,
                serialNum: serialNum,
                woNumber: woNumber
            }
            log.push(newItem);
            localStorage.setItem(_looUpLogKey, JSON.stringify(log));
        }

        var getAllItems = function () {
            var result = JSON.parse(localStorage.getItem(_looUpLogKey)) || [];
            _.each(result, function (i) {
                i.date = kendo.parseDate(i.date);
            });
            return result;
        }

        var pushOutBuffer = function () {
            var result = _buffer;
            buffer = undefined;
            return result;
        }

        var popToBuffer = function (lookUpLogItem) {
            _buffer = lookUpLogItem;
        }

        return {
            addLogItem: addLogItem,
            getAllItems: getAllItems,
            popToBuffer: popToBuffer,
            pushOutBuffer: pushOutBuffer
        };

    }]);
'use strict';
angular.module('utilliApp')
    .controller('WorkCentersController', ['$scope', '$rootScope', '$http', '$timeout', '$window',
        'usSpinnerService', 'LeftMenuService', '$state', 'GetAccountsService', '$stateParams', 'CommonHeaderService',
        'ModalServiceExt', 'WorkCentersService',
    function ($scope, $rootScope, $http, $timeout, $window, usSpinnerService, LeftMenuService, $state,
        GetAccountsService, $stateParams, CommonHeaderService, ModalServiceExt, WorkCentersService) {

        LeftMenuService.setCurrentTab('WorkCenters');
        CommonHeaderService.setUpBackButton('Work Centers');

        $scope.errors = [];
        $scope.accountDataList = {};

        $scope.showWorkOrders = function() {
            $state.goMainLayout("WorkOrders");
        }

        $scope.showCurrentWorkOrders = function (workCenter) {
            WorkCentersService.reset();
            WorkCentersService.add(workCenter);
            workCenter.selected = true;
            $state.goMainLayout("WorkOrders");
        }

        $scope.selectWorkCenter = function (workCenter) {
            if (WorkCentersService.exists(workCenter)) {
                WorkCentersService.remove(workCenter);
                workCenter.selected = false;
                return;
            }

            WorkCentersService.add(workCenter);
            workCenter.selected = true;
        }

        $scope.getWorkCenters = function () {
            usSpinnerService.spin('spinner-1');
            $scope.IsGettingDashboardInfo = true;
            //var accountNumber = localStorage.getItem('CurrentAccountNumber');
            var apiUrl = localStorage.getItem('ApiUrl');
            //var dataRequest = { contractAccountNumber: accountNumber }

            $http({
                url: apiUrl + 'api/TurnOffService/GetWorkCenterList/',
                method: "GET",
                //params: dataoRequest
            }).success(function (data) {
                $scope.IsGettingDashboardInfo = false;
                var jsondata = data;
                if (jsondata) {
                    if (jsondata.Errors && jsondata.Errors.length > 0) {

                        ModalServiceExt.showError(jsondata.Errors[0]);
                    } else {
                        $scope.workCentersList = data.Data;

                        for (var i = 0; i < $scope.workCentersList.length; i++) {
                            if (WorkCentersService.exists($scope.workCentersList[i])) {
                                $scope.workCentersList[i].selected = true;
                            }
                        }
                    }
                } else {
                    ModalServiceExt.showServerError();
                };
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }

        $scope.$watch("workCentersList", function (value) {
            var val = value || null;
            if (val)
                $timeout(function () {
                    $scope.hasScroll = hasScroll();
                });
        });

        function hasScroll() {
            var innerHeight = $('.AccountList').height();
            var mainHeight = $('.work-centers-list').height();
            var result = innerHeight >= mainHeight;
            return result;
        }
    }])
;
'use strict';
angular.module('utilliApp')
    .controller('LookUpController', ['$scope', '$rootScope', '$http', 'usSpinnerService', 'LeftMenuService',
        '$state', 'CommonHeaderService', 'ModalServiceExt', 'LookUpLogService',
    function ($scope, $rootScope, $http, usSpinnerService, LeftMenuService, $state,
        CommonHeaderService, ModalServiceExt, LookUpLogService) {

        LeftMenuService.setCurrentTab('LookUp');
        CommonHeaderService.setUpBackButton('Look Up');

        initForm();

        $scope.lookup = function () {
            $scope.submitted = true;
            if (!($scope.accNumber || $scope.discDoc || $scope.serialNumber || $scope.woNumber))
                return;
            LookUpLogService.addLogItem($scope.accNumber, $scope.discDoc, $scope.serialNum, $scope.woNumber);
            usSpinnerService.spin('spinner-1');
            var url = localStorage.getItem('ApiUrl') + 'api/TurnOffService/LookUp';
            $http({
                method: 'GET',
                url: url,
                params: {
                    accountNumber: $scope.accNumber,
                    discDocument: $scope.discDoc,
                    serialNumber: $scope.serialNumber,
                    woNumber: $scope.woNumber
                }
            }).success(function (response) {
                if (response.HasErrors) {
                    ModalServiceExt.showServerError();
                    usSpinnerService.stop('spinner-1');
                    return;
                }
                if (response.HasErrors) {
                    ModalServiceExt.showError(response.Errors[0]);
                }
                else {
                    if(!response.Data)
                    {
                        ModalServiceExt.showInfo("Work orders not found.");
                    }
                    //todo: goto work order/work orders page
                }
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                ModalServiceExt.showServerError();
                usSpinnerService.stop('spinner-1');
            });
        }

        function addLogItem() {
            var log = JSON.parse(localStorage.getItem(Config.looUpLogKey)) || []
            var newItem = {
                date: new Date(),
                accNumber: $scope.accNumber,
                discDoc: $scope.discDoc,
                serialNum: $scope.serialNum,
                woNumber: $scope.woNumber
            }
            log.push(newItem);
            localStorage.setItem(Config.looUpLogKey, JSON.stringify(log));
        }

        function initForm() {
            var lookUpLogRecord = LookUpLogService.pushOutBuffer();
            if (!lookUpLogRecord)
                return;
            $scope.accNumber = lookUpLogRecord.accNumber;
            $scope.discDoc = lookUpLogRecord.discDoc;
            $scope.serialNum = lookUpLogRecord.serialNum;
            $scope.woNumber = lookUpLogRecord.woNumber;
        }
    }]);
'use strict';
angular.module('utilliApp')
    .controller('LookUpLogController', ['$scope', '$rootScope', '$window', '$http', 'usSpinnerService', 'LeftMenuService',
        '$state', 'CommonHeaderService', 'ModalServiceExt', 'LookUpLogService',
    function ($scope, $rootScope, $window, $http, usSpinnerService, LeftMenuService, $state,
        CommonHeaderService, ModalServiceExt, LookUpLogService) {

        LeftMenuService.setCurrentTab('LookUpLog');
        CommonHeaderService.setUpBackButton('Look Up Log');

        $scope.log = LookUpLogService.getAllItems().reverse();

        $scope.formatDate = function (date) {
            var result = $window.kendo.toString(date, "yyyy-M-dd hh:mm:ss");
            return result;
        }

        $scope.goToLookUp = function (lookUpLogItem) {
            LookUpLogService.popToBuffer(lookUpLogItem);
            $state.goMainLayout('LookUp');
        }
    }]);
'use strict';
angular.module('utilliApp')
    .controller('PaymentHistoryController', ['$scope', '$rootScope', '$http', 'usSpinnerService', 'LeftMenuService',
        '$state', 'CommonHeaderService', 'ModalServiceExt',
    function ($scope, $rootScope, $http, usSpinnerService, LeftMenuService, $state,
        CommonHeaderService, ModalServiceExt) {

        LeftMenuService.setCurrentTab('PaymentHistory');
        CommonHeaderService.setUpBackButton('Payment History');

        $scope.paymentsLoading = false;
        $scope.payments = [];
        //$scope.before = 9007199254740991;
        $scope.before = 0;

        $scope.endOfDataReached = false; // fix for bug: http://stackoverflow.com/questions/23666712/nginfinitescroll-loadmore-method-gets-called-on-every-mouse-scroll

        $scope.getPayments = function () {
            if ($scope.paymentsLoading) return;
            $scope.paymentsLoading = true;


            usSpinnerService.spin('spinner-1');
            var url = localStorage.getItem('ApiUrl') + 'api/TurnOffService/GetPaymentList';
            var dataRequest = { before: $scope.before, count: 10 };

            $http({
                method: 'GET',
                url: url,
                params: dataRequest
            }).success(function (response) {

                if (response.HasErrors) {
                    ModalServiceExt.showServerError();
                    return;
                }
                if (response.HasErrors) {
                    ModalServiceExt.showError(response.Errors[0]);
                }
                else {
                    if(!response.Data)
                    {
                        ModalServiceExt.showInfo("Payments not found.");
                    }

                    //$scope.payments = response.Data;

                    if (response.Data.length == 0) {
                        $scope.paymentsLoading = false;
                        $scope.endOfDataReached = true; // fix for a bug: http://stackoverflow.com/questions/23666712/nginfinitescroll-loadmore-method-gets-called-on-every-mouse-scroll
                        usSpinnerService.stop('spinner-1');
                        return;
                    }

                    for (var i = 0; i < response.Data.length; i++) {
                        $scope.payments.push(response.Data[i]);
                    }
                    $scope.before = $scope.payments[$scope.payments.length - 1].Id;

                    $scope.paymentsLoading = false;
                    usSpinnerService.stop('spinner-1');
                }

            }).error(function () {
                $scope.paymentsLoading = false;
                ModalServiceExt.showServerError();
                usSpinnerService.stop('spinner-1');
            });
        }


    }]);
'use strict';
angular.module('utilliApp')
.controller('WorkOrderController',
[
    '$scope', '$rootScope', '$http', '$state', 'usSpinnerService',
    'LeftMenuService', 'CommonHeaderService', '$stateParams', 'ModalServiceExt',
    function($scope,
        $rootScope,
        $http,
        $state,
        usSpinnerService,
        LeftMenuService,
        CommonHeaderService,
        $stateParams,
        ModalServiceExt) {

        CommonHeaderService.setUpBackButton('Work Order');

        function applyServiceAddressElement() {
            var element = document.getElementById('serviceAddress');

            var height = element.scrollHeight + (element.offsetHeight - element.clientHeight);
            element.style.height = height + "px";
        }

        usSpinnerService.spin('spinner-1');
        var dataRequest = {
            contractAccountNumber: $stateParams.contractAccountNumber,
            orderNumber: $stateParams.orderNumber
        };
        $http({
                url: localStorage.getItem('ApiUrl') + 'api/TurnOffService/GetWorkOrder/',
                method: "GET",
                params: dataRequest
            })
            .success(function(response) {
                usSpinnerService.stop('spinner-1');
                if (response) {
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showError(response.Errors[0]);
                    } else {
                        $scope.order = response.Data;
                        setTimeout(function() { applyServiceAddressElement(); }, 10);
                    }
                } else {
                    ModalServiceExt.showServerError();
                }
            })
            .error(function() {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });

        $scope.payNow = function() {
            localStorage.setItem('CurrentAccountNumber', $scope.order.AccountNumber);
            $state.goMainLayout('PayNow');
        }
    }
]);

'use strict';
angular.module('utilliApp')
.controller('WorkOrdersController', ['$scope', '$rootScope', '$http', '$state', 'usSpinnerService',
            'LeftMenuService', 'CommonHeaderService', 'WorkCentersService', 'ModalServiceExt',
function ($scope, $rootScope, $http, $state, usSpinnerService, LeftMenuService, CommonHeaderService,
    WorkCentersService, ModalServiceExt) {
    LeftMenuService.setCurrentTab('WorkOrders');
    CommonHeaderService.setUpBackButton('Work Orders');

    if (WorkCentersService.empty())
    {
        $scope.goToWorkCenters = function () {
            $state.goMainLayout('WorkCenters');
        }

        $scope.errorMessage = 'You should select Work Centers.';
        return;
    }

    $scope.orders = [];
    $scope.ordersLoading = false;
    $scope.endOfDataReached = false;
    $scope.loadOrdersAfter = 0;

    $scope.getOrders = function () {

        if ($scope.ordersLoading)
            return;

        usSpinnerService.spin('spinner-1');

        $scope.ordersLoading = true;
        var pageSize = 20;
        var workCenters = WorkCentersService.getWorkCenters();
        var requestObjects = [];
        workCenters.forEach(function (item) {
            requestObjects.push({ Id: item.Id, CompanyCode: item.CompanyCode, Name: item.Name, Plant: item.Plant });
        });

        var jsonCenters = JSON.stringify(requestObjects);

        var dataRequest = { centers: jsonCenters, after: $scope.loadOrdersAfter, count: pageSize };
        $http({
            url: localStorage.getItem('ApiUrl') + 'api/TurnOffService/GetWorkOrders/',
            method: "GET",
            params: dataRequest
        }).success(function (response) {
            usSpinnerService.stop('spinner-1');

            if (response) {
                if (response.Errors && response.Errors.length > 0) {
                    ModalServiceExt.showError(response.Errors[0]);
                } else {
                    $scope.handleOrders(response.Data);
                    if (response.Data.length < pageSize) {
                        $scope.ordersLoading = false;
                        $scope.endOfDataReached = true; // fix for a bug: http://stackoverflow.com/questions/23666712/nginfinitescroll-loadmore-method-gets-called-on-every-mouse-scroll
                    }
                }
            } else {
                ModalServiceExt.showServerError();
            }
        }).error(function () {
            ModalServiceExt.showServerError();
        })['finally'](function() {
            usSpinnerService.stop('spinner-1');
        });
    };

    $scope.handleOrders = function (orders) {
        if (!orders) {
            $scope.ordersLoading = false;
            return;
        }

        for (var i = 0; i < orders.length; i++)
            $scope.orders.push(orders[i]);

        if ($scope.orders[$scope.orders.length - 1] != undefined)
            $scope.loadOrdersAfter = $scope.orders[$scope.orders.length - 1].Number;
        $scope.ordersLoading = false;

    };

    $scope.openOrderDetails = function (order)
    {
        $state.goMainLayout('WorkOrder', { contractAccountNumber: order.AccountNumber, orderNumber: order.Number });
    }
}]);